(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "styled-components"], factory);
	else if(typeof exports === 'object')
		exports["Zakeke"] = factory(require("react"), require("styled-components"));
	else
		root["Zakeke"] = factory(root["react"], root["styled-components"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_styled_components__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "../../3D/src/Components/AR/AndroidAR.ts":
/*!***********************************************!*\
  !*** ../../3D/src/Components/AR/AndroidAR.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AndroidAR": () => (/* binding */ AndroidAR)
/* harmony export */ });
class AndroidAR {
    static openSceneViewer(gltfSrc, notifyUnsupportedAR, arScale = true) {
        // If the fallback has ever been invoked this session, bounce early:
        if (this._fallbackInvoked) {
            return;
        }
        const location = self.location.toString();
        const locationUrl = new URL(location);
        const modelUrl = new URL(gltfSrc);
        const params = new URLSearchParams(modelUrl.search);
        locationUrl.hash = this._noArViewerSigil;
        // modelUrl can contain title/link/sound etc.
        params.set('mode', 'ar_preferred');
        if (!params.has('disable_occlusion')) {
            params.set('disable_occlusion', 'true');
        }
        if (!arScale) {
            params.set('resizable', 'false');
        }
        if (params.has('sound')) {
            const soundUrl = new URL(params.get('sound'), location);
            params.set('sound', soundUrl.toString());
        }
        if (params.has('link')) {
            const linkUrl = new URL(params.get('link'), location);
            params.set('link', linkUrl.toString());
        }
        const intent = `intent://arvr.google.com/scene-viewer/1.0?${params.toString() + '&file=' +
            encodeURIComponent(modelUrl
                .toString())}#Intent;scheme=https;package=com.google.ar.core;action=android.intent.action.VIEW;S.browser_fallback_url=${encodeURIComponent(locationUrl.toString())};end;`;
        console.log(intent);
        const undoHashChange = () => {
            if (self.location.hash === this._noArViewerSigil && !this._fallbackInvoked) {
                this._fallbackInvoked = true;
                if (notifyUnsupportedAR)
                    notifyUnsupportedAR();
                // The new history will be the current URL with a new hash.
                // Go back one step so that we reset to the expected URL.
                // NOTE: this should not invoke any browser-level navigation
                // because hash-only changes modify the URL in-place without
                // navigating:
                self.history.back();
            }
        };
        self.addEventListener('hashchange', undoHashChange, { once: true });
        this._anchor.setAttribute('href', intent);
        this._anchor.setAttribute('target', '_blank');
        document.body.appendChild(this._anchor);
        this._anchor.click();
    }
}
AndroidAR._anchor = document.createElement('a');
AndroidAR._linkOrTitle = /(link|title)(=|&)|(\?|&)(link|title)$/;
AndroidAR._noArViewerSigil = '#model-viewer-no-ar-fallback';
AndroidAR._fallbackInvoked = false;


/***/ }),

/***/ "../../3D/src/Components/ActionExecutor/SceneActionExecutor.ts":
/*!*********************************************************************!*\
  !*** ../../3D/src/Components/ActionExecutor/SceneActionExecutor.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SceneActionsExecutor": () => (/* binding */ SceneActionsExecutor)
/* harmony export */ });
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
/* harmony import */ var _Selector_ElementSelector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Selector/ElementSelector */ "../../3D/src/Components/Selector/ElementSelector.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


class SceneActionsExecutor {
    constructor(zkScene, scene, zkModel) {
        this._zkModel = null;
        this._sceneHelper = null;
        this._deviceType = MPlaza.DeviceType.All;
        this._meshDesignRefreshRequiredListeners = [];
        this._beginAssetsLoadingListeners = [];
        this._endAssetsLoadingListeners = [];
        this._useMaterialOffloading = false;
        this._prefetchMeshes = true;
        this._prefetchMaterials = true;
        this._zkScene = zkScene;
        this._scene = scene;
        this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper(scene);
        this._elementSelector = new _Selector_ElementSelector__WEBPACK_IMPORTED_MODULE_1__.ElementSelector();
        if (zkModel)
            this._zkModel = zkModel;
    }
    get deviceType() {
        return this._deviceType;
    }
    set deviceType(value) {
        if (this._deviceType != value)
            this._deviceType = value;
    }
    get useMaterialOffloading() {
        return this._useMaterialOffloading;
    }
    set useMaterialOffloading(value) {
        if (this._useMaterialOffloading != value)
            this._useMaterialOffloading = value;
    }
    get prefetchMeshes() {
        return this._prefetchMeshes;
    }
    set prefetchMeshes(value) {
        if (this._prefetchMeshes !== value)
            this._prefetchMeshes = value;
    }
    get prefetchMaterials() {
        return this._prefetchMaterials;
    }
    set prefetchMaterials(value) {
        if (this._prefetchMaterials !== value)
            this._prefetchMaterials = value;
    }
    dispose() {
        if (this._sceneHelper) {
            this._sceneHelper.dispose();
            this._sceneHelper = null;
        }
    }
    // -------------------------------------------------------
    // Events
    // -------------------------------------------------------
    addMeshDesignRefreshRequiredListeners(callback) {
        this._meshDesignRefreshRequiredListeners.push(callback);
    }
    fireMeshDesignRefreshRequiredEvent(meshes, effect) {
        const evt = { meshes, effect };
        for (let i = 0; i < this._meshDesignRefreshRequiredListeners.length; ++i) {
            this._meshDesignRefreshRequiredListeners[i](evt);
        }
    }
    addBeginAssetsLoadingListener(callback) {
        this._beginAssetsLoadingListeners.push(callback);
    }
    fireBeginAssetsLoadingEvent() {
        for (let i = 0; i < this._beginAssetsLoadingListeners.length; ++i) {
            this._beginAssetsLoadingListeners[i]();
        }
    }
    addEndAssetsLoadingListener(callback) {
        this._endAssetsLoadingListeners.push(callback);
    }
    fireEndAssetsLoadingEvent() {
        for (let i = 0; i < this._endAssetsLoadingListeners.length; ++i) {
            this._endAssetsLoadingListeners[i]();
        }
    }
    // -------------------------------------------------------
    // Actions Helpers Methods
    // -------------------------------------------------------
    isActionForDevice(action) {
        const type = action.get("deviceTypes");
        if (type === MPlaza.DeviceType.Any || type === MPlaza.DeviceType.All)
            return true;
        if ((type & this._deviceType) === this._deviceType)
            return true;
        return false;
    }
    // ad una mesh vengono associati dei dati aggiuntivi che servono per l'utilizzo dei filtri.
    // Un filtro consente di creare un contesto di mesh da associare ad una opzione di un attributo.
    // Quando si utilizza un'azione di tipo filtro, verranno visualizzate solo le mesh specificate dal filtro.
    // Per esempio, per un orologio potrei avere un attributo "modello" con le opzioni "classico", "moderno", "sportivo".
    // Selezionando un modello, potrebbe essere utile attivare solo le mesh che hanno a che fare con il
    // modello selezionato. Questo consentirebbe di specificare azioni su altre opzioni indipendentemente dal modello.
    // Ad esempio potrei avere un altro attributo "vetro" con le opzioni "zaffiro" e "normale" con le azioni
    // che visualizzano il vetro nel materiale selezionato, diverso per modello.
    // Un filtro è relativo ad un attributo, così da permettere la definizione di contesti più restrittivi
    // andando a cumulare filtri relativi ad attributi diversi.
    // Inizializza la struttura dati associata ad una mesh
    setupMeshData(mesh) {
        if (!mesh["data"]) {
            mesh["data"] = {
                filters: {},
                toShow: mesh.isVisible
            };
        }
    }
    // Imposta il filtro legato ad un attributo (da un'azione filtro)
    setMeshFilterAsync(mesh, attributeID, value) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setupMeshData(mesh);
            mesh["data"].filters[attributeID] = value;
            yield this.chekMeshVisibilityAsync(mesh);
        });
    }
    // Richiede la visibilità di una mesh (da un'azione show/hide)
    setMeshVisibilityAsync(mesh, value) {
        return __awaiter(this, void 0, void 0, function* () {
            this.setupMeshData(mesh);
            mesh["data"].toShow = value;
            yield this.chekMeshVisibilityAsync(mesh);
        });
    }
    // Determina se dopo l'applicazione di un filtro o una richiesta di visibilità
    // la mesh debba essere mostrata o nascosta. Il risultato andrà ad agire sulla
    // effettiva visibilità della mesh, secondo l'espressione booleana:
    // mesh.isVisible = F1 && F2 && ... && Fn && toShow
    chekMeshVisibilityAsync(mesh) {
        return __awaiter(this, void 0, void 0, function* () {
            let filters = null;
            if (mesh && mesh["data"]) {
                filters = mesh["data"].toShow;
                if (filters) {
                    for (const property in mesh["data"].filters) {
                        filters = filters && mesh["data"].filters[property];
                    }
                }
            }
            if (filters !== null && this._sceneHelper) {
                if (filters) {
                    const rootUrl = this._zkScene.get("rootUrl");
                    if (rootUrl)
                        yield this._sceneHelper.unsetMeshDummyMaterialAsync(mesh, rootUrl, true);
                    yield _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper.whenMeshIsReadyAsync(mesh);
                }
                this._sceneHelper.showHideMesh(mesh.id, filters);
            }
        });
    }
    getMeshByID(id) {
        return this._scene.getMeshByID(id);
    }
    getMaterialByID(id) {
        return this._scene.getMaterialByID(id);
    }
    setCameraLocation(locationID) {
        const zkCameraLocation = this._zkScene.getCameraLocation(locationID);
        if (zkCameraLocation) {
            const position = new BABYLON.Vector3(zkCameraLocation.get("px"), zkCameraLocation.get("py"), zkCameraLocation.get("pz"));
            const target = new BABYLON.Vector3(zkCameraLocation.get("tx"), zkCameraLocation.get("ty"), zkCameraLocation.get("tz"));
            if (this._sceneHelper)
                this._sceneHelper.animateCamera(target, position, 0.5);
        }
    }
    adjustCamera(animate) {
        if (this._sceneHelper) {
            if (animate !== undefined && typeof (animate) === "boolean")
                this._sceneHelper.adjustCamera(undefined, undefined, undefined, animate);
            else
                this._sceneHelper.adjustCamera();
        }
    }
    zoomIn() {
        if (this._sceneHelper)
            this._sceneHelper.zoomIn();
    }
    zoomOut() {
        if (this._sceneHelper)
            this._sceneHelper.zoomOut();
    }
    zoom(perc) {
        if (this._sceneHelper)
            this._sceneHelper.zoom(perc);
    }
    setCameraPivot(meshID) {
        if (this._sceneHelper) {
            const mesh = meshID ? this._scene.getMeshByID(meshID) : null;
            this._sceneHelper.setCameraPivot(mesh);
        }
    }
    setCameraZoomEnabled(enabled) {
        if (this._sceneHelper) {
            this._sceneHelper.setZoomEnabled(enabled);
        }
    }
    setMeshMaterial(material, mesh) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneHelper) {
                yield _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper.whenAllMaterialTexturesAreReady(material);
                const oldMaterial = mesh.material;
                Logger.info(`Setting material to mesh | mesh: ${mesh.id} - ${mesh.name} | material: ${material.id} - ${material.name}`);
                this._sceneHelper.applyMaterial(material, mesh);
                if (this._useMaterialOffloading && oldMaterial) {
                    this._sceneHelper.offloadMaterial(oldMaterial.id);
                }
            }
        });
    }
    setSubmeshMaterial(material, mesh, subMesh) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneHelper) {
                yield _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper.whenAllMaterialTexturesAreReady(material);
                const oldMaterial = this._sceneHelper.getSubMeshMaterial(mesh, subMesh);
                this._sceneHelper.applyMaterialToSubMesh(material, mesh, subMesh);
                if (this._useMaterialOffloading && oldMaterial) {
                    this._sceneHelper.offloadMaterial(oldMaterial.id);
                }
            }
        });
    }
    getMaterialFromActionValue(action) {
        if (this._elementSelector) {
            // Recupero il materiale, che deve essere specificato tramite nome o ID
            const matSel = action.get("value");
            if (matSel != undefined && matSel != null) {
                let material = this._scene.getMaterialByID(matSel);
                if (!material)
                    material = this._scene.getMaterialByName(matSel);
                return material;
            }
        }
        return null;
    }
    getDelayedMaterialIDFromAction(action) {
        if (this._zkScene && this._scene && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction) &&
            this._scene.metadata && this._scene.metadata.delayedMaterials) {
            // Recupero il materiale, che deve essere specificato tramite nome o ID
            const matSel = action.get("value");
            if (matSel != undefined && matSel != null) {
                if (this._scene.metadata.delayedMaterials.hasOwnProperty(matSel)) {
                    return matSel; // id trovato
                }
                else {
                    for (let key in this._scene.metadata.delayedMaterials) {
                        if (this._scene.metadata.delayedMaterials[key].name === matSel)
                            return key; // trovato nome
                    }
                }
            }
        }
        return null;
    }
    checkDelayedMaterial(materialID) {
        return __awaiter(this, void 0, void 0, function* () {
            let material = this.getMaterialByID(materialID);
            if (!material && this._sceneHelper) {
                const rootUrl = this._zkScene.get("rootUrl");
                if (rootUrl != undefined && rootUrl != null) {
                    material = yield this._sceneHelper.loadDelayedMaterialAsync(rootUrl, materialID);
                }
            }
            return material;
        });
    }
    getOffloadedMaterialIDFromAction(action) {
        if (this._zkScene && this._scene && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction) &&
            this._scene.metadata && this._scene.metadata.offloadedMaterials) {
            // Recupero il materiale, che deve essere specificato tramite nome o ID
            const matSel = action.get("value");
            if (matSel !== undefined && matSel !== null) {
                if (this._scene.metadata.offloadedMaterials.hasOwnProperty(matSel)) {
                    return matSel; // id trovato
                }
                else {
                    for (let key in this._scene.metadata.offloadedMaterials) {
                        if (this._scene.metadata.offloadedMaterials[key].name === matSel)
                            return key; // trovato nome
                    }
                }
            }
        }
        return null;
    }
    checkOffloadedMaterialAsync(materialID) {
        return __awaiter(this, void 0, void 0, function* () {
            let material = this.getMaterialByID(materialID);
            if (!material && this._sceneHelper) {
                const rootUrl = this._zkScene.get("rootUrl");
                if (rootUrl !== undefined && rootUrl !== null) {
                    material = yield this._sceneHelper.loadOffloadedMaterialAsync(rootUrl, materialID);
                }
            }
            return material;
        });
    }
    // Recupera il materiale specificato nel valore di un'azione, eventualmente caricandolo da remoto (delayed) oppure dalla cache (offloaded)
    getDeepMaterialFromActionValueAsync(action) {
        return __awaiter(this, void 0, void 0, function* () {
            let material = this.getMaterialFromActionValue(action);
            if (!material && this._sceneHelper) {
                const rootUrl = this._zkScene.get("rootUrl");
                if (rootUrl !== undefined && rootUrl !== null) {
                    // Verifico se si tratta di un materiale offloaded o delayed
                    let materialID = this.getOffloadedMaterialIDFromAction(action);
                    if (materialID) {
                        Logger.info("Requesting offloaded material - id: ", materialID);
                        material = yield this._sceneHelper.loadOffloadedMaterialAsync(rootUrl, materialID);
                        Logger.info("Obtained offloaded material - id: ", materialID);
                    }
                    else {
                        materialID = this.getDelayedMaterialIDFromAction(action);
                        if (materialID) {
                            Logger.info("Requesting delayed material - id: ", materialID);
                            material = yield this._sceneHelper.loadDelayedMaterialAsync(rootUrl, materialID);
                            Logger.info("Obtained delayed material - id: ", materialID);
                        }
                    }
                }
            }
            return material;
        });
    }
    scriptRequiresDelayedLoading(script) {
        for (let i = 0; i < script.length; i++) {
            const scriptActions = script[i];
            if (this.actionsRequireDelayedLoading(scriptActions.actions))
                return true;
        }
        return false;
    }
    actionsRequireDelayedLoading(actions) {
        for (let i = 0; i < actions.length; i++) {
            if (this.actionRequiresDelayedLoading(actions[i]))
                return true;
        }
        return false;
    }
    actionRequiresDelayedLoading(action) {
        // Almeno una mesh con delayLoading oppure con materiale dummy e materiali originali delayed o offloaded
        if (this._sceneHelper && action.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && action.get("value") === "show") {
            const expression = action.get("selector");
            if (expression !== undefined && expression !== null) {
                const meshes = this._elementSelector.getElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
                for (let k = 0; k < meshes.length; k++) {
                    const mesh = meshes[k];
                    if (mesh instanceof BABYLON.AbstractMesh && !mesh.isVisible) {
                        const meshDelayedMaterialIDs = this._sceneHelper.getMeshDelayedMaterialIDs(mesh);
                        const meshOffloadedMaterialIDs = this._sceneHelper.getMeshOffloadedMaterialIDs(mesh);
                        if (meshDelayedMaterialIDs.length > 0 || meshOffloadedMaterialIDs.length > 0)
                            return true;
                        if (_SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper.meshRequiresDelayedLoading(mesh))
                            return true;
                    }
                }
            }
        }
        // Almeno un materiale con delayedLoading
        if (action.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial ||
            action.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial ||
            action.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor ||
            action.get("actionTypeID") === MPlaza.SceneActionType.SetMeshDesignMaterial) {
            const material = this.getMaterialFromActionValue(action);
            if (!material) {
                const delayedMaterialID = this.getDelayedMaterialIDFromAction(action);
                if (delayedMaterialID)
                    return true;
                const offloadedMaterialID = this.getOffloadedMaterialIDFromAction(action);
                if (offloadedMaterialID)
                    return true;
            }
        }
        if (action.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor) {
            const expression = action.get("selector");
            if (expression !== undefined && expression !== null) {
                const delayedMaterialIDs = this._elementSelector.getDelayedElementIDs(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Material);
                const offloadedMaterialIDs = this._elementSelector.getOffloadedElementIDs(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Material);
                if (delayedMaterialIDs.length > 0 || offloadedMaterialIDs.length > 0)
                    return true;
            }
        }
        return false;
    }
    getAllMaterialElementsAsync(expression) {
        return __awaiter(this, void 0, void 0, function* () {
            const allMaterials = [];
            if (this._zkScene && this._scene && this._sceneHelper && this._elementSelector) {
                // Existing materials
                const materials = this._elementSelector.getMaterialElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Material);
                Array.prototype.push.apply(allMaterials, materials);
                const materialIDs = materials.map(m => m.id);
                const selectedDelayedMaterialIDs = this._elementSelector.getDelayedElementIDs(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Material);
                const selectedOffloadedMaterialIDs = this._elementSelector.getOffloadedElementIDs(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Material);
                const rootUrl = this._zkScene.get("rootUrl");
                if (rootUrl !== undefined && rootUrl !== null) {
                    // delayed materials
                    const delayedMaterialIDs = [];
                    selectedDelayedMaterialIDs.forEach(id => {
                        if (materialIDs.indexOf(id) === -1)
                            delayedMaterialIDs.push(id);
                    });
                    if (delayedMaterialIDs.length > 0) {
                        const delayedMaterials = yield this._sceneHelper.loadDelayedMaterialsAsync(rootUrl, delayedMaterialIDs);
                        Array.prototype.push.apply(allMaterials, delayedMaterials);
                    }
                    // offloaded materials
                    const offloadedMaterialIDs = [];
                    selectedOffloadedMaterialIDs.forEach(id => {
                        if (materialIDs.indexOf(id) === -1)
                            offloadedMaterialIDs.push(id);
                    });
                    if (offloadedMaterialIDs.length > 0) {
                        const offloadedMaterials = yield this._sceneHelper.loadOffloadedMaterialsByIDsAsync(rootUrl, offloadedMaterialIDs);
                        Array.prototype.push.apply(allMaterials, offloadedMaterials);
                    }
                }
            }
            return allMaterials;
        });
    }
    // Uno script è un array di oggetti ognuno dei quali rappresenta le azioni da eseguire
    // conseguentemente alla selezione di un valore per un attributo
    // si suppone che le azioni siano già ordinate per ordine di esecuzione
    // script: [{attributeID, selectedValue, actions}]
    executeScriptAsync(script) {
        return __awaiter(this, void 0, void 0, function* () {
            const requireDelayedLoading = this.scriptRequiresDelayedLoading(script);
            if (requireDelayedLoading) {
                this.fireBeginAssetsLoadingEvent();
            }
            for (let i = 0; i < script.length; i++) {
                const scriptActions = script[i];
                yield this.executeActionsAsync(scriptActions.attributeID, scriptActions.selectedValue, scriptActions.actions, false);
            }
            if (requireDelayedLoading)
                this.fireEndAssetsLoadingEvent();
        });
    }
    executeActionsAsync(attributeID, selectedValue, actions, notifyDelayLoading = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (actions.length > 0) {
                // Caricamento mesh e materiali delayed previsti per le azioni
                const requireDelayedLoading = this.actionsRequireDelayedLoading(actions);
                if (notifyDelayLoading && requireDelayedLoading)
                    this.fireBeginAssetsLoadingEvent();
                yield this.checkActionsAssetsAreReadyAsync(actions);
                // Esecuzione azioni
                for (let i = 0; i < actions.length; i++) {
                    yield this.executeActionAsync(attributeID, selectedValue, actions[i]);
                }
                if (notifyDelayLoading && requireDelayedLoading)
                    this.fireEndAssetsLoadingEvent();
                // -----------------------------------------
            }
        });
    }
    // Esegue una singola azione generata dalla selezione di un attributo
    // action: MPlaza.AttributeSceneAction
    executeActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isActionForDevice(action))
                return;
            //Logger.info("Action - Selector: " + action.get("selector") + " - Type: " + action.get("actionTypeID") + " - Value: " + action.get("value"));
            if (action) {
                switch (action.get("actionTypeID")) {
                    case MPlaza.SceneActionType.Filter:
                        yield this.executeFilterActionAsync(attributeID, selectedValue, action);
                        break;
                    case MPlaza.SceneActionType.ShowHideMesh:
                        yield this.executeShowHideActionAsync(attributeID, selectedValue, action);
                        break;
                    case MPlaza.SceneActionType.SetMeshMaterial:
                        yield this.executeSetMeshMaterialActionAsync(attributeID, selectedValue, action);
                        break;
                    case MPlaza.SceneActionType.SetSubMeshMaterial:
                        yield this.executeSetSubMeshMaterialActionAsync(attributeID, selectedValue, action);
                        break;
                    case MPlaza.SceneActionType.SetMaterialColor:
                        yield this.executeSetMaterialColorActionAsync(attributeID, selectedValue, action);
                        break;
                    case MPlaza.SceneActionType.SetCameraLocation:
                        yield this.executeSetCameraLocationActionAsync(attributeID, selectedValue, action);
                        break;
                    case MPlaza.SceneActionType.AdjustCamera:
                        yield this.executeAdjustCameraActionAsync(attributeID, selectedValue, action);
                        break;
                    case MPlaza.SceneActionType.SetCameraPivot:
                        yield this.executeSetCameraPivotActionAsync(attributeID, selectedValue, action);
                        break;
                    case MPlaza.SceneActionType.ResetCameraPivot:
                        yield this.executeResetCameraPivotActionAsync(attributeID, selectedValue, action);
                        break;
                    case MPlaza.SceneActionType.EnableDiableZoom:
                        yield this.executeEnableDisableZoomActionAsync(attributeID, selectedValue, action);
                        break;
                    case MPlaza.SceneActionType.SetMeshDesignMaterial:
                        yield this.executeSetMeshDesignMaterialActionAsync(attributeID, selectedValue, action);
                        break;
                    case MPlaza.SceneActionType.SetMeshDesignEffect:
                        yield this.executeSetMeshDesignEffectActionAsync(attributeID, selectedValue, action);
                        break;
                }
            }
        });
    }
    executeFilterActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isActionForDevice(action))
                return;
            if (attributeID !== null && this._zkScene && this._scene && this._sceneHelper && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction)) {
                // Recupero sia gli elementi che soddisfano il filtro che gli altri.
                // Questo perché per entrambe le tipologie di mesh devo settare i dati di filtro
                // e la conseguente visibilità
                const expression = action.get("selector");
                if (expression !== undefined && expression !== null) {
                    const elements = this._elementSelector.getYesNoElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
                    const value = action.get("value") === "enable" ? true : false;
                    for (let i = 0; i < elements.yes.length; i++) {
                        yield this.setMeshFilterAsync(elements.yes[i], attributeID, value);
                    }
                    for (let i = 0; i < elements.no.length; i++) {
                        yield this.setMeshFilterAsync(elements.yes[i], attributeID, !value);
                    }
                }
            }
        });
    }
    executeShowHideActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isActionForDevice(action))
                return;
            if (this._zkScene && this._scene && this._sceneHelper && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction)) {
                const expression = action.get("selector");
                if (expression !== undefined && expression !== null) {
                    const meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
                    const value = action.get("value") === "show";
                    for (let i = 0; i < meshes.length; i++) {
                        yield this.setMeshVisibilityAsync(meshes[i], value);
                    }
                }
            }
        });
    }
    executeSetMeshMaterialActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isActionForDevice(action))
                return;
            if (this._zkScene && this._scene && this._sceneHelper && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction)) {
                const expression = action.get("selector");
                if (expression !== undefined && expression !== null) {
                    const meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
                    const material = yield this.getDeepMaterialFromActionValueAsync(action);
                    if (material) {
                        for (let i = 0; i < meshes.length; i++) {
                            yield this.setMeshMaterial(material, meshes[i]);
                        }
                    }
                }
            }
        });
    }
    executeSetSubMeshMaterialActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isActionForDevice(action))
                return;
            if (this._zkScene && this._scene && this._sceneHelper && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction)) {
                const expression = action.get("selector");
                if (expression !== undefined && expression !== null) {
                    const subMeshes = this._elementSelector.getSubMeshElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.SubMesh);
                    const material = yield this.getDeepMaterialFromActionValueAsync(action);
                    if (material) {
                        for (let i = 0; i < subMeshes.length; i++) {
                            yield this.setSubmeshMaterial(material, null, subMeshes[i]);
                        }
                    }
                }
            }
        });
    }
    executeSetMaterialColorActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isActionForDevice(action))
                return;
            if (this._zkScene && this._scene && this._sceneHelper && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction)) {
                const expression = action.get("selector");
                if (expression !== undefined && expression !== null) {
                    const materials = yield this.getAllMaterialElementsAsync(expression);
                    const propertyName = action.get("propertyName");
                    let hexColor = action.get("value");
                    if (propertyName && hexColor) {
                        if (selectedValue) {
                            // Sostituisco la variabile %value% con il valore selezionato
                            hexColor = hexColor.replace(/%value%/g, selectedValue);
                        }
                        const color = BABYLON.Color3.FromHexString(hexColor);
                        for (let i = 0; i < materials.length; i++) {
                            this._sceneHelper.changeMaterialColor(materials[i], propertyName, color);
                        }
                    }
                }
            }
        });
    }
    executeSetCameraLocationActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isActionForDevice(action))
                return;
            if (this._zkScene && this._scene && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction)) {
                const value = action.get("value");
                let cameraLocation = null;
                if (value) {
                    for (let i = 0; i < this._zkScene.get("cameraLocations").length; i++) {
                        const location = this._zkScene.get("cameraLocations").at(i);
                        if (location.get("locationID") === value || location.get("name") === value) {
                            cameraLocation = location;
                            break;
                        }
                    }
                }
                if (cameraLocation !== null)
                    this.setCameraLocation(cameraLocation.get("locationID"));
            }
        });
    }
    executeAdjustCameraActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isActionForDevice(action))
                return;
            if (this._zkScene && this._scene && this._sceneHelper && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction)) {
                this._sceneHelper.adjustCamera();
            }
        });
    }
    executeSetCameraPivotActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isActionForDevice(action))
                return;
            if (this._zkScene && this._scene && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction)) {
                const value = action.get("value");
                let cameraPivot = null;
                if (value) {
                    for (let i = 0; i < this._scene.meshes.length; i++) {
                        const mesh = this._scene.meshes[i];
                        if (mesh.id === value || mesh.name === value) {
                            cameraPivot = mesh;
                            break;
                        }
                    }
                }
                if (cameraPivot)
                    this.setCameraPivot(cameraPivot.id);
            }
        });
    }
    executeResetCameraPivotActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isActionForDevice(action))
                return;
            this.setCameraPivot(null);
        });
    }
    executeEnableDisableZoomActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isActionForDevice(action))
                return;
            if (this._zkScene && this._scene && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction)) {
                const value = action.get("value") === "enable";
                this.setCameraZoomEnabled(value);
            }
        });
    }
    executeSetMeshDesignMaterialActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._zkScene && this._scene && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction)) {
                const expression = action.get("selector");
                if (expression != undefined && expression != null) {
                    const meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
                    const material = yield this.getDeepMaterialFromActionValueAsync(action);
                    if (material) {
                        for (let i = 0; i < meshes.length; i++) {
                            const mesh = meshes[i];
                            mesh.metadata = mesh.metadata || {};
                            mesh.metadata.designMaterialID = material.id;
                        }
                        this.fireMeshDesignRefreshRequiredEvent(meshes, null);
                    }
                }
            }
        });
    }
    executeSetMeshDesignEffectActionAsync(attributeID, selectedValue, action) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isActionForDevice(action))
                return;
            if (this._zkScene && this._scene && this._elementSelector && action && (action instanceof MPlaza.AttributeSceneAction)) {
                const expression = action.get("selector");
                if (expression != undefined && expression != null) {
                    let meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
                    let value = action.get("value");
                    let effect = null;
                    if (value != undefined && value != null && this._zkModel) {
                        for (let i = 0; i < this._zkModel.get("scenes").length; i++) {
                            const scene = this._zkModel.get("scenes").at(i);
                            if (scene.get("isDefault")) {
                                const effects = scene.get("meshDesignEffects");
                                if (effects) {
                                    for (let k = 0; k < effects.length; k++) {
                                        const eff = effects.at(k);
                                        if (eff.get("effectID") === value || eff.get("name") === value) {
                                            effect = eff;
                                            break;
                                        }
                                    }
                                }
                            }
                            if (effect)
                                break;
                        }
                    }
                    let material = null;
                    if (effect) {
                        const materialID = effect.get("materialID");
                        if (materialID) {
                            material = yield this.checkOffloadedMaterialAsync(materialID);
                            if (!material)
                                material = yield this.checkDelayedMaterial(materialID);
                        }
                    }
                    this.fireMeshDesignRefreshRequiredEvent(meshes, effect);
                }
            }
        });
    }
    prefetchMeshesForUnselectedOptionsAsync(actions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._zkScene && this._scene && this._elementSelector && this._sceneHelper && this._prefetchMeshes) {
                for (let i = 0; i < actions.length; i++) {
                    const action = actions[i];
                    if (action && action instanceof MPlaza.AttributeSceneAction) {
                        // Mesh
                        if (action.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && action.get("value") == "show") {
                            const expression = action.get("selector");
                            if (expression != undefined && expression != null) {
                                const meshes = this._elementSelector.getElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
                                for (let k = 0; k < meshes.length; k++) {
                                    const mesh = meshes[k];
                                    if (mesh instanceof BABYLON.AbstractMesh && !mesh.isVisible) {
                                        //Logger.info("prefetch", mesh);
                                        this._sceneHelper.checkDelayState(mesh);
                                        const material = mesh.material;
                                        if (material)
                                            yield this._sceneHelper.prefetchTexturesForMaterialAsync(material);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        });
    }
    checkActionsAssetsAreReadyAsync(actions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._zkScene && this._scene && this._elementSelector && this._sceneHelper) {
                // Meshes
                for (let i = 0; i < actions.length; i++) {
                    const action = actions[i];
                    const meshes = [];
                    if (action && (action instanceof MPlaza.AttributeSceneAction)) {
                        // Mesh
                        if (action.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && action.get("value") === "show") {
                            const expression = action.get("selector");
                            if (expression !== undefined && expression !== null) {
                                const expressionMeshes = this._elementSelector.getElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
                                for (let k = 0; k < expressionMeshes.length; k++) {
                                    const mesh = expressionMeshes[k];
                                    if (mesh instanceof BABYLON.AbstractMesh && !mesh.isVisible) {
                                        const rootUrl = this._zkScene.get("rootUrl");
                                        if (rootUrl) {
                                            const meshDelayedMaterialIDs = this._sceneHelper.getMeshDelayedMaterialIDs(mesh);
                                            const meshOffloadedMaterialIDs = this._sceneHelper.getMeshOffloadedMaterialIDs(mesh);
                                            if (meshDelayedMaterialIDs.length > 0)
                                                yield this._sceneHelper.loadDelayedMaterialsAsync(rootUrl, meshDelayedMaterialIDs);
                                            if (meshOffloadedMaterialIDs.length > 0)
                                                yield this._sceneHelper.loadOffloadedMaterialsByIDsAsync(rootUrl, meshOffloadedMaterialIDs);
                                        }
                                        meshes.push(mesh);
                                    }
                                }
                            }
                        }
                    }
                    yield _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper.whenAllMeshesAreReadyAsync(meshes);
                }
                // Materials
                for (let i = 0; i < actions.length; i++) {
                    const action = actions[i];
                    if (action && (action instanceof MPlaza.AttributeSceneAction)) {
                        if (action.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial ||
                            action.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial) {
                            let material = this.getMaterialFromActionValue(action);
                            if (!material) {
                                material = yield this.getDeepMaterialFromActionValueAsync(action);
                            }
                        }
                        if (action.get("actionTypeID") === MPlaza.SceneActionType.SetMaterialColor) {
                            const expression = action.get("selector");
                            if (expression !== undefined && expression !== null) {
                                const materials = yield this.getAllMaterialElementsAsync(expression);
                            }
                        }
                    }
                }
            }
        });
    }
    prefetchDataForUnselectedOptionsAsync(actions) {
        return __awaiter(this, void 0, void 0, function* () {
            return;
            /*
            if (this._zkScene && this._scene && this._elementSelector && this._sceneHelper) {
                for (let i = 0; i < actions.length; i++) {
                    const action = actions[i];
    
                    if (action && (action instanceof MPlaza.AttributeSceneAction)) {
    
                        // Mesh
                        if (this._prefetchMeshes && action.get("actionTypeID") === MPlaza.SceneActionType.ShowHideMesh && action.get("value") == "show") {
                            const expression = action.get("selector");
                            if (expression !== undefined && expression !== null) {
                                const meshes = this._elementSelector.getElements(this._zkScene, this._scene, null, expression, MPlaza.SceneElementType.Mesh);
                                for (let k = 0; k < meshes.length; k++) {
                                    const mesh = meshes[k];
                                    if (mesh instanceof BABYLON.AbstractMesh && !mesh.isVisible) {
                                        //Logger.info("prefetch", mesh);
                                        this._sceneHelper.checkDelayState(mesh);
                                        await this._sceneHelper.prefetchTexturesFormMeshAsync(mesh);
                                    }
                                }
                            }
                        }
    
                        // Materiali
                        if (this._prefetchMaterials &&
                            (action.get("actionTypeID") === MPlaza.SceneActionType.SetMeshMaterial ||
                             action.get("actionTypeID") === MPlaza.SceneActionType.SetSubMeshMaterial)) {
                            const material = this.getMaterialFromActionValue(action);
                            if (material) {
                                await this._sceneHelper.prefetchTexturesForMaterialAsync(material);
                            } else if (!this.useMaterialOffloading) {
                                // Precarico il materiale
                                const material = await this.getDeepMaterialFromActionValueAsync(action);
                            } else {
                                // Precarico le immagini associate al materiale
                                const rootUrl = this._zkScene.get("rootUrl");
                                const materialID = this.getOffloadedMaterialIDFromAction(action);
                                if (rootUrl !== undefined && rootUrl !== null && materialID) {
    
                                    const textureUrls = this._zkScene.get("textures")
                                        .filter(texture => texture.get("materialID") === materialID &&
                                                (texture.get("usage") === Zakeke.TextureUsage.Any ||
                                                (texture.get("usage") === Zakeke.TextureUsage.Desktop && !BABYLON.Constants.IS_MOBILE) ||
                                                (texture.get("usage") === Zakeke.TextureUsage.Mobile && BABYLON.Constants.IS_MOBILE)) )
                                        .map(t => t.get("url") as string);
    
                                    this._sceneHelper.loadTextureFiles(rootUrl, textureUrls);
                                }
                            }
                        }
                    }
                }
            }*/
        });
    }
}


/***/ }),

/***/ "../../3D/src/Components/CollapseExplode/MeshLocationsManager.ts":
/*!***********************************************************************!*\
  !*** ../../3D/src/Components/CollapseExplode/MeshLocationsManager.ts ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MeshLocationsManager": () => (/* binding */ MeshLocationsManager)
/* harmony export */ });
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

class MeshLocationsManager {
    constructor() {
        this._zkScene = null;
        this._scene = null;
        this._sceneHelper = null;
        this._meshLocationCache = {};
        this._cameraAnimationCompletedListeners = [];
        this._meshAnimationCompletedListeners = [];
        this._beforeSaveMeshLocationListeners = [];
        this._afterSaveMeshLocationListeners = [];
    }
    dispose() {
        while (this._cameraAnimationCompletedListeners.length > 0) {
            this._cameraAnimationCompletedListeners.pop();
        }
        while (this._meshAnimationCompletedListeners.length > 0) {
            this._meshAnimationCompletedListeners.pop();
        }
        while (this._beforeSaveMeshLocationListeners.length > 0) {
            this._beforeSaveMeshLocationListeners.pop();
        }
        while (this._afterSaveMeshLocationListeners.length > 0) {
            this._afterSaveMeshLocationListeners.pop();
        }
        this.disposeSceneHelper();
    }
    setScene(scene) {
        this._scene = scene;
        this.resetSceneHelper();
        this.resetCache();
    }
    setModel(zkScene) {
        this._zkScene = zkScene;
        this.resetCache();
    }
    setModelAndScene(zkScene, scene) {
        this._zkScene = zkScene;
        this._scene = scene;
        this.resetSceneHelper();
        this.resetCache();
    }
    resetCache() {
        this._meshLocationCache = {};
    }
    invalidateCache(locationID) {
        if (this._meshLocationCache)
            delete this._meshLocationCache[locationID];
    }
    disposeSceneHelper() {
        if (this._sceneHelper) {
            this._sceneHelper.dispose();
            this._sceneHelper = null;
        }
    }
    resetSceneHelper() {
        this.disposeSceneHelper();
        if (this._scene)
            this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper(this._scene);
    }
    clearMeshLocations() {
        if (this._zkScene) {
            const items = this._zkScene.get("meshLocations");
            while (items.length > 0)
                items.remove(items.at(0));
        }
    }
    setMeshLocationByID(locationID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._zkScene && this._scene) {
                const zkMeshLocation = this._zkScene.getMeshLocation(locationID);
                if (zkMeshLocation)
                    yield this.setMeshLocation(zkMeshLocation);
            }
        });
    }
    setMeshLocation(zkMeshLocation) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._zkScene && this._scene && this._sceneHelper) {
                let data;
                let adjustCamera = true;
                if (zkMeshLocation) {
                    let locationID = zkMeshLocation.get("locationID");
                    adjustCamera = zkMeshLocation.get("adjustCamera");
                    if (this._meshLocationCache.hasOwnProperty(locationID)) {
                        data = this._meshLocationCache[locationID];
                    }
                    else {
                        let compressedData = zkMeshLocation.get("data");
                        let uint8Array = null;
                        // Verifico se ho ottenuto una string (base64) o direttamente l'array
                        if (typeof compressedData === "string") {
                            let binary_string = window.atob(compressedData);
                            let len = binary_string.length;
                            let bytes = new Uint8Array(len);
                            for (let i = 0; i < len; i++) {
                                bytes[i] = binary_string.charCodeAt(i);
                            }
                            let arrayBuffer = bytes.buffer;
                            uint8Array = new Uint8Array(arrayBuffer);
                        }
                        else if (Object.prototype.toString.call(compressedData) === '[object Array]') {
                            uint8Array = Uint8Array.from(compressedData);
                        }
                        if (uint8Array != null) {
                            let json = LZString.decompressFromUint8Array(uint8Array);
                            data = JSON.parse(json);
                            if (data) {
                                for (var id in data) {
                                    var info = data[id];
                                    if (info.p)
                                        info.p = new BABYLON.Vector3(info.p.x, info.p.y, info.p.z);
                                    if (info.rE)
                                        info.rE = new BABYLON.Vector3(info.rE.x, info.rE.y, info.rE.z);
                                    if (info.rQ)
                                        info.rQ = new BABYLON.Quaternion(info.rQ.x, info.rQ.y, info.rQ.z, info.rQ.w);
                                    if (info.s)
                                        info.s = new BABYLON.Vector3(info.s.x, info.s.y, info.s.z);
                                }
                                this._meshLocationCache[locationID] = data;
                            }
                        }
                    }
                }
                if (data) {
                    const tasks = [];
                    // Animazione della camera
                    if (adjustCamera && data.hasOwnProperty("wemin") && data.hasOwnProperty("wemax")) {
                        var worldExtends = {
                            min: new BABYLON.Vector3(data.wemin.x, data.wemin.y, data.wemin.z),
                            max: new BABYLON.Vector3(data.wemax.x, data.wemax.y, data.wemax.z)
                        };
                        let camera = this._sceneHelper.camera;
                        if (camera && camera instanceof BABYLON.ArcRotateCamera) {
                            camera.upperRadiusLimit = null;
                            var radius = this._sceneHelper.calculateCameraRadius(worldExtends);
                            var target = this._sceneHelper.getWorldCenter(worldExtends);
                            if (target) {
                                this._sceneHelper.setCameraRadiusParameters(radius);
                                tasks.push(new Promise(resolve => {
                                    if (camera && camera instanceof BABYLON.ArcRotateCamera) {
                                        this._sceneHelper.animateCameraToFinalParamters(camera.alpha, camera.beta, radius, target, 1, () => {
                                            if (this._sceneHelper) {
                                                this._sceneHelper.setupCameraLimits(worldExtends);
                                                this.fireCameraAnimationCompletedEvent();
                                                resolve();
                                            }
                                        });
                                    }
                                }));
                            }
                        }
                    }
                    // Animazione delle mesh
                    for (var i = 0; i < this._scene.meshes.length; i++) {
                        var mesh = this._scene.meshes[i];
                        var id = mesh.id;
                        if (data.hasOwnProperty(id)) {
                            var info = data[id];
                            // Test animazione
                            tasks.push(new Promise(resolve => {
                                this._sceneHelper.animateMeshToFinalParameters(mesh, info.p, info.rE, info.rQ, info.s, 1, () => {
                                    this.fireMeshAnimationCompletedEvent();
                                    resolve();
                                });
                            }));
                        }
                    }
                    yield Promise.all(tasks);
                }
            }
        });
    }
    saveMeshLocation(name) {
        if (this._zkScene && this._scene) {
            var zkMeshLocation = new Zakeke.SceneMeshLocation();
            zkMeshLocation.set("name", name);
            this.updateMeshLocation(zkMeshLocation);
            this._zkScene.get("meshLocations").push(zkMeshLocation);
        }
    }
    saveExplodedMeshLocation() {
        if (this._zkScene && this._scene) {
            var zkMeshLocation = this._zkScene.getOrCreateExplodedMeshLocation();
            this.updateMeshLocation(zkMeshLocation);
        }
    }
    saveCollapsedMeshLocation() {
        if (this._zkScene && this._scene) {
            var zkMeshLocation = this._zkScene.getOrCreateCollapsedMeshLocation();
            this.updateMeshLocation(zkMeshLocation);
        }
    }
    updateMeshLocation(zkMeshLocation) {
        this.fireBeforeSaveMeshLocationEvent();
        if (this._scene && this._sceneHelper) {
            var data = this.getMeshPRSs();
            // Salvo il world extends perché servirà nell'animazione della camera
            var worldExtends = this._sceneHelper.getWorldExtends();
            if (worldExtends) {
                data.wemin = worldExtends.min;
                data.wemax = worldExtends.max;
            }
            var json = JSON.stringify(data);
            let uint8Array = LZString.compressToUint8Array(json);
            let compressed = [].slice.call(uint8Array);
            //let compressed = Array.from(uint8Array);
            zkMeshLocation.set("data", compressed);
            this.invalidateCache(zkMeshLocation.get("locationID"));
        }
        this.fireAfterSaveMeshLocationEvent();
    }
    getMeshPRSs() {
        let data = {
            wemin: undefined,
            wemax: undefined
        };
        if (this._scene && this._sceneHelper) {
            for (let i = 0; i < this._scene.meshes.length; i++) {
                const mesh = this._scene.meshes[i];
                if (this._sceneHelper.isRealMesh(mesh)) {
                    let id = mesh.id;
                    let info = {
                        p: undefined,
                        rQ: undefined,
                        rE: undefined,
                        s: undefined
                    };
                    info.p = mesh.position.clone();
                    if (mesh.rotationQuaternion == null) {
                        info.rQ = null;
                        info.rE = mesh.rotation.clone();
                    }
                    else {
                        info.rQ = mesh.rotationQuaternion.clone();
                        info.rE = null;
                    }
                    info.s = mesh.scaling.clone();
                    data[id] = info;
                }
            }
        }
        return data;
    }
    explodeMeshes() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._zkScene) {
                let zkMeshLocation = this._zkScene.getFirstExplodedMeshLocation();
                if (zkMeshLocation)
                    yield this.setMeshLocation(zkMeshLocation);
            }
        });
    }
    collapseMeshes() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._zkScene) {
                let zkMeshLocation = this._zkScene.getFirstCollapsedMeshLocation();
                if (zkMeshLocation)
                    yield this.setMeshLocation(zkMeshLocation);
            }
        });
    }
    // Events
    fireCameraAnimationCompletedEvent() {
        for (let i = 0; i < this._cameraAnimationCompletedListeners.length; ++i) {
            this._cameraAnimationCompletedListeners[i]();
        }
    }
    addCameraAnimationCompletedListener(listenerFunction) {
        this._cameraAnimationCompletedListeners.push(listenerFunction);
    }
    fireMeshAnimationCompletedEvent() {
        for (let i = 0; i < this._meshAnimationCompletedListeners.length; ++i) {
            this._meshAnimationCompletedListeners[i]();
        }
    }
    addMeshAnimationCompletedListener(listenerFunction) {
        this._meshAnimationCompletedListeners.push(listenerFunction);
    }
    fireBeforeSaveMeshLocationEvent() {
        for (let i = 0; i < this._beforeSaveMeshLocationListeners.length; ++i) {
            this._beforeSaveMeshLocationListeners[i]();
        }
    }
    addBeforeSaveMeshLocationListener(listenerFunction) {
        this._beforeSaveMeshLocationListeners.push(listenerFunction);
    }
    fireAfterSaveMeshLocationEvent() {
        for (let i = 0; i < this._afterSaveMeshLocationListeners.length; ++i) {
            this._afterSaveMeshLocationListeners[i]();
        }
    }
    addAfterSaveMeshLocationListener(listenerFunction) {
        this._afterSaveMeshLocationListeners.push(listenerFunction);
    }
}


/***/ }),

/***/ "../../3D/src/Components/DesignManagers/MeshDesignManager.ts":
/*!*******************************************************************!*\
  !*** ../../3D/src/Components/DesignManagers/MeshDesignManager.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MeshDesignManager": () => (/* binding */ MeshDesignManager)
/* harmony export */ });
/* harmony import */ var _Helpers_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Helpers/debounce */ "../../3D/src/Helpers/debounce.ts");
/* harmony import */ var _NormalMap_ProceduralNormalMap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../NormalMap/ProceduralNormalMap */ "../../3D/src/Components/NormalMap/ProceduralNormalMap.ts");
/* harmony import */ var _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ProceduralTextures/ForegroundBackgroundProceduralTexture */ "../../3D/src/Components/ProceduralTextures/ForegroundBackgroundProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../ProceduralTextures/MultiplyProceduralTexture */ "../../3D/src/Components/ProceduralTextures/MultiplyProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_OverlayProceduralTexture__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../ProceduralTextures/OverlayProceduralTexture */ "../../3D/src/Components/ProceduralTextures/OverlayProceduralTexture.ts");
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
/* harmony import */ var _Shadows_InnerShadow__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Shadows/InnerShadow */ "../../3D/src/Components/Shadows/InnerShadow.ts");
/* harmony import */ var _Shadows_OuterShadow__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Shadows/OuterShadow */ "../../3D/src/Components/Shadows/OuterShadow.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};








class MeshDesignManager {
    constructor(scene, zkScene, mesh, subMesh, zkModel, zkDesign, showDesign = true, effect) {
        this._subMesh = null;
        this._showDesign = true;
        // effect.get("materialID") indica il material da utilizzare per il design
        // effect.get("config") indica la configurazione da applicare
        this._effect = null;
        this._meshSide = null; // mesh - model side connection
        this._side = null; // Lato del modello (relativo ad un determinato colore) collegato alla mesh
        // Il lato esatto viene individuato in base agli item inseriti nel design (se ci sono)
        // Se il design non prevede item per il lato per nessun colore, il lato sarà null e sulla mesh non verrà
        // disegnato nulla
        this._defaultSize = 1024;
        //private readonly _size = Utils.isIPhoneX() ? 512 : 1024;
        this._size = 1024;
        this._baseWidth = this._size;
        this._baseHeight = this._size;
        this._textureWidth = this._size;
        this._textureHeight = this._size;
        this._coordinatesIndex = 0; // canale UV per le texture
        this._canvasMesh = null; // mesh clone per l'applicazione della texture dinamica (generata in base al design rappresentato sul canvas)
        this._originalCanvasMeshPosition = null; // Posizione originale della mesh clonata
        this._originalCanvasMeshScaling = null; // Scaling originale della mesh clonata
        this._normalmapMaterial = null; // materiale clonato per l'applicazione della normal map dinamica sulla mesh originale
        this._originalMaterial = null; // materiale originale della mesh
        this._blankDataUrl = null; // utile per verificare quando il canvas contiene un'immagine completamente vuota
        // L'esportazione per AR non supporta zOffset per i materiali. Una soluzione è quella di creare un clone
        // per la parte interna e uno per la parte esterna dell'oggetto, rispettivamente rimpicciolito e ingrandito di pochissimo
        // in modo da sovrapporsi all'oggetto originale. Resterebbe in questo modo scoperto solo la parte laterale dell'oggetto,
        // ma dovrebbe mitigare le problematiche. Un'alternativa sarebbe quella di usare MeshExpander per espandere l'oggetto in modo da
        // racchiuderlo, ma questo creerebbe un duplicato della gemoetria e non risolverebbe comunque il caso di oggetto piatto (senza spessore).
        this._innerCanvasMesh = null;
        this._outerCanvasMesh = null;
        this._ownDynamicMaterial = false;
        this._dynamicMaterial = null; // Materiale applicato alla mesh clonata per rappresentare il contenuto del canvas 
        this._dynamicTexture = null; // Texture che contiene il contenuto del canvas
        this._normalmapTexture = null; // Texture che contiene la normal map relativa al contenuto del canvas
        // La normal map può essere applicata sia al materiale della mesh (per effetto rilievo/incassato)
        // che alla mesh clonata per evidenziare il design
        this._dynamicOpacityTexture = null; // Procedurale creata nel caso in cui il design debba essere utilizzato
        // come mappa di opacità
        this._ownOldDynamicMaterial = false;
        this._oldDynamicMaterial = null;
        this._originalDiffuseTexture = null;
        this._combinedDiffuseTexture = null;
        // Le due normal map texture seguenti verranno eventualmente combinate (blend overlay) con
        // la normalmap generata dinamicamente dal contenuto del canvas
        this._originalMeshNormalmapTexture = null; // normalmap texture presente inizialmente sul materiale della mesh originale
        this._originalDesignNormalmapTexture = null; // Normal map orignale del materiale da utilizzare per la mesh clonata (che ricerverà il contenuto del canvas)
        // Texture procedurali date dalla combinazione della texture dinamica dal canvas
        // con le texture presenti sui materiali originali
        this._meshCombinedNormalmapTexture = null;
        this._designCombinedNormalmapTexture = null;
        // Lightmaps utili per outer e inner shadow
        this._originalMeshLightmapTexture = null; // da combinare con outer shadow
        this._originalDesignLightmapTexture = null; // da combinare con inner shadow
        this._meshCombinedLightmapTexture = null; // outer shadow finale
        this._designCombinedLightmapTexture = null; // inner shadow finale
        this._innerShadowTexture = null;
        this._outerShadowTexture = null;
        this._context = null;
        this._canvas = null;
        this._canvasID = Zakeke.generateUUID();
        this._customizer = null;
        this._renderingNeededListeners = [];
        // Generatore di texture procedurali per la normal map
        this._proceduralNormalMap = null;
        // Generatore di texture procedurali per inner/outer shadow
        this._innerShadowGenerator = null;
        this._outerShadowGenerator = null;
        this._debouncedUpdateDynamicTexture = null;
        this._originalViewMatrixValues = null;
        this._grids = [];
        // First render is not debounced, usefull for screenshots that must wait the
        // render to finish
        this.isFirstRender = true;
        this._scene = scene;
        this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper(scene);
        this._zkScene = zkScene;
        this._mesh = mesh;
        this._subMesh = subMesh;
        this._zkModel = zkModel;
        this._zkDesign = zkDesign;
        this._showDesign = showDesign;
        if (effect)
            this._effect = effect;
        //this.initAsync();
    }
    get showDesign() {
        return this._showDesign;
    }
    set showDesign(value) {
        if (this._showDesign != value) {
            this._showDesign = value;
        }
    }
    get side() {
        return this._side;
    }
    // Temporary until we can access internal matrix (speak with Matteo)
    getInternalCustomizer() {
        return this._customizer;
    }
    // Factory method for async object creation and initialization
    static createMeshDesignManagerAsync(scene, zkScene, mesh, subMesh, zkModel, zkDesign, showDesign = true, effect) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshDesignManager = new MeshDesignManager(scene, zkScene, mesh, subMesh, zkModel, zkDesign, showDesign, effect);
            yield meshDesignManager.initAsync();
            return meshDesignManager;
        });
    }
    initAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            // Just to be sure the mesh has the right material and not the dummy one
            const rootUrl = this._zkScene.get("rootUrl");
            if (rootUrl)
                yield this._sceneHelper.unsetMeshDummyMaterialAsync(this._mesh, rootUrl, true);
            this.setupMeshSide();
            this.checkDefaultEffect();
            this.refreshModelSide();
            yield this.setupClonedObjectsAsync();
            yield this.setupCanvasAsync();
            yield this.setupDynamicMaterialAsync();
            yield this.refreshAsync();
        });
    }
    isForMesh(mesh, subMesh) {
        if (!mesh || !this._mesh)
            return false;
        if (mesh.id !== this._mesh.id)
            return false;
        if (!this._subMesh && !subMesh)
            return true;
        if (!this._subMesh || !subMesh)
            return false;
        if (subMesh.materialIndex === this._subMesh.materialIndex)
            return true;
        return false;
        /*
        if (mesh && subMesh && this._mesh && this._subMesh &&
            mesh.id === this._mesh.id &&
            subMesh.materialIndex === this._subMesh.materialIndex) {
            return true;
        }
        else {
            return false;
        }
        */
    }
    getMeshID() {
        return this._mesh ? this._mesh.id : null;
    }
    getSubMeshIdx() {
        return this._subMesh ? this._subMesh.materialIndex : 0;
    }
    getMaterialIDForDesign() {
        let materialID;
        if (this._effect && this._effect.get("materialID")) {
            materialID = this._effect.get("materialID");
        }
        else if (this._mesh && this._mesh.metadata && this._mesh.metadata.designMaterialID) {
            materialID = this._mesh.metadata.designMaterialID;
        }
        else if (this._meshSide && this._meshSide.get("materialID")) {
            materialID = this._meshSide.get("materialID");
        }
        return materialID;
    }
    getDesignConfig() {
        let config;
        if (this._effect && this._effect.get("config")) {
            config = this._effect.get("config");
        }
        else if (this._meshSide && this._meshSide.get("config")) {
            config = this._meshSide.get("config");
        }
        if (!config) {
            config = new MPlaza.MeshDesignConfig();
        }
        return config;
    }
    dispose() {
        console.log('dispose');
        if (this._customizer) {
            this._customizer.clearMemoryForIOS();
            this._customizer = null;
        }
        this.disposeOuterInnerCanvasMeshes();
        if (this._canvasMesh) {
            this._canvasMesh.dispose();
            this._canvasMesh = null;
            this._originalCanvasMeshPosition = null;
            this._originalCanvasMeshScaling = null;
        }
        this.disposeDynamicMaterial();
        if (this._dynamicOpacityTexture) {
            this._dynamicOpacityTexture.dispose();
            this._dynamicOpacityTexture = null;
        }
        if (this._dynamicTexture) {
            this._dynamicTexture.dispose();
            this._dynamicTexture = null;
        }
        this._renderingNeededListeners = [];
        $("#" + this._canvasID).remove();
        this.restoreOrignalMaterial();
        this.disposeNormalmapMaterial();
        if (this._proceduralNormalMap) {
            this._proceduralNormalMap.dispose();
            this._proceduralNormalMap = null;
        }
        if (this._innerShadowGenerator) {
            this._innerShadowGenerator.dispose();
            this._innerShadowGenerator = null;
        }
        if (this._combinedDiffuseTexture) {
            this._combinedDiffuseTexture.dispose();
            this._combinedDiffuseTexture = null;
        }
        if (this._meshCombinedNormalmapTexture) {
            this._meshCombinedNormalmapTexture.dispose();
            this._meshCombinedNormalmapTexture = null;
        }
        if (this._designCombinedNormalmapTexture) {
            this._designCombinedNormalmapTexture.dispose();
            this._designCombinedNormalmapTexture = null;
        }
        if (this._meshCombinedLightmapTexture) {
            this._meshCombinedLightmapTexture.dispose();
            this._meshCombinedLightmapTexture = null;
        }
        if (this._designCombinedLightmapTexture) {
            this._designCombinedLightmapTexture.dispose();
            this._designCombinedLightmapTexture = null;
        }
    }
    disposeOuterInnerCanvasMeshes() {
        if (this._innerCanvasMesh) {
            this._innerCanvasMesh.dispose();
            this._innerCanvasMesh = null;
        }
        if (this._outerCanvasMesh) {
            this._outerCanvasMesh.dispose();
            this._outerCanvasMesh = null;
        }
    }
    disposeNormalmapMaterial() {
        if (this._normalmapMaterial &&
            this._originalMaterial &&
            this._normalmapMaterial.id !== this._originalMaterial.id &&
            this._sceneHelper.getMeshesUsingMaterial(this._normalmapMaterial.id).length == 0) {
            this._normalmapMaterial.dispose();
            this._normalmapMaterial = null;
        }
        this._originalMeshNormalmapTexture = null;
        this._originalMeshLightmapTexture = null;
    }
    disposeDynamicMaterial() {
        if (this._ownDynamicMaterial && this._dynamicMaterial) {
            this._dynamicMaterial.dispose();
        }
        this._dynamicMaterial = null;
        this._originalDesignNormalmapTexture = null;
        this._originalDesignLightmapTexture = null;
    }
    disposeOldDynamicMaterial() {
        if (this._ownOldDynamicMaterial && this._oldDynamicMaterial &&
            this._dynamicMaterial && this._oldDynamicMaterial != this._dynamicMaterial) {
            this._oldDynamicMaterial.dispose();
        }
        this._oldDynamicMaterial = null;
    }
    createCanvasMeshClone(name) {
        if (this._canvasMesh) {
            const clone = this._canvasMesh.clone(name, null);
            if (clone) {
                clone.id = Zakeke.generateUUID();
                if (this._canvasMesh.metadata && this._canvasMesh.metadata.AR !== undefined && this._canvasMesh.metadata.AR !== null) {
                    if (!clone.metadata)
                        clone.metadata = {};
                    clone.metadata.AR = this._canvasMesh.metadata.AR;
                }
                return clone;
            }
        }
        return null;
    }
    expandCanvasMesh() {
        if (!this._mesh || !this._canvasMesh)
            return;
        this.disposeOuterInnerCanvasMeshes();
        const scaling = this._mesh.scaling;
        const delta = 0.01;
        const scaleUp = 1.0 + delta;
        const scaleDown = 1.0 - delta;
        const meshSize = this.getMeshHierarchySize(this._mesh);
        const canvasMeshSize = this.getMeshHierarchySize(this._canvasMesh);
        // La mesh originale e il clone devono avere le stesse dimensioni iniziali
        if (!meshSize.equals(canvasMeshSize))
            return;
        const meshCenter = this.getMeshHierarchyCenter(this._mesh);
        this._outerCanvasMesh = this.createCanvasMeshClone(this._mesh.name + " outer clone");
        //this._innerCanvasMesh = this.createCanvasMeshClone(this._mesh.name + " inner clone");
        this._canvasMesh.isVisible = false;
        if (this._outerCanvasMesh) {
            const epsilon = 0.1;
            const isPlane = Math.abs(meshSize.x) <= epsilon || Math.abs(meshSize.y) <= epsilon || Math.abs(meshSize.z) <= epsilon;
            if (!isPlane) {
                // Scale up outer mesh
                const scalingOuter = scaling.multiplyByFloats(scaleUp, scaleUp, scaleUp);
                this._outerCanvasMesh.scaling = scalingOuter;
                const outerCenter = this.getMeshHierarchyCenter(this._outerCanvasMesh);
                let deltaVect = meshCenter.subtract(outerCenter);
                if (!deltaVect.equals(BABYLON.Vector3.Zero())) {
                    this._outerCanvasMesh.position.addInPlace(deltaVect);
                }
                // Scale down inner mesh
                //const scalingInner = scaling.multiplyByFloats(scaleDown, scaleDown, scaleDown);
                //this._innerCanvasMesh.scaling = scalingInner;
                //const innerCenter = this.getMeshHierarchyCenter(this._innerCanvasMesh);
                //deltaVect = meshCenter.subtract(innerCenter);
                //if (!deltaVect.equals(BABYLON.Vector3.Zero())) {
                //    this._innerCanvasMesh.position.addInPlace(deltaVect);
                //}
            }
            else {
                // se è un piano sposto la mesh leggermente nella direzione della normale
                const normals = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
                const normal = BABYLON.Vector3.FromArray(normals, 0).normalize();
                this._outerCanvasMesh.position = this._outerCanvasMesh.position.add(normal.scale(delta));
                //this._innerCanvasMesh.position = this._innerCanvasMesh.position.add(normal.scale(-delta));
            }
        }
    }
    // Nel caso in cui la mesh non sia un piano, espande la mesh clone in modo che 
    // racchiuda quella originale e che eviti il problema z- fighting. 
    // Nel caso in cui si tratti di un piano (o di un disco o equivalenti), la mesh clone verrà solo
    // spostata leggermente nella direzione della normale al piano
    // Tale possibilità verrà sfruttata soprattutto in fase di esportazione in altro formato che non preveda
    // proprietà simili al zOffset di Babylon JS
    expandCanvasMesh_old() {
        if (!this._mesh || !this._canvasMesh)
            return;
        const delta = 0.01;
        const scale = 1.0 + delta;
        const meshSize = this.getMeshHierarchySize(this._mesh);
        const canvasMeshSize = this.getMeshHierarchySize(this._canvasMesh);
        // La mesh originale e il clone devono avere le stesse dimensioni iniziali
        if (!meshSize.equals(canvasMeshSize))
            return;
        const epsilon = 0.1;
        const isPlane = Math.abs(meshSize.x) <= epsilon || Math.abs(meshSize.y) <= epsilon || Math.abs(meshSize.z) <= epsilon;
        if (!isPlane) {
            let scaling = this._canvasMesh.scaling;
            scaling = scaling.multiplyByFloats(scale, scale, scale);
            this._canvasMesh.scaling = scaling;
            // Nel caso in cui il pivot non sia al centro della mesh
            // lo scaling del clone lo avrà anche spostato
            let meshCenter = this.getMeshHierarchyCenter(this._mesh);
            let canvasMeshCenter = this.getMeshHierarchyCenter(this._canvasMesh);
            const deltaVect = meshCenter.subtract(canvasMeshCenter);
            if (!deltaVect.equals(BABYLON.Vector3.Zero())) {
                this._canvasMesh.position.addInPlace(deltaVect);
            }
        }
        else {
            // se è un piano sposto la mesh leggermente nella direzione della normale
            let normals = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
            let normal = BABYLON.Vector3.FromArray(normals, 0).normalize();
            this._canvasMesh.position = this._canvasMesh.position.add(normal.scale(delta));
        }
    }
    contractCanvasMesh() {
        if (this._canvasMesh)
            this._canvasMesh.isVisible = true;
        this.disposeOuterInnerCanvasMeshes();
    }
    // Riporta la mesh clone allo stato originale, continuando a sfruttare unicamente la proprietà
    // zOffset per superare il problema dello z-fighting
    contractCanvasMesh_old() {
        if (!this._mesh || !this._canvasMesh || !this._originalCanvasMeshScaling || !this._originalCanvasMeshPosition)
            return;
        this._canvasMesh.scaling = this._originalCanvasMeshScaling;
        this._canvasMesh.position = this._originalCanvasMeshPosition;
        // Verifico che il centro coincida
        const meshCenter = this.getMeshHierarchyCenter(this._mesh);
        const canvasMeshCenter = this.getMeshHierarchyCenter(this._canvasMesh);
        const deltaVect = meshCenter.subtract(canvasMeshCenter);
        if (!deltaVect.equals(BABYLON.Vector3.Zero())) {
            this._canvasMesh.position.addInPlace(deltaVect);
        }
    }
    setupMeshSide() {
        this._meshSide = null;
        this._coordinatesIndex = 0;
        if (this._zkModel && this._mesh && this._mesh.id) {
            for (let i = 0; i < this._zkModel.get("scenes").length; i++) {
                var scene = this._zkModel.get("scenes").at(i);
                if (scene.get("isDefault")) {
                    // Scena di default
                    for (let j = 0; j < scene.get("meshSides").length; j++) {
                        var meshSide = scene.get("meshSides").at(j);
                        if (meshSide.get("meshID") == this._mesh.id) {
                            this._meshSide = meshSide;
                            if (this._meshSide.get("uvChannel") >= 0)
                                this._coordinatesIndex = this._meshSide.get("uvChannel");
                            return;
                        }
                    }
                }
            }
        }
    }
    checkDefaultEffect() {
        if (!this._effect && this._meshSide) {
            var modelScene = this._meshSide.getParentModel();
            if (modelScene && modelScene instanceof MPlaza.ModelScene) {
                let meshID = this.getMeshID();
                if (meshID) {
                    let effect = modelScene.getDefaultDesignEffect(meshID, this.getSubMeshIdx());
                    if (effect)
                        this._effect = effect;
                }
            }
        }
    }
    getAllSides() {
        const sides = [];
        this._zkModel.get('colors').each(color => {
            color.get("sides").each(side => {
                if (!sides.find(x => x.get("sideID") == side.get("sideID"))) {
                    sides.push(side);
                }
            });
        });
        return sides;
    }
    // Recupera il lato del modello corrispondente alla mesh in input
    // Del lato abbiamo solo sideID, mentre per il modello i lati sono per colore. Recuperiamo il colorID
    // in base agli elementi del design, considerando buono il primo colore con elementi grafici
    refreshModelSide() {
        this._side = null;
        if (this._meshSide && this._zkDesign) {
            const sideID = this._meshSide.get("sideID");
            const tempID = this._meshSide.tempID;
            let side = null;
            // Find the first side available so we can get all items on the side
            side = this.getAllSides().find(function (side) { return side.get("sideID") == sideID; }) || null;
            if (side) {
                let designItem = null;
                for (const _designItem of this._zkDesign.get("designItems").models) {
                    designItem = _designItem;
                    if (designItem.isOnSide(side)) {
                        // Get the correct color from the design item
                        const colorID = designItem && designItem.get("areas").length > 0 ? designItem.get("areas").at(0).get("colorID") : null;
                        // Find the correct side of the correct color
                        if (colorID) {
                            this._zkModel.get("colors").each(function (color) {
                                if (color.get("colorID") == colorID)
                                    color.get("sides").each(function (_side) {
                                        if (_side.tempID ? _side.tempID == tempID : _side.get("sideID") == sideID) {
                                            side = _side;
                                        }
                                    });
                            });
                        }
                        break;
                    }
                }
                this._side = side;
            }
        }
    }
    setupClonedObjectsAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._side)
                return;
            for (var i = 0; i < this._scene.meshes.length; i++) {
                let mesh = this._scene.meshes[i];
                if (mesh && mesh.metadata && mesh.metadata.originalMeshID && mesh.metadata.originalMeshID == this._mesh.id) {
                    this._canvasMesh = mesh;
                    this._normalmapMaterial = this._mesh.material;
                    this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial);
                    this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial);
                    break;
                }
            }
            if (!this._canvasMesh) {
                let name = this._mesh.name + " - clone";
                this._canvasMesh = this._mesh.clone(name, null);
                if (this._canvasMesh) {
                    this._canvasMesh.id = Zakeke.generateUUID();
                    this._canvasMesh.doNotSerialize = true;
                    this._canvasMesh.isPickable = false;
                    this._canvasMesh.metadata = {};
                    this._canvasMesh.metadata.originalMeshID = this._mesh.id;
                    this._canvasMesh.metadata.isRealMesh = false;
                    this._canvasMesh.metadata.iscanvasMesh = true;
                    if (this._mesh.metadata && this._mesh.metadata.AR !== undefined && this._mesh.metadata.AR !== null)
                        this._canvasMesh.metadata.AR = this._mesh.metadata.AR;
                }
            }
            if (this._canvasMesh) {
                this._originalCanvasMeshPosition = this._canvasMesh.position;
                this._originalCanvasMeshScaling = this._canvasMesh.scaling;
            }
            if (!this._normalmapMaterial) {
                yield this.setupNormalmapMaterialAsync();
            }
        });
    }
    // Prepara il materiale per la normalmap da applicare alla mesh originale
    // posizionata sotto quella su cui è apposto il design.
    // Tale materiale viene utilizzato anche per l'eventuale lightmap di dropshadow (outer shadow)
    // quindi il nome andrebbe cambiato
    setupNormalmapMaterialAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this.disposeNormalmapMaterial();
            this._originalMaterial = this._mesh.material;
            let materialId = Zakeke.generateUUID();
            let materialName = "normalmapMaterial - " + materialId;
            if (this._originalMaterial) {
                materialName = this._originalMaterial.name + " - clone";
                this._normalmapMaterial = yield this.cloneMaterialAsync(this._originalMaterial, materialName);
            }
            else {
                this._normalmapMaterial = new BABYLON.StandardMaterial(materialName, this._scene);
            }
            if (this._normalmapMaterial) {
                this._normalmapMaterial.id = materialId;
                this._normalmapMaterial.doNotSerialize = true;
                this._normalmapMaterial.metadata = {};
                if (this._originalMaterial)
                    this._normalmapMaterial.metadata.originalMaterialID = this._originalMaterial.id;
                else
                    this._normalmapMaterial.metadata.originalMaterialID = null;
                this._normalmapMaterial.metadata.isRealMaterial = false;
                this._originalMeshNormalmapTexture = this.getMaterialNormalmap(this._normalmapMaterial);
                this._originalMeshLightmapTexture = this.getMaterialLightmap(this._normalmapMaterial);
            }
        });
    }
    getOriginalTexture() {
        if (this._originalMaterial) {
            var propertyName = this.getMaterialDiffuseTexturePropertyName(this._originalMaterial);
            if (!this._originalMaterial[propertyName])
                return null;
            return this._originalMaterial[propertyName];
        }
        return null;
    }
    getMaterialDiffuseTexturePropertyName(material) {
        if (material instanceof BABYLON.StandardMaterial) {
            return "diffuseTexture";
        }
        else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
            return "baseTexture";
        }
        else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
            return "diffuseTexture";
        }
        else if (material instanceof BABYLON.PBRMaterial) {
            return "albedoTexture";
        }
        else if (material instanceof Zakeke.PBRMaterial) {
            return "albedoTexture";
        }
        return "diffuseTexture";
    }
    getMaterialOpacityTexturePropertyName(material) {
        if (material instanceof BABYLON.StandardMaterial) {
            return "opacityTexture";
        }
        else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
            return null;
        }
        else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
            return null;
        }
        else if (material instanceof BABYLON.PBRMaterial) {
            return "opacityTexture";
        }
        else if (material instanceof Zakeke.PBRMaterial) {
            return "opacityTexture";
        }
        return "opacityTexture";
    }
    getMaterialNormalmapTexturePropertyName(material) {
        if (material instanceof BABYLON.StandardMaterial) {
            return "bumpTexture";
        }
        else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
            return "normalTexture";
        }
        else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
            return "normalTexture";
        }
        else if (material instanceof BABYLON.PBRMaterial) {
            return "bumpTexture";
        }
        else if (material instanceof Zakeke.PBRMaterial) {
            return "bumpTexture";
        }
        return "bumpTexture";
    }
    getMaterialLightmapTexturePropertyName(material) {
        if (material instanceof BABYLON.StandardMaterial) {
            return "ambientTexture";
        }
        else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
            return "occlusionTexture";
        }
        else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
            return "occlusionTexture";
        }
        else if (material instanceof BABYLON.PBRMaterial) {
            return "ambientTexture";
        }
        else if (material instanceof Zakeke.PBRMaterial) {
            return "aoTexture";
        }
        return "lightmapTexture";
    }
    getMaterialDiffuse(material) {
        let propName = this.getMaterialDiffuseTexturePropertyName(material);
        return material[propName];
    }
    getMaterialNormalmap(material) {
        if (!material)
            return null;
        let propName = this.getMaterialNormalmapTexturePropertyName(material);
        return material[propName];
    }
    getMaterialLightmap(material) {
        if (!material)
            return null;
        let propName = this.getMaterialLightmapTexturePropertyName(material);
        return material[propName];
    }
    getMaterialOpacity(material) {
        if (!material)
            return null;
        let propName = this.getMaterialOpacityTexturePropertyName(material);
        if (propName)
            return material[propName];
        return null;
    }
    setMaterialLightmap(material, texture) {
        if (!material)
            return;
        var propName = this.getMaterialLightmapTexturePropertyName(material);
        material[propName] = texture;
        if (material instanceof Zakeke.PBRMaterial) {
            material.useAOTextureAsLightmap = true;
        }
    }
    setTextureWrapping(texture) {
        if (texture) {
            texture.wrapU = BABYLON.Texture.CLAMP_ADDRESSMODE;
            texture.wrapV = BABYLON.Texture.CLAMP_ADDRESSMODE;
        }
    }
    setupCanvasAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._side && this._canvasMesh && this._meshSide) {
                var width = this._baseWidth;
                if (this._meshSide.get("percWidth") > 0)
                    width *= this._meshSide.get("percWidth");
                var height = this._baseHeight;
                if (this._meshSide.get("percHeight") > 0)
                    height *= this._meshSide.get("percHeight");
                this._textureWidth = width;
                this._textureHeight = height;
                // creo un offset canvas su cui eseguire il disegno
                var $canvas = $("<canvas>", { id: this._canvasID }).attr({ width: width, height: height });
                this._canvas = $canvas[0];
                /* Debug canvas
                document.body.appendChild(this._canvas);
                this._canvas.style.background = 'red';
                this._canvas.style.position = 'fixed';
                this._canvas.style.left = '0';
                this._canvas.style.top = '0';
                this._canvas.style.width = '200px';
                this._canvas.style.height = '200px';
                this._canvas.style.zIndex = '10000';*/
                this._context = this._canvas.getContext("2d");
                if (this._context) {
                    this._context["imageSmoothingQuality"] = "high";
                    this._context.imageSmoothingEnabled = true;
                    this._customizer = new MPlaza.Customizer(true, false, this._canvas, true);
                    this._blankDataUrl = this._canvas.toDataURL();
                    this._customizer.showSideImage = false;
                    this._customizer.model = this._zkModel;
                    this._customizer.fitToScreenMargin = 1;
                    this._customizer.setGrids(this._grids);
                    this._customizer.setDesign(this._zkDesign);
                    yield new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                        var _a, _b;
                        yield ((_a = this._customizer) === null || _a === void 0 ? void 0 : _a.setSide(this._side));
                        (_b = this._customizer) === null || _b === void 0 ? void 0 : _b.refresh({ boundsToAreas: true }, () => __awaiter(this, void 0, void 0, function* () {
                            if (this._customizer) {
                                if (this._meshSide) {
                                    let valuesJson = this._meshSide.get("matrix");
                                    if (valuesJson) {
                                        const values = JSON.parse(valuesJson);
                                        let matrix = new this._customizer.paper.Matrix(values);
                                        if (this._defaultSize !== this._size) {
                                            const scale = this._size / this._defaultSize;
                                            const scaledMatrix = new this._customizer.paper.Matrix().scale(scale, scale);
                                            matrix = matrix.prepend(scaledMatrix);
                                        }
                                        this._customizer.paper.view.matrix = matrix;
                                        this._customizer.paper.view.update();
                                    }
                                }
                                yield this.updateDynamicTextureAsync();
                                // Attach events only after the first rendering 
                                // to avoid concurrent updates
                                this._customizer.addItemCreatedListener(() => __awaiter(this, void 0, void 0, function* () {
                                    yield this.updateDynamicTextureAsync();
                                    this.fireRenderingNeededEvent();
                                }));
                                this._customizer.addItemChangedListener(() => __awaiter(this, void 0, void 0, function* () {
                                    yield this.updateDynamicTextureAsync();
                                    this.fireRenderingNeededEvent();
                                }));
                                this._customizer.addItemRemovedListener(() => __awaiter(this, void 0, void 0, function* () {
                                    yield this.updateDynamicTextureAsync();
                                    this.fireRenderingNeededEvent();
                                }));
                                this._customizer.addImageLoadedListener(() => __awaiter(this, void 0, void 0, function* () {
                                    yield this.updateDynamicTextureAsync();
                                    this.fireRenderingNeededEvent();
                                }));
                            }
                            resolve();
                        }));
                    }));
                }
            }
        });
    }
    setCustomizerGrids(grids) {
        var _a;
        this._grids = grids;
        (_a = this._customizer) === null || _a === void 0 ? void 0 : _a.setGrids(grids);
    }
    // Ripristino il materiale originale sulla mesh, a meno che non sia stato già cambiato
    restoreOrignalMaterial() {
        if (this._mesh && this._originalMaterial &&
            this._mesh.material &&
            this._normalmapMaterial &&
            this._mesh.material.id === this._normalmapMaterial.id) {
            this._mesh.material = this._originalMaterial;
        }
    }
    getMeshesUsingMaterial(materialID) {
        var meshes = [];
        var allMeshes = this._scene.meshes;
        for (var i = 0; i < allMeshes.length; i++) {
            var mesh = allMeshes[i];
            if (mesh.material) {
                if (mesh.material.id == materialID) {
                    meshes.push(mesh);
                }
                else if (mesh.material instanceof BABYLON.MultiMaterial) {
                    for (var k = 0; k < mesh.material.subMaterials.length; k++) {
                        let subMaterial = mesh.material.subMaterials[k];
                        if (subMaterial != null && subMaterial.id === materialID) {
                            meshes.push(mesh);
                            break;
                        }
                    }
                }
            }
        }
        return meshes;
    }
    checkNormalmapMaterialAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            let changed = this._mesh && this._normalmapMaterial &&
                (!this._mesh.material || this._mesh.material.id !== this._normalmapMaterial.id);
            if (changed)
                yield this.setupNormalmapMaterialAsync();
        });
    }
    // Se il materiale associato alla mesh è cambiato lo ricrea
    checkDynamicMaterialAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            let materialID = this.getMaterialIDForDesign();
            if (materialID) {
                let changed = this._side && this._canvasMesh && this._meshSide &&
                    this._dynamicMaterial &&
                    this._dynamicMaterial.id != materialID;
                if (changed)
                    yield this.setupDynamicMaterialAsync();
            }
        });
    }
    setupDynamicMaterialAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._side && this._canvasMesh && this._meshSide) {
                this._ownOldDynamicMaterial = this._ownDynamicMaterial;
                this._oldDynamicMaterial = this._dynamicMaterial;
                var materialID = this.getMaterialIDForDesign();
                if (materialID) {
                    let dynMaterial = this._scene.getMaterialByID(materialID);
                    if (dynMaterial) {
                        this._dynamicMaterial = yield this.cloneMaterialAsync(dynMaterial, dynMaterial.name + " - clone");
                        this._ownDynamicMaterial = true;
                    }
                }
                if (!this._dynamicMaterial) {
                    if (this._mesh.material && this._mesh.material instanceof BABYLON.PBRBaseMaterial) {
                        const dynamicMaterial = new BABYLON.PBRMaterial("dynamicMaterial", this._scene);
                        dynamicMaterial.enableSpecularAntiAliasing = true;
                        dynamicMaterial.backFaceCulling = false;
                        dynamicMaterial.albedoColor = BABYLON.Color3.White();
                        dynamicMaterial.reflectivityColor = BABYLON.Color3.Black();
                        if (this._mesh.material["subSurface"]["indexOfRefraction"] != undefined)
                            dynamicMaterial.subSurface.indexOfRefraction = this._mesh.material["subSurface"]["indexOfRefraction"];
                        if (this._mesh.material["roughness"] != undefined)
                            dynamicMaterial.roughness = this._mesh.material["roughness"];
                        if (this._mesh.material["metallic"] != undefined)
                            dynamicMaterial.metallic = this._mesh.material["metallic"];
                        if (this._mesh.material["reflectionTexture"] != undefined)
                            dynamicMaterial.reflectionTexture = this._mesh.material["reflectionTexture"];
                        if (this._mesh.material["microSurface"] != undefined)
                            dynamicMaterial.microSurface = this._mesh.material["microSurface"];
                        this._dynamicMaterial = dynamicMaterial;
                    }
                    else {
                        this._dynamicMaterial = new BABYLON.StandardMaterial("dynamicMaterial", this._scene);
                        this._dynamicMaterial.backFaceCulling = false;
                        this._dynamicMaterial.specularColor = BABYLON.Color3.Black();
                        this._dynamicMaterial.ambientColor = BABYLON.Color3.White();
                        this._dynamicMaterial.diffuseColor = BABYLON.Color3.White();
                    }
                    this._dynamicMaterial.id = Zakeke.generateUUID();
                    this._ownDynamicMaterial = true;
                    /*
                    this._dynamicMaterial = new BABYLON.StandardMaterial("dynamicMaterial", this._scene);
                    this._dynamicMaterial.id = Zakeke.generateUUID();
                    (this._dynamicMaterial as BABYLON.StandardMaterial).specularColor = BABYLON.Color3.Black();
                    this._ownDynamicMaterial = true;
                    //this.dynamicMaterial.diffuseTexture = this.dynamicTexture;
                    */
                }
                this._dynamicMaterial.zOffset = -1;
                this._dynamicMaterial.metadata = { isRealMaterial: false };
                this._dynamicMaterial.doNotSerialize = true;
                this._originalDiffuseTexture = this.getMaterialDiffuse(this._dynamicMaterial);
                this._originalDesignNormalmapTexture = this.getMaterialNormalmap(this._dynamicMaterial);
                this._originalDesignLightmapTexture = this.getMaterialLightmap(this._dynamicMaterial);
                // Imposto il materiale solo quando è pronta la texture
                // altrimenti per qualche istante apparirebbe il materiale standard grigio/bianco
                //this.canvasMesh.material = this.dynamicMaterial;
            }
        });
    }
    /*
    private whenTextureIsReadyAsync(texture: BABYLON.BaseTexture): Promise<void> {
        return new Promise<void>((resolve, reject) => {

            let t = setInterval(() => {
                if (texture.isReady()) {
                    clearInterval(t);
                    if (texture instanceof BABYLON.ProceduralTexture)
                        texture.getEffect();
                    resolve();
                }
            }, 5);

        });
    }
    */
    cloneMaterialAsync(material, name) {
        return __awaiter(this, void 0, void 0, function* () {
            if (material) {
                var textures = material.getActiveTextures();
                textures.forEach((txt) => __awaiter(this, void 0, void 0, function* () {
                    yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(txt);
                }));
                //let promises: Promise<void>[] = [];
                //var textures = material.getActiveTextures();
                //textures.forEach((txt) => {
                //    promises.push(SceneHelper.whenTextureIsReadyAsync(txt));
                //});
                //await Promise.all(promises);
                var newName = name || material.name + " - clone";
                if (material instanceof BABYLON.ShaderMaterial) {
                    const rootUrl = this._zkScene.get("rootUrl");
                    if (!rootUrl)
                        return null;
                    let serialized = material.serialize();
                    let deserialized = BABYLON.Material.Parse(serialized, this._scene, rootUrl);
                    return deserialized;
                }
                else {
                    return material.clone(newName);
                }
                /*
                Promise.all(promises).then(() => {
                    var newName = name || material.name + " - clone";
        
                    if (material instanceof BABYLON.ShaderMaterial) {
                        const rootUrl = this._zkScene.get("rootUrl");
                        if (!rootUrl)
                            return null;
        
                        let serialized = material.serialize();
                        let deserialized = BABYLON.Material.Parse(serialized, this._scene, rootUrl);
                        return deserialized;
                    } else {
                        return material.clone(newName);
                    }
                });
                */
            }
            return null;
        });
    }
    getMeshHierarchySize(mesh) {
        let boundingBox = mesh.getHierarchyBoundingVectors(true);
        let size = boundingBox.max.subtract(boundingBox.min);
        return size;
    }
    getMeshHierarchyCenter(mesh) {
        let boundingBox = mesh.getHierarchyBoundingVectors(true);
        let size = boundingBox.max.subtract(boundingBox.min);
        let center = boundingBox.min.add(size.scale(0.5));
        return center;
    }
    refreshAsync(effect) {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof effect !== "undefined")
                this._effect = effect;
            if (!this._side) {
                this.setupMeshSide();
                this.checkDefaultEffect();
                yield this.setupClonedObjectsAsync();
                yield this.setupCanvasAsync();
                yield this.setupDynamicMaterialAsync();
            }
            else {
                yield this.checkDynamicMaterialAsync();
                yield this.checkNormalmapMaterialAsync();
            }
            // Always check a better model side. 
            // E.g, when running from a template without items, we can't know the correct colorID => sideID until
            // we add some item. But, for configurator we must select at last the first variant or we will be unable
            // to add any elements
            this.refreshModelSide();
            /*
            if (this._side && this._customizer) {
                this._customizer.refresh({ boundsToAreas: true });
            
                // apply matrix to view
                if (this._meshSide) {
                    let valuesJson = this._meshSide.get("matrix");
                    if (valuesJson) {
                        var values = JSON.parse(valuesJson);
                        this._customizer.appendViewMatrix(values);
                    }
                }
            
                await this.updateDynamicTextureAsync();
            }
            */
            yield new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b;
                if (this._meshSide && this.side && this._customizer) {
                    yield ((_a = this._customizer) === null || _a === void 0 ? void 0 : _a.setSide(this._side));
                    (_b = this._customizer) === null || _b === void 0 ? void 0 : _b.refresh({ boundsToAreas: true }, () => __awaiter(this, void 0, void 0, function* () {
                        if (this._meshSide) {
                            let valuesJson = this._meshSide.get("matrix");
                            if (valuesJson && this._customizer) {
                                const values = JSON.parse(valuesJson);
                                let matrix = new this._customizer.paper.Matrix(values);
                                if (this._defaultSize !== this._size) {
                                    const scale = this._size / this._defaultSize;
                                    const scaledMatrix = new this._customizer.paper.Matrix().scale(scale, scale);
                                    matrix = matrix.prepend(scaledMatrix);
                                }
                                this._customizer.paper.view.matrix = matrix;
                                this._customizer.paper.view.update();
                            }
                        }
                        yield this.updateDynamicTextureAsync();
                        resolve();
                    }));
                }
            }));
        });
    }
    updateDynamicTextureAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            // First render is not debounced, usefull for screenshots that must wait the
            // render to finish
            if (this.isFirstRender) {
                console.log('First render...');
                yield this.updateDynamicTextureInternalAsync();
                this.isFirstRender = false;
                return;
            }
            // any other render, use debounced
            if (!this._debouncedUpdateDynamicTexture)
                this._debouncedUpdateDynamicTexture = (0,_Helpers_debounce__WEBPACK_IMPORTED_MODULE_0__.debounce)(this.updateDynamicTextureInternalAsync, 150);
            this._debouncedUpdateDynamicTexture();
        });
    }
    updateDynamicTextureInternalAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            Logger.info("updateDynamicTextureInternal");
            if (!this._side || !this._meshSide || !this._canvas || !this._canvasMesh || !this._dynamicMaterial)
                return;
            const config = this.getDesignConfig();
            yield this.checkDynamicMaterialAsync();
            yield this.checkNormalmapMaterialAsync();
            let diffuseEnabled = config.getDiffuseEnabled();
            let diffuseBlendMode = config.getDiffuseBlendMode();
            let diffuseBlendLevel = config.getDiffuseLevel();
            if (diffuseBlendMode !== "normal" && diffuseBlendMode !== "multiply" && diffuseBlendMode !== "overlay")
                diffuseBlendMode = "normal";
            const opacityEnabled = config.getOpacityEnabled();
            const opacityConfig = config.getOrCreateOpacityConfig();
            const normalmapEnabled = config.getNormalmapEnabled();
            const normalmapConfig = config.getOrCreateNormalmapConfig();
            const innerShadowEnabled = config.getInnerShadowEnabled();
            const innerShadowConfig = config.getOrCreateInnerShadowConfig();
            const outerShadowEnabled = config.getOuterShadowEnabled();
            const outerShadowConfig = config.getOrCreateOuterShadowConfig();
            let dynamicTexturePropertyName = "diffuseTexture";
            const materialTextureName = this._meshSide.get("materialTexture");
            if (materialTextureName)
                dynamicTexturePropertyName = materialTextureName;
            else {
                dynamicTexturePropertyName = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial);
            }
            let opacityTexturePropertyName = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial);
            let oldTexture = this._dynamicTexture;
            if (oldTexture)
                oldTexture.dispose();
            // Recupero l'immagine del design
            let dataUrl = this._canvas.toDataURL();
            let isBlank = dataUrl == this._blankDataUrl;
            let blob = this.dataURItoBlob(dataUrl);
            let URL = window.URL || window.webkitURL;
            let blobTextureURL = URL.createObjectURL(blob);
            this._dynamicTexture = new BABYLON.Texture(blobTextureURL, this._scene);
            this._dynamicTexture.hasAlpha = true;
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicTexture);
            if (!isBlank && this._dynamicTexture) {
                if (normalmapEnabled)
                    yield this.updateNormalmapTextureAsync(normalmapConfig);
                if (innerShadowEnabled)
                    yield this.updateInnerShadowTextureAsync(innerShadowConfig);
                if (outerShadowEnabled)
                    yield this.updateOuterShadowTextureAsync(outerShadowConfig);
                if (opacityEnabled)
                    yield this.updateOpacityTextureAsync();
                if (this._originalDiffuseTexture && diffuseEnabled && diffuseBlendMode !== "normal")
                    yield this.combineDiffuseTexturesAsync(diffuseBlendMode, diffuseBlendLevel);
                if (this._showDesign) {
                    // Imposta la texture dinamica (diffuse)
                    if (diffuseEnabled && dynamicTexturePropertyName) {
                        if (diffuseBlendMode === "normal" || !this._originalDiffuseTexture || !this._combinedDiffuseTexture) {
                            this._dynamicTexture.coordinatesIndex = this._coordinatesIndex;
                            this.setTextureWrapping(this._dynamicTexture);
                            this._dynamicMaterial[dynamicTexturePropertyName] = this._dynamicTexture;
                        }
                        else if (this._combinedDiffuseTexture) {
                            this._combinedDiffuseTexture.coordinatesIndex = this._coordinatesIndex;
                            this.setTextureWrapping(this._combinedDiffuseTexture);
                            this._dynamicMaterial[dynamicTexturePropertyName] = this._combinedDiffuseTexture;
                        }
                        this._dynamicMaterial[dynamicTexturePropertyName].hasAlpha = false;
                        this._dynamicMaterial[dynamicTexturePropertyName].hasAlpha = true;
                    }
                    if (!diffuseEnabled && dynamicTexturePropertyName && !this.compareTextures(this._dynamicMaterial[dynamicTexturePropertyName], this._originalDiffuseTexture)) {
                        this._dynamicMaterial[dynamicTexturePropertyName] = this._originalDiffuseTexture;
                    }
                    // Opacity
                    if (opacityEnabled && opacityTexturePropertyName && this._dynamicOpacityTexture) {
                        this._dynamicOpacityTexture.coordinatesIndex = this._coordinatesIndex;
                        this.setTextureWrapping(this._dynamicOpacityTexture);
                        if (this._dynamicMaterial instanceof BABYLON.ShaderMaterial) {
                            this._dynamicMaterial.setTexture(opacityTexturePropertyName, this._dynamicOpacityTexture);
                        }
                        else {
                            this._dynamicMaterial[opacityTexturePropertyName] = this._dynamicOpacityTexture;
                        }
                    }
                    // Qui andrebbe salvata anche la vecchia texture di opacità per poterla ripristinata
                    if (!opacityEnabled && opacityTexturePropertyName) {
                        this._dynamicMaterial[opacityTexturePropertyName] = null;
                    }
                    if (this._canvasMesh.material !== this._dynamicMaterial)
                        this._canvasMesh.material = this._dynamicMaterial;
                    // Imposta la normalmap
                    if (normalmapEnabled && this._normalmapTexture) {
                        yield this.setNormalmapTextureAsync(normalmapConfig);
                    }
                    else {
                        this.resetMeshNormalmapTexture();
                        this.resetDesignNormalmapTexture();
                    }
                    // Imposta l'ombra interna ed esterna
                    if (innerShadowEnabled && this._innerShadowTexture)
                        yield this.setInnerShadowTextureAsync(innerShadowConfig);
                    else
                        this.removeInnerShadowTexture();
                    if (outerShadowEnabled && this._outerShadowTexture)
                        yield this.setOuterShadowTextureAsync(outerShadowConfig);
                    else
                        this.removeOuterShadowTexture();
                    this.disposeOldDynamicMaterial();
                    this._canvasMesh.isVisible = config.getShowDesign();
                }
            }
            if (isBlank) {
                this._canvasMesh.isVisible = false;
            }
            this.fireRenderingNeededEvent();
        });
    }
    resetDynamicTextures() {
        // DynamicMaterial
        if (this._dynamicMaterial) {
            // Diffuse
            let dynamicTexturePropertyName = "diffuseTexture";
            const materialTextureName = this._meshSide ? this._meshSide.get("materialTexture") : null;
            if (materialTextureName)
                dynamicTexturePropertyName = materialTextureName;
            else {
                dynamicTexturePropertyName = this.getMaterialDiffuseTexturePropertyName(this._dynamicMaterial);
            }
            if (dynamicTexturePropertyName && !this.compareTextures(this._dynamicMaterial[dynamicTexturePropertyName], this._originalDiffuseTexture)) {
                this._dynamicMaterial[dynamicTexturePropertyName] = this._originalDiffuseTexture || new BABYLON.Texture(this._blankDataUrl, this._scene);
                this._dynamicMaterial[dynamicTexturePropertyName].hasAlpha = false;
                this._dynamicMaterial[dynamicTexturePropertyName].hasAlpha = true;
            }
            // Normal
            this.resetDesignNormalmapTexture();
            // Opacity
            let opacityTexturePropertyName = this.getMaterialOpacityTexturePropertyName(this._dynamicMaterial);
            if (opacityTexturePropertyName) {
                this._dynamicMaterial[opacityTexturePropertyName] = null;
            }
            // InnerShadow
            this.removeInnerShadowTexture();
        }
        // NormalmapMaterial
        if (this._normalmapMaterial) {
            this.resetMeshNormalmapTexture();
            this.removeOuterShadowTexture();
        }
    }
    updateOpacityTextureAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._dynamicTexture) {
                yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicTexture);
                // Genero la maschera di opacità a partire dalla texture dinamic
                if (!this._dynamicOpacityTexture) {
                    this._dynamicOpacityTexture = new _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_2__.ForegroundBackgroundProceduralTexture("dynamicOpacity", this._textureWidth, this._scene, this._dynamicTexture);
                    this._dynamicOpacityTexture.backColor = new BABYLON.Vector3(0, 0, 0);
                    this._dynamicOpacityTexture.foreColor = new BABYLON.Vector3(1, 1, 1);
                    this._dynamicOpacityTexture.refreshRate = 0;
                    this._dynamicOpacityTexture.getAlphaFromRGB = true;
                }
                if (this._dynamicOpacityTexture) {
                    this._dynamicOpacityTexture.baseTexture = this._dynamicTexture;
                    yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicOpacityTexture);
                    this._dynamicOpacityTexture.render();
                }
            }
        });
    }
    combineDiffuseTexturesAsync(blendMode, blendLevel) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._originalDiffuseTexture || !this._dynamicTexture)
                return;
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._originalDiffuseTexture);
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicTexture);
            const baseTexture = blendLevel === 0 ? this._dynamicTexture : this._originalDiffuseTexture;
            const blendTexture = blendLevel === 0 ? this._originalDiffuseTexture : this._dynamicTexture;
            if (!this._combinedDiffuseTexture) {
                if (blendMode == "multiply")
                    this._combinedDiffuseTexture = new _ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_3__.MultiplyProceduralTexture("multiplyDiffuse", this._textureWidth, this._scene, baseTexture, blendTexture);
                else
                    this._combinedDiffuseTexture = new _ProceduralTextures_OverlayProceduralTexture__WEBPACK_IMPORTED_MODULE_4__.OverlayProceduralTexture("overlayDiffuse", this._textureWidth, this._scene, baseTexture, blendTexture);
                this._combinedDiffuseTexture.refreshRate = 0;
            }
            if (this._combinedDiffuseTexture) {
                this._combinedDiffuseTexture.baseTexture = baseTexture;
                this._combinedDiffuseTexture.blendTexture = blendTexture;
                yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._combinedDiffuseTexture);
                this._combinedDiffuseTexture.render();
            }
        });
    }
    // NORMAL MAP
    updateNormalmapTextureAsync(config) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._dynamicTexture) {
                yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicTexture);
                if (!this._proceduralNormalMap) {
                    this._proceduralNormalMap = new _NormalMap_ProceduralNormalMap__WEBPACK_IMPORTED_MODULE_1__.ProceduralNormalMap(this._dynamicTexture, this._textureWidth, config, this._scene);
                }
                this._normalmapTexture = yield this._proceduralNormalMap.getNormalMapTextureAsync(this._dynamicTexture, config);
                if (this._normalmapTexture)
                    this._normalmapTexture.coordinatesIndex = this._coordinatesIndex; // Canale UV di riferimento da settare da parte dell'utente
            }
        });
    }
    // Aggiorna i materiali con la normalmapTexture
    // La complicazione principale qui è che le normalmap eventualmente devono essere combinate con quelle preesistenti
    // sul materiale. Inoltre, essendo i materiali clonati (per non modificare quelli originari) è necessario controllare
    // che le texture siano pronte
    setNormalmapTextureAsync(config) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            let meshNormalmapTexture = this._normalmapTexture;
            let designNormalmapTexture = this._normalmapTexture;
            if (config.get("showOnMesh")) {
                if (this._originalMeshNormalmapTexture && this._normalmapTexture) {
                    yield this.combineMeshNormalmapTexturesAsync();
                    if (this._meshCombinedNormalmapTexture)
                        meshNormalmapTexture = this._meshCombinedNormalmapTexture;
                }
            }
            if (config.get("showOnDesign")) {
                if (this._originalDesignNormalmapTexture && this._normalmapTexture) {
                    yield this.combineDesignNormalmapTexturesAsync();
                    if (this._designCombinedNormalmapTexture)
                        designNormalmapTexture = this._designCombinedNormalmapTexture;
                }
            }
            if (this._normalmapMaterial && meshNormalmapTexture) {
                meshNormalmapTexture.coordinatesIndex = this._coordinatesIndex;
                this.setTextureWrapping(meshNormalmapTexture);
                const propName = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
                if (config.get("showOnMesh"))
                    this._normalmapMaterial[propName] = meshNormalmapTexture;
                else
                    this.resetMeshNormalmapTexture();
                if (this._mesh.material !== this._normalmapMaterial) {
                    this._mesh.material = this._normalmapMaterial;
                    if (!this._mesh.metadata)
                        this._mesh.metadata = {};
                    this._mesh.metadata.originalNormalmapMaterialID = (_a = this._originalMaterial) === null || _a === void 0 ? void 0 : _a.id;
                }
            }
            if (this._dynamicMaterial && designNormalmapTexture) {
                designNormalmapTexture.coordinatesIndex = this._coordinatesIndex;
                this.setTextureWrapping(designNormalmapTexture);
                const propName = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
                if (config.get("showOnDesign"))
                    this._dynamicMaterial[propName] = designNormalmapTexture;
                else
                    this.resetDesignNormalmapTexture();
            }
        });
    }
    combineMeshNormalmapTexturesAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._originalMeshNormalmapTexture || !this._normalmapTexture)
                return;
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._originalMeshNormalmapTexture);
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._normalmapTexture);
            if (!this._meshCombinedNormalmapTexture) {
                this._meshCombinedNormalmapTexture = new _ProceduralTextures_OverlayProceduralTexture__WEBPACK_IMPORTED_MODULE_4__.OverlayProceduralTexture("overlayMeshNormal", this._textureWidth, this._scene, this._originalMeshNormalmapTexture, this._normalmapTexture);
                this._meshCombinedNormalmapTexture.refreshRate = 0;
            }
            if (this._meshCombinedNormalmapTexture) {
                this._meshCombinedNormalmapTexture.baseTexture = this._originalMeshNormalmapTexture;
                this._meshCombinedNormalmapTexture.blendTexture = this._normalmapTexture;
                yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._meshCombinedNormalmapTexture);
                this._meshCombinedNormalmapTexture.render();
            }
        });
    }
    resetMeshNormalmapTexture() {
        if (this._normalmapMaterial) {
            const propName = this.getMaterialNormalmapTexturePropertyName(this._normalmapMaterial);
            if (!this.compareTextures(this._normalmapMaterial[propName], this._originalMeshNormalmapTexture)) {
                if (!this._originalMeshNormalmapTexture)
                    this._normalmapMaterial[propName] = null;
                else
                    this._normalmapMaterial[propName] = this._originalMeshNormalmapTexture;
            }
        }
    }
    resetDesignNormalmapTexture() {
        if (this._dynamicMaterial) {
            const propName = this.getMaterialNormalmapTexturePropertyName(this._dynamicMaterial);
            if (!this.compareTextures(this._dynamicMaterial[propName], this._originalDesignNormalmapTexture)) {
                if (!this._originalDesignNormalmapTexture)
                    this._dynamicMaterial[propName] = null;
                else
                    this._dynamicMaterial[propName] = this._originalDesignNormalmapTexture;
            }
        }
    }
    combineDesignNormalmapTexturesAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._originalDesignNormalmapTexture || !this._normalmapTexture)
                return;
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._originalDesignNormalmapTexture);
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._normalmapTexture);
            if (!this._designCombinedNormalmapTexture) {
                this._designCombinedNormalmapTexture = new _ProceduralTextures_OverlayProceduralTexture__WEBPACK_IMPORTED_MODULE_4__.OverlayProceduralTexture("overlayDesignNormal", this._textureWidth, this._scene, this._originalDesignNormalmapTexture, this._normalmapTexture);
                this._designCombinedNormalmapTexture.refreshRate = 0;
            }
            if (this._designCombinedNormalmapTexture) {
                this._designCombinedNormalmapTexture.baseTexture = this._originalDesignNormalmapTexture;
                this._designCombinedNormalmapTexture.blendTexture = this._normalmapTexture;
                yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._designCombinedNormalmapTexture);
                this._designCombinedNormalmapTexture.render();
            }
        });
    }
    // INNER SHADOW
    updateInnerShadowTextureAsync(config) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._dynamicTexture) {
                yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicTexture);
                if (!this._innerShadowGenerator) {
                    this._innerShadowGenerator = new _Shadows_InnerShadow__WEBPACK_IMPORTED_MODULE_6__.InnerShadow(this._dynamicTexture, this._textureWidth, config, this._scene);
                    this._innerShadowTexture = yield this._innerShadowGenerator.getInnerShadowTextureAsync(this._dynamicTexture);
                    this._innerShadowTexture.coordinatesIndex = this._coordinatesIndex;
                }
                else {
                    yield this._innerShadowGenerator.updateAsync(this._dynamicTexture, config);
                }
            }
        });
    }
    setInnerShadowTextureAsync(config) {
        return __awaiter(this, void 0, void 0, function* () {
            let designLightmapTexture = this._innerShadowTexture;
            if (this._originalDesignLightmapTexture && this._innerShadowTexture) {
                yield this.combineDesignLightmapTexturesAsync();
                if (this._designCombinedLightmapTexture)
                    designLightmapTexture = this._designCombinedLightmapTexture;
            }
            if (designLightmapTexture) {
                designLightmapTexture.coordinatesIndex = this._coordinatesIndex;
                this.setTextureWrapping(designLightmapTexture);
                this.setMaterialLightmap(this._dynamicMaterial, designLightmapTexture);
            }
        });
    }
    combineDesignLightmapTexturesAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._originalDesignLightmapTexture || !this._innerShadowTexture)
                return;
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._originalDesignLightmapTexture);
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._innerShadowTexture);
            if (!this._designCombinedLightmapTexture) {
                this._designCombinedLightmapTexture = new _ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_3__.MultiplyProceduralTexture("overlayDesignLightmaps", this._textureWidth, this._scene, this._originalDesignLightmapTexture, this._innerShadowTexture);
                this._designCombinedLightmapTexture.refreshRate = 0;
            }
            if (this._designCombinedLightmapTexture) {
                this._designCombinedLightmapTexture.baseTexture = this._originalDesignLightmapTexture;
                this._designCombinedLightmapTexture.blendTexture = this._innerShadowTexture;
                yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._designCombinedLightmapTexture);
                this._designCombinedLightmapTexture.render();
            }
        });
    }
    removeInnerShadowTexture() {
        if (this._dynamicMaterial) {
            let current = this.getMaterialLightmap(this._dynamicMaterial);
            let original = this._originalDesignLightmapTexture;
            if (!this.compareTextures(current, original)) {
                this.setMaterialLightmap(this._dynamicMaterial, original);
            }
        }
    }
    // OUTER SHADOW
    updateOuterShadowTextureAsync(config) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._dynamicTexture) {
                yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._dynamicTexture);
                if (!this._outerShadowGenerator) {
                    this._outerShadowGenerator = new _Shadows_OuterShadow__WEBPACK_IMPORTED_MODULE_7__.OuterShadow(this._dynamicTexture, this._textureWidth, config, this._scene);
                    this._outerShadowTexture = yield this._outerShadowGenerator.getOuterShadowTextureAsync(this._dynamicTexture);
                    this._outerShadowTexture.coordinatesIndex = this._coordinatesIndex;
                }
                else {
                    yield this._outerShadowGenerator.updateAsync(this._dynamicTexture, config);
                }
            }
        });
    }
    setOuterShadowTextureAsync(config) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshLightmapTexture = this._outerShadowTexture;
            if (this._originalMeshLightmapTexture && this._outerShadowTexture) {
                yield this.combineMeshLightmapTexturesAsync();
                if (this._meshCombinedLightmapTexture)
                    meshLightmapTexture = this._meshCombinedLightmapTexture;
            }
            if (meshLightmapTexture) {
                meshLightmapTexture.coordinatesIndex = this._coordinatesIndex;
                this.setTextureWrapping(meshLightmapTexture);
                this.setMaterialLightmap(this._normalmapMaterial, meshLightmapTexture);
                if (this._mesh.material !== this._normalmapMaterial)
                    this._mesh.material = this._normalmapMaterial;
            }
        });
    }
    combineMeshLightmapTexturesAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._originalMeshLightmapTexture || !this._outerShadowTexture)
                return;
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._originalMeshLightmapTexture);
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._outerShadowTexture);
            if (!this._meshCombinedLightmapTexture) {
                this._meshCombinedLightmapTexture = new _ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_3__.MultiplyProceduralTexture("overlayMeshLightmap", this._textureWidth, this._scene, this._originalMeshLightmapTexture, this._outerShadowTexture);
                this._meshCombinedLightmapTexture.refreshRate = 0;
            }
            if (this._meshCombinedLightmapTexture) {
                this._meshCombinedLightmapTexture.baseTexture = this._originalMeshLightmapTexture;
                this._meshCombinedLightmapTexture.blendTexture = this._outerShadowTexture;
                yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._meshCombinedLightmapTexture);
                this._meshCombinedLightmapTexture.render();
            }
        });
    }
    removeOuterShadowTexture() {
        if (this._normalmapMaterial) {
            const current = this.getMaterialLightmap(this._normalmapMaterial);
            const original = this._originalMeshLightmapTexture;
            if (!this.compareTextures(current, original)) {
                this.setMaterialLightmap(this._normalmapMaterial, original);
            }
        }
    }
    compareTextures(a, b) {
        if (typeof a === "undefined" && typeof b === "undefined")
            return true;
        if (a === null && b === null)
            return true;
        if (!a || !b)
            return false;
        return a === b;
    }
    dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        let byteString = atob(dataURI.split(',')[1]);
        // separate out the mime component
        let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to an ArrayBuffer
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        // write the ArrayBuffer to a blob, and you're done
        let bb = new Blob([ab], { type: mimeString });
        return bb;
    }
    downloadImage(data, filename) {
        let blob = this.dataURItoBlob(data);
        let url = window.URL.createObjectURL(blob);
        let fileNameToSaveAs = filename || "image.png";
        let downloadLink = document.createElement("a");
        downloadLink.download = fileNameToSaveAs;
        downloadLink.innerHTML = "Download File";
        downloadLink.href = url;
        downloadLink.onclick = (ev) => {
            document.body.removeChild(downloadLink);
        };
        downloadLink.style.display = "none";
        downloadLink.setAttribute("type", "hidden");
        document.body.appendChild(downloadLink);
        downloadLink.click();
    }
    setDesignMeshVisibility(visibile) {
        if (this._canvasMesh) {
            this._canvasMesh.isVisible = visibile;
        }
    }
    getItemsInfo() {
        if (this._customizer) {
            return this._customizer.getItemsInfo();
        }
        return [];
    }
    removeItem(itemGuid) {
        if (this._customizer)
            this._customizer.removeItemByGuid(itemGuid);
    }
    addItemText(settings) {
        if (this._customizer)
            this._customizer.addTextElement(null, settings, false);
    }
    setItemText(itemGuid, text) {
        if (this._customizer)
            this._customizer.modifyTextElementContentByGuid(itemGuid, text);
    }
    setItemBold(guid, bold) {
        if (this._customizer) {
            let item = this._customizer.findItemByGuid(guid);
            if (item) {
                let info = this._customizer.getTextItemInfo(item);
                let data = info.fontWeight.split(' ');
                let style = [data.length > 1 ? data[0] : 'normal'];
                style.push(bold ? 'bold' : 'normal');
                this._customizer.modifyTextElementFontWeight(item, style.join(' '));
            }
        }
    }
    setItemItalic(guid, italic) {
        if (this._customizer) {
            let item = this._customizer.findItemByGuid(guid);
            if (item) {
                let info = this._customizer.getTextItemInfo(item);
                let data = info.fontWeight.split(' ');
                let style = [italic ? 'italic' : 'normal'];
                style.push(data.length > 1 ? data[1] : data[0]);
                this._customizer.modifyTextElementFontWeight(item, style.join(' '));
            }
        }
    }
    setItemColor(guid, color) {
        if (this._customizer)
            this._customizer.modifyTextElementFillColorByGuid(guid, color);
    }
    setItemFontFamily(guid, fontFamily) {
        if (this._customizer)
            this._customizer.modifyTextElementFontFamilyByGuid(guid, fontFamily);
    }
    addItemImage(imageID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._customizer)
                yield this._customizer.insertImageById(imageID);
        });
    }
    setItemImage(guid, image) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._customizer)
                yield this._customizer.replaceImageByGuid(guid, image);
        });
    }
    setItemTextOnPath(guid, value) {
        if (this._customizer) {
            let item = this._customizer.findItemByGuid(guid);
            if (value) {
                this._customizer.convertToTextOnPath(item);
            }
            else {
                this._customizer.convertToTextArea(item);
            }
        }
    }
    removeItemImage(guid) {
        if (this._customizer)
            this._customizer.removeImageByGuid(guid);
    }
    containsItem(guid) {
        if (this._customizer) {
            const item = this._customizer.findItemByGuid(guid);
            return item != null && item != undefined;
        }
        return false;
    }
    // -------------------------------------------------------------
    // Events 
    // -------------------------------------------------------------
    addNotifyMessageListener(listener) {
        if (this._customizer) {
            const customizer = this._customizer;
            let wrapperListener = (itemGuid, type, title, message, closable, onClick, onClose, data) => {
                listener(customizer.side.getSideID(), itemGuid, type, title, message, closable, data.requiredWidth, data.requiredHeight);
            };
            customizer.addNotifyMessageListeners(wrapperListener);
        }
    }
    addRemoveMessageListener(listener) {
        if (this._customizer) {
            const customizer = this._customizer;
            let wrapperListener = (itemGuid) => {
                listener(customizer.side.getSideID(), itemGuid);
            };
            customizer.addRemoveMessageListeners(wrapperListener);
        }
    }
    setEventMessages(eventMessages) {
        if (this._customizer) {
            const customizer = this._customizer;
            customizer.setCustomizedMessages(eventMessages);
        }
    }
    fireRenderingNeededEvent() {
        for (let i = 0; i < this._renderingNeededListeners.length; ++i) {
            this._renderingNeededListeners[i]();
        }
    }
    addRenderingNeededListener(listenerFunction) {
        this._renderingNeededListeners.push(listenerFunction);
    }
    // -------------------------------------------------------------
    // Design view transformation
    // -------------------------------------------------------------
    translateDesignView(dx, dy) {
        if (this._meshSide && this._customizer) {
            // Aggiorno la vista
            //this.customizer.translateView(dx, dy);
            // Aggiorno la matrice memorizzata nel modello
            let valuesJson = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values);
            var values = JSON.parse(valuesJson);
            var newValues = this._customizer.getTranslatedMatrixValues(values, dx, dy);
            var newValuesJson = JSON.stringify(newValues);
            this._meshSide.set("matrix", newValuesJson);
        }
    }
    rotateDesignView(angle, centerX, centerY) {
        if (this._meshSide && this._customizer) {
            // Aggiorno la vista
            //this.customizer.rotateView(angle, centerX, centerY);
            // Aggiorno la matrice memorizzata nel modello
            var valuesJson = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values);
            var values = JSON.parse(valuesJson);
            var newValues = this._customizer.getRotatedMatrixValues(values, angle, centerX, centerY);
            var newValuesJson = JSON.stringify(newValues);
            this._meshSide.set("matrix", newValuesJson);
        }
    }
    scaleDesignView(hor, ver, centerX, centerY) {
        if (this._meshSide && this._customizer) {
            // Aggiorno la vista
            //this.customizer.scaleView(hor, ver, centerX, centerY);
            // Aggiorno la matrice memorizzata nel modello
            var valuesJson = this._meshSide.get("matrix") || JSON.stringify(this._customizer.paper.view.matrix.values);
            var values = JSON.parse(valuesJson);
            var newValues = this._customizer.getScaledMatrixValues(values, hor, ver, centerX, centerY);
            var newValuesJson = JSON.stringify(newValues);
            this._meshSide.set("matrix", newValuesJson);
        }
    }
    setDesignViewTextureUVChannelAsync(uvChannel) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._meshSide) {
                this._meshSide.set("uvChannel", uvChannel);
                yield this.updateDynamicTextureAsync();
            }
        });
    }
    setDesignViewFormFactorAsync(percWidth, percHeight) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._meshSide) {
                this._meshSide.set("percWidth", percWidth);
                this._meshSide.set("percHeight", percHeight);
                yield this.refreshAsync();
            }
        });
    }
}


/***/ }),

/***/ "../../3D/src/Components/DesignManagers/SceneDesignManager.ts":
/*!********************************************************************!*\
  !*** ../../3D/src/Components/DesignManagers/SceneDesignManager.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SceneDesignManager": () => (/* binding */ SceneDesignManager)
/* harmony export */ });
/* harmony import */ var _MeshDesignManager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./MeshDesignManager */ "../../3D/src/Components/DesignManagers/MeshDesignManager.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

class SceneDesignManager {
    constructor(scene, zkScene, zkModel, zkDesign, showDesign = true) {
        this._grids = [];
        this._meshDesignManagers = [];
        this._renderingNeededListeners = [];
        this._designNotifyMessageListeners = [];
        this._designRemoveMessageListeners = [];
        this._designEventMessages = [];
        this._scene = scene;
        this._zkScene = zkScene;
        this._zkModel = zkModel;
        this._zkDesign = zkDesign;
        this._showDesign = showDesign;
        this.init();
    }
    get showDesign() {
        return this._showDesign;
    }
    set showDesign(value) {
        if (this._showDesign != value) {
            this._showDesign = value;
            this._meshDesignManagers.forEach(m => m.showDesign = value);
        }
    }
    dispose() {
        this._meshDesignManagers.forEach(m => m.dispose());
    }
    init() {
        // do nothing
    }
    isForModels(scene, zkModel, zkDesign) {
        return this._scene == scene &&
            this._zkModel == zkModel &&
            this._zkDesign == zkDesign;
    }
    getDefaultModelScene() {
        if (this._zkModel) {
            let modelScene = this._zkModel.get("scenes").findWhere({ isDefault: true });
            if (modelScene)
                return modelScene;
        }
        return null;
    }
    getModelSceneMeshSide(meshID, submeshID = 0) {
        if (this._scene && this._zkModel) {
            const scene = this.getDefaultModelScene();
            if (scene) {
                for (let j = 0; j < scene.get("meshSides").length; j++) {
                    let meshSide = scene.get("meshSides").at(j);
                    if (meshSide.get("meshID") == meshID && meshSide.get("subMeshID") == submeshID)
                        return meshSide;
                }
            }
        }
        return null;
    }
    refreshAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._scene && this._zkModel && this._zkDesign) {
                const scene = this.getDefaultModelScene();
                if (scene) {
                    let meshDesignManager = null;
                    let mesh = null;
                    let meshSide = null;
                    // Removed sceneID check otherwise it will not work when creating the scene in the customizer
                    // backoffice
                    //let sceneID = scene.get("sceneID");
                    // Per ogni collegamento Mesh-Side aggiorno il corrispondente gestore
                    for (let j = 0; j < scene.get("meshSides").length; j++) {
                        meshSide = scene.get("meshSides").at(j);
                        const meshID = meshSide.get("meshID");
                        const submeshIdx = meshSide.get("subMeshID");
                        if (meshID)
                            yield this.refreshMeshDesignAsync(meshID, submeshIdx);
                    }
                    // Elimino tutti i gestori non più necessari
                    for (let j = 0; j < this._meshDesignManagers.length; j++) {
                        meshDesignManager = this._meshDesignManagers[j];
                        let found = false;
                        for (let k = 0; k < scene.get("meshSides").length; k++) {
                            meshSide = scene.get("meshSides").at(k);
                            if (meshSide.get("meshID") == meshDesignManager.getMeshID() &&
                                meshSide.get("subMeshID") == meshDesignManager.getSubMeshIdx()) {
                                found = true;
                                break;
                            }
                        }
                        let meshVisible = true;
                        if (found) {
                            let meshID = meshDesignManager.getMeshID();
                            if (meshID) {
                                mesh = this._scene.getMeshByID(meshID);
                                if (mesh)
                                    meshVisible = mesh.isVisible;
                            }
                        }
                        if (!found || !meshVisible) {
                            meshDesignManager.dispose();
                            this._meshDesignManagers.splice(j--, 1);
                        }
                    }
                }
            }
        });
    }
    isValidEffectForMesh(meshID, submeshID, effect) {
        // lascio i controlli in modo che finiscano nel javascript
        if (effect && effect instanceof MPlaza.ModelSceneMeshDesignEffect) {
            const modelScene = effect.getParentModel();
            if (modelScene && modelScene instanceof MPlaza.ModelScene) {
                return modelScene.isEffectForMesh(meshID, submeshID, effect.get("effectID"));
            }
        }
        return false;
    }
    refreshMeshDesignAsync(meshID, submeshID = 0, effect) {
        return __awaiter(this, void 0, void 0, function* () {
            let validEffect = effect;
            if (effect && !this.isValidEffectForMesh(meshID, submeshID, effect))
                validEffect = undefined;
            const mesh = this._scene.getMeshByID(meshID);
            if (mesh && mesh.isVisible) {
                let subMesh = null;
                if (mesh.subMeshes && mesh.subMeshes.length > 0 && submeshID >= 0 && submeshID < mesh.subMeshes.length) {
                    subMesh = mesh.subMeshes[submeshID];
                }
                let meshDesignManager = this.getMeshDesignMananger(mesh, subMesh);
                if (!meshDesignManager) {
                    meshDesignManager = yield _MeshDesignManager__WEBPACK_IMPORTED_MODULE_0__.MeshDesignManager.createMeshDesignManagerAsync(this._scene, this._zkScene, mesh, subMesh, this._zkModel, this._zkDesign, this._showDesign, validEffect);
                    meshDesignManager.addRenderingNeededListener(() => this.fireRenderingNeededEvent());
                    meshDesignManager.setCustomizerGrids(this._grids);
                    meshDesignManager.setEventMessages(this._designEventMessages);
                    for (let listener of this._designNotifyMessageListeners)
                        meshDesignManager.addNotifyMessageListener(listener);
                    for (let listener of this._designRemoveMessageListeners)
                        meshDesignManager.addRemoveMessageListener(listener);
                    this._meshDesignManagers.push(meshDesignManager);
                }
                else {
                    meshDesignManager.showDesign = this._showDesign;
                    yield meshDesignManager.refreshAsync(validEffect);
                }
            }
        });
    }
    getMeshDesignMananger(mesh, subMesh) {
        for (let i = 0; i < this._meshDesignManagers.length; i++) {
            const meshDesignManager = this._meshDesignManagers[i];
            if (meshDesignManager.isForMesh(mesh, subMesh))
                return meshDesignManager;
        }
        return null;
    }
    clearMeshDesignManagers() {
        this._meshDesignManagers = [];
    }
    setCustomizerGrids(grids) {
        this._grids = grids;
        this._meshDesignManagers.forEach(meshDesignMangaer => meshDesignMangaer.setCustomizerGrids(grids));
    }
    getItemsInfo() {
        let infoArray = [];
        for (let i = 0; i < this._meshDesignManagers.length; i++) {
            const meshDesignManager = this._meshDesignManagers[i];
            const tempArray = meshDesignManager.getItemsInfo();
            for (let j = 0; j < tempArray.length; j++) {
                const info = tempArray[j];
                let found = false;
                for (let k = 0; k < infoArray.length; k++) {
                    if (infoArray[k].itemGuid == info.itemGuid) {
                        found = true;
                        break;
                    }
                }
                if (!found)
                    infoArray.push(info);
            }
        }
        return infoArray;
    }
    execOnMeshManagersContainingItem(guid, func) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const manager of this._meshDesignManagers) {
                if (manager.containsItem(guid))
                    yield func(manager);
            }
        });
    }
    removeItem(guid) {
        this.execOnMeshManagersContainingItem(guid, (manager) => __awaiter(this, void 0, void 0, function* () { return manager.removeItem(guid); }));
    }
    addItemText(settings, sideID) {
        let meshDesignManager = this._meshDesignManagers.find(x => x.side != null && x.side.get("sideID") === sideID);
        if (meshDesignManager)
            meshDesignManager.addItemText(settings);
    }
    addItemImage(imageID, sideID) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshDesignManager = this._meshDesignManagers.find(x => x.side != null && x.side.get("sideID") === sideID);
            if (meshDesignManager)
                yield meshDesignManager.addItemImage(imageID);
        });
    }
    setItemText(guid, text) {
        this.execOnMeshManagersContainingItem(guid, (manager) => __awaiter(this, void 0, void 0, function* () { return manager.setItemText(guid, text); }));
    }
    setItemItalic(guid, italic) {
        this.execOnMeshManagersContainingItem(guid, (manager) => __awaiter(this, void 0, void 0, function* () { return manager.setItemItalic(guid, italic); }));
    }
    setItemBold(guid, bold) {
        this.execOnMeshManagersContainingItem(guid, (manager) => __awaiter(this, void 0, void 0, function* () { return manager.setItemBold(guid, bold); }));
    }
    setItemColor(guid, color) {
        this.execOnMeshManagersContainingItem(guid, (manager) => __awaiter(this, void 0, void 0, function* () { return manager.setItemColor(guid, color); }));
    }
    setItemFontFamily(guid, fontFamily) {
        this.execOnMeshManagersContainingItem(guid, (manager) => __awaiter(this, void 0, void 0, function* () { return manager.setItemFontFamily(guid, fontFamily); }));
    }
    setItemImage(guid, image) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.execOnMeshManagersContainingItem(guid, (manager) => __awaiter(this, void 0, void 0, function* () { return manager.setItemImage(guid, image); }));
        });
    }
    setItemTextOnPath(guid, areaId, value) {
        const meshDesignManager = this._meshDesignManagers.find(x => x.side != null && x.side.get("sideID") === areaId);
        if (meshDesignManager)
            meshDesignManager.setItemTextOnPath(guid, value);
    }
    removeItemImage(guid) {
        this.execOnMeshManagersContainingItem(guid, (manager) => __awaiter(this, void 0, void 0, function* () { return manager.removeItemImage(guid); }));
    }
    setDesignVisibility(meshId, visibile) {
        const mesh = this._scene.getMeshByID(meshId);
        if (mesh) {
            const manager = this.getMeshDesignMananger(mesh, mesh.subMeshes.length > 0 ? mesh.subMeshes[0] : null);
            if (manager)
                manager.setDesignMeshVisibility(visibile);
        }
    }
    getDesignItemsJson() {
        let json = "";
        for (let i = 0; i < this._zkDesign.get("designItems").length; i++) {
            if (json)
                json += "\n";
            json += this._zkDesign.get("designItems").at(i).get("json");
        }
        return json;
    }
    getDesignID() {
        return this._zkDesign.getDesignID();
    }
    // -------------------------------------------------------------
    // Events 
    // -------------------------------------------------------------
    fireRenderingNeededEvent() {
        for (let i = 0; i < this._renderingNeededListeners.length; ++i) {
            this._renderingNeededListeners[i]();
        }
    }
    addRenderingNeededListener(listenerFunction) {
        this._renderingNeededListeners.push(listenerFunction);
    }
    addNotifyMessageListener(listener) {
        this._designNotifyMessageListeners.push(listener);
        for (let meshDesignManager of this._meshDesignManagers)
            meshDesignManager.addNotifyMessageListener(listener);
    }
    addRemoveMessageListener(listener) {
        this._designRemoveMessageListeners.push(listener);
        for (let meshDesignManager of this._meshDesignManagers)
            meshDesignManager.addRemoveMessageListener(listener);
    }
    setEventMessages(eventMessages) {
        this._designEventMessages = eventMessages;
        for (let meshDesignManager of this._meshDesignManagers)
            meshDesignManager.setEventMessages(eventMessages);
    }
    // -------------------------------------------------------------
    // Design view transformation
    // -------------------------------------------------------------
    translateDesignView(mesh, submesh, dx, dy) {
        const meshDesignManager = this.getMeshDesignMananger(mesh, submesh);
        if (meshDesignManager)
            meshDesignManager.translateDesignView(dx, dy);
    }
    rotateDesignView(mesh, submesh, angle, centerX, centerY) {
        const meshDesignManager = this.getMeshDesignMananger(mesh, submesh);
        if (meshDesignManager)
            meshDesignManager.rotateDesignView(angle, centerX, centerY);
    }
    scaleDesignView(mesh, submesh, hor, ver, centerX, centerY) {
        const meshDesignManager = this.getMeshDesignMananger(mesh, submesh);
        if (meshDesignManager)
            meshDesignManager.scaleDesignView(hor, ver, centerX, centerY);
    }
    setDesignViewTextureUVChannelAsync(mesh, submesh, uvChannel) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshDesignManager = this.getMeshDesignMananger(mesh, submesh);
            if (meshDesignManager)
                yield meshDesignManager.setDesignViewTextureUVChannelAsync(uvChannel);
        });
    }
    setDesignViewFormFactorAsync(mesh, submesh, percWidth, percHeight) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshDesignManager = this.getMeshDesignMananger(mesh, submesh);
            if (meshDesignManager)
                yield meshDesignManager.setDesignViewFormFactorAsync(percWidth, percHeight);
        });
    }
    // -------------------------------------------------------------
    // Mesh - Side connection
    // -------------------------------------------------------------
    connectMeshToModelSideAsync(meshID, submeshID, sideID) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshSide = this.getModelSceneMeshSide(meshID, submeshID);
            if (!meshSide && this._scene && this._zkModel) {
                let mesh = this._scene.getMeshByID(meshID);
                if (mesh) {
                    let subMesh = null;
                    if (mesh.subMeshes && mesh.subMeshes.length > 0 && submeshID >= 0 && submeshID < mesh.subMeshes.length) {
                        subMesh = mesh.subMeshes[submeshID];
                        let scene = this.getDefaultModelScene();
                        if (scene) {
                            meshSide = new MPlaza.ModelSceneMeshSide();
                            meshSide.set("meshID", meshID);
                            meshSide.set("subMeshID", submeshID);
                            meshSide.set("sideID", sideID);
                            scene.get("meshSides").add(meshSide);
                            yield this.refreshAsync();
                        }
                    }
                }
            }
        });
    }
    expandCanvasMeshes() {
        this._meshDesignManagers.forEach(m => m.expandCanvasMesh());
    }
    contractCanvasMeshes() {
        this._meshDesignManagers.forEach(m => m.contractCanvasMesh());
    }
}


/***/ }),

/***/ "../../3D/src/Components/Draco/DracoCompression.ts":
/*!*********************************************************!*\
  !*** ../../3D/src/Components/Draco/DracoCompression.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DracoCompression": () => (/* binding */ DracoCompression)
/* harmony export */ });
/* harmony import */ var _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Misc/WorkerPool */ "../../3D/src/Misc/WorkerPool.ts");

function loadScriptAsync(url) {
    if (typeof importScripts === "function") {
        importScripts(url);
        return Promise.resolve();
    }
    else {
        return new Promise((resolve, reject) => {
            BABYLON.Tools.LoadScript(url, () => {
                resolve();
            }, (message) => {
                reject(new Error(message));
            });
        });
    }
}
function loadFileAsync(url) {
    return new Promise((resolve, reject) => {
        BABYLON.Tools.LoadFile(url, (data) => {
            resolve(data);
        }, undefined, undefined, true, (request, exception) => {
            reject(exception);
        });
    });
}
function createDecoderAsync(wasmUrl, wasmBinary, fallbackUrl) {
    const decoderUrl = (wasmBinary && wasmUrl) || fallbackUrl;
    if (decoderUrl) {
        return loadScriptAsync(decoderUrl).then(() => {
            return new Promise((resolve) => {
                DracoDecoderModule({ wasmBinary: wasmBinary }).then((module) => {
                    resolve({ module: module });
                });
            });
        });
    }
    return undefined;
}
function decodeMesh(decoderModule, dataView, attributes, onIndicesData, onAttributeData) {
    const buffer = new decoderModule.DecoderBuffer();
    buffer.Init(dataView, dataView.byteLength);
    const decoder = new decoderModule.Decoder();
    let geometry;
    let status;
    try {
        const type = decoder.GetEncodedGeometryType(buffer);
        switch (type) {
            case decoderModule.TRIANGULAR_MESH:
                geometry = new decoderModule.Mesh();
                status = decoder.DecodeBufferToMesh(buffer, geometry);
                break;
            case decoderModule.POINT_CLOUD:
                geometry = new decoderModule.PointCloud();
                status = decoder.DecodeBufferToPointCloud(buffer, geometry);
                break;
            default:
                throw new Error("Invalid geometry type " + type);
        }
        if (!status.ok() || !geometry.ptr) {
            throw new Error(status.error_msg());
        }
        const numPoints = geometry.num_points();
        if (type === decoderModule.TRIANGULAR_MESH) {
            const numFaces = geometry.num_faces();
            const faceIndices = new decoderModule.DracoInt32Array();
            try {
                const indices = new Uint32Array(numFaces * 3);
                for (let i = 0; i < numFaces; i++) {
                    decoder.GetFaceFromMesh(geometry, i, faceIndices);
                    const offset = i * 3;
                    indices[offset + 0] = faceIndices.GetValue(0);
                    indices[offset + 1] = faceIndices.GetValue(1);
                    indices[offset + 2] = faceIndices.GetValue(2);
                }
                onIndicesData(indices);
            }
            finally {
                decoderModule.destroy(faceIndices);
            }
        }
        // Positions
        const posAttId = decoder.GetAttributeId(geometry, decoderModule.POSITION);
        const posAttribute = decoder.GetAttributeByUniqueId(geometry, posAttId);
        const posDracoData = new decoderModule.DracoFloat32Array();
        try {
            decoder.GetAttributeFloatForAllPoints(geometry, posAttribute, posDracoData);
            const babylonData = new Float32Array(numPoints * posAttribute.num_components());
            for (let i = 0; i < babylonData.length; i++) {
                babylonData[i] = posDracoData.GetValue(i);
            }
            onAttributeData("position", babylonData);
        }
        finally {
            decoderModule.destroy(posDracoData);
        }
        // Normals
        const normAttId = decoder.GetAttributeId(geometry, decoderModule.NORMAL);
        if (normAttId !== -1) {
            const normAttribute = decoder.GetAttributeByUniqueId(geometry, normAttId);
            const normDracoData = new decoderModule.DracoFloat32Array();
            try {
                decoder.GetAttributeFloatForAllPoints(geometry, normAttribute, normDracoData);
                const babylonData = new Float32Array(numPoints * normAttribute.num_components());
                for (var i = 0; i < babylonData.length; i++) {
                    babylonData[i] = normDracoData.GetValue(i);
                }
                onAttributeData("normal", babylonData);
            }
            finally {
                decoderModule.destroy(normDracoData);
            }
        }
        // Colors
        const colorAttId = decoder.GetAttributeId(geometry, decoderModule.COLOR);
        if (colorAttId !== -1) {
            const colorAttribute = decoder.GetAttributeByUniqueId(geometry, colorAttId);
            //var colorDracoData = new decoderModule.DracoUInt32Array();
            const colorDracoData = new decoderModule.DracoFloat32Array();
            try {
                decoder.GetAttributeFloatForAllPoints(geometry, colorAttribute, colorDracoData);
                const babylonData = new Float32Array(numPoints * colorAttribute.num_components());
                for (var i = 0; i < babylonData.length; i++) {
                    babylonData[i] = colorDracoData.GetValue(i);
                }
                onAttributeData("color", babylonData);
            }
            finally {
                decoderModule.destroy(colorDracoData);
            }
        }
        // uvs
        var uvsAttId = decoder.GetAttributeId(geometry, decoderModule.TEX_COORD);
        if (uvsAttId !== -1) {
            const uvsAttribute = decoder.GetAttributeByUniqueId(geometry, uvsAttId);
            const uvsDracoData = new decoderModule.DracoFloat32Array();
            try {
                decoder.GetAttributeFloatForAllPoints(geometry, uvsAttribute, uvsDracoData);
                const babylonData = new Float32Array(numPoints * uvsAttribute.num_components());
                for (var i = 0; i < babylonData.length; i++) {
                    babylonData[i] = uvsDracoData.GetValue(i);
                }
                onAttributeData("uv", babylonData);
            }
            finally {
                decoderModule.destroy(uvsDracoData);
            }
            // uv2s
            const uv2sAttribute = decoder.GetAttributeByUniqueId(geometry, uvsAttId + 1);
            if (uv2sAttribute && uv2sAttribute.size() > 0) {
                const uv2sDracoData = new decoderModule.DracoFloat32Array();
                try {
                    decoder.GetAttributeFloatForAllPoints(geometry, uv2sAttribute, uv2sDracoData);
                    const babylonData = new Float32Array(numPoints * uv2sAttribute.num_components());
                    for (var i = 0; i < babylonData.length; i++) {
                        babylonData[i] = uv2sDracoData.GetValue(i);
                    }
                    onAttributeData("uv2", babylonData);
                }
                finally {
                    decoderModule.destroy(uv2sDracoData);
                }
            }
        }
    }
    finally {
        if (geometry) {
            decoderModule.destroy(geometry);
        }
        decoderModule.destroy(decoder);
        decoderModule.destroy(buffer);
    }
}
function decodeMesh_OLD(decoderModule, dataView, attributes, onIndicesData, onAttributeData) {
    const buffer = new decoderModule.DecoderBuffer();
    buffer.Init(dataView, dataView.byteLength);
    const decoder = new decoderModule.Decoder();
    let geometry;
    let status;
    try {
        const type = decoder.GetEncodedGeometryType(buffer);
        switch (type) {
            case decoderModule.TRIANGULAR_MESH:
                geometry = new decoderModule.Mesh();
                status = decoder.DecodeBufferToMesh(buffer, geometry);
                break;
            case decoderModule.POINT_CLOUD:
                geometry = new decoderModule.PointCloud();
                status = decoder.DecodeBufferToPointCloud(buffer, geometry);
                break;
            default:
                throw new Error(`Invalid geometry type ${type}`);
        }
        if (!status.ok() || !geometry.ptr) {
            throw new Error(status.error_msg());
        }
        const numPoints = geometry.num_points();
        if (type === decoderModule.TRIANGULAR_MESH) {
            const numFaces = geometry.num_faces();
            const faceIndices = new decoderModule.DracoInt32Array();
            try {
                const indices = new Uint32Array(numFaces * 3);
                for (let i = 0; i < numFaces; i++) {
                    decoder.GetFaceFromMesh(geometry, i, faceIndices);
                    const offset = i * 3;
                    indices[offset + 0] = faceIndices.GetValue(0);
                    indices[offset + 1] = faceIndices.GetValue(1);
                    indices[offset + 2] = faceIndices.GetValue(2);
                }
                onIndicesData(indices);
            }
            finally {
                decoderModule.destroy(faceIndices);
            }
        }
        const processAttribute = (kind, attribute) => {
            const dracoData = new decoderModule.DracoFloat32Array();
            try {
                decoder.GetAttributeFloatForAllPoints(geometry, attribute, dracoData);
                const babylonData = new Float32Array(numPoints * attribute.num_components());
                for (let i = 0; i < babylonData.length; i++) {
                    babylonData[i] = dracoData.GetValue(i);
                }
                onAttributeData(kind, babylonData);
            }
            finally {
                decoderModule.destroy(dracoData);
            }
        };
        if (attributes) {
            for (const kind in attributes) {
                const id = attributes[kind];
                const attribute = decoder.GetAttributeByUniqueId(geometry, id);
                processAttribute(kind, attribute);
            }
        }
        else {
            const nativeAttributeTypes = {
                "position": "POSITION",
                "normal": "NORMAL",
                "color": "COLOR",
                "uv": "TEX_COORD"
            };
            for (const kind in nativeAttributeTypes) {
                const id = decoder.GetAttributeId(geometry, decoderModule[nativeAttributeTypes[kind]]);
                if (id !== -1) {
                    const attribute = decoder.GetAttribute(geometry, id);
                    processAttribute(kind, attribute);
                    // generalmente le uv2 sono codificate dopo le uv
                    if (kind === "uv") {
                        try {
                            // uv2
                            const uv2sAttribute = decoder.GetAttribute(geometry, id + 1);
                            if (uv2sAttribute && uv2sAttribute.size() > 0 && decoder.GetAttributeId(uv2sAttribute) >= 0) {
                                processAttribute("uv2", uv2sAttribute);
                            }
                        }
                        catch (e) {
                            console.log("Unable to decode UV2 draco data: ", e);
                        }
                    }
                }
            }
        }
    }
    finally {
        if (geometry) {
            decoderModule.destroy(geometry);
        }
        decoderModule.destroy(decoder);
        decoderModule.destroy(buffer);
    }
}
/**
 * The worker function that gets converted to a blob url to pass into a worker.
 */
function worker() {
    let decoderPromise;
    onmessage = (event) => {
        const data = event.data;
        switch (data.id) {
            case "init": {
                const decoder = data.decoder;
                decoderPromise = createDecoderAsync(decoder.wasmUrl, decoder.wasmBinary, decoder.fallbackUrl);
                postMessage("done");
                break;
            }
            case "decodeMesh": {
                if (!decoderPromise) {
                    throw new Error("Draco decoder module is not available");
                }
                decoderPromise.then((decoder) => {
                    decodeMesh(decoder.module, data.dataView, data.attributes, (indices) => {
                        postMessage({ id: "indices", value: indices }, [indices.buffer]);
                    }, (kind, data) => {
                        postMessage({ id: kind, value: data }, [data.buffer]);
                    });
                    postMessage("done");
                });
                break;
            }
        }
    };
}
function getAbsoluteUrl(url) {
    if (typeof document !== "object" || typeof url !== "string") {
        return url;
    }
    return BABYLON.Tools.GetAbsoluteUrl(url);
}
/**
 * Draco compression (https://google.github.io/draco/)
 *
 * This class wraps the Draco module.
 *
 * **Encoder**
 *
 * The encoder is not currently implemented.
 *
 * **Decoder**
 *
 * By default, the configuration points to a copy of the Draco decoder files for glTF from the babylon.js preview cdn https://preview.babylonjs.com/draco_wasm_wrapper_gltf.js.
 *
 * To update the configuration, use the following code:
 * ```javascript
 *     DracoCompression.Configuration = {
 *         decoder: {
 *             wasmUrl: "<url to the WebAssembly library>",
 *             wasmBinaryUrl: "<url to the WebAssembly binary>",
 *             fallbackUrl: "<url to the fallback JavaScript library>",
 *         }
 *     };
 * ```
 *
 * Draco has two versions, one for WebAssembly and one for JavaScript. The decoder configuration can be set to only support Webssembly or only support the JavaScript version.
 * Decoding will automatically fallback to the JavaScript version if WebAssembly version is not configured or if WebAssembly is not supported by the browser.
 * Use `DracoCompression.DecoderAvailable` to determine if the decoder configuration is available for the current context.
 *
 * To decode Draco compressed data, get the default DracoCompression object and call decodeMeshAsync:
 * ```javascript
 *     var vertexData = await DracoCompression.Default.decodeMeshAsync(data);
 * ```
 *
 * @see https://www.babylonjs-playground.com/#N3EK4B#0
 */
class DracoCompression {
    /**
     * Constructor
     * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
     */
    constructor(numWorkers = DracoCompression.DefaultNumWorkers) {
        const decoder = DracoCompression.Configuration.decoder;
        const decoderWasmBinaryPromise = (decoder.wasmUrl && decoder.wasmBinaryUrl && typeof WebAssembly === "object")
            ? loadFileAsync(getAbsoluteUrl(decoder.wasmBinaryUrl))
            : Promise.resolve(undefined);
        if (numWorkers && typeof Worker === "function") {
            this._workerPoolPromise = decoderWasmBinaryPromise.then((decoderWasmBinary) => {
                const workerContent = `${loadScriptAsync}${createDecoderAsync}${decodeMesh}(${worker})()`;
                const workerBlobUrl = URL.createObjectURL(new Blob([workerContent], { type: "application/javascript" }));
                const workerPromises = new Array(numWorkers);
                for (let i = 0; i < workerPromises.length; i++) {
                    workerPromises[i] = new Promise((resolve, reject) => {
                        const worker = new Worker(workerBlobUrl);
                        const onError = (error) => {
                            worker.removeEventListener("error", onError);
                            worker.removeEventListener("message", onMessage);
                            reject(error);
                        };
                        const onMessage = (message) => {
                            if (message.data === "done") {
                                worker.removeEventListener("error", onError);
                                worker.removeEventListener("message", onMessage);
                                resolve(worker);
                            }
                        };
                        worker.addEventListener("error", onError);
                        worker.addEventListener("message", onMessage);
                        worker.postMessage({
                            id: "init",
                            decoder: {
                                wasmUrl: getAbsoluteUrl(decoder.wasmUrl),
                                wasmBinary: decoderWasmBinary,
                                fallbackUrl: getAbsoluteUrl(decoder.fallbackUrl)
                            }
                        });
                    });
                }
                return Promise.all(workerPromises).then((workers) => {
                    return new _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_0__.WorkerPool(workers);
                });
            });
        }
        else {
            this._decoderModulePromise = decoderWasmBinaryPromise.then((decoderWasmBinary) => {
                return createDecoderAsync(decoder.wasmUrl, decoderWasmBinary, decoder.fallbackUrl);
            });
        }
    }
    /**
     * Returns true if the decoder configuration is available.
     */
    static get DecoderAvailable() {
        const decoder = DracoCompression.Configuration.decoder;
        return !!((decoder.wasmUrl && decoder.wasmBinaryUrl && typeof WebAssembly === "object") || decoder.fallbackUrl);
    }
    static GetDefaultNumWorkers() {
        if (typeof navigator !== "object" || !navigator.hardwareConcurrency) {
            return 1;
        }
        // Use 50% of the available logical processors but capped at 4.
        return Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 1);
    }
    /**
     * Default instance for the draco compression object.
     */
    static get Default() {
        if (!DracoCompression._Default) {
            DracoCompression._Default = new DracoCompression();
        }
        return DracoCompression._Default;
    }
    /**
     * Stop all async operations and release resources.
     */
    dispose() {
        //if (this._workerPoolPromise) {
        //    this._workerPoolPromise.then((workerPool) => {
        //        workerPool.dispose();
        //    });
        //}
        //delete this._workerPoolPromise;
        //delete this._decoderModulePromise;
    }
    /**
     * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
     * @returns a promise that resolves when ready
     */
    whenReadyAsync() {
        if (this._workerPoolPromise) {
            return this._workerPoolPromise.then(() => { });
        }
        if (this._decoderModulePromise) {
            return this._decoderModulePromise.then(() => { });
        }
        return Promise.resolve();
    }
    /**
      * Decode Draco compressed mesh data to vertex data.
      * @param data The ArrayBuffer or ArrayBufferView for the Draco compression data
      * @param attributes A map of attributes from vertex buffer kinds to Draco unique ids
      * @returns A promise that resolves with the decoded vertex data
      */
    decodeMeshAsync(data, attributes) {
        const dataView = data instanceof ArrayBuffer ? new Uint8Array(data) : data;
        if (this._workerPoolPromise) {
            return this._workerPoolPromise.then((workerPool) => {
                return new Promise((resolve, reject) => {
                    workerPool.push((worker, onComplete) => {
                        const vertexData = new BABYLON.VertexData();
                        const onError = (error) => {
                            worker.removeEventListener("error", onError);
                            worker.removeEventListener("message", onMessage);
                            reject(error);
                            onComplete();
                        };
                        const onMessage = (message) => {
                            if (message.data === "done") {
                                worker.removeEventListener("error", onError);
                                worker.removeEventListener("message", onMessage);
                                resolve(vertexData);
                                onComplete();
                            }
                            else if (message.data.id === "indices") {
                                vertexData.indices = message.data.value;
                            }
                            else {
                                vertexData.set(message.data.value, message.data.id);
                            }
                        };
                        worker.addEventListener("error", onError);
                        worker.addEventListener("message", onMessage);
                        const dataViewCopy = new Uint8Array(dataView.byteLength);
                        dataViewCopy.set(new Uint8Array(dataView.buffer, dataView.byteOffset, dataView.byteLength));
                        worker.postMessage({ id: "decodeMesh", dataView: dataViewCopy, attributes: attributes }, [dataViewCopy.buffer]);
                    });
                });
            });
        }
        if (this._decoderModulePromise) {
            return this._decoderModulePromise.then((decoder) => {
                const vertexData = new BABYLON.VertexData();
                decodeMesh(decoder.module, dataView, attributes, (indices) => {
                    vertexData.indices = indices;
                }, (kind, data) => {
                    vertexData.set(data, kind);
                });
                return vertexData;
            });
        }
        throw new Error("Draco decoder module is not available");
    }
}
/**
 * The configuration. Defaults to the following urls:
 * - wasmUrl: "https://zakekecdn.azureedge.net/cdn/Scripts/draco/1.3.4/rev.1/draco_wasm_wrapper.js"
 * - wasmBinaryUrl: "https://zakekecdn.azureedge.net/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.wasm"
 * - fallbackUrl: "https://zakekecdn.azureedge.net/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.js"
 */
DracoCompression.Configuration = {
    decoder: {
        //wasmUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_wasm_wrapper.js"),
        //wasmBinaryUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.wasm"),
        //fallbackUrl: getAbsoluteUrl("/Scripts/libs/draco/draco_decoder.js")
        /*
        wasmUrl: "https://preview.babylonjs.com/draco_wasm_wrapper_gltf.js",
        wasmBinaryUrl: "https://preview.babylonjs.com/draco_decoder_gltf.wasm",
        fallbackUrl: "https://preview.babylonjs.com/draco_decoder_gltf.js"
        */
        wasmUrl: "https://zakekecdn.azureedge.net/cdn/Scripts/draco/1.3.4/rev.1/draco_wasm_wrapper.js",
        wasmBinaryUrl: "https://zakekecdn.azureedge.net/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.wasm",
        fallbackUrl: "https://zakekecdn.azureedge.net/cdn/Scripts/draco/1.3.4/rev.1/draco_decoder.js"
    }
};
/**
 * Default number of workers to create when creating the draco compression object.
 */
DracoCompression.DefaultNumWorkers = DracoCompression.GetDefaultNumWorkers();
DracoCompression._Default = null;


/***/ }),

/***/ "../../3D/src/Components/Environment/EnvironmentManager.ts":
/*!*****************************************************************!*\
  !*** ../../3D/src/Components/Environment/EnvironmentManager.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EnvironmentManager": () => (/* binding */ EnvironmentManager)
/* harmony export */ });
/* harmony import */ var _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Misc/DefaultAssetUrls */ "../../3D/src/Misc/DefaultAssetUrls.ts");
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");


class EnvironmentManager {
    constructor(zkScene, scene, isHologram = false) {
        this._originalSceneClearColor = null;
        this._originalCameraAutoRotate = null;
        this._environmentHelper = null;
        this._shadowLight = null;
        this._isHologram = false;
        this._zkScene = zkScene;
        this._scene = scene;
        this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_1__.SceneHelper(this._scene);
        this._isHologram = isHologram;
    }
    get scene() {
        return this._scene;
    }
    get isHologram() {
        return this._isHologram;
    }
    set isHologram(value) {
        this._isHologram = value;
        this.update();
    }
    dispose() {
        if (this._shadowLight)
            this._shadowLight.dispose();
        if (this._environmentHelper) {
            this._environmentHelper.dispose();
            this._environmentHelper = null;
        }
        ;
        this.removeOldSkybox();
    }
    update() {
        this.configureScene();
        this.configureCamera();
        this.configureSkybox();
    }
    configureSkybox() {
        this.removeOldSkybox();
        if (!this._isHologram)
            this.createSkybox();
    }
    removeOldSkybox() {
        const mesh = this.getSkyboxMesh();
        const material = this.getSkyboxMaterial();
        if (mesh)
            mesh.dispose();
        if (material)
            material.dispose();
    }
    createSkybox() {
        var _a, _b;
        const generalConfig = this.getGeneralConfig();
        const environmentConfig = this.getEnvironmentConfig();
        const skyboxConfig = this.getSkyboxConfig();
        if (skyboxConfig && skyboxConfig.get("createSkybox") != undefined && skyboxConfig.get("createSkybox")) {
            let sizeAuto = true;
            if (environmentConfig &&
                environmentConfig.get("sizeAuto") != undefined &&
                environmentConfig.get("sizeAuto") != null &&
                typeof (environmentConfig.get("sizeAuto")) === "boolean")
                sizeAuto = environmentConfig.get("sizeAuto");
            let skyboxSize = null;
            if (skyboxConfig.get("size") != undefined && typeof (skyboxConfig.get("size")) === 'number')
                skyboxSize = skyboxConfig.get("size");
            let url = null;
            if (skyboxConfig.get("texture") != undefined && typeof (skyboxConfig.get("texture")) === "string")
                url = skyboxConfig.get("texture");
            let blur = 0;
            if (skyboxConfig.get("blur") > 0)
                blur = skyboxConfig.get("blur");
            let extensions = null;
            if (skyboxConfig.get("extensions") != undefined && skyboxConfig.get("extensions") != null &&
                Object.prototype.toString.call(skyboxConfig.get("extensions")) === '[object Array]' &&
                ((_a = skyboxConfig.get("extensions")) === null || _a === void 0 ? void 0 : _a.length) === 6) {
                extensions = skyboxConfig.get("extensions");
            }
            let files = null;
            if (skyboxConfig.get("files") != undefined && skyboxConfig.get("files") != null &&
                Object.prototype.toString.call(skyboxConfig.get("files")) === '[object Array]' &&
                ((_b = skyboxConfig.get("files")) === null || _b === void 0 ? void 0 : _b.length) === 6) {
                files = skyboxConfig.get("files");
            }
            if (url) {
                let texture = null;
                if (url.endsWith(".dds"))
                    texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene);
                else if (url.endsWith(".hdr"))
                    texture = new BABYLON.HDRCubeTexture(url, this._scene, 256, false, true, false, true);
                else if (url.endsWith(".env")) {
                    texture = new BABYLON.CubeTexture(url, this._scene, null, false, null, undefined, null, undefined, true, undefined, true);
                }
                else if (url.endsWith(".basis")) {
                    texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene);
                }
                else if (extensions && files) {
                    texture = new BABYLON.CubeTexture(url, this._scene, extensions, false, files, undefined);
                }
                else {
                    texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene);
                }
                if (texture) {
                    let scale = 1000;
                    if (skyboxSize != null && skyboxSize > 0)
                        scale = skyboxSize;
                    else
                        scale = (this._scene.activeCamera.maxZ - this._scene.activeCamera.minZ) / 2;
                    const hdrSkybox = this._scene.createDefaultSkybox(texture, true, scale, blur, false);
                    if (hdrSkybox) {
                        hdrSkybox.metadata = { isSkyboxMesh: true, isRealMesh: false };
                        hdrSkybox.doNotSerialize = true;
                        const material = hdrSkybox.material;
                        if (material) {
                            material.metadata = { isSkyboxMaterial: true, isRealMaterial: false };
                            material.doNotSerialize = true;
                        }
                    }
                }
            }
        }
    }
    getSkyboxMesh() {
        let mesh = this._scene.meshes.find(m => m.metadata && m.metadata.isSkyboxMesh);
        return mesh || null;
    }
    getSkyboxMaterial() {
        let material = this._scene.materials.find(m => m.metadata && m.metadata.isSkyboxMaterial);
        if (!material)
            return null;
        return material;
    }
    getSkyboxTexture() {
        const material = this.getSkyboxMaterial();
        if (material)
            return material.reflectionTexture;
        return null;
    }
    update_OLD() {
        this.configureScene();
        this.configureCamera();
        this.configureEnvironment();
    }
    configureScene() {
        if (!this._scene)
            return;
        this._originalSceneClearColor = this._scene.clearColor.clone();
        if (this._isHologram) {
            this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 1);
            return;
        }
        var generalConfig = this.getGeneralConfig();
        if (generalConfig) {
            let alpha = null;
            if (generalConfig.get("backgroundAlpha") != undefined && generalConfig.get("backgroundAlpha") != null && typeof (generalConfig.get("backgroundAlpha")) === 'number')
                alpha = generalConfig.get("backgroundAlpha");
            let color = null;
            if (generalConfig.get("backgroundColor") != undefined && typeof (generalConfig.get("backgroundColor")) === "string" && this.isValidHexColor(generalConfig.get("backgroundColor")))
                color = generalConfig.get("backgroundColor");
            // Clear color
            if (alpha || color) {
                this._originalSceneClearColor = this._scene.clearColor;
                let oldcc = this._scene.clearColor;
                if (color != null) {
                    let cc = BABYLON.Color3.FromHexString(color);
                    oldcc.r = cc.r;
                    oldcc.g = cc.g;
                    oldcc.b = cc.b;
                }
                if (alpha != null) {
                    oldcc.a = alpha;
                }
            }
        }
    }
    configureEnvironment() {
        if (this._environmentHelper) {
            this._environmentHelper.dispose();
            this._environmentHelper = null;
        }
        ;
        if (this._shadowLight) {
            this._shadowLight.dispose();
            this._shadowLight = null;
        }
        if (this._sceneHelper.countSceneMeshes() == 0)
            return;
        var options = this.buildEnvironmentHelperOptions();
        if (options) {
            this._environmentHelper = this._scene.createDefaultEnvironment(options);
            /*if (this._environmentHelper && options.mainColor != undefined)
                this._environmentHelper.setMainColor(options.mainColor);*/
            // Make all environment not serializable
            const nodes = this.getEnvironmentSceneNodes();
            for (let i = 0; i < nodes.length; i++) {
                const node = nodes[i];
                if (node) {
                    this.setDoNotSerialize(node);
                    if (!node.metadata)
                        node.metadata = {};
                    node.metadata.isEnvironmentNode = true;
                    if (node instanceof BABYLON.AbstractMesh) {
                        node.isPickable = false;
                        node.metadata.isRealMesh = false;
                    }
                    if (node instanceof BABYLON.Material)
                        node.metadata.isRealMaterial = false;
                }
            }
        }
    }
    buildEnvironmentHelperOptions() {
        let options = null;
        const generalConfig = this.getGeneralConfig();
        const environmentConfig = this.getEnvironmentConfig();
        const skyboxConfig = this.getSkyboxConfig();
        const groundConfig = this.getGroundConfig();
        const cameraConfig = this.getCameraConfig();
        // La environment non viene più gestita come parametro del viewer,
        // bensì come impostazione generale della scena
        /*
        if (generalConfig && generalConfig.get("environmentTexture") != undefined) {
            options = options || {};
            options.environmentTexture = generalConfig.get("environmentTexture");
        }
        */
        let environmentTexture = null;
        if (generalConfig && generalConfig.get("environmentTexture") != undefined && generalConfig.get("environmentTexture") != null)
            environmentTexture = generalConfig.get("environmentTexture");
        let contrast = null;
        if (cameraConfig && cameraConfig.get("contrast") != undefined && typeof (cameraConfig.get("contrast")) === 'number')
            contrast = cameraConfig.get("contrast");
        let exposure = null;
        if (cameraConfig && cameraConfig.get("exposure") != undefined && typeof (cameraConfig.get("exposure")) === 'number')
            exposure = cameraConfig.get("exposure");
        let toneMappingEnabled = null;
        if (cameraConfig && cameraConfig.get("toneMappingEnabled") != undefined && typeof (cameraConfig.get("toneMappingEnabled")) === 'boolean')
            toneMappingEnabled = cameraConfig.get("toneMappingEnabled");
        let sizeAuto = null;
        if (environmentConfig &&
            environmentConfig.get("sizeAuto") != undefined &&
            environmentConfig.get("sizeAuto") != null &&
            typeof (environmentConfig.get("sizeAuto")) === "boolean")
            sizeAuto = environmentConfig.get("sizeAuto");
        let mainColor = null;
        if (environmentConfig && environmentConfig.get("mainColor") != undefined && typeof (environmentConfig.get("mainColor")) === "string" && this.isValidHexColor(environmentConfig.get("mainColor")))
            mainColor = environmentConfig.get("mainColor");
        let groundSize = null;
        if (groundConfig && groundConfig.get("size") != undefined && typeof (groundConfig.get("size")) === 'number')
            groundSize = groundConfig.get("size");
        let groundColor = null;
        if (groundConfig && groundConfig.get("color") != undefined && typeof (groundConfig.get("color")) === "string" && this.isValidHexColor(groundConfig.get("color")))
            groundColor = groundConfig.get("color");
        let enableShadow = null;
        if (groundConfig && groundConfig.get("enableShadow") != undefined && typeof (groundConfig.get("enableShadow")) === "boolean")
            enableShadow = groundConfig.get("enableShadow");
        let shadowLevel = null;
        if (groundConfig && groundConfig.get("shadowLevel") != undefined && typeof (groundConfig.get("shadowLevel")) === 'number')
            shadowLevel = groundConfig.get("shadowLevel");
        let enableMirror = null;
        if (groundConfig && groundConfig.get("enableMirror") != undefined && typeof (groundConfig.get("enableMirror")) === "boolean")
            enableMirror = groundConfig.get("enableMirror");
        let groundTexture = null;
        if (groundConfig && groundConfig.get("texture") != undefined && typeof (groundConfig.get("texture")) === "string")
            groundTexture = groundConfig.get("texture");
        let groundOpacity = null;
        if (groundConfig && groundConfig.get("opacity") != undefined && typeof (groundConfig.get("opacity")) === 'number')
            groundOpacity = groundConfig.get("opacity");
        let mirrorBlurKernel = null;
        if (groundConfig && groundConfig.get("mirrorBlurKernel") != undefined && typeof (groundConfig.get("mirrorBlurKernel")) === 'number')
            mirrorBlurKernel = groundConfig.get("mirrorBlurKernel");
        let skyboxSize = null;
        if (skyboxConfig && skyboxConfig.get("size") != undefined && typeof (skyboxConfig.get("size")) === 'number')
            skyboxSize = skyboxConfig.get("size");
        let skyboxColor = null;
        if (skyboxConfig && skyboxConfig.get("color") != undefined && typeof (skyboxConfig.get("color")) === "string" && this.isValidHexColor(skyboxConfig.get("color")))
            skyboxColor = skyboxConfig.get("color");
        let skyboxTexture = null;
        if (skyboxConfig && skyboxConfig.get("texture") != undefined && typeof (skyboxConfig.get("texture")) === "string")
            skyboxTexture = skyboxConfig.get("texture");
        let setupImageProcessing = environmentTexture != null ||
            contrast != null ||
            exposure != null ||
            toneMappingEnabled;
        if (skyboxConfig || groundConfig || setupImageProcessing) {
            options = options || {
                createSkybox: skyboxConfig && skyboxConfig.get("createSkybox"),
                createGround: groundConfig && groundConfig.get("createGround")
            };
            // Disabilitato per il momento perché da problemi nel rendering di alcuni material
            options.setupImageProcessing = false;
            if (environmentTexture != null) {
                options.environmentTexture = environmentTexture;
            }
            if (options.createSkybox || options.createGround) {
                // General Environment options
                if (sizeAuto != null) {
                    options.sizeAuto = sizeAuto;
                }
                if (mainColor != null) {
                    options.mainColor = BABYLON.Color3.FromHexString(mainColor);
                }
                // Ground options
                if (options.createGround) {
                    if (!options.sizeAuto && groundSize != null) {
                        options.groundSize = groundSize;
                    }
                    if (!options.mainColor && groundColor != null)
                        options.groundColor = BABYLON.Color3.FromHexString(groundColor);
                    if (enableShadow != null) {
                        options.enableGroundShadow = enableShadow;
                    }
                    if (options.enableGroundShadow) {
                        this.createShadowLight();
                    }
                    if (shadowLevel != null) {
                        options.groundShadowLevel = shadowLevel;
                    }
                    if (enableMirror != null) {
                        options.enableGroundMirror = enableMirror;
                    }
                    if (groundTexture != null) {
                        options.groundTexture = groundTexture;
                    }
                    if (groundOpacity != null) {
                        options.groundOpacity = groundOpacity;
                    }
                    if (options.enableGroundMirror && mirrorBlurKernel != null) {
                        options.groundMirrorBlurKernel = mirrorBlurKernel;
                    }
                }
                // Skybox options
                if (options.createSkybox) {
                    if (!options.sizeAuto && skyboxSize != null) {
                        options.skyboxSize = skyboxSize;
                    }
                    if (!options.mainColor && skyboxColor != null)
                        options.skyboxColor = BABYLON.Color3.FromHexString(skyboxColor);
                    if (skyboxTexture != null) {
                        options.skyboxTexture = skyboxTexture;
                    }
                }
                // test
                if (cameraConfig) {
                    if (contrast != null) {
                        options.cameraContrast = contrast;
                    }
                    if (exposure != null) {
                        options.cameraExposure = exposure;
                    }
                    if (toneMappingEnabled != null) {
                        options.toneMappingEnabled = toneMappingEnabled;
                    }
                }
            }
        }
        // TEST
        // Imposto gli url di default, se necessario. Così evito che vengano usati gli url 
        // di default di babylon
        if (options) {
            if (!options.environmentTexture && !this._scene.environmentTexture)
                options.environmentTexture = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_0__.DefaultAssetUrls.Environment.EnvironmentTextureCDNUrl;
            if (options.createGround != undefined && options.createGround && !options.groundTexture) {
                options.groundTexture = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_0__.DefaultAssetUrls.Environment.GroundTextureCDNUrl;
            }
            if (options.createSkybox != undefined && options.createSkybox && !options.skyboxTexture) {
                options.skyboxTexture = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_0__.DefaultAssetUrls.Environment.SkyboxTextureCDNUrl;
            }
        }
        return options;
    }
    createShadowLight() {
        if (this._shadowLight) {
            this._shadowLight.dispose();
            this._shadowLight = null;
        }
        if (this._scene && this._sceneHelper) {
            var bounds = this._sceneHelper.getSceneBoundingInfo();
            if (bounds && bounds.boundingBox) {
                const vectorsWorld = bounds.boundingBox.vectorsWorld;
                const width = Number(vectorsWorld[1].x - (vectorsWorld[0].x));
                const height = Number(vectorsWorld[1].y - (vectorsWorld[0].y));
                const depth = Number(vectorsWorld[1].z - (vectorsWorld[0].z));
                const center = bounds.boundingBox.centerWorld;
                const max = bounds.boundingBox.maximumWorld;
                const x = center.x + width * 2.67;
                const y = center.y + height * 4.5;
                const z = center.z + depth * 1;
                const origin = new BABYLON.Vector3(x, y, z);
                const target = center;
                let direction = target.subtract(origin);
                direction = BABYLON.Vector3.Normalize(direction);
                direction = new BABYLON.Vector3(-2, -3, 1);
                this._shadowLight = new BABYLON.DirectionalLight("shadowLight", direction, this._scene);
                this._shadowLight.position = origin;
                this._shadowLight.intensity = 0.1;
                var generator = new BABYLON.ShadowGenerator(512, this._shadowLight);
                generator.useBlurExponentialShadowMap = true;
                generator.useKernelBlur = true;
                generator.usePercentageCloserFiltering = true;
                generator.blurKernel = 32;
                for (let i = 0; i < this._scene.meshes.length; i++) {
                    const mesh = this._scene.meshes[i];
                    if (!this.isEnvironmentNode(mesh) &&
                        this._sceneHelper.isRealMesh(mesh)) {
                        mesh.receiveShadows = false;
                        generator.addShadowCaster(mesh);
                    }
                }
            }
        }
    }
    configureCamera() {
        if (!this._scene || !this._scene.activeCamera || !(this._scene.activeCamera instanceof BABYLON.ArcRotateCamera))
            return;
        const cameraConfig = this.getCameraConfig();
        if (cameraConfig) {
            const camera = this._scene.activeCamera;
            this._originalCameraAutoRotate = camera.useAutoRotationBehavior;
            let autoRotate = cameraConfig.get("autoRotate");
            camera.useAutoRotationBehavior = autoRotate != undefined && autoRotate;
        }
    }
    sanityCheck() {
        return this._scene &&
            this._scene instanceof BABYLON.Scene &&
            this._zkScene &&
            this._zkScene instanceof Zakeke.Scene &&
            this._zkScene.get("config") != undefined &&
            this._zkScene.get("config") != null &&
            this._zkScene.get("config") instanceof Zakeke.SceneConfig;
    }
    getSceneConfig() {
        if (this.sanityCheck()) {
            let config = this._zkScene.getSceneConfig();
            if (config != undefined && config != null)
                return config;
        }
        return null;
    }
    getGeneralConfig() {
        if (this.sanityCheck()) {
            let config = this._zkScene.getGeneralConfig();
            if (config != undefined && config != null)
                return config;
        }
        return null;
    }
    getEnvironmentConfig() {
        if (this.sanityCheck()) {
            let config = this._zkScene.getEnvironmentConfig();
            if (config != undefined && config != null)
                return config;
        }
        return null;
    }
    getSkyboxConfig() {
        if (this.sanityCheck()) {
            let config = this._zkScene.getSkyboxConfig();
            if (config != undefined && config != null)
                return config;
        }
        return null;
    }
    getGroundConfig() {
        if (this.sanityCheck()) {
            let config = this._zkScene.getGroundConfig();
            if (config != undefined && config != null)
                return config;
        }
        return null;
    }
    getCameraConfig() {
        if (this.sanityCheck()) {
            let config = this._zkScene.getCameraConfig();
            if (config != undefined && config != null)
                return config;
        }
        return null;
    }
    isValidHexColor(hexColor) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(hexColor);
    }
    getEnvironmentSceneNodes() {
        const nodes = [];
        if (this._environmentHelper) {
            if (this._environmentHelper.rootMesh)
                nodes.push(this._environmentHelper.rootMesh);
            if (this._environmentHelper.skybox)
                nodes.push(this._environmentHelper.skybox);
            if (this._environmentHelper.skyboxMaterial)
                nodes.push(this._environmentHelper.skyboxMaterial);
            if (this._environmentHelper.skyboxTexture)
                nodes.push(this._environmentHelper.skyboxTexture);
            if (this._environmentHelper.ground)
                nodes.push(this._environmentHelper.ground);
            if (this._environmentHelper.groundMaterial)
                nodes.push(this._environmentHelper.groundMaterial);
            if (this._environmentHelper.groundTexture)
                nodes.push(this._environmentHelper.groundTexture);
            if (this._environmentHelper.groundMirror)
                nodes.push(this._environmentHelper.groundMirror);
            if (this._shadowLight)
                nodes.push(this._shadowLight);
        }
        return nodes;
    }
    isEnvironmentNode(node) {
        const nodes = this.getEnvironmentSceneNodes();
        for (let i = 0; i < nodes.length; i++) {
            if (node == nodes[i])
                return true;
        }
        return false;
    }
    setDoNotSerialize(node) {
        if (node instanceof BABYLON.AbstractMesh ||
            node instanceof BABYLON.Material ||
            node instanceof BABYLON.Light) {
            node.doNotSerialize = true;
        }
    }
    reset() {
        if (!this._scene)
            return;
        if (this._originalSceneClearColor)
            this._scene.clearColor = this._originalSceneClearColor;
        if (this._originalCameraAutoRotate != null && this._scene.activeCamera && this._scene.activeCamera instanceof BABYLON.ArcRotateCamera)
            this._scene.activeCamera.useAutoRotationBehavior = this._originalCameraAutoRotate;
        if (this._environmentHelper)
            this._environmentHelper.updateOptions({});
    }
}


/***/ }),

/***/ "../../3D/src/Components/Glow/GlowManager.ts":
/*!***************************************************!*\
  !*** ../../3D/src/Components/Glow/GlowManager.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GlowManager": () => (/* binding */ GlowManager)
/* harmony export */ });
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");

class GlowManager {
    constructor(zkScene, scene) {
        this._glowLayer = null;
        this._zkScene = zkScene;
        this._scene = scene;
        this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper(this._scene);
        this._glowLayer = this._scene.getGlowLayerByName("glow");
    }
    get enabled() {
        const glowConfig = this.getGlowConfig();
        let enabled = null;
        if (glowConfig && glowConfig.get("enabled") != undefined && typeof (glowConfig.get("enabled")) === 'boolean')
            enabled = glowConfig.get("enabled");
        return false;
    }
    set enabled(value) {
        var glowConfig = this.getOrCreateGlowConfig();
        if (glowConfig)
            glowConfig.set("enabled", value);
        this.update();
    }
    get intensity() {
        const glowConfig = this.getGlowConfig();
        let intensity = null;
        if (glowConfig && glowConfig.get("intensity") != undefined && typeof (glowConfig.get("intensity")) === 'number')
            intensity = glowConfig.get("intensity");
        return 1;
    }
    set intensity(value) {
        var glowConfig = this.getOrCreateGlowConfig();
        if (glowConfig)
            glowConfig.set("intensity", value);
        this.update();
    }
    get blurSize() {
        const glowConfig = this.getGlowConfig();
        let intensity = null;
        if (glowConfig && glowConfig.get("blurSize") != undefined && typeof (glowConfig.get("blurSize")) === 'number')
            intensity = glowConfig.get("blurSize");
        return 1;
    }
    set blurSize(value) {
        var glowConfig = this.getOrCreateGlowConfig();
        if (glowConfig)
            glowConfig.set("blurSize", value);
        this.update();
    }
    dispose() {
        this.destroyGlowLayer();
    }
    destroyGlowLayer() {
        if (this._glowLayer) {
            this._glowLayer.dispose();
            this._glowLayer = null;
        }
    }
    createOrUpdateGlowLayer(intensity, blurSize) {
        if (!this._glowLayer)
            this._glowLayer = new BABYLON.GlowLayer("glow", this._scene);
        if (this._glowLayer) {
            this._glowLayer.intensity = intensity;
            this._glowLayer.blurKernelSize = blurSize;
        }
    }
    update() {
        if (!this._scene)
            return;
        var glowConfig = this.getGlowConfig();
        if (glowConfig) {
            const enabled = this.enabled;
            const intensity = this.intensity;
            const blurSize = this.blurSize;
            if (enabled) {
                this.createOrUpdateGlowLayer(intensity, blurSize);
            }
            else {
                this.destroyGlowLayer();
            }
        }
        else {
            this.destroyGlowLayer();
        }
    }
    turnOffGlow() {
        this.destroyGlowLayer();
    }
    turnOnGlow() {
        this.update();
    }
    sanityCheck() {
        return this._scene &&
            this._scene instanceof BABYLON.Scene &&
            this._zkScene &&
            this._zkScene instanceof Zakeke.Scene &&
            this._zkScene.get("config") != undefined &&
            this._zkScene.get("config") != null &&
            this._zkScene.get("config") instanceof Zakeke.SceneConfig;
    }
    isGlowEnabledForMesh(mesh) {
        if (mesh)
            return mesh.metadata && mesh.metadata.enableGlow;
        return false;
    }
    // La possibilità di abilitare solo alcune mesh al glow viene disabilitata
    // perché c'è il problema che l'effetto glow è visibile attraverso le mesh
    // per cui il glow è diabilitato
    enableGlowForMesh(mesh) {
    }
    disableGlowForMesh(mesh) {
    }
    getGlowConfig() {
        if (this.sanityCheck()) {
            let config = this._zkScene.getGlowConfig();
            if (config)
                return config;
        }
        return null;
    }
    getOrCreateGlowConfig() {
        if (this.sanityCheck()) {
            return this._zkScene.getOrCreateGlowConfig();
        }
        return null;
    }
}


/***/ }),

/***/ "../../3D/src/Components/IncrementalFiles/IncrementalFiles.ts":
/*!********************************************************************!*\
  !*** ../../3D/src/Components/IncrementalFiles/IncrementalFiles.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IncrementalFiles": () => (/* binding */ IncrementalFiles)
/* harmony export */ });
/* harmony import */ var _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Misc/WorkerPool */ "../../3D/src/Misc/WorkerPool.ts");

function loadScriptAsync(url) {
    if (typeof importScripts === "function") {
        importScripts(url);
        return Promise.resolve();
    }
    else {
        return new Promise((resolve, reject) => {
            BABYLON.Tools.LoadScript(url, () => {
                resolve();
            }, (message) => {
                reject(new Error(message));
            });
        });
    }
}
function importWorkerScriptsAsync(urls) {
    if (urls.length == 0)
        return Promise.resolve();
    let promises = [];
    for (let i = 0; i < urls.length; i++) {
        promises.push(loadScriptAsync(urls[i]));
    }
    return new Promise((resolve) => {
        Promise.all(promises).then(() => resolve());
    });
}
function makeIncrementalFiles(sceneJson, version, options) {
    const makeIncremental = new MakeIncremental();
    const files = makeIncremental.getSceneIncrementalFiles(sceneJson, version, options);
    return files;
}
/**
 * The worker function that gets converted to a blob url to pass into a worker.
 */
function worker() {
    let initializerPromise;
    onmessage = (event) => {
        const data = event.data;
        switch (data.id) {
            case "init": {
                const urls = data.urls;
                initializerPromise = importWorkerScriptsAsync(urls);
                postMessage("done");
                break;
            }
            case "makeIncremental": {
                if (!initializerPromise) {
                    throw new Error("Worker not initialized");
                }
                initializerPromise.then(() => {
                    const sceneJson = data.sceneJson;
                    const version = data.version;
                    const options = data.options;
                    const files = makeIncrementalFiles(sceneJson, version, options);
                    postMessage({ id: "result", files: files });
                    postMessage("done");
                });
                break;
            }
        }
    };
}
function getAbsoluteUrl(url) {
    if (typeof document !== "object" || typeof url !== "string") {
        return url;
    }
    return BABYLON.Tools.GetAbsoluteUrl(url);
}
// La classe si occupa di eseguire la suddivisione (ed eventuale compressione Draco)
// in un worker thread. Per la reale suddivisione utilizza la classe MakeIncrmental
class IncrementalFiles {
    /**
     * Constructor
     * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
    */
    constructor(numWorkers = IncrementalFiles.DefaultNumWorkers) {
        const scriptUrls = ['/Scripts/libs/underscore/underscore.js',
            '/Scripts/libs/backbone/backbone.js',
            '/Scripts/libs/backbone/backbone-associations.js',
            '/Scripts/libs/msgpack/msgpack.min.js',
            '/Scripts/libs/draco/draco_encoder.js',
            '/Scripts/composer/models/model.js',
            '/Scripts/composer/helpers/utils.js',
            '/Scripts/3D/dist/MakeIncremental.js'
        ].map(url => getAbsoluteUrl(url));
        if (numWorkers && typeof Worker === "function") {
            const workerContent = `${loadScriptAsync}${importWorkerScriptsAsync}${makeIncrementalFiles}(${worker})()`;
            const workerBlobUrl = URL.createObjectURL(new Blob([workerContent], { type: "application/javascript" }));
            const workerPromises = new Array(numWorkers);
            for (let i = 0; i < workerPromises.length; i++) {
                workerPromises[i] = new Promise((resolve, reject) => {
                    const worker = new Worker(workerBlobUrl);
                    const onError = (error) => {
                        worker.removeEventListener("error", onError);
                        worker.removeEventListener("message", onMessage);
                        reject(error);
                    };
                    const onMessage = (message) => {
                        if (message.data === "done") {
                            worker.removeEventListener("error", onError);
                            worker.removeEventListener("message", onMessage);
                            resolve(worker);
                        }
                    };
                    worker.addEventListener("error", onError);
                    worker.addEventListener("message", onMessage);
                    worker.postMessage({
                        id: "init",
                        urls: scriptUrls
                    });
                });
            }
            this._workerPoolPromise = Promise.all(workerPromises).then((workers) => {
                return new _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_0__.WorkerPool(workers);
            });
        }
    }
    static GetDefaultNumWorkers() {
        if (typeof navigator !== "object" || !navigator.hardwareConcurrency) {
            return 1;
        }
        // Use 50% of the available logical processors but capped at 4.
        return Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
    }
    /**
     * Default instance for the incremental file maker
     */
    static get Default() {
        if (!IncrementalFiles._Default) {
            IncrementalFiles._Default = new IncrementalFiles();
        }
        return IncrementalFiles._Default;
    }
    dispose() {
        //if (this._workerPoolPromise) {
        //    this._workerPoolPromise.then((workerPool) => {
        //        workerPool.dispose();
        //    });
        //}
        //delete this._workerPoolPromise;
    }
    /**
     * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
     * @returns a promise that resolves when ready
     */
    whenReadyAsync() {
        if (this._workerPoolPromise) {
            return this._workerPoolPromise.then(() => { });
        }
        return Promise.resolve();
    }
    getIncrementalFilesAsync(sceneJson, version, options) {
        if (this._workerPoolPromise) {
            return this._workerPoolPromise.then((workerPool) => {
                return new Promise((resolve, reject) => {
                    workerPool.push((worker, onComplete) => {
                        let files = [];
                        const onError = (error) => {
                            worker.removeEventListener("error", onError);
                            worker.removeEventListener("message", onMessage);
                            reject(error);
                            onComplete();
                        };
                        const onMessage = (message) => {
                            if (message.data === "done") {
                                worker.removeEventListener("error", onError);
                                worker.removeEventListener("message", onMessage);
                                resolve(files);
                                onComplete();
                            }
                            else if (message.data.id === "result") {
                                files = message.data.files;
                            }
                        };
                        worker.addEventListener("error", onError);
                        worker.addEventListener("message", onMessage);
                        worker.postMessage({ id: "makeIncremental", sceneJson: sceneJson, version: version, options: options });
                    });
                });
            });
        }
        throw new Error("Incremental file worker is not available");
    }
}
/**
 * Default number of workers to create when splitting files
 */
IncrementalFiles.DefaultNumWorkers = IncrementalFiles.GetDefaultNumWorkers();
IncrementalFiles._Default = null;


/***/ }),

/***/ "../../3D/src/Components/IncrementalFiles/MakeIncremental.ts":
/*!*******************************************************************!*\
  !*** ../../3D/src/Components/IncrementalFiles/MakeIncremental.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MakeIncremental": () => (/* binding */ MakeIncremental)
/* harmony export */ });
// Classe che si occupa di spezzare il file di scena in tanti file più piccoli
// per il caricamento incrementale. Un file può essere ottenuto sia dalla geometria
// di una mesh che da un materiale. Nel caso di geometria, se abilitata, avverrà
// la compressione Draco dei dati.
class MakeIncremental {
    // Spezzo la scena in tanti file per un caricamento incrementale delle mesh
    // la funzione accetta il JSON ottenuto dalla serializzazione della scena
    // e restituisce un elenco di oggetti Zakeke.IncrementalFileInfo
    // Se abilitata la codifica Draco, la proprietà "data" conterrà l'ArrayBuffer
    // con i byte dell'oggetto serializzato contenente, tra l'altro, i dati codificati con Draco
    getSceneIncrementalFiles(sceneJson, version, options) {
        const files = [];
        const dracoOptions = {
            useDraco: options.useDraco || false,
            dracoEncodingSpeed: options.dracoEncodingSpeed || 5,
            dracoDecodingSpeed: options.dracoDecodingSpeed || 5
        };
        const excludedMeshes = options.excludedMeshes || [];
        sceneJson.autoClear = true;
        // Test -
        //sceneJson.useDelayedTextureLoading = false;
        // lascio il valore impostato sulla scena
        const doNotDelayLoadingForGeometries = [];
        // Parsing meshes
        sceneJson.meshes.forEach(mesh => {
            if (!excludedMeshes.some(meshCheck => meshCheck.test(mesh.name))) {
                // Do not delay load visibile object
                // TEST Ritardo il caricamento anche degli oggetti visibili
                /*
                if (mesh.isVisible) {
                    if (mesh.geometryId)
                        doNotDelayLoadingForGeometries.push(mesh.geometryId);
                    return;
                }
                */
                // Escludo le mesh con submesh per un bug di Babylon JS in fase di caricamento
                if (mesh.subMeshes && mesh.subMeshes.length > 1) {
                    if (mesh.geometryId)
                        doNotDelayLoadingForGeometries.push(mesh.geometryId);
                    return;
                }
                // Do not delay load collisions object
                if (mesh.checkCollisions) {
                    if (mesh.geometryId) {
                        doNotDelayLoadingForGeometries.push(mesh.geometryId);
                    }
                }
                else {
                    const incrementalFileInfo = this.extractIncrementalFile(version, mesh, true, dracoOptions);
                    if (incrementalFileInfo)
                        files.push(incrementalFileInfo);
                }
            }
        });
        // Parsing vertexData
        const geometries = sceneJson.geometries;
        if (geometries) {
            const vertexData = geometries.vertexData;
            vertexData.forEach(geometry => {
                const id = geometry.id;
                if (!doNotDelayLoadingForGeometries.some(g => g === id)) {
                    const incrementalFileInfo = this.extractIncrementalFile(version, geometry, false, dracoOptions);
                    if (incrementalFileInfo)
                        files.push(incrementalFileInfo);
                }
            });
        }
        // Delayed Material Loading
        // I materiali non indicati vengono salvati in file a parte per un cricamento ritardato
        if (sceneJson.metadata && sceneJson.metadata.delayedMaterials) {
            const ids = Object.keys(sceneJson.metadata.delayedMaterials);
            for (let i = 0; i < sceneJson.materials.length; i++) {
                const material = sceneJson.materials[i];
                if (ids.some(id => id === material.id)) {
                    const info = sceneJson.metadata.delayedMaterials[material.id];
                    const incrementalFileInfo = this.extractIncrementalMaterialFile(version, material, info.file);
                    if (incrementalFileInfo) {
                        files.push(incrementalFileInfo);
                        sceneJson.materials.splice(i--, 1);
                    }
                }
            }
        }
        // Creo il file principale della scena incrementale con quel che resta
        // dopo aver inserito i dati delle mesh in file separati
        var file = new Zakeke.IncrementalFileInfo();
        file.name = "scene_" + version + ".incremental.babylon";
        file.isScene = true;
        file.dracoEncoded = false;
        file.data = JSON.stringify(sceneJson, null, 0);
        files.push(file);
        return files;
    }
    extractIncrementalFile(version, meshOrGeometry, isMesh, dracoOptions) {
        let file = null;
        //Logger.info("Extracting " + isMesh ? meshOrGeometry.name : meshOrGeometry.id);
        if (meshOrGeometry.positions && meshOrGeometry.normals && meshOrGeometry.indices) {
            // Create delay loading file
            file = this.createDelayLoadingFile(version, meshOrGeometry, isMesh, dracoOptions);
            if (file && file.data) {
                meshOrGeometry.delayLoadingFile = file.name;
                //Logger.info("Delay loading file: " + meshOrGeometry.delayLoadingFile);
                // Compute bounding boxes
                let positions = meshOrGeometry.positions.map(v => parseFloat(v));
                let minimum = [Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE];
                let maximum = [Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE];
                for (let index = 0; index < positions.length; index += 3) {
                    let x = positions[index];
                    let y = positions[index + 1];
                    let z = positions[index + 2];
                    if (x < minimum[0]) {
                        minimum[0] = x;
                    }
                    if (x > maximum[0]) {
                        maximum[0] = x;
                    }
                    if (y < minimum[1]) {
                        minimum[1] = y;
                    }
                    if (y > maximum[1]) {
                        maximum[1] = y;
                    }
                    if (z < minimum[2]) {
                        minimum[2] = z;
                    }
                    if (z > maximum[2]) {
                        maximum[2] = z;
                    }
                }
                meshOrGeometry.boundingBoxMinimum = minimum;
                meshOrGeometry.boundingBoxMaximum = maximum;
                // Erasing infos
                meshOrGeometry.positions = null;
                meshOrGeometry.normals = null;
                meshOrGeometry.indices = null;
                if (meshOrGeometry.uvs) {
                    meshOrGeometry.hasUVs = true;
                    meshOrGeometry.uvs = null;
                }
                if (meshOrGeometry.uv2s) {
                    meshOrGeometry.hasUVs2 = true;
                    meshOrGeometry.uv2s = null;
                }
                if (meshOrGeometry.colors) {
                    meshOrGeometry.hasColors = true;
                    meshOrGeometry.colors = null;
                }
                // Added tangents
                if (meshOrGeometry.tangents) {
                    meshOrGeometry.hasTangents = true;
                    meshOrGeometry.tangents = null;
                }
                if (meshOrGeometry.matricesIndices) {
                    meshOrGeometry.hasMatricesIndices = true;
                    meshOrGeometry.matricesIndices = null;
                }
                if (meshOrGeometry.matricesWeights) {
                    meshOrGeometry.hasMatricesWeights = true;
                    meshOrGeometry.matricesWeights = null;
                }
                if (isMesh && meshOrGeometry.subMeshes) {
                    meshOrGeometry.subMeshes = null;
                }
            }
        }
        if (file && file.data)
            return file;
        else
            return null;
    }
    createDelayLoadingFile(version, meshOrGeometry, isMesh, dracoOptions) {
        var file = new Zakeke.IncrementalFileInfo();
        file.isScene = false;
        // Per ora uso la codifica draco, se abilitata, solo nel caso di geometria
        // e se la geometria ha un solo canale per le texture
        //var dracoEncode = dracoOptions.useDraco && !isMesh && !meshOrGeometry.uv2s && !(meshOrGeometry.matricesIndices || meshOrGeometry.matricesWeights);
        var dracoEncode = dracoOptions.useDraco && !isMesh &&
            !(meshOrGeometry.matricesIndices || meshOrGeometry.matricesWeights || meshOrGeometry.tangents) &&
            meshOrGeometry.indices.length > 0 &&
            meshOrGeometry.positions.length > 0 &&
            meshOrGeometry.normals.length > 0;
        file.dracoEncoded = dracoEncode;
        var encodedName = (isMesh ? meshOrGeometry.name : meshOrGeometry.id).replace("+", "_").replace(" ", "_");
        var namepart = dracoEncode ? "draco" : "";
        file.name = "scene_" + version + "." + encodedName + (isMesh ? ".babylonmesh" + namepart + "data" : ".babylongeometry" + namepart + "data");
        if (dracoEncode)
            file.data = this.createDracoDelayLoadingFileData(meshOrGeometry, dracoOptions);
        else
            file.data = this.createPlainDelayLoadingFileData(meshOrGeometry, isMesh);
        return file;
    }
    createPlainDelayLoadingFileData(meshOrGeometry, isMesh) {
        var result = {
            positions: meshOrGeometry.positions,
            indices: meshOrGeometry.indices,
            normals: meshOrGeometry.normals,
        };
        if (meshOrGeometry.uvs) {
            result.uvs = meshOrGeometry.uvs;
        }
        if (meshOrGeometry.uv2s) {
            result.uv2s = meshOrGeometry.uv2s;
        }
        if (meshOrGeometry.colors) {
            result.colors = meshOrGeometry.colors;
        }
        if (meshOrGeometry.tangents) {
            result.tangents = meshOrGeometry.tangents;
        }
        if (meshOrGeometry.matricesIndices) {
            result.matricesIndices = meshOrGeometry.matricesIndices;
        }
        if (meshOrGeometry.matricesWeights) {
            result.matricesWeights = meshOrGeometry.matricesWeights;
        }
        if (isMesh && meshOrGeometry.subMeshes) {
            result.subMeshes = meshOrGeometry.subMeshes;
        }
        var json = JSON.stringify(result, null, 0);
        return json;
    }
    createDracoDelayLoadingFileData(geometry, dracoOptions) {
        const start = new Date().getTime();
        const dracoData = this.getDracoEncodedGeometry(geometry, dracoOptions);
        const elapsed = new Date().getTime() - start;
        //Logger.info("Draco Encoding - " + geometry.id + "\t" + elapsed + " ms");
        if (dracoData) {
            var result = {
                type: "draco",
                data: dracoData
            };
            // Serializzo tutto in formato binario
            return msgpack.encode(result);
        }
        return null;
    }
    getDracoEncodedGeometry(geometry, dracoOptions) {
        if (!geometry)
            return null;
        const positions = geometry.positions;
        const normals = geometry.normals;
        const colors = geometry.colors;
        const uvs = geometry.uvs;
        const uv2s = geometry.uv2s;
        const indices = geometry.indices;
        const mesh = {
            indices: new Uint32Array(indices),
            positions: new Float32Array(positions),
            normals: new Float32Array(normals),
        };
        if (uvs)
            mesh.uvs = new Float32Array(uvs);
        if (uv2s)
            mesh.uv2s = new Float32Array(uv2s);
        if (colors)
            mesh.colors = new Float32Array(colors);
        const encoderModule = DracoEncoderModule();
        const encoder = new encoderModule.Encoder();
        const meshBuilder = new encoderModule.MeshBuilder();
        const dracoMesh = new encoderModule.Mesh();
        const numFaces = mesh.indices.length / 3;
        const numPoints = mesh.positions.length / 3;
        meshBuilder.AddFacesToMesh(dracoMesh, numFaces, mesh.indices);
        meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.POSITION, numPoints, 3, mesh.positions);
        if (mesh.normals) {
            meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.NORMAL, numPoints, 3, mesh.normals);
        }
        if (mesh.colors) {
            meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.COLOR, numPoints, 4, mesh.colors);
        }
        if (mesh.uvs) {
            meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.TEX_COORD, numPoints, 2, mesh.uvs);
        }
        // Attenzione! E' importante passare il secondo canale per ultimo e subito dopo il primo
        // In fase di decoding si supporrà che questa sia la posizione.
        if (mesh.uv2s) {
            meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.TEX_COORD, numPoints, 2, mesh.uv2s);
        }
        encoder.SetSpeedOptions(dracoOptions.dracoEncodingSpeed, dracoOptions.dracoDecodingSpeed);
        encoder.SetAttributeQuantization(encoderModule.POSITION, 14);
        encoder.SetAttributeQuantization(encoderModule.TEX_COORD, 12);
        encoder.SetAttributeQuantization(encoderModule.NORMAL, 10);
        encoder.SetAttributeQuantization(encoderModule.COLOR, 10);
        encoder.SetAttributeQuantization(encoderModule.GENERIC, 8);
        encoder.SetEncodingMethod(encoderModule.MESH_EDGEBREAKER_ENCODING);
        const encodedData = new encoderModule.DracoInt8Array();
        const encodedLen = encoder.EncodeMeshToDracoBuffer(dracoMesh, encodedData);
        var outputBuffer = new ArrayBuffer(encodedLen);
        var outputData = new Int8Array(outputBuffer);
        for (let i = 0; i < encodedLen; ++i) {
            outputData[i] = encodedData.GetValue(i);
        }
        encoderModule.destroy(dracoMesh);
        encoderModule.destroy(encodedData);
        encoderModule.destroy(encoder);
        encoderModule.destroy(meshBuilder);
        return outputBuffer;
    }
    extractIncrementalMaterialFile(version, material, fileName) {
        //Logger.info("Extracting material " + material.id);
        var file = this.createDelayLoadingMaterialFile(version, material, fileName);
        //Logger.info("Delay loading material file: " + file.name);
        return file;
    }
    createDelayLoadingMaterialFile(version, material, fileName) {
        var file = new Zakeke.IncrementalFileInfo();
        file.isScene = false;
        file.dracoEncoded = false;
        file.name = fileName;
        file.data = this.createMaterialFileData(material);
        return file;
    }
    createMaterialFileData(material) {
        var json = JSON.stringify(material, null, 0);
        return json;
    }
}


/***/ }),

/***/ "../../3D/src/Components/InfoPointsManager/InfoPointsManager.ts":
/*!**********************************************************************!*\
  !*** ../../3D/src/Components/InfoPointsManager/InfoPointsManager.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "InfoPointsManager": () => (/* binding */ InfoPointsManager)
/* harmony export */ });
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");

// Classe che ha la responsabilità di gestire gli info points della scena
// Nella presente implementazione, gli info points sono "agganciati" alle mesh
// e hanno la possibilità di visualizzare le eventuali immagini di anteprima dei materiali
class InfoPointsManager {
    constructor(zkScene, scene, style) {
        this._meshesInfoPoints = {};
        this._infoPoints = [];
        this._imageUrls = [];
        this._currentIdx = 0;
        this._imagePanel = null;
        this._loadingText = null;
        this._image = null;
        this._closeImageButton = null;
        this._moveNextImageButton = null;
        this._movePrevImageButton = null;
        this._isOnMoveNextButton = false;
        this._isOnMovePrevButton = false;
        this._lastCameraPosition = null;
        this.onBeforeShowImages = null;
        this.onAfterShowImages = null;
        this._infoPointsShown = true;
        this._canShowInfoPointsContent = true;
        // Eventi
        this._infoPointPickedListeners = [];
        this._infoPointContentShownListeners = [];
        this._infoPointContentHiddenListeners = [];
        this._renderingNeededListeners = [];
        this.CLOSE_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-close' style='fill:§color§'%3E%3Cpath d='M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'/%3E%3Cpath d='M0 0h24v24H0z' fill='none'/%3E%3C/g%3E%3C/svg%3E";
        this.CHEVRON_LEFT_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-left'%3E%3Cpath fill='§color§' d='M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z' /%3E%3C/g%3E%3C/svg%3E";
        this.CHEVRON_RIGHT_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='24' viewBox='0 0 24 24' width='24'%3E%3Cg id='mdi-chevron-right'%3E%3Cpath fill='§color§' d='M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z' /%3E%3C/g%3E%3C/svg%3E";
        this._zkScene = zkScene;
        this._scene = scene;
        this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper(scene);
        this._style = {};
        this.setDefaultStyle();
        if (style)
            this.setStyle(style);
        this._rootContainer = BABYLON.GUI.AdvancedDynamicTexture.CreateFullscreenUI("UI", true, this._scene);
    }
    get infoPointsShown() {
        return this._infoPointsShown;
    }
    get canShowInfoPointsContent() {
        return this._canShowInfoPointsContent;
    }
    set canShowInfoPointsContent(value) {
        this._canShowInfoPointsContent = value;
        this.hideImages();
    }
    dispose() {
        this._renderingNeededListeners = [];
        this._rootContainer.dispose();
    }
    setDefaultStyle() {
        this._style.infoPointsStyle = {
            borderColor: "#ffffff",
            innerPointColor: "#ffffff",
            color: "#a01c20",
            highlightColor: "#bb2025"
        };
        this._style.imagePanelStyle = {
            backgroundColor: this._scene.clearColor.toHexString(),
            loadingTextColor: "#ffffff",
            buttonsBorderColor: "#a01c20",
            buttonsColor: "#a01c20",
            buttonsBorderHighlightColor: "#bb2025",
            buttonsHighlightColor: "#bb2025",
            buttonsIconColor: "white"
        };
    }
    setStyle(style) {
        if (style) {
            if (style.infoPointsStyle) {
                if (!this._style.infoPointsStyle)
                    this._style.infoPointsStyle = {};
                if (style.infoPointsStyle.borderColor)
                    this._style.infoPointsStyle.borderColor = style.infoPointsStyle.borderColor;
                if (style.infoPointsStyle.innerPointColor)
                    this._style.infoPointsStyle.innerPointColor = style.infoPointsStyle.innerPointColor;
                if (style.infoPointsStyle.color)
                    this._style.infoPointsStyle.color = style.infoPointsStyle.color;
                if (style.infoPointsStyle.highlightColor)
                    this._style.infoPointsStyle.highlightColor = style.infoPointsStyle.highlightColor;
            }
            if (style.imagePanelStyle) {
                if (!this._style.imagePanelStyle)
                    this._style.imagePanelStyle = {};
                if (style.imagePanelStyle.backgroundColor)
                    this._style.imagePanelStyle.backgroundColor = style.imagePanelStyle.backgroundColor;
                if (style.imagePanelStyle.loadingTextColor)
                    this._style.imagePanelStyle.loadingTextColor = style.imagePanelStyle.loadingTextColor;
                if (style.imagePanelStyle.buttonsBorderColor)
                    this._style.imagePanelStyle.buttonsBorderColor = style.imagePanelStyle.buttonsBorderColor;
                if (style.imagePanelStyle.buttonsColor)
                    this._style.imagePanelStyle.buttonsColor = style.imagePanelStyle.buttonsColor;
                if (style.imagePanelStyle.buttonsBorderHighlightColor)
                    this._style.imagePanelStyle.buttonsBorderHighlightColor = style.imagePanelStyle.buttonsBorderHighlightColor;
                if (style.imagePanelStyle.buttonsHighlightColor)
                    this._style.imagePanelStyle.buttonsHighlightColor = style.imagePanelStyle.buttonsHighlightColor;
                if (style.imagePanelStyle.buttonsIconColor)
                    this._style.imagePanelStyle.buttonsIconColor = style.imagePanelStyle.buttonsIconColor;
            }
        }
        else {
            this.setDefaultStyle();
        }
    }
    applyStyle(style) {
        this.setStyle(style);
        this.refresh();
    }
    showInfoPoints() {
        this.hideImages();
        this.getAllInfoPoints().forEach(i => i.isVisible = true);
        this._infoPointsShown = true;
        this.fireRenderingNeededEvent();
    }
    hideInfoPoints() {
        this.hideImages();
        this.getAllInfoPoints().forEach(i => i.isVisible = false);
        this._infoPointsShown = false;
        this.fireRenderingNeededEvent();
    }
    refresh() {
        this.hideImages();
        this.refreshInfoPoints();
        this.updateGuiElementsStyle();
        this.fireRenderingNeededEvent();
    }
    getAllInfoPoints() {
        const infoPoints = [];
        for (const prop in this._meshesInfoPoints)
            infoPoints.push(this._meshesInfoPoints[prop]);
        return infoPoints;
    }
    refreshInfoPoints() {
        for (let i = 0; i < this._scene.meshes.length; i++) {
            const mesh = this._scene.meshes[i];
            const canShowOnMesh = mesh.metadata && mesh.metadata.showInfoPoints && (mesh.isVisible || mesh.metadata.forceShowInfoPoints);
            const material = mesh.material;
            const urls = material ? this.getMaterialPhotoUrls(material) : [];
            if (canShowOnMesh && urls.length > 0) {
                const infoPoint = this.getOrCreateMeshInfoPoint(mesh);
                this.updateInfoPointUrls(infoPoint, urls);
            }
            else {
                this.removeMeshInfoPoints(mesh);
            }
        }
    }
    removeMeshInfoPoints(mesh) {
        if (this._meshesInfoPoints.hasOwnProperty(mesh.id)) {
            const infoPoint = this._meshesInfoPoints[mesh.id];
            infoPoint.dispose();
            delete this._meshesInfoPoints[mesh.id];
        }
    }
    getOrCreateMeshInfoPoint(mesh) {
        if (this._meshesInfoPoints.hasOwnProperty(mesh.id))
            return this._meshesInfoPoints[mesh.id];
        const meshInfoPoint = this.createMeshInfoPoint(mesh);
        this._meshesInfoPoints[mesh.id] = meshInfoPoint;
        return meshInfoPoint;
    }
    updateInfoPointUrls(infoPoint, urls) {
        if (!infoPoint.metadata)
            infoPoint.metadata = {};
        infoPoint.metadata.urls = urls;
    }
    createMeshInfoPoint(mesh) {
        var _a, _b, _c, _d;
        const circleOut = new BABYLON.GUI.Ellipse("infoPoint");
        circleOut.width = "29px";
        circleOut.height = "29px";
        circleOut.color = ((_a = this._style.infoPointsStyle) === null || _a === void 0 ? void 0 : _a.borderColor) || "#dddddd";
        circleOut.thickness = 4;
        circleOut.background = ((_b = this._style.infoPointsStyle) === null || _b === void 0 ? void 0 : _b.color) || "#a01c20";
        circleOut.alpha = 1;
        circleOut.onPointerEnterObservable.add((data) => {
            var _a;
            circleOut.background = ((_a = this._style.infoPointsStyle) === null || _a === void 0 ? void 0 : _a.highlightColor) || "#bb2025";
            this.fireRenderingNeededEvent();
        });
        circleOut.onPointerOutObservable.add((data) => {
            var _a;
            circleOut.background = ((_a = this._style.infoPointsStyle) === null || _a === void 0 ? void 0 : _a.color) || "#a01c20";
            this.fireRenderingNeededEvent();
        });
        this._rootContainer.addControl(circleOut);
        const circleIn = new BABYLON.GUI.Ellipse("innerPoint");
        circleIn.width = 0.29;
        circleIn.height = 0.29;
        circleIn.color = ((_c = this._style.infoPointsStyle) === null || _c === void 0 ? void 0 : _c.innerPointColor) || "White";
        circleIn.thickness = 0;
        circleIn.background = ((_d = this._style.infoPointsStyle) === null || _d === void 0 ? void 0 : _d.innerPointColor) || "White";
        circleOut.addControl(circleIn);
        circleOut.linkWithMesh(mesh);
        circleOut.linkOffsetY = 0;
        circleOut.shadowBlur = 6;
        circleOut.shadowOffsetX = 2;
        circleOut.shadowOffsetY = 2;
        circleOut.isPointerBlocker = true;
        circleOut.hoverCursor = "pointer";
        circleOut.onPointerClickObservable.add((data) => {
            if (circleOut.metadata && circleOut.metadata.urls) {
                const args = {
                    meshID: mesh.id,
                    materialID: mesh.material ? mesh.material.id : null,
                    materialPhotoUrl: circleOut.metadata.urls
                };
                this.fireInfoPointPickedEvent(args);
                this.showImages(circleOut.metadata.urls);
            }
            this.fireRenderingNeededEvent();
        });
        return circleOut;
    }
    getMaterialInfoPoint(materialID) {
        for (let i = 0; i < this._infoPoints.length; i++) {
            const infoPoint = this._infoPoints[i];
            if (infoPoint.metadata && infoPoint.metadata.materialID && infoPoint.metadata.materialID === materialID)
                return infoPoint;
        }
        return null;
    }
    getMaterialPhotoUrls(material) {
        return this._zkScene.get("materialPhotos").getMaterialPhotoUrls(material.id);
    }
    getOrCreateImagePanel() {
        if (!this._imagePanel)
            this.createImagePanel();
        return this._imagePanel;
    }
    createImagePanel() {
        var _a;
        const imagePanel = new BABYLON.GUI.Rectangle("imagePanel");
        imagePanel.background = ((_a = this._style.imagePanelStyle) === null || _a === void 0 ? void 0 : _a.backgroundColor) || this._scene.clearColor.toHexString();
        imagePanel.width = 1;
        imagePanel.height = 1;
        imagePanel.zIndex = 10000;
        imagePanel.isVisible = false;
        this._imagePanel = imagePanel;
        this._rootContainer.addControl(imagePanel);
        this.addCloseButton(imagePanel);
        this.addMoveNextImageButton(imagePanel);
        this.addMovePrevImageButton(imagePanel);
        return imagePanel;
    }
    addCloseButton(imagePanel) {
        var _a, _b, _c;
        const closePanel = new BABYLON.GUI.StackPanel("closePanel");
        closePanel.height = "48px";
        closePanel.width = "48px";
        closePanel.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        closePanel.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_TOP;
        closePanel.isVertical = false;
        closePanel.zIndex = 10003;
        imagePanel.addControl(closePanel);
        const closeRect = new BABYLON.GUI.Rectangle("closeRect");
        closeRect.width = "24px";
        closeRect.height = "24px";
        closeRect.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        closeRect.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        closeRect.background = ((_a = this._style.imagePanelStyle) === null || _a === void 0 ? void 0 : _a.buttonsColor) || "#a01c20";
        closeRect.color = ((_b = this._style.imagePanelStyle) === null || _b === void 0 ? void 0 : _b.buttonsBorderColor) || "#a01c20";
        closeRect.isPointerBlocker = true;
        closeRect.hoverCursor = "pointer";
        closeRect.onPointerEnterObservable.add((data) => {
            var _a, _b;
            closeRect.background = ((_a = this._style.imagePanelStyle) === null || _a === void 0 ? void 0 : _a.buttonsHighlightColor) || "#bb2025";
            closeRect.color = ((_b = this._style.imagePanelStyle) === null || _b === void 0 ? void 0 : _b.buttonsBorderHighlightColor) || "#bb2025";
            this.fireRenderingNeededEvent();
        });
        closeRect.onPointerOutObservable.add((data) => {
            var _a, _b;
            closeRect.background = ((_a = this._style.imagePanelStyle) === null || _a === void 0 ? void 0 : _a.buttonsColor) || "#a01c20";
            closeRect.color = ((_b = this._style.imagePanelStyle) === null || _b === void 0 ? void 0 : _b.buttonsBorderColor) || "#a01c20";
            this.fireRenderingNeededEvent();
        });
        closeRect.onPointerClickObservable.add((data) => {
            this.hideImages();
            this.fireRenderingNeededEvent();
        });
        closePanel.addControl(closeRect);
        const closeIcon = new BABYLON.GUI.Image("close", this.getCloseSvg(((_c = this._style.imagePanelStyle) === null || _c === void 0 ? void 0 : _c.buttonsIconColor) || "white"));
        closeIcon.width = 1;
        closeIcon.height = 1;
        closeIcon.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM;
        closeRect.addControl(closeIcon);
        this._closeImageButton = closePanel;
    }
    addMoveNextImageButton(imagePanel) {
        var _a, _b, _c;
        const rightPanel = new BABYLON.GUI.StackPanel("rightPanel");
        rightPanel.width = "48px";
        rightPanel.height = "48px";
        rightPanel.paddingRight = "24px";
        rightPanel.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        rightPanel.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        rightPanel.isVertical = false;
        rightPanel.zIndex = 10003;
        rightPanel.alpha = 0.3;
        rightPanel.isVisible = false;
        imagePanel.addControl(rightPanel);
        const rightRect = new BABYLON.GUI.Rectangle("rightRect");
        rightRect.width = "24px";
        rightRect.height = "48px";
        rightRect.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        rightRect.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        rightRect.background = ((_a = this._style.imagePanelStyle) === null || _a === void 0 ? void 0 : _a.buttonsColor) || "#a01c20";
        rightRect.color = ((_b = this._style.imagePanelStyle) === null || _b === void 0 ? void 0 : _b.buttonsBorderColor) || "#a01c20";
        rightRect.isPointerBlocker = true;
        rightRect.hoverCursor = "pointer";
        rightRect.onPointerEnterObservable.add((data) => {
            var _a, _b;
            this._isOnMoveNextButton = true;
            rightRect.background = ((_a = this._style.imagePanelStyle) === null || _a === void 0 ? void 0 : _a.buttonsHighlightColor) || "#bb2025";
            rightRect.color = ((_b = this._style.imagePanelStyle) === null || _b === void 0 ? void 0 : _b.buttonsBorderHighlightColor) || "#bb2025";
            this.updateMoveNextImageButton();
            this.fireRenderingNeededEvent();
        });
        rightRect.onPointerOutObservable.add((data) => {
            var _a, _b;
            this._isOnMoveNextButton = false;
            rightRect.background = ((_a = this._style.imagePanelStyle) === null || _a === void 0 ? void 0 : _a.buttonsColor) || "#a01c20";
            rightRect.color = ((_b = this._style.imagePanelStyle) === null || _b === void 0 ? void 0 : _b.buttonsBorderColor) || "#a01c20";
            this.updateMoveNextImageButton();
            this.fireRenderingNeededEvent();
        });
        rightRect.onPointerClickObservable.add((data) => {
            this.moveNextImage();
            this.fireRenderingNeededEvent();
        });
        rightPanel.addControl(rightRect);
        const rightIcon = new BABYLON.GUI.Image("move-next", this.getChevronRightSvg(((_c = this._style.imagePanelStyle) === null || _c === void 0 ? void 0 : _c.buttonsIconColor) || "white"));
        rightIcon.width = 1;
        rightIcon.height = 1;
        rightIcon.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM;
        rightIcon.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        rightRect.addControl(rightIcon);
        this._moveNextImageButton = rightPanel;
    }
    addMovePrevImageButton(imagePanel) {
        var _a, _b, _c;
        const leftPanel = new BABYLON.GUI.StackPanel("leftPanel");
        leftPanel.width = "48px";
        leftPanel.height = "48px";
        leftPanel.paddingLeft = "24px";
        leftPanel.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        leftPanel.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        leftPanel.isVertical = false;
        leftPanel.alpha = 0.3;
        leftPanel.zIndex = 10003;
        leftPanel.isVisible = false;
        imagePanel.addControl(leftPanel);
        const leftRect = new BABYLON.GUI.Rectangle("leftRect");
        leftRect.width = "24px";
        leftRect.height = "48px";
        leftRect.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        leftRect.horizontalAlignment = BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_RIGHT;
        leftRect.background = ((_a = this._style.imagePanelStyle) === null || _a === void 0 ? void 0 : _a.buttonsColor) || "#a01c20";
        leftRect.color = ((_b = this._style.imagePanelStyle) === null || _b === void 0 ? void 0 : _b.buttonsBorderColor) || "#a01c20";
        leftRect.isPointerBlocker = true;
        leftRect.hoverCursor = "pointer";
        leftRect.onPointerEnterObservable.add((data) => {
            var _a, _b;
            this._isOnMovePrevButton = true;
            leftRect.background = ((_a = this._style.imagePanelStyle) === null || _a === void 0 ? void 0 : _a.buttonsHighlightColor) || "#bb2025";
            leftRect.color = ((_b = this._style.imagePanelStyle) === null || _b === void 0 ? void 0 : _b.buttonsBorderHighlightColor) || "#bb2025";
            this.updateMovePrevImageButton();
            this.fireRenderingNeededEvent();
        });
        leftRect.onPointerOutObservable.add((data) => {
            var _a, _b;
            this._isOnMovePrevButton = false;
            leftRect.background = ((_a = this._style.imagePanelStyle) === null || _a === void 0 ? void 0 : _a.buttonsColor) || "#a01c20";
            leftRect.color = ((_b = this._style.imagePanelStyle) === null || _b === void 0 ? void 0 : _b.buttonsBorderColor) || "#a01c20";
            this.updateMovePrevImageButton();
            this.fireRenderingNeededEvent();
        });
        leftRect.onPointerClickObservable.add((data) => {
            this.movePrevImage();
            this.fireRenderingNeededEvent();
        });
        leftPanel.addControl(leftRect);
        const leftIcon = new BABYLON.GUI.Image("move-prev", this.getChevronLeftSvg(((_c = this._style.imagePanelStyle) === null || _c === void 0 ? void 0 : _c.buttonsIconColor) || "white"));
        leftIcon.width = 1;
        leftIcon.height = 1;
        leftIcon.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM;
        leftIcon.verticalAlignment = BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        leftRect.addControl(leftIcon);
        this._movePrevImageButton = leftPanel;
    }
    updateMoveNextImageButton() {
        if (this._moveNextImageButton) {
            if (this._imageUrls.length <= 1)
                this._moveNextImageButton.isVisible = false;
            else {
                this._moveNextImageButton.isVisible = true;
                this._moveNextImageButton.alpha = this.canMoveNextImage() ? (this._isOnMoveNextButton ? 1 : 0.3) : 0.1;
            }
        }
    }
    updateMovePrevImageButton() {
        if (this._movePrevImageButton) {
            if (this._imageUrls.length <= 1)
                this._movePrevImageButton.isVisible = false;
            else {
                this._movePrevImageButton.isVisible = true;
                this._movePrevImageButton.alpha = this.canMovePrevImage() ? (this._isOnMovePrevButton ? 1 : 0.3) : 0.1;
            }
        }
    }
    showImages(urls) {
        if (!this._canShowInfoPointsContent)
            return;
        this._currentIdx = 0;
        this._imageUrls = urls;
        this._isOnMoveNextButton = false;
        this._isOnMovePrevButton = false;
        this.getOrCreateImagePanel();
        if (this._imagePanel) {
            if (this.onBeforeShowImages)
                this.onBeforeShowImages();
            this.updateMoveNextImageButton();
            this.updateMovePrevImageButton();
            this._imagePanel.isVisible = true;
            this.showCurrentImage();
            this.fireInfoPointContentShownEvent();
        }
        this.fireRenderingNeededEvent();
    }
    moveNextImage() {
        if (this.canMoveNextImage()) {
            this._currentIdx++;
            this.showCurrentImage();
            this.updateMoveNextImageButton();
            this.updateMovePrevImageButton();
            this.fireRenderingNeededEvent();
        }
    }
    movePrevImage() {
        if (this.canMovePrevImage()) {
            this._currentIdx--;
            this.showCurrentImage();
            this.updateMoveNextImageButton();
            this.updateMovePrevImageButton();
            this.fireRenderingNeededEvent();
        }
    }
    showCurrentImage() {
        if (this._currentIdx >= 0 && this._currentIdx < this._imageUrls.length)
            this.showImage(this._imageUrls[this._currentIdx]);
    }
    canMoveNextImage() {
        return this._imageUrls.length > 0 && this._currentIdx < (this._imageUrls.length - 1);
    }
    canMovePrevImage() {
        return this._imageUrls.length > 0 && this._currentIdx > 0;
    }
    hideImages() {
        if (this._imagePanel) {
            this._imagePanel.isVisible = false;
            if (this.onAfterShowImages)
                this.onAfterShowImages();
            this.fireInfoPointContentHiddenEvent();
            this.fireRenderingNeededEvent();
        }
    }
    showImage(url) {
        if (this._imagePanel) {
            if (this._image) {
                this._imagePanel.removeControl(this._image);
                this._image.isVisible = false;
                this._image.dispose();
                this._image = null;
            }
            this.showLoadingText();
            const image = new BABYLON.GUI.Image("but", url);
            image.width = 1;
            image.height = 1;
            image.isVisible = true;
            image.zIndex = 10002;
            image.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM;
            image.onImageLoadedObservable.add(data => {
                this.hideLoadingText();
            });
            this._imagePanel.addControl(image);
            this._image = image;
            this.fireRenderingNeededEvent();
        }
        /*
        if (this._imagePanel) {
            const image = new BABYLON.GUI.Image("but", url);
            image.width = 1;
            image.height = 1;
            image.isVisible = true;
            image.stretch = BABYLON.GUI.Image.STRETCH_UNIFORM;
            this._imagePanel.addControl(image);
            if (this._image) {
                this._imagePanel.removeControl(this._image);
                this._image.isVisible = false;
                this._image.dispose();
                this._image = null;
            }
            this._image = image;
        }
        */
    }
    /**
     * Update info points visibility and return true if at least one info point has been updated.
     *
     * @return {boolean} Return true if any info point has been updated.
     */
    updateInfoPointsVisibility() {
        let ret = false;
        if (this._scene.activeCamera) {
            if (!this._lastCameraPosition || !this._lastCameraPosition.equals(this._scene.activeCamera.position)) {
                this._lastCameraPosition = this._scene.activeCamera.position.clone();
                for (const meshID in this._meshesInfoPoints) {
                    const mesh = this._scene.getMeshByID(meshID);
                    if (mesh) {
                        this.updateMeshInfoPointVisibility(mesh, this._meshesInfoPoints[meshID]);
                        ret = true;
                    }
                }
            }
        }
        return ret;
    }
    drawRay(origin, forward) {
        let direction = forward.subtract(origin);
        direction = direction.normalize();
        const length = forward.subtract(origin).length() * 2;
        const ray = new BABYLON.Ray(origin, direction, length);
        // debug
        BABYLON.RayHelper.CreateAndShow(ray, this._scene, new BABYLON.Color3(1, 1, 0.1));
    }
    updateMeshInfoPointVisibility(mesh, infoPoint) {
        if (this._scene.activeCamera) {
            const forward = this._sceneHelper.getMeshHierarchyCenter(mesh);
            const origin = this._scene.activeCamera.position;
            let direction = forward.subtract(origin);
            direction = direction.normalize();
            const length = forward.subtract(origin).length() * 2;
            const ray = new BABYLON.Ray(origin, direction, length);
            const hit = this._scene.pickWithRay(ray);
            if (hit && hit.pickedMesh) {
                infoPoint.alpha = hit.pickedMesh === mesh ? 1 : 0.2;
            }
        }
    }
    getCloseSvg(color) {
        return this.getSvg(this.CLOSE_SVG, color);
    }
    getChevronLeftSvg(color) {
        return this.getSvg(this.CHEVRON_LEFT_SVG, color);
    }
    getChevronRightSvg(color) {
        return this.getSvg(this.CHEVRON_RIGHT_SVG, color);
    }
    getSvg(svg, color) {
        return svg.replace("§color§", encodeURIComponent(color));
    }
    // -------------------------------------------------------------
    // Events 
    // -------------------------------------------------------------
    // picked
    fireInfoPointPickedEvent(e) {
        for (let i = 0; i < this._infoPointPickedListeners.length; i++)
            this._infoPointPickedListeners[i](e);
    }
    addInfoPointPickedListener(listenerFunction) {
        this._infoPointPickedListeners.push(listenerFunction);
    }
    addInfoPointPickedListenerRange(listenerFunctions) {
        this._infoPointPickedListeners.push(...listenerFunctions);
    }
    // Content shown
    fireInfoPointContentShownEvent() {
        for (let i = 0; i < this._infoPointContentShownListeners.length; i++)
            this._infoPointContentShownListeners[i]();
    }
    addInfoPointContentShownListener(listenerFunction) {
        this._infoPointContentShownListeners.push(listenerFunction);
    }
    addInfoPointContentShownListenerRange(listenerFunctions) {
        this._infoPointContentShownListeners.push(...listenerFunctions);
    }
    // content hidden
    fireInfoPointContentHiddenEvent() {
        for (let i = 0; i < this._infoPointContentHiddenListeners.length; i++)
            this._infoPointContentHiddenListeners[i]();
    }
    addInfoPointContentHiddenListener(listenerFunction) {
        this._infoPointContentHiddenListeners.push(listenerFunction);
    }
    addInfoPointContentHiddenListenerRange(listenerFunctions) {
        this._infoPointContentHiddenListeners.push(...listenerFunctions);
    }
    // Rendering Needed
    fireRenderingNeededEvent() {
        for (let i = 0; i < this._renderingNeededListeners.length; ++i) {
            this._renderingNeededListeners[i]();
        }
    }
    addRenderingNeededListener(listenerFunction) {
        this._renderingNeededListeners.push(listenerFunction);
    }
    showLoadingText() {
        var _a;
        if (this._loadingText) {
            this._loadingText.isVisible = true;
            return;
        }
        if (this._imagePanel) {
            this._loadingText = new BABYLON.GUI.TextBlock("loading");
            this._loadingText.text = "Loading...";
            this._loadingText.left = 0.5;
            this._loadingText.top = 0.7;
            this._loadingText.zIndex = 10001;
            this._loadingText.color = ((_a = this._style.imagePanelStyle) === null || _a === void 0 ? void 0 : _a.loadingTextColor) || "white";
            this._imagePanel.addControl(this._loadingText);
            this.fireRenderingNeededEvent();
        }
    }
    hideLoadingText() {
        if (this._loadingText)
            this._loadingText.isVisible = false;
        this.fireRenderingNeededEvent();
    }
    updateGuiElementsStyle() {
        this.updateMeshInfoPointsStyle();
        this.updateImagePanelStyle();
        this.fireRenderingNeededEvent();
    }
    updateMeshInfoPointsStyle() {
        this.getAllInfoPoints().forEach(infoPoint => {
            var _a, _b, _c;
            infoPoint.color = ((_a = this._style.infoPointsStyle) === null || _a === void 0 ? void 0 : _a.borderColor) || "#dddddd";
            infoPoint.background = ((_b = this._style.infoPointsStyle) === null || _b === void 0 ? void 0 : _b.color) || "#a01c20";
            const circleIn = infoPoint.getChildByName("innerPoint");
            if (circleIn && circleIn instanceof BABYLON.GUI.Container) {
                circleIn.background = ((_c = this._style.infoPointsStyle) === null || _c === void 0 ? void 0 : _c.innerPointColor) || "White";
            }
        });
    }
    updateImagePanelStyle() {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (this._imagePanel) {
            this._imagePanel.background = ((_a = this._style.imagePanelStyle) === null || _a === void 0 ? void 0 : _a.backgroundColor) || this._scene.clearColor.toHexString();
            const closePanel = this._imagePanel.getChildByName("closePanel");
            if (closePanel && closePanel instanceof BABYLON.GUI.Container) {
                const closeRect = closePanel.getChildByName("closeRect");
                if (closeRect && closeRect instanceof BABYLON.GUI.Container) {
                    closeRect.background = ((_b = this._style.imagePanelStyle) === null || _b === void 0 ? void 0 : _b.buttonsColor) || "#a01c20";
                    closeRect.color = ((_c = this._style.imagePanelStyle) === null || _c === void 0 ? void 0 : _c.buttonsBorderColor) || "#a01c20";
                }
            }
            const rightPanel = this._imagePanel.getChildByName("rightPanel");
            if (rightPanel && rightPanel instanceof BABYLON.GUI.Container) {
                const rightRect = rightPanel.getChildByName("rightRect");
                if (rightRect && rightRect instanceof BABYLON.GUI.Container) {
                    rightRect.background = ((_d = this._style.imagePanelStyle) === null || _d === void 0 ? void 0 : _d.buttonsColor) || "#a01c20";
                    rightRect.color = ((_e = this._style.imagePanelStyle) === null || _e === void 0 ? void 0 : _e.buttonsBorderColor) || "#a01c20";
                }
            }
            const leftPanel = this._imagePanel.getChildByName("leftPanel");
            if (leftPanel && leftPanel instanceof BABYLON.GUI.Container) {
                const leftRect = leftPanel.getChildByName("leftRect");
                if (leftRect && leftRect instanceof BABYLON.GUI.Container) {
                    leftRect.background = ((_f = this._style.imagePanelStyle) === null || _f === void 0 ? void 0 : _f.buttonsColor) || "#a01c20";
                    leftRect.color = ((_g = this._style.imagePanelStyle) === null || _g === void 0 ? void 0 : _g.buttonsBorderColor) || "#a01c20";
                }
            }
            if (this._loadingText) {
                this._loadingText.color = ((_h = this._style.imagePanelStyle) === null || _h === void 0 ? void 0 : _h.loadingTextColor) || "white";
            }
        }
    }
}


/***/ }),

/***/ "../../3D/src/Components/MaterialsPreview/MaterialsPreview.ts":
/*!********************************************************************!*\
  !*** ../../3D/src/Components/MaterialsPreview/MaterialsPreview.ts ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MaterialPreviewData": () => (/* binding */ MaterialPreviewData),
/* harmony export */   "MaterialsPreview": () => (/* binding */ MaterialsPreview)
/* harmony export */ });
/* harmony import */ var _Helpers_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Helpers/utils */ "../../3D/src/Helpers/utils.ts");
/* harmony import */ var _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../Misc/DefaultAssetUrls */ "../../3D/src/Misc/DefaultAssetUrls.ts");
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



class MaterialPreviewData {
    constructor() {
        this.previewFiles = {};
    }
    downloadFiles() {
        function endsWith(str, suffix) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }
        for (let key in this.previewFiles) {
            let blob = null;
            const data = this.previewFiles[key];
            if (typeof data == "string")
                blob = _Helpers_utils__WEBPACK_IMPORTED_MODULE_0__.Utils.dataURItoBlob(data);
            else
                blob = data;
            if (blob) {
                let mimeType = null;
                if (endsWith(key, ".jpeg" || 0)) {
                    mimeType = { type: "image/jpeg" };
                }
                else if (endsWith(key, ".png")) {
                    mimeType = { type: "image/png" };
                }
                if (mimeType) {
                    let link = document.createElement('a');
                    document.body.appendChild(link);
                    link.setAttribute("type", "hidden");
                    link.download = key;
                    link.href = window.URL.createObjectURL(new Blob([blob], mimeType));
                    link.click();
                }
            }
        }
    }
}
class MaterialsPreview {
    static getPreviewsAsync(scene, rootUrl, materialIDs, options, createBlobs = true) {
        return __awaiter(this, void 0, void 0, function* () {
            yield scene.whenReadyAsync();
            const previewMaker = new MaterialPreviewMaker(scene, rootUrl, materialIDs, options);
            const previews = yield previewMaker.getPreviewsAsync(createBlobs);
            previewMaker.dispose();
            return previews;
        });
    }
    static downloadPreviewsAsync(scene, rootUrl, materialsIDs, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield MaterialsPreview.getPreviewsAsync(scene, rootUrl, materialsIDs, options);
            data.downloadFiles();
        });
    }
}
class MaterialPreviewMaker {
    constructor(scene, rootUrl, materialIDs, options) {
        this._width = 256;
        this._height = 256;
        this._crop = false;
        this._materials = [];
        this._localEngine = null;
        this._hostingScene = null;
        this._hostingSceneHelper = null;
        this._hostingMesh = null;
        this._scene = scene;
        this._rootUrl = rootUrl;
        this._materialIDs = materialIDs;
        this._options = options || {};
        this.setupPreviewSize();
        if (this._options.crop != undefined)
            this._crop = this._options.crop;
        this.readMaterials();
    }
    dispose() {
        this.disposeHostingScene();
        this.disposeLocalEngine();
    }
    getLocalEngine() {
        if (!this._localEngine) {
            const localCanvas = document.createElement('canvas');
            localCanvas.id = "MaterialPreviewCanvas";
            localCanvas.width = 1024;
            localCanvas.height = 1024;
            this._localEngine = new BABYLON.Engine(localCanvas, true, { premultipliedAlpha: false, preserveDrawingBuffer: true });
            this._localEngine.setSize(this._width, this._height);
            //this._localEngine.setViewport(new BABYLON.Viewport(0, 0, 1, 1));
        }
        return this._localEngine;
    }
    disposeLocalEngine() {
        if (this._localEngine)
            this._localEngine.dispose();
    }
    disposeHostingScene() {
        if (this._hostingSceneHelper) {
            this._hostingSceneHelper.dispose();
            this._hostingSceneHelper = null;
        }
        if (this._hostingScene) {
            this._hostingScene.dispose();
            this._hostingScene = null;
        }
    }
    setupPreviewSize() {
        let options = this._options;
        if (options.width != undefined && options.height == undefined) {
            this._width = options.width;
            this._height = options.width;
        }
        else if (options.width == undefined && options.height != undefined) {
            this._width = options.height;
            this._height = options.height;
        }
        else if (options.width != undefined && options.height != undefined) {
            this._width = options.width;
            this._height = options.height;
        }
    }
    readMaterials() {
        this._materialIDs.forEach(id => {
            const material = this._scene.getMaterialByID(id);
            if (material)
                this._materials.push(material);
        });
    }
    downloadPreviewsAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const container = yield this.getPreviewsAsync();
            container.downloadFiles();
        });
    }
    getPreviewsAsync(createBlobs = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const files = [];
            const engine = this.getLocalEngine();
            this._hostingScene = new BABYLON.Scene(engine);
            this._hostingSceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_2__.SceneHelper(this._hostingScene);
            this._hostingSceneHelper.setupCamera();
            // Antialiasing
            const camera = this._hostingScene.activeCamera;
            if (camera) {
                const is_firefox = /firefox/i.test(navigator.userAgent);
                if (!is_firefox)
                    new BABYLON.PassPostProcess("scale_pass", 4.0, camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE);
                new BABYLON.PassPostProcess("scale_pass", 2.0, camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE);
                new BABYLON.PassPostProcess("scale_pass", 1.0, camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE);
            }
            return new Promise(resolve => {
                const environmentTexture = new BABYLON.CubeTexture(_Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Environment.EnvironmentTextureCDNUrl, this._hostingScene, null, false, null, () => __awaiter(this, void 0, void 0, function* () {
                    if (!this._hostingScene || !this._hostingSceneHelper)
                        return;
                    this._hostingScene.environmentTexture = environmentTexture;
                    this._hostingSceneHelper.setupLights();
                    this._hostingMesh = this._hostingSceneHelper.createSphere(null);
                    this._hostingSceneHelper.adjustCamera(undefined, undefined, undefined, false);
                    const container = new MaterialPreviewData();
                    for (let i = 0; i < this._materials.length; i++) {
                        const sourceMaterial = this._materials[i];
                        yield this.createMaterialPreviewFileAsync(sourceMaterial, container, createBlobs);
                    }
                    this.disposeHostingScene();
                    this.disposeLocalEngine();
                    resolve(container);
                }), null, undefined, true, undefined, true);
            });
        });
    }
    createMaterialPreviewFileAsync(sourceMaterial, container, createBlobs = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._hostingScene && this._hostingSceneHelper && this._hostingMesh) {
                const sourceJsonObj = sourceMaterial.serialize();
                const newMaterial = BABYLON.Material.Parse(sourceJsonObj, this._hostingScene, this._rootUrl);
                if (newMaterial) {
                    this._hostingMesh.material = newMaterial;
                    yield _SceneHelper__WEBPACK_IMPORTED_MODULE_2__.SceneHelper.whenMeshMaterialIsReady(this._hostingMesh);
                    this._hostingScene.render();
                    let previewData = yield this._hostingSceneHelper.takeContentScreenshotAsync(this._width, this._height);
                    if (this._crop) {
                        const cropped = yield _Helpers_utils__WEBPACK_IMPORTED_MODULE_0__.Utils.trimImageAsync(previewData);
                        if (cropped)
                            previewData = cropped;
                    }
                    let filename = newMaterial.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
                    filename = this.getNextIncrementalName(filename, ".png", container) + ".png";
                    Logger.info("preview: " + filename);
                    let data = previewData;
                    if (createBlobs)
                        data = _Helpers_utils__WEBPACK_IMPORTED_MODULE_0__.Utils.dataURItoBlob(previewData);
                    container.previewFiles[filename] = data;
                }
            }
        });
    }
    getNextIncrementalName(name, ext, previewData) {
        let newName = name;
        if (name) {
            let nameWithoutSuffix;
            let incremental = 0;
            while (previewData.previewFiles.hasOwnProperty(newName + ext)) {
                if (!nameWithoutSuffix) {
                    nameWithoutSuffix = name;
                    var idx = name.lastIndexOf("_");
                    if (idx > 0) {
                        var numText = name.substring(idx + 1);
                        var num = parseInt(numText);
                        if (num.toString() === numText) {
                            nameWithoutSuffix = name.substring(0, idx);
                        }
                    }
                }
                incremental++;
                newName = nameWithoutSuffix + "_" + incremental;
            }
        }
        return newName;
    }
}


/***/ }),

/***/ "../../3D/src/Components/MeshExpander/MeshExpander.ts":
/*!************************************************************!*\
  !*** ../../3D/src/Components/MeshExpander/MeshExpander.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MeshExpander": () => (/* binding */ MeshExpander)
/* harmony export */ });
// La classe espande una mesh muovendo tutti i vertici della geometria lungo la tangente
// risultante delle tangenti alle facce che hanno i vertici come spigoli
class MeshExpander {
    constructor() {
        this._mesh = null;
        this._scene = null;
        this._facesOfVertices = null;
        this._meshVerticesPositions = null;
        this._meshVerticesNormals = null;
        this._meshIndices = null;
        this._meshPositions = null;
        this._meshFacesNormals = null;
        this._sharedFacesOfVertices = {};
    }
    dispose() {
        // ...
    }
    resetDataModel() {
        this._facesOfVertices = null;
        this._meshVerticesPositions = null;
        this._meshVerticesNormals = null;
        this._meshIndices = null;
        this._meshPositions = null;
        this._meshFacesNormals = null;
        this._sharedFacesOfVertices = {};
    }
    prepareDataModel() {
        this.resetDataModel();
        if (this._mesh && this._scene) {
            this._facesOfVertices = [];
            this._sharedFacesOfVertices = {};
            this._meshVerticesPositions = this._mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind);
            this._meshVerticesNormals = this._mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
            this._meshIndices = this._mesh.getIndices();
            this._meshPositions = [];
            this._meshFacesNormals = [];
            if (this._meshVerticesPositions && this._meshVerticesNormals && this._meshIndices) {
                for (let index = 0; index < this._meshVerticesPositions.length; index += 3) {
                    this._meshPositions.push(new BABYLON.Vector3(this._meshVerticesPositions[index], this._meshVerticesPositions[index + 1], this._meshVerticesPositions[index + 2]));
                }
                for (let index = 0; index < this._mesh.getTotalIndices() / 3; index++) {
                    this._computeFaceNormal(index);
                }
                this._getFacesOfVertices();
            }
        }
    }
    _getFaceVerticesIndex(faceID) {
        if (this._meshIndices) {
            return {
                v1: this._meshIndices[faceID * 3],
                v2: this._meshIndices[faceID * 3 + 1],
                v3: this._meshIndices[faceID * 3 + 2]
            };
        }
        return null;
    }
    // La normale ad una faccia è calcolata come prodotto vettoriale (cross product)
    // tra i vettori che connettono gli spigoli
    _computeFaceNormal(face) {
        if (this._meshPositions && this._meshIndices && this._meshFacesNormals) {
            const faceInfo = this._getFaceVerticesIndex(face);
            if (faceInfo) {
                const v1v2 = this._meshPositions[faceInfo.v1].subtract(this._meshPositions[faceInfo.v2]);
                const v3v2 = this._meshPositions[faceInfo.v3].subtract(this._meshPositions[faceInfo.v2]);
                this._meshFacesNormals[face] = BABYLON.Vector3.Normalize(BABYLON.Vector3.Cross(v1v2, v3v2));
            }
        }
    }
    _getPositionKey(vector) {
        return `${vector.x}_${vector.y}_${vector.z}`;
    }
    // Determina le facce di ogni vertice sia considerando vertici uguali ripetuti più volte (_facesOfVertices)
    // che quelle condivise da uno stesso vertice ripetuto (_sharedFacesOfVertices). Queste ultime saranno
    // quelle che verranno considerate per il calcolo della normale risultante da tutte le facce che hanno
    // un vertice come spigolo.
    _getFacesOfVertices() {
        if (this._mesh && this._meshPositions && this._meshIndices) {
            this._sharedFacesOfVertices = {};
            this._facesOfVertices = [];
            for (let index = 0; index < this._meshPositions.length; index++) {
                this._facesOfVertices[index] = [];
                const position = this._meshPositions[index];
                const key = this._getPositionKey(position);
                if (!this._sharedFacesOfVertices.hasOwnProperty(key))
                    this._sharedFacesOfVertices[key] = new Set();
            }
            for (let index = 0; index < this._meshIndices.length; index++) {
                const vertexIndex = this._meshIndices[index];
                const faceID = index / 3 | 0;
                this._facesOfVertices[vertexIndex].push(faceID);
                const position = this._meshPositions[vertexIndex];
                const key = this._getPositionKey(position);
                if (this._sharedFacesOfVertices.hasOwnProperty(key))
                    this._sharedFacesOfVertices[key].add(faceID);
            }
        }
    }
    expandMesh(mesh, delta = 0.01) {
        if (mesh instanceof BABYLON.Mesh) {
            this._mesh = mesh;
            this._scene = mesh.getScene();
            this.prepareDataModel();
            if (this._meshPositions && this._meshVerticesPositions && this._meshVerticesNormals) {
                for (let index = 0; index < this._meshPositions.length; index++) {
                    const position = this._meshPositions[index];
                    // Qui avviene lo spostamento vero e proprio del vertice lungo la normale
                    const normal = this._getVertexComputedNormal(index);
                    if (normal) {
                        const scaledNormal = normal.scale(delta);
                        position.addInPlace(scaledNormal);
                        this._meshVerticesPositions[index * 3] = position.x;
                        this._meshVerticesPositions[index * 3 + 1] = position.y;
                        this._meshVerticesPositions[index * 3 + 2] = position.z;
                    }
                }
                //this._reComputeNormals();
                this._mesh.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.PositionKind, true);
                //this._mesh.markVerticesDataAsUpdatable(BABYLON.VertexBuffer.NormalKind, true);
                this._mesh.updateVerticesData(BABYLON.VertexBuffer.PositionKind, this._meshVerticesPositions);
                //this._mesh.updateVerticesData(BABYLON.VertexBuffer.NormalKind, this._meshVerticesNormals);
                this._mesh.computeWorldMatrix(true);
            }
        }
    }
    _reComputeNormals() {
        const faces = [];
        if (this._meshPositions && this._facesOfVertices) {
            for (let vertexIndex = 0; vertexIndex < this._meshPositions.length; vertexIndex++) {
                const faceOfVertices = this._facesOfVertices[vertexIndex];
                for (let index = 0; index < faceOfVertices.length; index++) {
                    faces[faceOfVertices[index]] = true;
                }
            }
            let face;
            for (face in faces) {
                this._computeFaceNormal(face);
            }
            for (face in faces) {
                const faceInfo = this._getFaceVerticesIndex(face);
                if (faceInfo) {
                    this._computeNormal(faceInfo.v1);
                    this._computeNormal(faceInfo.v2);
                    this._computeNormal(faceInfo.v3);
                }
            }
        }
    }
    _getVertexComputedNormal(vertexIndex) {
        let normal = null;
        if (this._meshPositions && this._meshFacesNormals) {
            const meshPositions = this._meshPositions;
            const meshFacesNormals = this._meshFacesNormals;
            const position = meshPositions[vertexIndex];
            const key = this._getPositionKey(position);
            if (this._sharedFacesOfVertices.hasOwnProperty(key)) {
                const faces = this._sharedFacesOfVertices[key];
                normal = BABYLON.Vector3.Zero();
                faces.forEach(faceID => {
                    const faceNormal = meshFacesNormals[faceID];
                    if (normal && faceNormal) {
                        normal = normal.add(faceNormal);
                    }
                });
                normal = BABYLON.Vector3.Normalize(normal.scale(1 / faces.size));
            }
        }
        return normal;
    }
    _computeNormal(vertexIndex) {
        const normal = this._getVertexComputedNormal(vertexIndex);
        if (normal && this._meshVerticesNormals) {
            this._meshVerticesNormals[vertexIndex * 3] = normal.x;
            this._meshVerticesNormals[vertexIndex * 3 + 1] = normal.y;
            this._meshVerticesNormals[vertexIndex * 3 + 2] = normal.z;
        }
    }
}


/***/ }),

/***/ "../../3D/src/Components/NormalMap/ProceduralNormalMap.ts":
/*!****************************************************************!*\
  !*** ../../3D/src/Components/NormalMap/ProceduralNormalMap.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ProceduralNormalMap": () => (/* binding */ ProceduralNormalMap)
/* harmony export */ });
/* harmony import */ var _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ProceduralTextures/BlurXProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurXProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ProceduralTextures/BlurYProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurYProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_NormalMapProceduralTexture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ProceduralTextures/NormalMapProceduralTexture */ "../../3D/src/Components/ProceduralTextures/NormalMapProceduralTexture.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



class ProceduralNormalMap {
    constructor(baseTexture, size, config, scene) {
        this._bias = 50.0;
        this._invertR = false;
        this._invertG = false;
        this._preBlurEnabled = false;
        this._preBlur = 3;
        this._postBlurEnabled = false;
        this._postBlur = 3;
        this._bevel = true;
        this._intensity = 0.5;
        this._activeTextures = [];
        this._preBlurXTexture = null;
        this._preBlurYTexture = null;
        this._normalMapTexture = null;
        this._postBlurXTexture = null;
        this._postBlurYTexture = null;
        this._baseTexture = baseTexture;
        this._size = size;
        this._scene = scene;
        this.init(config);
    }
    init(config) {
        this._bias = config.get("bias");
        this._invertR = config.get("invertR");
        this._invertG = config.get("invertG");
        this._bevel = config.get("bevel");
        this._intensity = config.get("intensity");
        this._preBlurEnabled = config.get("preBlurEnabled");
        this._preBlur = config.get("preBlur");
        this._postBlurEnabled = config.get("postBlurEnabled");
        this._postBlur = config.get("postBlur");
        while (this._activeTextures.length > 0) {
            this._activeTextures.pop();
        }
        this.updateTextures();
    }
    updateTextures() {
        let texture = this.updatePreBlurTexture();
        texture = this.updateNormalmapTexture(texture);
        texture = this.updatePostBlurTexture(texture);
    }
    updatePreBlurTexture() {
        let resultTexture = this._baseTexture;
        if (this._preBlurEnabled) {
            if (!this._preBlurXTexture)
                this._preBlurXTexture = new _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BlurXProceduralTexture("preBlurX", this._size, this._scene, this._baseTexture, undefined, false);
            else
                this._preBlurXTexture.baseTexture = this._baseTexture;
            this._preBlurXTexture.beginInit();
            this._preBlurXTexture.blur = this._preBlur;
            this._preBlurXTexture.refreshRate = 0;
            this._preBlurXTexture.endInit();
            this._activeTextures.push(this._preBlurXTexture);
            if (!this._preBlurYTexture)
                this._preBlurYTexture = new _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_1__.BlurYProceduralTexture("preBlurY", this._size, this._scene, this._preBlurXTexture, undefined, false);
            else
                this._preBlurYTexture.baseTexture = this._preBlurXTexture;
            this._preBlurYTexture.beginInit();
            this._preBlurYTexture.blur = this._preBlur;
            this._preBlurYTexture.refreshRate = 0;
            this._preBlurYTexture.endInit();
            this._activeTextures.push(this._preBlurYTexture);
            resultTexture = this._preBlurYTexture;
        }
        return resultTexture;
    }
    updateNormalmapTexture(baseTexture) {
        if (!this._normalMapTexture)
            this._normalMapTexture = new _ProceduralTextures_NormalMapProceduralTexture__WEBPACK_IMPORTED_MODULE_2__.NormalMapProceduralTexture("procNormal", this._size, this._scene, baseTexture, undefined, false);
        else
            this._normalMapTexture.baseTexture = baseTexture;
        this._normalMapTexture.beginInit();
        this._normalMapTexture.bias = this._bias;
        this._normalMapTexture.invertR = this._invertR;
        this._normalMapTexture.invertG = this._invertG;
        this._normalMapTexture.bevel = this._bevel;
        this._normalMapTexture.intensity = this._intensity;
        this._normalMapTexture.refreshRate = 0;
        this._normalMapTexture.endInit();
        this._activeTextures.push(this._normalMapTexture);
        return this._normalMapTexture;
    }
    updatePostBlurTexture(baseTexture) {
        let resultTexture = baseTexture;
        if (this._postBlurEnabled) {
            if (!this._postBlurXTexture)
                this._postBlurXTexture = new _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BlurXProceduralTexture("postBlurX", this._size, this._scene, baseTexture, undefined, false);
            else
                this._postBlurXTexture.baseTexture = baseTexture;
            if (this._postBlurXTexture) {
                this._postBlurXTexture.beginInit();
                this._postBlurXTexture.blur = this._postBlur;
                this._postBlurXTexture.refreshRate = 0;
                this._postBlurXTexture.endInit();
                this._activeTextures.push(this._postBlurXTexture);
                if (!this._postBlurYTexture)
                    this._postBlurYTexture = new _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_1__.BlurYProceduralTexture("postBlurY", this._size, this._scene, this._postBlurXTexture, undefined, false);
                else
                    this._postBlurYTexture.baseTexture = this._postBlurXTexture;
                if (this._postBlurYTexture) {
                    this._postBlurYTexture.beginInit();
                    this._postBlurYTexture.blur = this._postBlur;
                    this._postBlurYTexture.refreshRate = 0;
                    this._postBlurYTexture.endInit();
                    this._activeTextures.push(this._postBlurYTexture);
                    resultTexture = this._postBlurYTexture;
                }
            }
        }
        return resultTexture;
    }
    dispose() {
        if (this._preBlurXTexture) {
            this._preBlurXTexture.dispose();
            this._preBlurXTexture = null;
        }
        if (this._preBlurYTexture) {
            this._preBlurYTexture.dispose();
            this._preBlurYTexture = null;
        }
        if (this._normalMapTexture) {
            this._normalMapTexture.dispose();
            this._normalMapTexture = null;
        }
        if (this._postBlurXTexture) {
            this._postBlurXTexture.dispose();
            this._postBlurXTexture = null;
        }
        if (this._postBlurYTexture) {
            this._postBlurYTexture.dispose();
            this._postBlurYTexture = null;
        }
    }
    getNormalMapTextureAsync(baseTexture, config) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateAsync(baseTexture, config);
            if (this._activeTextures.length > 0)
                return this._activeTextures[this._activeTextures.length - 1];
            return null;
        });
    }
    updateAsync(baseTexture, config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.init(config);
            if (this._activeTextures.length > 0) {
                this._activeTextures[0].baseTexture = baseTexture;
                for (var i = 0; i < this._activeTextures.length; i++) {
                    yield this._activeTextures[i].isReadyAsync();
                    this._activeTextures[i].render();
                }
            }
        });
    }
}


/***/ }),

/***/ "../../3D/src/Components/Preview3D/Preview3DConfigurationManager.ts":
/*!**************************************************************************!*\
  !*** ../../3D/src/Components/Preview3D/Preview3DConfigurationManager.ts ***!
  \**************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Preview3DConfigurationManager": () => (/* binding */ Preview3DConfigurationManager)
/* harmony export */ });
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");

class Preview3DConfigurationManager {
    constructor(zkModel, zkScene, scene) {
        this._zkModel = zkModel;
        this._zkScene = zkScene;
        this._scene = scene;
        this._sceneHelper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper(scene);
    }
    // restituisce tutti materiali della scena per cui è possibile specificare se sono
    // variabili o meno in base alle varianti del prodotto. Da tale elenco verranno esclusi
    // tutti i materiali che sono stati già clonati per rappresentare la variazione.
    // verranno esclusi anche tutti i materiali che comunque sono stati marcati (metadata)
    // come materiali creati ad hoc per una preview di prodotto (isForPreview = true)
    // e verranno esclusi tutti i materiali non assegnati a nessuna mesh. 
    // Verranno considerati quindi tutti i materiali non clonati assegnati ad almeno una mesh (direttamente
    // o indirettamente)
    getPossibleVariableMaterials() {
        const allMaterials = this._sceneHelper.getAllMaterials();
        const variableMaterials = [];
        for (let i = 0; i < allMaterials.length; i++) {
            const material = allMaterials[i];
            const meshes = this.getMeshesUsingMaterial(material.id);
            const isForVariant = this.isSceneMaterialForVariant(material);
            if (meshes.length > 0 && !isForVariant) {
                variableMaterials.push(material);
            }
        }
        return variableMaterials;
        /*
        const allMaterials: BABYLON.Material[] = this._sceneHelper.getAllMaterials();
        const preview3D = this._zkModel.getPreview3D();
        if (preview3D) {
            const variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
            if (variantsAttributeOptions) {
                const optionsMaterials = variantsAttributeOptions.getOptionsMaterialIDs();
                for (let i = 0; i < allMaterials.length; i++) {
                    let material = allMaterials[i];
                    if (optionsMaterials.indexOf(material.id) !== -1 ||
                        this.isSceneMaterialForVariant(material))
                        allMaterials.splice(i--, 1);
                }
            }
        }
        return allMaterials;
        */
    }
    // Restituisce l'elenco dei materiali della scena già selezionati come variabili
    getVariableMaterials() {
        const materials = [];
        const preview3D = this._zkModel.getPreview3D();
        if (preview3D) {
            const variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
            if (variantsAttributeOptions) {
                for (let i = 0; i < variantsAttributeOptions.get("variableMaterials").length; i++) {
                    let materialID = variantsAttributeOptions.get("variableMaterials").at(i).get("materialID");
                    let material = this._scene.getMaterialByID(materialID);
                    if (material)
                        materials.push(material);
                }
            }
        }
        return materials;
    }
    getVariableMaterialsSelection() {
        const variableMaterials = this.getVariableMaterials();
        const variableMaterialsIds = variableMaterials.map(m => m.id);
        const allMaterials = this.getPossibleVariableMaterials();
        const selection = allMaterials.map(m => {
            return {
                id: m.id,
                name: m.name,
                selected: variableMaterialsIds.indexOf(m.id) != -1
            };
        });
        return selection;
    }
    getVariantMaterialsWithOriginal(modelColor) {
        const materials = [];
        const preview3D = this._zkModel.getPreview3D();
        if (preview3D && modelColor && modelColor instanceof MPlaza.Color) {
            const variantID = this.getVariantID(modelColor);
            const variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
            if (variantsAttributeOptions) {
                const variantOption = variantsAttributeOptions.getVariantOption(variantID);
                if (variantOption) {
                    for (let i = 0; i < variantOption.get("materials").length; i++) {
                        const variantOptionMaterial = variantOption.get("materials").at(i);
                        const materialID = variantOptionMaterial.get("optionMaterialID");
                        const material = this._scene.getMaterialByID(materialID);
                        const variableMaterialID = variantOptionMaterial.get("variableMaterialID");
                        const variableMaterial = this._scene.getMaterialByID(variableMaterialID);
                        if (material && variableMaterial)
                            materials.push({ material, variableMaterial });
                    }
                }
            }
        }
        return materials;
    }
    // Per tutti i materiali impostati come variabili, verifica che questi materiali esistano ancora.
    // Se un materiale esiste, aggiorna l'indicazione delle mesh alle quali è impostato e le azioni per opzione.
    // Se un materiale non esiste, lo elimina tra i materiali variabili.
    updateVariableMaterials() {
        const preview3D = this._zkModel.getPreview3D();
        if (preview3D) {
            const variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
            if (variantsAttributeOptions) {
                const materialsToSet = [];
                const materialsToUnset = [];
                for (let i = 0; i < variantsAttributeOptions.get("variableMaterials").length; i++) {
                    const variableMaterial = variantsAttributeOptions.get("variableMaterials").at(i);
                    const materialID = variableMaterial.get("materialID");
                    let material = this._scene.getMaterialByID(materialID);
                    if (material)
                        materialsToSet.push(materialID);
                    else
                        materialsToUnset.push(materialID);
                }
                materialsToSet.forEach(id => this.setVariableMaterialID(id));
                materialsToUnset.forEach(id => this.unsetVariableMaterialID(id));
            }
        }
    }
    // Imposta un materiale come NON variabile per variante. Questo significa che vanno eliminate
    // tutte le eventuali azioni relative al materiale ed eventualmente le opzioni
    unsetVariableMaterialID(materialID) {
        const preview3D = this._zkModel.getPreview3D();
        if (preview3D) {
            const variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
            if (variantsAttributeOptions) {
                const attribute = this._zkModel.getAttributeByGuid(variantsAttributeOptions.get("attributeGuid"));
                // ripristino il materiale originale sulle mesh di riferimento
                const variableMaterial = variantsAttributeOptions.get("variableMaterials").getVariableMaterial(materialID);
                if (variableMaterial) {
                    const material = this._scene.getMaterialByID(materialID);
                    if (material) {
                        for (let i = 0; i < variableMaterial.get("meshes").length; i++) {
                            const mesh = this._scene.getMeshByID(variableMaterial.get("meshes")[i]);
                            if (mesh)
                                this._sceneHelper.applyMaterial(material, mesh);
                        }
                    }
                }
                // elimino dall'elenco dei materiali variabili
                variantsAttributeOptions.removeVariableMaterial(materialID);
                // elimino tutte le azioni, opzione per opzione
                const variantOptionsToRemove = [];
                for (let i = 0; i < variantsAttributeOptions.get("variantOptions").length; i++) {
                    const variantOption = variantsAttributeOptions.get("variantOptions").at(i);
                    let option = null;
                    if (attribute)
                        option = attribute.getOptionByGuid(variantOption.get("optionGuid"));
                    const variantOptionMaterialsToRemove = [];
                    for (let j = 0; j < variantOption.get("materials").length; j++) {
                        const variantOptionMaterial = variantOption.get("materials").at(j);
                        if (variantOptionMaterial.get("variableMaterialID") === materialID) {
                            for (let k = 0; k < variantOptionMaterial.get("actions").length; k++) {
                                const variantOptionMaterialAction = variantOptionMaterial.get("actions").at(k);
                                if (option) {
                                    const action = option.get("actions").getActionByGuid(variantOptionMaterialAction.get("actionGuid"));
                                    if (action)
                                        option.get("actions").remove(action);
                                }
                            }
                            // Elimino il materiale creato proprio per l'azione dell'opzione
                            this.deleteSceneMaterial(variantOptionMaterial.get("optionMaterialID"));
                            variantOptionMaterialsToRemove.push(variantOptionMaterial);
                        }
                    }
                    variantOption.get("materials").remove(variantOptionMaterialsToRemove);
                    if (variantOption.get("materials").length === 0) {
                        variantOptionsToRemove.push(variantOption);
                    }
                }
                for (let i = 0; i < variantOptionsToRemove.length; i++)
                    this.removeVariantOption(variantsAttributeOptions, variantOptionsToRemove[i]);
            }
        }
    }
    // Imposta un materiale come variabile. Vengono generati i materiali cloni per le varie opzioni
    // e create le azioni di trasformazione della scena che impostano il materiale sulle varie mesh
    setVariableMaterialID(materialID) {
        const material = this._scene.getMaterialByID(materialID);
        if (material) {
            const meshes = this.getMeshesUsingMaterial(material.id);
            const meshIDs = meshes.map(m => m.id);
            const preview3D = this._zkModel.getOrCreatePreview3D();
            const variantsAttributeOptions = preview3D.getOrCreateVariantsAttributeOptions();
            const attribute = this.getOrCreateVariantAttribute(variantsAttributeOptions);
            // Imposto l'elenco delle mesh che hanno il materiale in questione
            variantsAttributeOptions.setVariableMaterial(materialID, meshIDs);
            // Variante per variante verifico l'opzione associata
            const variantIDs = [];
            for (let i = 0; i < this._zkModel.get("colors").length; i++) {
                const modelColor = this._zkModel.get("colors").at(i);
                const variantID = this.getVariantID(modelColor);
                variantIDs.push(variantID);
                this.checkVariantOption(variantsAttributeOptions, material, meshes, modelColor);
            }
            // elimino le opzioni associate a varianti non più esistenti
            for (let i = 0; i < variantsAttributeOptions.get("variantOptions").length; i++) {
                const variantOption = variantsAttributeOptions.get("variantOptions").at(i);
                if (variantIDs.indexOf(variantOption.get("variantID")) === -1)
                    this.removeVariantOption(variantsAttributeOptions, variantOption);
            }
        }
    }
    checkVariantOption(variantsAttributeOptions, material, meshes, modelColor) {
        const variantID = this.getVariantID(modelColor);
        let variantOption = variantsAttributeOptions.get("variantOptions").getVariantOption(variantID);
        if (!variantOption) {
            variantOption = this.createVariantOption(variantsAttributeOptions, modelColor);
        }
        this.checkVariantOptionMaterial(variantsAttributeOptions, variantOption, material, meshes, modelColor);
    }
    createVariantOption(variantsAttributeOptions, modelColor) {
        const variantID = this.getVariantID(modelColor);
        const attribute = this.getOrCreateVariantAttribute(variantsAttributeOptions);
        const option = this.getOrCreateVariantAttributeOption(variantsAttributeOptions, modelColor, attribute);
        const variantOption = new MPlaza.VariantOption();
        variantOption.set("variantID", variantID);
        variantOption.set("optionGuid", option.get("optionGuid"));
        variantsAttributeOptions.get("variantOptions").push(variantOption);
        return variantOption;
    }
    removeVariantOption(variantsAttributeOptions, variantOption) {
        // Elimino l'opzione dall'attributo
        const attribute = this._zkModel.getAttributeByGuid(variantsAttributeOptions.get("attributeGuid"));
        if (attribute) {
            const option = attribute.getOptionByGuid(variantOption.get("optionGuid"));
            if (option) {
                attribute.get("options").remove(option);
            }
        }
        // Elimino i materiali clonati dalla scena
        for (let i = 0; i < variantOption.get("materials").length; i++) {
            const variantOptionMaterial = variantOption.get("materials").at(i);
            const materialID = variantOptionMaterial.get("optionMaterialID");
            this.deleteSceneMaterial(materialID);
        }
        variantsAttributeOptions.get("variantOptions").remove(variantOption);
    }
    getOrCreateVariantAttribute(variantsAttributeOptions) {
        let attribute = null;
        if (variantsAttributeOptions.get("attributeGuid"))
            attribute = this._zkModel.getAttributeByGuid(variantsAttributeOptions.get("attributeGuid"));
        if (!attribute) {
            // verifico se già esite un attributo con codice variants_attribute
            attribute = this._zkModel.get("attributes").getAttributeByCode("variants_attribute");
        }
        if (!attribute) {
            // Per forza di cose elimino tutte le eventuali opzioni esistenti (non dovrebbero essercene)
            for (let i = 0; i < variantsAttributeOptions.get("variantOptions").length; i++) {
                this.removeVariantOption(variantsAttributeOptions, variantsAttributeOptions.get("variantOptions").at(i));
            }
            attribute = new MPlaza.Attribute();
            attribute.set("attributeGuid", MPlaza.generateUUID());
            attribute.set("name", "Variants attribute");
            attribute.set("attributeCode", "variants_attribute");
            attribute.set("attributeTypeID", MPlaza.AttributeType.Options);
            variantsAttributeOptions.set("attributeGuid", attribute.get("attributeGuid"));
            this._zkModel.get("attributes").push(attribute);
        }
        return attribute;
    }
    getOrCreateVariantAttributeOption(variantsAttributeOptions, modelColor, attribute) {
        const variantID = this.getVariantID(modelColor);
        let option = attribute.getOptionByCode(variantID);
        if (!option) {
            option = new MPlaza.AttributeOption();
            option.set("optionCode", variantID);
            option.set("name", modelColor.get("name"));
            attribute.get("options").push(option);
        }
        return option;
    }
    getVariantID(modelColor) {
        return `${modelColor.getModelID()}_${modelColor.getColorID()}`;
    }
    checkVariantOptionMaterial(variantsAttributeOptions, variantOption, material, meshes, modelColor) {
        const variantID = this.getVariantID(modelColor);
        let variantOptionMaterial = null;
        for (let i = 0; i < variantOption.get("materials").length; i++) {
            const mat = variantOption.get("materials").at(i);
            if (mat.get("variableMaterialID") === material.id) {
                variantOptionMaterial = mat;
                break;
            }
        }
        if (!variantOptionMaterial) {
            // verifico se esiste nella scena già un materiale predisposto per la variante
            // questo perme di creare un materiale manualmente ed utilizzarlo come materiale di variante,
            // ovviamente impostato opportunamente i metadati del materiale
            let optionMaterial = this.getSceneMaterialForVariant(variantID, material.id);
            if (!optionMaterial) {
                // creo il materiale per l'opzione come clone del material passato
                const name = `${material.name} - ${modelColor.get("name")}`;
                optionMaterial = this.cloneSceneMaterial(material.id, undefined, name);
                if (optionMaterial)
                    this.setupSceneMaterialForVariant(optionMaterial, variantID, material.id);
            }
            if (optionMaterial) {
                variantOptionMaterial = new MPlaza.VariantOptionMaterial();
                variantOptionMaterial.set("optionMaterialID", optionMaterial.id);
                variantOptionMaterial.set("variableMaterialID", material.id);
                variantOption.get("materials").push(variantOptionMaterial);
            }
        }
        if (variantOptionMaterial)
            this.checkVariantOptionActions(variantsAttributeOptions, variantOption, variantOptionMaterial, material, meshes, modelColor);
    }
    // Una materiale creato per una variante viene marcato con dei metadati. Questo significa che i materiali creati in altro modo
    // e con i materiali giusti verrano riconosciuti e utilizzati per le azioni delle opzioni
    setupSceneMaterialForVariant(material, variantID, variableMaterialID) {
        const metadata = this.getOrCreateSceneMaterialMetadata(material.id);
        metadata.isForPreview = true;
        metadata.autoCreate = true;
        metadata.variantID = variantID;
        metadata.variableMaterialID = variableMaterialID;
    }
    getSceneMaterialForVariant(variantID, variableMaterialID) {
        const materials = this._sceneHelper.getAllMaterials();
        for (let i = 0; i < materials.length; i++) {
            const material = materials[i];
            const metadata = this.getSceneMaterialMetadata(material.id);
            if (metadata &&
                metadata.isForPreview &&
                metadata.variantID === variantID &&
                metadata.variableMaterialID === variableMaterialID) {
                return materials[i];
            }
        }
        return null;
    }
    isSceneMaterialForVariant(material) {
        if (!material)
            return false;
        const metadata = this.getSceneMaterialMetadata(material.id);
        return metadata && metadata.isForPreview;
    }
    canDeleteSceneMaterialForVariant(material) {
        if (!material)
            return false;
        const metadata = this.getSceneMaterialMetadata(material.id);
        if (!metadata)
            return true;
        if (metadata.isForPreview === undefined || metadata.isForPreview === null)
            return true;
        if (metadata.autoCreate === undefined || metadata.autoCreate === null)
            return true;
        return metadata.isForPreview && metadata.autoCreate;
    }
    getSceneMaterialMetadata(materialID) {
        return this._sceneHelper.getSceneMaterialMetadata(materialID);
    }
    getOrCreateSceneMaterialMetadata(materialID) {
        return this._sceneHelper.getOrCreateSceneMaterialMetadata(materialID);
    }
    removeSceneMaterialMetadata(materialID) {
        this._sceneHelper.removeSceneMaterialMetadata(materialID);
    }
    // Clona un materiale
    cloneSceneMaterial(id, newId, newName) {
        let material = this._scene.getMaterialByID(id);
        let newMaterial = null;
        if (material) {
            const materialName = newName || `${material.name} - clone`;
            newMaterial = material.clone(materialName);
            if (newMaterial) {
                const materialId = newId || MPlaza.generateUUID();
                newMaterial.id = materialId;
                // Verifico se il materiale originario deriva da un materiale di libreria.
                // Nel caso, devo impostare il mapping in modo da copiare anche le relative textures
                const mapping = this._zkScene.getMappingForSceneMaterial(material.id);
                if (mapping) {
                    const libraryMaterialID = mapping.get("libraryMaterialID");
                    this._zkScene.mapLibraryMaterial(libraryMaterialID, newMaterial.id);
                    const textures = this._sceneHelper.getTexturesForMaterial(newMaterial);
                    for (let i = 0; i < textures.length; i++) {
                        let texture = textures[i];
                        texture["materialMapping"] = { libraryMaterialID: libraryMaterialID, sceneMaterialID: newMaterial.id };
                    }
                }
            }
        }
        return newMaterial;
    }
    deleteSceneMaterial(materialID) {
        const material = this._scene.getMaterialByID(materialID);
        if (material && this.canDeleteSceneMaterialForVariant(material)) {
            this.removeSceneMaterialMetadata(materialID);
            const libraryMaterialID = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(materialID);
            if (libraryMaterialID)
                this._zkScene.unregisterShaderMaterial(libraryMaterialID);
            this._zkScene.removeMappingForSceneMaterial(material.id);
            const textures = this._sceneHelper.getTexturesExclusivelyForMaterial(material);
            material.dispose();
            for (let i = 0; i < textures.length; i++)
                textures[i].dispose();
        }
    }
    checkVariantOptionActions(variantsAttributeOptions, variantOption, variantOptionMaterial, material, meshes, modelColor) {
        // verifico che ci siano tutte e solo le azioni per le mesh
        let meshIDs = [];
        meshes.forEach(m => meshIDs.push(m.id));
        let attribute = this.getOrCreateVariantAttribute(variantsAttributeOptions);
        let option = this.getOrCreateVariantAttributeOption(variantsAttributeOptions, modelColor, attribute);
        for (let i = 0; i < meshes.length; i++) {
            let mesh = meshes[i];
            let variantOptionMaterialAction = variantOptionMaterial.get("actions").getActionForMesh(mesh.id);
            if (!variantOptionMaterialAction) {
                // creo l'azione
                let action = new MPlaza.AttributeSceneAction();
                action.set("name", "");
                action.set("actionTypeID", MPlaza.SceneActionType.SetMeshMaterial);
                action.set("sceneElementTypeID", MPlaza.SceneElementType.Mesh);
                action.set("selector", mesh.id);
                action.set("value", variantOptionMaterial.get("optionMaterialID"));
                option.get("actions").push(action);
                variantOptionMaterialAction = new MPlaza.VariantOptionMaterialAction();
                variantOptionMaterialAction.set("actionGuid", action.get("actionGuid"));
                variantOptionMaterialAction.set("meshID", mesh.id);
                variantOptionMaterial.get("actions").push(variantOptionMaterialAction);
            }
        }
        // Elimino le azioni sulle mesh che non usano più il materiale dell'opzione
        let actionsToRemove = [];
        for (let i = 0; i < variantOptionMaterial.get("actions").length; i++) {
            let variantOptionMaterialAction = variantOptionMaterial.get("actions").at(i);
            if (meshIDs.indexOf(variantOptionMaterialAction.get("meshID")) === -1) {
                // elimino l'azione tra quelle dell'opzione
                let action = option.getActionByGuid(variantOptionMaterialAction.get("actionGuid"));
                if (action) {
                    option.get("actions").remove(action);
                }
                actionsToRemove.push(variantOptionMaterialAction);
            }
        }
        variantOptionMaterial.get("actions").remove(actionsToRemove);
    }
    getVariantMaterials(modelColor) {
        let materials = [];
        const preview3D = this._zkModel.getPreview3D();
        if (preview3D && modelColor && modelColor instanceof MPlaza.Color) {
            const variantID = this.getVariantID(modelColor);
            const variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
            if (variantsAttributeOptions) {
                const variantOption = variantsAttributeOptions.getVariantOption(variantID);
                if (variantOption) {
                    for (let i = 0; i < variantOption.get("materials").length; i++) {
                        const variantOptionMaterial = variantOption.get("materials").at(i);
                        const materialID = variantOptionMaterial.get("optionMaterialID");
                        const material = this._scene.getMaterialByID(materialID);
                        if (material)
                            materials.push(material);
                    }
                }
            }
        }
        return materials;
    }
    getSelectedAttributeOption(selectedModelColor) {
        let res = {
            attributeID: null,
            attributeGuid: null,
            optionID: null,
            optionGuid: null
        };
        const preview3D = this._zkModel.getPreview3D();
        if (preview3D && selectedModelColor && selectedModelColor instanceof MPlaza.Color) {
            const variantID = this.getVariantID(selectedModelColor);
            const variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
            if (variantsAttributeOptions && variantsAttributeOptions.get("attributeGuid")) {
                const attribute = this._zkModel.getAttributeByGuid(variantsAttributeOptions.get("attributeGuid"));
                if (attribute) {
                    const variantOption = variantsAttributeOptions.getVariantOption(variantID);
                    if (variantOption) {
                        const option = attribute.getOptionByGuid(variantOption.get("optionGuid"));
                        if (option) {
                            res.attributeID = attribute.get("attributeID");
                            res.attributeGuid = attribute.get("attributeGuid");
                            res.optionID = option.get("optionID");
                            res.optionGuid = option.get("optionGuid");
                        }
                    }
                }
            }
        }
        return res;
    }
    resetOriginaMaterialsOnMeshes() {
        const preview3D = this._zkModel.getPreview3D();
        if (preview3D) {
            const variantsAttributeOptions = preview3D.getVariantsAttributeOptions();
            if (variantsAttributeOptions) {
                for (let i = 0; i < variantsAttributeOptions.get("variableMaterials").length; i++) {
                    const variableMaterial = variantsAttributeOptions.get("variableMaterials").at(i);
                    const materialID = variableMaterial.get("materialID");
                    const meshes = variableMaterial.get("meshes");
                    const material = this._scene.getMaterialByID(materialID);
                    if (material) {
                        for (let j = 0; j < meshes.length; j++) {
                            const mesh = this._scene.getMeshByID(variableMaterial.get("meshes")[j]);
                            if (mesh)
                                this._sceneHelper.applyMaterial(material, mesh);
                        }
                    }
                }
            }
        }
    }
    // Una mesh usa un materiale se sulla mesh è impostato direttamente quel materiale o se sulla mesh è
    // attualmente impostato un materiale creato ad hoc per la preview 3D e che deriva dal materiale in oggetto (clone)
    getMeshesUsingMaterial(materialID) {
        const meshes = [];
        const allMeshes = this._sceneHelper.getSceneMeshes();
        for (let i = 0; i < allMeshes.length; i++) {
            const mesh = allMeshes[i];
            if (this._sceneHelper.isMeshUsingMaterial(mesh, materialID)) {
                meshes.push(mesh);
            }
            else {
                const meshMaterials = this._sceneHelper.getMeshMaterials(mesh);
                for (let j = 0; j < meshMaterials.length; j++) {
                    const meshMaterial = meshMaterials[j];
                    const metadata = this.getSceneMaterialMetadata(meshMaterial.id);
                    if (metadata && metadata.isForPreview &&
                        metadata.variableMaterialID &&
                        metadata.variableMaterialID === materialID) {
                        meshes.push(mesh);
                        break;
                    }
                }
            }
        }
        return meshes;
    }
}


/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts":
/*!***************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BaseProceduralTexture": () => (/* binding */ BaseProceduralTexture)
/* harmony export */ });
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");

class BaseProceduralTexture extends BABYLON.ProceduralTexture {
    constructor(name, size, fragment, scene, baseTexture, fallbackTexture, generateMipMaps) {
        super(name, size, fragment, scene, fallbackTexture, generateMipMaps);
        this._initializing = false;
        this._baseTexture = baseTexture;
        this.updateShaderUniforms();
    }
    get initializing() {
        return this._initializing;
    }
    get baseTexture() {
        return this._baseTexture;
    }
    set baseTexture(texture) {
        this._baseTexture = texture;
        this.updateShaderUniforms();
    }
    isReadyAsync() {
        return _SceneHelper__WEBPACK_IMPORTED_MODULE_0__.SceneHelper.whenTextureIsReadyAsync(this);
    }
    dispose() {
        super.dispose();
        if (this._baseTexture)
            this._baseTexture.dispose();
    }
    beginInit() {
        this._initializing = true;
    }
    endInit() {
        this._initializing = false;
        this.updateShaderUniforms();
    }
    updateShaderUniforms() {
        if (this._initializing)
            return;
        this.setBaseTextureUniform();
    }
    setBaseTextureUniform() {
        this.setTexture("uSampler", this._baseTexture);
    }
}


/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/BlendProceduralTexture.ts":
/*!****************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/BlendProceduralTexture.ts ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlendProceduralTexture": () => (/* binding */ BlendProceduralTexture)
/* harmony export */ });
class BlendProceduralTexture extends BABYLON.ProceduralTexture {
    constructor(name, size, scene = null, fallbackTexture, generateMipMaps) {
        super(name, size, BlendProceduralTexture.FRAGMENT_SHADER, scene, fallbackTexture, generateMipMaps);
        this._baseTexture = null;
        this._blendTexture = null;
        this.updateShaderUniforms();
    }
    dispose() {
        if (this._baseTexture)
            this._baseTexture.dispose();
        if (this._blendTexture)
            this._blendTexture.dispose();
    }
    updateShaderUniforms() {
        if (this._baseTexture) {
            this.setTexture("uSampler", this._baseTexture);
            this.setInt("hasSampler", 1);
            this.setVector2("uSamplerScale", new BABYLON.Vector2(this._baseTexture.uScale, this._baseTexture.vScale));
        }
        else {
            this.setInt("hasSampler", 0);
            this.setVector2("uSamplerScale", new BABYLON.Vector2(1, 1));
        }
        if (this._blendTexture) {
            this.setTexture("uBlendSampler", this._blendTexture);
            this.setInt("hasBlend", 1);
            this.setVector2("uBlendScale", new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale));
        }
        else {
            this.setInt("hasBlend", 0);
            this.setVector2("uBlendScale", new BABYLON.Vector2(1, 1));
        }
        this.setFloat("size", this.getRenderSize());
    }
    render(useCameraPostProcess) {
        super.render(useCameraPostProcess);
    }
    resize(size, generateMipMaps) {
        super.resize(size, generateMipMaps);
        // We need to update the "size" uniform
        this.updateShaderUniforms();
    }
    isReady() {
        /*
        if (!this._baseTexture || !this._baseTexture.isReady()) {
            return false;
        }
        */
        if (this._baseTexture && !this._baseTexture.isReady())
            return false;
        if (this._blendTexture && !this._blendTexture.isReady())
            return false;
        return super.isReady();
    }
    //@BABYLON.serializeAsTexture()
    get baseTexture() {
        return this._baseTexture;
    }
    set baseTexture(texture) {
        this._baseTexture = texture;
        this.updateShaderUniforms();
    }
    //@BABYLON.serializeAsTexture()
    get blendTexture() {
        return this._blendTexture;
    }
    set blendTexture(texture) {
        this._blendTexture = texture;
        this.updateShaderUniforms();
    }
    /**
     * Serializes this normal map procedural texture
     * @returns a serialized normal map procedural texture object
     */
    serialize() {
        var serializationObject = BABYLON.SerializationHelper.Serialize(this, super.serialize());
        serializationObject.customType = BlendProceduralTexture.CUSTOM_TYPE;
        if (this.baseTexture)
            serializationObject.baseTexture = this.baseTexture.serialize();
        else
            serializationObject.baseTexture = null;
        if (this.blendTexture)
            serializationObject.blendTexture = this.blendTexture.serialize();
        else
            serializationObject.blendTexture = null;
        return serializationObject;
    }
    /**
     * Creates a Normal Map Procedural Texture from parsed normal map procedural texture data
     * @param parsedTexture defines parsed texture data
     * @param scene defines the current scene
     * @param rootUrl defines the root URL containing normal map procedural texture information
     * @returns a parsed Normal Map Procedural Texture
     */
    static Parse(parsedTexture, scene, rootUrl) {
        var texture = BABYLON.SerializationHelper.Parse(() => new BlendProceduralTexture(parsedTexture.name, parsedTexture._size, scene, undefined, parsedTexture._generateMipMaps), parsedTexture, scene, rootUrl);
        if (parsedTexture.baseTexture)
            texture.baseTexture = BABYLON.Texture.Parse(parsedTexture.baseTexture, scene, rootUrl);
        if (parsedTexture.blendTexture)
            texture.blendTexture = BABYLON.Texture.Parse(parsedTexture.blendTexture, scene, rootUrl);
        return texture;
    }
}
BlendProceduralTexture.FRAGMENT_SHADER = "zakeke_BlendProceduralTexture";
BlendProceduralTexture.CUSTOM_TYPE = "Zakeke.BlendProceduralTexture";
var shaderLines = [
    'precision mediump float;',
    'varying vec2 vUV;',
    'uniform sampler2D uSampler;',
    'uniform sampler2D uBlendSampler;',
    'uniform vec2 uSamplerScale;',
    'uniform vec2 uBlendScale;',
    'uniform bool hasSampler;',
    'uniform bool hasBlend;',
    'float BlendOverlayf(float base, float blend)',
    '{',
    '   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));',
    '}',
    'vec4 BlendOverlay(vec4 base, vec4 blend)',
    '{',
    '   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));',
    '}',
    'void main(void) {',
    '   if (!hasSampler && !hasBlend)',
    '   {',
    '       gl_FragColor = vec4(1.0, 1.0, 1.0, 1.0);',
    '       return;',
    '   }',
    '   if (hasSampler && !hasBlend)',
    '   {',
    '       gl_FragColor = texture2D(uSampler, vUV.xy*uSamplerScale);',
    '       return;',
    '   }',
    '   if (!hasSampler && hasBlend)',
    '   {',
    '       gl_FragColor = texture2D(uBlendSampler, vUV.xy*uBlendScale);',
    '       return;',
    '   }',
    '   vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);',
    '   vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);',
    '   gl_FragColor = BlendOverlay(base, blend);',
    '}'
];
var shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore[`${BlendProceduralTexture.FRAGMENT_SHADER}PixelShader`] = shader;
BABYLON.RegisterClass("Zakeke.BlendProceduralTexture", BlendProceduralTexture);


/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/BlurXProceduralTexture.ts":
/*!****************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/BlurXProceduralTexture.ts ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlurXProceduralTexture": () => (/* binding */ BlurXProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");

class BlurXProceduralTexture extends _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture {
    constructor(name, size, scene, baseTexture, fallbackTexture, generateMipMaps) {
        super(name, size, BlurXProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
        this._blur = 1 / 512;
        this.updateShaderUniforms();
    }
    //@BABYLON.serialize()
    get blur() {
        return this._blur / (1 / 7000);
    }
    set blur(value) {
        this._blur = (1 / 7000) * value;
        this.updateShaderUniforms();
    }
    dispose() {
        super.dispose();
    }
    updateShaderUniforms() {
        super.updateShaderUniforms();
        if (this.initializing)
            return;
        const blur = this._blur != undefined ? this._blur : (1 / 512);
        this.setFloat("blur", blur);
    }
    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
    render(useCameraPostProcess) {
        super.render(useCameraPostProcess);
    }
    /**
      * Resize the texture to new value.
      * @param size Define the new size the texture should have
      * @param generateMipMaps Define whether the new texture should create mip maps
      */
    resize(size, generateMipMaps) {
        super.resize(size, generateMipMaps);
        // We need to update the "size" uniform
        this.updateShaderUniforms();
    }
}
BlurXProceduralTexture.FRAGMENT_SHADER = "zakeke_BlurXProceduralTexture";
BlurXProceduralTexture.CUSTOM_TYPE = "Zakeke.BlurXProceduralTexture";
const shaderLines = [
    'precision mediump float;',
    'varying vec2 vUV;',
    'varying vec4 vColor;',
    'uniform float blur;',
    'uniform sampler2D uSampler;',
    'void main(void) {',
    '   vec4 sum = vec4(0.0);',
    '   sum += texture2D(uSampler, vec2(vUV.x - 4.0*blur, vUV.y)) * 0.05;',
    '   sum += texture2D(uSampler, vec2(vUV.x - 3.0*blur, vUV.y)) * 0.09;',
    '   sum += texture2D(uSampler, vec2(vUV.x - 2.0*blur, vUV.y)) * 0.12;',
    '   sum += texture2D(uSampler, vec2(vUV.x - blur, vUV.y)) * 0.15;',
    '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;',
    '   sum += texture2D(uSampler, vec2(vUV.x + blur, vUV.y)) * 0.15;',
    '   sum += texture2D(uSampler, vec2(vUV.x + 2.0*blur, vUV.y)) * 0.12;',
    '   sum += texture2D(uSampler, vec2(vUV.x + 3.0*blur, vUV.y)) * 0.09;',
    '   sum += texture2D(uSampler, vec2(vUV.x + 4.0*blur, vUV.y)) * 0.05;',
    '   gl_FragColor = sum;',
    '}'
];
const shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore[`${BlurXProceduralTexture.FRAGMENT_SHADER}PixelShader`] = shader;


/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/BlurYProceduralTexture.ts":
/*!****************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/BlurYProceduralTexture.ts ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BlurYProceduralTexture": () => (/* binding */ BlurYProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");

class BlurYProceduralTexture extends _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture {
    constructor(name, size, scene, baseTexture, fallbackTexture, generateMipMaps) {
        super(name, size, BlurYProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
        this._blur = 1 / 512;
        this.updateShaderUniforms();
    }
    get blur() {
        return this._blur / (1 / 7000);
    }
    set blur(value) {
        this._blur = (1 / 7000) * value;
        this.updateShaderUniforms();
    }
    dispose() {
        super.dispose();
    }
    updateShaderUniforms() {
        super.updateShaderUniforms();
        if (this.initializing)
            return;
        const blur = this._blur != undefined ? this._blur : (1 / 512);
        this.setFloat("blur", blur);
    }
    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
    render(useCameraPostProcess) {
        super.render(useCameraPostProcess);
    }
    /**
      * Resize the texture to new value.
      * @param size Define the new size the texture should have
      * @param generateMipMaps Define whether the new texture should create mip maps
      */
    resize(size, generateMipMaps) {
        super.resize(size, generateMipMaps);
        // We need to update the "size" uniform
        this.updateShaderUniforms();
    }
}
BlurYProceduralTexture.FRAGMENT_SHADER = "zakeke_BlurYProceduralTexture";
BlurYProceduralTexture.CUSTOM_TYPE = "Zakeke.BlurYProceduralTexture";
const shaderLines = [
    'precision mediump float;',
    'varying vec2 vUV;',
    'varying vec4 vColor;',
    'uniform float blur;',
    'uniform sampler2D uSampler;',
    'void main(void) {',
    '   vec4 sum = vec4(0.0);',
    '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 4.0*blur)) * 0.05;',
    '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 3.0*blur)) * 0.09;',
    '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - 2.0*blur)) * 0.12;',
    '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y - blur)) * 0.15;',
    '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y)) * 0.16;',
    '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + blur)) * 0.15;',
    '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 2.0*blur)) * 0.12;',
    '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 3.0*blur)) * 0.09;',
    '   sum += texture2D(uSampler, vec2(vUV.x, vUV.y + 4.0*blur)) * 0.05;',
    '   gl_FragColor = sum;',
    '}'
];
const shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore[`${BlurYProceduralTexture.FRAGMENT_SHADER}PixelShader`] = shader;


/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/ForegroundBackgroundProceduralTexture.ts":
/*!*******************************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/ForegroundBackgroundProceduralTexture.ts ***!
  \*******************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ForegroundBackgroundProceduralTexture": () => (/* binding */ ForegroundBackgroundProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");

class ForegroundBackgroundProceduralTexture extends _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture {
    constructor(name, size, scene, baseTexture, fallbackTexture, generateMipMaps) {
        super(name, size, ForegroundBackgroundProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
        this._foreColor = new BABYLON.Vector3(1, 1, 1);
        this._backColor = new BABYLON.Vector3(0, 0, 0);
        this.updateShaderUniforms();
    }
    //@BABYLON.serializeAsVector3()
    get foreColor() {
        return this._foreColor;
    }
    set foreColor(value) {
        this._foreColor = value;
        this.updateShaderUniforms();
    }
    //@BABYLON.serializeAsVector3()
    get backColor() {
        return this._backColor;
    }
    set backColor(value) {
        this._backColor = value;
        this.updateShaderUniforms();
    }
    dispose() {
        super.dispose();
    }
    updateShaderUniforms() {
        super.updateShaderUniforms();
        if (this.initializing)
            return;
        const foreColor = this._foreColor || new BABYLON.Vector3(1, 1, 1);
        const backColor = this._backColor || new BABYLON.Vector3(0, 0, 0);
        this.setVector3("foreColor", foreColor);
        this.setVector3("backColor", backColor);
    }
    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
    render(useCameraPostProcess) {
        super.render(useCameraPostProcess);
    }
    /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
    resize(size, generateMipMaps) {
        super.resize(size, generateMipMaps);
        // We need to update the "size" uniform
        this.updateShaderUniforms();
    }
}
ForegroundBackgroundProceduralTexture.FRAGMENT_SHADER = "zakeke_ForegroundBackgroundProceduralTexture";
ForegroundBackgroundProceduralTexture.CUSTOM_TYPE = "Zakeke.ForegroundBackgroundProceduralTexture";
const shaderLines = [
    'precision mediump float;',
    'varying vec2 vUV;',
    'uniform sampler2D uSampler;',
    'uniform vec3 foreColor;',
    'uniform vec3 backColor;',
    'void main(void) {',
    '   // background color',
    '   vec4 background = vec4(backColor.xyz, 1);',
    '   vec4 foreground = vec4(foreColor.xyz, 1);',
    '   // texel',
    '	vec4 t0 = texture2D(uSampler, vUV.xy);',
    '   // change in white',
    '   t0 = vec4(foreground.xyz, t0.a);',
    '   gl_FragColor = mix(background, t0, t0.a);',
    '}'
];
const shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore[`${ForegroundBackgroundProceduralTexture.FRAGMENT_SHADER}PixelShader`] = shader;


/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/MoveProceduralTexture.ts":
/*!***************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/MoveProceduralTexture.ts ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MoveProceduralTexture": () => (/* binding */ MoveProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");

class MoveProceduralTexture extends _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture {
    constructor(name, size, scene, baseTexture, fallbackTexture, generateMipMaps) {
        super(name, size, MoveProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
        this._offset = new BABYLON.Vector2(0, 0);
        this.updateShaderUniforms();
    }
    //@BABYLON.serializeAsVector2()
    get offset() {
        return this._offset;
    }
    set offset(value) {
        this._offset = value;
        this.updateShaderUniforms();
    }
    dispose() {
        super.dispose();
    }
    updateShaderUniforms() {
        super.updateShaderUniforms();
        if (this.initializing)
            return;
        const size = this.getRenderSize();
        const offset = this._offset || new BABYLON.Vector2();
        this.setVector2("offset", new BABYLON.Vector2(offset.x / size, offset.y / size));
    }
    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
    render(useCameraPostProcess) {
        super.render(useCameraPostProcess);
    }
    /**
    * Resize the texture to new value.
    * @param size Define the new size the texture should have
    * @param generateMipMaps Define whether the new texture should create mip maps
    */
    resize(size, generateMipMaps) {
        super.resize(size, generateMipMaps);
        // We need to update the "size" uniform
        this.updateShaderUniforms();
    }
}
MoveProceduralTexture.FRAGMENT_SHADER = "zakeke_MoveProceduralTexture";
MoveProceduralTexture.CUSTOM_TYPE = "Zakeke.MoveProceduralTexture";
const shaderLines = [
    'precision mediump float;',
    'varying vec2 vUV;',
    'uniform sampler2D uSampler;',
    'uniform vec2 offset;',
    'void main(void) {',
    '   // translated texel',
    '   gl_FragColor = texture2D(uSampler, vec2(vUV.x - offset.x, vUV.y + offset.y));',
    //'   gl_FragColor = texture2D(uSampler, vUV.xy - offset);',
    '}'
];
const shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore[`${MoveProceduralTexture.FRAGMENT_SHADER}PixelShader`] = shader;


/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/MultiplyProceduralTexture.ts":
/*!*******************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/MultiplyProceduralTexture.ts ***!
  \*******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MultiplyProceduralTexture": () => (/* binding */ MultiplyProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");

class MultiplyProceduralTexture extends _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture {
    constructor(name, size, scene, baseTexture, blendTexture, fallbackTexture, generateMipMaps) {
        super(name, size, MultiplyProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
        this._blendTexture = blendTexture;
        this.updateShaderUniforms();
    }
    //@BABYLON.serializeAsTexture()
    get blendTexture() {
        return this._blendTexture;
    }
    set blendTexture(texture) {
        this._blendTexture = texture;
        this.updateShaderUniforms();
    }
    dispose() {
        super.dispose();
        if (this._blendTexture)
            this._blendTexture.dispose();
    }
    updateShaderUniforms() {
        super.updateShaderUniforms();
        if (this.initializing)
            return;
        var baseScale = new BABYLON.Vector2(1, 1);
        if (this.baseTexture)
            baseScale = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale);
        this.setVector2("uSamplerScale", baseScale);
        this.setTexture("uBlendSampler", this._blendTexture);
        var blendScale = new BABYLON.Vector2(1, 1);
        if (this._blendTexture)
            blendScale = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale);
        this.setVector2("uBlendScale", blendScale);
    }
    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
    render(useCameraPostProcess) {
        super.render(useCameraPostProcess);
    }
    /**
      * Resize the texture to new value.
      * @param size Define the new size the texture should have
      * @param generateMipMaps Define whether the new texture should create mip maps
      */
    resize(size, generateMipMaps) {
        super.resize(size, generateMipMaps);
        // We need to update the "size" uniform
        this.updateShaderUniforms();
    }
}
MultiplyProceduralTexture.FRAGMENT_SHADER = "zakeke_MultiplyProceduralTexture";
MultiplyProceduralTexture.CUSTOM_TYPE = "Zakeke.MultiplyProceduralTexture";
const shaderLines = [
    'precision mediump float;',
    'varying vec2 vUV;',
    'uniform sampler2D uSampler;',
    'uniform sampler2D uBlendSampler;',
    'uniform vec2 uSamplerScale;',
    'uniform vec2 uBlendScale;',
    'void main(void) {',
    '	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);',
    '	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);',
    '   gl_FragColor = base * blend;',
    '}'
];
const shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore[`${MultiplyProceduralTexture.FRAGMENT_SHADER}PixelShader`] = shader;


/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/NormalMapProceduralTexture.ts":
/*!********************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/NormalMapProceduralTexture.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NormalMapProceduralTexture": () => (/* binding */ NormalMapProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");

class NormalMapProceduralTexture extends _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture {
    constructor(name, size, scene, baseTexture, fallbackTexture, generateMipMaps) {
        super(name, size, NormalMapProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
        this._bias = 50.0;
        this._invertR = false;
        this._invertG = false;
        this._bevel = false;
        this._intensity = 0.5;
        this.updateShaderUniforms();
    }
    get bias() {
        if (this._bias == undefined)
            return 50.0;
        return this._bias;
    }
    set bias(value) {
        this._bias = value;
        this.updateShaderUniforms();
    }
    get invertR() {
        if (this._invertR == undefined)
            return false;
        return this._invertR;
    }
    set invertR(value) {
        this._invertR = value;
        this.updateShaderUniforms();
    }
    get invertG() {
        if (this._invertG == undefined)
            return false;
        return this._invertG;
    }
    set invertG(value) {
        this._invertG = value;
        this.updateShaderUniforms();
    }
    get bevel() {
        if (this._bevel == undefined)
            return false;
        return this._bevel;
    }
    set bevel(value) {
        this._bevel = value;
        this.updateShaderUniforms();
    }
    get intensity() {
        if (this._intensity == undefined)
            return 0.5;
        return this._intensity;
    }
    set intensity(value) {
        this._intensity = value;
        this.updateShaderUniforms();
    }
    dispose() {
        super.dispose();
    }
    updateShaderUniforms() {
        super.updateShaderUniforms();
        if (this.initializing)
            return;
        var size = this.getRenderSize();
        var dim = size < 1024 ? size * 2 : size;
        this.setFloat("size", size);
        this.setVector2("u_textureSize", new BABYLON.Vector2(size, size));
        this.setVector3("dimensions", new BABYLON.Vector3(dim, dim, 0));
        this.setFloat("bias", this.bias);
        this.setFloat("invertR", this.invertR ? -1.0 : 1.0);
        this.setFloat("invertG", this.invertG ? -1.0 : 1.0);
        this.setFloat("bevel", this.bevel ? 1.0 : 0.0);
        this.setFloat("intensity", this.intensity);
    }
    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
    render(useCameraPostProcess) {
        super.render(useCameraPostProcess);
    }
    /**
      * Resize the texture to new value.
      * @param size Define the new size the texture should have
      * @param generateMipMaps Define whether the new texture should create mip maps
      */
    resize(size, generateMipMaps) {
        super.resize(size, generateMipMaps);
        // We need to update the "size" uniform
        this.updateShaderUniforms();
    }
}
NormalMapProceduralTexture.FRAGMENT_SHADER = "zakeke_normalMapProceduralTexture";
NormalMapProceduralTexture.CUSTOM_TYPE = "Zakeke.NormalMapProceduralTexture";
const shaderLines = [
    'precision mediump float;',
    'varying vec2 vUV;',
    'uniform vec3 dimensions;',
    'uniform sampler2D uSampler;',
    'uniform vec2 u_textureSize;',
    'uniform float bias;',
    'uniform float invertR;',
    'uniform float invertG;',
    'uniform float bevel;',
    'uniform float intensity;',
    'void main(void) {',
    '   vec2 step = vec2(1.0, 1.0) / dimensions.xy;',
    '   vec4 black = vec4(0, 0, 0, 1);',
    '	vec4 bk = vec4(1, 1, 1, 1);',
    '	vec4 t0 = texture2D(uSampler, vUV.xy + vec2(0.0, 0.0));',
    '	vec4 t1 = texture2D(uSampler, vUV.xy + vec2(step.x, 0.0));',
    '	vec4 t2 = texture2D(uSampler, vUV.xy + vec2(-step.x, 0.0));',
    '	vec4 t3 = texture2D(uSampler, vUV.xy + vec2(0.0, step.y));',
    '	vec4 t4 = texture2D(uSampler, vUV.xy + vec2(0.0, -step.y));',
    '   if (bevel != 0.0) ',
    '   {',
    '      t0 = vec4(0, 0, 0, t0.a);',
    '      t1 = vec4(0, 0, 0, t1.a);',
    '      t2 = vec4(0, 0, 0, t2.a);',
    '      t3 = vec4(0, 0, 0, t3.a);',
    '      t4 = vec4(0, 0, 0, t4.a);',
    '   }',
    '	t0 = mix(bk, t0, t0.a);',
    '	t1 = mix(bk, t1, t1.a);',
    '	t2 = mix(bk, t2, t2.a);',
    '	t3 = mix(bk, t3, t3.a);',
    '	t4 = mix(bk, t4, t4.a);',
    '	float d0 = abs(t0.r);',
    '	float d1 = abs(t1.r);',
    '	float d2 = abs(t2.r);',
    '	float d3 = abs(t3.r);',
    '	float d4 = abs(t4.r);',
    '	float dx = ((d2 - d0) + (d0 - d1)) * intensity;',
    '	float dy = ((d4 - d0) + (d0 - d3)) * intensity;',
    '	vec4 normal = vec4(normalize(vec3(dx * invertR, dy * invertG, 1.0 - ((bias - 0.1) / 100.0))), 1.0);',
    '	gl_FragColor = vec4(normal.xyz * 0.5 + 0.5, 1.0);',
    '}'
];
const shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore[`${NormalMapProceduralTexture.FRAGMENT_SHADER}PixelShader`] = shader;


/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/OpacityProceduralTexture.ts":
/*!******************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/OpacityProceduralTexture.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OpacityProceduralTexture": () => (/* binding */ OpacityProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");

class OpacityProceduralTexture extends _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture {
    constructor(name, size, scene, baseTexture, blendTexture, fallbackTexture, generateMipMaps) {
        super(name, size, OpacityProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
        this._opacity = 1.0;
        this.updateShaderUniforms();
    }
    get opacity() {
        if (this._opacity == undefined)
            return 1.0;
        return this._opacity;
    }
    set opacity(value) {
        this._opacity = value;
        this.updateShaderUniforms();
    }
    dispose() {
        super.dispose();
    }
    updateShaderUniforms() {
        super.updateShaderUniforms();
        if (this.initializing)
            return;
        this.setFloat("opacity", this.opacity);
    }
    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
    render(useCameraPostProcess) {
        super.render(useCameraPostProcess);
    }
    /**
      * Resize the texture to new value.
      * @param size Define the new size the texture should have
      * @param generateMipMaps Define whether the new texture should create mip maps
      */
    resize(size, generateMipMaps) {
        super.resize(size, generateMipMaps);
        // We need to update the "size" uniform
        this.updateShaderUniforms();
    }
}
OpacityProceduralTexture.FRAGMENT_SHADER = "zakeke_OpacityProceduralTexture";
OpacityProceduralTexture.CUSTOM_TYPE = "Zakeke.OpacityProceduralTexture";
const shaderLines = [
    'precision mediump float;',
    'varying vec2 vUV;',
    'uniform sampler2D uSampler;',
    'uniform float opacity;',
    'void main(void) {',
    '	vec4 color = texture2D(uSampler, vUV.xy);',
    '   color.a = opacity;',
    '   gl_FragColor = color;',
    '}'
];
const shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore[`${OpacityProceduralTexture.FRAGMENT_SHADER}PixelShader`] = shader;


/***/ }),

/***/ "../../3D/src/Components/ProceduralTextures/OverlayProceduralTexture.ts":
/*!******************************************************************************!*\
  !*** ../../3D/src/Components/ProceduralTextures/OverlayProceduralTexture.ts ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OverlayProceduralTexture": () => (/* binding */ OverlayProceduralTexture)
/* harmony export */ });
/* harmony import */ var _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./BaseProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BaseProceduralTexture.ts");

class OverlayProceduralTexture extends _BaseProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.BaseProceduralTexture {
    constructor(name, size, scene, baseTexture, blendTexture, fallbackTexture, generateMipMaps) {
        super(name, size, OverlayProceduralTexture.FRAGMENT_SHADER, scene, baseTexture, fallbackTexture, generateMipMaps);
        this._blendTexture = blendTexture;
        this.updateShaderUniforms();
    }
    //@BABYLON.serializeAsTexture()
    get blendTexture() {
        return this._blendTexture;
    }
    set blendTexture(texture) {
        this._blendTexture = texture;
        this.updateShaderUniforms();
    }
    dispose() {
        super.dispose();
        if (this._blendTexture)
            this._blendTexture.dispose();
    }
    updateShaderUniforms() {
        super.updateShaderUniforms();
        if (this.initializing)
            return;
        var baseScale = new BABYLON.Vector2(1, 1);
        if (this.baseTexture)
            baseScale = new BABYLON.Vector2(this.baseTexture.uScale, this.baseTexture.vScale);
        this.setVector2("uSamplerScale", baseScale);
        this.setTexture("uBlendSampler", this._blendTexture);
        var blendScale = new BABYLON.Vector2(1, 1);
        if (this._blendTexture)
            blendScale = new BABYLON.Vector2(this._blendTexture.uScale, this._blendTexture.vScale);
        this.setVector2("uBlendScale", blendScale);
    }
    /**
    * Render the texture to its associated render target.
    * @param useCameraPostProcess Define if camera post process should be applied to the texture
    */
    render(useCameraPostProcess) {
        super.render(useCameraPostProcess);
    }
    /**
      * Resize the texture to new value.
      * @param size Define the new size the texture should have
      * @param generateMipMaps Define whether the new texture should create mip maps
      */
    resize(size, generateMipMaps) {
        super.resize(size, generateMipMaps);
        // We need to update the "size" uniform
        this.updateShaderUniforms();
    }
}
OverlayProceduralTexture.FRAGMENT_SHADER = "zakeke_OverlayProceduralTexture";
OverlayProceduralTexture.CUSTOM_TYPE = "Zakeke.OverlayProceduralTexture";
var shaderLines = [
    'precision mediump float;',
    'varying vec2 vUV;',
    'uniform sampler2D uSampler;',
    'uniform sampler2D uBlendSampler;',
    'uniform vec2 uSamplerScale;',
    'uniform vec2 uBlendScale;',
    'float BlendOverlayf(float base, float blend)',
    '{',
    '   return (base < 0.5 ? (2.0 * base * blend) : (1.0 - 2.0 * (1.0 - base) * (1.0 - blend)));',
    '}',
    'vec4 BlendOverlay(vec4 base, vec4 blend)',
    '{',
    '   return vec4(BlendOverlayf(base.r, blend.r), BlendOverlayf(base.g, blend.g), BlendOverlayf(base.b, blend.b), BlendOverlayf(base.a, blend.a));',
    '}',
    'void main(void) {',
    '	vec4 base = texture2D(uSampler, vUV.xy*uSamplerScale);',
    '	vec4 blend = texture2D(uBlendSampler, vUV.xy*uBlendScale);',
    '   gl_FragColor = BlendOverlay(base, blend);',
    '}'
];
var shader = shaderLines.join('\n');
BABYLON.Effect.ShadersStore[`${OverlayProceduralTexture.FRAGMENT_SHADER}PixelShader`] = shader;


/***/ }),

/***/ "../../3D/src/Components/SceneHelper.ts":
/*!**********************************************!*\
  !*** ../../3D/src/Components/SceneHelper.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SceneHelper": () => (/* binding */ SceneHelper)
/* harmony export */ });
/* harmony import */ var _gltf_transform_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @gltf-transform/core */ "../../../node_modules/@gltf-transform/core/dist/core.modern.js");
/* harmony import */ var _composer_Components_ChunkedTask__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../composer/Components/ChunkedTask */ "../Components/ChunkedTask.ts");
/* harmony import */ var _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Misc/DefaultAssetUrls */ "../../3D/src/Misc/DefaultAssetUrls.ts");
/* harmony import */ var _Misc_StringTools__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Misc/StringTools */ "../../3D/src/Misc/StringTools.ts");
/* harmony import */ var _MeshExpander_MeshExpander__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./MeshExpander/MeshExpander */ "../../3D/src/Components/MeshExpander/MeshExpander.ts");
/* harmony import */ var _USDZ_UsdzHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./USDZ/UsdzHelper */ "../../3D/src/Components/USDZ/UsdzHelper.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






class SceneHelper {
    constructor(scene) {
        this._hemiLight = null;
        this._pointLight = null;
        this._onPrePointerObservableObserver = null;
        this._isPointerDown = false;
        this._radiusScale = 0.85;
        this._positionScale = 0.5;
        this._limitLowerRadius = true;
        this._zoomEnabled = true;
        this._minZoomPerc = null;
        this._maxZoomPerc = null;
        this._cameraPivot = null;
        this._defHemiLightID = "f90aba65-3b60-44ac-87f4-1b6441aee44b";
        this._defPointLightID = "b6491635-c471-45a4-bbb8-3f08556e5b3c";
        this._targetAnimationID = "6225769c-0113-4236-ab17-c39d24013de4";
        this._radiusAnimationID = "6f946c2f-af8d-46ab-9bea-9e22dedc4e9d";
        this._alphaAnimationID = "10713520-fe06-4cbf-bc6a-bab881d516e6";
        this._betaAnimationID = "6096ba34-852a-4423-bab3-dc97c1a9268f";
        this._dummyMaterialID = "081796b8-0908-44dc-a38a-d786b14cA6fc";
        // Dictionary per i materiali in stati di caricamento
        this._loadingMaterials = {};
        this._scene = scene;
        this._engine = scene.getEngine();
        this._camera = scene.activeCamera;
        this._canvas = scene.getEngine().getRenderingCanvas();
        this.init();
    }
    get camera() {
        return this._camera;
    }
    static checkAllMaterialTextureReady(material) {
        const textures = material.getActiveTextures();
        for (let i = 0; i < textures.length; i++) {
            const texture = textures[i];
            if (!texture.isReady())
                return false;
            else {
                if (texture instanceof BABYLON.ProceduralTexture)
                    texture.getEffect();
            }
        }
        return true;
    }
    static whenAllMaterialTexturesAreReady(material) {
        return new Promise((resolve, reject) => {
            if (this.checkAllMaterialTextureReady(material))
                resolve();
            else {
                let t = setInterval(() => {
                    if (this.checkAllMaterialTextureReady(material)) {
                        clearInterval(t);
                        resolve();
                    }
                }, 5);
            }
        });
    }
    static whenTextureIsReadyAsync(texture) {
        return new Promise((resolve, reject) => {
            if (texture.isReady())
                resolve();
            else {
                let t = setInterval(() => {
                    if (texture.isReady()) {
                        clearInterval(t);
                        if (texture instanceof BABYLON.ProceduralTexture)
                            texture.getEffect();
                        resolve();
                    }
                }, 5);
            }
        });
    }
    static whenMeshMaterialIsReady(mesh) {
        return new Promise((resolve, reject) => {
            let t = setInterval(() => {
                if (!mesh.material || mesh.material.isReady(mesh)) {
                    clearInterval(t);
                    resolve();
                }
            }, 5);
        });
    }
    static whenMaterialIsReadyForSubMeshAsync(material, mesh, subMesh) {
        return new Promise((resolve, reject) => {
            if (material.isReadyForSubMesh(mesh, subMesh)) {
                Logger.info(`Material ${material.name} ready`);
                resolve();
            }
            else {
                Logger.info(`Material ${material.name} NOT ready`);
                let t = setInterval(() => {
                    if (material.isReadyForSubMesh(mesh, subMesh) &&
                        (!mesh.material || mesh.material != material || mesh.material.isReady(mesh))) {
                        Logger.info(`Material ${material.name} ready`);
                        clearInterval(t);
                        resolve();
                    }
                }, 5);
            }
        });
    }
    static getMeshGeometry(mesh) {
        if (mesh.geometry)
            return mesh.geometry;
        const scene = mesh.getScene();
        const geometries = scene.getGeometries();
        for (let i = 0; i < geometries.length; i++) {
            const geometry = geometries[i];
            if (geometry.meshes.find(m => m === mesh))
                return geometry;
        }
        return null;
    }
    static checkMeshIsReady(mesh) {
        if (mesh instanceof BABYLON.Mesh) {
            mesh._checkDelayState();
            if (mesh.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED)
                return false;
            if (!mesh.geometry) {
                const scene = mesh.getScene();
                const geometries = scene.getGeometries();
                for (let i = 0; i < geometries.length; i++) {
                    const geometry = geometries[i];
                    if (geometry.meshes.find(m => m === mesh) &&
                        !geometry.isReady()) {
                        return false;
                    }
                }
            }
            if (mesh.geometry && !mesh.geometry.isReady())
                return false;
            for (let j = 0; j < mesh.getChildMeshes().length; j++) {
                const child = mesh.getChildMeshes()[j];
                if (!this.checkMeshIsReady(child))
                    return false;
            }
        }
        return mesh.isReady(true);
    }
    static checkAllMeshesAreReady(meshes) {
        let ret = true;
        for (let i = 0; i < meshes.length; i++)
            if (!this.checkMeshIsReady(meshes[i]))
                ret = false;
        return ret;
    }
    static whenAllMeshesAreReadyAsync(meshes) {
        return new Promise((resolve, reject) => {
            if (this.checkAllMeshesAreReady(meshes)) {
                resolve();
            }
            else {
                let t = setInterval(() => {
                    if (this.checkAllMeshesAreReady(meshes)) {
                        clearInterval(t);
                        resolve();
                    }
                }, 5);
            }
        });
    }
    static whenAllVisibleMeshesAreReadyAsync(scene) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshes = scene.meshes.filter(m => m.isVisible);
            yield this.whenAllMeshesAreReadyAsync(meshes);
        });
    }
    static whenMeshIsReadyAsync(mesh) {
        return new Promise((resolve, reject) => {
            if (this.checkMeshIsReady(mesh)) {
                resolve();
            }
            else {
                let t = setInterval(() => {
                    if (this.checkMeshIsReady(mesh)) {
                        clearInterval(t);
                        resolve();
                    }
                }, 5);
            }
        });
    }
    static visibleMeshesRequireDelayedLoading(scene) {
        const meshes = scene.meshes.filter(m => m.isVisible);
        for (let i = 0; i < meshes.length; i++) {
            if (this.meshRequiresDelayedLoading(meshes[i]))
                return true;
        }
        return false;
    }
    static meshRequiresDelayedLoading(mesh) {
        if (mesh instanceof BABYLON.Mesh) {
            if (mesh.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED ||
                mesh.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING)
                return true;
            const geometry = SceneHelper.getMeshGeometry(mesh);
            if (geometry &&
                (geometry.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_LOADING ||
                    geometry.delayLoadState === BABYLON.Constants.DELAYLOADSTATE_NOTLOADED))
                return true;
        }
        return false;
    }
    materialRequiresDelayedLoading(materialID) {
        const material = this._scene.getMaterialByID(materialID);
        if (material)
            return false;
        if (this._scene.metadata &&
            this._scene.metadata.delayedMaterials &&
            this._scene.metadata.delayedMaterials.hasOwnProperty(materialID))
            return true;
        if (this._scene.metadata &&
            this._scene.metadata.offloadedMaterials &&
            this._scene.metadata.offloadedMaterials.hasOwnProperty(materialID))
            return true;
        return false;
    }
    init() {
        this._onPrePointerObservableObserver = this._scene.onPrePointerObservable.add(pointerInfoPre => {
            if (pointerInfoPre.type === BABYLON.PointerEventTypes.POINTERDOWN) {
                this._isPointerDown = true;
                return;
            }
            if (pointerInfoPre.type === BABYLON.PointerEventTypes.POINTERUP) {
                this._isPointerDown = false;
            }
        });
    }
    dispose() {
        if (this._scene && this._onPrePointerObservableObserver) {
            this._scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver);
        }
    }
    switchFullScreen(parent) {
        if (document.fullscreenElement ||
            document.webkitFullscreenElement ||
            document.mozFullScreenElement ||
            document.msFullscreenElement) {
            this.quitFullscreen(parent ? parent : this._canvas);
        }
        else {
            this.launchFullscreen(parent ? parent : this._canvas);
        }
        if (this._canvas) {
            this._canvas.width = document.body.clientWidth; //document.width is obsolete
            this._canvas.height = document.body.clientHeight; //document.height is obsolete
            this.adjustCamera(undefined, true, true, false);
        }
    }
    quitFullscreen(element) {
        let exitFullscreen = document.exitFullscreen || document.webkitExitFullscreen || document.msExitFullscreen || document.mozCancelFullScreen;
        if (exitFullscreen)
            exitFullscreen.call(document);
    }
    launchFullscreen(element) {
        let requestFullScreen = element.requestFullscreen || element.webkitRequestFullscreen || element.msRequestFullscreen || element.mozRequestFullScreen;
        if (requestFullScreen)
            requestFullScreen.call(element);
    }
    getMeshHierarchySize(mesh) {
        let boundingBox = mesh.getHierarchyBoundingVectors(true);
        const size = boundingBox.max.subtract(boundingBox.min);
        return size;
    }
    getMeshHierarchyCenter(mesh) {
        const boundingBox = mesh.getHierarchyBoundingVectors(true);
        const size = boundingBox.max.subtract(boundingBox.min);
        const center = boundingBox.min.add(size.scale(0.5));
        return center;
    }
    getSceneBoundingInfo() {
        if (!this._scene)
            return null;
        const worldExtends = this.getWorldExtends();
        if (worldExtends)
            return new BABYLON.BoundingInfo(worldExtends.min, worldExtends.max);
        return null;
    }
    userIsMoving() {
        if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera)) {
            return false;
        }
        return this._camera.inertialAlphaOffset !== 0 ||
            this._camera.inertialBetaOffset !== 0 ||
            this._camera.inertialRadiusOffset !== 0 ||
            this._camera.inertialPanningX !== 0 ||
            this._camera.inertialPanningY !== 0 ||
            this._isPointerDown;
    }
    cameraIsMoving() {
        if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera)) {
            return false;
        }
        return this._camera.inertialAlphaOffset !== 0 ||
            this._camera.inertialBetaOffset !== 0 ||
            this._camera.inertialRadiusOffset !== 0 ||
            this._camera.inertialPanningX !== 0 ||
            this._camera.inertialPanningY !== 0;
    }
    cameraLimitsReached() {
        if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera)) {
            return false;
        }
        return (this._camera.lowerRadiusLimit !== undefined &&
            this._camera.lowerRadiusLimit !== null &&
            this._camera.radius === this._camera.lowerRadiusLimit) ||
            (this._camera.upperRadiusLimit !== undefined &&
                this._camera.upperRadiusLimit !== null &&
                this._camera.radius === this._camera.upperRadiusLimit);
    }
    restoreCameraState() {
        if (this._camera) {
            this._camera.restoreState();
        }
    }
    isTextureWithUrl(texture) {
        return texture &&
            (texture instanceof BABYLON.Texture ||
                texture instanceof BABYLON.CubeTexture ||
                texture instanceof BABYLON.HDRCubeTexture ||
                texture instanceof BABYLON.ColorGradingTexture ||
                texture instanceof BABYLON.EquiRectangularCubeTexture);
    }
    getTextureUrl(texture) {
        if (texture &&
            (texture instanceof BABYLON.Texture ||
                texture instanceof BABYLON.CubeTexture ||
                texture instanceof BABYLON.HDRCubeTexture ||
                texture instanceof BABYLON.ColorGradingTexture ||
                texture instanceof BABYLON.EquiRectangularCubeTexture)) {
            let textureUrl = texture.url;
            if (texture.getInternalTexture) {
                const internalTexture = texture.getInternalTexture();
                if (internalTexture && internalTexture.url) {
                    textureUrl = internalTexture.url;
                }
            }
            return textureUrl;
        }
        return null;
    }
    isEditControl(mesh) {
        return mesh && (mesh.name == "EditoControl" || (mesh.metadata && mesh.metadata.isEditControl));
    }
    isRealMesh(mesh) {
        return !(this.isEditControl(mesh) ||
            mesh.metadata && (mesh.metadata.boundingBox ||
                mesh.metadata.isAxis ||
                mesh.metadata.isGround ||
                mesh.metadata.isEnvironmentNode ||
                (mesh.metadata.hasOwnProperty("isRealMesh") && !mesh.metadata.isRealMesh)));
    }
    meshHasParent(meshID, parentID) {
        if (this._scene) {
            let mesh = this._scene.getMeshByID(meshID);
            if (mesh) {
                while (mesh.parent) {
                    if (mesh.parent.id === parentID)
                        return true;
                    mesh = mesh.parent;
                }
            }
        }
        return false;
    }
    countSceneMeshes() {
        let count = 0;
        if (this._scene) {
            this._scene.meshes.forEach(mesh => {
                if (this.isRealMesh(mesh))
                    count++;
            });
        }
        return count;
    }
    sceneHasRealMeshes() {
        for (let i = 0; i < this._scene.meshes.length; i++) {
            if (this.isRealMesh(this._scene.meshes[i]))
                return true;
        }
        return false;
    }
    getSceneMeshes() {
        const meshes = [];
        if (this._scene) {
            this._scene.meshes.forEach(mesh => {
                if (this.isRealMesh(mesh))
                    meshes.push(mesh);
            });
        }
        return meshes;
    }
    getSceneMeshesByName(name) {
        let meshes = [];
        if (this._scene) {
            const escapeRegExp = function (string) {
                return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
            };
            if (name) {
                var regExp = new RegExp(escapeRegExp(name).replace(/\\\*/g, ".*"), "i");
                for (let i = 0; i < this._scene.meshes.length; i++) {
                    const mesh = this._scene.meshes[i];
                    if (this.isRealMesh(mesh) && mesh.name && regExp.test(mesh.name))
                        meshes.push(mesh);
                }
            }
        }
        return meshes;
    }
    getVisibleMeshes() {
        const meshes = [];
        this._scene.meshes.forEach(mesh => {
            if (this.isRealMesh(mesh) && mesh.isVisible)
                meshes.push(mesh);
        });
        return meshes;
    }
    getInvisibleMeshes() {
        const meshes = [];
        this._scene.meshes.forEach(mesh => {
            if (this.isRealMesh(mesh) && !mesh.isVisible)
                meshes.push(mesh);
        });
        return meshes;
    }
    getSubMesh(mesh, submeshIdx) {
        if (mesh.subMeshes && mesh.subMeshes.length > 0 && submeshIdx >= 0 && submeshIdx < mesh.subMeshes.length) {
            return mesh.subMeshes[submeshIdx];
        }
        return null;
    }
    getMeshHierarchy(parentID) {
        const meshes = [];
        let parent = this._scene.getMeshByID(parentID);
        if (!parent)
            return meshes;
        let addMesh = (mesh) => {
            meshes.push(mesh);
            let children = mesh.getChildMeshes();
            for (let i = 0; i < children.length; i++)
                addMesh(children[i]);
        };
        addMesh(parent);
        return meshes;
    }
    isCanvasMesh(mesh) {
        if (!mesh)
            return false;
        if (!mesh.metadata)
            return false;
        if (mesh.metadata.hasOwnProperty("iscanvasMesh") && typeof mesh.metadata.iscanvasMesh === "boolean")
            return mesh.metadata.iscanvasMesh;
        return false;
    }
    isAREnabledForMesh(mesh) {
        if (!mesh)
            return false;
        if (!mesh.metadata)
            return true;
        if (mesh.metadata.AR === undefined || mesh.metadata.AR === null || typeof mesh.metadata.AR !== "boolean")
            return true;
        return mesh.metadata.AR;
    }
    isTryOnEnabledForMesh(mesh) {
        if (!mesh)
            return false;
        if (!mesh.metadata)
            return true;
        if (mesh.metadata.TryOn === undefined || mesh.metadata.TryOn === null || typeof mesh.metadata.TryOn !== "boolean")
            return true;
        return mesh.metadata.TryOn;
    }
    getMeshesForAR() {
        const meshes = [];
        if (this._scene) {
            this._scene.meshes.forEach((mesh) => {
                if ((this.isRealMesh(mesh) || this.isCanvasMesh(mesh)) &&
                    mesh.isVisible &&
                    this.isAREnabledForMesh(mesh))
                    meshes.push(mesh);
            });
        }
        return meshes;
    }
    checkMaterialsForAR() {
        const materials = this.getMeshesMaterials(this.getMeshesForAR());
        for (let i = 0; i < materials.length; i++) {
            const material = materials[i];
            if (!(material instanceof BABYLON.PBRMaterial) &&
                !(material instanceof BABYLON.PBRMetallicRoughnessMaterial) &&
                !(material instanceof BABYLON.StandardMaterial))
                return false;
        }
        return true;
    }
    getMeshesMaterials(meshes) {
        const ids = [];
        const materials = [];
        for (let i = 0; i < meshes.length; i++) {
            let mesh = meshes[i];
            if (mesh.material) {
                if (mesh.material instanceof BABYLON.MultiMaterial) {
                    for (let k = 0; k < mesh.material.subMaterials.length; k++) {
                        let subMaterial = mesh.material.subMaterials[k];
                        if (subMaterial && ids.indexOf(subMaterial.id) === -1) {
                            materials.push(subMaterial);
                            ids.push(subMaterial.id);
                        }
                    }
                }
                else {
                    if (ids.indexOf(mesh.material.id) === -1) {
                        materials.push(mesh.material);
                        ids.push(mesh.material.id);
                    }
                }
            }
        }
        return materials;
    }
    getMeshMaterials(mesh) {
        const materials = [];
        if (mesh && mesh.material) {
            if (mesh.material instanceof BABYLON.MultiMaterial) {
                for (let k = 0; k < mesh.material.subMaterials.length; k++) {
                    let subMaterial = mesh.material.subMaterials[k];
                    if (subMaterial)
                        materials.push(subMaterial);
                }
            }
            else {
                materials.push(mesh.material);
            }
        }
        return materials;
    }
    getHiddenMeshTotalVertices() {
        return this.getTotalVertices(mesh => !mesh.isVisible);
    }
    getTotalVertices(predicate) {
        let tot = 0;
        if (this._scene) {
            this._scene.meshes.forEach(mesh => {
                if (!this.isRealMesh(mesh))
                    return;
                if (predicate && !predicate(mesh))
                    return;
                tot += mesh.getTotalVertices();
            });
        }
        return tot;
    }
    getHiddenMeshTotalIndices() {
        return this.getTotalIndices(mesh => !mesh.isVisible);
    }
    getTotalIndices(predicate) {
        let tot = 0;
        if (this._scene) {
            this._scene.meshes.forEach(mesh => {
                if (!this.isRealMesh(mesh))
                    return;
                if (predicate && !predicate(mesh))
                    return;
                tot += mesh.getTotalIndices();
            });
        }
        return tot;
    }
    getAllMaterials() {
        const materials = [];
        if (this._scene) {
            this._scene.materials.forEach(material => {
                if (material.metadata) {
                    if (material.metadata.isRealMaterial !== undefined && !material.metadata.isRealMaterial)
                        return;
                    if (material.metadata.isEnvironmentNode !== undefined && material.metadata.isEnvironmentNode)
                        return;
                }
                if (material.id === "groundMaterial")
                    return;
                if (material.id === "default material")
                    return;
                materials.push(material);
            });
        }
        return materials;
    }
    getMeshesUsingMaterial(materialID) {
        const meshes = [];
        const allMeshes = this.getSceneMeshes();
        for (let i = 0; i < allMeshes.length; i++) {
            const mesh = allMeshes[i];
            if (this.isMeshUsingMaterial(mesh, materialID))
                meshes.push(mesh);
        }
        return meshes;
    }
    isMeshUsingMaterial(mesh, materialID) {
        if (mesh.material) {
            if (mesh.material.id === materialID) {
                return true;
            }
            else if (mesh.material instanceof BABYLON.MultiMaterial) {
                for (let k = 0; k < mesh.material.subMaterials.length; k++) {
                    const subMaterial = mesh.material.subMaterials[k];
                    if (subMaterial && subMaterial.id === materialID) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    getAllUnusedMaterials() {
        const materials = this.getAllMaterials();
        const unusedMaterials = [];
        for (let i = 0; i < materials.length; i++) {
            const material = materials[i];
            const meshes = this.getMeshesUsingMaterial(material.id);
            if (meshes.length === 0)
                unusedMaterials.push(material);
        }
        return unusedMaterials;
    }
    getSceneScreenshotAsync(width, height) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._camera)
                return "";
            let size = { width, height };
            return yield BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, size, "image/png");
        });
    }
    containsPBRMaterials() {
        if (this._scene) {
            for (let i = 0; i < this._scene.materials.length; i++) {
                const material = this._scene.materials[i];
                if (material instanceof BABYLON.PBRBaseMaterial)
                    return true;
            }
        }
        return false;
    }
    getMeshesForTryOn() {
        const meshes = [];
        if (this._scene) {
            this._scene.meshes.forEach((mesh) => {
                if ((this.isRealMesh(mesh) || this.isCanvasMesh(mesh)) && mesh.isVisible && this.isTryOnEnabledForMesh(mesh)) {
                    meshes.push(mesh);
                }
            });
        }
        return meshes;
    }
    setupLights() {
        this._hemiLight = null;
        this._pointLight = null;
        let firstHemiLight = null;
        let firstPointLight = null;
        this._scene.lights.forEach(light => {
            if (light instanceof BABYLON.HemisphericLight) {
                if (firstHemiLight === null)
                    firstHemiLight = light;
                if (light.id === this._defHemiLightID)
                    this._hemiLight = light;
            }
            if (light instanceof BABYLON.PointLight) {
                if (firstPointLight === null)
                    firstPointLight = light;
                if (light.id === this._defPointLightID)
                    this._pointLight = light;
            }
        });
        if (this._hemiLight === null) {
            if (firstHemiLight !== null) {
                this._hemiLight = firstHemiLight;
            }
            else {
                this._hemiLight = new BABYLON.HemisphericLight('Default Hemispheric Light', BABYLON.Vector3.Up(), this._scene);
                this._hemiLight.intensity = 0.5;
            }
            if (this._hemiLight)
                this._hemiLight.id = this._defHemiLightID;
        }
        if (this._pointLight === null) {
            if (firstPointLight !== null) {
                this._pointLight = firstPointLight;
            }
            else {
                this._pointLight = new BABYLON.PointLight("Default Point Light", new BABYLON.Vector3(0, 5, 0), this._scene);
                this._pointLight.intensity = 0.5;
            }
            if (this._pointLight)
                this._pointLight.id = this._defPointLightID;
        }
    }
    getDefaultHemisphericLight() {
        return this._hemiLight;
    }
    getDefaultPointLight() {
        return this._pointLight;
    }
    isDefaultLight(light) {
        return light.id == this._defHemiLightID ||
            light.id == this._defPointLightID;
    }
    setupCamera() {
        if (this._scene) {
            let sceneCamera = this._scene.cameras.find(c => c instanceof BABYLON.ArcRotateCamera);
            if (!sceneCamera) {
                this._camera = new BABYLON.ArcRotateCamera("camera1", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene);
                this._camera.setPosition(new BABYLON.Vector3(0, 3, -8));
            }
            else {
                this._camera = sceneCamera;
            }
            this.setupCameraLimits();
            if (this._canvas)
                this._camera.attachControl(this._canvas, false);
        }
    }
    setCameraRadiusParameters(radius) {
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            this._camera.lowerRadiusLimit = radius * (this._zoomEnabled ? 0.01 : 1);
            this._camera.upperRadiusLimit = radius * (this._zoomEnabled ? 3 : 1);
            this._camera.wheelPrecision = 100 / radius;
            this._camera.pinchPrecision = 100 / radius;
            this._camera.minZ = radius * 0.01;
            this._camera.maxZ = radius * 1000;
            this._camera.speed = radius * 0.2;
            this._camera.wheelDeltaPercentage = 0.01;
            this._camera.pinchDeltaPercentage = 0.0006;
            this._camera.panningSensibility = 0.000001;
            this._camera.wheelPrecision = 100 / radius;
            this._camera.panningAxis = BABYLON.Vector3.Zero(); // elimino il panning del tutto
            this._camera.panningInertia = 0;
        }
    }
    removeCameraLimits() {
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            this._camera.lowerRadiusLimit = null;
            this._camera.upperRadiusLimit = null;
            this._camera.minZ = 1;
            this._camera.maxZ = 10000.0;
        }
    }
    getWorldExtends() {
        if (this._scene)
            return this._scene.getWorldExtends(mesh => this.isRealMesh(mesh) && mesh.isVisible);
        return null;
    }
    getCameraWorldExtends() {
        let worldExtends = null;
        if (this._scene) {
            let pivotMesh = this._cameraPivot;
            if (!pivotMesh) {
                for (let i = 0; i < this._scene.meshes.length; i++) {
                    const mesh = this._scene.meshes[i];
                    if (mesh.metadata && mesh.metadata.isCameraPivot !== undefined && mesh.metadata.isCameraPivot) {
                        pivotMesh = mesh;
                        break;
                    }
                }
            }
            if (pivotMesh) {
                worldExtends = this._scene.getWorldExtends(mesh => {
                    return mesh === pivotMesh || this.meshHasParent(mesh.id, pivotMesh.id);
                });
            }
        }
        if (!worldExtends)
            worldExtends = this.getWorldExtends();
        return worldExtends;
    }
    setupCameraLimits(worldExtends) {
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            if (worldExtends === undefined || worldExtends === null) {
                let we = this.getCameraWorldExtends();
                if (we)
                    worldExtends = we;
            }
            if (!worldExtends)
                return;
            const worldSize = worldExtends.max.subtract(worldExtends.min);
            if (isFinite(worldSize.length())) {
                this.removeCameraLimits();
                const radius = this.calculateCameraRadius(worldExtends);
                this.setCameraRadiusParameters(radius);
                if (this._limitLowerRadius) {
                    if (this._scene.meshes.length && this._zoomEnabled) {
                        // Enable camera's behaviors
                        this._camera.useFramingBehavior = true;
                        const framingBehavior = this._camera.getBehaviorByName("Framing");
                        if (framingBehavior && framingBehavior instanceof BABYLON.FramingBehavior) {
                            framingBehavior.framingTime = 0;
                            framingBehavior.elevationReturnTime = -1;
                            framingBehavior.radiusScale = this._radiusScale;
                            // test position scale
                            framingBehavior.positionScale = this._positionScale;
                            this._camera.lowerRadiusLimit = null;
                            framingBehavior.zoomOnBoundingInfo(worldExtends.min, worldExtends.max);
                            if (this._minZoomPerc !== null && this._minZoomPerc !== undefined && this._minZoomPerc > 0)
                                this._camera.lowerRadiusLimit = radius * this._minZoomPerc;
                            if (this._maxZoomPerc !== null && this._maxZoomPerc !== undefined && this._maxZoomPerc > 0)
                                this._camera.upperRadiusLimit = radius * this._maxZoomPerc;
                        }
                    }
                }
                else {
                    this._camera.lowerRadiusLimit = null;
                }
            }
        }
    }
    adjustCamera(currentPluginName, keepAlpha = true, keepBeta = true, animate = true) {
        if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
            return;
        let worldExtends = this.getCameraWorldExtends();
        if (!worldExtends)
            return;
        const worldSize = worldExtends.max.subtract(worldExtends.min);
        if (!isFinite(worldSize.length()))
            return;
        const worldCenter = worldExtends.min.add(worldSize.scale(0.5));
        this.removeCameraLimits();
        const radius = this.calculateCameraRadius(worldExtends);
        let alpha = this._camera.alpha;
        if (!keepAlpha) {
            alpha = -(Math.PI / 2);
            if (currentPluginName && currentPluginName === "gltf") {
                // glTF assets use a +Z forward convention while the default camera faces +Z. Rotate the camera to look at the front of the asset.
                alpha += Math.PI;
            }
        }
        let beta = this._camera.beta;
        if (!keepBeta)
            beta = Math.PI / 2 - 0.3;
        let target = worldCenter.clone();
        // position scale
        let bottom = worldExtends.min.y;
        let top = worldExtends.max.y;
        let zoomTargetY = bottom + (top - bottom) * this._positionScale;
        target.y = zoomTargetY;
        if (!animate) {
            this._camera.alpha = alpha;
            this._camera.beta = beta;
            this._camera.radius = radius;
            this._camera.target = target;
            this.setupCameraLimits(worldExtends);
        }
        else {
            this.animateCameraToFinalParamters(alpha, beta, radius, target, 2, () => {
                this.setupCameraLimits(worldExtends);
            });
        }
    }
    normalizeAngleOfView(alpha, beta) {
        const target = BABYLON.Vector3.Zero();
        const ghost = new BABYLON.ArcRotateCamera("ghostCamera", alpha, beta, 1, target, this._scene);
        const position = ghost.position;
        ghost.dispose();
        return this.computeCameraAngleOfView(target, position);
    }
    computeCameraAngleOfView(target, position) {
        // creo una ghost camera per recuperare alpha, beta e radius nuovi
        const ghost = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, target, this._scene);
        ghost.setPosition(position);
        const endAlpha = ghost.alpha;
        const endBeta = ghost.beta;
        ghost.dispose();
        return {
            alpha: endAlpha,
            beta: endBeta
        };
    }
    moveCamera(endTarget, endPosition) {
        // creo una ghost camera per recuperare alpha, beta e radius nuovi
        var ghost = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, endTarget, this._scene);
        ghost.setPosition(endPosition);
        var endAlpha = ghost.alpha;
        var endBeta = ghost.beta;
        var endRadius = ghost.radius;
        ghost.dispose();
        this.moveCameraToFinalParameters(endAlpha, endBeta, endRadius, endTarget);
    }
    animateCamera(endTarget, endPosition, seconds, callback) {
        // creo una ghost camera per recuperare alpha, beta e radius nuovi
        var ghost = new BABYLON.ArcRotateCamera("ghostCamera", 0, 0, 0, endTarget, this._scene);
        ghost.setPosition(endPosition);
        var endAlpha = ghost.alpha;
        var endBeta = ghost.beta;
        var endRadius = ghost.radius;
        ghost.dispose();
        this.animateCameraToFinalParamters(endAlpha, endBeta, endRadius, endTarget, seconds, callback);
    }
    // riporta angle nel range -180, + 180
    wrapPi(angle) {
        if (Math.abs(angle) > Math.PI) {
            var twoppi = 2.0 * Math.PI;
            var revolutions = Math.floor((angle + Math.PI) * (1.0 / twoppi));
            angle -= revolutions * twoppi;
        }
        return angle;
    }
    wrap2Pi(angle) {
        let a = angle % (Math.PI * 2);
        if (a < 0) {
            a += Math.PI * 2;
        }
        return a;
    }
    zoomIn() {
        this.zoom(0.85);
    }
    zoomOut() {
        this.zoom(1.15);
    }
    zoom(perc) {
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            let radius = this._camera.radius;
            let lowerRadius = this._camera.lowerRadiusLimit !== null &&
                this._camera.lowerRadiusLimit !== undefined ? this._camera.lowerRadiusLimit : 0;
            let min = Math.max(0, lowerRadius);
            let max = Number.MAX_VALUE;
            if (this._camera.upperRadiusLimit != null)
                max = this._camera.upperRadiusLimit;
            var newRadius = Math.max(min, Math.min(max, radius * perc));
            if (newRadius !== radius) {
                this.animateCameraToFinalParamters(this._camera.alpha, this._camera.beta, newRadius, this._camera.target, 0.5);
            }
        }
    }
    moveCameraToFinalParameters(alpha, beta, radius, target) {
        if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
            return;
        this._camera.target = target;
        this._camera.alpha = alpha;
        this._camera.beta = beta;
        this._camera.radius = radius;
    }
    animateCameraToFinalParamters(endAlpha, endBeta, endRadius, endTarget, seconds, callback) {
        if (!this._camera || !(this._camera instanceof BABYLON.ArcRotateCamera))
            return;
        let removeOldAnimations = () => {
            if (this._camera) {
                this._scene.stopAnimation(this._camera);
                for (let i = 0; i < this._camera.animations.length; i++) {
                    var anim = this._camera.animations[i];
                    this._camera.animations.splice(i--, 1);
                }
            }
        };
        removeOldAnimations();
        // resetting the alpha and beta to a much simpler version
        let alpha1 = this._camera.alpha;
        if (!this._camera.lowerAlphaLimit && !this._camera.upperAlphaLimit) {
            alpha1 = this.wrap2Pi(this._camera.alpha);
        }
        let beta1 = this._camera.beta;
        if (!this._camera.lowerBetaLimit && !this._camera.upperBetaLimit) {
            beta1 = this.wrap2Pi(this._camera.beta);
        }
        // used to find the shortest curve IE. if angle == 3PI/2 => take the -1PI/2 instead
        let alpha2 = isFinite(endAlpha) ? this.wrapPi(endAlpha) : alpha1;
        if (Math.abs(alpha1 - alpha2) > Math.PI) {
            alpha2 += Math.PI * 2;
        }
        let beta2 = isFinite(endBeta) ? this.wrapPi(endBeta) : beta1;
        if (Math.abs(beta1 - beta2) > Math.PI) {
            beta2 += Math.PI * 2;
        }
        let duration = 2;
        if (seconds && typeof seconds === 'number' && seconds > 0)
            duration = seconds;
        let fps = 60;
        let numFrames = Math.floor(duration * fps);
        // Target
        let targetVect = this._camera.target.subtract(endTarget);
        let targetDist = targetVect.length();
        let targetPerc = targetDist / this._camera.radius;
        let keys = [];
        // easing function
        let easingFunction = new BABYLON.CubicEase();
        easingFunction.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
        let targetAnimation = null;
        if (this._camera.target !== endTarget) {
            if (targetPerc >= 0.005) {
                targetAnimation = new BABYLON.Animation("camTargetAnimation", "target", fps, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
                // keys
                keys = [{
                        frame: 0,
                        value: this._camera.target
                    }, {
                        frame: numFrames,
                        value: endTarget
                    }];
                targetAnimation.setKeys(keys);
                targetAnimation.setEasingFunction(easingFunction);
            }
            else {
                this._camera.target = endTarget;
            }
        }
        // Alpha
        let alphaAnimation = null;
        if (alpha1 !== alpha2) {
            //Logger.info("alpha1: " + alpha1 + " - alpha2: " + alpha2);
            alphaAnimation = new BABYLON.Animation("camAlphaAnimation", "alpha", fps, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
            // keys
            keys = [{
                    frame: 0,
                    value: alpha1
                }, {
                    frame: numFrames,
                    value: alpha2
                }];
            alphaAnimation.setKeys(keys);
            alphaAnimation.setEasingFunction(easingFunction);
        }
        // Beta
        let betaAnimation = null;
        ;
        if (beta1 !== beta2) {
            betaAnimation = new BABYLON.Animation("camBetaAnimation", "beta", fps, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
            // keys
            keys = [{
                    frame: 0,
                    value: beta1
                }, {
                    frame: numFrames,
                    value: beta2
                }];
            betaAnimation.setKeys(keys);
            betaAnimation.setEasingFunction(easingFunction);
        }
        // Radius
        let deltaPerc = Math.abs(this._camera.radius - endRadius) / this._camera.radius;
        let radiusAnimation = null;
        if (this._camera.radius !== endRadius) {
            if (deltaPerc >= 0.005) {
                radiusAnimation = new BABYLON.Animation("camRadiusAnimation", "radius", fps, BABYLON.Animation.ANIMATIONTYPE_FLOAT, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
                // keys
                keys = [{
                        frame: 0,
                        value: this._camera.radius
                    }, {
                        frame: numFrames,
                        value: endRadius
                    }];
                radiusAnimation.setKeys(keys);
                radiusAnimation.setEasingFunction(easingFunction);
            }
            else {
                this._camera.radius = endRadius;
            }
        }
        let oldAnimationCounts = this._camera.animations.length;
        if (targetAnimation)
            this._camera.animations.push(targetAnimation);
        if (alphaAnimation)
            this._camera.animations.push(alphaAnimation);
        if (betaAnimation)
            this._camera.animations.push(betaAnimation);
        if (radiusAnimation)
            this._camera.animations.push(radiusAnimation);
        if (this._camera.animations.length > oldAnimationCounts) {
            //Logger.info("starting camera animations");
            var animatable = this._scene.beginAnimation(this._camera, 0, numFrames, false, 1);
            // Remove animations from camera
            animatable.onAnimationEnd = () => {
                removeOldAnimations();
                this.setupShaderMaterialsCameraPosition();
                if (callback)
                    callback();
            };
        }
        else {
            if (callback)
                callback();
        }
    }
    //Returns the frustum slope based on the canvas ratio and camera FOV
    //returns The frustum slope represented as a Vector2 with X and Y slopes
    getFrustumSlope() {
        // Calculate the viewport ratio
        // Aspect Ratio is Height/Width.
        let camera = this._camera;
        if (!camera) {
            return BABYLON.Vector2.Zero();
        }
        let engine = this._engine;
        let aspectRatio = engine.getAspectRatio(camera);
        // Camera FOV is the vertical field of view (top-bottom) in radians.
        // Slope of the frustum top/bottom planes in view space, relative to the forward vector.
        let frustumSlopeY = Math.tan(camera.fov / 2);
        // Slope of the frustum left/right planes in view space, relative to the forward vector.
        // Provides the amount that one side (e.g. left) of the frustum gets wider for every unit
        // along the forward vector.
        let frustumSlopeX = frustumSlopeY * aspectRatio;
        return new BABYLON.Vector2(frustumSlopeX, frustumSlopeY);
    }
    calculateCameraRadius(worldExtends) {
        if (worldExtends === undefined || worldExtends === null) {
            let we = this.getCameraWorldExtends();
            if (we)
                worldExtends = we;
        }
        if (!worldExtends)
            return 1;
        var worldSize = worldExtends.max.subtract(worldExtends.min);
        var radius = this.calculateLowerRadiusFromModelBoundingSphere(worldExtends.min, worldExtends.max);
        if (!isFinite(radius)) {
            radius = 1;
        }
        return radius;
    }
    // Calculates the lowest radius for the camera based on the bounding box of the mesh.
    calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld) {
        const size = maximumWorld.subtract(minimumWorld);
        const boxVectorGlobalDiagonal = size.length();
        const frustumSlope = this.getFrustumSlope();
        // Formula for setting distance
        // (Good explanation: http://stackoverflow.com/questions/2866350/move-camera-to-fit-3d-scene)
        const radiusWithoutFraming = boxVectorGlobalDiagonal * 0.5;
        // Horizon distance
        const radiusScale = this._radiusScale;
        const radius = radiusWithoutFraming * radiusScale;
        const distanceForHorizontalFrustum = radius * Math.sqrt(1.0 + 1.0 / (frustumSlope.x * frustumSlope.x));
        const distanceForVerticalFrustum = radius * Math.sqrt(1.0 + 1.0 / (frustumSlope.y * frustumSlope.y));
        let distance = Math.max(distanceForHorizontalFrustum, distanceForVerticalFrustum);
        var camera = this._camera;
        if (!camera || !(camera instanceof BABYLON.ArcRotateCamera)) {
            return 0;
        }
        // Don't exceed the upper radius limit
        if (camera.upperRadiusLimit) {
            distance = distance > camera.upperRadiusLimit ? camera.upperRadiusLimit : distance;
        }
        return distance;
    }
    getWorldCenter(worldExtends) {
        if (worldExtends === undefined || worldExtends === null) {
            let we = this.getCameraWorldExtends();
            if (we)
                worldExtends = we;
        }
        if (!worldExtends)
            return null;
        let worldSize = worldExtends.max.subtract(worldExtends.min);
        if (!isFinite(worldSize.length()))
            return null;
        let worldCenter = worldExtends.min.add(worldSize.scale(0.5));
        return worldCenter;
    }
    getCameraWorldCenter(worldExtends) {
        if (worldExtends === undefined || worldExtends === null) {
            let we = this.getCameraWorldExtends();
            if (we)
                worldExtends = we;
        }
        if (!worldExtends)
            return null;
        let worldSize = worldExtends.max.subtract(worldExtends.min);
        if (!isFinite(worldSize.length()))
            return null;
        let worldCenter = worldExtends.min.add(worldSize.scale(0.5));
        return worldCenter;
    }
    getCameraRadius(worldExtends) {
        if (worldExtends === undefined || worldExtends === null) {
            let we = this.getCameraWorldExtends();
            if (we)
                worldExtends = we;
        }
        if (!worldExtends)
            return null;
        let worldSize = worldExtends.max.subtract(worldExtends.min);
        if (!isFinite(worldSize.length()))
            return null;
        let radius = this.calculateCameraRadius(worldExtends);
        return radius;
    }
    setCameraLimitLowerRadius(limitLowerRadius, adjustCamera = false) {
        this._limitLowerRadius = limitLowerRadius;
        this.setupCameraLimits();
        if (adjustCamera && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
            let target = this._camera.target.clone();
            let worldExtends = this.getCameraWorldExtends();
            if (worldExtends) {
                let bottom = worldExtends.min.y;
                let top = worldExtends.max.y;
                let zoomTargetY = bottom + (top - bottom) * this._positionScale;
                target.y = zoomTargetY;
                this.animateCameraToFinalParamters(this._camera.alpha, this._camera.beta, this._camera.radius, target, 0.5);
            }
        }
    }
    setCameraPositionScale(positionScale, adjustCamera = false) {
        this._positionScale = positionScale;
        if (adjustCamera && this._camera && this._camera instanceof BABYLON.ArcRotateCamera && this.sceneHasRealMeshes()) {
            var target = this._camera.target.clone();
            var worldExtends = this.getCameraWorldExtends();
            if (worldExtends) {
                var bottom = worldExtends.min.y;
                var top = worldExtends.max.y;
                var zoomTargetY = bottom + (top - bottom) * this._positionScale;
                target.y = zoomTargetY;
                this.animateCameraToFinalParamters(this._camera.alpha, this._camera.beta, this._camera.radius, target, 0.5);
            }
        }
    }
    getCameraPivot() {
        return this._cameraPivot;
    }
    setCameraPivot(mesh) {
        this._cameraPivot = mesh;
        this.adjustCamera(undefined, true, true, true);
    }
    setZoomEnabled(enabled) {
        this._zoomEnabled = enabled;
        this.adjustCamera(undefined, true, true, true);
    }
    setMinZoomPerc(minZoomPerc) {
        const newVal = minZoomPerc === undefined || minZoomPerc === null ? null : minZoomPerc;
        if (newVal !== this._minZoomPerc) {
            this._minZoomPerc = newVal;
            this.adjustCamera(undefined, true, true, false);
        }
    }
    setMaxZoomPerc(maxZoomPerc) {
        const newVal = maxZoomPerc === undefined || maxZoomPerc === null ? null : maxZoomPerc;
        if (newVal !== this._maxZoomPerc) {
            this._maxZoomPerc = newVal;
            this.adjustCamera(undefined, true, true, false);
        }
    }
    setCameraAlphaLimits(lower, upper) {
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            //const alpha = this.wrapPi(this._camera.alpha);
            const alpha = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).alpha;
            this.setCameraLowerAlphaLimit(lower);
            this.setCameraUpperAlphaLimit(upper);
            this._camera.alpha = alpha;
        }
    }
    setCameraLowerAlphaLimit(angle) {
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            if (angle === null || angle === undefined) {
                this._camera.lowerAlphaLimit = null;
            }
            else {
                let a = this.normalizeAngleOfView(angle, this._camera.beta).alpha;
                if (this._camera.upperAlphaLimit && a > this._camera.upperAlphaLimit)
                    this._camera.upperAlphaLimit += Math.PI * 2;
                this._camera.lowerAlphaLimit = a;
            }
        }
    }
    setCameraUpperAlphaLimit(angle) {
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            if (angle === null || angle === undefined) {
                this._camera.upperAlphaLimit = null;
            }
            else {
                let a = this.normalizeAngleOfView(angle, this._camera.beta).alpha;
                if (this._camera.lowerAlphaLimit && a < this._camera.lowerAlphaLimit)
                    a += Math.PI * 2;
                this._camera.upperAlphaLimit = a;
            }
        }
    }
    setCameraLowerBetaLimit(angle) {
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            if (angle === null || angle === undefined) {
                this._camera.lowerBetaLimit = 0.01;
            }
            else {
                let a = this.normalizeAngleOfView(this._camera.alpha, angle).beta;
                if (this._camera.upperBetaLimit && a > this._camera.upperBetaLimit)
                    this._camera.upperBetaLimit += Math.PI * 2;
                this._camera.lowerBetaLimit = a;
            }
        }
    }
    setCameraUpperBetaLimit(angle) {
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            if (angle === null || angle === undefined) {
                this._camera.upperBetaLimit = Math.PI - 0.01;
            }
            else {
                let a = this.normalizeAngleOfView(this._camera.alpha, angle).beta;
                if (this._camera.lowerBetaLimit && a < this._camera.lowerBetaLimit)
                    this._camera.lowerBetaLimit -= Math.PI * 2;
                this._camera.upperBetaLimit = a;
            }
        }
    }
    setCameraBetaLimits(lower, upper) {
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            const beta = this.normalizeAngleOfView(this._camera.alpha, this._camera.beta).beta;
            this.setCameraLowerBetaLimit(lower);
            this.setCameraUpperBetaLimit(upper);
            this._camera.beta = beta;
        }
    }
    zoomOnMesh(mesh) {
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            // Enable camera's behaviors
            this._camera.useFramingBehavior = true;
            const framingBehavior = this._camera.getBehaviorByName("Framing");
            if (framingBehavior && framingBehavior instanceof BABYLON.FramingBehavior) {
                framingBehavior.framingTime = 0;
                framingBehavior.elevationReturnTime = -1;
                framingBehavior.radiusScale = this._radiusScale;
                // test position scale
                framingBehavior.positionScale = this._positionScale;
                framingBehavior.zoomOnMeshHierarchy(mesh);
            }
        }
    }
    takeScreenshotAsync(width, height) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._camera)
                return "";
            const size = { width, height };
            return yield BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, size, "image/png");
        });
    }
    takeContentScreenshotAsync(width, height) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._camera)
                return "";
            // rendo lo sfondo trasparente
            var oldClearColor = this._scene.clearColor.clone();
            this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
            this._scene.render(); // Forzo il ridisegno
            let size = { width, height };
            const promise = BABYLON.Tools.CreateScreenshotAsync(this._engine, this._camera, size, "image/png");
            this._scene.render(); // Forzo il ridisegno
            this._scene.getEngine().endFrame();
            const data = yield promise;
            this._scene.clearColor = oldClearColor;
            return data;
        });
    }
    takeMaterialScreenshotAsync(materialID, width, height) {
        return __awaiter(this, void 0, void 0, function* () {
            let material = this._scene.getMaterialByID(materialID);
            if (!material)
                return "";
            // Devo nascondere tutte le mesh attuali
            // Creare una sfera e applicarci il materiale
            // scattare la screenshot
            // eliiminare la sfera e riposizionare il tutto come era.
            let meshes = this.getVisibleMeshes(); // Mesh da nascondere e rivisualizzare
            for (let i = 0; i < meshes.length; i++) {
                var mesh = meshes[i];
                mesh.isVisible = false;
            }
            // rendo lo sfondo trasparente
            let oldClearColor = this._scene.clearColor.clone();
            this._scene.clearColor = new BABYLON.Color4(0, 0, 0, 0);
            // Creo una sfera temporanea
            let sphere = BABYLON.Mesh.CreateSphere("temp_sphere", 32, 2, this._scene);
            sphere.material = material;
            // Creo una nuova camera temporanea
            let newCamera = new BABYLON.ArcRotateCamera("temp_camera", 0, 0, 0, BABYLON.Vector3.Zero(), this._scene);
            newCamera.setPosition(new BABYLON.Vector3(0, 0, -4));
            this._scene.activeCamera = newCamera;
            this._scene.render(); // Forzo il ridisegno
            let size = { width, height };
            let data = yield BABYLON.Tools.CreateScreenshotAsync(this._engine, newCamera, size, "image/png");
            this._scene.clearColor = oldClearColor;
            sphere.dispose();
            // mostro le mesh precedentemente nascoste
            for (let i = 0; i < meshes.length; i++) {
                var mesh = meshes[i];
                mesh.isVisible = true;
            }
            // riattivo la vecchia camera
            this._scene.activeCamera = this._camera;
            newCamera.dispose();
            return data;
        });
    }
    getScenePBRMaterials() {
        const materials = [];
        if (this._scene) {
            this._scene.materials.forEach((material) => {
                if (material instanceof BABYLON.PBRBaseMaterial)
                    materials.push(material);
            });
        }
        return materials;
    }
    resetPBRMaterialsImageProcessingConfiguration() {
        var materials = this.getScenePBRMaterials();
        materials.forEach((material) => {
            this.adjustPBRMaterialImageProcessingConfiguration(material);
        });
    }
    adjustPBRMaterialImageProcessingConfiguration(material) {
        if (material instanceof BABYLON.PBRMaterial && material.imageProcessingConfiguration) {
            //if (material.imageProcessingConfiguration.isEnabled !== undefined)
            //    material.imageProcessingConfiguration.isEnabled = undefined;
            material.imageProcessingConfiguration.colorGradingWithGreenDepth = false;
            material.imageProcessingConfiguration.colorGradingBGR = false;
            material.imageProcessingConfiguration.exposure = 1;
            material.imageProcessingConfiguration.toneMappingEnabled = false;
            material.imageProcessingConfiguration.contrast = 1;
        }
    }
    animateMeshToFinalParameters(mesh, p, rE, rQ, s, seconds = 2, callback) {
        if (this._scene && mesh) {
            const id = mesh.id;
            const removeOldAnimations = () => {
                this._scene.stopAnimation(mesh);
                for (let i = 0; i < mesh.animations.length; i++) {
                    mesh.animations.splice(i--, 1);
                }
            };
            removeOldAnimations();
            const duration = seconds;
            const fps = 60;
            const numFrames = Math.floor(duration * fps);
            let keys;
            // Position
            let positionAnimation = null;
            if (mesh.position !== p) {
                positionAnimation = new BABYLON.Animation("positionAnimation", "position", fps, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
                // keys
                keys = [{
                        frame: 0,
                        value: mesh.position
                    }, {
                        frame: numFrames,
                        value: p
                    }];
                positionAnimation.setKeys(keys);
            }
            // Rotation
            let eulerAnimation = null;
            let quaternionAnimation = null;
            if (mesh.rotationQuaternion == null) {
                // Euler
                var endE;
                if (rE != null) {
                    endE = rE.clone();
                }
                else {
                    endE = rQ.toEulerAngles().clone();
                }
                if (mesh.rotation != endE) {
                    eulerAnimation = new BABYLON.Animation("eulerAnimation", "rotation", fps, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
                    // keys
                    keys = [{
                            frame: 0,
                            value: mesh.rotation
                        }, {
                            frame: numFrames,
                            value: endE
                        }];
                    eulerAnimation.setKeys(keys);
                }
            }
            else {
                // Quaternion
                let endQ;
                if (rQ != null) {
                    endQ = rQ.clone();
                }
                else {
                    endQ = BABYLON.Quaternion.Identity();
                    endQ.copyFrom(BABYLON.Quaternion.RotationYawPitchRoll(rE.y, rE.x, rE.z));
                }
                quaternionAnimation = new BABYLON.Animation("quaternionAnimation", "rotationQuaternion", fps, BABYLON.Animation.ANIMATIONTYPE_QUATERNION, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
                // keys
                keys = [{
                        frame: 0,
                        value: mesh.rotationQuaternion
                    }, {
                        frame: numFrames,
                        value: endQ
                    }];
                quaternionAnimation.setKeys(keys);
            }
            // Scaling
            let scalingAnimation = null;
            if (mesh.scaling !== s) {
                scalingAnimation = new BABYLON.Animation("scalingAnimation", "scaling", fps, BABYLON.Animation.ANIMATIONTYPE_VECTOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE);
                // keys
                keys = [{
                        frame: 0,
                        value: mesh.scaling
                    }, {
                        frame: numFrames,
                        value: s
                    }];
                scalingAnimation.setKeys(keys);
            }
            let oldAnimationCounts = mesh.animations.length;
            if (positionAnimation)
                mesh.animations.push(positionAnimation);
            if (eulerAnimation)
                mesh.animations.push(eulerAnimation);
            if (quaternionAnimation)
                mesh.animations.push(quaternionAnimation);
            if (scalingAnimation)
                mesh.animations.push(scalingAnimation);
            if (mesh.animations.length > oldAnimationCounts) {
                //Logger.info("starting camera animations");
                var animatable = this._scene.beginAnimation(mesh, 0, numFrames, false, 1);
                // Remove animations from camera
                animatable.onAnimationEnd = () => {
                    removeOldAnimations();
                    if (callback)
                        callback();
                };
            }
        }
    }
    getMaterialsUsingTexture(texture) {
        // costruisco una mappa texture uid --> [materials]
        var map = this.getTextureMaterialsMap();
        this._scene.materials.forEach(material => {
            var txts = this.getTexturesForMaterial(material);
            txts.forEach(txt => {
                if (!map.hasOwnProperty(txt.uid))
                    map[txt.uid] = [];
                map[txt.uid].push(material);
            });
        });
        if (map.hasOwnProperty(texture.uid))
            return map[texture.uid];
        return [];
    }
    getTextureMaterialsMap() {
        let map = {};
        if (this._scene) {
            this._scene.materials.forEach(material => {
                var txts = this.getTexturesForMaterial(material);
                txts.forEach(txt => {
                    if (!map.hasOwnProperty(txt.uid))
                        map[txt.uid] = [];
                    map[txt.uid].push(material);
                });
            });
        }
        return map;
    }
    // Recupera tutte le texture di un materiale
    getTexturesForMaterial(material) {
        return material.getActiveTextures();
    }
    getTexturesExclusivelyForMaterial(material) {
        let allTextures = this.getTexturesForMaterial(material);
        let map = this.getTextureMaterialsMap();
        for (var i = 0; i < allTextures.length; i++) {
            let texture = allTextures[i];
            var allMaterials = map.hasOwnProperty(texture.uid) ? map[texture.uid] : [];
            if (allMaterials.length > 1)
                allTextures.splice(i--, 1);
        }
        return allTextures;
    }
    getStandardMaterialTextures(material) {
        return material.getActiveTextures();
    }
    getPBRBaseSimpleMaterialTextures(material) {
        return material.getActiveTextures();
    }
    getPBRMaterialTextures(material) {
        return material.getActiveTextures();
    }
    getPBRMetallicRoughnessMaterialTextures(material) {
        return material.getActiveTextures();
    }
    getPBRSpecularGlossinessMaterialTextures(material) {
        return material.getActiveTextures();
    }
    getNewPBRMaterialTextures(material) {
        return material.getActiveTextures();
    }
    createMeshesFromSubMeshes(mesh) {
        let children = mesh.getChildMeshes();
        for (let i = 0; i < children.length; i++)
            this.createMeshesFromSubMeshes(children[i]);
        let newMeshes = [];
        if (mesh.subMeshes && mesh.subMeshes.length > 0) {
            for (let i = 0; i < mesh.subMeshes.length; i++) {
                let newMesh = this.createMeshFromSubMesh(mesh, i);
                if (newMesh)
                    newMeshes.push(newMesh);
            }
        }
        let vertexData = new BABYLON.VertexData();
        vertexData.positions = [];
        vertexData.indices = [];
        vertexData.normals = [];
        vertexData.uvs = [];
        vertexData.uvs2 = [];
        vertexData.applyToMesh(mesh, true);
        mesh.subMeshes = [];
        mesh.material = null;
        newMeshes.forEach(child => {
            child.parent = mesh;
        });
    }
    createMeshFromSubMesh(mesh, idx, name) {
        let newMesh = null;
        let submesh = mesh.subMeshes[idx];
        let positionsData = mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind);
        let normalsData = mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
        let indicesData = mesh.getIndices();
        if (positionsData && normalsData && indicesData) {
            let positions = positionsData.slice(3 * submesh.verticesStart, 3 * (submesh.verticesStart + submesh.verticesCount));
            let normals = normalsData.slice(3 * submesh.verticesStart, 3 * (submesh.verticesStart + submesh.verticesCount));
            let indices = indicesData.slice(submesh.indexStart, submesh.indexStart + submesh.indexCount);
            let uvs = null;
            if (mesh.isVerticesDataPresent(BABYLON.VertexBuffer.UVKind)) {
                let uvsData = mesh.getVerticesData(BABYLON.VertexBuffer.UVKind);
                if (uvsData)
                    uvs = uvsData.slice(2 * submesh.verticesStart, 2 * (submesh.verticesStart + submesh.verticesCount));
            }
            var uvs2 = null;
            if (mesh.isVerticesDataPresent(BABYLON.VertexBuffer.UV2Kind)) {
                let uvs2Data = mesh.getVerticesData(BABYLON.VertexBuffer.UV2Kind);
                if (uvs2Data)
                    uvs2 = uvs2Data.slice(2 * submesh.verticesStart, 2 * (submesh.verticesStart + submesh.verticesCount));
            }
            for (let k = 0; k < indices.length; k++)
                indices[k] -= submesh.verticesStart;
            let newMesh = new BABYLON.Mesh(name || mesh.name + "_part_" + submesh._id, this._scene);
            let vertexData = new BABYLON.VertexData;
            vertexData.positions = positions;
            vertexData.normals = normals;
            vertexData.indices = indices;
            if (uvs)
                vertexData.uvs = uvs;
            if (uvs2)
                vertexData.uvs2 = uvs2;
            vertexData.applyToMesh(newMesh);
            if (mesh.material)
                newMesh.material = mesh.material instanceof BABYLON.MultiMaterial ? mesh.material.subMaterials[submesh.materialIndex] : mesh.material;
        }
        return newMesh;
    }
    getNextIncrementalName(name) {
        let newName = name;
        if (name) {
            let nameWithoutSuffix;
            var incremental = 0;
            while (this._scene.getMeshByName(newName)) {
                if (!nameWithoutSuffix) {
                    nameWithoutSuffix = name;
                    var idx = name.lastIndexOf("_");
                    if (idx > 0) {
                        var numText = name.substring(idx + 1);
                        var num = parseInt(numText);
                        if (num.toString() === numText) {
                            nameWithoutSuffix = name.substring(0, idx);
                        }
                    }
                }
                incremental++;
                newName = nameWithoutSuffix + "_" + incremental;
            }
        }
        return newName;
    }
    createBox(parent, name) {
        let n = name || "Box";
        n = this.getNextIncrementalName(n);
        let mesh = BABYLON.Mesh.CreateBox(n, 5, this._scene);
        mesh.id = Zakeke.generateUUID();
        if (parent)
            mesh.parent = parent;
        return mesh;
    }
    createBoundingBox(mesh, name) {
        let n = name || "BoundingBox";
        n = this.getNextIncrementalName(n);
        const boundingVectors = mesh ? mesh.getHierarchyBoundingVectors() : this.getWorldExtends();
        if (!boundingVectors)
            return this.createBox(mesh, name);
        const min = boundingVectors.min;
        const max = boundingVectors.max;
        const totalBounds = new BABYLON.BoundingInfo(min, max);
        const boundSize = max.subtract(min);
        if (!isFinite(boundSize.length()))
            return this.createBox(mesh, name);
        const width = max.x - min.x;
        const height = max.y - min.y;
        const depth = max.z - min.z;
        const vertexdata = BABYLON.VertexData.CreateBox({ width, height, depth });
        const custombb_mesh = new BABYLON.Mesh(n, this._scene);
        vertexdata.applyToMesh(custombb_mesh);
        custombb_mesh.position.copyFrom(totalBounds.boundingBox.centerWorld);
        custombb_mesh.refreshBoundingInfo();
        if (mesh && mesh.parent)
            custombb_mesh.parent = mesh.parent;
        return custombb_mesh;
    }
    createSphere(parent, name) {
        let n = name || "Sphere";
        n = this.getNextIncrementalName(n);
        const mesh = BABYLON.Mesh.CreateSphere(n, 30, 5, this._scene);
        mesh.id = Zakeke.generateUUID();
        if (parent)
            mesh.parent = parent;
        return mesh;
    }
    createPlane(parent, name) {
        let n = name || "Plane";
        n = this.getNextIncrementalName(n);
        const mesh = BABYLON.Mesh.CreatePlane(n, 10.0, this._scene);
        mesh.id = Zakeke.generateUUID();
        if (parent)
            mesh.parent = parent;
        return mesh;
    }
    createDisc(parent, name) {
        let n = name || "Disc";
        n = this.getNextIncrementalName(n);
        const mesh = BABYLON.MeshBuilder.CreateDisc(n, { tessellation: 70 }, this._scene);
        mesh.id = Zakeke.generateUUID();
        if (parent)
            mesh.parent = parent;
        return mesh;
    }
    createCylinder(parent, name) {
        let n = name || "Cylinder";
        n = this.getNextIncrementalName(n);
        const mesh = BABYLON.Mesh.CreateCylinder(n, 6, 6, 6, 30, 1, this._scene, false);
        mesh.id = Zakeke.generateUUID();
        if (parent)
            mesh.parent = parent;
        return mesh;
    }
    createTorus(parent, name) {
        let n = name || "Torus";
        let i = 1;
        n = this.getNextIncrementalName(n);
        const mesh = BABYLON.Mesh.CreateTorus(n, 8, 1, 50, this._scene, false);
        mesh.id = Zakeke.generateUUID();
        if (parent)
            mesh.parent = parent;
        return mesh;
    }
    createKnot(parent, name) {
        let n = name || "Knot";
        let i = 1;
        n = this.getNextIncrementalName(n);
        const mesh = BABYLON.Mesh.CreateTorusKnot(n, 2, 0.5, 128, 64, 2, 3, this._scene);
        mesh.id = Zakeke.generateUUID();
        if (parent)
            mesh.parent = parent;
        return mesh;
    }
    createRibbon(parent, name) {
        let n = name || "Ribbon";
        let i = 1;
        n = this.getNextIncrementalName(n);
        // Creation of a ribbon
        // let's first create many paths along a maths exponential function as an example 
        const exponentialPath = function (p) {
            var path = [];
            for (var i = -10; i < 10; i++) {
                path.push(new BABYLON.Vector3(p, i, Math.sin(p / 3) * 5 * Math.exp(-(i - p) * (i - p) / 60) + i / 3));
            }
            return path;
        };
        // let's populate arrayOfPaths with all these different paths
        var arrayOfPaths = [];
        for (var p = 0; p < 20; p++) {
            arrayOfPaths[p] = exponentialPath(p);
        }
        // (name, array of paths, closeArray, closePath, offset, scene)
        const mesh = BABYLON.Mesh.CreateRibbon("ribbon", arrayOfPaths, false, false, 0, this._scene);
        mesh.id = Zakeke.generateUUID();
        if (parent)
            mesh.parent = parent;
        return mesh;
    }
    createRoundedCubeAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RoundedCubeName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RootUrl;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RoundedCubeFileName;
            let n = name || "Rounded Cube";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
        });
    }
    createRoundedCylinderAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RoundedCylinderName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RootUrl;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RoundedCylinderFileName;
            let n = name || "Rounded Cylinder";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
        });
    }
    createMatBallAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.MatBallName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RootUrl;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.MatBallFileName;
            let n = name || "Mat Ball";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
        });
    }
    createMaleHeadAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.MaleHeadName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RootUrl;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.MaleHeadFileName;
            let n = name || "Male Head";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
        });
    }
    createFemaleHeadAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.FemaleHeadName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RootUrl;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.FemaleHeadFileName;
            let n = name || "Female Head";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
        });
    }
    createPokemonBallAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.PokemonBallName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RootUrl;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.PokemonBallFileName;
            let n = name || "Pokemon Ball";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
        });
    }
    createShaderBallAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.ShaderBallName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RootUrl;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.ShaderBallFileName;
            let n = name || "Shader Ball";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
        });
    }
    createBootsAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.BootsName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RootUrl;
            const folder = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.BootsFolder;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.BootsFileName;
            let n = name || "Boots";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl + folder, filename, parent, n, onProgress);
        });
    }
    createSuzanneAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.SuzanneName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RootUrl;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.SuzanneFileName;
            let n = name || "Suzanne";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
        });
    }
    createStepPyramidAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.StepPyramidName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RootUrl;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.StepPyramidFileName;
            let n = name || "Step Pyramid";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
        });
    }
    createTeapotAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.TeapotName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RootUrl;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.TeapotFileName;
            let n = name || "Teapot";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
        });
    }
    createAlloyWheelAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.AlloyWheelName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.RootUrl;
            const folder = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.AlloyWheelFolder;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Shapes.AlloyWheelFileName;
            let n = name || "Wheel";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl + folder, filename, parent, n, onProgress);
        });
    }
    createTryonReferenceGlassesFrameAsync(parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshName = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Tryon.ReferenceGlassesFrameName;
            const rootUrl = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Tryon.RootUrl;
            const filename = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_1__.DefaultAssetUrls.Tryon.ReferenceGlassesFrameFileName;
            let n = name || "Reference Glasses Frame";
            n = this.getNextIncrementalName(n);
            return yield this.importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, n, onProgress);
        });
    }
    importPrimitiveShapeAsync(meshName, rootUrl, filename, parent, name, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let result = yield BABYLON.SceneLoader.ImportMeshAsync(meshName, rootUrl, filename, this._scene, onProgress);
            if (result && result.meshes) {
                meshes = result.meshes;
                for (let i = 0; i < meshes.length; i++) {
                    let mesh = meshes[i];
                    if (!mesh.parent)
                        mesh.name = name;
                    mesh.id = Zakeke.generateUUID();
                    if (parent)
                        mesh.parent = parent;
                }
            }
            return meshes;
        });
    }
    replaceTransformNodeWithMesh(transformNode) {
        let newMesh = null;
        if (this._scene) {
            const parent = transformNode.parent;
            const children = transformNode.getChildren();
            newMesh = new BABYLON.Mesh(transformNode.name, this._scene, parent);
            newMesh.id = Zakeke.generateUUID();
            newMesh.scaling = transformNode.scaling.clone();
            newMesh.position = transformNode.position.clone();
            newMesh.rotation = transformNode.rotation.clone();
            if (transformNode.rotationQuaternion)
                newMesh.rotationQuaternion = transformNode.rotationQuaternion.clone();
            children.forEach(c => c.parent = newMesh);
            transformNode.dispose();
        }
        return newMesh;
    }
    // import 3d model from a remote url
    importMeshesFromUrlAsync(url, parent, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            // Setting up some GLTF values
            let currentPluginName = undefined;
            BABYLON.GLTFFileLoader.IncrementalLoading = false;
            BABYLON.SceneLoader.OnPluginActivatedObservable.add((plugin) => {
                currentPluginName = plugin.name;
            });
            let meshes = [];
            const result = yield BABYLON.SceneLoader.ImportMeshAsync("", url, undefined, this._scene, onProgress);
            if (result) {
                result.meshes.forEach(mesh => {
                    mesh.id = Zakeke.generateUUID();
                    meshes.push(mesh);
                    const materials = this.getMeshMaterials(mesh);
                    materials.forEach(m => m.id = Zakeke.generateUUID());
                });
                // trasformo i TransformNodes in meshes (perché attualmente i transform node non sono gestiti dall'editor)
                result.transformNodes.forEach(n => {
                    n.id = Zakeke.generateUUID();
                    const newMesh = this.replaceTransformNodeWithMesh(n);
                    if (newMesh)
                        meshes.push(newMesh);
                });
                result.geometries.forEach(g => g.id = Zakeke.generateUUID());
            }
            // Raggruppo le mesh caricate
            let sceneFileName = BABYLON.Tools.GetFilename(url);
            let name = sceneFileName;
            let idx = sceneFileName.lastIndexOf(".");
            if (idx !== -1)
                name = sceneFileName.substr(0, idx);
            const roots = meshes.filter(m => !m.parent);
            if (roots.length > 1 || (roots.length === 1 && roots[0].name !== "__root__")) {
                const root = new BABYLON.Mesh(name, this._scene);
                root.id = Zakeke.generateUUID();
                root.metadata = {
                    isRealMesh: true,
                    isGroup: true
                };
                roots.forEach(m => m.parent = root);
            }
            else if (roots.length === 1) {
                const root = roots[0];
                if (root.name === "__root__") {
                    let name = BABYLON.Tools.GetFilename(url);
                    let idx = sceneFileName.lastIndexOf(".");
                    if (idx !== -1)
                        name = sceneFileName.substring(0, idx);
                    root.name = name;
                }
            }
            this.adjustCamera(currentPluginName, false, false);
            this.setupShaderMaterialsCameraPosition();
            return meshes;
        });
    }
    setupShaderMaterialsCameraPosition() {
        if (this._scene) {
            for (let i = 0; i < this._scene.materials.length; i++) {
                var material = this._scene.materials[i];
                this.setupShaderMaterialCameraPosition(material);
            }
        }
    }
    setupShaderMaterialCameraPosition(material) {
        if (this._scene && material && material instanceof BABYLON.ShaderMaterial) {
            const camera = this._scene.activeCamera;
            if (camera)
                material.setVector3("cameraPosition", camera.position);
        }
    }
    getSceneCmScalingFactor() {
        let scale = null;
        if (this._scene) {
            let mesh = null;
            for (let i = 0; i < this._scene.meshes.length; i++) {
                var m = this._scene.meshes[i];
                if (m.metadata && m.metadata.sizecm) {
                    mesh = m;
                    break;
                }
            }
            if (mesh) {
                const boundingVectors = mesh.getHierarchyBoundingVectors();
                const min = boundingVectors.min;
                const max = boundingVectors.max;
                const boundSize = max.subtract(min);
                if (isFinite(boundSize.length())) {
                    const width = max.x - min.x;
                    const height = max.y - min.y;
                    const depth = max.z - min.z;
                    const size = mesh.metadata.sizecm;
                    if (size.width !== undefined && typeof size.width === "number" && !isNaN(size.width) && width !== 0) {
                        scale = size.width / width;
                    }
                    else if (size.height !== undefined && typeof size.height === "number" && !isNaN(size.height) && height !== 0) {
                        scale = size.height / height;
                    }
                    else if (size.depth !== undefined && typeof size.depth === "number" && !isNaN(size.depth) && depth !== 0) {
                        scale = size.depth / depth;
                    }
                    return scale;
                }
            }
        }
        return scale;
    }
    exportSceneToUsdzAsync(sceneName, sceneRootUrl, sceneID, sceneCode, arScale = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshes = this.getMeshesForAR();
            let filePrefix = sceneName || "scene";
            filePrefix = filePrefix.replace(/[^a-z0-9]/gi, '_').toLowerCase();
            return yield this.exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, sceneID, sceneCode, "usdz", arScale);
        });
    }
    exportMeshToUsdzAsync(sceneRootUrl, mesh, arScale = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshes = this.getMeshHierarchy(mesh.id);
            let filePrefix = mesh.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
            return yield this.exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, undefined, undefined, 'usdz', arScale);
        });
    }
    exportSceneToRemoteGlTFAsync(sceneName, sceneRootUrl, sceneID, sceneCode, arScale = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshes = this.getMeshesForAR();
            let filePrefix = sceneName || "scene";
            filePrefix = filePrefix.replace(/[^a-z0-9]/gi, '_').toLowerCase();
            return yield this.exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, sceneID, sceneCode, "glTF", arScale);
        });
    }
    exportMeshToRemoteGlTFAsync(sceneRootUrl, mesh, arScale = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshes = this.getMeshHierarchy(mesh.id);
            let filePrefix = mesh.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
            return yield this.exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, undefined, undefined, "glTF", arScale);
        });
    }
    exportSceneToRemoteGLBAsync(sceneName, sceneRootUrl, sceneID, sceneCode, arScale = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshes = this.getMeshesForAR();
            let filePrefix = sceneName || "scene";
            filePrefix = filePrefix.replace(/[^a-z0-9]/gi, '_').toLowerCase();
            return yield this.exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, sceneID, sceneCode, "glb", arScale);
        });
    }
    exportMeshToRemoteGLBAsync(sceneRootUrl, mesh, arScale = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshes = this.getMeshHierarchy(mesh.id);
            let filePrefix = mesh.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
            return yield this.exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, undefined, undefined, "glb", arScale);
        });
    }
    exportSceneToARMultiformatAsync(sceneName, sceneRootUrl, formats = ["usdz", "glb", "png"], arScale = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshes = this.getMeshesForAR();
            let filePrefix = sceneName || "scene";
            filePrefix = filePrefix.replace(/[^a-z0-9]/gi, '_').toLowerCase();
            return yield this.exportMeshesToARMultiformatAsync(filePrefix, sceneRootUrl, meshes, formats, arScale);
        });
    }
    exportMeshToARMultiformatAsync(sceneRootUrl, mesh, formats = ["usdz", "glb", "png"], arScale = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshes = this.getMeshHierarchy(mesh.id);
            let filePrefix = mesh.name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
            return yield this.exportMeshesToARMultiformatAsync(filePrefix, sceneRootUrl, meshes, formats, arScale);
        });
    }
    getGltfBlobForARExport(filePrefix, sceneRootUrl, meshes) {
        return __awaiter(this, void 0, void 0, function* () {
            // Opzioni di serializzazione
            const options = {
                meshes: meshes,
                materials: this.getMeshesMaterials(meshes),
                transformNodes: undefined,
                lights: undefined,
                exportTextureUrls: sceneRootUrl !== null && sceneRootUrl !== undefined,
                rootUrl: sceneRootUrl,
                shouldExportNode: (node) => {
                    for (let i = 0; i < meshes.length; i++)
                        if (meshes[i] === node)
                            return true;
                    return false;
                }
            };
            const gltf = yield BABYLON.GLTF2Export.GLTFAsync(this._scene, filePrefix, options);
            if (gltf) {
                const zip = new JSZip();
                // Evito di fare l'upload delle immagini che posso scaricare lato server
                const serverImages = gltf.serverImages && gltf.glTFFiles.hasOwnProperty("TextureUrls.txt") ? gltf.serverImages : [];
                for (var key in gltf.glTFFiles) {
                    if (serverImages.indexOf(key) === -1) {
                        let blob = gltf.glTFFiles[key];
                        if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_2__.StringTools.EndsWith(key, ".gltf") || _Misc_StringTools__WEBPACK_IMPORTED_MODULE_2__.StringTools.EndsWith(key, ".bin")) {
                            zip.file(key, blob, {
                                compression: "DEFLATE",
                                compressionOptions: {
                                    level: 9 // force a compression and a compression level for this file
                                }
                            });
                        }
                        else {
                            zip.file(key, blob, {
                                compression: "STORE" // no compression
                            });
                        }
                    }
                }
                let blob = yield zip.generateAsync({ type: "blob" });
                if (blob) {
                    blob = blob;
                    blob.lastModifiedDate = new Date();
                    blob.name = "arobj.zip";
                    return blob;
                }
            }
            return null;
        });
    }
    exportMeshesToARAsync(filePrefix, sceneRootUrl, meshes, sceneID, sceneCode, fileFormat = 'usdz', arScale = true) {
        return __awaiter(this, void 0, void 0, function* () {
            let arFileUrl = "";
            if (sceneID && sceneCode && Zakeke.config) {
                // Verifico se il file è già disponibile
                const url = Zakeke.config.baseApiUrl + "artasks/cachedresults/" + sceneID + "/" + sceneCode + "/" + fileFormat;
                try {
                    arFileUrl = yield jQuery.ajax({
                        url: url,
                        data: null,
                        cache: false,
                        contentType: false,
                        processData: false,
                        type: 'GET'
                    });
                }
                catch (err) {
                    arFileUrl = "";
                }
            }
            if (!arFileUrl) {
                // Il file va generato
                let scale = this.getSceneCmScalingFactor();
                /* Lascio l'adattamento al servizio di esportazione
                if (fileFormat !== "usdz" && scale)
                    scale /= 100;
                */
                const blob = yield this.getGltfBlobForARExport(filePrefix, sceneRootUrl, meshes);
                if (blob) {
                    const taskOptions = {
                        flipTextures: true, formats: [fileFormat]
                    };
                    if (sceneID)
                        taskOptions.sceneID = sceneID;
                    if (sceneCode)
                        taskOptions.sceneCode = sceneCode;
                    if (scale)
                        taskOptions.scale = scale;
                    let isOwin = true;
                    if (window["isOwin"] != undefined)
                        isOwin = window["isOwin"];
                    const chunkedTask = new _composer_Components_ChunkedTask__WEBPACK_IMPORTED_MODULE_0__.Task("artasks", window["token"], isOwin);
                    const uploadResult = yield chunkedTask.upload(blob, taskOptions);
                    if (uploadResult && uploadResult.length > 0) {
                        arFileUrl = uploadResult[0].arFileUrl;
                    }
                }
            }
            return arFileUrl;
        });
    }
    exportMeshesToARMultiformatAsync(filePrefix, sceneRootUrl, meshes, formats = ["usdz", "glb", "png"], arScale = true) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = [];
            const scale = this.getSceneCmScalingFactor();
            const blob = yield this.getGltfBlobForARExport(filePrefix, sceneRootUrl, meshes);
            if (blob) {
                const taskOptions = {
                    flipTextures: true, formats: formats
                };
                if (scale)
                    taskOptions.scale = scale;
                let isOwin = true;
                if (window["isOwin"] !== undefined)
                    isOwin = window["isOwin"];
                const chunkedTask = new _composer_Components_ChunkedTask__WEBPACK_IMPORTED_MODULE_0__.Task("artasks", window["token"], isOwin);
                const uploadResult = yield chunkedTask.upload(blob, taskOptions);
                if (uploadResult && uploadResult.length > 0) {
                    for (let i = 0; i < uploadResult.length; i++) {
                        const res = uploadResult[i];
                        result.push(res);
                    }
                    //result = [...uploadResult];
                }
            }
            return result;
        });
    }
    // Metodi per esportazione on-the-fly client side
    exportSceneToLocalGlTFBlobsAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const filePrefix = Zakeke.generateUUID();
            const options = this.getSceneToGltfExportOptions();
            const gltf = yield BABYLON.GLTF2Export.GLTFAsync(this._scene, filePrefix, options);
            let blobs = [];
            for (let key in gltf.glTFFiles) {
                blobs.push(gltf.glTFFiles[key]);
            }
            return blobs;
        });
    }
    exportSceneToLocalGlTFUrlsAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const urls = [];
            const filePrefix = Zakeke.generateUUID();
            const options = this.getSceneToGltfExportOptions();
            const gltf = yield BABYLON.GLTF2Export.GLTFAsync(this._scene, filePrefix, options);
            if (gltf) {
                for (let key in gltf.glTFFiles) {
                    var blob = gltf.glTFFiles[key];
                    urls.push(this.getGltfFileUrl(key, blob));
                }
            }
            return urls;
        });
    }
    downloadSceneLocalGltfAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const filePrefix = Zakeke.generateUUID();
            const options = this.getSceneToGltfExportOptions();
            const gltf = yield BABYLON.GLTF2Export.GLTFAsync(this._scene, filePrefix, options);
            if (gltf) {
                gltf.downloadFiles();
            }
        });
    }
    exportSceneToLocalGLBBlobAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.getSceneLocalGLBBlobInfoAsync();
            if (result) {
                return result.blob;
            }
            return null;
        });
    }
    exportSceneToLocalGLBBase64Async() {
        return __awaiter(this, void 0, void 0, function* () {
            let dataUrl = null;
            const info = yield this.getSceneLocalGLBBlobInfoAsync();
            if (info && info.blob instanceof Blob) {
                let reader = new FileReader();
                reader.readAsDataURL(info.blob);
                reader.onloadend = () => {
                    let res = reader.result;
                    if (typeof res === "string")
                        dataUrl = res;
                };
            }
            return dataUrl;
        });
    }
    exportSceneToLocalGLBUrlAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            let url = null;
            const info = yield this.getSceneLocalGLBBlobInfoAsync();
            if (info && info.name && info.blob instanceof Blob) {
                url = this.getGltfFileUrl(info.name, info.blob);
            }
            return url;
        });
    }
    downloadSceneLocalGLBAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const info = yield this.getSceneLocalGLBBlobInfoAsync();
            if (info && info.name && info.blob instanceof Blob) {
                let url = this.getGltfFileUrl(info.name, info.blob);
                var link = document.createElement('a');
                document.body.appendChild(link);
                link.setAttribute("type", "hidden");
                link.download = info.name;
                link.href = url;
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }
        });
    }
    getSceneLocalGLBBlobInfoAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            let result = { name: null, blob: null };
            const filePrefix = Zakeke.generateUUID();
            const options = this.getSceneToGltfExportOptions();
            let gltf = yield BABYLON.GLTF2Export.GLBAsync(this._scene, filePrefix, options);
            if (gltf && gltf.glTFFiles) {
                for (let key in gltf.glTFFiles) {
                    if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_2__.StringTools.EndsWith(key, ".glb")) {
                        // Using glTF-Transform for gltf scaling and rotation
                        let scale = this.getSceneCmScalingFactor();
                        let s = 1;
                        if (scale)
                            s = scale / 100;
                        const quanternion = BABYLON.Quaternion.RotationAxis(BABYLON.Axis.Y, 2 * Math.PI);
                        const io = new _gltf_transform_core__WEBPACK_IMPORTED_MODULE_5__.WebIO();
                        const buffer = yield gltf.glTFFiles[key].arrayBuffer();
                        const doc = io.readBinary(buffer);
                        const roots = doc.getRoot().listNodes().filter(n => n.getParent() === null || n.getParent() instanceof _gltf_transform_core__WEBPACK_IMPORTED_MODULE_5__.Scene);
                        const a1 = [0, 1, 0, 0];
                        const canRotate = roots.every(r => {
                            const a2 = r.getRotation();
                            return a1.length === a2.length && a1.every((value, index) => value === a2[index]);
                        });
                        roots.forEach(r => {
                            r.setScale([s, s, s]);
                            // La questione rotazione necessita di approfondimento
                            if (canRotate) {
                                r.setRotation([quanternion.x, quanternion.y, quanternion.z, quanternion.w]);
                            }
                        });
                        const glbArray = io.writeBinary(doc); // Document → Uint8Array
                        const glbBlob = new Blob([glbArray], { type: "model/gltf-binary" });
                        // ------------------------------
                        result.name = key;
                        //result.blob = gltf.glTFFiles[key];
                        result.blob = glbBlob;
                        break;
                    }
                }
            }
            return result;
        });
    }
    // -----------------------------------------------------------------------
    // Metodi per exportazione della scena in USDZ su client (on-the-fly)
    exportSceneToLocalUSDZBlobAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.getSceneLocalUSDZBlobInfoAsync();
            if (result) {
                return result.blob;
            }
            return null;
        });
    }
    exportSceneToLocalUSDZBase64Async() {
        return __awaiter(this, void 0, void 0, function* () {
            let dataUrl = null;
            const info = yield this.getSceneLocalUSDZBlobInfoAsync();
            if (info && info.blob instanceof Blob) {
                let reader = new FileReader();
                reader.readAsDataURL(info.blob);
                reader.onloadend = () => {
                    let res = reader.result;
                    if (typeof res === "string")
                        dataUrl = res;
                };
            }
            return dataUrl;
        });
    }
    exportSceneToLocalUSDZUrlAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            let url = null;
            const info = yield this.getSceneLocalUSDZBlobInfoAsync();
            if (info && info.name && info.blob instanceof Blob) {
                url = this.getUsdzFileUrl(info.name, info.blob);
            }
            return url;
        });
    }
    downloadSceneLocalUSDZAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const info = yield this.getSceneLocalUSDZBlobInfoAsync();
            if (info && info.name && info.blob instanceof Blob) {
                let url = this.getUsdzFileUrl(info.name, info.blob);
                var link = document.createElement('a');
                document.body.appendChild(link);
                link.setAttribute("type", "hidden");
                link.download = info.name;
                link.href = url;
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            }
        });
    }
    getSceneLocalUSDZBlobInfoAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            let result = { name: null, blob: null };
            const glbInfo = yield this.getSceneLocalGLBBlobInfoAsync();
            if (glbInfo && glbInfo.name && glbInfo.blob && glbInfo.blob instanceof Blob) {
                const glbUrl = this.getGltfFileUrl(glbInfo.name, glbInfo.blob);
                const usdzBlob = yield _USDZ_UsdzHelper__WEBPACK_IMPORTED_MODULE_4__.UsdzHelper.convertGlbToUsdz(glbUrl);
                result.name = glbInfo.name.replace(".glb", ".usdz");
                result.blob = usdzBlob;
            }
            return result;
        });
    }
    // -----------------------------------------------------------------------
    getSceneToGltfExportOptions() {
        var meshes = this.getMeshesForAR();
        var options = {
            meshes: meshes,
            materials: this.getMeshesMaterials(meshes),
            transformNodes: undefined,
            lights: undefined,
            exportTextureUrls: false,
            rootUrl: null,
            shouldExportNode: (node) => {
                for (var i = 0; i < meshes.length; i++)
                    if (meshes[i] === node)
                        return true;
                return false;
            }
        };
        return options;
    }
    getGltfFileUrl(name, blob) {
        var mimeType = undefined;
        if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_2__.StringTools.EndsWith(name, ".glb")) {
            mimeType = { type: "model/gltf-binary" };
        }
        else if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_2__.StringTools.EndsWith(name, ".bin")) {
            mimeType = { type: "application/octet-stream" };
        }
        else if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_2__.StringTools.EndsWith(name, ".gltf")) {
            mimeType = { type: "model/gltf+json" };
        }
        else if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_2__.StringTools.EndsWith(name, ".jpeg")) {
            mimeType = { type: "image/jpeg" };
        }
        else if (_Misc_StringTools__WEBPACK_IMPORTED_MODULE_2__.StringTools.EndsWith(name, ".png")) {
            mimeType = { type: "image/png" };
        }
        return window.URL.createObjectURL(new Blob([blob], mimeType));
    }
    getUsdzFileUrl(name, blob) {
        var mimeType = { type: "model/vnd.usdz+zip" };
        return window.URL.createObjectURL(new Blob([blob], mimeType));
    }
    exportSceneToBabylon() {
        const serializedScene = BABYLON.SceneSerializer.Serialize(this._scene);
        const json = JSON.stringify(serializedScene);
        return json;
    }
    exportVisibleMeshesToBabylon() {
        const meshes = this.getVisibleMeshes();
        const serializedMeshes = BABYLON.SceneSerializer.SerializeMesh(meshes, false, false);
        let json = JSON.stringify(serializedMeshes);
        return json;
    }
    downloadImageFromBase64(base64, name, mimetype) {
        var a = document.createElement("a"); //Create <a>
        a.href = base64; //Image Base64 Goes here
        a.download = name; //File name Here
        a.click(); //Downloaded file
        a.remove();
    }
    getStandardMaterialTextureType(material, texture) {
        if (material.diffuseTexture === texture)
            return "diffuse";
        if (material.emissiveTexture === texture)
            return "emissive";
        if (material.ambientTexture === texture)
            return "ambient";
        if (material.lightmapTexture === texture)
            return "lightmap";
        if (material.opacityTexture === texture)
            return "opacity";
        if (material.specularTexture === texture)
            return "specular";
        if (material.reflectionTexture === texture)
            return "reflection";
        if (material.refractionTexture === texture)
            return "refraction";
        if (material.bumpTexture === texture)
            return "bump";
        return null;
    }
    getPBRMetallicRoughnessMaterialTextureType(material, texture) {
        if (material.environmentTexture === texture)
            return "environment";
        if (material.normalTexture === texture)
            return "normal";
        if (material.emissiveTexture === texture)
            return "emissive";
        if (material.occlusionTexture === texture)
            return "occlusion";
        if (material.baseTexture === texture)
            return "base";
        if (material.metallicRoughnessTexture === texture)
            return "metallicRoughness";
        return null;
    }
    getPBRSpecularGlossinessMaterialTextureType(material, texture) {
        if (material.environmentTexture === texture)
            return "environment";
        if (material.normalTexture === texture)
            return "normal";
        if (material.emissiveTexture === texture)
            return "emissive";
        if (material.occlusionTexture === texture)
            return "occlusion";
        if (material.diffuseTexture === texture)
            return "diffuse";
        if (material.specularGlossinessTexture === texture)
            return "specularGlossiness";
        return null;
    }
    getPBRMaterialTextureType(material, texture) {
        if (material.cameraColorGradingTexture === texture)
            return "cameraColorGrading";
        if (material.albedoTexture === texture)
            return "albedo";
        if (material.ambientTexture === texture)
            return "ambient";
        if (material.opacityTexture === texture)
            return "opacity";
        if (material.reflectionTexture === texture)
            return "reflection";
        if (material.emissiveTexture === texture)
            return "emissive";
        if (material.reflectivityTexture === texture)
            return "reflectivity";
        if (material.metallicTexture === texture)
            return "metallic";
        if (material.microSurfaceTexture === texture)
            return "microSurface";
        if (material.bumpTexture === texture)
            return "bump";
        if (material.lightmapTexture === texture)
            return "lightmap";
        if (material.refractionTexture === texture)
            return "refraction";
        if (material.clearCoat) {
            if (material.clearCoat.texture === texture)
                return "clearCoat";
            if (material.clearCoat.bumpTexture === texture)
                return "clearCoat_bump";
            if (material.clearCoat.tintTexture === texture)
                return "clearCoat_tint";
            if (material.clearCoat.textureRoughness === texture)
                return "clearCoat_textureRoughness";
            if (material.clearCoat.texture === texture)
                return "clearCoat_texture";
        }
        if (material.anisotropy) {
            if (material.anisotropy.texture === texture)
                return "anisotropy_texture";
        }
        if (material.sheen) {
            if (material.sheen.texture === texture)
                return "sheen_texture";
            if (material.sheen.textureRoughness === texture)
                return "sheen_textureRoughness";
        }
        if (material.subSurface) {
            if (material.subSurface.thicknessTexture === texture)
                return "subSurface_thickness";
            if (material.subSurface.refractionIntensityTexture === texture)
                return "subSurface_refractionIntensity";
            if (material.subSurface.translucencyIntensityTexture === texture)
                return "subSurface_translucencyIntensity";
        }
        return null;
    }
    getZakekePBRMaterialTextureType(material, texture) {
        if (material.albedoTexture === texture)
            return "albedo";
        if (material.bumpTexture === texture)
            return "bump";
        if (material.reflectionTexture === texture)
            return "reflection";
        if (material.matCapReflectionTexture === texture)
            return "matCapReflection";
        if (material.reflectivityTexture === texture)
            return "reflectivity";
        if (material.microsurfaceTexture === texture)
            return "microsurface";
        if (material.ambientTexture === texture)
            return "ambient";
        if (material.aoTexture === texture)
            return "ao";
        if (material.opacityTexture === texture)
            return "opacity";
        return null;
    }
    getMaterialTextureType(material, texture) {
        if (material instanceof BABYLON.StandardMaterial)
            return this.getStandardMaterialTextureType(material, texture);
        if (material instanceof BABYLON.PBRMetallicRoughnessMaterial)
            return this.getPBRMetallicRoughnessMaterialTextureType(material, texture);
        if (material instanceof BABYLON.PBRSpecularGlossinessMaterial)
            return this.getPBRSpecularGlossinessMaterialTextureType(material, texture);
        if (material instanceof BABYLON.PBRMaterial)
            return this.getPBRMaterialTextureType(material, texture);
        if (material instanceof Zakeke.PBRMaterial)
            return this.getZakekePBRMaterialTextureType(material, texture);
        return null;
    }
    getMaterialTexture(material, type) {
        if (material instanceof BABYLON.StandardMaterial) {
            switch (type) {
                case "diffuse":
                    return material.diffuseTexture;
                case "emissive":
                    return material.emissiveTexture;
                case "ambient":
                    return material.ambientTexture;
                case "lightmap":
                    return material.lightmapTexture;
                case "opacity":
                    return material.opacityTexture;
                case "specular":
                    return material.specularTexture;
                case "reflection":
                    return material.reflectionTexture;
                case "refraction":
                    return material.refractionTexture;
                case "bump":
                    return material.bumpTexture;
            }
        }
        else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
            switch (type) {
                case "environment":
                case "normal":
                case "emissive":
                case "occlusion":
                case "base":
                case "metallicRoughness":
                    return material[`${type}Texture`];
            }
        }
        else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
            switch (type) {
                case "environment":
                case "normal":
                case "emissive":
                case "occlusion":
                case "diffuse":
                case "specularGlossiness":
                    return material[`${type}Texture`];
            }
        }
        else if (material instanceof BABYLON.PBRMaterial) {
            switch (type) {
                case "cameraColorGrading":
                    return material.cameraColorGradingTexture;
                case "albedo":
                case "ambient":
                case "opacity":
                case "reflection":
                case "emissive":
                case "reflectivity":
                case "metallic":
                case "microSurface":
                case "bump":
                case "lightmap":
                    return material[`${type}Texture`];
                case "refraction":
                    return material.refractionTexture;
                case "environmentBRDF":
                    return material.environmentBRDFTexture;
                case "clearCoat_texture":
                    return material.clearCoat.texture;
                case "clearCoat_bump":
                    return material.clearCoat.bumpTexture;
                case "clearCoat_tint":
                    return material.clearCoat.tintTexture;
                case "clearCoat_textureRoughness":
                    return material.clearCoat.textureRoughness;
                case "anisotropy_texture":
                    return material.anisotropy.texture;
                case "sheen_texture":
                    return material.sheen.texture;
                case "sheen_textureRoughness":
                    return material.sheen.textureRoughness;
                case "subSurface_thickness":
                    return material.subSurface.thicknessTexture;
                case "subSurface_translucencyIntensity":
                    return material.subSurface.translucencyIntensityTexture;
                case "subSurface_refractionIntensity":
                    return material.subSurface.refractionIntensityTexture;
            }
        }
        else if (material instanceof Zakeke.PBRMaterial) {
            switch (type) {
                case "albedo":
                    return material.albedoTexture;
                case "bump":
                    return material.bumpTexture;
                case "reflection":
                    return material.reflectionTexture;
                case "matCapReflection":
                    return material.matCapReflectionTexture;
                case "reflectivity":
                    return material.reflectivityTexture;
                case "microsurface":
                    return material.microsurfaceTexture;
                case "ambient":
                    return material.ambientTexture;
                case "ao":
                    return material.aoTexture;
                case "opacity":
                    return material.opacityTexture;
            }
        }
        return null;
    }
    applyTexture(texture, material, type) {
        // Lightmap always on second channel
        if (texture && type == "lightmap") {
            texture.coordinatesIndex = 1;
            if (material instanceof BABYLON.StandardMaterial ||
                material instanceof BABYLON.PBRMaterial ||
                material instanceof BABYLON.PBRBaseSimpleMaterial)
                material.useLightmapAsShadowmap = true;
        }
        if (material instanceof BABYLON.StandardMaterial) {
            switch (type) {
                case "diffuse":
                    material.diffuseTexture = texture;
                    break;
                case "emissive":
                    material.emissiveTexture = texture;
                    break;
                case "ambient":
                    material.ambientTexture = texture;
                    break;
                case "lightmap":
                    material.lightmapTexture = texture;
                    break;
                case "opacity":
                    material.opacityTexture = texture;
                    break;
                case "specular":
                    material.specularTexture = texture;
                    break;
                case "reflection":
                    material.reflectionTexture = texture;
                    break;
                case "refraction":
                    material.refractionTexture = texture;
                    break;
                case "bump":
                    material.bumpTexture = texture;
                    break;
            }
        }
        else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
            switch (type) {
                case "environment":
                case "normal":
                case "emissive":
                case "occlusion":
                case "base":
                case "metallicRoughness":
                    material[`${type}Texture`] = texture;
                    break;
            }
        }
        else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
            switch (type) {
                case "environment":
                case "normal":
                case "emissive":
                case "occlusion":
                case "diffuse":
                case "specularGlossiness":
                    material[`${type}Texture`] = texture;
                    break;
            }
        }
        else if (material instanceof BABYLON.PBRMaterial) {
            switch (type) {
                case "cameraColorGrading":
                    material.cameraColorGradingTexture = texture;
                    break;
                case "albedo":
                case "ambient":
                case "opacity":
                case "reflection":
                case "emissive":
                case "reflectivity":
                case "metallic":
                case "microSurface":
                case "bump":
                case "lightmap":
                    material[`${type}Texture`] = texture;
                    break;
                case "refraction":
                    material.refractionTexture = texture;
                    break;
                case "environmentBRDF":
                    material.environmentBRDFTexture = texture;
                    break;
                case "clearCoat_texture":
                    material.clearCoat.texture = texture;
                    break;
                case "clearCoat_bump":
                    material.clearCoat.bumpTexture = texture;
                    break;
                case "clearCoat_tint":
                    material.clearCoat.tintTexture = texture;
                    break;
                case "clearCoat_textureRoughness":
                    material.clearCoat.textureRoughness = texture;
                    break;
                case "anisotropy_texture":
                    material.anisotropy.texture = texture;
                    break;
                case "sheen_texture":
                    material.sheen.texture = texture;
                    break;
                case "sheen_textureRoughness":
                    material.sheen.textureRoughness = texture;
                    break;
                case "subSurface_thickness":
                    material.subSurface.thicknessTexture = texture;
                    break;
                case "subSurface_translucencyIntensity":
                    material.subSurface.translucencyIntensityTexture = texture;
                    break;
                case "subSurface_refractionIntensity":
                    material.subSurface.refractionIntensityTexture = texture;
                    break;
            }
        }
        else if (material instanceof BABYLON.ShaderMaterial) {
            if (texture && texture instanceof BABYLON.Texture)
                material.setTexture(type, texture);
            else
                material.removeTexture(type);
        }
        else if (material instanceof Zakeke.PBRMaterial) {
            switch (type) {
                case "albedo":
                    material.albedoTexture = texture;
                    break;
                case "bump":
                    material.bumpTexture = texture;
                    break;
                case "reflection":
                    material.reflectionTexture = texture;
                    break;
                case "matCapReflection":
                    material.matCapReflectionTexture = texture;
                    break;
                case "reflectivity":
                    material.reflectivityTexture = texture;
                    break;
                case "microsurface":
                    material.microsurfaceTexture = texture;
                    break;
                case "ambient":
                    material.ambientTexture = texture;
                    break;
                case "ao":
                    material.aoTexture = texture;
                    break;
                case "opacity":
                    material.opacityTexture = texture;
                    break;
            }
        }
    }
    applyTextureOnSerializedMaterial(serializedTexture, serializedMaterial, textureType, materialType) {
        // Lightmap always on second channel
        if (serializedTexture && textureType == "lightmap") {
            serializedTexture.coordinatesIndex = 1;
            if (materialType === "BABYLON.StandardMaterial" ||
                materialType === "BABYLON.PBRMaterial" ||
                materialType === "BABYLON.PBRBaseSimpleMaterial")
                serializedMaterial["useLightmapAsShadowmap"] = true;
        }
        if (materialType === "BABYLON.StandardMaterial") {
            serializedMaterial[`${textureType}Texture`] = serializedTexture;
        }
        else if (materialType === "BABYLON.PBRMetallicRoughnessMaterial") {
            serializedMaterial[`${textureType}Texture`] = serializedTexture;
        }
        else if (materialType === "BABYLON.PBRSpecularGlossinessMaterial") {
            serializedMaterial[`${textureType}Texture`] = serializedTexture;
        }
        else if (materialType === "BABYLON.PBRMaterial") {
            switch (textureType) {
                case "cameraColorGrading":
                    serializedMaterial["cameraColorGradingTexture"] = serializedTexture;
                    break;
                case "albedo":
                case "ambient":
                case "opacity":
                case "reflection":
                case "emissive":
                case "reflectivity":
                case "metallic":
                case "microSurface":
                case "bump":
                case "lightmap":
                case "refraction":
                    serializedMaterial[`${textureType}Texture`] = serializedTexture;
                    break;
                case "environmentBRDF":
                    serializedMaterial.environmentBRDFTexture = serializedTexture;
                    break;
                case "clearCoat_texture":
                    serializedMaterial.clearCoat.texture = serializedTexture;
                    break;
                case "clearCoat_bump":
                    serializedMaterial.clearCoat.bumpTexture = serializedTexture;
                    break;
                case "clearCoat_tint":
                    serializedMaterial.clearCoat.tintTexture = serializedTexture;
                    break;
                case "clearCoat_textureRoughness":
                    serializedMaterial.clearCoat.textureRoughness = serializedTexture;
                    break;
                case "anisotropy_texture":
                    serializedMaterial.anisotropy.texture = serializedTexture;
                    break;
                case "sheen_texture":
                    serializedMaterial.sheen.texture = serializedTexture;
                    break;
                case "sheen_textureRoughness":
                    serializedMaterial.sheen.textureRoughness = serializedTexture;
                    break;
                case "subSurface_thickness":
                    serializedMaterial.subSurface.thicknessTexture = serializedTexture;
                    break;
                case "subSurface_translucencyIntensity":
                    serializedMaterial.subSurface.translucencyIntensityTexture = serializedTexture;
                    break;
                case "subSurface_refractionIntensity":
                    serializedMaterial.subSurface.refractionIntensityTexture = serializedTexture;
                    break;
            }
        }
        else if (materialType === "Zakeke.PBRMaterial") {
            serializedMaterial[`${textureType}Texture`] = serializedTexture;
        }
    }
    getSerializedMaterialTexture(serializedMaterial, textureType, materialType) {
        if (materialType === "BABYLON.StandardMaterial") {
            return serializedMaterial[`${textureType}Texture`];
        }
        else if (materialType === "BABYLON.PBRMetallicRoughnessMaterial") {
            return serializedMaterial[`${textureType}Texture`];
        }
        else if (materialType === "BABYLON.PBRSpecularGlossinessMaterial") {
            return serializedMaterial[`${textureType}Texture`];
        }
        else if (materialType === "BABYLON.PBRMaterial") {
            switch (textureType) {
                case "cameraColorGrading":
                    return serializedMaterial["cameraColorGradingTexture"];
                case "albedo":
                case "ambient":
                case "opacity":
                case "reflection":
                case "emissive":
                case "reflectivity":
                case "metallic":
                case "microSurface":
                case "bump":
                case "lightmap":
                case "refraction":
                    return serializedMaterial[`${textureType}Texture`];
                case "environmentBRDF":
                    return serializedMaterial.environmentBRDFTexture;
                case "clearCoat_texture":
                    return serializedMaterial.clearCoat.texture;
                case "clearCoat_bump":
                    return serializedMaterial.clearCoat.bumpTexture;
                case "clearCoat_tint":
                    return serializedMaterial.clearCoat.tintTexture;
                case "clearCoat_textureRoughness":
                    return serializedMaterial.clearCoat.textureRoughness;
                case "anisotropy_texture":
                    return serializedMaterial.anisotropy.texture;
                case "sheen_texture":
                    return serializedMaterial.sheen.texture;
                case "sheen_textureRoughness":
                    return serializedMaterial.sheen.textureRoughness;
                case "subSurface_thickness":
                    return serializedMaterial.subSurface.thicknessTexture;
                case "subSurface_translucencyIntensity":
                    return serializedMaterial.subSurface.translucencyIntensityTexture;
                case "subSurface_refractionIntensity":
                    return serializedMaterial.subSurface.refractionIntensityTexture;
            }
        }
        else if (materialType === "Zakeke.PBRMaterial") {
            return serializedMaterial[`${textureType}Texture`];
        }
        return null;
    }
    getMaterialTypeName(material) {
        if (material instanceof BABYLON.StandardMaterial)
            return "BABYLON.StandardMaterial";
        if (material instanceof BABYLON.PBRMetallicRoughnessMaterial)
            return "BABYLON.PBRMetallicRoughnessMaterial";
        if (material instanceof BABYLON.PBRSpecularGlossinessMaterial)
            return "BABYLON.PBRSpecularGlossinessMaterial";
        if (material instanceof BABYLON.PBRMaterial)
            return "BABYLON.PBRMaterial";
        if (material instanceof BABYLON.ShaderMaterial)
            return "BABYLON.ShaderMaterial";
        if (material instanceof Zakeke.PBRMaterial)
            return "Zakeke.PBRMaterial";
        return "BABYLON.StandardMaterial";
    }
    exportMeshToBabylon(mesh) {
        return __awaiter(this, void 0, void 0, function* () {
            const meshes = this.getMeshHierarchy(mesh.id);
            return yield this.exportMeshesToBabylon(meshes);
        });
    }
    exportMeshesToBabylon(meshes) {
        return __awaiter(this, void 0, void 0, function* () {
            const materials = this.getMeshesMaterials(meshes);
            // Save previous serializable property value
            const meshSerializability = meshes.map(m => {
                return { id: m.id, doNotSerialize: m.doNotSerialize };
            });
            const materialSerializability = materials.map(m => {
                return { id: m.id, doNotSerialize: m.doNotSerialize };
            });
            // set all serializable
            meshes.forEach(m => m.doNotSerialize = false);
            materials.forEach(m => m.doNotSerialize = false);
            try {
                const materialTextures = {};
                for (let i = 0; i < materials.length; i++) {
                    const material = materials[i];
                    const materialID = material.id;
                    const textures = this.getMaterialDynamicTextures(material);
                    if (textures.length > 0) {
                        materialTextures[materialID] = {
                            materialType: this.getMaterialTypeName(material),
                            textures: []
                        };
                        for (let j = 0; j < textures.length; j++) {
                            const texture = textures[j];
                            const textureID = Zakeke.generateUUID();
                            const type = this.getMaterialTextureType(material, texture);
                            const base64String = yield this.exportTextureToBase64Async(texture, "image/png");
                            if (type && base64String) {
                                const textureData = { id: textureID, type, base64String, isProcedural: texture instanceof BABYLON.ProceduralTexture };
                                materialTextures[materialID].textures.push(textureData);
                            }
                        }
                    }
                }
                const serializedMeshes = BABYLON.SceneSerializer.SerializeMesh(meshes, false, false);
                // now for each dynamic texture we embed the base64 data uri
                for (let i = 0; i < serializedMeshes.materials.length; i++) {
                    const serializedMaterial = serializedMeshes.materials[i];
                    const propertyNames = Object.getOwnPropertyNames(serializedMaterial)
                        .filter(n => n.slice(-"Texture".length) === "Texture" && typeof serializedMaterial[n] === "object");
                    const materialID = serializedMaterial.id;
                    if (materialTextures.hasOwnProperty(materialID)) {
                        const materialInfo = materialTextures[materialID];
                        const materialType = materialInfo.materialType;
                        const textureInfoArray = materialInfo.textures;
                        for (let j = 0; j < textureInfoArray.length; j++) {
                            const textureInfo = textureInfoArray[j];
                            const serializedTexture = this.getSerializedMaterialTexture(serializedMaterial, textureInfo.type, materialInfo.materialType);
                            if (serializedTexture) {
                                if (textureInfo.isProcedural) {
                                    const tempTexture = new BABYLON.Texture(textureInfo.base64String, this._scene, undefined, undefined, undefined, undefined);
                                    yield SceneHelper.whenTextureIsReadyAsync(tempTexture);
                                    tempTexture.uScale = serializedTexture.uScale;
                                    tempTexture.vScale = serializedTexture.vScale;
                                    tempTexture.uOffset = serializedTexture.uOffset;
                                    tempTexture.vOffset = serializedTexture.vOffset;
                                    tempTexture.uAng = serializedTexture.uAng;
                                    tempTexture.vAng = serializedTexture.vAng;
                                    tempTexture.level = serializedTexture.level;
                                    tempTexture.coordinatesIndex = serializedTexture.coordinatesIndex;
                                    tempTexture.coordinatesMode = serializedTexture.coordinatesMode;
                                    tempTexture.wrapU = serializedTexture.wrapU;
                                    tempTexture.wrapV = serializedTexture.wrapV;
                                    const newTextureJson = tempTexture.serialize();
                                    newTextureJson.url = textureInfo.base64String;
                                    newTextureJson.name = "prcedural texture";
                                    this.applyTextureOnSerializedMaterial(newTextureJson, serializedMaterial, textureInfo.type, materialType);
                                    tempTexture.dispose();
                                }
                            }
                            else {
                                serializedTexture.url = textureInfo.base64String;
                                serializedTexture.name = "dynamic texture";
                            }
                        }
                    }
                }
                let json = JSON.stringify(serializedMeshes);
                // Reset doNotSerialize property value
                meshes.forEach(m => { var _a; return m.doNotSerialize = (_a = meshSerializability.find(s => s.id === m.id)) === null || _a === void 0 ? void 0 : _a.doNotSerialize; });
                materials.forEach(m => m.doNotSerialize = materialSerializability.find(s => s.id === m.id).doNotSerialize);
                return json;
            }
            finally {
                meshes.forEach(m => { var _a; return m.doNotSerialize = (_a = meshSerializability.find(s => s.id === m.id)) === null || _a === void 0 ? void 0 : _a.doNotSerialize; });
                materials.forEach(m => m.doNotSerialize = materialSerializability.find(s => s.id === m.id).doNotSerialize);
            }
        });
    }
    exportMeshesForTyOnToBabylon() {
        return __awaiter(this, void 0, void 0, function* () {
            const meshes = this.getMeshesForTryOn();
            return yield this.exportMeshesToBabylon(meshes);
        });
    }
    downloadBlob(blob) {
        const link = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.download = "mesh.json";
        a.href = link;
        a.click();
        URL.revokeObjectURL(link);
    }
    downloadMeshBabylonAsync(mesh) {
        return __awaiter(this, void 0, void 0, function* () {
            const json = yield this.exportMeshToBabylon(mesh);
            if (json) {
                const blob = new Blob([json], { type: "application/json" });
                this.downloadBlob(blob);
            }
        });
    }
    downloadMeshesBabylonAsync(meshes) {
        return __awaiter(this, void 0, void 0, function* () {
            const json = yield this.exportMeshesToBabylon(meshes);
            if (json) {
                const blob = new Blob([json], { type: "application/json" });
                this.downloadBlob(blob);
            }
        });
    }
    loadAllDelayedMaterialsAsync(rootUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            let results = [];
            if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
                var delayedMaterials = {};
                for (var materialID in this._scene.metadata.delayedMaterials) {
                    delayedMaterials[materialID] = {
                        name: this._scene.metadata.delayedMaterials[materialID].name,
                        file: this._scene.metadata.delayedMaterials[materialID].file
                    };
                }
                results = yield this.loadMaterialsAsync(rootUrl, delayedMaterials);
            }
            return results;
        });
    }
    loadDelayedMaterialsAsync(rootUrl, materialIDs) {
        return __awaiter(this, void 0, void 0, function* () {
            let results = [];
            if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
                var delayedMaterials = {};
                for (var i = 0; i < materialIDs.length; i++) {
                    if (this._scene.metadata.delayedMaterials.hasOwnProperty(materialIDs[i])) {
                        delayedMaterials[materialIDs[i]] = {
                            name: this._scene.metadata.delayedMaterials[materialIDs[i]].name,
                            file: this._scene.metadata.delayedMaterials[materialIDs[i]].file
                        };
                    }
                }
                results = yield this.loadMaterialsAsync(rootUrl, delayedMaterials);
            }
            return results;
        });
    }
    loadDelayedMaterialAsync(rootUrl, materialID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._scene && this._scene.metadata && this._scene.metadata.delayedMaterials) {
                var delayedMaterials = {};
                if (this._scene.metadata.delayedMaterials.hasOwnProperty(materialID)) {
                    delayedMaterials[materialID] = {
                        name: this._scene.metadata.delayedMaterials[materialID].name,
                        file: this._scene.metadata.delayedMaterials[materialID].file
                    };
                    let materials = yield this.loadMaterialsAsync(rootUrl, delayedMaterials);
                    if (materials.length > 0)
                        return materials[0];
                }
            }
            return null;
        });
    }
    loadMaterialsAsync(rootUrl, delayedMaterials) {
        return __awaiter(this, void 0, void 0, function* () {
            const newMaterials = [];
            let promises = [];
            for (let materialID in delayedMaterials) {
                const material = this._scene.getMaterialByID(materialID);
                if (!material) {
                    const info = delayedMaterials[materialID];
                    promises.push(this.loadMaterialInternalAsync(materialID, rootUrl, info.file));
                }
                else {
                    newMaterials.push(material);
                }
            }
            const results = yield Promise.all(promises);
            for (let i = 0; i < results.length; i++) {
                const result = results[i];
                const jsonObj = JSON.parse(result);
                const material = BABYLON.Material.Parse(jsonObj, this._scene, rootUrl);
                if (material) {
                    Logger.info("Waiting for material ready: " + material.id + " - " + material.name);
                    yield SceneHelper.whenAllMaterialTexturesAreReady(material);
                    Logger.info("Material ready: " + material.id + " - " + material.name);
                    newMaterials.push(material);
                }
            }
            this.setupShaderMaterialsCameraPosition();
            return newMaterials;
        });
    }
    loadMaterialInternalAsync(materialID, rootUrl, fileName) {
        Logger.info("Loading delayed material: " + materialID);
        if (this._loadingMaterials.hasOwnProperty(materialID))
            return this._loadingMaterials[materialID];
        let sep = _Misc_StringTools__WEBPACK_IMPORTED_MODULE_2__.StringTools.EndsWith(rootUrl, "/") ? "" : "/";
        var url = rootUrl + sep + fileName;
        let promise = new Promise((resolve, reject) => {
            BABYLON.Tools.LoadFile(url, (data) => {
                Logger.info("Loaded delayed material: " + materialID);
                resolve(data);
                delete this._loadingMaterials[materialID];
            }, undefined, undefined, false, (request, exception) => {
                reject(exception);
                delete this._loadingMaterials[materialID];
            });
        });
        this._loadingMaterials[materialID] = promise;
        return promise;
    }
    showMesh(meshID) {
        this.showHideMesh(meshID, true);
    }
    hideMesh(meshID) {
        this.showHideMesh(meshID, false);
    }
    showHideMesh(meshID, show) {
        var showHideWithChildren = (parent, show) => {
            parent.isVisible = show;
            var children = parent.getChildMeshes();
            if (children) {
                children.forEach((child) => {
                    showHideWithChildren(child, show);
                });
            }
        };
        var mesh = this._scene.getMeshByID(meshID);
        if (mesh) {
            showHideWithChildren(mesh, show);
        }
    }
    changeMaterialColor(material, propertyName, nextColor) {
        let mesh = null;
        for (let i = 0; i < this._scene.meshes.length; i++) {
            let m = this._scene.meshes[i];
            if (m.material === material) {
                mesh = m;
                break;
            }
        }
        // Animation gives problems on PBR materials
        //if (mesh) {
        //    var animation = new BABYLON.Animation("colorAnimation", "material." + propertyName, 60, BABYLON.Animation.ANIMATIONTYPE_COLOR3, BABYLON.Animation.ANIMATIONLOOPMODE_CONSTANT);
        //    // keys
        //    var keys = [{
        //        frame: 0,
        //        value: material[propertyName]
        //    }, {
        //        frame: 60,
        //        value: nextColor
        //    }];
        //    animation.setKeys(keys);
        //    mesh.animations.push(animation);
        //    var animatable = this._scene.beginAnimation(mesh, 0, 60, false, 3);
        //    // Remove animations
        //    animatable.onAnimationEnd = function () {
        //        if (mesh) {
        //            for (let i = 0; i < mesh.animations.length; i++) {
        //                var anim = mesh.animations[i];
        //                if (anim === animation)
        //                    mesh.animations.splice(i--, 1);
        //            }
        //        }
        //    };
        //} else {
        //    material[propertyName] = nextColor;
        //}
        material[propertyName] = nextColor;
    }
    applyMaterialByName(name, mesh) {
        if (this._scene) {
            let material = this._scene.getMaterialByName(name);
            if (material)
                this.applyMaterial(material, mesh);
        }
    }
    applyMaterial(material, mesh) {
        var applyWithChildren = (parent) => {
            if (parent.subMeshes && parent.subMeshes.length > 0 && parent.material && parent.material instanceof BABYLON.MultiMaterial) {
                for (let i = 0; i < parent.subMeshes.length; i++) {
                    let subMesh = parent.subMeshes[i];
                    this.applyMaterialToSubMesh(material, parent, subMesh);
                }
            }
            else {
                parent.material = material;
            }
            var children = parent.getChildMeshes();
            if (children) {
                children.forEach((child) => {
                    applyWithChildren(child);
                });
            }
        };
        if (mesh) {
            applyWithChildren(mesh);
        }
    }
    applyMaterialToSubMeshByName(name, mesh, subMesh) {
        var material = this._scene.getMaterialByName(name);
        if (material)
            this.applyMaterialToSubMesh(material, mesh, subMesh);
    }
    applyMaterialToSubMesh(material, mesh, subMesh) {
        const idx = subMesh.materialIndex;
        const m = mesh || subMesh.getMesh();
        if (m.material instanceof BABYLON.MultiMaterial &&
            idx >= 0 && idx < m.material.subMaterials.length) {
            m.material.subMaterials[idx] = material;
        }
    }
    getSubMeshMaterial(mesh, subMesh) {
        const idx = subMesh.materialIndex;
        const m = mesh || subMesh.getMesh();
        if (m.material instanceof BABYLON.MultiMaterial &&
            idx >= 0 && idx < m.material.subMaterials.length) {
            return m.material.subMaterials[idx];
        }
        return null;
    }
    prefetchTexturesFormMeshAsync(mesh) {
        return __awaiter(this, void 0, void 0, function* () {
            if (mesh.material)
                yield this.prefetchTexturesForMaterialAsync(mesh.material);
            var children = mesh.getChildMeshes();
            for (let i = 0; i < children.length; i++) {
                let child = children[i];
                if (child.material)
                    yield this.prefetchTexturesForMaterialAsync(child.material);
            }
        });
    }
    prefetchTexturesForMaterialAsync(material) {
        return __awaiter(this, void 0, void 0, function* () {
            if (material) {
                var textures = this.getTexturesForMaterial(material);
                for (let i = 0; i < textures.length; i++) {
                    yield SceneHelper.whenTextureIsReadyAsync(textures[i]);
                }
            }
        });
    }
    checkDelayState(mesh) {
        if (mesh instanceof BABYLON.Mesh) {
            mesh._checkDelayState();
        }
        var children = mesh.getChildMeshes();
        children.forEach(child => this.checkDelayState(child));
    }
    // Crea una nuova mesh data da una minima espansione di quella passata in input
    // in modo che ne costituisca un rivestimento
    createEnvelopeMesh(mesh) {
        let delta = 0.01;
        const boundingVectors = mesh.getHierarchyBoundingVectors();
        if (boundingVectors) {
            const min = boundingVectors.min;
            const max = boundingVectors.max;
            const boundingInfo = new BABYLON.BoundingInfo(min, max);
            const boundingSphere = boundingInfo.boundingSphere;
            const radius = boundingSphere.radius;
            delta = radius * 0.0050;
        }
        const newMesh = this.cloneMesh(mesh.id, true, true);
        if (newMesh && newMesh instanceof BABYLON.Mesh) {
            this.expandMesh(newMesh, delta);
        }
        return newMesh;
    }
    expandMesh(mesh, delta) {
        const expander = new _MeshExpander_MeshExpander__WEBPACK_IMPORTED_MODULE_3__.MeshExpander();
        if (mesh && mesh instanceof BABYLON.Mesh) {
            expander.expandMesh(mesh, delta);
            const children = mesh.getChildMeshes();
            for (const child of children) {
                if (child instanceof BABYLON.Mesh) {
                    expander.expandMesh(child, delta);
                }
            }
        }
    }
    cloneMesh(id, duplicateGeometry = false, updatableGeometry = false) {
        let newMesh = null;
        if (this._scene) {
            const mesh = this._scene.getMeshByID(id);
            if (mesh) {
                const name = this.getNextIncrementalName(mesh.name);
                newMesh = mesh.clone(name, mesh.parent);
                if (newMesh) {
                    newMesh.id = Zakeke.generateUUID();
                    if (duplicateGeometry) {
                        this.duplicateGeometry(mesh, newMesh, updatableGeometry);
                    }
                    const children = newMesh.getChildMeshes();
                    for (const child of children) {
                        const originalChild = this._scene.getMeshByID(child.id);
                        child.id = Zakeke.generateUUID();
                        const parentName = child.parent ? child.parent.name : null;
                        if (parentName) {
                            // Clean the sub folder name that use babylon
                            const index = child.name.indexOf(parentName + ".") + parentName.length + 1;
                            child.name = child.name.substr(index);
                        }
                        if (originalChild && duplicateGeometry) {
                            this.duplicateGeometry(originalChild, child, updatableGeometry);
                        }
                    }
                }
            }
        }
        return newMesh;
    }
    duplicateGeometry(originalMesh, newMesh, updatable = false) {
        if (originalMesh instanceof BABYLON.Mesh && newMesh instanceof BABYLON.Mesh) {
            const vertexData = BABYLON.VertexData.ExtractFromMesh(originalMesh, true, true);
            const geometry = new BABYLON.Geometry(Zakeke.generateUUID(), newMesh.getScene(), vertexData, updatable, newMesh);
            return geometry;
        }
        return null;
    }
    // Material metadata
    getSceneMaterialMetadata(materialID) {
        // i metadata dei materiali non vengono serializzati in Babylon JS,
        // sono quindi costretto a salvarli nei metadati della scena.
        if (this._scene && this._scene.metadata && this._scene.metadata.materialsMetadata &&
            this._scene.metadata.materialsMetadata.hasOwnProperty(materialID))
            return this._scene.metadata.materialsMetadata[materialID];
        return null;
    }
    getOrCreateSceneMaterialMetadata(materialID) {
        let metadata = this.getSceneMaterialMetadata(materialID);
        if (!metadata) {
            metadata = {};
            if (!this._scene.metadata)
                this._scene.metadata = {};
            if (!this._scene.metadata.materialsMetadata)
                this._scene.metadata.materialsMetadata = {};
            this._scene.metadata.materialsMetadata[materialID] = metadata;
        }
        return metadata;
    }
    removeSceneMaterialMetadata(materialID) {
        if (this._scene.metadata && this._scene.metadata.materialsMetadata && this._scene.metadata.materialsMetadata.hasOwnProperty(materialID)) {
            delete this._scene.metadata.materialsMetadata[materialID];
        }
    }
    offloadAllUnusedMaterials() {
        const materials = this.getAllUnusedMaterials();
        materials.forEach(m => this.offloadMaterial(m.id));
    }
    // Salva la serializzazione del materiale e lo rimuove dalla scena (eliminando anche le relative texture).
    // Lo scopo è quello di liberare la memoria occupata dalle texture
    offloadMaterial(materialID) {
        const material = this._scene.getMaterialByID(materialID);
        if (material && material.id !== "default material") {
            // Verifico che il material non sia assegnato ad alcuna mesh
            const meshes = this.getMeshesUsingMaterial(materialID);
            if (meshes.length === 0) {
                Logger.info("Offloading material: " + material.id + " - " + material.name);
                /* le texture verranno eliminate contestulmente alla dispose del materiale
                const textures = material.getActiveTextures();
                const removableTextures: BABYLON.BaseTexture[] = [];
                textures.forEach(t => {
                    const usingTextures: BABYLON.Material[] = this.getMaterialsUsingTexture(t);
                    if (usingTextures.length === 1 && usingTextures[0].id === materialID)
                        removableTextures.push(t);
                });
                */
                // Serializzo il materiale e lo salvo nella scena
                if (!this._scene.metadata)
                    this._scene.metadata = {};
                if (!this._scene.metadata.offloadedMaterials)
                    this._scene.metadata.offloadedMaterials = {};
                this._scene.metadata.offloadedMaterials[materialID] = this.getOffloadedMaterialInfo(material);
                // Dispose del materiale e delle relative texture
                Logger.info("Disposing material: " + materialID);
                material.dispose(false, true);
                /*
                for (let i = 0; i < removableTextures.length; i++) {
                    const removableTexture = removableTextures[i];
                    Logger.info("Disposing texture: ", removableTexture.name);
                    removableTexture.dispose();
                }
                */
            }
        }
    }
    getOffloadedMaterialInfo(material) {
        return { name: material.name, data: material.serialize() };
    }
    // Il materiale restituito dalla versione sincrona potrebbe non essere pronto per l'applicazione alla mesh
    loadAllOffloadedMaterials(rootUrl) {
        let results = [];
        if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
            results = this.loadOffloadedMaterials(rootUrl, this._scene.metadata.offloadedMaterials);
        }
        return results;
    }
    loadOffloadedMaterialsByIDs(rootUrl, materialIDs) {
        let results = [];
        if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
            const offloadedMaterials = {};
            for (let i = 0; i < materialIDs.length; i++) {
                if (this._scene.metadata.offloadedMaterials.hasOwnProperty(materialIDs[i])) {
                    offloadedMaterials[materialIDs[i]] = {
                        name: this._scene.metadata.offloadedMaterials[materialIDs[i]].name,
                        data: this._scene.metadata.offloadedMaterials[materialIDs[i]].data
                    };
                }
            }
            results = this.loadOffloadedMaterials(rootUrl, offloadedMaterials);
        }
        return results;
    }
    loadOffloadedMaterial(rootUrl, materialID) {
        if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
            const offloadedMaterials = {};
            if (this._scene.metadata.offloadedMaterials.hasOwnProperty(materialID)) {
                offloadedMaterials[materialID] = {
                    name: this._scene.metadata.offloadedMaterials[materialID].name,
                    data: this._scene.metadata.offloadedMaterials[materialID].data
                };
                const materials = this.loadOffloadedMaterials(rootUrl, offloadedMaterials);
                if (materials.length > 0)
                    return materials[0];
            }
        }
        return null;
    }
    loadOffloadedMaterials(rootUrl, offloadedMaterials) {
        const newMaterials = [];
        for (const materialID in offloadedMaterials) {
            const info = offloadedMaterials[materialID];
            const material = this.loadOffloadedMaterialInternal(materialID, info.name, rootUrl, info.data);
            if (material)
                newMaterials.push(material);
        }
        return newMaterials;
    }
    // Il nome viene passato solo ai fini del log
    loadOffloadedMaterialInternal(materialID, name, rootUrl, data) {
        const material = this._scene.getMaterialByID(materialID);
        if (material)
            return material;
        const namePart = name ? ` - ${name}` : '';
        Logger.info("Loading offloaded material: " + materialID + namePart);
        return BABYLON.Material.Parse(data, this._scene, rootUrl);
    }
    // Nella versione asincrona si aspetta che tutte le texture del materiale caricato siano pronte
    loadAllOffloadedMaterialsAsync(rootUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            let results = [];
            if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
                results = yield this.loadOffloadedMaterialsAsync(rootUrl, this._scene.metadata.offloadedMaterials);
            }
            return results;
        });
    }
    loadOffloadedMaterialsByIDsAsync(rootUrl, materialIDs) {
        return __awaiter(this, void 0, void 0, function* () {
            let results = [];
            if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
                const offloadedMaterials = {};
                for (let i = 0; i < materialIDs.length; i++) {
                    if (this._scene.metadata.offloadedMaterials.hasOwnProperty(materialIDs[i])) {
                        offloadedMaterials[materialIDs[i]] = {
                            name: this._scene.metadata.offloadedMaterials[materialIDs[i]].name,
                            data: this._scene.metadata.offloadedMaterials[materialIDs[i]].data
                        };
                    }
                }
                results = yield this.loadOffloadedMaterialsAsync(rootUrl, offloadedMaterials);
            }
            return results;
        });
    }
    loadOffloadedMaterialAsync(rootUrl, materialID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._scene && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
                const offloadedMaterials = {};
                if (this._scene.metadata.offloadedMaterials.hasOwnProperty(materialID)) {
                    offloadedMaterials[materialID] = {
                        name: this._scene.metadata.offloadedMaterials[materialID].name,
                        data: this._scene.metadata.offloadedMaterials[materialID].data
                    };
                    const materials = yield this.loadOffloadedMaterialsAsync(rootUrl, offloadedMaterials);
                    if (materials.length > 0)
                        return materials[0];
                }
            }
            return null;
        });
    }
    loadOffloadedMaterialsAsync(rootUrl, offloadedMaterials) {
        return __awaiter(this, void 0, void 0, function* () {
            const newMaterials = [];
            const promises = [];
            for (const materialID in offloadedMaterials) {
                const info = offloadedMaterials[materialID];
                promises.push(this.loadOffloadedMaterialInternalAsync(materialID, info.name, rootUrl, info.data));
            }
            const results = yield Promise.all(promises);
            results.forEach(result => {
                if (result)
                    newMaterials.push(result);
            });
            return newMaterials;
        });
    }
    // Il nome viene passato solo ai fini del log
    loadOffloadedMaterialInternalAsync(materialID, name, rootUrl, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const material = this._scene.getMaterialByID(materialID);
            if (material)
                return material;
            const namePart = name ? ` - ${name}` : '';
            Logger.info("Loading offloaded material: " + materialID + namePart);
            const newMaterial = BABYLON.Material.Parse(data, this._scene, rootUrl);
            if (newMaterial) {
                Logger.info("Waiting for material ready: " + materialID + namePart);
                yield SceneHelper.whenAllMaterialTexturesAreReady(newMaterial);
                Logger.info("Material ready: " + materialID + namePart);
            }
            else {
                Logger.info("No material was created from offloaded material: " + materialID + namePart);
            }
            return newMaterial;
        });
    }
    loadTextureFiles(rootUrl, textureUrls) {
        if (rootUrl) {
            for (let i = 0; i < textureUrls.length; i++) {
                const url = textureUrls[i];
                const isAbsolute = /^(?:\/|[a-z]+:\/\/)/.test(url);
                let absoluteUrl = url;
                if (!isAbsolute)
                    absoluteUrl = rootUrl + url;
                const lastDot = absoluteUrl.lastIndexOf(".");
                const extension = lastDot > -1 ? absoluteUrl.substring(lastDot).toLowerCase() : "";
                const isDDS = (extension === ".dds");
                const isEnv = (extension === ".env");
                const isPng = (extension === ".png");
                const isJpg = (extension === ".jpg");
                const isHDR = (extension === ".hdr");
                if (isDDS || isEnv || isHDR) {
                    BABYLON.Tools.LoadFile(absoluteUrl, () => { });
                }
                else if (isPng || isJpg) {
                    BABYLON.Tools.LoadImage(absoluteUrl, (img) => { }, function () { }, null);
                }
            }
        }
    }
    // Recupera il materiale specificato, eventualmente caricandolo da remoto (delayed) oppure dalla cache (offloaded)
    getOrLoadMaterialAsync(materialID, rootUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            let material = this._scene.getMaterialByID(materialID);
            if (!material && this._scene.metadata) {
                if (this._scene.metadata.offloadedMaterials && this._scene.metadata.offloadedMaterials.hasOwnProperty(materialID)) {
                    material = yield this.loadOffloadedMaterialAsync(rootUrl, materialID);
                }
                else if (this._scene.metadata.delayedMaterials && this._scene.metadata.delayedMaterials.hasOwnProperty(materialID)) {
                    material = yield this.loadDelayedMaterialAsync(rootUrl, materialID);
                }
            }
            return material;
        });
    }
    getOrCreateDummyMaterial() {
        let material = this._scene.getMaterialByID(this._dummyMaterialID);
        if (!material) {
            material = new BABYLON.StandardMaterial("Dummy Material", this._scene);
            material.id = this._dummyMaterialID;
            material.metadata = { isRealMaterial: false };
        }
        return material;
    }
    isDummyMaterial(material) {
        return material.id === this._dummyMaterialID;
    }
    meshHasDummyMaterial(mesh, recursive) {
        var _a;
        if (mesh.subMeshes && mesh.subMeshes.length > 0 && mesh.material && mesh.material instanceof BABYLON.MultiMaterial) {
            for (let i = 0; i < mesh.subMeshes.length; i++) {
                const subMesh = mesh.subMeshes[i];
                const idx = subMesh.materialIndex;
                if (mesh.material.subMaterials[idx] && ((_a = mesh.material.subMaterials[idx]) === null || _a === void 0 ? void 0 : _a.id) === this._dummyMaterialID)
                    return true;
            }
        }
        else {
            if (mesh.material && mesh.material.id === this._dummyMaterialID)
                return true;
        }
        if (recursive) {
            for (let i = 0; i < mesh.getChildMeshes().length; i++) {
                if (this.meshHasDummyMaterial(mesh.getChildMeshes()[i], true))
                    return true;
            }
        }
        return false;
    }
    getMeshDelayedMaterialIDs(mesh) {
        var _a;
        const materialIDs = [];
        if (mesh.subMeshes && mesh.subMeshes.length > 0 && mesh.material && mesh.material instanceof BABYLON.MultiMaterial) {
            for (let i = 0; i < mesh.subMeshes.length; i++) {
                const subMesh = mesh.subMeshes[i];
                const idx = subMesh.materialIndex;
                if (mesh.material.subMaterials[idx] && ((_a = mesh.material.subMaterials[idx]) === null || _a === void 0 ? void 0 : _a.id) === this._dummyMaterialID) {
                    const key = `${mesh.id}_${idx}`;
                    if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(key)) {
                        const originalMaterialID = this._scene.metadata.originalMeshMaterials[key];
                        if (this._scene.metadata.delayedMaterials.hasOwnProperty(originalMaterialID) &&
                            materialIDs.indexOf(originalMaterialID) === -1) {
                            materialIDs.push(originalMaterialID);
                        }
                    }
                }
            }
        }
        else {
            if (mesh.material && mesh.material.id === this._dummyMaterialID &&
                this._scene.metadata && this._scene.metadata.delayedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(mesh.id)) {
                const originalMaterialID = this._scene.metadata.originalMeshMaterials[mesh.id];
                if (this._scene.metadata.delayedMaterials.hasOwnProperty(originalMaterialID) &&
                    materialIDs.indexOf(originalMaterialID) === -1) {
                    materialIDs.push(originalMaterialID);
                }
            }
        }
        mesh.getChildMeshes().forEach(child => Array.prototype.push.apply(materialIDs, this.getMeshDelayedMaterialIDs(child)));
        return materialIDs;
    }
    getMeshOffloadedMaterialIDs(mesh) {
        var _a;
        const materialIDs = [];
        if (mesh.subMeshes && mesh.subMeshes.length > 0 && mesh.material && mesh.material instanceof BABYLON.MultiMaterial) {
            for (let i = 0; i < mesh.subMeshes.length; i++) {
                const subMesh = mesh.subMeshes[i];
                const idx = subMesh.materialIndex;
                if (mesh.material.subMaterials[idx] && ((_a = mesh.material.subMaterials[idx]) === null || _a === void 0 ? void 0 : _a.id) === this._dummyMaterialID) {
                    const key = `${mesh.id}_${idx}`;
                    if (this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(key)) {
                        const originalMaterialID = this._scene.metadata.originalMeshMaterials[key];
                        if (this._scene.metadata.offloadedMaterials.hasOwnProperty(originalMaterialID) &&
                            materialIDs.indexOf(originalMaterialID) === -1) {
                            materialIDs.push(originalMaterialID);
                        }
                    }
                }
            }
        }
        else {
            if (mesh.material && mesh.material.id === this._dummyMaterialID &&
                this._scene.metadata && this._scene.metadata.offloadedMaterials && this._scene.metadata.originalMeshMaterials.hasOwnProperty(mesh.id)) {
                const originalMaterialID = this._scene.metadata.originalMeshMaterials[mesh.id];
                if (this._scene.metadata.offloadedMaterials.hasOwnProperty(originalMaterialID) &&
                    materialIDs.indexOf(originalMaterialID) === -1) {
                    materialIDs.push(originalMaterialID);
                }
            }
        }
        mesh.getChildMeshes().forEach(child => Array.prototype.push.apply(materialIDs, this.getMeshOffloadedMaterialIDs(child)));
        return materialIDs;
    }
    setDummyMaterialToInvisibleMeshes() {
        const meshes = this.getInvisibleMeshes();
        meshes.forEach(mesh => {
            this.setMeshDummyMaterial(mesh, false);
        });
    }
    setMeshDummyMaterial(mesh, recursive) {
        if (!this._scene.metadata)
            this._scene.metadata = {};
        if (!this._scene.metadata.originalMeshMaterials)
            this._scene.metadata.originalMeshMaterials = {};
        const dummyMaterial = this.getOrCreateDummyMaterial();
        if (mesh.material) {
            if (mesh.subMeshes && mesh.subMeshes.length > 0 && mesh.material instanceof BABYLON.MultiMaterial) {
                for (let i = 0; i < mesh.subMeshes.length; i++) {
                    const subMesh = mesh.subMeshes[i];
                    const idx = subMesh.materialIndex;
                    const subMeshMaterial = mesh.material.subMaterials[idx];
                    if (subMeshMaterial &&
                        !this.isDummyMaterial(subMeshMaterial)) {
                        const key = `${mesh.id}_${idx}`;
                        this._scene.metadata.originalMeshMaterials[key] = subMeshMaterial.id;
                        mesh.material.subMaterials[idx] = dummyMaterial;
                    }
                }
            }
            else {
                if (mesh.material && !this.isDummyMaterial(mesh.material)) {
                    this._scene.metadata.originalMeshMaterials[mesh.id] = mesh.material.id;
                    mesh.material = dummyMaterial;
                }
            }
        }
        if (recursive) {
            mesh.getChildMeshes().forEach(child => this.setMeshDummyMaterial(child, true));
        }
    }
    // Il metodo è sincrono perché mi aspetto che tutti i materiali originali siano già presenti nella scena
    unsetAllDummyMaterials() {
        for (let i = 0; i < this._scene.meshes.length; i++) {
            this.unsetMeshDummyMaterial(this._scene.meshes[i], false);
        }
    }
    // Il metodo è asincrono perché ci sia aspetta che non tutti i materiali siano presenti nella scena, in qual caso verranno caricati
    unsetAllDummyMaterialsAsync(rootUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            for (let i = 0; i < this._scene.meshes.length; i++) {
                yield this.unsetMeshDummyMaterialAsync(this._scene.meshes[i], rootUrl, false);
            }
        });
    }
    // Il metodo è sincrono perché mi aspetto che i materiali originali siano tutti gà presenti nella scena
    unsetMeshDummyMaterial(mesh, recursive) {
        var _a;
        if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
            if (mesh.subMeshes && mesh.subMeshes.length > 0 && mesh.material && mesh.material instanceof BABYLON.MultiMaterial) {
                for (let i = 0; i < mesh.subMeshes.length; i++) {
                    const subMesh = mesh.subMeshes[i];
                    const idx = subMesh.materialIndex;
                    if (mesh.material.subMaterials[idx] && ((_a = mesh.material.subMaterials[idx]) === null || _a === void 0 ? void 0 : _a.id) === this._dummyMaterialID) {
                        const key = `${mesh.id}_${idx}`;
                        if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(key)) {
                            const originalMaterialID = this._scene.metadata.originalMeshMaterials[key];
                            const originalMaterial = this._scene.getMaterialByID(originalMaterialID);
                            if (originalMaterial) {
                                mesh.material.subMaterials[idx] = originalMaterial;
                                delete this._scene.metadata.originalMeshMaterials[key];
                            }
                        }
                    }
                }
            }
            else {
                if (mesh.material && mesh.material.id === this._dummyMaterialID &&
                    this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(mesh.id)) {
                    const originalMaterialID = this._scene.metadata.originalMeshMaterials[mesh.id];
                    const originalMaterial = this._scene.getMaterialByID(originalMaterialID);
                    if (originalMaterial) {
                        mesh.material = originalMaterial;
                        delete this._scene.metadata.originalMeshMaterials[mesh.id];
                    }
                }
            }
            if (recursive) {
                mesh.getChildMeshes().forEach(child => this.unsetMeshDummyMaterial(child, true));
            }
        }
    }
    // Il metodo è asincrono perché ci si aspetta che non tutti i materiali siano presenti sulla scena, nel qual caso verranno caricati
    unsetMeshDummyMaterialAsync(mesh, rootUrl, recursive) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
                if (mesh.subMeshes && mesh.subMeshes.length > 0 && mesh.material && mesh.material instanceof BABYLON.MultiMaterial) {
                    for (let i = 0; i < mesh.subMeshes.length; i++) {
                        const subMesh = mesh.subMeshes[i];
                        const idx = subMesh.materialIndex;
                        if (mesh.material.subMaterials[idx] && ((_a = mesh.material.subMaterials[idx]) === null || _a === void 0 ? void 0 : _a.id) === this._dummyMaterialID) {
                            const key = `${mesh.id}_${idx}`;
                            if (this._scene.metadata.originalMeshMaterials.hasOwnProperty(key)) {
                                const originalMaterialID = this._scene.metadata.originalMeshMaterials[key];
                                const originalMaterial = yield this.getOrLoadMaterialAsync(originalMaterialID, rootUrl);
                                mesh.material.subMaterials[idx] = originalMaterial;
                                delete this._scene.metadata.originalMeshMaterials[key];
                            }
                        }
                    }
                }
                else {
                    if (mesh.material && mesh.material.id === this._dummyMaterialID &&
                        this._scene.metadata && this._scene.metadata.originalMeshMaterials.hasOwnProperty(mesh.id)) {
                        const originalMaterialID = this._scene.metadata.originalMeshMaterials[mesh.id];
                        const originalMaterial = yield this.getOrLoadMaterialAsync(originalMaterialID, rootUrl);
                        mesh.material = originalMaterial;
                        delete this._scene.metadata.originalMeshMaterials[mesh.id];
                    }
                }
                if (recursive) {
                    const children = mesh.getChildMeshes();
                    for (let i = 0; i < children.length; i++) {
                        yield this.unsetMeshDummyMaterialAsync(children[i], rootUrl, true);
                    }
                }
            }
        });
    }
    reloadAllLoadingErrorTexturesAsync(rootUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            // ricarico sequenzialmente tutte le texture che hanno avuto un problema in fase di caricamento
            for (const texture of this._scene.textures)
                yield this.reloadLoadingErrorTextureAsync(rootUrl, texture);
        });
    }
    reloadMaterialLoadingErrorTexturesAsync(rootUrl, material) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const texture of material.getActiveTextures())
                yield this.reloadLoadingErrorTextureAsync(rootUrl, texture);
        });
    }
    reloadLoadingErrorTextureAsync(rootUrl, texture) {
        if (texture instanceof BABYLON.Texture && texture.url) {
            const internalTexture = texture.getInternalTexture();
            if (texture.loadingError || (internalTexture && internalTexture.loadingError)) {
                const originalUrl = texture.url;
                const isAbsolute = /^(?:\/|[a-z]+:\/\/)/.test(texture.url);
                var absoluteUrl = texture.url;
                if (!isAbsolute)
                    absoluteUrl = rootUrl + texture.url;
                return new Promise((resolve, reject) => {
                    texture.updateURL(absoluteUrl, null, () => {
                        texture.url = originalUrl;
                        resolve();
                    }, () => {
                        texture.url = originalUrl;
                        reject();
                    });
                });
            }
        }
        return Promise.resolve();
    }
    isTextureLoadingError(texture) {
        if (texture.loadingError)
            return true;
        const internalTexture = texture.getInternalTexture();
        return internalTexture !== null && internalTexture.loadingError;
    }
    materialHasLoadingErrorTextues(material) {
        return material.getActiveTextures().some(t => this.isTextureLoadingError(t));
    }
    // A dynamic texture is a procedural texture or a texture created from a Blob
    getMaterialDynamicTextures(material) {
        const textures = material.getActiveTextures();
        return textures.filter(t => t instanceof BABYLON.ProceduralTexture ||
            (t instanceof BABYLON.Texture && t.url && t.url.indexOf("blob:") !== -1));
    }
    exportTextureToBase64Async(babylonTexture, mimeType = "image/png", invertY = false) {
        return Promise.resolve().then(() => __awaiter(this, void 0, void 0, function* () {
            const pixels = yield this.getPixelsFromTexture(babylonTexture);
            if (!pixels) {
                return null;
            }
            const size = babylonTexture.getSize();
            // Preserve texture mime type if defined
            if (babylonTexture.mimeType) {
                switch (babylonTexture.mimeType) {
                    case "image/jpeg":
                        mimeType = "image/jpeg";
                        break;
                    case "image/png":
                        mimeType = "image/png";
                        break;
                }
            }
            return this.createBase64FromCanvasAsync(pixels, size.width, size.height, mimeType, invertY);
        }));
    }
    createBase64FromCanvasAsync(buffer, width, height, mimeType, invertY = false) {
        return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
            const textureType = BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT;
            const hostingScene = this._scene;
            const engine = hostingScene.getEngine();
            // Create a temporary texture with the texture buffer data
            const tempTexture = engine.createRawTexture(buffer, width, height, BABYLON.Constants.TEXTUREFORMAT_RGBA, false, invertY, BABYLON.Texture.NEAREST_SAMPLINGMODE, null, textureType);
            yield BABYLON.TextureTools.ApplyPostProcess("pass", tempTexture, hostingScene, textureType, BABYLON.Constants.TEXTURE_NEAREST_SAMPLINGMODE, BABYLON.Constants.TEXTUREFORMAT_RGBA);
            const data = yield engine._readTexturePixels(tempTexture, width, height);
            const base64 = yield BABYLON.Tools.DumpDataAsync(width, height, data, mimeType, undefined, true, false);
            resolve(base64);
        }));
    }
    getPixelsFromTexture(babylonTexture) {
        const pixels = babylonTexture.textureType === BABYLON.Constants.TEXTURETYPE_UNSIGNED_INT ? babylonTexture.readPixels() : babylonTexture.readPixels();
        return pixels;
    }
    comparePBRMaterials(mat1, mat2) {
        if ((mat1.albedoColor && !mat2.albedoColor) ||
            (!mat1.albedoColor && mat2.albedoColor) ||
            (mat1.albedoColor && mat2.albedoColor && !mat1.albedoColor.equals(mat2.albedoColor)))
            console.log("albedoColor");
        if (mat1.allowShaderHotSwapping !== mat2.allowShaderHotSwapping)
            console.log("allowShaderHotSwapping");
        if (mat1.alphaCutOff !== mat2.alphaCutOff)
            console.log("alphaCutOff");
        if ((mat1.ambientColor && !mat2.ambientColor) ||
            (!mat1.ambientColor && mat2.ambientColor) ||
            (mat1.ambientColor && mat2.ambientColor && !mat1.ambientColor.equals(mat2.ambientColor)))
            console.log("ambientColor");
        if (mat1.ambientTextureStrength !== mat2.ambientTextureStrength)
            console.log("ambientTextureStrength");
        this.compareAnisotropy(mat1.anisotropy, mat2.anisotropy);
        this.compareBRDF(mat1.brdf, mat2.brdf);
        this.compareClearCoat(mat1.clearCoat, mat2.clearCoat);
        if (mat1.depthFunction !== mat2.depthFunction)
            console.log("depthFunction");
        this.compareDetailMap(mat1.detailMap, mat2.detailMap);
        if (mat1.directIntensity !== mat2.directIntensity)
            console.log("directIntensity");
        if (mat1.disableBumpMap !== mat2.disableBumpMap)
            console.log("disableBumpMap");
        if (mat1.disableColorWrite !== mat2.disableColorWrite)
            console.log("disableColorWrite");
        if (mat1.disableDepthWrite !== mat2.disableDepthWrite)
            console.log("disableDepthWrite");
        if (mat1.disableLighting !== mat2.disableLighting)
            console.log("disableLighting");
        if ((mat1.emissiveColor && !mat2.emissiveColor) ||
            (!mat1.emissiveColor && mat2.emissiveColor) ||
            (mat1.emissiveColor && mat2.emissiveColor && !mat1.emissiveColor.equals(mat2.emissiveColor)))
            console.log("emissiveColor");
        if (mat1.emissiveIntensity !== mat2.emissiveIntensity)
            console.log("emissiveIntensity");
        if (mat1.enableSpecularAntiAliasing !== mat2.enableSpecularAntiAliasing)
            console.log("enableSpecularAntiAliasing");
        if (mat1.environmentIntensity !== mat2.environmentIntensity)
            console.log("environmentIntensity");
        if (mat1.forceAlphaTest !== mat2.forceAlphaTest)
            console.log("forceAlphaTest");
        if (mat1.forceDepthWrite !== mat2.forceDepthWrite)
            console.log("forceDepthWrite");
        if (mat1.forceIrradianceInFragment !== mat2.forceIrradianceInFragment)
            console.log("forceIrradianceInFragment");
        if (mat1.forceNormalForward !== mat2.forceNormalForward)
            console.log("forceNormalForward");
        if (mat1.invertNormalMapX !== mat2.invertNormalMapX)
            console.log("invertNormalMapX");
        if (mat1.invertNormalMapY !== mat2.invertNormalMapY)
            console.log("invertNormalMapY");
        if (mat1.maxSimultaneousLights !== mat2.maxSimultaneousLights)
            console.log("maxSimultaneousLights");
        if (mat1.metallic !== mat2.metallic)
            console.log("metallic");
        if (mat1.metallicF0Factor !== mat2.metallicF0Factor)
            console.log("metallicF0Factor");
        if ((mat1.metallicReflectanceColor && !mat2.metallicReflectanceColor) ||
            (!mat1.metallicReflectanceColor && mat2.metallicReflectanceColor) ||
            (mat1.metallicReflectanceColor && mat2.metallicReflectanceColor && !mat1.metallicReflectanceColor.equals(mat2.metallicReflectanceColor)))
            console.log("metallicReflectanceColor");
        if (mat1.microSurface !== mat2.microSurface)
            console.log("microSurface");
        if (mat1.parallaxScaleBias !== mat2.parallaxScaleBias)
            console.log("parallaxScaleBias");
        if (mat1.pointSize !== mat2.pointSize)
            console.log("pointSize");
        this.comparePrePassConfiguration(mat1.prePassConfiguration, mat2.prePassConfiguration);
        if ((mat1.reflectionColor && !mat2.reflectionColor) ||
            (!mat1.reflectionColor && mat2.reflectionColor) ||
            (mat1.reflectionColor && mat2.reflectionColor && !mat1.reflectionColor.equals(mat2.reflectionColor)))
            console.log("reflectionColor");
        if ((mat1.reflectivityColor && !mat2.reflectivityColor) ||
            (!mat1.reflectivityColor && mat2.reflectivityColor) ||
            (mat1.reflectivityColor && mat2.reflectivityColor && !mat1.reflectivityColor.equals(mat2.reflectivityColor)))
            console.log("reflectivityColor");
        if (mat1.roughness !== mat2.roughness)
            console.log("roughness");
        if (mat1.separateCullingPass !== mat2.separateCullingPass)
            console.log("separateCullingPass");
        this.compareSheen(mat1.sheen, mat2.sheen);
        if (mat1.sideOrientation !== mat2.sideOrientation)
            console.log("sideOrientation");
        if (mat1.specularIntensity !== mat2.specularIntensity)
            console.log("specularIntensity");
        this.compareSubSurface(mat1.subSurface, mat2.subSurface);
        if (mat1.twoSidedLighting !== mat2.twoSidedLighting)
            console.log("twoSidedLighting");
        if (mat1.unlit !== mat2.unlit)
            console.log("unlit");
        if (mat1.useAlphaFresnel !== mat2.useAlphaFresnel)
            console.log("useAlphaFresnel");
        if (mat1.useAlphaFromAlbedoTexture !== mat2.useAlphaFromAlbedoTexture)
            console.log("useAlphaFromAlbedoTexture");
        if (mat1.useAmbientInGrayScale !== mat2.useAmbientInGrayScale)
            console.log("useAmbientInGrayScale");
        if (mat1.useAmbientOcclusionFromMetallicTextureRed !== mat2.useAmbientOcclusionFromMetallicTextureRed)
            console.log("useAmbientOcclusionFromMetallicTextureRed");
        if (mat1.useAutoMicroSurfaceFromReflectivityMap !== mat2.useAutoMicroSurfaceFromReflectivityMap)
            console.log("useAutoMicroSurfaceFromReflectivityMap");
        if (mat1.useHorizonOcclusion !== mat2.useHorizonOcclusion)
            console.log("useHorizonOcclusion");
        if (mat1.useLightmapAsShadowmap !== mat2.useLightmapAsShadowmap)
            console.log("useLightmapAsShadowmap");
        if (mat1.useLinearAlphaFresnel !== mat2.useLinearAlphaFresnel)
            console.log("useLinearAlphaFresnel");
        if (mat1.useMetallnessFromMetallicTextureBlue !== mat2.useMetallnessFromMetallicTextureBlue)
            console.log("useMetallnessFromMetallicTextureBlue");
        if (mat1.useMicroSurfaceFromReflectivityMapAlpha !== mat2.useMicroSurfaceFromReflectivityMapAlpha)
            console.log("useMicroSurfaceFromReflectivityMapAlpha");
        if (mat1.useObjectSpaceNormalMap !== mat2.useObjectSpaceNormalMap)
            console.log("useObjectSpaceNormalMap");
        if (mat1.useOnlyMetallicFromMetallicReflectanceTexture !== mat2.useOnlyMetallicFromMetallicReflectanceTexture)
            console.log("useOnlyMetallicFromMetallicReflectanceTexture");
        if (mat1.useParallax !== mat2.useParallax)
            console.log("useParallax");
        if (mat1.useParallaxOcclusion !== mat2.useParallaxOcclusion)
            console.log("useParallaxOcclusion");
        if (mat1.useRadianceOcclusion !== mat2.useRadianceOcclusion)
            console.log("useRadianceOcclusion");
        if (mat1.useRadianceOverAlpha !== mat2.useRadianceOverAlpha)
            console.log("useRadianceOverAlpha");
        if (mat1.useRoughnessFromMetallicTextureAlpha !== mat2.useRoughnessFromMetallicTextureAlpha)
            console.log("useRoughnessFromMetallicTextureAlpha");
        if (mat1.useRoughnessFromMetallicTextureGreen !== mat2.useRoughnessFromMetallicTextureGreen)
            console.log("useRoughnessFromMetallicTextureGreen");
        if (mat1.useSpecularOverAlpha !== mat2.useSpecularOverAlpha)
            console.log("useSpecularOverAlpha");
        if (mat1.zOffset !== mat2.zOffset)
            console.log("zOffset");
        if (mat1.zOffsetUnits !== mat2.zOffsetUnits)
            console.log("zOffsetUnits");
        // Accessors
        if (mat1.alpha !== mat2.alpha)
            console.log("alpha");
        if (mat1.alphaMode !== mat2.alphaMode)
            console.log("alphaMode");
        if (mat1.backFaceCulling !== mat2.backFaceCulling)
            console.log("backFaceCulling");
        this.compareCameraCurve("", mat1.cameraColorCurves, mat2.cameraColorCurves);
        if (mat1.cameraColorCurvesEnabled !== mat2.cameraColorCurvesEnabled)
            console.log("cameraColorCurvesEnabled");
        if (mat1.cameraColorGradingEnabled !== mat2.cameraColorGradingEnabled)
            console.log("cameraColorGradingEnabled");
        if (mat1.cameraContrast !== mat2.cameraContrast)
            console.log("cameraContrast");
        if (mat1.cameraExposure !== mat2.cameraExposure)
            console.log("cameraExposure");
        if (mat1.cameraToneMappingEnabled !== mat2.cameraToneMappingEnabled)
            console.log("cameraToneMappingEnabled");
        if (mat1.canRenderToMRT !== mat2.canRenderToMRT)
            console.log("canRenderToMRT");
        if (mat1.cullBackFaces !== mat2.cullBackFaces)
            console.log("cullBackFaces");
        if (mat1.fillMode !== mat2.fillMode)
            console.log("fillMode");
        if (mat1.fogEnabled !== mat2.fogEnabled)
            console.log("fogEnabled");
        if (mat1.hasRenderTargetTextures !== mat2.hasRenderTargetTextures)
            console.log("hasRenderTargetTextures");
        this.compareImageProcessingConfiguration(mat1.imageProcessingConfiguration, mat2.imageProcessingConfiguration);
        if (mat1.indexOfRefraction !== mat2.indexOfRefraction)
            console.log("indexOfRefraction");
        if (mat1.invertRefractionY !== mat2.invertRefractionY)
            console.log("invertRefractionY");
        if (mat1.isFrozen !== mat2.isFrozen)
            console.log("isFrozen");
        if (mat1.isPrePassCapable !== mat2.isPrePassCapable)
            console.log("isPrePassCapable");
        if (mat1.linkRefractionWithTransparency !== mat2.linkRefractionWithTransparency)
            console.log("linkRefractionWithTransparency");
        if (mat1.needDepthPrePass !== mat2.needDepthPrePass)
            console.log("needDepthPrePass");
        if (mat1.realTimeFiltering !== mat2.realTimeFiltering)
            console.log("realTimeFiltering");
        if (mat1.realTimeFilteringQuality !== mat2.realTimeFilteringQuality)
            console.log("realTimeFilteringQuality");
        if (mat1.transparencyMode !== mat2.transparencyMode)
            console.log("transparencyMode");
        if (mat1.useGLTFLightFalloff !== mat2.useGLTFLightFalloff)
            console.log("useGLTFLightFalloff");
        if (mat1.useLogarithmicDepth !== mat2.useLogarithmicDepth)
            console.log("useLogarithmicDepth");
        if (mat1.usePhysicalLightFalloff !== mat2.usePhysicalLightFalloff)
            console.log("usePhysicalLightFalloff");
        this.compareTexture("albedo", mat1.albedoTexture, mat2.albedoTexture);
        this.compareTexture("emissive", mat1.emissiveTexture, mat2.emissiveTexture);
    }
    compareAnisotropy(an1, an2) {
        const prefix = "anisotropy";
        if ((an1.direction && !an2.direction) ||
            (!an1.direction && an2.direction) ||
            (an1.direction && an2.direction && !an1.direction.equals(an2.direction)))
            console.log(prefix + " - direction");
        if (an1.intensity !== an2.intensity)
            console.log(prefix + " - intensity");
        if (an1.isEnabled !== an2.isEnabled)
            console.log(prefix + " - isEnabled");
    }
    compareBRDF(b1, b2) {
        const prefix = "brdf";
        if (b1.useEnergyConservation !== b2.useEnergyConservation)
            console.log(prefix + " - useEnergyConservation");
        if (b1.useSmithVisibilityHeightCorrelated !== b2.useSmithVisibilityHeightCorrelated)
            console.log(prefix + " - useSmithVisibilityHeightCorrelated");
        if (b1.useSpecularGlossinessInputEnergyConservation !== b2.useSpecularGlossinessInputEnergyConservation)
            console.log(prefix + " - useSpecularGlossinessInputEnergyConservation");
        if (b1.useSphericalHarmonics !== b2.useSphericalHarmonics)
            console.log(prefix + " - useSphericalHarmonics");
    }
    compareClearCoat(c1, c2) {
        const prefix = "clearCoat";
        if (c1.indexOfRefraction !== c2.indexOfRefraction)
            console.log(prefix + " - indexOfRefraction");
        if (c1.intensity !== c2.intensity)
            console.log(prefix + " - intensity");
        if (c1.isEnabled !== c2.isEnabled)
            console.log(prefix + " - isEnabled");
        if (c1.isTintEnabled !== c2.isTintEnabled)
            console.log(prefix + " - isTintEnabled");
        if (c1.roughness !== c2.roughness)
            console.log(prefix + " - roughness");
        if ((c1.tintColor && !c2.tintColor) ||
            (!c1.tintColor && c2.tintColor) ||
            (c1.tintColor && c2.tintColor && !c1.tintColor.equals(c2.tintColor)))
            console.log(prefix + " - tintColor");
        if (c1.tintColorAtDistance !== c2.tintColorAtDistance)
            console.log(prefix + " - tintColorAtDistance");
        if (c1.tintThickness !== c2.tintThickness)
            console.log(prefix + " - tintThickness");
        if (c1.useRoughnessFromMainTexture != c2.useRoughnessFromMainTexture)
            console.log(prefix + " - useRoughnessFromMainTexture");
    }
    compareDetailMap(m1, m2) {
        const prefix = "detailMap";
        if (m1.bumpLevel !== m2.bumpLevel)
            console.log(prefix + " - bumpLevel");
        if (m1.diffuseBlendLevel !== m2.diffuseBlendLevel)
            console.log(prefix + " - diffuseBlendLevel");
        if (m1.isEnabled !== m2.isEnabled)
            console.log(prefix + " - isEnabled");
        if (m1.normalBlendMethod !== m2.normalBlendMethod)
            console.log(prefix + " - normalBlendMethod");
        if (m1.roughnessBlendLevel !== m2.roughnessBlendLevel)
            console.log(prefix + " - roughnessBlendLevel");
    }
    comparePrePassConfiguration(c1, c2) {
        const prefix = "PrePassConfiguration";
        if ((c1.currentViewProjection && !c2.currentViewProjection) ||
            (!c1.currentViewProjection && c2.currentViewProjection) ||
            (c1.currentViewProjection && c2.currentViewProjection && !c1.currentViewProjection.equals(c2.currentViewProjection)))
            console.log(prefix + " - currentViewProjection");
        if ((c1.previousViewProjection && !c2.previousViewProjection) ||
            (!c1.previousViewProjection && c2.previousViewProjection) ||
            (c1.previousViewProjection && c2.previousViewProjection && !c1.previousViewProjection.equals(c2.previousViewProjection)))
            console.log(prefix + " - previousViewProjection");
    }
    compareSheen(s1, s2) {
        const prefix = "Sheen";
        if (s1.albedoScaling !== s2.albedoScaling)
            console.log(prefix + " - albedoScaling");
        if ((s1.color && !s2.color) ||
            (!s1.color && s2.color) ||
            (s1.color && s2.color && !s1.color.equals(s2.color)))
            console.log(prefix + " - color");
        if (s1.intensity !== s2.intensity)
            console.log(prefix + " - intensity");
        if (s1.isEnabled !== s2.isEnabled)
            console.log(prefix + " - isEnabled");
        if (s1.linkSheenWithAlbedo !== s2.linkSheenWithAlbedo)
            console.log(prefix + " - linkSheenWithAlbedo");
        if (s1.roughness !== s2.roughness)
            console.log(prefix + " - roughness");
        if (s1.useRoughnessFromMainTexture !== s2.useRoughnessFromMainTexture)
            console.log(prefix + " - useRoughnessFromMainTexture");
    }
    compareSubSurface(s1, s2) {
        const prefix = "SubSurface";
        if ((s1.diffusionDistance && !s2.diffusionDistance) ||
            (!s1.diffusionDistance && s2.diffusionDistance) ||
            (s1.diffusionDistance && s2.diffusionDistance && !s1.diffusionDistance.equals(s2.diffusionDistance)))
            console.log(prefix + " - diffusionDistance");
        if (s1.indexOfRefraction !== s2.indexOfRefraction)
            console.log(prefix + " - indexOfRefraction");
        if (s1.invertRefractionY !== s2.invertRefractionY)
            console.log(prefix + " - invertRefractionY");
        if (s1.isRefractionEnabled !== s2.isRefractionEnabled)
            console.log(prefix + " - isRefractionEnabled");
        if (s1.isScatteringEnabled !== s2.isScatteringEnabled)
            console.log(prefix + " - isScatteringEnabled");
        if (s1.isTranslucencyEnabled !== s2.isTranslucencyEnabled)
            console.log(prefix + " - isTranslucencyEnabled");
        if (s1.linkRefractionWithTransparency !== s2.linkRefractionWithTransparency)
            console.log(prefix + " - linkRefractionWithTransparency");
        if (s1.maximumThickness !== s2.maximumThickness)
            console.log(prefix + " - maximumThickness");
        if (s1.minimumThickness !== s2.minimumThickness)
            console.log(prefix + " - minimumThickness");
        if (s1.refractionIntensity !== s2.refractionIntensity)
            console.log(prefix + " - refractionIntensity");
        if ((s1.tintColor && !s2.tintColor) ||
            (!s1.tintColor && s2.tintColor) ||
            (s1.tintColor && s2.tintColor && !s1.tintColor.equals(s2.tintColor)))
            console.log(prefix + " - tintColor");
        if (s1.tintColorAtDistance !== s2.tintColorAtDistance)
            console.log(prefix + " - tintColorAtDistance");
        if (s1.translucencyIntensity !== s2.translucencyIntensity)
            console.log(prefix + " - translucencyIntensity");
        if (s1.useAlbedoToTintRefraction !== s2.useAlbedoToTintRefraction)
            console.log(prefix + " - useAlbedoToTintRefraction");
        if (s1.useAlbedoToTintTranslucency !== s2.useAlbedoToTintTranslucency)
            console.log(prefix + " - useAlbedoToTintTranslucency");
        if (s1.useGltfStyleTextures !== s2.useGltfStyleTextures)
            console.log(prefix + " - useGltfStyleTextures");
        if (s1.useMaskFromThicknessTexture !== s2.useMaskFromThicknessTexture)
            console.log(prefix + " - useMaskFromThicknessTexture");
        if (s1.useThicknessAsDepth !== s2.useThicknessAsDepth)
            console.log(prefix + " - useThicknessAsDepth");
    }
    compareCameraCurve(pref, c1, c2) {
        if ((c1 === null && c2 !== null) ||
            (c1 !== null && c2 === null))
            console.log("cameraColorCurves");
        if (c1 && c2) {
            const prefix = pref ? pref + " - cameraColorCurves" : "cameraColorCurves";
            if (c1.globalDensity !== c2.globalDensity)
                console.log(prefix + " - globalDensity");
            if (c1.globalExposure !== c2.globalExposure)
                console.log(prefix + "- globalExposure");
            if (c1.globalHue !== c2.globalHue)
                console.log(prefix + " - globalHue");
            if (c1.globalSaturation !== c2.globalSaturation)
                console.log(prefix + " - globalSaturation");
            if (c1.highlightsDensity !== c2.highlightsDensity)
                console.log(prefix + " - highlightsDensity");
            if (c1.highlightsExposure !== c2.highlightsExposure)
                console.log(prefix + " - highlightsExposure");
            if (c1.highlightsHue !== c2.highlightsHue)
                console.log(prefix + " - highlightsHue");
            if (c1.highlightsSaturation !== c2.highlightsSaturation)
                console.log(prefix + " - highlightsSaturation");
            if (c1.midtonesDensity !== c2.midtonesDensity)
                console.log(prefix + " - midtonesDensity");
            if (c1.midtonesExposure !== c2.midtonesExposure)
                console.log(prefix + " - midtonesExposure");
            if (c1.midtonesHue !== c2.midtonesHue)
                console.log(prefix + " - midtonesHue");
            if (c1.midtonesSaturation !== c2.midtonesSaturation)
                console.log(prefix + " - midtonesSaturation");
            if (c1.shadowsDensity !== c2.shadowsDensity)
                console.log(prefix + " - shadowsDensity");
            if (c1.shadowsExposure !== c2.shadowsExposure)
                console.log(prefix + " - shadowsExposure");
            if (c1.shadowsHue !== c2.shadowsHue)
                console.log(prefix + " - shadowsHue");
            if (c1.shadowsSaturation !== c2.shadowsSaturation)
                console.log(prefix + " - shadowsSaturation");
        }
    }
    compareImageProcessingConfiguration(c1, c2) {
        const prefix = "imageProcessingConfiguration";
        this.compareCameraCurve(prefix, c1.colorCurves, c2.colorCurves);
        if (c1.vignetteCameraFov !== c2.vignetteCameraFov)
            console.log(prefix + " - vignetteCameraFov");
        if (c1.vignetteCentreX !== c2.vignetteCentreX)
            console.log(prefix + " - vignetteCentreX");
        if (c1.vignetteCentreY !== c2.vignetteCentreY)
            console.log(prefix + " - vignetteCentreY");
        if ((c1.vignetteColor && !c2.vignetteColor) ||
            (!c1.vignetteColor && c2.vignetteColor) ||
            (c1.vignetteColor && c2.vignetteColor && !c1.vignetteColor.equals(c2.vignetteColor)))
            console.log(prefix + " - vignetteColor");
        if (c1.vignetteStretch !== c2.vignetteStretch)
            console.log(prefix + " - vignetteStretch");
        if (c1.vignetteWeight !== c2.vignetteWeight)
            console.log(prefix + " - vignetteWeight");
        // Accessors
        if (c1.applyByPostProcess !== c2.applyByPostProcess)
            console.log(prefix + " - applyByPostProcess");
        if (c1.colorCurvesEnabled !== c2.colorCurvesEnabled)
            console.log(prefix + " - colorCurvesEnabled");
        if (c1.colorGradingBGR !== c2.colorGradingBGR)
            console.log(prefix + " - colorGradingBGR");
        if (c1.colorGradingEnabled !== c2.colorGradingEnabled)
            console.log(prefix + " - colorGradingEnabled");
        if (c1.colorGradingWithGreenDepth !== c2.colorGradingWithGreenDepth)
            console.log(prefix + " - colorGradingWithGreenDepth");
        if (c1.contrast !== c2.contrast)
            console.log(prefix + " - contrast");
        if (c1.exposure !== c2.exposure)
            console.log(prefix + " - exposure");
        if (c1.isEnabled !== c2.isEnabled)
            console.log(prefix + " - isEnabled");
        if (c1.toneMappingEnabled !== c2.toneMappingEnabled)
            console.log(prefix + " - toneMappingEnabled");
        if (c1.toneMappingType !== c2.toneMappingType)
            console.log(prefix + " - toneMappingType");
        if (c1.vignetteBlendMode !== c2.vignetteBlendMode)
            console.log(prefix + " - vignetteBlendMode");
        if (c1.vignetteEnabled !== c2.vignetteEnabled)
            console.log(prefix + " - vignetteEnabled");
    }
    compareTexture(type, t1, t2) {
        if ((t1 && !t2) || (!t1 && t2)) {
            console.log(type);
            return;
        }
        if ((t1 instanceof BABYLON.Texture && !(t2 instanceof BABYLON.Texture)) ||
            (t2 instanceof BABYLON.Texture && !(t1 instanceof BABYLON.Texture))) {
            console.log(type);
            return;
        }
        if (t1 && t2) {
            if (t1.anisotropicFilteringLevel !== t2.anisotropicFilteringLevel)
                console.log(type + " - anisotropicFilteringLevel");
            if (t1 instanceof BABYLON.Texture && t2 instanceof BABYLON.Texture) {
                if (t1.homogeneousRotationInUVTransform !== t2.homogeneousRotationInUVTransform)
                    console.log(type + " - homogeneousRotationInUVTransform");
                if (t1.uAng !== t2.uAng)
                    console.log(type + " - uAng");
                if (t1.uOffset !== t2.uOffset)
                    console.log(type + " - uOffset");
                if (t1.uRotationCenter !== t2.uRotationCenter)
                    console.log(type + " - uRotationCenterSearch");
                if (t1.uScale !== t2.uScale)
                    console.log(type + " - uScale");
                if (t1.vAng !== t2.vAng)
                    console.log(type + " - vAng");
                if (t1.vOffset !== t2.vOffset)
                    console.log(type + " - vOffset");
                if (t1.vRotationCenter !== t2.vRotationCenter)
                    console.log(type + " - vRotationCenterSearch");
                if (t1.vScale !== t2.vScale)
                    console.log(type + " - vScale");
                if (t1.wAng !== t2.wAng)
                    console.log(type + " - wAng");
                if (t1.wRotationCenter !== t2.wRotationCenter)
                    console.log(type + " - wRotationCenterSearch");
                if (t1.invertY !== t2.invertY)
                    console.log(type + " - invertY");
                if (t1.mimeType !== t2.mimeType)
                    console.log(type + " - mimeType");
            }
            if (t1.invertZ !== t2.invertZ)
                console.log(type + " - invertZ");
            if (t1.isRenderTarget !== t2.isRenderTarget)
                console.log(type + " - isRenderTarget");
            if (t1.level !== t2.level)
                console.log(type + " - level");
            if (t1.wrapR !== t2.wrapR)
                console.log(type + " - wrapR");
            // Accessor
            if (t1.canRescale !== t2.canRescale)
                console.log(type + " - canRescale");
            if (t1.coordinatesIndex !== t2.coordinatesIndex)
                console.log(type + " - coordinatesIndex");
            if (t1.coordinatesMode !== t2.coordinatesMode)
                console.log(type + " - coordinatesMode");
            if (t1.gammaSpace !== t2.gammaSpace)
                console.log(type + " - gammaSpace");
            if (t1.getAlphaFromRGB !== t2.getAlphaFromRGB)
                console.log(type + " - getAlphaFromRGB");
            if (t1.hasAlpha !== t2.hasAlpha)
                console.log(type + "- hasAlpha");
            if (t1.is2DArray !== t2.is2DArray)
                console.log(type + " - is2DArray");
            if (t1.is3D !== t2.is3D)
                console.log(type + " - is3D");
            if (t1.isBlocking !== t2.isBlocking)
                console.log(type + " - isBlocking");
            if (t1.isCube !== t2.isCube)
                console.log(type + " - isCube");
            if (t1.isRGBD !== t2.isRGBD)
                console.log(type + " - isRGBD");
            if (t1.linearSpecularLOD !== t2.linearSpecularLOD)
                console.log(type + " - linearSpecularLOD");
            if (t1.lodGenerationOffset !== t2.lodGenerationOffset)
                console.log(type + " - lodGenerationOffset");
            if (t1.lodGenerationScale !== t2.lodGenerationScale)
                console.log(type + " - lodGenerationScale");
            if (t1.noMipmap !== t2.noMipmap)
                console.log(type + " - noMipmap");
            if (t1.samplingMode !== t2.samplingMode)
                console.log(type + " - samplingMode");
            if (t1.textureFormat !== t2.textureFormat)
                console.log(type + " - textureFormat");
            if (t1.textureType !== t2.textureType)
                console.log(type + " - textureType");
            if (t1.wrapU !== t2.wrapU)
                console.log(type + " - wrapU");
            if (t1.wrapV !== t2.wrapV)
                console.log(type + " - wrapV");
        }
    }
}


/***/ }),

/***/ "../../3D/src/Components/ScenePreview/ScenePreview.ts":
/*!************************************************************!*\
  !*** ../../3D/src/Components/ScenePreview/ScenePreview.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ScenePreviewData": () => (/* binding */ ScenePreviewData),
/* harmony export */   "ScenesPreview": () => (/* binding */ ScenesPreview)
/* harmony export */ });
/* harmony import */ var _Components_DesignManagers_MeshDesignManager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Components/DesignManagers/MeshDesignManager */ "../../3D/src/Components/DesignManagers/MeshDesignManager.ts");
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


class ScenePreviewData {
}
class ScenesPreview {
    static getPreviewsAsync(scene, rootUrl, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const previewMaker = new ScenePreviewMaker(scene, rootUrl, options);
            const previews = yield previewMaker.getPreviewsAsync();
            previewMaker.dispose();
            return previews;
        });
    }
}
class ScenePreviewMaker {
    constructor(scene, rootUrl, options) {
        this._rootUrl = "";
        this._localEngine = null;
        this._hostingScene = null;
        this._hostingSceneHelper = null;
        this._scene = scene;
        this._rootUrl = rootUrl;
        this._options = options;
    }
    dispose() {
        this.disposeHostingScene();
        this.disposeLocalEngine();
    }
    createLocalEngine() {
        var _a, _b;
        if (!this._localEngine) {
            const localCanvas = document.createElement('canvas');
            localCanvas.id = "ScenePreviewCanvas";
            localCanvas.width = (_a = this._options.width) !== null && _a !== void 0 ? _a : 1024;
            localCanvas.height = (_b = this._options.height) !== null && _b !== void 0 ? _b : 1024;
            this._localEngine = new BABYLON.Engine(localCanvas, true, { premultipliedAlpha: false, preserveDrawingBuffer: true });
            this._localEngine.setSize(localCanvas.width, localCanvas.height);
            this._localEngine.displayLoadingUI = () => null;
            this._localEngine.hideLoadingUI = () => null;
        }
        return this._localEngine;
    }
    createScenePreviewFileAsync(rootUrl, sourceScene, container) {
        return __awaiter(this, void 0, void 0, function* () {
            const serialized = BABYLON.SceneSerializer.Serialize(sourceScene);
            const serializedScene = JSON.stringify(serialized);
            if (serializedScene) {
                const scene = new BABYLON.Scene(this._localEngine);
                if (scene) {
                    const helper = new _SceneHelper__WEBPACK_IMPORTED_MODULE_1__.SceneHelper(scene);
                    yield new Promise((resolve) => {
                        BABYLON.SceneLoader.Append(rootUrl, "data:" + serializedScene, scene, () => __awaiter(this, void 0, void 0, function* () {
                            var _a, _b, _c;
                            yield scene.whenReadyAsync();
                            helper.setupCamera();
                            helper.setupLights();
                            const arcCamera = scene.activeCamera;
                            arcCamera.position = this._options.camera.position;
                            arcCamera.target = this._options.camera.target;
                            // Re render dynamic textures
                            if (this._options.meshesWithCustomizationIds && this._options.zkDesign && this._options.zkModel && this._options.zkScene) {
                                for (const meshId of this._options.meshesWithCustomizationIds) {
                                    var ourMesh = scene.getMeshByID(meshId);
                                    if (ourMesh) {
                                        // Restore the original material id if it was changed from the mesh design manager
                                        if (ourMesh.metadata && ourMesh.metadata.originalNormalmapMaterialID) {
                                            ourMesh.material = (_a = scene.materials.find(x => x.id === ourMesh.metadata.originalNormalmapMaterialID)) !== null && _a !== void 0 ? _a : null;
                                        }
                                        yield _Components_DesignManagers_MeshDesignManager__WEBPACK_IMPORTED_MODULE_0__.MeshDesignManager.createMeshDesignManagerAsync(scene, this._options.zkScene, ourMesh, ourMesh.subMeshes && ourMesh.subMeshes.length > 0 ? ourMesh.subMeshes[0] : null, this._options.zkModel, this._options.zkDesign, true);
                                    }
                                }
                                // Sleep
                                yield new Promise((resolve) => {
                                    setTimeout(() => {
                                        resolve();
                                    }, 500);
                                });
                                scene.render();
                                yield new Promise((resolve) => {
                                    setTimeout(() => {
                                        resolve();
                                    }, 500);
                                });
                            }
                            container.previewFile = yield helper.takeContentScreenshotAsync((_b = this._options.width) !== null && _b !== void 0 ? _b : 1024, (_c = this._options.height) !== null && _c !== void 0 ? _c : 1024);
                            resolve();
                        }));
                    });
                }
            }
        });
    }
    getPreviewsAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this.createLocalEngine();
            const container = new ScenePreviewData();
            yield this.createScenePreviewFileAsync(this._rootUrl, this._scene, container);
            this.disposeHostingScene();
            this.disposeLocalEngine();
            return container;
        });
    }
    disposeLocalEngine() {
        if (this._localEngine)
            this._localEngine.dispose();
    }
    disposeHostingScene() {
        if (this._hostingSceneHelper) {
            this._hostingSceneHelper.dispose();
            this._hostingSceneHelper = null;
        }
        if (this._hostingScene) {
            this._hostingScene.dispose();
            this._hostingScene = null;
        }
    }
}


/***/ }),

/***/ "../../3D/src/Components/SceneToBlobs/SceneToBlobs.ts":
/*!************************************************************!*\
  !*** ../../3D/src/Components/SceneToBlobs/SceneToBlobs.ts ***!
  \************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SceneToBlobs": () => (/* binding */ SceneToBlobs)
/* harmony export */ });
/* harmony import */ var _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../Misc/WorkerPool */ "../../3D/src/Misc/WorkerPool.ts");

function loadScriptAsync(url) {
    if (typeof importScripts === "function") {
        importScripts(url);
        return Promise.resolve();
    }
    else {
        return new Promise((resolve, reject) => {
            BABYLON.Tools.LoadScript(url, () => {
                resolve();
            }, (message) => {
                reject(new Error(message));
            });
        });
    }
}
function importWorkerScriptsAsync(urls) {
    if (urls.length == 0)
        return Promise.resolve();
    let promises = [];
    for (let i = 0; i < urls.length; i++) {
        promises.push(loadScriptAsync(urls[i]));
    }
    return new Promise((resolve) => {
        Promise.all(promises).then(() => resolve());
    });
}
function chunkString(str, size) {
    // Rollup will try to execute this function with str as undefined. IDK
    if (!str)
        return null;
    return str.match(new RegExp('.[^]{1,' + size + '}', 'g'));
}
function makeBlobs(json, version, onProgress) {
    let name = "scene_" + version + ".babylon";
    let data = json;
    const blobInfos = [];
    // Se il file di scena supera i 5000000 di bytes viene spezzato in blocchi di 800000 che vengono compressi
    if (data.length <= 5000000) {
        // Unico blob. verifico se comprimere i dati 
        let compressed = false;
        if (data.length > 180 && data.length <= 1000000) {
            //Logger.info("Uncompressed file length: " + data.length);
            // compress file content
            data = LZString.compressToUint8Array(data);
            //Logger.info("Compressed file length: " + data.length);
            name = "compressed_" + name;
            compressed = true;
        }
        let blob = null;
        if (!compressed) {
            blob = new Blob([data], { type: "text/plain" });
        }
        else {
            let arrayBuffer = data.buffer;
            blob = new Blob([arrayBuffer]);
        }
        if (blob) {
            blobInfos.push({
                name: name, blob: blob
            });
        }
    }
    else {
        // separo il file in chunks da comprimere
        let chunks = chunkString(data, 800000);
        if (chunks) {
            for (let i = 0; i < chunks.length; i++) {
                let chunkData = chunks[i];
                let chunkFileName = name + "_part_" + i;
                let compressed = false;
                if (chunkData.length > 180) {
                    //Logger.info("Uncompressed file length: " + chunkData.length);
                    // compress file content
                    chunkData = LZString.compressToUint8Array(chunkData);
                    //Logger.info("Compressed file length: " + chunkData.length);
                    chunkFileName = "compressed_" + chunkFileName;
                    compressed = true;
                }
                let blob = null;
                if (!compressed) {
                    blob = new Blob([chunkData], { type: "text/plain" });
                }
                else {
                    var arrayBuffer = chunkData.buffer;
                    blob = new Blob([arrayBuffer]);
                }
                if (blob) {
                    blobInfos.push({
                        name: chunkFileName, blob: blob
                    });
                }
                onProgress(i / chunks.length * 100);
            }
        }
    }
    return blobInfos;
}
function getAbsoluteUrl(url) {
    if (typeof document !== "object" || typeof url !== "string") {
        return url;
    }
    return BABYLON.Tools.GetAbsoluteUrl(url);
}
/**
 * The worker function that gets converted to a blob url to pass into a worker.
 */
function worker() {
    let initializerPromise;
    onmessage = (event) => {
        const data = event.data;
        switch (data.id) {
            case "init": {
                const urls = data.urls;
                initializerPromise = importWorkerScriptsAsync(urls);
                postMessage("done");
                break;
            }
            case "makeBlobs": {
                if (!initializerPromise) {
                    throw new Error("Worker not initialized");
                }
                initializerPromise.then(() => {
                    const json = data.json;
                    const version = data.version;
                    const blobInfos = makeBlobs(json, version, (perc) => {
                        postMessage({ id: "progress", perc: perc });
                    });
                    postMessage({ id: "result", blobInfos: blobInfos });
                    postMessage("done");
                });
                break;
            }
        }
    };
}
class SceneToBlobs {
    /**
 * Constructor
 * @param numWorkers The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
*/
    constructor(numWorkers = SceneToBlobs.DefaultNumWorkers) {
        const scriptUrls = ['/Scripts/libs/lz-string/base64-string.js',
            '/Scripts/libs/lz-string/lz-string.min.js'
        ].map(url => getAbsoluteUrl(url));
        if (numWorkers && typeof Worker === "function") {
            const workerContent = `${loadScriptAsync}${importWorkerScriptsAsync}${chunkString}${makeBlobs}(${worker})()`;
            const workerBlobUrl = URL.createObjectURL(new Blob([workerContent], { type: "application/javascript" }));
            const workerPromises = new Array(numWorkers);
            for (let i = 0; i < workerPromises.length; i++) {
                workerPromises[i] = new Promise((resolve, reject) => {
                    const worker = new Worker(workerBlobUrl);
                    const onError = (error) => {
                        worker.removeEventListener("error", onError);
                        worker.removeEventListener("message", onMessage);
                        reject(error);
                    };
                    const onMessage = (message) => {
                        if (message.data === "done") {
                            worker.removeEventListener("error", onError);
                            worker.removeEventListener("message", onMessage);
                            resolve(worker);
                        }
                    };
                    worker.addEventListener("error", onError);
                    worker.addEventListener("message", onMessage);
                    worker.postMessage({
                        id: "init",
                        urls: scriptUrls
                    });
                });
            }
            this._workerPoolPromise = Promise.all(workerPromises).then((workers) => {
                return new _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_0__.WorkerPool(workers);
            });
        }
    }
    static GetDefaultNumWorkers() {
        if (typeof navigator !== "object" || !navigator.hardwareConcurrency) {
            return 1;
        }
        // Use 50% of the available logical processors but capped at 2.
        return Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 2);
    }
    /**
     * Default instance for the draco compression object.
     */
    static get Default() {
        if (!SceneToBlobs._Default) {
            SceneToBlobs._Default = new SceneToBlobs();
        }
        return SceneToBlobs._Default;
    }
    dispose() {
        //if (this._workerPoolPromise) {
        //    this._workerPoolPromise.then((workerPool) => {
        //        workerPool.dispose();
        //    });
        //}
        //delete this._workerPoolPromise;
    }
    /**
 * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
 * @returns a promise that resolves when ready
 */
    whenReadyAsync() {
        if (this._workerPoolPromise) {
            return this._workerPoolPromise.then(() => { });
        }
        return Promise.resolve();
    }
    getSceneBlobsAsync(json, version, onProgress) {
        if (this._workerPoolPromise) {
            return this._workerPoolPromise.then((workerPool) => {
                return new Promise((resolve, reject) => {
                    workerPool.push((worker, onComplete) => {
                        let blobInfos = [];
                        const onError = (error) => {
                            worker.removeEventListener("error", onError);
                            worker.removeEventListener("message", onMessage);
                            reject(error);
                            onComplete();
                        };
                        const onMessage = (message) => {
                            if (message.data === "done") {
                                worker.removeEventListener("error", onError);
                                worker.removeEventListener("message", onMessage);
                                resolve(blobInfos);
                                onComplete();
                            }
                            else if (message.data.id === "progress") {
                                onProgress(message.data.perc);
                            }
                            else if (message.data.id === "result") {
                                blobInfos = message.data.blobInfos;
                            }
                        };
                        worker.addEventListener("error", onError);
                        worker.addEventListener("message", onMessage);
                        worker.postMessage({ id: "makeBlobs", json: json, version: version });
                    });
                });
            });
        }
        throw new Error("SceneToBlob worker is not available");
    }
}
/**
 * Default number of workers to create when splitting files
 */
SceneToBlobs.DefaultNumWorkers = SceneToBlobs.GetDefaultNumWorkers();
SceneToBlobs._Default = null;


/***/ }),

/***/ "../../3D/src/Components/Selector/ElementSelector.ts":
/*!***********************************************************!*\
  !*** ../../3D/src/Components/Selector/ElementSelector.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ElementSelector": () => (/* binding */ ElementSelector)
/* harmony export */ });
class ElementSelector {
    constructor() {
    }
    getSubmeshIdx(selectionExpression) {
        let idx = selectionExpression.lastIndexOf("-");
        if (idx != -1) {
            selectionExpression = selectionExpression.substring(0, idx);
            let smidx = Number(selectionExpression.substring(idx + 1));
            if (smidx && !isNaN(smidx))
                return smidx;
        }
        return null;
    }
    getRegExp(selectionExpression, type) {
        let subMeshIndex = 0;
        if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
            let idx = selectionExpression.lastIndexOf("-");
            if (idx != -1) {
                selectionExpression = selectionExpression.substring(0, idx);
                let smidx = Number(selectionExpression.substring(idx + 1));
                if (smidx && !isNaN(smidx)) {
                    subMeshIndex = smidx;
                }
            }
        }
        return new RegExp(this.escapeRegExp(selectionExpression).replace(/\\\*/g, ".*"), "i");
    }
    getElements(zkScene, scene, filter, expression, type) {
        const elements = [];
        // Le espressioni ammesse sono quelle con i caratteri jolly *
        // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
        // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
        // Es. "classic_*;modern_*;sport_*"
        const parts = expression.split(";");
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            let selectionExpression = part;
            let regExp = this.getRegExp(part, type);
            if ((type & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
                const meshes = this.getMeshes(zkScene, scene, filter, regExp, selectionExpression);
                Array.prototype.push.apply(elements, meshes);
            }
            if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
                let subMeshIndex = this.getSubmeshIdx(selectionExpression);
                if (subMeshIndex) {
                    const subMeshes = this.getSubMeshes(zkScene, scene, filter, regExp, selectionExpression, subMeshIndex);
                    Array.prototype.push.apply(elements, subMeshes);
                }
            }
            if ((type & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
                const materials = this.getMaterials(zkScene, scene, filter, regExp, selectionExpression);
                Array.prototype.push.apply(elements, materials);
            }
            if ((type & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
                const lights = this.getLights(zkScene, scene, filter, regExp, selectionExpression);
                Array.prototype.push.apply(elements, lights);
            }
            if ((type & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
                const cameras = this.getCameras(zkScene, scene, filter, regExp, selectionExpression);
                Array.prototype.push.apply(elements, cameras);
            }
            if ((type & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
                const locations = this.getCameraLocations(zkScene, scene, filter, regExp);
                Array.prototype.push.apply(elements, locations);
            }
        }
        return elements;
    }
    getMeshElements(zkScene, scene, filter, expression, type) {
        const elements = [];
        // Le espressioni ammesse sono quelle con i caratteri jolly *
        // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
        // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
        // Es. "classic_*;modern_*;sport_*"
        const parts = expression.split(";");
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            let selectionExpression = part;
            let regExp = this.getRegExp(part, type);
            if ((type & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
                const meshes = this.getMeshes(zkScene, scene, filter, regExp, selectionExpression);
                Array.prototype.push.apply(elements, meshes);
            }
        }
        return elements;
    }
    getSubMeshElements(zkScene, scene, filter, expression, type) {
        const elements = [];
        // Le espressioni ammesse sono quelle con i caratteri jolly *
        // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
        // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
        // Es. "classic_*;modern_*;sport_*"
        const parts = expression.split(";");
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            let selectionExpression = part;
            let regExp = this.getRegExp(part, type);
            if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
                let subMeshIndex = this.getSubmeshIdx(selectionExpression);
                if (subMeshIndex) {
                    const subMeshes = this.getSubMeshes(zkScene, scene, filter, regExp, selectionExpression, subMeshIndex);
                    Array.prototype.push.apply(elements, subMeshes);
                }
            }
        }
        return elements;
    }
    getMaterialElements(zkScene, scene, filter, expression, type) {
        const elements = [];
        // Le espressioni ammesse sono quelle con i caratteri jolly *
        // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
        // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
        // Es. "classic_*;modern_*;sport_*"
        const parts = expression.split(";");
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            let selectionExpression = part;
            let regExp = this.getRegExp(part, type);
            if ((type & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
                const materials = this.getMaterials(zkScene, scene, filter, regExp, selectionExpression);
                Array.prototype.push.apply(elements, materials);
            }
        }
        return elements;
    }
    getLightElements(zkScene, scene, filter, expression, type) {
        const elements = [];
        // Le espressioni ammesse sono quelle con i caratteri jolly *
        // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
        // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
        // Es. "classic_*;modern_*;sport_*"
        const parts = expression.split(";");
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            let selectionExpression = part;
            let regExp = this.getRegExp(part, type);
            if ((type & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
                const lights = this.getLights(zkScene, scene, filter, regExp, selectionExpression);
                Array.prototype.push.apply(elements, lights);
            }
        }
        return elements;
    }
    getCameraElements(zkScene, scene, filter, expression, type) {
        const elements = [];
        // Le espressioni ammesse sono quelle con i caratteri jolly *
        // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
        // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
        // Es. "classic_*;modern_*;sport_*"
        const parts = expression.split(";");
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            let selectionExpression = part;
            let regExp = this.getRegExp(part, type);
            if ((type & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
                const cameras = this.getCameras(zkScene, scene, filter, regExp, selectionExpression);
                Array.prototype.push.apply(elements, cameras);
            }
        }
        return elements;
    }
    getCameraLocationElements(zkScene, scene, filter, expression, type) {
        const elements = [];
        // Le espressioni ammesse sono quelle con i caratteri jolly *
        // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
        // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
        // Es. "classic_*;modern_*;sport_*"
        const parts = expression.split(";");
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            let selectionExpression = part;
            let regExp = this.getRegExp(part, type);
            if ((type & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
                const locations = this.getCameraLocations(zkScene, scene, filter, regExp);
                Array.prototype.push.apply(elements, locations);
            }
        }
        return elements;
    }
    getOffloadedElementIDs(zkScene, scene, filter, expression, type) {
        const ids = [];
        // Le espressioni ammesse sono quelle con i caratteri jolly *
        // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
        // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
        // Es. "classic_*;modern_*;sport_*"
        const parts = expression.split(";");
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            let selectionExpression = part;
            let subMeshIndex = 0;
            if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
                var idx = part.lastIndexOf("-");
                if (idx != -1) {
                    selectionExpression = part.substring(0, idx);
                    let smidx = Number(part.substring(idx + 1));
                    if (smidx && !isNaN(smidx)) {
                        subMeshIndex = smidx;
                    }
                }
            }
            var regExp = new RegExp(this.escapeRegExp(selectionExpression).replace(/\\\*/g, ".*"), "i");
            if ((type & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
                var materialIDs = this.getOffloadedMaterialIDs(zkScene, scene, filter, regExp, selectionExpression);
                Array.prototype.push.apply(ids, materialIDs);
            }
        }
        return ids;
    }
    getDelayedElementIDs(zkScene, scene, filter, expression, type) {
        const ids = [];
        // Le espressioni ammesse sono quelle con i caratteri jolly *
        // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
        // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
        // Es. "classic_*;modern_*;sport_*"
        const parts = expression.split(";");
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            let selectionExpression = part;
            let subMeshIndex = 0;
            if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
                var idx = part.lastIndexOf("-");
                if (idx != -1) {
                    selectionExpression = part.substring(0, idx);
                    let smidx = Number(part.substring(idx + 1));
                    if (smidx && !isNaN(smidx)) {
                        subMeshIndex = smidx;
                    }
                }
            }
            var regExp = new RegExp(this.escapeRegExp(selectionExpression).replace(/\\\*/g, ".*"), "i");
            if ((type & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
                var materialIDs = this.getDelayedMaterialIDs(zkScene, scene, filter, regExp, selectionExpression);
                Array.prototype.push.apply(ids, materialIDs);
            }
        }
        return ids;
    }
    getMeshes(zkScene, scene, filter, regExp, originalExpression) {
        const meshes = [];
        if (scene && scene instanceof BABYLON.Scene) {
            for (let i = 0; i < scene.meshes.length; i++) {
                const mesh = scene.meshes[i];
                if (((mesh.name && regExp.test(mesh.name)) ||
                    (mesh.id && mesh.id == originalExpression)) &&
                    this.verifyFilter(mesh.id, filter))
                    meshes.push(mesh);
            }
        }
        return meshes;
    }
    getSubMeshes(zkScene, scene, filter, regExp, originalExpression, subMeshIndex) {
        const subMeshes = [];
        if (scene && scene instanceof BABYLON.Scene) {
            for (let i = 0; i < scene.meshes.length; i++) {
                const mesh = scene.meshes[i];
                if (((mesh.name && regExp.test(mesh.name)) ||
                    (mesh.id && mesh.id == originalExpression)) &&
                    this.verifyFilter(mesh.id, filter) &&
                    subMeshIndex < mesh.subMeshes.length &&
                    subMeshIndex >= 0)
                    subMeshes.push(mesh.subMeshes[subMeshIndex]);
            }
        }
        return subMeshes;
    }
    getMaterials(zkScene, scene, filter, regExp, originalExpression) {
        const materials = [];
        // Nella selezione considero anche i materiali creati clonati usati per gli effetti sul design
        if (scene && scene instanceof BABYLON.Scene) {
            for (let i = 0; i < scene.materials.length; i++) {
                const material = scene.materials[i];
                if (((material.name && regExp.test(material.name)) ||
                    (material.id && material.id == originalExpression) ||
                    (material.metadata && !material.metadata.isRealMaterial && material.metadata.originalMaterialID == originalExpression)) &&
                    this.verifyFilter(material.id, filter))
                    materials.push(material);
            }
        }
        return materials;
    }
    getOffloadedMaterialIDs(zkScene, scene, filter, regExp, originalExpression) {
        const materialIDs = [];
        if (scene && scene instanceof BABYLON.Scene && scene.metadata && scene.metadata.offloadedMaterials) {
            for (let key in scene.metadata.offloadedMaterials) {
                const info = scene.metadata.offloadedMaterials[key];
                if (((info.name && regExp.test(info.name)) ||
                    (key && key == originalExpression)) &&
                    this.verifyFilter(key, filter))
                    materialIDs.push(key);
            }
        }
        return materialIDs;
    }
    getDelayedMaterialIDs(zkScene, scene, filter, regExp, originalExpression) {
        const materialIDs = [];
        if (scene && scene instanceof BABYLON.Scene && scene.metadata && scene.metadata.delayedMaterials) {
            for (let key in scene.metadata.delayedMaterials) {
                const info = scene.metadata.delayedMaterials[key];
                if (((info.name && regExp.test(info.name)) ||
                    (key && key == originalExpression)) &&
                    this.verifyFilter(key, filter))
                    materialIDs.push(key);
            }
        }
        return materialIDs;
    }
    getLights(zkScene, scene, filter, regExp, originalExpression) {
        const lights = [];
        if (scene && scene instanceof BABYLON.Scene) {
            for (let i = 0; i < scene.lights.length; i++) {
                const light = scene.lights[i];
                if (((light.name && regExp.test(light.name)) ||
                    (light.id && light.id == originalExpression)) &&
                    this.verifyFilter(light.id, filter))
                    lights.push(light);
            }
        }
        return lights;
    }
    getCameras(zkScene, scene, filter, regExp, originalExpression) {
        const cameras = [];
        if (scene && scene instanceof BABYLON.Scene) {
            for (let i = 0; i < scene.cameras.length; i++) {
                const camera = scene.cameras[i];
                if (((camera.name && regExp.test(camera.name)) ||
                    (camera.id && camera.id == originalExpression)) &&
                    this.verifyFilter(camera.id, filter))
                    cameras.push(camera);
            }
        }
        return cameras;
    }
    getCameraLocations(zkScene, scene, filter, regExp) {
        var locations = [];
        if (zkScene && zkScene instanceof Zakeke.Scene) {
            for (var i = 0; i < zkScene.get("cameraLocations").length; i++) {
                var cameraLocation = zkScene.get("cameraLocations").at(i);
                var id = cameraLocation.getLocationID();
                var name = cameraLocation.get("name");
                if (((name && regExp.test(name)) ||
                    (id && regExp.test(id))) &&
                    this.verifyFilter(id, filter))
                    locations.push(cameraLocation);
            }
        }
        return locations;
    }
    getYesNoElements(zkScene, scene, filter, expression, type) {
        const elements = { yes: [], no: [] };
        // Le espressioni ammesse sono quelle con i caratteri jolly *
        // Es. A*ric* è soddisfatto da Apricena ma non da Apicena.
        // E' possibile concatenare più espressione usando il simbolo ";" come separatore.
        // Es. "classic_*;modern_*;sport_*"
        const parts = expression.split(";");
        for (let i = 0; i < parts.length; i++) {
            const part = parts[i];
            let selectionExpression = part;
            let subMeshIndex = 0;
            if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
                let idx = part.lastIndexOf("-");
                if (idx != -1) {
                    selectionExpression = part.substring(0, idx);
                    let smidx = Number(part.substring(idx + 1));
                    if (smidx && !isNaN(smidx)) {
                        subMeshIndex = smidx;
                    }
                }
            }
            const regExp = new RegExp(this.escapeRegExp(selectionExpression).replace(/\\\*/g, ".*"), "i");
            if ((type & MPlaza.SceneElementType.Mesh) == MPlaza.SceneElementType.Mesh) {
                const meshes = this.getYesNoMeshes(zkScene, scene, filter, regExp);
                Array.prototype.push.apply(elements.yes, meshes.yes);
                Array.prototype.push.apply(elements.no, meshes.no);
            }
            if ((type & MPlaza.SceneElementType.SubMesh) == MPlaza.SceneElementType.SubMesh) {
                const subMeshes = this.getYesNoSubMeshes(zkScene, scene, filter, regExp, subMeshIndex);
                Array.prototype.push.apply(elements.yes, subMeshes.yes);
                Array.prototype.push.apply(elements.no, subMeshes.no);
            }
            if ((type & MPlaza.SceneElementType.Material) == MPlaza.SceneElementType.Material) {
                const materials = this.getYesNoMaterials(zkScene, scene, filter, regExp);
                Array.prototype.push.apply(elements.yes, materials.yes);
                Array.prototype.push.apply(elements.no, materials.no);
            }
            if ((type & MPlaza.SceneElementType.Light) == MPlaza.SceneElementType.Light) {
                const lights = this.getYesNoLights(zkScene, scene, filter, regExp);
                Array.prototype.push.apply(elements.yes, lights.yes);
                Array.prototype.push.apply(elements.no, lights.no);
            }
            if ((type & MPlaza.SceneElementType.Camera) == MPlaza.SceneElementType.Camera) {
                const cameras = this.getYesNoCameras(zkScene, scene, filter, regExp);
                Array.prototype.push.apply(elements.yes, cameras.yes);
                Array.prototype.push.apply(elements.no, cameras.no);
            }
            if ((type & MPlaza.SceneElementType.CameraLocation) == MPlaza.SceneElementType.CameraLocation) {
                const locations = this.getYesNoCameraLocations(zkScene, scene, filter, regExp);
                Array.prototype.push.apply(elements.yes, locations.yes);
                Array.prototype.push.apply(elements.no, locations.no);
            }
        }
        return elements;
    }
    getYesNoMeshes(zkScene, scene, filter, regExp) {
        const elements = { yes: [], no: [] };
        if (scene && scene instanceof BABYLON.Scene) {
            for (let i = 0; i < scene.meshes.length; i++) {
                let mesh = scene.meshes[i];
                let arr = elements.no;
                if (((mesh.name && regExp.test(mesh.name)) ||
                    (mesh.id && regExp.test(mesh.id))) &&
                    this.verifyFilter(mesh.id, filter)) {
                    arr = elements.yes;
                }
                arr.push(mesh);
            }
        }
        return elements;
    }
    getYesNoSubMeshes(zkScene, scene, filter, regExp, subMeshIndex) {
        const elements = { yes: [], no: [] };
        if (scene && scene instanceof BABYLON.Scene) {
            for (let i = 0; i < scene.meshes.length; i++) {
                let mesh = scene.meshes[i];
                if (((mesh.name && regExp.test(mesh.name)) ||
                    (mesh.id && regExp.test(mesh.id))) &&
                    this.verifyFilter(mesh.id, filter) &&
                    mesh.subMeshes) {
                    for (let j = 0; j < mesh.subMeshes.length; j++) {
                        if (j == subMeshIndex)
                            elements.yes.push(mesh.subMeshes[j]);
                        else
                            elements.no.push(mesh.subMeshes[j]);
                    }
                }
            }
        }
        return elements;
    }
    getYesNoMaterials(zkScene, scene, filter, regExp) {
        const elements = { yes: [], no: [] };
        if (scene && scene instanceof BABYLON.Scene) {
            for (let i = 0; i < scene.materials.length; i++) {
                let material = scene.materials[i];
                if (((material.name && regExp.test(material.name)) ||
                    (material.id && regExp.test(material.id))) &&
                    this.verifyFilter(material.id, filter)) {
                    elements.yes.push(material);
                }
                else {
                    elements.no.push(material);
                }
            }
        }
        return elements;
    }
    getYesNoLights(zkScene, scene, filter, regExp) {
        const elements = { yes: [], no: [] };
        if (scene && scene instanceof BABYLON.Scene) {
            for (let i = 0; i < scene.lights.length; i++) {
                let light = scene.lights[i];
                if (((light.name && regExp.test(light.name)) ||
                    (light.id && regExp.test(light.id))) &&
                    this.verifyFilter(light.id, filter)) {
                    elements.yes.push(light);
                }
                else {
                    elements.no.push(light);
                }
            }
        }
        return elements;
    }
    getYesNoCameras(zkScene, scene, filter, regExp) {
        const elements = { yes: [], no: [] };
        if (scene && scene instanceof BABYLON.Scene) {
            for (let i = 0; i < scene.cameras.length; i++) {
                let camera = scene.cameras[i];
                if (((camera.name && regExp.test(camera.name)) ||
                    (camera.id && regExp.test(camera.id))) &&
                    this.verifyFilter(camera.id, filter)) {
                    elements.yes.push(camera);
                }
                else {
                    elements.no.push(camera);
                }
            }
        }
        return elements;
    }
    getYesNoCameraLocations(zkScene, scene, filter, regExp) {
        const elements = { yes: [], no: [] };
        if (zkScene && zkScene instanceof Zakeke.Scene) {
            for (let i = 0; i < zkScene.get("cameraLocations").length; i++) {
                let cameraLocation = zkScene.get("cameraLocations").at(i);
                let id = cameraLocation.getLocationID();
                let name = cameraLocation.get("name");
                if (((name && regExp.test(name)) ||
                    (id && regExp.test(id))) &&
                    this.verifyFilter(id, filter)) {
                    elements.yes.push(cameraLocation);
                }
                else {
                    elements.no.push(cameraLocation);
                }
            }
        }
        return elements;
    }
    escapeRegExp(str) {
        return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
    }
    verifyFilter(id, filter) {
        if (!filter)
            return true;
        if (filter.length == 0)
            return true;
        return filter.indexOf(id) !== -1;
    }
}


/***/ }),

/***/ "../../3D/src/Components/Shadows/InnerShadow.ts":
/*!******************************************************!*\
  !*** ../../3D/src/Components/Shadows/InnerShadow.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "InnerShadow": () => (/* binding */ InnerShadow)
/* harmony export */ });
/* harmony import */ var _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ProceduralTextures/ForegroundBackgroundProceduralTexture */ "../../3D/src/Components/ProceduralTextures/ForegroundBackgroundProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ProceduralTextures/BlurXProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurXProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ProceduralTextures/BlurYProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurYProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_MoveProceduralTexture__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../ProceduralTextures/MoveProceduralTexture */ "../../3D/src/Components/ProceduralTextures/MoveProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../ProceduralTextures/MultiplyProceduralTexture */ "../../3D/src/Components/ProceduralTextures/MultiplyProceduralTexture.ts");
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};






class InnerShadow {
    constructor(baseTexture, size, config, scene) {
        this._baseTexture = baseTexture;
        this._size = size;
        this._scene = scene;
        this._mask = new _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.ForegroundBackgroundProceduralTexture("mask", this._size, this._scene, this._baseTexture);
        this._mask.backColor = new BABYLON.Vector3(0, 0, 0);
        this._mask.foreColor = new BABYLON.Vector3(1, 1, 1);
        this._mask.refreshRate = 0;
        this._shadow = new _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.ForegroundBackgroundProceduralTexture("shadow", this._size, this._scene, this._baseTexture);
        this._shadow.backColor = new BABYLON.Vector3(0.1, 0.1, 0.1);
        this._shadow.foreColor = new BABYLON.Vector3(1, 1, 1);
        this._shadow.refreshRate = 0;
        this._shadowBlurX = new _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_1__.BlurXProceduralTexture("shadow_blurX", this._size, this._scene, this._shadow);
        this._shadowBlurX.blur = 5;
        this._shadowBlurX.refreshRate = 0;
        this._shadowBlurY = new _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_2__.BlurYProceduralTexture("shadow_blurY", this._size, this._scene, this._shadowBlurX);
        this._shadowBlurY.blur = 5;
        this._shadowBlurY.refreshRate = 0;
        this._shadowMove = new _ProceduralTextures_MoveProceduralTexture__WEBPACK_IMPORTED_MODULE_3__.MoveProceduralTexture("shadow_move", this._size, this._scene, this._shadowBlurY);
        this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5);
        this._shadowMove.refreshRate = 0;
        this._lightmap = new _ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_4__.MultiplyProceduralTexture("lightmap", this._size, this._scene, this._shadowMove, this._mask);
        this._lightmap.refreshRate = 0;
        this.updateParameters(config);
    }
    updateParameters(config) {
        if (config) {
            let backColor = new BABYLON.Vector3(0, 0, 0);
            if (config.get("color")) {
                const color = BABYLON.Color3.FromHexString(config.get("color"));
                backColor = new BABYLON.Vector3(color.r, color.g, color.b);
            }
            this._shadow.backColor = backColor;
            let distance = 1;
            let angle = 135;
            if (config.get("angle") !== undefined && config.get("angle") !== null)
                angle = config.get("angle");
            if (config.get("distance") != undefined && config.get("distance") !== null)
                distance = config.get("distance");
            let radians = angle * Math.PI / 180;
            radians = this.wrapPi(radians);
            const xDistance = Math.cos(radians) * distance;
            const yDistance = Math.sin(radians) * distance;
            this._shadowMove.offset = new BABYLON.Vector2(-xDistance, yDistance);
            let blur = 5;
            if (config.get("size") !== undefined && config.get("size") !== null)
                blur = Math.max(0, Math.min(100, config.get("size")));
            this._shadowBlurX.blur = blur;
            this._shadowBlurY.blur = blur;
        }
    }
    // riporta angle nel range -180, + 180
    wrapPi(angle) {
        if (Math.abs(angle) > Math.PI) {
            var twoppi = 2.0 * Math.PI;
            var revolutions = Math.floor((angle + Math.PI) * (1.0 / twoppi));
            angle -= revolutions * twoppi;
        }
        return angle;
    }
    dispose() {
        this._mask.dispose();
        this._shadow.dispose();
        this._shadowBlurX.dispose();
        this._shadowBlurY.dispose();
        this._shadowMove.dispose();
        this._lightmap.dispose();
    }
    getInnerShadowTextureAsync(baseTexture) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateAsync(baseTexture);
            return this._lightmap;
        });
    }
    updateAsync(baseTexture, config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.updateParameters(config);
            this._baseTexture = baseTexture;
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_5__.SceneHelper.whenTextureIsReadyAsync(this._baseTexture);
            this._mask.baseTexture = this._baseTexture;
            yield this._mask.isReadyAsync();
            this._mask.render();
            this._shadow.baseTexture = this._baseTexture;
            yield this._shadow.isReadyAsync();
            this._shadow.render();
            yield this._shadowBlurX.isReadyAsync();
            this._shadowBlurX.render();
            yield this._shadowBlurY.isReadyAsync();
            this._shadowBlurY.render();
            yield this._shadowMove.isReadyAsync();
            this._shadowMove.render();
            yield this._lightmap.isReadyAsync();
            this._lightmap.render();
        });
    }
}


/***/ }),

/***/ "../../3D/src/Components/Shadows/OuterShadow.ts":
/*!******************************************************!*\
  !*** ../../3D/src/Components/Shadows/OuterShadow.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OuterShadow": () => (/* binding */ OuterShadow)
/* harmony export */ });
/* harmony import */ var _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../ProceduralTextures/ForegroundBackgroundProceduralTexture */ "../../3D/src/Components/ProceduralTextures/ForegroundBackgroundProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../ProceduralTextures/BlurXProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurXProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../ProceduralTextures/BlurYProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurYProceduralTexture.ts");
/* harmony import */ var _ProceduralTextures_MoveProceduralTexture__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../ProceduralTextures/MoveProceduralTexture */ "../../3D/src/Components/ProceduralTextures/MoveProceduralTexture.ts");
/* harmony import */ var _SceneHelper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};





class OuterShadow {
    constructor(baseTexture, size, config, scene) {
        this._size = size;
        this._baseTexture = baseTexture;
        this._scene = scene;
        this._shadow = new _ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_0__.ForegroundBackgroundProceduralTexture("shadow", this._size, this._scene, this._baseTexture);
        this._shadow.backColor = new BABYLON.Vector3(1, 1, 1);
        this._shadow.foreColor = new BABYLON.Vector3(0.2, 0.2, 0.2);
        this._shadow.refreshRate = 0;
        this._shadowBlurX = new _ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_1__.BlurXProceduralTexture("shadow_blurX", this._size, this._scene, this._shadow);
        this._shadowBlurX.blur = 15;
        this._shadowBlurX.refreshRate = 0;
        this._shadowBlurY = new _ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_2__.BlurYProceduralTexture("shadow_blurY", this._size, this._scene, this._shadowBlurX);
        this._shadowBlurY.blur = 15;
        this._shadowBlurY.refreshRate = 0;
        this._shadowMove = new _ProceduralTextures_MoveProceduralTexture__WEBPACK_IMPORTED_MODULE_3__.MoveProceduralTexture("shadow_move", this._size, this._scene, this._shadowBlurY);
        this._shadowMove.offset = new BABYLON.Vector2(2.5, 2.5);
        this._shadowMove.refreshRate = 0;
        this.updateParameters(config);
    }
    updateParameters(config) {
        if (config) {
            var foreColor = new BABYLON.Vector3(0, 0, 0);
            if (config.get("color")) {
                var color = BABYLON.Color3.FromHexString(config.get("color"));
                foreColor = new BABYLON.Vector3(color.r, color.g, color.b);
            }
            this._shadow.foreColor = foreColor;
            let distance = 1;
            let angle = 135;
            if (config.get("angle") !== undefined && config.get("angle") !== null)
                angle = config.get("angle");
            if (config.get("distance") != undefined && config.get("distance") !== null)
                distance = config.get("distance");
            let radians = angle * Math.PI / 180;
            radians = this.wrapPi(radians);
            const xDistance = Math.cos(radians) * distance;
            const yDistance = Math.sin(radians) * distance;
            this._shadowMove.offset = new BABYLON.Vector2(-xDistance, yDistance);
            let blur = 5;
            if (config.get("size") !== undefined && config.get("size") !== null)
                blur = Math.max(0, Math.min(100, config.get("size")));
            this._shadowBlurX.blur = blur;
            this._shadowBlurY.blur = blur;
        }
    }
    wrapPi(angle) {
        if (Math.abs(angle) > Math.PI) {
            var twoppi = 2.0 * Math.PI;
            var revolutions = Math.floor((angle + Math.PI) * (1.0 / twoppi));
            angle -= revolutions * twoppi;
        }
        return angle;
    }
    dispose() {
        this._shadow.dispose();
        this._shadowBlurX.dispose();
        this._shadowBlurY.dispose();
        this._shadowMove.dispose();
    }
    getOuterShadowTextureAsync(baseTexture) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateAsync(baseTexture);
            return this._shadowMove;
        });
    }
    updateAsync(baseTexture, config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.updateParameters(config);
            this._baseTexture = baseTexture;
            yield _SceneHelper__WEBPACK_IMPORTED_MODULE_4__.SceneHelper.whenTextureIsReadyAsync(this._baseTexture);
            this._shadow.baseTexture = this._baseTexture;
            yield this._shadow.isReadyAsync();
            this._shadow.render();
            yield this._shadowBlurX.isReadyAsync();
            this._shadowBlurX.render();
            yield this._shadowBlurY.isReadyAsync();
            this._shadowBlurY.render();
            yield this._shadowMove.isReadyAsync();
            this._shadowMove.render();
        });
    }
}


/***/ }),

/***/ "../../3D/src/Components/USDZ/UsdzHelper.ts":
/*!**************************************************!*\
  !*** ../../3D/src/Components/USDZ/UsdzHelper.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UsdzHelper": () => (/* binding */ UsdzHelper)
/* harmony export */ });
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class UsdzHelper {
    static convertGlbToUsdz(glbUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                let usdz = null;
                /* Test without renderer
                const localCanvas = document.createElement('canvas');
                localCanvas.id = "Threejs - usdz converter";
                localCanvas.width = 1024;
                localCanvas.height = 1024;
    
                let camera, scene, renderer;
    
                renderer = new THREE.WebGLRenderer({ antialias: true, canvas: localCanvas });
                renderer.setPixelRatio(window.devicePixelRatio);
                renderer.setSize(window.innerWidth, window.innerHeight);
                renderer.toneMapping = THREE.ACESFilmicToneMapping;
                renderer.outputEncoding = THREE.sRGBEncoding;
                */
                //document.body.appendChild(renderer.domElement);
                //camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.25, 20);
                //camera.position.set(- 2.5, 0.6, 3.0);
                //const pmremGenerator = new THREE.PMREMGenerator(renderer);
                //scene = new THREE.Scene();
                //scene.background = new THREE.Color(0xf0f0f0);
                //scene.environment = pmremGenerator.fromScene( new RoomEnvironment(), 0.04 ).texture;
                const loader = new THREE.GLTFLoader();
                loader.load(glbUrl, function (gltf) {
                    return __awaiter(this, void 0, void 0, function* () {
                        //scene.add(gltf.scene);
                        // modifico la geometria in base alle trasformazioni
                        // gltf.scene.scale.multiplyScalar(scalingFactor); // scaling
                        gltf.scene.updateWorldMatrix(true, true);
                        //render();
                        // USDZ
                        const exporter = new THREE.USDZExporter();
                        const arraybuffer = yield exporter.parse(gltf.scene);
                        usdz = new Blob([arraybuffer], { type: 'model/vnd.usdz+zip' });
                        //renderer.dispose();
                        resolve(usdz);
                    });
                });
            });
        });
    }
}


/***/ }),

/***/ "../../3D/src/Enumerations.ts":
/*!************************************!*\
  !*** ../../3D/src/Enumerations.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EditingMode": () => (/* binding */ EditingMode),
/* harmony export */   "EnvironmentMode": () => (/* binding */ EnvironmentMode),
/* harmony export */   "ZakekeEnvironment": () => (/* binding */ ZakekeEnvironment)
/* harmony export */ });
var EnvironmentMode;
(function (EnvironmentMode) {
    EnvironmentMode[EnvironmentMode["Editor"] = 1] = "Editor";
    EnvironmentMode[EnvironmentMode["Viewer"] = 2] = "Viewer";
})(EnvironmentMode || (EnvironmentMode = {}));
var EditingMode;
(function (EditingMode) {
    EditingMode["None"] = "None";
    EditingMode["Translate"] = "Translate";
    EditingMode["Rotate"] = "Rotate";
    EditingMode["Scaling"] = "Scaling";
})(EditingMode || (EditingMode = {}));
var ZakekeEnvironment;
(function (ZakekeEnvironment) {
    ZakekeEnvironment[ZakekeEnvironment["Customizer"] = 1] = "Customizer";
    ZakekeEnvironment[ZakekeEnvironment["Composer"] = 2] = "Composer";
    ZakekeEnvironment[ZakekeEnvironment["Viewer"] = 3] = "Viewer";
})(ZakekeEnvironment || (ZakekeEnvironment = {}));


/***/ }),

/***/ "../../3D/src/Helpers/debounce.ts":
/*!****************************************!*\
  !*** ../../3D/src/Helpers/debounce.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "debounce": () => (/* binding */ debounce)
/* harmony export */ });
/*
export function debounceAsync<T extends (...args: any[]) => any>(time: number, func: T): (...funcArgs: Parameters<T>) => Promise<ReturnType<T>> {
    let timeout: Timeout;

    return (...args: Parameters<T>): Promise<ReturnType<T>> => new Promise((resolve) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            resolve(func(...args));
        }, time)
    });
}
*/
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function debounce(func, waitMilliseconds = 50, options = {
    isImmediate: false
}) {
    let timeoutId;
    return function (...args) {
        const context = this;
        const doLater = function () {
            timeoutId = undefined;
            if (!options.isImmediate) {
                func.apply(context, args);
            }
        };
        const shouldCallNow = options.isImmediate && timeoutId === undefined;
        if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(doLater, waitMilliseconds);
        if (shouldCallNow) {
            func.apply(context, args);
        }
    };
}
function pippo(name) {
    return __awaiter(this, void 0, void 0, function* () {
        return;
    });
}


/***/ }),

/***/ "../../3D/src/Helpers/utils.ts":
/*!*************************************!*\
  !*** ../../3D/src/Helpers/utils.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Utils": () => (/* binding */ Utils)
/* harmony export */ });
/// <reference path="../../../typescript_definitions/jquery.d.ts" />
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class Utils {
    static isIPhoneX() {
        // Really basic check for the ios platform
        // https://stackoverflow.com/questions/9038625/detect-if-device-is-ios
        const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window['MSStream'];
        // Get the device pixel ratio
        const ratio = window.devicePixelRatio || 1;
        // Define the users device screen dimensions
        const screen = {
            width: window.screen.width * ratio,
            height: window.screen.height * ratio
        };
        // iPhone X Detection
        if (iOS && screen.width === 1125 && screen.height === 2436) {
            return true;
        }
        else {
            return false;
        }
    }
    static isAndroid() {
        return /android/i.test(navigator.userAgent);
    }
    static isiOS() {
        return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    }
    static isMobile() {
        const userAgent = navigator.userAgent || navigator.vendor || self["opera"];
        return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i
            .test(userAgent) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i
                .test(userAgent.substr(0, 4));
    }
    static getViewport() {
        const m = document.compatMode === 'CSS1Compat';
        return {
            l: window.pageXOffset || (m ? document.documentElement.scrollLeft : document.body.scrollLeft),
            t: window.pageYOffset || (m ? document.documentElement.scrollTop : document.body.scrollTop),
            w: window.innerWidth || (m ? document.documentElement.clientWidth : document.body.clientWidth),
            h: window.innerHeight || (m ? document.documentElement.clientHeight : document.body.clientHeight)
        };
    }
    static getContrastYIQ(r, g, b) {
        var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return (yiq >= 128) ? 'black' : 'white';
    }
    static getContrastYIQHex(hexcolor) {
        var r = parseInt(hexcolor.substr(0, 2), 16);
        var g = parseInt(hexcolor.substr(2, 2), 16);
        var b = parseInt(hexcolor.substr(4, 2), 16);
        var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
        return (yiq >= 128) ? 'black' : 'white';
    }
    static arrayContains(array, itemToSearch) {
        if (typeof itemToSearch === "undefined" || typeof itemToSearch === null)
            return false;
        const contains = function (array, needle) {
            // Per spec, the way to identify NaN is that it is not equal to itself
            let findNaN = needle !== needle;
            let indexOf;
            if (!findNaN && typeof Array.prototype.indexOf === 'function') {
                indexOf = Array.prototype.indexOf;
                return indexOf.call(array, needle) > -1;
            }
            else {
                indexOf = function (array, needle) {
                    var i = -1, index = -1;
                    for (i = 0; i < array.length; i++) {
                        var item = array[i];
                        if ((findNaN && item !== item) || item === needle) {
                            index = i;
                            break;
                        }
                    }
                    return index;
                };
                return indexOf(array, needle) > -1;
            }
        };
        return contains(array, itemToSearch);
    }
    static getColorBrightness(hex) {
        // validate hex string
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        var r = parseInt(hex.substr(0 * 2, 2), 16);
        var g = parseInt(hex.substr(1 * 2, 2), 16);
        var b = parseInt(hex.substr(2 * 2, 2), 16);
        var brightness = Math.sqrt(r * r * 0.241 +
            g * g * 0.691 +
            b * b * 0.068);
        return brightness;
    }
    static isColorDark(hex) {
        return Utils.getColorBrightness(hex) < 130;
    }
    static changeColorLuminosity(hex, lum = 0) {
        // validate hex string
        hex = String(hex).replace(/[^0-9a-f]/gi, '');
        if (hex.length < 6) {
            hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
        }
        lum = lum || 0;
        // convert to decimal and change luminosity
        var rgb = "#", c, i;
        for (i = 0; i < 3; i++) {
            c = parseInt(hex.substr(i * 2, 2), 16);
            c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
            rgb += ("00" + c).substr(c.length);
        }
        return rgb;
    }
    static cropImageTransparency(imageDataURI, targetWidth, targetHeight, callback) {
        var img = new Image();
        var $canvas = $("<canvas>"); // create an offscreen canvas
        var canvas = $canvas[0];
        var context = canvas.getContext("2d");
        img.crossOrigin = "anonymous";
        img.onload = function () {
            $canvas.attr({ width: img.width, height: img.height });
            context = canvas.getContext("2d");
            if (context) {
                context.drawImage(img, 0, 0);
                let dataUrl = Utils.removeBlanks(canvas, img.width, img.height, targetWidth, targetHeight);
                if (callback)
                    callback(dataUrl);
            }
            else {
                alert('Get a real browser!');
            }
        };
        img.src = imageDataURI;
    }
    static trimImageAsync(imageDataURI) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const $canvas = $("<canvas>"); // create an offscreen canvas
            let canvas = $canvas[0];
            let context = canvas.getContext("2d");
            img.crossOrigin = "anonymous";
            img.onload = function () {
                $canvas.attr({ width: img.width, height: img.height });
                context = canvas.getContext("2d");
                if (context) {
                    context.drawImage(img, 0, 0);
                    let dataUrl = Utils.trimCanvas(canvas);
                    resolve(dataUrl);
                }
                else {
                    reject(new Error("HTML5 Canvas not supported"));
                }
            };
            img.src = imageDataURI;
        });
    }
    static trimCanvas(canvas) {
        const context = canvas.getContext("2d");
        if (!context)
            return null;
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
        const getAlpha = (x, y) => data[(imgWidth * y + x) * 4 + 3];
        const getRBGA = (x, y) => {
            return {
                red: data[(imgWidth * y + x) * 4],
                green: data[(imgWidth * y + x) * 4 + 1],
                blue: data[(imgWidth * y + x) * 4 + 2],
                alpha: data[(imgWidth * y + x) * 4 + 3]
            };
        };
        const isTransparent = (alpha) => alpha < 10;
        const scanY = (fromTop) => {
            const offset = fromTop ? 1 : -1;
            // loop through each row
            for (var y = fromTop ? 0 : imgHeight - 1; fromTop ? (y < imgHeight) : (y > -1); y += offset) {
                // loop through each column
                for (var x = 0; x < imgWidth; x++) {
                    if (!isTransparent(getAlpha(x, y))) {
                        return y;
                    }
                }
            }
            return null; // all image is transparent
        };
        const scanX = (fromLeft) => {
            const offset = fromLeft ? 1 : -1;
            // loop through each column
            for (var x = fromLeft ? 0 : imgWidth - 1; fromLeft ? (x < imgWidth) : (x > -1); x += offset) {
                // loop through each row
                for (var y = 0; y < imgHeight; y++) {
                    if (!isTransparent(getAlpha(x, y))) {
                        return x;
                    }
                }
            }
            return null; // all image is transparent
        };
        const cropTop = scanY(true);
        const cropBottom = scanY(false);
        const cropLeft = scanX(true);
        const cropRight = scanX(false);
        if (cropTop != null && cropBottom != null && cropLeft != null && cropRight != null) {
            const cropWidth = cropRight - cropLeft + 1;
            const cropHeight = cropBottom - cropTop + 1;
            const $croppedCanvas = $("<canvas>").attr({ width: cropWidth, height: cropHeight });
            const croppedCanvas = $croppedCanvas[0];
            var croppedContext = croppedCanvas.getContext("2d");
            if (!croppedContext)
                return null;
            croppedContext.drawImage(canvas, cropLeft, cropTop, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);
            var croppedImageData = croppedContext.getImageData(0, 0, croppedCanvas.width, croppedCanvas.height);
            var croppedDataUrl = croppedCanvas.toDataURL();
            return croppedDataUrl;
        }
        else
            return null;
    }
    static cropImageTransparencyAsync(imageDataURI, targetWidth, targetHeight) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            const $canvas = $("<canvas>"); // create an offscreen canvas
            let canvas = $canvas[0];
            let context = canvas.getContext("2d");
            img.crossOrigin = "anonymous";
            img.onload = function () {
                $canvas.attr({ width: img.width, height: img.height });
                context = canvas.getContext("2d");
                if (context) {
                    context.drawImage(img, 0, 0);
                    let dataUrl = Utils.removeBlanks(canvas, img.width, img.height, targetWidth, targetHeight);
                    resolve(dataUrl);
                }
                else {
                    reject(new Error("HTML5 Canvas not supported"));
                }
            };
            img.src = imageDataURI;
        });
    }
    ;
    static removeBlanks(canvas, imgWidth, imgHeight, targetWidth, targetHeight) {
        const context = canvas.getContext("2d");
        if (!context)
            return null;
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
        const getAlpha = (x, y) => data[(imgWidth * y + x) * 4 + 3];
        const getRBGA = (x, y) => {
            return {
                red: data[(imgWidth * y + x) * 4],
                green: data[(imgWidth * y + x) * 4 + 1],
                blue: data[(imgWidth * y + x) * 4 + 2],
                alpha: data[(imgWidth * y + x) * 4 + 3]
            };
        };
        const isTransparent = (alpha) => alpha === 0;
        const scanY = (fromTop) => {
            const offset = fromTop ? 1 : -1;
            // loop through each row
            for (var y = fromTop ? 0 : imgHeight - 1; fromTop ? (y < imgHeight) : (y > -1); y += offset) {
                // loop through each column
                for (var x = 0; x < imgWidth; x++) {
                    if (!isTransparent(getAlpha(x, y))) {
                        return y;
                    }
                }
            }
            return null; // all image is transparent
        };
        const scanX = (fromLeft) => {
            const offset = fromLeft ? 1 : -1;
            // loop through each column
            for (var x = fromLeft ? 0 : imgWidth - 1; fromLeft ? (x < imgWidth) : (x > -1); x += offset) {
                // loop through each row
                for (var y = 0; y < imgHeight; y++) {
                    if (!isTransparent(getAlpha(x, y))) {
                        return x;
                    }
                }
            }
            return null; // all image is transparent
        };
        const cropTop = scanY(true);
        const cropBottom = scanY(false);
        const cropLeft = scanX(true);
        const cropRight = scanX(false);
        if (cropTop != null && cropBottom != null && cropLeft != null && cropRight != null) {
            const cropWidth = cropRight - cropLeft;
            const cropHeight = cropBottom - cropTop;
            // Mantain proportions in canvas
            const canvasWidth = targetWidth;
            const canvasHeight = targetHeight;
            const ratioX = canvasWidth / cropWidth;
            const ratioY = canvasHeight / cropHeight;
            let finalWidth = cropWidth * ratioX;
            let finalHeight = cropHeight * ratioX;
            if (finalHeight > canvasHeight) {
                finalWidth = cropWidth * ratioY;
                finalHeight = cropHeight * ratioY;
            }
            const $croppedCanvas = $("<canvas>").attr({ width: canvasWidth, height: canvasHeight });
            const croppedCanvas = $croppedCanvas[0];
            var croppedContext = croppedCanvas.getContext("2d");
            if (!croppedContext)
                return null;
            croppedContext.drawImage(canvas, cropLeft, cropTop, cropWidth, cropHeight, (canvasWidth - finalWidth) / 2, (canvasHeight - finalHeight) / 2, finalWidth, finalHeight);
            var croppedImageData = croppedContext.getImageData(0, 0, croppedCanvas.width, croppedCanvas.height);
            var croppedDataUrl = croppedCanvas.toDataURL();
            return croppedDataUrl;
        }
        else
            return null;
    }
    /** Draw an image from data uri on a width * height canvas, create canvas inside method and return the data uri of canvas */
    static resizeImageFromDataUri(dataUrl, width, height, padding) {
        return new Promise(resolve => {
            const img = new Image();
            img.crossOrigin = "anonymous";
            img.onload = function () {
                const $canvas = $("<canvas>"); // create an offscreen canvas
                let canvas = $canvas[0];
                let context = canvas.getContext("2d");
                if (context) {
                    canvas.width = width;
                    canvas.height = height;
                    // Fit the image
                    const ratio = Math.min(width / img.width, height / img.height);
                    const newImageWidth = img.width * ratio;
                    const newImageHeight = img.height * ratio;
                    context.drawImage(img, 0, 0, img.width, img.height, (width - newImageWidth + padding) / 2, (height - newImageHeight + padding) / 2, newImageWidth - padding, newImageHeight - padding);
                    const dataUrl = canvas.toDataURL();
                    resolve(dataUrl);
                }
            };
            img.src = dataUrl;
        });
    }
    static getColorImage(hex, width, height) {
        var $canvas = $("<canvas>"); // create an offscreen canvas
        $canvas.attr({ width: width, height: height });
        var canvas = $canvas[0];
        var context = canvas.getContext("2d");
        if (context) {
            context.fillStyle = hex;
            context.fillRect(0, 0, width, height);
            var dataUrl = canvas.toDataURL();
            return dataUrl;
        }
        else {
            return null;
        }
    }
    /**
    * Split a string into chunks of the given size
    * @param  {String} str is the String to split
    * @param  {Number} size is the size you of the cuts
    * @return {Array} an Array with the strings
    */
    static chunkString(str, size) {
        // Rollup will try to execute this function with str as undefined. IDK
        if (!str)
            return null;
        return str.match(new RegExp('.[^]{1,' + size + '}', 'g'));
    }
    static getStringHashCode(str) {
        let hash = 0, i, chr;
        if (str.length === 0)
            return hash;
        for (i = 0; i < str.length; i++) {
            chr = str.charCodeAt(i);
            hash = ((hash << 5) - hash) + chr;
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
    static getAbsoluteUrl(relative) {
        var tempLink = document.createElement("a");
        tempLink.href = relative;
        const absolute = tempLink.href;
        return absolute;
    }
    static dataURItoBlob(dataURI) {
        // convert base64 to raw binary data held in a string
        // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
        var byteString = atob(dataURI.split(',')[1]);
        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        // write the bytes of the string to an ArrayBuffer
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        // write the ArrayBuffer to a blob, and you're done
        var bb = new Blob([ab], { type: mimeString });
        return bb;
    }
    static getRandomString(length, keyspace) {
        if ((typeof length !== 'number') && (length < 1)) {
            throw new RangeError('Length must be a positive integer!');
        }
        if (keyspace === undefined) {
            keyspace = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        }
        let result = '';
        const charactersLength = keyspace.length;
        for (var i = 0; i < length; i++) {
            result += keyspace.charAt(Math.floor(Math.random() * charactersLength));
        }
        return (result);
    }
    // Flip image vertically using canvas
    static flipImage(arrayBuffer, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve) => {
                const arrayBufferView = new Uint8Array(arrayBuffer);
                const blob = new Blob([arrayBufferView], { type });
                const urlCreator = window.URL || window.webkitURL;
                const imageUrl = urlCreator.createObjectURL(blob);
                // ArrayBuffer to image
                const image = new Image();
                image.src = imageUrl;
                image.onload = () => __awaiter(this, void 0, void 0, function* () {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    canvas.width = image.width;
                    canvas.height = image.height;
                    ctx.translate(0, image.height);
                    ctx.scale(1, -1);
                    ctx.drawImage(image, 0, 0);
                    // Canvas to arraybuffer
                    canvas.toBlob((blob) => {
                        const reader = new FileReader();
                        reader.addEventListener('loadend', () => {
                            const arrayBuffer = reader.result;
                            resolve(arrayBuffer);
                        });
                        reader.readAsArrayBuffer(blob);
                    }, type);
                });
            });
        });
    }
}


/***/ }),

/***/ "../../3D/src/Interfaces/IDisposable.ts":
/*!**********************************************!*\
  !*** ../../3D/src/Interfaces/IDisposable.ts ***!
  \**********************************************/
/***/ (() => {



/***/ }),

/***/ "../../3D/src/Interfaces/ISceneEditor.ts":
/*!***********************************************!*\
  !*** ../../3D/src/Interfaces/ISceneEditor.ts ***!
  \***********************************************/
/***/ (() => {



/***/ }),

/***/ "../../3D/src/Interfaces/ISupportInitialize.ts":
/*!*****************************************************!*\
  !*** ../../3D/src/Interfaces/ISupportInitialize.ts ***!
  \*****************************************************/
/***/ (() => {



/***/ }),

/***/ "../../3D/src/Layers/AxesLayer.ts":
/*!****************************************!*\
  !*** ../../3D/src/Layers/AxesLayer.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AxesLayer": () => (/* binding */ AxesLayer)
/* harmony export */ });
class AxesLayer {
    constructor(sceneEditor) {
        this._axisRoot = null;
        this._axes = [];
        this._sceneEditor = sceneEditor;
        if (!sceneEditor.engine)
            throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
        const engine = sceneEditor.engine;
        if (!sceneEditor.scene)
            throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
        this._editorScene = sceneEditor.scene;
        this._scene = new BABYLON.Scene(engine);
        this._scene.autoClear = false;
        this._scene.postProcessesEnabled = false;
        this._sceneEditor.addPreUpdateListener(() => this.onPreUpdate());
        this._sceneEditor.addPostUpdateListener(() => this.onPostUpdate());
        this.createAxes();
    }
    dispose() {
        if (this._scene) {
            this._scene.dispose();
        }
    }
    onPreUpdate() {
        if (!this._scene)
            return;
        // Update camera
        const camera = this._editorScene.activeCamera;
        if (camera) {
            this._scene.activeCamera = camera;
            if (this._axisRoot) {
                const distance = BABYLON.Vector3.Distance(camera.position, this._axisRoot.position) * 0.03;
                this._axisRoot.scaling = new BABYLON.Vector3(distance, distance, distance);
                this._axisRoot.computeWorldMatrix(true);
            }
        }
    }
    onPostUpdate() {
        // nothing to do
    }
    createAxes() {
        const size = 10;
        const scene = this._scene;
        const parent = new BABYLON.Mesh("axisRoot", scene);
        parent.isVisible = this._sceneEditor.canShowAxes();
        const makeTextPlane = (text, color, size) => {
            let dynamicTexture = new BABYLON.DynamicTexture("DynamicTexture", 50, scene, true);
            dynamicTexture.hasAlpha = true;
            dynamicTexture.drawText(text, 5, 40, "bold 36px Arial", color, "transparent", true);
            const plane = BABYLON.MeshBuilder.CreatePlane("TextPlane", { size: size, updatable: true }, scene);
            const material = new BABYLON.StandardMaterial("TextPlaneMaterial", scene);
            material.metadata = { isRealMaterial: false };
            material.backFaceCulling = false;
            material.specularColor = new BABYLON.Color3(0, 0, 0);
            material.diffuseTexture = dynamicTexture;
            plane.material = material;
            plane.metadata = { isRealMesh: false, isAxis: true };
            plane.parent = parent;
            plane.isVisible = this._sceneEditor.canShowAxes();
            return plane;
        };
        const axisX = BABYLON.Mesh.CreateLines("axisX", [
            BABYLON.Vector3.Zero(),
            new BABYLON.Vector3(size, 0, 0),
            new BABYLON.Vector3(size * 0.95, 0.05 * size, 0),
            new BABYLON.Vector3(size, 0, 0),
            new BABYLON.Vector3(size * 0.95, -0.05 * size, 0)
        ], scene, true);
        axisX.metadata = { isRealMesh: false, isAxis: true };
        axisX.color = new BABYLON.Color3(1, 0, 0);
        axisX.parent = parent;
        axisX.isVisible = this._sceneEditor.canShowAxes();
        const xChar = makeTextPlane("X", "red", size / 10);
        xChar.position = new BABYLON.Vector3(0.9 * size, -0.05 * size, 0);
        const axisY = BABYLON.Mesh.CreateLines("axisY", [
            BABYLON.Vector3.Zero(),
            new BABYLON.Vector3(0, size, 0),
            new BABYLON.Vector3(-0.05 * size, size * 0.95, 0),
            new BABYLON.Vector3(0, size, 0),
            new BABYLON.Vector3(0.05 * size, size * 0.95, 0)
        ], scene, true);
        axisY.metadata = { isRealMesh: false, isAxis: true };
        axisY.color = new BABYLON.Color3(0, 1, 0);
        axisY.parent = parent;
        axisY.isVisible = this._sceneEditor.canShowAxes();
        const yChar = makeTextPlane("Y", "green", size / 10);
        yChar.position = new BABYLON.Vector3(0, 0.9 * size, -0.05 * size);
        const axisZ = BABYLON.Mesh.CreateLines("axisZ", [
            BABYLON.Vector3.Zero(),
            new BABYLON.Vector3(0, 0, size),
            new BABYLON.Vector3(0, -0.05 * size, size * 0.95),
            new BABYLON.Vector3(0, 0, size),
            new BABYLON.Vector3(0, 0.05 * size, size * 0.95)
        ], scene, true);
        axisZ.metadata = { isRealMesh: false, isAxis: true };
        axisZ.color = new BABYLON.Color3(0, 0, 1);
        axisZ.parent = parent;
        axisZ.isVisible = this._sceneEditor.canShowAxes();
        const zChar = makeTextPlane("Z", "blue", size / 10);
        zChar.position = new BABYLON.Vector3(0, 0.05 * size, 0.9 * size);
        this._axisRoot = parent;
        this._axes.push(parent, axisX, axisY, axisZ, xChar, yChar, zChar);
    }
    refresh() {
        for (let i = 0; i < this._axes.length; i++) {
            const mesh = this._axes[i];
            mesh.isVisible = this._sceneEditor.canShowAxes();
        }
    }
    render() {
        if (this._scene && this._scene.activeCamera)
            this._scene.render();
    }
    getScene() {
        return this._scene;
    }
}


/***/ }),

/***/ "../../3D/src/Layers/LightsLayer.ts":
/*!******************************************!*\
  !*** ../../3D/src/Layers/LightsLayer.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LightsLayer": () => (/* binding */ LightsLayer)
/* harmony export */ });
class LightsLayer {
    constructor(sceneEditor) {
        this._lightMeshes = [];
        this._lightSelectedListeners = [];
        this._sceneEditor = sceneEditor;
        if (!sceneEditor.engine)
            throw Error("LightsLayer requires a valid Babylon JS 3D Engine");
        const engine = sceneEditor.engine;
        if (!sceneEditor.scene)
            throw Error("LightsLayer requires a valid Babylon JS 3D Scene");
        this._editorScene = sceneEditor.scene;
        this._scene = new BABYLON.Scene(engine);
        this._scene.autoClear = false;
        this._scene.postProcessesEnabled = false;
        this._scene.onPointerDown = this.onPointerDown;
        this._sceneEditorPreUpdate = () => this.onPreUpdate();
        this._sceneEditorPostUpdate = () => this.onPostUpdate();
        this._sceneEditor.addPreUpdateListener(this._sceneEditorPreUpdate);
        this._sceneEditor.addPostUpdateListener(this._sceneEditorPostUpdate);
    }
    dispose() {
        if (this._sceneEditor) {
            this._sceneEditor.removePreUpdateListener(this._sceneEditorPreUpdate);
            this._sceneEditor.removePostUpdateListener(this._sceneEditorPostUpdate);
        }
        if (this._scene) {
            this._scene.dispose();
        }
    }
    onPreUpdate() {
        this._scene.activeCamera = this._editorScene.activeCamera;
    }
    onPostUpdate() {
        const engine = this._scene.getEngine();
        for (let i = 0; i < this._lightMeshes.length; i++) {
            const lightMesh = this._lightMeshes[i];
            const light = this._editorScene.getLightByID(lightMesh.id);
            if (light) {
                this.configureLightMesh(lightMesh, light);
            }
        }
    }
    onPointerDown(evt, pickInfo, type) {
        if (pickInfo.hit && pickInfo.pickedMesh) {
            const event = { name: pickInfo.pickedMesh.name, id: pickInfo.pickedMesh.id };
            //Logger.info("Light Picked: " + pickInfo.pickedMesh.id);
            this.fireLightSelectedEvent(event);
        }
    }
    refresh() {
        this.updateLightMeshes();
    }
    updateLightMeshes() {
        if (this._scene && this._sceneEditor) {
            for (let i = 0; i < this._editorScene.lights.length; i++) {
                const light = this._editorScene.lights[i];
                const lightMesh = this._scene.getMeshByID(light.id);
                if (lightMesh)
                    this.configureLightMesh(lightMesh, light);
                else {
                    this._lightMeshes.push(this.createLightMesh(light));
                }
            }
            for (let i = 0; i < this._lightMeshes.length; i++) {
                const lightMesh = this._lightMeshes[i];
                const light = this._editorScene.getLightByID(lightMesh.id);
                if (!light) {
                    lightMesh.dispose();
                    this._lightMeshes.splice(i--, 1);
                }
            }
        }
    }
    createLightMesh(light) {
        //const lightTexture = new BABYLON.Texture("/Content/css/composer/images/bulb_01.png", this._scene);
        const lightTexture = new BABYLON.Texture(LightsLayer._lightTexture, this._scene);
        lightTexture.hasAlpha = true;
        const material = new BABYLON.StandardMaterial("LightMeshMaterial_" + light.id, this._scene);
        material.emissiveColor = BABYLON.Color3.White();
        material.useAlphaFromDiffuseTexture = true;
        material.disableDepthWrite = false;
        material.diffuseTexture = lightTexture;
        const mesh = BABYLON.Mesh.CreatePlane(light.name, 1, this._scene);
        mesh.id = light.id;
        mesh.billboardMode = BABYLON.Mesh.BILLBOARDMODE_ALL;
        mesh.material = material;
        this.configureLightMesh(mesh, light);
        return mesh;
    }
    clearLightMeshes() {
        if (this._scene) {
            while (this._lightMeshes.length > 0) {
                const lightMesh = this._lightMeshes.pop();
                if (lightMesh)
                    lightMesh.dispose();
            }
        }
    }
    configureLightMesh(lightMesh, light) {
        const camera = this._editorScene.activeCamera;
        if (camera && lightMesh && light) {
            lightMesh.position = light.getAbsolutePosition();
            const distance = BABYLON.Vector3.Distance(camera.position, lightMesh.position) * 0.03;
            lightMesh.scaling = new BABYLON.Vector3(distance, distance, distance);
            lightMesh.computeWorldMatrix(true);
            lightMesh.isVisible = this._sceneEditor.canShowLights();
        }
    }
    render() {
        if (this._scene)
            this._scene.render();
    }
    getScene() {
        return this._scene;
    }
    fireLightSelectedEvent(evt) {
        for (let i = 0; i < this._lightSelectedListeners.length; ++i) {
            this._lightSelectedListeners[i](evt);
        }
    }
    addLightSelectedListener(listener) {
        this._lightSelectedListeners.push(listener);
    }
}
LightsLayer._lightTexture = "data:image/png;base64,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";


/***/ }),

/***/ "../../3D/src/Misc/Database.ts":
/*!*************************************!*\
  !*** ../../3D/src/Misc/Database.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Database": () => (/* binding */ Database)
/* harmony export */ });
class Database {
    /**
     * Creates a new Database
    */
    constructor() {
        // Handling various flavors of prefixed version of IndexedDB
        this._idbFactory = (typeof window !== "undefined" ? window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB : indexedDB);
        this._db = null;
        this._hasReachedQuota = false;
        this._isSupported = true;
    }
    openAsync() {
        return new Promise((resolve, reject) => this.open(resolve, reject));
    }
    /**
     * Open the database and make it available
     * @param successCallback defines the callback to call on success
     * @param errorCallback defines the callback to call on error
     */
    open(successCallback, errorCallback) {
        const handleError = () => {
            this._isSupported = false;
            if (errorCallback) {
                errorCallback();
            }
        };
        if (!this._idbFactory) {
            // Your browser doesn't support IndexedDB
            this._isSupported = false;
            if (errorCallback) {
                errorCallback();
            }
        }
        else {
            // If the DB hasn't been opened or created yet
            if (!this._db) {
                this._hasReachedQuota = false;
                this._isSupported = true;
                const request = this._idbFactory.open("zakeke", 1);
                // Could occur if user is blocking the quota for the DB and/or doesn't grant access to IndexedDB
                request.onerror = () => {
                    handleError();
                };
                // executes when a version change transaction cannot complete due to other active transactions
                request.onblocked = () => {
                    Logger.info("IDB request blocked. Please reload the page.");
                    handleError();
                };
                // DB has been opened successfully
                request.onsuccess = () => {
                    this._db = request.result;
                    successCallback();
                };
                // Initialization of the DB. Creating Scenes & Textures stores
                request.onupgradeneeded = (event) => {
                    this._db = event.target.result;
                    if (this._db) {
                        try {
                            this._db.createObjectStore("files", { keyPath: "fileId" });
                        }
                        catch (ex) {
                            Logger.info("Error while creating object stores. Exception: " + ex.message);
                            handleError();
                        }
                    }
                };
            }
            // DB has already been created and opened
            else {
                if (successCallback) {
                    successCallback();
                }
            }
        }
    }
    loadFileAsync(fileId) {
        return new Promise((resolve, reject) => {
            if (this._isSupported && this._db) {
                const targetStore = "files";
                let file;
                const transaction = this._db.transaction([targetStore]);
                transaction.oncomplete = () => {
                    if (file) {
                        resolve(file.data);
                    }
                    // file was not found in DB
                    else {
                        resolve(null);
                    }
                };
                transaction.onabort = () => {
                    resolve(null);
                };
                const getRequest = transaction.objectStore(targetStore).get(fileId);
                getRequest.onsuccess = (event) => {
                    file = event.target.result;
                };
                getRequest.onerror = () => {
                    Logger.info("Error loading file " + fileId + " from DB.");
                    resolve(null);
                };
            }
            else {
                Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open.");
                reject("IndexedDB not supported or Db is not open");
            }
        });
    }
    saveFileAsync(fileId, data) {
        return new Promise((resolve, reject) => {
            if (this._isSupported) {
                const targetStore = "files";
                if (!this._hasReachedQuota && this._db) {
                    // Open a transaction to the database
                    const transaction = this._db.transaction([targetStore], "readwrite");
                    // the transaction could abort because of a QuotaExceededError error
                    transaction.onabort = (event) => {
                        //backwards compatibility with ts 1.0, srcElement doesn't have an "error" according to ts 1.3
                        const error = event.srcElement["error"];
                        if (error && error.name === "QuotaExceededError") {
                            this._hasReachedQuota = true;
                            reject("Quota Exceeded");
                        }
                    };
                    transaction.oncomplete = () => {
                        Logger.info("File saved successfully");
                        resolve();
                    };
                    const newFile = { fileId, data };
                    // Put the file into the database
                    const addRequest = transaction.objectStore(targetStore).put(newFile);
                    addRequest.onsuccess = () => { };
                    addRequest.onerror = () => {
                        Logger.info("Error in DB add file request in Zakeke3D.Database.");
                        reject("Error in DB add file request");
                    };
                }
                else {
                    const error = this._hasReachedQuota ? "Quota has been reached" : "Database closed";
                    reject(error);
                }
            }
            else {
                Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open.");
                reject("IndexedDB not supported or Db is not open");
            }
        });
    }
    deleteFileAsync(fileId) {
        return new Promise((resolve, reject) => {
            if (this._isSupported && this._db) {
                const targetStore = "files";
                const transaction = this._db.transaction([targetStore]);
                transaction.oncomplete = () => {
                    resolve();
                };
                transaction.onabort = () => {
                    reject("aborted cancellation");
                };
                const getRequest = transaction.objectStore(targetStore).get(fileId);
                getRequest.onerror = () => {
                    Logger.info("Error deleting file " + fileId + " from DB.");
                    reject("Error deleting file from DB");
                };
            }
            else {
                Logger.info("Error: IndexedDB not supported by your browser or Zakeke database is not open.");
                reject("IndexedDB not supported or Db is not open");
            }
        });
    }
}


/***/ }),

/***/ "../../3D/src/Misc/DefaultAssetUrls.ts":
/*!*********************************************!*\
  !*** ../../3D/src/Misc/DefaultAssetUrls.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DefaultAssetUrls": () => (/* binding */ DefaultAssetUrls)
/* harmony export */ });
class DefaultAssetUrls {
}
DefaultAssetUrls.Environment = {
    //EnvironmentTextureName: "environmentSpecular.dds",
    EnvironmentTextureName: "environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env",
    GroundTextureCDNUrl: "https://zakekecdn.azureedge.net/cdn/3d/assets/environments/backgroundGround9.png",
    SkyboxTextureCDNUrl: "https://zakekecdn.azureedge.net/cdn/3d/assets/environments/backgroundSkybox.dds",
    //EnvironmentTextureCDNUrl: "https://zakekecdn.azureedge.net/cdn/3d/assets/environments/environmentSpecular.dds"
    EnvironmentTextureCDNUrl: "https://zakekecdn.blob.core.windows.net/cdn/3d/assets/environments/environmentSpecular_0af79b7524dc4cd4825eae49c5d9e22fae220fd.env",
};
DefaultAssetUrls.Tryon = {
    RootUrl: "https://zakekecdn.blob.core.windows.net/cdn/3d/assets/tryon/references/",
    ReferenceGlassesFrameName: "Reference Glasses Frame",
    ReferenceGlassesFrameFileName: "Reference_Glasses_Frame_001.json"
};
DefaultAssetUrls.Shapes = {
    RootUrl: "https://zakekecdn.blob.core.windows.net/cdn/3d/assets/shapes/",
    RoundedCubeName: "Rounded Cube",
    RoundedCubeFileName: "rounded_cube.babylon",
    RoundedCylinderName: "Rounded Cylinder",
    RoundedCylinderFileName: "rounded_cylinder.babylon",
    MatBallName: "Mat Ball",
    MatBallFileName: "mat_ball.babylon",
    MaleHeadName: "Group48944",
    MaleHeadFileName: "DemoHead.babylon",
    FemaleHeadName: "Group12208",
    FemaleHeadFileName: "FemaleHead.babylon",
    PokemonBallName: "PokemonBall",
    PokemonBallFileName: "PokemonBall.babylon",
    ShaderBallName: "Elements",
    ShaderBallFileName: "ShaderBall.babylon",
    BootsFolder: "boots/",
    BootsName: "shoe",
    BootsFileName: "boots.incremental.babylon",
    SuzanneName: "Suzanne",
    SuzanneFileName: "suzanne.babylon",
    StepPyramidName: "Pyramid",
    StepPyramidFileName: "step-pyramid.babylon",
    TeapotName: "Teapot",
    TeapotFileName: "teapot.babylon",
    AlloyWheelName: "Wheel",
    AlloyWheelFolder: "alloy_wheel/",
    AlloyWheelFileName: "alloy_wheel.incremental.babylon"
};


/***/ }),

/***/ "../../3D/src/Misc/Observable.ts":
/*!***************************************!*\
  !*** ../../3D/src/Misc/Observable.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EventState": () => (/* binding */ EventState),
/* harmony export */   "MultiObserver": () => (/* binding */ MultiObserver),
/* harmony export */   "Observable": () => (/* binding */ Observable),
/* harmony export */   "Observer": () => (/* binding */ Observer)
/* harmony export */ });
/**
 * A class serves as a medium between the observable and its observers
 */
class EventState {
    /**
     * Create a new EventState
     * @param mask defines the mask associated with this state
     * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
     * @param target defines the original target of the state
     * @param currentTarget defines the current target of the state
     */
    constructor(mask, skipNextObservers = false, target, currentTarget) {
        /**
         * An Observer can set this property to true to prevent subsequent observers of being notified
         */
        this.skipNextObservers = false;
        /**
         * Get the mask value that were used to trigger the event corresponding to this EventState object
         */
        this.mask = 0;
        this.initalize(mask, skipNextObservers, target, currentTarget);
    }
    /**
     * Initialize the current event state
     * @param mask defines the mask associated with this state
     * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
     * @param target defines the original target of the state
     * @param currentTarget defines the current target of the state
     * @returns the current event state
     */
    initalize(mask, skipNextObservers = false, target, currentTarget) {
        this.mask = mask;
        this.skipNextObservers = skipNextObservers;
        this.target = target;
        this.currentTarget = currentTarget;
        return this;
    }
}
/**
 * Represent an Observer registered to a given Observable object.
 */
class Observer {
    /**
     * Creates a new observer
     * @param callback defines the callback to call when the observer is notified
     * @param mask defines the mask of the observer (used to filter notifications)
     * @param scope defines the current scope used to restore the JS context
     */
    constructor(
    /**
     * Defines the callback to call when the observer is notified
     */
    callback, 
    /**
     * Defines the mask of the observer (used to filter notifications)
     */
    mask, 
    /**
     * Defines the current scope used to restore the JS context
     */
    scope = null) {
        this.callback = callback;
        this.mask = mask;
        this.scope = scope;
        /** @hidden */
        this._willBeUnregistered = false;
        /**
         * Gets or sets a property defining that the observer as to be unregistered after the next notification
         */
        this.unregisterOnNextCall = false;
    }
}
/**
 * Represent a list of observers registered to multiple Observables object.
 */
class MultiObserver {
    constructor() {
        this._observers = null;
        this._observables = null;
    }
    /**
     * Release associated resources
     */
    dispose() {
        if (this._observers && this._observables) {
            for (var index = 0; index < this._observers.length; index++) {
                this._observables[index].remove(this._observers[index]);
            }
        }
        this._observers = null;
        this._observables = null;
    }
    /**
     * Raise a callback when one of the observable will notify
     * @param observables defines a list of observables to watch
     * @param callback defines the callback to call on notification
     * @param mask defines the mask used to filter notifications
     * @param scope defines the current scope used to restore the JS context
     * @returns the new MultiObserver
     */
    static Watch(observables, callback, mask = 0, scope = null) {
        let result = new MultiObserver();
        result._observers = new Array();
        result._observables = observables;
        for (var observable of observables) {
            let observer = observable.add(callback, mask, false, scope);
            if (observer) {
                result._observers.push(observer);
            }
        }
        return result;
    }
}
/**
 * The Observable class is a simple implementation of the Observable pattern.
 *
 * There's one slight particularity though: a given Observable can notify its observer using a particular mask value, only the Observers registered with this mask value will be notified.
 * This enable a more fine grained execution without having to rely on multiple different Observable objects.
 * For instance you may have a given Observable that have four different types of notifications: Move (mask = 0x01), Stop (mask = 0x02), Turn Right (mask = 0X04), Turn Left (mask = 0X08).
 * A given observer can register itself with only Move and Stop (mask = 0x03), then it will only be notified when one of these two occurs and will never be for Turn Left/Right.
 */
class Observable {
    /**
     * Creates a new observable
     * @param onObserverAdded defines a callback to call when a new observer is added
     */
    constructor(onObserverAdded) {
        this._observers = new Array();
        this._onObserverAdded = null;
        this._eventState = new EventState(0);
        if (onObserverAdded) {
            this._onObserverAdded = onObserverAdded;
        }
    }
    /**
     * Gets the list of observers
     */
    get observers() {
        return this._observers;
    }
    /**
     * Create a new Observer with the specified callback
     * @param callback the callback that will be executed for that Observer
     * @param mask the mask used to filter observers
     * @param insertFirst if true the callback will be inserted at the first position, hence executed before the others ones. If false (default behavior) the callback will be inserted at the last position, executed after all the others already present.
     * @param scope optional scope for the callback to be called from
     * @param unregisterOnFirstCall defines if the observer as to be unregistered after the next notification
     * @returns the new observer created for the callback
     */
    add(callback, mask = 0, insertFirst = false, scope = null, unregisterOnFirstCall = false) {
        if (!callback) {
            return null;
        }
        var observer = new Observer(callback, mask, scope);
        observer.unregisterOnNextCall = unregisterOnFirstCall;
        if (insertFirst) {
            this._observers.unshift(observer);
        }
        else {
            this._observers.push(observer);
        }
        if (this._onObserverAdded) {
            this._onObserverAdded(observer);
        }
        return observer;
    }
    /**
     * Create a new Observer with the specified callback and unregisters after the next notification
     * @param callback the callback that will be executed for that Observer
     * @returns the new observer created for the callback
     */
    addOnce(callback) {
        return this.add(callback, undefined, undefined, undefined, true);
    }
    /**
     * Remove an Observer from the Observable object
     * @param observer the instance of the Observer to remove
     * @returns false if it doesn't belong to this Observable
     */
    remove(observer) {
        if (!observer) {
            return false;
        }
        var index = this._observers.indexOf(observer);
        if (index !== -1) {
            this._deferUnregister(observer);
            return true;
        }
        return false;
    }
    /**
     * Remove a callback from the Observable object
     * @param callback the callback to remove
     * @param scope optional scope. If used only the callbacks with this scope will be removed
     * @returns false if it doesn't belong to this Observable
    */
    removeCallback(callback, scope) {
        for (var index = 0; index < this._observers.length; index++) {
            const observer = this._observers[index];
            if (observer._willBeUnregistered) {
                continue;
            }
            if (observer.callback === callback && (!scope || scope === observer.scope)) {
                this._deferUnregister(observer);
                return true;
            }
        }
        return false;
    }
    _deferUnregister(observer) {
        observer.unregisterOnNextCall = false;
        observer._willBeUnregistered = true;
        setTimeout(() => {
            this._remove(observer);
        }, 0);
    }
    // This should only be called when not iterating over _observers to avoid callback skipping.
    // Removes an observer from the _observer Array.
    _remove(observer) {
        if (!observer) {
            return false;
        }
        var index = this._observers.indexOf(observer);
        if (index !== -1) {
            this._observers.splice(index, 1);
            return true;
        }
        return false;
    }
    /**
     * Moves the observable to the top of the observer list making it get called first when notified
     * @param observer the observer to move
     */
    makeObserverTopPriority(observer) {
        this._remove(observer);
        this._observers.unshift(observer);
    }
    /**
     * Moves the observable to the bottom of the observer list making it get called last when notified
     * @param observer the observer to move
     */
    makeObserverBottomPriority(observer) {
        this._remove(observer);
        this._observers.push(observer);
    }
    /**
     * Notify all Observers by calling their respective callback with the given data
     * Will return true if all observers were executed, false if an observer set skipNextObservers to true, then prevent the subsequent ones to execute
     * @param eventData defines the data to send to all observers
     * @param mask defines the mask of the current notification (observers with incompatible mask (ie mask & observer.mask === 0) will not be notified)
     * @param target defines the original target of the state
     * @param currentTarget defines the current target of the state
     * @returns false if the complete observer chain was not processed (because one observer set the skipNextObservers to true)
     */
    notifyObservers(eventData, mask = 0, target, currentTarget) {
        if (!this._observers.length) {
            return true;
        }
        let state = this._eventState;
        state.mask = mask;
        state.target = target;
        state.currentTarget = currentTarget;
        state.skipNextObservers = false;
        state.lastReturnValue = eventData;
        for (var obs of this._observers) {
            if (obs._willBeUnregistered) {
                continue;
            }
            if (obs.mask & mask) {
                if (obs.scope) {
                    state.lastReturnValue = obs.callback.apply(obs.scope, [eventData, state]);
                }
                else {
                    state.lastReturnValue = obs.callback(eventData, state);
                }
                if (obs.unregisterOnNextCall) {
                    this._deferUnregister(obs);
                }
            }
            if (state.skipNextObservers) {
                return false;
            }
        }
        return true;
    }
    /**
     * Calling this will execute each callback, expecting it to be a promise or return a value.
     * If at any point in the chain one function fails, the promise will fail and the execution will not continue.
     * This is useful when a chain of events (sometimes async events) is needed to initialize a certain object
     * and it is crucial that all callbacks will be executed.
     * The order of the callbacks is kept, callbacks are not executed parallel.
     *
     * @param eventData The data to be sent to each callback
     * @param mask is used to filter observers defaults to 0
     * @param target defines the callback target (see EventState)
     * @param currentTarget defines he current object in the bubbling phase
     * @returns {Promise<T>} will return a Promise than resolves when all callbacks executed successfully.
     */
    notifyObserversWithPromise(eventData, mask = 0, target, currentTarget) {
        // create an empty promise
        let p = Promise.resolve(eventData);
        // no observers? return this promise.
        if (!this._observers.length) {
            return p;
        }
        let state = this._eventState;
        state.mask = mask;
        state.target = target;
        state.currentTarget = currentTarget;
        state.skipNextObservers = false;
        // execute one callback after another (not using Promise.all, the order is important)
        this._observers.forEach((obs) => {
            if (state.skipNextObservers) {
                return;
            }
            if (obs._willBeUnregistered) {
                return;
            }
            if (obs.mask & mask) {
                if (obs.scope) {
                    p = p.then((lastReturnedValue) => {
                        state.lastReturnValue = lastReturnedValue;
                        return obs.callback.apply(obs.scope, [eventData, state]);
                    });
                }
                else {
                    p = p.then((lastReturnedValue) => {
                        state.lastReturnValue = lastReturnedValue;
                        return obs.callback(eventData, state);
                    });
                }
                if (obs.unregisterOnNextCall) {
                    this._deferUnregister(obs);
                }
            }
        });
        // return the eventData
        return p.then(() => { return eventData; });
    }
    /**
     * Notify a specific observer
     * @param observer defines the observer to notify
     * @param eventData defines the data to be sent to each callback
     * @param mask is used to filter observers defaults to 0
     */
    notifyObserver(observer, eventData, mask = 0) {
        let state = this._eventState;
        state.mask = mask;
        state.skipNextObservers = false;
        observer.callback(eventData, state);
    }
    /**
     * Gets a boolean indicating if the observable has at least one observer
     * @returns true is the Observable has at least one Observer registered
     */
    hasObservers() {
        return this._observers.length > 0;
    }
    /**
    * Clear the list of observers
    */
    clear() {
        this._observers = new Array();
        this._onObserverAdded = null;
    }
    /**
     * Clone the current observable
     * @returns a new observable
     */
    clone() {
        var result = new Observable();
        result._observers = this._observers.slice(0);
        return result;
    }
    /**
     * Does this observable handles observer registered with a given mask
     * @param mask defines the mask to be tested
     * @return whether or not one observer registered with the given mask is handeled
    **/
    hasSpecificMask(mask = 0) {
        for (var obs of this._observers) {
            if (obs.mask & mask || obs.mask === mask) {
                return true;
            }
        }
        return false;
    }
}


/***/ }),

/***/ "../../3D/src/Misc/StringTools.ts":
/*!****************************************!*\
  !*** ../../3D/src/Misc/StringTools.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StringTools": () => (/* binding */ StringTools)
/* harmony export */ });
/**
 * Helper to manipulate strings
 */
class StringTools {
    /**
     * Checks for a matching suffix at the end of a string (for ES5 and lower)
     * @param str Source string
     * @param suffix Suffix to search for in the source string
     * @returns Boolean indicating whether the suffix was found (true) or not (false)
     */
    static EndsWith(str, suffix) {
        return str.indexOf(suffix, str.length - suffix.length) !== -1;
    }
    /**
     * Checks for a matching suffix at the beginning of a string (for ES5 and lower)
     * @param str Source string
     * @param suffix Suffix to search for in the source string
     * @returns Boolean indicating whether the suffix was found (true) or not (false)
     */
    static StartsWith(str, suffix) {
        return str.indexOf(suffix) === 0;
    }
    /**
     * Decodes a buffer into a string
     * @param buffer The buffer to decode
     * @returns The decoded string
     */
    static Decode(buffer) {
        if (typeof TextDecoder !== "undefined") {
            return new TextDecoder().decode(buffer);
        }
        let result = "";
        for (let i = 0; i < buffer.byteLength; i++) {
            result += String.fromCharCode(buffer[i]);
        }
        return result;
    }
    /**
     * Encode a buffer to a base64 string
     * @param buffer defines the buffer to encode
     * @returns the encoded string
     */
    static EncodeArrayBufferToBase64(buffer) {
        var keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
        var bytes = ArrayBuffer.isView(buffer) ? new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength) : new Uint8Array(buffer);
        while (i < bytes.length) {
            chr1 = bytes[i++];
            chr2 = i < bytes.length ? bytes[i++] : Number.NaN;
            chr3 = i < bytes.length ? bytes[i++] : Number.NaN;
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            }
            else if (isNaN(chr3)) {
                enc4 = 64;
            }
            output += keyStr.charAt(enc1) + keyStr.charAt(enc2) +
                keyStr.charAt(enc3) + keyStr.charAt(enc4);
        }
        return output;
    }
}


/***/ }),

/***/ "../../3D/src/Misc/WorkerPool.ts":
/*!***************************************!*\
  !*** ../../3D/src/Misc/WorkerPool.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WorkerPool": () => (/* binding */ WorkerPool)
/* harmony export */ });
/**
 * Helper class to push actions to a pool of workers.
 */
class WorkerPool {
    /**
     * Constructor
     * @param workers Array of workers to use for actions
     */
    constructor(workers) {
        this._pendingActions = new Array();
        this._workerInfos = workers.map((worker) => ({
            worker: worker,
            active: false
        }));
    }
    /**
     * Terminates all workers and clears any pending actions.
     */
    dispose() {
        for (const workerInfo of this._workerInfos) {
            workerInfo.worker.terminate();
        }
        delete this._workerInfos;
        delete this._pendingActions;
    }
    /**
     * Pushes an action to the worker pool. If all the workers are active, the action will be
     * pended until a worker has completed its action.
     * @param action The action to perform. Call onComplete when the action is complete.
     */
    push(action) {
        for (const workerInfo of this._workerInfos) {
            if (!workerInfo.active) {
                this._execute(workerInfo, action);
                return;
            }
        }
        this._pendingActions.push(action);
    }
    _execute(workerInfo, action) {
        workerInfo.active = true;
        action(workerInfo.worker, () => {
            workerInfo.active = false;
            const nextAction = this._pendingActions.shift();
            if (nextAction) {
                this._execute(workerInfo, nextAction);
            }
        });
    }
}


/***/ }),

/***/ "../../3D/src/Viewers/MaterialEditor.ts":
/*!**********************************************!*\
  !*** ../../3D/src/Viewers/MaterialEditor.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EditorMeshType": () => (/* binding */ EditorMeshType),
/* harmony export */   "MaterialEditor": () => (/* binding */ MaterialEditor)
/* harmony export */ });
/* harmony import */ var _SceneEditor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./SceneEditor */ "../../3D/src/Viewers/SceneEditor.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var EditorMeshType;
(function (EditorMeshType) {
    EditorMeshType[EditorMeshType["Box"] = 0] = "Box";
    EditorMeshType[EditorMeshType["RoundedBox"] = 1] = "RoundedBox";
    EditorMeshType[EditorMeshType["Sphere"] = 2] = "Sphere";
    EditorMeshType[EditorMeshType["Plane"] = 3] = "Plane";
    EditorMeshType[EditorMeshType["Cylinder"] = 4] = "Cylinder";
    EditorMeshType[EditorMeshType["RoundedCylinder"] = 5] = "RoundedCylinder";
    EditorMeshType[EditorMeshType["Torus"] = 6] = "Torus";
    EditorMeshType[EditorMeshType["Knot"] = 7] = "Knot";
    EditorMeshType[EditorMeshType["Ribbon"] = 8] = "Ribbon";
    EditorMeshType[EditorMeshType["Custom"] = 9] = "Custom";
})(EditorMeshType || (EditorMeshType = {}));
class MaterialEditor extends _SceneEditor__WEBPACK_IMPORTED_MODULE_0__.SceneEditor {
    constructor(options) {
        super(options);
        this._zkMaterial = null;
        this._material = null;
        this._meshType = EditorMeshType.Box;
        this._mesh = null;
        this._materialCreatedListeners = [];
        this._filesInput = null;
    }
    get zkMaterial() {
        return this._zkMaterial;
    }
    get material() {
        return this._material;
    }
    static createMaterialEditorAsync(options) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!options) {
                options = {
                    showGround: false,
                    editorBackgroundColor: "#33334c",
                    showHighlight: false,
                };
            }
            const editor = new MaterialEditor(options);
            yield editor.initAsync();
            return editor;
        });
    }
    deleteComponents() {
        super.deleteComponents();
        this.deleteEditorMaterial();
        this.deleteEditorMesh();
    }
    deleteEditorMaterial() {
        if (this._material) {
            this._material.dispose();
            this._material = null;
            this.fireMaterialCreatedEvent();
        }
    }
    deleteEditorMesh() {
        if (this._mesh) {
            this._mesh.dispose();
            this._mesh = null;
        }
        // Elimino tutte le mesh della scena
        if (this._scene && this._sceneHelper) {
            let meshes = this._sceneHelper.getSceneMeshes();
            meshes.forEach(m => m.dispose());
        }
    }
    dispose() {
        super.dispose();
    }
    createEmptySceneAsync() {
        const _super = Object.create(null, {
            createEmptySceneAsync: { get: () => super.createEmptySceneAsync }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.createEmptySceneAsync.call(this);
            this.createEditorMaterial(undefined, "Standard");
            yield this.createEditorMeshAsync();
        });
    }
    createEditorMaterial(name, type, group) {
        let material = null;
        if (type != "ShaderMaterial") {
            material = super.createMaterial(name, type, group);
        }
        else {
            material = this.createShaderMaterial();
            if (material) {
                material.id = Zakeke.generateUUID();
                this.checkSceneEmptyEnvironmentTexture();
            }
        }
        this._material = material;
        this.setRenderingNeeded();
        this.fireMaterialCreatedEvent();
        return material;
    }
    applyEditorMaterial() {
        if (this._material && this._mesh)
            this.applyMaterial(this._material, this._mesh);
    }
    replaceSceneAsync(newScene) {
        return __awaiter(this, void 0, void 0, function* () {
            // Serializzo il materiale per la vecchia scena
            var jsonObj = null;
            var rootUrl = null;
            if (this._material && this._zkMaterial) {
                jsonObj = this._material.serialize();
                rootUrl = this._zkMaterial.get("rootUrl");
            }
            this.deleteScene();
            this._scene = newScene;
            yield this.setupSceneAsync();
            // Deserializzo il material sulla nuova scena
            if (jsonObj && rootUrl) {
                this._material = BABYLON.Material.Parse(jsonObj, this._scene, rootUrl);
                this.fireMaterialCreatedEvent();
            }
            else {
                this.createEditorMaterial(undefined, "Standard");
            }
            this.applyEditorMaterial();
            this.adjustCamera(false);
        });
    }
    createShaderMaterial() {
        let material = null;
        if (this._scene && this._zkMaterial && this._zkMaterial.get("shaders")) {
            const name = this._zkMaterial.get("name") || "ShaderMaterial - " + Zakeke.makeID(5);
            var paths = {
                vertex: this._zkMaterial.get("shaders").get("name"),
                fragment: this._zkMaterial.get("shaders").get("name")
            };
            const options = {
                attributes: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Attribute),
                uniforms: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Uniform),
                samplers: this._zkMaterial.getShaderAttributeOptions(Zakeke.ShaderOptionType.Sampler)
            };
            material = new BABYLON.ShaderMaterial(name, this._scene, paths, options);
            this.setupShaderMaterialCameraPosition(material);
        }
        return material;
    }
    createEditorMaterialFromJson(jsonText, rootUrl) {
        if (this._scene) {
            var jsonObj = JSON.parse(jsonText);
            this._material = BABYLON.Material.Parse(jsonObj, this._scene, rootUrl);
            if (this._material)
                this.setupShaderMaterialCameraPosition(this._material);
            this.checkSceneEmptyEnvironmentTexture();
            this.fireMaterialCreatedEvent();
        }
    }
    createEditorMeshAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this.deleteEditorMesh();
            switch (this._meshType) {
                case EditorMeshType.Box:
                    this._mesh = this.createBox(null, "box");
                    break;
                case EditorMeshType.RoundedBox:
                    {
                        const meshes = yield this.createRoundedCubeAsync(null, "rounded box");
                        if (meshes.length == 1)
                            this._mesh = meshes[0];
                        else {
                            this._mesh = this.createGroup(null, "rounded box group", meshes);
                        }
                    }
                    break;
                case EditorMeshType.Sphere:
                    this._mesh = this.createSphere(null, "sphere");
                    break;
                case EditorMeshType.Plane:
                    this._mesh = this.createPlane(null, "plane");
                    break;
                case EditorMeshType.Cylinder:
                    this._mesh = this.createCylinder(null, "cylinder");
                    break;
                case EditorMeshType.RoundedCylinder:
                    {
                        const meshes = yield this.createRoundedCylinderAsync(null, "rounded cylinder");
                        if (meshes.length == 1)
                            this._mesh = meshes[0];
                        else {
                            this._mesh = this.createGroup(null, "rounded cylinder group");
                            meshes.forEach(m => m.parent = this._mesh);
                        }
                    }
                    break;
                case EditorMeshType.Torus:
                    this._mesh = this.createTorus(null, "torus");
                    break;
                case EditorMeshType.Knot:
                    this._mesh = this.createKnot(null, "knot");
                    break;
                case EditorMeshType.Ribbon:
                    this._mesh = this.createRibbon(null, "ribbon");
                    break;
            }
            this.applyEditorMaterial();
            this.adjustCamera(false);
        });
    }
    setEditorMeshType(meshType) {
        return __awaiter(this, void 0, void 0, function* () {
            this._meshType = meshType;
            yield this.createEditorMeshAsync();
        });
    }
    updateMaterialModelAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._zkMaterial && this._material && this._sceneHelper) {
                const data = yield this._sceneHelper.takeMaterialScreenshotAsync(this._material.id, 500, 450);
                this._zkMaterial.set("imageData", data);
                const name = this._zkMaterial.get("name");
                if (name && name != this._material.name)
                    this._material.name = name;
                var json = this.getEditorMaterialJson();
                if (json)
                    this._zkMaterial.set("JSON", json);
            }
        });
    }
    getEditorMaterialJson() {
        if (this._scene && this._sceneHelper && this._material) {
            const sceneHelper = this._sceneHelper;
            // Sistemo il nome delle texture che deve essere relativo al root path
            // .../materialID/textures/materialID/filename.xxx
            this._scene.textures.forEach((txt) => {
                if (sceneHelper.isTextureWithUrl(txt)) {
                    if (txt.url) {
                        var idx = txt.url.lastIndexOf("/");
                        if (idx !== -1) {
                            idx = txt.url.lastIndexOf("/", idx - 1);
                            if (idx !== -1) {
                                idx = txt.url.lastIndexOf("/", idx - 1);
                                if (idx != -1) {
                                    var newName = txt.url.substring(idx + 1);
                                    txt.name = newName;
                                    txt.url = txt.name;
                                }
                            }
                        }
                    }
                }
            });
            var jsonObj = this._material.serialize();
            var json = JSON.stringify(jsonObj);
            return json;
        }
        return null;
    }
    setMaterialModel(zkMaterial, type) {
        this._zkMaterial = zkMaterial;
        this.deleteEditorMaterial();
        if (this._zkMaterial && this._zkMaterial instanceof Zakeke.Material) {
            const materialShaders = this._zkMaterial.get("shaders");
            if (materialShaders) {
                const name = materialShaders.get("name");
                const vertex = materialShaders.get("vertex");
                const fragment = materialShaders.get("fragment");
                if (name && vertex && fragment) {
                    this.setupShadersStore({ name, vertex, fragment });
                }
            }
            var jsonText = this._zkMaterial.get("JSON");
            var rootUrl = this._zkMaterial.get("rootUrl");
            if (jsonText && rootUrl)
                this.createEditorMaterialFromJson(jsonText, rootUrl);
            else
                this.createEditorMaterial(this._zkMaterial.get("name") || undefined, type);
            if (this._material)
                this._material.id = this._zkMaterial.getMaterialID();
        }
        else
            this.createEditorMaterial(undefined, type);
        this.applyEditorMaterial();
        this.adjustCamera(false);
        this.setupShaderMaterialsCameraPosition();
    }
    getTexturesUploadUrl(materialID) {
        if (this._zkMaterial)
            return this._zkMaterial.getTexturesUrl();
        return "";
    }
    loadEditorMaterialTextureFiles__(filesToLoad, type, onSuccess, onError) {
        this.loadTextureFiles(filesToLoad, this._material, type, onSuccess, onError);
    }
    loadEditorMaterialTextureFiles(filesToLoad, type, onSuccess, onError) {
        if (!this._material)
            return;
        const getExtension = (name) => {
            let idx = name.lastIndexOf(".");
            if (idx !== -1) {
                const ext = name.substring(idx);
                return ext;
            }
        };
        const isCubeImage = (name, suffix) => {
            const idx = name.lastIndexOf(".");
            if (idx !== -1) {
                const nameWithoutExt = name.substring(0, idx);
                return nameWithoutExt.endsWith("_" + suffix);
            }
            return false;
        };
        if (!filesToLoad || filesToLoad.length == 0)
            return;
        var isCubemap = this.canLoadCubemap(this._material, type) && (filesToLoad.length == 6 || getExtension(filesToLoad[0].name) == ".dds" || getExtension(filesToLoad[0].name) == ".hdr");
        var files = [];
        if (isCubemap && filesToLoad.length == 6) {
            // verfico che ci siano tutte le estensioni accettate dalla cubemap
            var suffixes = ["px", "py", "pz", "nx", "ny", "nz"];
            for (let k = 0; k < filesToLoad.length; k++) {
                const file = filesToLoad[k];
                let lastIdx = -1;
                for (var i = 0; i < suffixes.length; i++) {
                    if (isCubeImage(file.name, suffixes[i])) {
                        files.push(file);
                        lastIdx = i;
                        break;
                    }
                }
                if (lastIdx !== -1)
                    suffixes.splice(lastIdx, 1);
            }
            if (suffixes.length != 0) {
                var msg = "Immagini per la cube map non valide";
                if (onError)
                    onError(msg);
                Logger.info(msg);
                return;
            }
        }
        else {
            // Carico solo la prima selezionata
            files.push(filesToLoad[0]);
        }
        // Upload
        var data = new FormData();
        for (let i = 0; i < files.length; i++) {
            data.append('file-' + i, files[i]);
        }
        jQuery.ajax({
            url: this.getTexturesUploadUrl(this._material.id),
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: (data) => {
                if (Object.prototype.toString.call(data) === '[object Array]') {
                    if (isCubemap)
                        this.setEditorMaterialCubeTextureImages(data, type);
                    else
                        this.setEditorMaterialTextureImage(data[0], type);
                }
                if (onSuccess)
                    onSuccess();
            },
            error: (xhr, textStatus, errorThrown) => {
                var msg = "An error occurred: " + textStatus + "nError: " + errorThrown;
                if (onError)
                    onError(msg);
            }
        });
    }
    setEditorMaterialTextureImage(textureImage, type) {
        if (this._scene && this._zkMaterial && this._material && textureImage && textureImage.imageUrl && textureImage.fileObjectID) {
            // salvo i dati dell'immagine con il materiale
            const item = new Zakeke.MaterialTextureImage();
            item.set("textureImageID", Zakeke.generateUUID());
            item.set("fileObjectID", textureImage.fileObjectID);
            item.set("imageUrl", textureImage.imageUrl);
            this._zkMaterial.get("textureImages").push(item);
            const url = textureImage.imageUrl;
            const texture = new BABYLON.Texture(url, this._scene);
            const oldTexture = this.getMaterialTexture(this._material, type);
            if (oldTexture && oldTexture instanceof BABYLON.Texture) {
                texture.uScale = oldTexture.uScale;
                texture.vScale = oldTexture.vScale;
                texture.uOffset = oldTexture.uOffset;
                texture.vOffset = oldTexture.vOffset;
                texture.uAng = oldTexture.uAng;
                texture.vAng = oldTexture.vAng;
                texture.level = oldTexture.level;
                texture.coordinatesIndex = oldTexture.coordinatesIndex;
                texture.coordinatesMode = oldTexture.coordinatesMode;
                texture.hasAlpha = oldTexture.hasAlpha;
                texture.wrapU = oldTexture.wrapU;
                texture.wrapV = oldTexture.wrapV;
            }
            this.applyTexture(texture, this._material, type);
            if (oldTexture && !this.isTextureUsed(oldTexture))
                oldTexture.dispose();
        }
    }
    setEditorMaterialCubeTextureImages(textureImages, type) {
        if (!this._scene || !this._zkMaterial || !this._material || Object.prototype.toString.call(textureImages) != '[object Array]')
            return;
        let texture = null;
        const onImagesLoad = () => this.setRenderingNeeded();
        if (textureImages.length == 1) {
            let textureImage = textureImages[0];
            if (textureImage.imageUrl && textureImage.fileObjectID) {
                if (textureImage.imageUrl.endsWith(".dds"))
                    texture = BABYLON.CubeTexture.CreateFromPrefilteredData(textureImage.imageUrl, this._scene);
                else if (textureImage.imageUrl.endsWith(".hdr"))
                    texture = new BABYLON.HDRCubeTexture(textureImage.imageUrl, this._scene, 512, undefined, undefined, undefined, undefined, onImagesLoad);
                // salvo i dati dell'immagine con il materiale
                var item = new Zakeke.MaterialTextureImage();
                item.set("textureImageID", Zakeke.generateUUID());
                item.set("fileObjectID", textureImage.fileObjectID);
                item.set("imageUrl", textureImage.imageUrl);
                this._zkMaterial.get("textureImages").push(item);
            }
        }
        else if (textureImages.length == 6) {
            const suffixes = ["px", "py", "pz", "nx", "ny", "nz"];
            let rootUrl = "";
            const files = [];
            const extensions = [];
            const containsSuffix = (name, suffix) => {
                var idx = name.lastIndexOf(".");
                if (idx !== -1) {
                    var nameWithoutExt = name.substring(0, idx);
                    return nameWithoutExt.endsWith("_" + suffix);
                }
                return false;
            };
            const getRootUrl = (url, suffix) => {
                const idx = url.lastIndexOf(".");
                if (idx !== -1) {
                    var nameWithoutExt = url.substring(0, idx);
                    if (nameWithoutExt.endsWith("_" + suffix)) {
                        const rootUrl = nameWithoutExt.substring(0, nameWithoutExt.length - ("_" + suffix).length);
                        return rootUrl;
                    }
                }
                return null;
            };
            const getFileExtension = (url, suffix) => {
                const idx = url.lastIndexOf("_" + suffix);
                if (idx !== -1) {
                    return url.substr(idx);
                }
                return null;
            };
            for (let i = 0; i < suffixes.length; i++) {
                var suffix = suffixes[i];
                for (let k = 0; k < textureImages.length; k++) {
                    const textureImage = textureImages[k];
                    const url = textureImage.imageUrl;
                    if (url && containsSuffix(url, suffix)) {
                        files.push(url);
                        extensions.push(getFileExtension(url, suffix));
                        if (!rootUrl)
                            rootUrl = getRootUrl(url, suffix);
                        break;
                    }
                }
            }
            // salvo i dati delle immagini con il materiale
            for (let i = 0; i < textureImages.length; i++) {
                const textureImage = textureImages[i];
                if (textureImage.imageUrl && textureImage.fileObjectID != undefined) {
                    const imageUrl = textureImage.imageUrl;
                    const fileObjectID = textureImage.fileObjectID;
                    const item = new Zakeke.MaterialTextureImage();
                    item.set("textureImageID", Zakeke.generateUUID());
                    item.set("fileObjectID", fileObjectID);
                    item.set("imageUrl", imageUrl);
                    this._zkMaterial.get("textureImages").push(item);
                }
            }
            //CubeTexture(rootUrl, scene, extensions, noMipmap, files
            texture = new BABYLON.CubeTexture(rootUrl, this._scene, extensions, false, files);
        }
        if (texture) {
            var oldTexture = this.getMaterialTexture(this._material, type);
            this.applyTexture(texture, this._material, type);
            if (oldTexture && !this.isTextureUsed(oldTexture))
                oldTexture.dispose();
        }
    }
    // -------------------------------------------------------------
    // Events
    // -------------------------------------------------------------
    fireMaterialCreatedEvent() {
        for (let i = 0; i < this._materialCreatedListeners.length; ++i) {
            this._materialCreatedListeners[i]();
        }
    }
    addMaterialCreatedListener(listenerFunction) {
        this._materialCreatedListeners.push(listenerFunction);
    }
    //#region Load Custom Mesh
    loadFiles(event, onSuccess, onError) {
        if (!this._engine || !this._scene || !this._sceneHelper)
            return;
        const engine = this._engine;
        const scene = this._scene;
        const sceneHelper = this._sceneHelper;
        if (!this._filesInput) {
            this._filesInput = new BABYLON.FilesInput(engine, scene, (sceneFile, babylonScene) => __awaiter(this, void 0, void 0, function* () {
                yield this.replaceSceneAsync(babylonScene);
                const meshes = sceneHelper.getSceneMeshes();
                // Raggruppo tutte le mesh
                this._meshType = EditorMeshType.Custom;
                this._mesh = this.createGroup(null, "group", meshes);
                this.applyEditorMaterial();
                if (onSuccess)
                    onSuccess();
            }), null, //(progress: BABYLON.SceneLoaderProgressEvent) => { }, // progressCallback
            null, //() => { },  // additionalRenderLoopLogicCallback
            null, //(remaining: number) => { }, // textureLoadingCallback
            null, //(files?: File[]) => { },  // startingProcessingFilesCallback
            null, //(sceneFile: File) => { }, // onReloadCallback
            (sceneFile, babylonScene, message) => {
                if (onError)
                    onError(message);
            });
        }
        if (this._filesInput)
            this._filesInput.loadFiles(event);
    }
}


/***/ }),

/***/ "../../3D/src/Viewers/SceneEditor.ts":
/*!*******************************************!*\
  !*** ../../3D/src/Viewers/SceneEditor.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MaterialGroup": () => (/* binding */ MaterialGroup),
/* harmony export */   "SceneEditor": () => (/* binding */ SceneEditor),
/* harmony export */   "SourceTaskStatus": () => (/* binding */ SourceTaskStatus)
/* harmony export */ });
/* harmony import */ var _Components_Environment_EnvironmentManager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Components/Environment/EnvironmentManager */ "../../3D/src/Components/Environment/EnvironmentManager.ts");
/* harmony import */ var _Components_IncrementalFiles_IncrementalFiles__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Components/IncrementalFiles/IncrementalFiles */ "../../3D/src/Components/IncrementalFiles/IncrementalFiles.ts");
/* harmony import */ var _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Components/MaterialsPreview/MaterialsPreview */ "../../3D/src/Components/MaterialsPreview/MaterialsPreview.ts");
/* harmony import */ var _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Components/SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
/* harmony import */ var _Components_SceneToBlobs_SceneToBlobs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Components/SceneToBlobs/SceneToBlobs */ "../../3D/src/Components/SceneToBlobs/SceneToBlobs.ts");
/* harmony import */ var _Enumerations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Enumerations */ "../../3D/src/Enumerations.ts");
/* harmony import */ var _Helpers_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Helpers/utils */ "../../3D/src/Helpers/utils.ts");
/* harmony import */ var _Layers_AxesLayer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Layers/AxesLayer */ "../../3D/src/Layers/AxesLayer.ts");
/* harmony import */ var _Layers_LightsLayer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Layers/LightsLayer */ "../../3D/src/Layers/LightsLayer.ts");
/* harmony import */ var _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Misc/DefaultAssetUrls */ "../../3D/src/Misc/DefaultAssetUrls.ts");
/* harmony import */ var _SceneViewer__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./SceneViewer */ "../../3D/src/Viewers/SceneViewer.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};











class MaterialGroup {
    constructor(groupName) {
        this.materials = [];
        this.guid = Zakeke.generateUUID();
        this.groupName = groupName;
    }
}
var SourceTaskStatus;
(function (SourceTaskStatus) {
    SourceTaskStatus[SourceTaskStatus["uploading"] = 0] = "uploading";
    SourceTaskStatus[SourceTaskStatus["progress"] = 1] = "progress";
    SourceTaskStatus[SourceTaskStatus["checking"] = 2] = "checking";
    SourceTaskStatus[SourceTaskStatus["success"] = 3] = "success";
    SourceTaskStatus[SourceTaskStatus["completed_success"] = 4] = "completed_success";
    SourceTaskStatus[SourceTaskStatus["completed_error"] = 5] = "completed_error";
})(SourceTaskStatus || (SourceTaskStatus = {}));
class SceneEditor extends _SceneViewer__WEBPACK_IMPORTED_MODULE_10__.SceneViewer {
    constructor(options) {
        super({ configPreview: true });
        this._dracoEnabled = true;
        // Sets the desired encoding and decoding speed for the given options.
        //
        //  0 = slowest speed, but the best compression.
        // 10 = fastest, but the worst compression.
        // -1 = undefined.
        //
        // Note that both speed options affect the encoder choice of used methods and
        // algorithms. For example, a requirement for fast decoding may prevent the
        // encoder from using the best compression methods even if the encoding speed
        // is set to 0. In general, the faster of the two options limits the choice of
        // features that can be used by the encoder. Additionally, setting
        // |decoding_speed| to be faster than the |encoding_speed| may allow the
        // encoder to choose the optimal method out of the available features for the
        // given |decoding_speed|.
        this._dracoEncodingSpeed = 5;
        this._dracoDecodingSpeed = 5;
        this._envMode = _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor;
        this._selectOnPick = true;
        this._showBoundingBox = false;
        this._editorBackgroundColor = "#444444";
        this._showGround = true;
        this._ground = null;
        this._showLights = false;
        this._lightsLayer = null;
        this._showAxes = false;
        this._axesLayer = null;
        this._showHighlight = true;
        this._highlightOver = true;
        this._highlightOverColor = "#0082ff";
        this._editingMode = _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EditingMode.None;
        this._manipulatedNode = null;
        this._oldManipulatedNode = null;
        this._EditControl = org.ssatguru.babylonjs.component.EditControl;
        this._editControl = null;
        this._editControlVisible = false;
        this._shiftPressed = false;
        this._ctrlPressed = false;
        this._realMeshVisibility = {};
        this._sceneSourceTasks = [];
        this._isLoadingSourceFiles = false;
        // Per gli eventi
        this._preUpdateListeners = [];
        this._postUpdateListeners = [];
        this._meshSelectedListeners = [];
        this._selectionChangedListeners = [];
        this._lightSelectedListeners = [];
        this._sceneCreatedListeners = [];
        this._cameraLocationCreatedListeners = [];
        this._sceneSourceTaskSuccessListeners = []; // Per comunicare che l'importazione dei file ha avuto successo
        this._sceneSourceTaskErrorListeners = []; // Per notificare che l'importazione dei file è andata in errore
        this._sceneSourceTasksCheckListeners = []; // Eseguita ad ogni tick/controllo della task per avere l'elenco aggiornato delle tasks
        this._meshesUpdateListeners = []; // Quando qualcosa nella struttura delle mesh cambia, oppure cambia una singola mesh
        this._materialsUpdateListeners = []; // Quando qualcosa nella struttura del materiali cambia, oppure un singolo materiale
        this._lightsUpdateListeners = []; // Quando qualcosa nella struttura delle luci cambia, oppure una singola luce
        this._cameraLocationsUpdateListeners = [];
        this._meshLocationCreatedListeners = [];
        this._meshLocationsUpdateListeners = [];
        this._arTaskSuccessListeners = []; // Per comunicare che la conversione dei file per AR ha avuto successo
        this._arTaskErrorListeners = []; // Per notificare che la conversione dei file per AR è andata in errore
        this._arTasksCheckListeners = []; // Eseguita ad ogni tick/controllo del task per avere l'elenco aggiornato dei tasks
        // Materiali iniziali
        this._initialMeshMaterials = {}; // hash meshID -> materialID
        this._initialSubMeshMaterials = {}; // hash subMeshID -> materialID
        // Ultimi material applicati
        this._lastMeshMaterials = {}; // hash meshID -> materialID
        this._lastSubMeshMaterials = {}; // hash subMeshID -> materialID
        this._meshOver = null;
        this._incrementalFilesMaker = null;
        this._sceneToBlobs = null;
        if (options) {
            if (options.showGround != undefined && options.showGround != null)
                this._showGround = options.showGround;
            if (options.editorBackgroundColor !== undefined && options.editorBackgroundColor !== null)
                this._editorBackgroundColor = options.editorBackgroundColor;
            if (options.showHighlight !== undefined && options.showHighlight !== null)
                this._showHighlight = options.showHighlight;
            if (options.highlightColor !== undefined && options.highlightColor !== null)
                this._highlightColor = options.highlightColor;
            if (options.highlightOver !== undefined && options.highlightOver != null)
                this._highlightOver = options.highlightOver;
            if (options.highlightOverColor !== undefined && options.highlightOverColor != null)
                this._highlightOverColor = options.highlightOverColor;
        }
    }
    // Real mesh visibility
    get realMeshVisibility() {
        return this._realMeshVisibility;
    }
    // Environemnt manager
    get environmentManager() {
        return this._environmentManager;
    }
    // EnvMode
    get envMode() {
        return this._envMode;
    }
    // Source tasks
    get sceneSourceTasks() {
        return this._sceneSourceTasks;
    }
    set envMode(value) {
        if (this._envMode != value) {
            this._envMode = value;
            this.refreshEnvironment();
        }
    }
    // SelectOnPick
    get selectOnPick() {
        return this._selectOnPick;
    }
    set seletOnPick(value) {
        if (this._selectOnPick != value)
            this._selectOnPick = value;
    }
    // ShowBoundingBox
    get showBoundingBox() {
        return this._showBoundingBox;
    }
    set showBoundingBox(value) {
        if (this._showBoundingBox != value) {
            this._showBoundingBox = value;
            this.updateBoundingBox();
            this.setRenderingNeeded();
        }
    }
    // EditorBackgroundColor
    get editorBackgroundColor() {
        return this._editorBackgroundColor;
    }
    set editorBackgroundColor(value) {
        if (this._editorBackgroundColor != value) {
            this.setEditorBackgroundColor(value);
        }
    }
    // ShowGround
    get showGround() {
        return this._showGround;
    }
    set showGround(value) {
        if (this._showGround != value) {
            this._showGround = value;
            this.refreshGround();
        }
    }
    // ShowLights
    get showLights() {
        return this._showLights;
    }
    set showLights(value) {
        if (this._showLights != value) {
            this._showLights = value;
            if (this._lightsLayer)
                this._lightsLayer.refresh();
            this.setRenderingNeeded();
        }
    }
    // ShowAxes
    get showAxes() {
        return this._showAxes;
    }
    set showAxes(value) {
        if (this._showAxes != value) {
            this._showAxes = value;
            if (this._axesLayer)
                this._axesLayer.refresh();
            this.setRenderingNeeded();
        }
    }
    // ShowHighlight
    get showHighlight() {
        return this._showHighlight;
    }
    set showHighlight(value) {
        if (this._showHighlight != value) {
            this._showHighlight = value;
        }
    }
    // HighlightOver
    get highlightOver() {
        return this._highlightOver;
    }
    set highlightOver(value) {
        if (this._highlightOver != value) {
            this._highlightOver = value;
        }
    }
    // HighlightOverColor
    get highlightOverColor() {
        return this._highlightOverColor;
    }
    set highlightOverColor(value) {
        if (this._highlightOverColor != value) {
            this._highlightOverColor = value;
        }
    }
    // EditingMode
    get editingMode() {
        return this._editingMode;
    }
    set editingMode(value) {
        if (this._editingMode != value) {
            this.setEditingMode(value);
        }
    }
    // EditingControlVisible
    get editControlVisible() {
        return this._editControlVisible;
    }
    set editControlVisible(value) {
        if (this._editControlVisible != value) {
            this.showHideEditControl(value);
        }
    }
    static createSceneEditorAsync(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const editor = new SceneEditor(options);
            yield editor.initAsync();
            editor.checkSceneSourceTasks();
            return editor;
        });
    }
    createCanvas() {
        const canvas = super.createCanvas();
        canvas.addEventListener("keydown", (e) => {
            this._shiftPressed = e.key == "Shift";
            this._ctrlPressed = e.key == "Control";
        }, false);
        canvas.addEventListener("keyup", (e) => {
            this._shiftPressed = !(e.key == "Shift");
            this._ctrlPressed = !(e.key == "Control");
        }, false);
        canvas.addEventListener("dblclick", (e) => {
            this.setRenderingNeeded();
        });
        return canvas;
    }
    deleteComponents() {
        super.deleteComponents();
        if (this._editControl) {
            this._editControl.detach();
            this._editControl = null;
        }
        if (this._lightsLayer) {
            this._lightsLayer.dispose();
            this._lightsLayer = null;
        }
        if (this._axesLayer) {
            this._axesLayer.dispose();
            this._axesLayer = null;
        }
    }
    dispose() {
        super.dispose();
        if (this._incrementalFilesMaker) {
            this._incrementalFilesMaker.dispose();
            delete this._incrementalFilesMaker;
        }
        if (this._sceneToBlobs) {
            this._sceneToBlobs.dispose();
            delete this._sceneToBlobs;
        }
        // ...
    }
    createEngine() {
        super.createEngine();
        // Forzo il caricamento totale per i file incrementali
        BABYLON.SceneLoader.ForceFullSceneLoadingForIncremental = true;
    }
    createEmptySceneAsync() {
        const _super = Object.create(null, {
            createEmptySceneAsync: { get: () => super.createEmptySceneAsync }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.createEmptySceneAsync.call(this);
            if (this._engine) {
                this.fireSceneCreatedEvent();
            }
        });
    }
    setupSceneAsync() {
        const _super = Object.create(null, {
            setupSceneAsync: { get: () => super.setupSceneAsync }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.setupSceneAsync.call(this);
            if (this._engine && this._scene) {
                this._scene.setRenderingAutoClearDepthStencil(1, true, true, false);
                this._scene.setRenderingAutoClearDepthStencil(2, true, true, false);
                this._lightsLayer = new _Layers_LightsLayer__WEBPACK_IMPORTED_MODULE_8__.LightsLayer(this);
                this._lightsLayer.addLightSelectedListener((event) => { this.lightsLayer_onLightSelected(event); });
                this.setupAxes();
                if (this._zkModel && this._meshLocationsManager) {
                    this._meshLocationsManager.addBeforeSaveMeshLocationListener(() => this.onBeforeSaveMeshLocation());
                    this._meshLocationsManager.addAfterSaveMeshLocationListener(() => this.onAfterSaveMeshLocation());
                }
                this._scene.onPointerMove = (evt, pickInfo) => this.onPointerMove(evt, pickInfo);
            }
        });
    }
    render() {
        this.firePreUpdateEvent();
        super.render();
        if (this._lightsLayer)
            this._lightsLayer.render();
        if (this._axesLayer)
            this._axesLayer.render();
        this.firePostUpdateEvent();
    }
    deleteHighlightLayer() {
        if (this._highlightLayer) {
            this._highlightLayer.dispose();
            this._highlightLayer = null;
        }
        this.setRenderingNeeded();
    }
    setupAntialiasPostProcesses() {
        if (this.antialias && this.getAntialiasEnabled()) {
            this.createAntialiasPostProcesses();
            this.disableAntialiasing();
        }
    }
    canEnableAntialiasing() {
        return (this._scene && this._antialias && this.getAntialiasEnabled() && this.envMode === _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Viewer);
    }
    setupHighlightLayerIntensity() {
        if (this._highlightLayer) {
            this._highlightLayer.blurHorizontalSize = this._highlightBlurHorizontalSize;
            this._highlightLayer.blurVerticalSize = this._highlightBlurVerticalSize;
        }
    }
    setupAxes() {
        this._axesLayer = new _Layers_AxesLayer__WEBPACK_IMPORTED_MODULE_7__.AxesLayer(this);
    }
    getMatchSameNameTextures() {
        if (this._zkScene) {
            let val = this._zkScene.getMatchSameNameTextures();
            if (val === undefined || val === null)
                return false;
            return val;
        }
        return false;
    }
    setMatchSameNameTextures(value) {
        if (this._zkScene) {
            this._zkScene.setMatchSameNameTextures(value);
        }
    }
    getAREnabled() {
        let def = false;
        if (this._zkScene) {
            let val = this._zkScene.getAREnabled();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setAREnabled(value) {
        if (this._zkScene) {
            this._zkScene.setAREnabled(value);
        }
    }
    getArOnTheFly() {
        let def = false;
        if (this._zkScene) {
            let val = this._zkScene.getArOnTheFly();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setArOnTheFly(value) {
        if (this._zkScene) {
            this._zkScene.setArOnTheFly(value);
        }
    }
    getTryOnEnabled() {
        let def = false;
        if (this._zkScene) {
            let val = this._zkScene.getTryOnEnabled();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setTryOnEnabled(value) {
        if (this._zkScene) {
            this._zkScene.setTryOnEnabled(value);
        }
    }
    getUseDelayedMaterialLoading() {
        let def = false;
        if (this.zkScene) {
            let val = this.zkScene.getUseDelayedMaterialLoading();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setUseDelayedMaterialLoading(value) {
        if (this._zkScene) {
            this._zkScene.setUseDelayedMaterialLoading(value);
        }
    }
    getUseDelayedTextureLoading() {
        const def = false;
        if (this._zkScene) {
            let val = this._zkScene.getUseDelayedTextureLoading();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setUseDelayedTextureLoading(value) {
        if (this._zkScene) {
            this._zkScene.setUseDelayedTextureLoading(value);
        }
    }
    getGlowEnabled() {
        if (this._glowManager)
            return this._glowManager.enabled;
        return false;
    }
    setGlowEnabled(enabled) {
        if (this._glowManager) {
            this._glowManager.enabled = enabled;
            this.setRenderingNeeded();
        }
    }
    getGlowIntensity() {
        if (this._glowManager)
            return this._glowManager.intensity;
        return 1;
    }
    setGlowIntensity(intensity) {
        if (this._glowManager) {
            this._glowManager.intensity = intensity;
            this.setRenderingNeeded();
        }
    }
    getGlowBlurSize() {
        if (this._glowManager)
            return this._glowManager.blurSize;
        return 16;
    }
    setGlowBlurSize(blurSize) {
        if (this._glowManager) {
            this._glowManager.blurSize = blurSize;
            this.setRenderingNeeded();
        }
    }
    getInfoPointsEnabled() {
        let def = false;
        if (this._zkScene) {
            let val = this._zkScene.getInfoPointsEnabled();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setInfoPointsEnabled(value) {
        if (this._zkScene) {
            this._zkScene.setInfoPointsEnabled(value);
        }
        this.refreshInfoPoints();
    }
    getInfoPointsBorderColor() {
        const def = "";
        if (this._zkScene) {
            const val = this._zkScene.getInfoPointsBorderColor();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setInfoPointsBorderColor(value) {
        if (this._zkScene) {
            this._zkScene.setInfoPointsBorderColor(value);
            this.refreshInfoPoints();
        }
    }
    getInfoPointsInnerPointColor() {
        const def = "";
        if (this._zkScene) {
            const val = this._zkScene.getInfoPointsInnerPointColor();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setInfoPointsInnerPointColor(value) {
        if (this._zkScene) {
            this._zkScene.setInfoPointsInnerPointColor(value);
            this.refreshInfoPoints();
        }
    }
    getInfoPointsColor() {
        const def = "";
        if (this._zkScene) {
            const val = this._zkScene.getInfoPointsColor();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setInfoPointsColor(value) {
        if (this._zkScene) {
            this._zkScene.setInfoPointsColor(value);
            this.refreshInfoPoints();
        }
    }
    getInfoPointsHighlightColor() {
        const def = "";
        if (this._zkScene) {
            const val = this._zkScene.getInfoPointsHighlightColor();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setInfoPointsHighlightColor(value) {
        if (this._zkScene) {
            this._zkScene.setInfoPointsHighlightColor(value);
            this.refreshInfoPoints();
        }
    }
    enableGlowForMesh(mesh) {
        if (this._glowManager) {
            this._glowManager.enableGlowForMesh(mesh);
        }
    }
    disableGlowForMesh(mesh) {
        if (this._glowManager) {
            this._glowManager.disableGlowForMesh(mesh);
            this.setRenderingNeeded();
        }
    }
    enableARForMesh(mesh) {
        if (mesh) {
            if (!mesh.metadata)
                mesh.metadata = {};
            mesh.metadata.AR = true;
        }
    }
    disableARForMesh(mesh) {
        if (mesh) {
            if (!mesh.metadata)
                mesh.metadata = {};
            mesh.metadata.AR = false;
        }
    }
    disableTryOnForMesh(mesh) {
        if (mesh) {
            if (!mesh.metadata)
                mesh.metadata = {};
            mesh.metadata.TryOn = false;
            mesh.getChildMeshes().forEach(child => this.disableTryOnForMesh(child));
        }
    }
    enableTryOnForMesh(mesh) {
        if (mesh) {
            if (!mesh.metadata)
                mesh.metadata = {};
            mesh.metadata.TryOn = true;
            mesh.getChildMeshes().forEach(child => this.enableTryOnForMesh(child));
        }
    }
    enableInfoPointsForMesh(mesh) {
        if (mesh) {
            if (!mesh.metadata)
                mesh.metadata = {};
            mesh.metadata.showInfoPoints = true;
            this.refreshInfoPoints();
        }
    }
    disableInfoPointsForMesh(mesh) {
        if (mesh && mesh.metadata &&
            mesh.metadata.showInfoPoints !== undefined &&
            mesh.metadata.showInfoPoints !== null) {
            delete mesh.metadata.showInfoPoints;
            this.refreshInfoPoints();
        }
    }
    enableForcedInfoPointsVisibilityOnMesh(mesh) {
        if (mesh) {
            if (!mesh.metadata)
                mesh.metadata = {};
            mesh.metadata.forceShowInfoPoints = true;
            this.refreshInfoPoints();
        }
    }
    disableForcedInfoPointsVisibilityOnMesh(mesh) {
        if (mesh && mesh.metadata &&
            mesh.metadata.forceShowInfoPoints !== undefined &&
            mesh.metadata.forceShowInfoPoints !== null) {
            delete mesh.metadata.forceShowInfoPoints;
            this.refreshInfoPoints();
        }
    }
    setEditorBackgroundColor(hexColor) {
        this._editorBackgroundColor = hexColor;
        this.refreshEnvironment();
    }
    setViewerBackgroundAlpha(alpha) {
        if (this._zkScene) {
            const generalConfig = this._zkScene.getOrCreateGeneralConfig();
            generalConfig.set("backgroundAlpha", alpha);
            this.refreshEnvironment();
        }
    }
    setViewerBackgroundColor(hexColor) {
        if (this._zkScene) {
            const generalConfig = this._zkScene.getOrCreateGeneralConfig();
            generalConfig.set("backgroundColor", hexColor);
            this.refreshEnvironment();
        }
    }
    setViewerEnvironmentSizeAuto(sizeAuto) {
        if (this._zkScene) {
            const environmentConfig = this._zkScene.getOrCreateEnvironmentConfig();
            environmentConfig.set("sizeAuto", sizeAuto);
            this.refreshEnvironment();
        }
    }
    setViewerEnvironmentMainColor(hexColor) {
        if (this._zkScene) {
            const environmentConfig = this._zkScene.getOrCreateEnvironmentConfig();
            environmentConfig.set("mainColor", hexColor);
            this.refreshEnvironment();
        }
    }
    setViewerSkyboxCreateSkybox(createSkybox) {
        if (this._zkScene) {
            const skyboxConfig = this._zkScene.getOrCreateSkyboxConfig();
            skyboxConfig.set("createSkybox", createSkybox);
            this.refreshEnvironment();
        }
    }
    setViewerSkyboxSize(size) {
        if (this._zkScene) {
            const skyboxConfig = this._zkScene.getOrCreateSkyboxConfig();
            skyboxConfig.set("size", size);
            this.refreshEnvironment();
        }
    }
    setViewerSkyboxBlur(blur) {
        if (this._zkScene) {
            let blurSize = blur >= 0 ? blur : 0;
            const skyboxConfig = this._zkScene.getOrCreateSkyboxConfig();
            skyboxConfig.set("blur", blurSize);
            this.refreshEnvironment();
        }
    }
    setViewerSkyboxTexture(url, extensions, files) {
        if (this._zkScene && url != undefined && typeof (url) === "string") {
            const skyboxConfig = this._zkScene.getOrCreateSkyboxConfig();
            skyboxConfig.set("texture", url);
            skyboxConfig.set("extensions", extensions);
            skyboxConfig.set("files", files);
            this.refreshEnvironment();
        }
    }
    removeViewerSkyboxTexture() {
        if (this._zkScene) {
            const skyboxConfig = this._zkScene.getSkyboxConfig();
            if (skyboxConfig && skyboxConfig.get("texture") != undefined) {
                skyboxConfig.unset("texture");
                this.refreshEnvironment();
            }
        }
    }
    setViewerSkyboxColor(hexColor) {
        if (this._zkScene && hexColor != undefined && typeof (hexColor) === "string") {
            const skyboxConfig = this._zkScene.getOrCreateSkyboxConfig();
            skyboxConfig.set("color", hexColor);
            this.refreshEnvironment();
        }
    }
    setViewerGroundCreateGround(createGround) {
        if (this._zkScene && createGround != undefined && typeof (createGround) === "boolean") {
            const groundConfig = this._zkScene.getOrCreateGroundConfig();
            groundConfig.set("createGround", createGround);
            this.refreshEnvironment();
        }
    }
    setViewerGroundSize(size) {
        if (this._zkScene) {
            const groundConfig = this._zkScene.getOrCreateGroundConfig();
            groundConfig.set("size", size);
            this.refreshEnvironment();
        }
    }
    setViewerGroundTexture(url) {
        if (this._zkScene && url != undefined && typeof (url) === "string") {
            const groundConfig = this._zkScene.getOrCreateGroundConfig();
            groundConfig.set("texture", url);
            this.refreshEnvironment();
        }
    }
    removeViewerGroundTexture() {
        if (this._zkScene) {
            const groundConfig = this._zkScene.getGroundConfig();
            if (groundConfig && groundConfig.get("texture") != undefined) {
                groundConfig.unset("texture");
                this.refreshEnvironment();
            }
        }
    }
    setViewerGroundColor(hexColor) {
        if (this._zkScene && hexColor != undefined && typeof (hexColor) === "string") {
            const groundConfig = this._zkScene.getOrCreateGroundConfig();
            groundConfig.set("color", hexColor);
            this.refreshEnvironment();
        }
    }
    setViewerGroundOpacity(opacity) {
        if (this._zkScene && opacity != undefined && typeof (opacity) === "number") {
            const groundConfig = this._zkScene.getOrCreateGroundConfig();
            groundConfig.set("opacity", opacity);
            this.refreshEnvironment();
        }
    }
    setViewerGroundEnableShadow(enableShadow) {
        if (this._zkScene && enableShadow != undefined && typeof (enableShadow) === "boolean") {
            const groundConfig = this._zkScene.getOrCreateGroundConfig();
            groundConfig.set("enableShadow", enableShadow);
            this.refreshEnvironment();
        }
    }
    setViewerGroundShadowLevel(shadowLevel) {
        if (this._zkScene && shadowLevel != undefined && typeof (shadowLevel) === "number") {
            const groundConfig = this._zkScene.getOrCreateGroundConfig();
            groundConfig.set("shadowLevel", shadowLevel);
            this.refreshEnvironment();
        }
    }
    setViewerGroundEnableMirror(enableMirror) {
        if (this._zkScene && enableMirror != undefined && typeof (enableMirror) === "boolean") {
            const groundConfig = this._zkScene.getOrCreateGroundConfig();
            groundConfig.set("enableMirror", enableMirror);
            this.refreshEnvironment();
        }
    }
    setViewerGroundMirrorBlur(mirrorBlur) {
        if (this._zkScene && mirrorBlur != undefined && typeof (mirrorBlur) === "number") {
            const groundConfig = this._zkScene.getOrCreateGroundConfig();
            groundConfig.set("mirrorBlurKernel", mirrorBlur);
            this.refreshEnvironment();
        }
    }
    setViewerCameraAutoRotate(autoRotate) {
        if (this._zkScene && autoRotate != undefined && typeof (autoRotate) === "boolean") {
            const cameraConfig = this._zkScene.getOrCreateCameraConfig();
            cameraConfig.set("autoRotate", autoRotate);
            this.autoRender = autoRotate;
            this.refreshEnvironment();
        }
    }
    setViewerCameraContrast(contrast) {
        if (this._zkScene && contrast != undefined && typeof (contrast) === "number") {
            const cameraConfig = this._zkScene.getOrCreateCameraConfig();
            cameraConfig.set("contrast", contrast);
            this.refreshEnvironment();
        }
    }
    setViewerCameraExposure(exposure) {
        if (this._zkScene && exposure != undefined && typeof (exposure) === "number") {
            const cameraConfig = this._zkScene.getOrCreateCameraConfig();
            cameraConfig.set("exposure", exposure);
            this.refreshEnvironment();
        }
    }
    setViewerCameraToneMappingEnabled(toneMappingEnabled) {
        if (this._zkScene && toneMappingEnabled != undefined && typeof (toneMappingEnabled) === "boolean") {
            const cameraConfig = this._zkScene.getOrCreateCameraConfig();
            cameraConfig.set("toneMappingEnabled", toneMappingEnabled);
            this.refreshEnvironment();
        }
    }
    resetEditorEnvironment() {
        this.resetEditorBackground();
        this.resetEditorCamera();
        this.setRenderingNeeded();
    }
    resetEditorBackground() {
        if (this._scene) {
            this._scene.clearColor = BABYLON.Color3.FromHexString(this._editorBackgroundColor).toColor4();
            this.refreshGround();
            this.setRenderingNeeded();
        }
    }
    resetEditorCamera() {
        if (this._scene) {
            const camera = this._scene.activeCamera;
            if (camera instanceof BABYLON.ArcRotateCamera)
                camera.useAutoRotationBehavior = false;
            this._autoRender = false;
            this.setRenderingNeeded();
        }
    }
    preSceneContentScreenshot() {
        this.resetEditorEnvironment();
        this.removeGround();
    }
    postSceneContentScreenshot() {
    }
    preSceneMaterialScreenshot() {
        super.preSceneMaterialScreenshot();
        this.adjustSceneForSerialization();
    }
    postSceneMaterialScreenshot() {
        super.postSceneMaterialScreenshot();
    }
    sceneReadyForSave() {
        if (this._scene) {
            for (let i = 0; i < this._scene.meshes.length; i++) {
                const mesh = this._scene.meshes[i];
                if (!mesh.isReady())
                    return false;
            }
        }
        return true;
    }
    isCurrentCameraPivot(meshID) {
        if (this._sceneHelper) {
            const cameraPivot = this._sceneHelper.getCameraPivot();
            return cameraPivot && cameraPivot.id === meshID;
        }
        return false;
    }
    getCurrentCameraPivotID() {
        if (this._scene && this._sceneHelper) {
            const cameraPivot = this._sceneHelper.getCameraPivot();
            if (cameraPivot) {
                const mesh = this._scene.getMeshByID(cameraPivot.id);
                if (mesh)
                    return mesh.id;
            }
        }
        return null;
    }
    // Riscritta quella di SceneViewer perché viene salvata l'informazione
    // sul nuovo pivot, non solo modifcato il punto di vista
    setCameraPivot(meshID) {
        if (this._scene && this._sceneHelper) {
            // Elmino il pivot corrente
            for (let i = 0; i < this._scene.meshes.length; i++) {
                var m = this._scene.meshes[i];
                if (m.metadata && m.metadata.isCameraPivot != undefined)
                    delete m.metadata.isCameraPivot;
            }
            if (meshID) {
                const mesh = this._scene.getMeshByID(meshID);
                if (mesh) {
                    mesh.metadata = mesh.metadata || {};
                    mesh.metadata.isCameraPivot = true;
                }
                this._sceneHelper.setCameraPivot(mesh || null);
            }
            else {
                this._sceneHelper.setCameraPivot(null);
            }
        }
    }
    // --------------------------------------------------------
    // Funzioni per il salvataggio della scena
    // --------------------------------------------------------
    getBlobFromEmbeddedTextureAsync(texture) {
        return __awaiter(this, void 0, void 0, function* () {
            let blob = null;
            if (texture.url) {
                const url = texture.url;
                var fromData = url.substring(0, 5) === "data:";
                var fromBlob = url.substring(0, 5) === "blob:";
                var isBase64 = fromData && url.indexOf(";base64,") !== -1;
                if (fromData && texture._buffer && (texture._buffer instanceof ArrayBuffer || texture._buffer instanceof Uint8Array || texture._buffer instanceof Blob)) {
                    if (texture._buffer instanceof Blob)
                        blob = texture._buffer;
                    else if (texture._buffer instanceof Uint8Array)
                        blob = new Blob([texture._buffer], { type: texture.mimeType });
                    else if (texture._buffer instanceof ArrayBuffer)
                        blob = new Blob([new Uint8Array(texture._buffer)], { type: texture.mimeType });
                }
                else if (fromBlob) {
                    yield new Promise(resolve => {
                        var xhr = new XMLHttpRequest();
                        xhr.open('GET', url, true);
                        xhr.responseType = 'blob';
                        xhr.onload = function (e) {
                            if (this.status == 200) {
                                resolve(this.response);
                            }
                        };
                        xhr.send();
                    });
                }
                else if (isBase64) {
                    const buffer = new Uint8Array(BABYLON.Tools.DecodeBase64(url));
                    blob = new Blob([buffer], { type: texture.mimeType });
                }
            }
            return blob;
        });
    }
    uploadEmbeddedTexturesAsync(onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            const textureToUpload = [];
            if (this._zkScene && this._scene && this._sceneHelper) {
                const scene = this._scene;
                const zkScene = this._zkScene;
                const sceneHelper = this._sceneHelper;
                const materials = this.getAllMaterials();
                materials.forEach(m => {
                    const textures = m.getActiveTextures().filter(t => t instanceof BABYLON.Texture);
                    textures.forEach(t => {
                        if (t.url) {
                            var fromData = t.url.substring(0, 5) === "data:";
                            var fromBlob = t.url.substring(0, 5) === "blob:";
                            var isBase64 = fromData && t.url.indexOf(";base64,") !== -1;
                            if (fromData || fromBlob || isBase64) {
                                const type = sceneHelper.getMaterialTextureType(m, t);
                                if (type) {
                                    textureToUpload.push({
                                        texture: t,
                                        material: m,
                                        type: type
                                    });
                                }
                            }
                        }
                    });
                });
            }
            let perc = 0;
            for (let i = 0; i < textureToUpload.length; i++) {
                const info = textureToUpload[i];
                const texture = info.texture;
                const blob = yield this.getBlobFromEmbeddedTextureAsync(texture);
                if (blob) {
                    let extension = ".png";
                    if (texture.mimeType === "image/jpeg")
                        extension = ".jpg";
                    const name = info.type.replace(' ', '_');
                    //const filename = `${Utils.getRandomString(8, "0123456789abcdefghijklmnopqrstuvwxyz")}${extension}`;
                    const filename = `${name}${extension}`;
                    let file = new File([blob], filename);
                    const zkTexture = yield this.uploadTextureFileAsync(file, info.material);
                    if (zkTexture) {
                        const newUrl = zkTexture.get("url");
                        if (newUrl) {
                            yield new Promise((resolve, reject) => {
                                texture.updateURL(newUrl, undefined, () => resolve(), () => reject());
                            });
                        }
                    }
                    if (onProgress)
                        onProgress(i / textureToUpload.length * 100, "textures");
                }
            }
        });
    }
    useIncrementalLoading() {
        if (this._sceneHelper) {
            //var vertices = this.sceneHelper.getHiddenMeshTotalVertices();
            //var indices = this.sceneHelper.getHiddenMeshTotalIndices();
            const vertices = this._sceneHelper.getTotalVertices();
            const indices = this._sceneHelper.getTotalIndices();
            if (vertices + indices >= 1000)
                return true;
        }
        return false;
    }
    // Prepara il modello backbone zkScene per il salvataggio. Nel dettaglio:
    // 1. Esegue lo screenshot della scena e imposta i byte nel modello zkScene
    // 2. Recupera il JSON della scena da Babylon JS. 
    // 3. Esegue l'upload del file in modo che possa essere salvato nel percorso previsto per la scena corrente.
    // 4. Aggiorna il modello impostando i dati relativi al file "uploadato" (essenzialmente il fileObject)
    updateSceneModel(onSuccess, onError, onProgress) {
        if (this._zkScene && this._scene) {
            const scene = this._scene;
            const zkScene = this._zkScene;
            this.resetRealVisibility();
            const infoPointsShown = this.infoPointsShown;
            if (infoPointsShown)
                this.hideInfoPoints();
            this.uploadEmbeddedTexturesAsync((perc, type) => {
                if (onProgress)
                    onProgress(perc, type);
            }).then(() => {
                this.getSceneScreenshotAsync(500, 450).then((data) => {
                    if (infoPointsShown)
                        this.showInfoPoints();
                    zkScene.set("imageData", data);
                    // Incremento la versione
                    zkScene.set("version", zkScene.get("version") + 1);
                    // Si potrebbe rendere opzionale il caricamento incrementale
                    var incremental = this.useIncrementalLoading();
                    if (!incremental) {
                        // Salvo il file di scena per intero
                        this.uploadSceneFile((sceneFileInfo) => {
                            this.onUploadScenFileSuccess(sceneFileInfo);
                            if (onSuccess)
                                onSuccess();
                        }, (reason) => {
                            if (onError)
                                onError(reason);
                        }, (percentage, type) => {
                            if (onProgress)
                                onProgress(percentage, type);
                        });
                    }
                    else {
                        // Salvo il file di scena in maniera incrementale
                        this.uploadSceneIncrementalFiles((sceneFileInfo) => {
                            this.onUploadScenFileSuccess(sceneFileInfo);
                            if (onSuccess)
                                onSuccess();
                        }, (reason) => {
                            if (onError)
                                onError(reason);
                        }, (percentage) => {
                            if (onProgress)
                                onProgress(percentage);
                        });
                    }
                });
            }).catch((reason) => {
                if (onError)
                    onError(reason);
            });
        }
    }
    // Aggiorna il modello con i dati sul file di scena salvato
    onUploadScenFileSuccess(sceneFileInfo) {
        if (this._zkScene && sceneFileInfo && sceneFileInfo.hasOwnProperty("fileObjectID") && sceneFileInfo.hasOwnProperty("rootUrl") && sceneFileInfo.hasOwnProperty("sceneFileName") && sceneFileInfo.hasOwnProperty("manifestFileObjectID") && sceneFileInfo.hasOwnProperty("incrementalsFileObjectID")) {
            // Aggiorno il modello in modo che riporti i dati del file di scena salvato
            this._zkScene.set("fileObjectID", sceneFileInfo.fileObjectID);
            this._zkScene.set("url", sceneFileInfo.url);
            this._zkScene.set("rootUrl", sceneFileInfo.rootUrl);
            this._zkScene.set("sceneFileName", sceneFileInfo.sceneFileName);
            this._zkScene.set("manifestFileObjectID", sceneFileInfo.manifestFileObjectID);
            this._zkScene.set("incrementalsFileObjectID", sceneFileInfo.incrementalsFileObjectID);
        }
        else
            Logger.info("le informazioni sul file di scena salvato sono vuote o incorrette");
    }
    uploadSceneFile(onSuccess, onError, onProgress) {
        if (!this._scene || !this._zkScene) {
            if (onError)
                onError("No scene to upload");
            return;
        }
        const scene = this._scene;
        const zkScene = this._zkScene;
        const version = zkScene.get("version");
        const json = this.getSceneJson();
        const param = { json, version };
        this.getSceneFileBlobsAsync(json, version, (percentage) => {
            if (onProgress)
                onProgress(percentage, "optimize");
        }).then(blobInfos => {
            // Blobs ricevuti, ora va fallo l'upload sul server
            const formData = new FormData();
            for (let i = 0; i < blobInfos.length; i++) {
                const blobInfo = blobInfos[i];
                formData.append('file_' + i, blobInfo.blob, blobInfo.name);
            }
            jQuery.ajax({
                url: zkScene.getSceneFileUploadUrl(),
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                type: 'POST',
                xhr: () => {
                    let xhr = new XMLHttpRequest();
                    //Upload progress
                    xhr.upload.addEventListener("progress", (evt) => {
                        if (evt.lengthComputable) {
                            const percentComplete = evt.loaded / evt.total;
                            if (onProgress)
                                onProgress(percentComplete * 100, "upload");
                        }
                    }, false);
                    return xhr;
                },
                success: function (data) {
                    if (onSuccess)
                        onSuccess(data);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    if (onError)
                        onError(thrownError);
                }
            });
        });
    }
    getSceneFileBlobsAsync(json, version, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            let blobInfos = [];
            if (!this._sceneToBlobs) {
                this._sceneToBlobs = _Components_SceneToBlobs_SceneToBlobs__WEBPACK_IMPORTED_MODULE_4__.SceneToBlobs.Default;
            }
            if (this._sceneToBlobs) {
                yield this._sceneToBlobs.whenReadyAsync();
                blobInfos = yield this._sceneToBlobs.getSceneBlobsAsync(json, version, onProgress);
            }
            return blobInfos;
        });
    }
    // Serializza in JSON la scena Babylon JS
    getSceneJson() {
        var _a;
        let json = "";
        if (this._scene && this._sceneHelper) {
            const oldEnvMode = this._envMode;
            this.setEnvironmentMode(_Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor);
            // Disabilito l'antialiasing per evitare che vengano serializzati anche i PassPostProcess
            this.disableAntialiasing(true);
            // Resetto i limiti di rotazione che comunque sono salvati nella configurazione della scena
            const oldLimits = this.resetCameraRotationLimits();
            this.deleteHighlightLayer();
            const manipulatedNode = this._manipulatedNode;
            this.setManipulatedNode(null);
            // Se useMaterialOffloading e !useDelayedMaterialLoading scarico tutti materiali non utilizzati e li ricarico dopo
            if (this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading()) {
                this._sceneHelper.offloadAllUnusedMaterials();
            }
            // Sulle mesh nascosto imposto un materiale di default in modo da non caricare subiti materiali assegnati a mesh nascoste
            this._sceneHelper.setDummyMaterialToInvisibleMeshes();
            this.adjustSceneForSerialization();
            const serializedScene = BABYLON.SceneSerializer.Serialize(this._scene);
            serializedScene.postProcesses = []; // elimino gli eventuali post process
            json = JSON.stringify(serializedScene);
            // Ricarico gli eventuali materiali scaricati
            if (this.getUseMaterialOffloading() && !this.getUseDelayedMaterialLoading()) {
                const rootUrl = (_a = this._zkScene) === null || _a === void 0 ? void 0 : _a.get("rootUrl");
                if (rootUrl)
                    this._sceneHelper.loadAllOffloadedMaterials(rootUrl);
            }
            // Ripristino i materiali originali sulle mesh nascoste
            this._sceneHelper.unsetAllDummyMaterials();
            if (oldEnvMode != _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor)
                this.setEnvironmentMode(oldEnvMode);
            this.enableAntialiasing();
            this.createHighlightLayer();
            this.setManipulatedNode(manipulatedNode);
            // Reimposto i limiti correnti
            this.setCameraRotationLimits(oldLimits);
        }
        return json;
    }
    resetCameraRotationLimits() {
        const limits = {
            lowerAlphaLimit: null,
            upperAlphaLimit: null,
            lowerBetaLimit: null,
            upperBetaLimit: null
        };
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            limits.lowerAlphaLimit = this._camera.lowerAlphaLimit;
            limits.upperAlphaLimit = this._camera.upperAlphaLimit;
            limits.lowerBetaLimit = this._camera.lowerBetaLimit;
            limits.upperBetaLimit = this._camera.upperBetaLimit;
            this._camera.lowerAlphaLimit = null;
            this._camera.upperAlphaLimit = null;
            this._camera.lowerBetaLimit = 0.01;
            this._camera.upperBetaLimit = Math.PI - 0.01;
        }
        return limits;
    }
    setCameraRotationLimits(limits) {
        limits = limits || { lowerAlphaLimit: null, upperAlphaLimit: null, lowerBetaLimit: 0.01, upperBetaLimit: Math.PI - 0.01 };
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            this._camera.lowerAlphaLimit = limits.lowerAlphaLimit;
            this._camera.upperAlphaLimit = limits.upperAlphaLimit;
            this._camera.lowerBetaLimit = limits.lowerBetaLimit || 0.01;
            this._camera.upperBetaLimit = limits.upperBetaLimit || Math.PI - 0.01;
        }
    }
    // Metodo fondamentale per modificare gli url delle texture ed eliminare le 
    // le texture non più utilizzate. In fase di caricamento della scena, Babylon JS
    // risolve il nome delle texture in base al path della scena. Quindi gli url delle
    // texture vanno, se necessario, trasformanti in path relativi.
    adjustSceneForSerialization() {
        if (this._scene && this._sceneHelper && this._zkScene) {
            const sceneHelper = this._sceneHelper;
            this.removeDisabledFresnelParameters();
            let delayedTextures = false;
            if (this._zkScene.getUseDelayedTextureLoading() != undefined)
                delayedTextures = this._zkScene.getUseDelayedTextureLoading();
            this._scene.useDelayedTextureLoading = delayedTextures;
            // Attenzione!
            // Prima della serializzazione della scena, è necessario sistemare il path delle texture.
            // Sostanzialmente modifico il nome della texture settando il path relativo
            // in modo che poi possa essere risolto come path assoluto relativo alla scena.
            // MatchSameNameTextures indica se nel salvataggio della scena due texture con lo stesso
            // nome possono essere considerate come uguali. In caso affermativo nella scena verrà
            // utilizzato solo l'url di una di esse, evitando qindi di scaricare più volte la stessa
            // immagine
            const matchSameNameTextures = this.getMatchSameNameTextures();
            const sourcesIDs = this._zkScene.getSourcesIDs();
            const libraryMaterialIDs = this._zkScene.getLibraryMaterialIDs();
            // per ogni id di materiale di libreria, contiene una mappa nome file texture --> url
            const libMaps = {};
            // mappa textureName -> url
            const urlMap = {};
            // Contiene gli url delle texture effettivamente usate nella scena. 
            // Consente di eliminare dal modello zkScene tutte le texture non più utilizzate
            const usedTextureUrls = [];
            const onlyDesktopTextureUrls = [];
            const onlyMobileTextureUrls = [];
            // Da rivedere la gestione della mappa d'ambiente di default
            const envUrl = sceneHelper.getTextureUrl(this._scene.environmentTexture);
            //const useDefaultEnvironmentTexture = envUrl != null && envUrl == DefaultAssetUrls.Environment.EnvironmentTextureCDNUrl;
            const useDefaultEnvironmentTexture = envUrl !== null && envUrl.endsWith(_Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_9__.DefaultAssetUrls.Environment.EnvironmentTextureName);
            this._zkScene.set("useDefaultEnvironmentTexture", useDefaultEnvironmentTexture);
            // La rotazione dell'environmentTexture purtroppo al momento non viene serializzata nella scena.
            // Utilizzo i metadati allora
            if (this._scene.environmentTexture &&
                (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture)) {
                const rotationY = this._scene.environmentTexture.rotationY;
                if (!this._scene.metadata)
                    this._scene.metadata = {};
                this._scene.metadata.environmentTextureRotationY = rotationY;
            }
            this._scene.textures.forEach((txt) => {
                if (!sceneHelper.isTextureWithUrl(txt))
                    return;
                let txtUrl = txt.url;
                if (txt.getInternalTexture) {
                    const internalTexture = txt.getInternalTexture();
                    if (internalTexture && internalTexture.url) {
                        txtUrl = internalTexture.url;
                    }
                }
                if (txtUrl) {
                    let textureUrl = txtUrl;
                    // EnvironmentTexture di default
                    if (textureUrl === _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_9__.DefaultAssetUrls.Environment.EnvironmentTextureCDNUrl) {
                        // La scena utilizza una environment texture di default
                        // Impostanto useDefaultEnvironmnetTexture a true sulla scena
                        // faccio in modo che, al momento del salvataggio sul server,
                        // il file immagine venga copiato nello stesso percorso della scena
                        // nella directory textures/00000000000000000000000000000000/
                        txt.url = "textures/" + Zakeke.getEmptyUUID().replace(/-/g, "") + "/" + _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_9__.DefaultAssetUrls.Environment.EnvironmentTextureName;
                        txt.name = txt.url;
                        return;
                    }
                    // Skybox e ground di default. Verranno ricreate al caricamento della scena
                    if (textureUrl == _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_9__.DefaultAssetUrls.Environment.SkyboxTextureCDNUrl ||
                        textureUrl == _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_9__.DefaultAssetUrls.Environment.GroundTextureCDNUrl)
                        return;
                    // Altre texture
                    let isSource = false;
                    if (textureUrl.startsWith("blob:") && txt.metadata && txt.metadata.fileUrl) {
                        textureUrl = txt.metadata.fileUrl;
                    }
                    // Se la texture proviene da una sorgente, 
                    // allora devo prendere solo la parte dal codice sorgente in poi
                    // name = "{sourceID}/.../{filename.xxx}"
                    for (let i = 0; i < sourcesIDs.length; i++) {
                        let sourceID = sourcesIDs[i].replace(/-/g, "");
                        let idx = textureUrl.indexOf(sourceID);
                        if (idx != -1) {
                            isSource = true;
                            txt.name = textureUrl.substring(idx);
                            txt.url = txt.name;
                            Logger.info("texture url: " + txt.url);
                            break;
                        }
                    }
                    // Texture per materiali di libreria
                    // Per i materiali di libreria avremo già un percorso del tipo "textures/{libraryMaterialID}/{filename.xxx}"
                    // Sarà sufficiente sostituire "libraryMaterialID" con il nuovo id del materiale assegnato
                    // nella scena corrente
                    let isLibrary = false;
                    if (txt["materialMapping"]) {
                        isLibrary = true;
                        let libraryMaterialID = txt["materialMapping"].libraryMaterialID.replace(/-/g, "");
                        let sceneMaterialID = txt["materialMapping"].sceneMaterialID.replace(/-/g, "");
                        let finalUrl = textureUrl;
                        let finalName = txt.name;
                        let idx = textureUrl.indexOf(libraryMaterialID);
                        if (idx != -1) {
                            let libTxtUrl = textureUrl.replace(new RegExp(libraryMaterialID, 'g'), sceneMaterialID);
                            finalUrl = libTxtUrl;
                            finalName = libTxtUrl;
                            let map = {};
                            if (libMaps.hasOwnProperty(libraryMaterialID))
                                map = libMaps[libraryMaterialID];
                            else {
                                libMaps[libraryMaterialID] = map;
                            }
                            idx = libTxtUrl.lastIndexOf("/");
                            if (idx !== -1) {
                                let libTxtName = libTxtUrl.substring(idx + 1);
                                if (map.hasOwnProperty(libTxtName)) {
                                    finalUrl = map[libTxtName];
                                    finalName = finalUrl;
                                    if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(usedTextureUrls, finalUrl))
                                        usedTextureUrls.push(finalUrl);
                                }
                                else {
                                    idx = libTxtUrl.lastIndexOf("/", idx - 1);
                                    if (idx !== -1) {
                                        idx = libTxtUrl.lastIndexOf("/", idx - 1);
                                        if (idx != -1) {
                                            finalUrl = libTxtUrl.substring(idx + 1);
                                            finalName = finalUrl;
                                            if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(usedTextureUrls, finalUrl))
                                                usedTextureUrls.push(finalUrl);
                                            if (matchSameNameTextures) {
                                                map[libTxtName] = finalUrl;
                                            }
                                        }
                                    }
                                }
                            }
                            txt.name = finalName;
                            txt.url = finalUrl;
                        }
                    }
                    // Texture caricate dall'utente per un materiale
                    // il percorso iniziale sarà del tipo ..../textures/{materialID}/{filename.xxx}
                    // imposto il nome a "textures/{materialID}/{filename.xxx}"
                    if (!isSource && !isLibrary) {
                        const textureInfo = this.extractTextureNameAndUrl(textureUrl, matchSameNameTextures, urlMap);
                        if (textureInfo.url && textureInfo.name) {
                            txt.url = textureInfo.url;
                            txt.name = textureInfo.name;
                            if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(usedTextureUrls, txt.url))
                                usedTextureUrls.push(txt.url);
                        }
                        if (txt.metadata && txt.metadata.mobileUrl) {
                            const mobileTextureInfo = this.extractTextureNameAndUrl(txt.metadata.mobileUrl, matchSameNameTextures, urlMap);
                            if (mobileTextureInfo.url && mobileTextureInfo.name) {
                                txt.metadata.mobileUrl = mobileTextureInfo.url;
                                if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(usedTextureUrls, txt.metadata.mobileUrl))
                                    usedTextureUrls.push(txt.metadata.mobileUrl);
                                if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(onlyMobileTextureUrls, txt.metadata.mobileUrl))
                                    onlyMobileTextureUrls.push(txt.metadata.mobileUrl);
                                if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(onlyDesktopTextureUrls, txt.url))
                                    onlyDesktopTextureUrls.push(txt.url);
                            }
                        }
                    }
                }
            });
            // Elimino dal modello zkScene tutte le texture non efettivamente utilizzate nella scena
            const suffixes = ["px", "py", "pz", "nx", "ny", "nz"];
            const clearCubeMapSuffix = (url) => {
                let idx = url.lastIndexOf(".");
                let newUrl = url;
                if (idx !== -1) {
                    let nameWithoutExt = url.substring(0, idx);
                    for (let p = 0; p < suffixes.length; p++) {
                        const suffix = suffixes[p];
                        idx = nameWithoutExt.lastIndexOf("_" + suffix);
                        if (idx != -1) {
                            newUrl = nameWithoutExt.substring(0, idx);
                            break;
                        }
                    }
                }
                return newUrl;
            };
            const isUsedTextureUrl = (url) => {
                const newUrl = clearCubeMapSuffix(url);
                for (let u = 0; u < usedTextureUrls.length; u++) {
                    const usedUrl = usedTextureUrls[u];
                    if (newUrl.endsWith(usedUrl))
                        return true;
                }
                return false;
            };
            const isOnlyDesktopTextureUrl = (url) => {
                const newUrl = clearCubeMapSuffix(url);
                for (let u = 0; u < onlyDesktopTextureUrls.length; u++) {
                    const usedUrl = onlyDesktopTextureUrls[u];
                    if (newUrl.endsWith(usedUrl))
                        return true;
                }
                return false;
            };
            const isOnlyMobileTextureUrl = (url) => {
                const newUrl = clearCubeMapSuffix(url);
                for (let u = 0; u < onlyMobileTextureUrls.length; u++) {
                    const usedUrl = onlyMobileTextureUrls[u];
                    if (newUrl.endsWith(usedUrl))
                        return true;
                }
                return false;
            };
            // Elimino le texture e costruisco una mappa delle texture per materiale, utilizzabile in fase di prefetch
            const modelsToRemove = [];
            for (let t = 0; t < this._zkScene.get("textures").length; t++) {
                const zkTexture = this._zkScene.get("textures").at(t);
                const url = zkTexture.get("url");
                if (url) {
                    if (!isUsedTextureUrl(url))
                        modelsToRemove.push(zkTexture);
                    else if (isOnlyDesktopTextureUrl(url))
                        zkTexture.set("usage", Zakeke.TextureUsage.Desktop);
                    else if (isOnlyMobileTextureUrl(url))
                        zkTexture.set("usage", Zakeke.TextureUsage.Mobile);
                    else
                        zkTexture.set("usage", Zakeke.TextureUsage.Any);
                }
                else {
                    modelsToRemove.push(zkTexture);
                }
                //if (url && !isUsedTextureUrl(url))
                //    modelsToRemove.push(zkTexture);
            }
            if (modelsToRemove.length > 0)
                this._zkScene.get("textures").remove(modelsToRemove);
            // Salvo l'elenco delle texture utilizzate in modo che lato backend si evitino
            // le duplicazioni di texture nello spostamento da materiali di libreria a quelli di scena
            this._zkScene.set("usedTextureUrls", usedTextureUrls);
        }
    }
    // Metodo da usare per le texture caricate dall'utente, per trasformre il percorso assoluto
    // del tipo ..../textures/{ materialID }/{filename.xxx} nel percorso relativo textures/{materialID}/{filename.xxx}
    // Utilizza ed aggiorna eventualmente un dictionary per riutilizzare lo stesso percorso a parità di nome
    extractTextureNameAndUrl(textureUrl, matchSameNameTextures, urlMap) {
        const info = { name: "", url: "" };
        let idx = textureUrl.lastIndexOf("/");
        if (idx !== -1) {
            const textureName = textureUrl.substring(idx + 1);
            if (urlMap.hasOwnProperty(textureName)) {
                info.url = urlMap[textureName];
                info.name = info.url;
            }
            else {
                idx = textureUrl.lastIndexOf("/", idx - 1);
                if (idx !== -1) {
                    idx = textureUrl.lastIndexOf("/", idx - 1);
                    if (idx !== -1) {
                        const newName = textureUrl.substring(idx + 1);
                        info.url = newName;
                        info.name = newName;
                        if (matchSameNameTextures) {
                            urlMap[textureName] = newName;
                        }
                    }
                }
            }
        }
        return info;
    }
    removeDisabledFresnelParameters() {
        const canRemoveFresnelParameters = function (fresnelParameters) {
            return fresnelParameters &&
                (fresnelParameters.isEnabled != undefined && !fresnelParameters.isEnabled) &&
                (fresnelParameters.leftColor != undefined && fresnelParameters.leftColor != null && fresnelParameters.leftColor instanceof BABYLON.Color3 && fresnelParameters.leftColor.equals(BABYLON.Color3.White())) &&
                (fresnelParameters.rightColor != undefined && fresnelParameters.rightColor != null && fresnelParameters.rightColor instanceof BABYLON.Color3 && fresnelParameters.rightColor.equals(BABYLON.Color3.Black())) &&
                (fresnelParameters.bias != undefined && fresnelParameters.bias == 0) &&
                (fresnelParameters.power != undefined && fresnelParameters.power == 1);
        };
        if (this._scene) {
            this._scene.materials.forEach(function (material) {
                if (material instanceof BABYLON.StandardMaterial) {
                    if (material.diffuseFresnelParameters && canRemoveFresnelParameters(material.diffuseFresnelParameters)) {
                        material.diffuseFresnelParameters = new BABYLON.FresnelParameters();
                        material.diffuseFresnelParameters.isEnabled = false;
                    }
                    if (material.emissiveFresnelParameters && canRemoveFresnelParameters(material.emissiveFresnelParameters)) {
                        material.emissiveFresnelParameters = new BABYLON.FresnelParameters();
                        material.emissiveFresnelParameters.isEnabled = false;
                    }
                    if (material.opacityFresnelParameters && canRemoveFresnelParameters(material.opacityFresnelParameters)) {
                        material.opacityFresnelParameters = new BABYLON.FresnelParameters();
                        material.opacityFresnelParameters.isEnabled = false;
                    }
                    if (material.reflectionFresnelParameters && canRemoveFresnelParameters(material.reflectionFresnelParameters)) {
                        material.reflectionFresnelParameters = new BABYLON.FresnelParameters();
                        material.reflectionFresnelParameters.isEnabled = false;
                    }
                    if (material.refractionFresnelParameters && canRemoveFresnelParameters(material.refractionFresnelParameters)) {
                        material.refractionFresnelParameters = new BABYLON.FresnelParameters();
                        material.refractionFresnelParameters.isEnabled = false;
                    }
                }
                else if (material instanceof BABYLON.PBRMaterial) {
                    // non più presenti su PBRMaterial
                    /*
                    if (material.opacityFresnelParameters && canRemoveFresnelParameters(material.opacityFresnelParameters))
                        material.opacityFresnelParameters = undefined;

                    if (material.emissiveFresnelParameters && canRemoveFresnelParameters(material.emissiveFresnelParameters))
                        material.emissiveFresnelParameters = undefined;
                    */
                }
                else if (material instanceof Zakeke.PBRMaterial) {
                    if (material.opacityFresnelParameters && canRemoveFresnelParameters(material.opacityFresnelParameters))
                        material.opacityFresnelParameters = undefined;
                }
            });
        }
    }
    // Versione che utilizza un webworker (incapsulato in IncrementalFiles) per produrre i file incrementali (ed eventualmente 
    // codificarli con Draco). In futuro si potrebbe convertire in async.
    uploadSceneIncrementalFiles(onSuccess, onError, onProgress) {
        if (!this._scene || !this._zkScene || !this._sceneHelper) {
            if (onError)
                onError("No scene to upload");
            return;
        }
        const scene = this._scene;
        const zkScene = this._zkScene;
        const sceneHelper = this._sceneHelper;
        let version = zkScene.get("version");
        let oldEnvMode = this.envMode;
        this.setEnvironmentMode(_Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor);
        // Disabilito l'antialiasing per evitare che vengano serializzati anche i PassPostProcess
        this.disableAntialiasing(true);
        let oldLimits = this.resetCameraRotationLimits();
        this.deleteHighlightLayer();
        this.adjustSceneForSerialization();
        // Imposto un materiale fittizio sulle mesh nascoste
        sceneHelper.setDummyMaterialToInvisibleMeshes();
        // Delayed Material Loading
        let delayedMaterialLoading = this.getUseDelayedMaterialLoading();
        let useMaterialOffloading = this.getUseMaterialOffloading();
        // nel caso di delayed loading indico tutti i materiali da utilizzare in modo differito
        let delayedMaterials = {};
        let offloadedMaterials = {};
        if (delayedMaterialLoading) {
            const materials = this.getAllMaterials();
            materials.forEach(m => {
                const meshes = this.getMeshesUsingMaterial(m.id);
                if (m.id !== "default material" && meshes.length === 0) {
                    delayedMaterials[m.id] = {
                        name: m.name,
                        file: "material_" + version + "_" + m.id.replace(/[^a-z0-9]/gi, '_').toLowerCase() + ".json"
                    };
                }
            });
        }
        else if (useMaterialOffloading) {
            const materials = this.getAllMaterials();
            materials.forEach(m => {
                const meshes = this.getMeshesUsingMaterial(m.id);
                if (m.id !== "default material" && meshes.length === 0) {
                    offloadedMaterials[m.id] = sceneHelper.getOffloadedMaterialInfo(m);
                }
            });
        }
        if (!this._scene.metadata)
            this._scene.metadata = {};
        this._scene.metadata.offloadedMaterials = offloadedMaterials;
        this._scene.metadata.delayedMaterials = delayedMaterials;
        let sceneJson = BABYLON.SceneSerializer.Serialize(this._scene);
        sceneJson.postProcesses = []; // elimino gli eventuali post process
        // Ripristino subito i materiali originali sulle mesh nascoste
        if (sceneJson.metadata && sceneJson.metadata.originalMeshMaterials) {
            // quando ripristino i materiali originali vengnono modificati anche i metadati della scena json
            const oldOriginalMeshMaterials = JSON.parse(JSON.stringify(sceneJson.metadata.originalMeshMaterials));
            sceneHelper.unsetAllDummyMaterials();
            sceneJson.metadata.originalMeshMaterials = oldOriginalMeshMaterials;
        }
        const options = {
            useDraco: this._dracoEnabled,
            dracoEncodingSpeed: this._dracoEncodingSpeed,
            dracoDecodingSpeed: this._dracoDecodingSpeed,
            excludedMeshes: [],
            delayMatarialLoading: Object.keys(delayedMaterials),
            offloadedMaterialIDs: Object.keys(offloadedMaterials)
        };
        this.getSceneIncrementalFilesAsync(version, sceneJson, options, onProgress)
            .then((incrementalFiles) => {
            let formData = new FormData();
            for (let i = 0; i < incrementalFiles.length; i++) {
                const incrementalFileInfo = incrementalFiles[i];
                let name = incrementalFileInfo.name;
                let data = incrementalFileInfo.data;
                let compressed = false;
                if (!incrementalFileInfo.dracoEncoded && incrementalFileInfo.data.length > 180 && incrementalFileInfo.data.length < 450000) {
                    Logger.info("Uncompressed file length: " + incrementalFileInfo.data.length);
                    // compress file content
                    data = LZString.compressToUint8Array(incrementalFileInfo.data);
                    Logger.info("Compressed file length: " + data.length);
                    name = "compressed_" + incrementalFileInfo.name;
                    compressed = true;
                }
                let blob;
                if (!incrementalFileInfo.dracoEncoded && !compressed) {
                    blob = new Blob([data], { type: "text/plain" });
                }
                else {
                    var arrayBuffer = data.buffer;
                    blob = new Blob([arrayBuffer]);
                }
                formData.append('file_' + i, blob, name);
            }
            jQuery.ajax({
                url: zkScene.getSceneIncrementalFileUploadUrl(),
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                type: 'POST',
                xhr: function () {
                    var xhr = new XMLHttpRequest();
                    //Upload progress
                    xhr.upload.addEventListener("progress", (evt) => {
                        if (evt.lengthComputable) {
                            var percentComplete = evt.loaded / evt.total;
                            if (onProgress)
                                onProgress(percentComplete * 100);
                        }
                    }, false);
                    return xhr;
                },
                success: (data) => {
                    if (onSuccess)
                        onSuccess(data);
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    if (onError)
                        onError(thrownError);
                }
            });
            if (oldEnvMode != _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor)
                this.setEnvironmentMode(oldEnvMode);
            this.enableAntialiasing();
            this.createHighlightLayer();
            this.setCameraRotationLimits(oldLimits);
        });
    }
    // Utilizza il web worker MakeIncrementalFiles per ottenere i file incrementali (eventualmente codificati con Draco)
    getSceneIncrementalFilesAsync(version, json, options, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            let files = [];
            if (!this._incrementalFilesMaker)
                this._incrementalFilesMaker = _Components_IncrementalFiles_IncrementalFiles__WEBPACK_IMPORTED_MODULE_1__.IncrementalFiles.Default;
            if (this._incrementalFilesMaker) {
                yield this._incrementalFilesMaker.whenReadyAsync();
                files = yield this._incrementalFilesMaker.getIncrementalFilesAsync(json, version, options);
            }
            return files;
        });
    }
    // Fine funzioni salvataggio scena
    // --------------------------------------------------------
    setNewSceneModelAsync(zkModel, zkScene) {
        return __awaiter(this, void 0, void 0, function* () {
            this._zkModel = zkModel;
            this._zkScene = zkScene;
            yield this.init3DEngineAsync();
            this.fireMeshesUpdateEvent();
            this.fireMaterialsUpdateEvent();
            this.fireLightsUpdateEvent();
            this.fireCameraLocationsUpdateEvent();
        });
    }
    preSceneFileLoading() {
        this.resetRealVisibility();
    }
    postSceneFileLoading() {
        this.fireSceneCreatedEvent();
        this.fireMeshesUpdateEvent();
        this.fireMaterialsUpdateEvent();
        this.fireLightsUpdateEvent();
        this.fireCameraLocationsUpdateEvent();
    }
    // ==============================================================================
    // Importazione Assets 
    // ==============================================================================
    // I file "uploadati" dall'utente non vengono caricati immediatamente nella scena
    // ma viene creato un task di elaborazione lato server il cui stato verrà controllato tramite polling.
    // Per ogni task server di caricamento verrà creato un oggetto task lato client che è utile
    // per il recupero tramite polling delle informazioni.
    // I task lato client avranno uno degli stati:
    //   uploading         - Task avviato per l'uploading dei file
    //   progress          - Task in elaborazione
    //   checking          - Chimata Ajax di controllo stato in corso
    //   success           - Task server completato con successo, si possono importare i relativi file nella scena Babylon JS corrente
    //   completed_success - Task eseguito correttamente e file importati nella scena Babylon JS
    //   completed_error   - Task in errore, può essere eliminato dalla lista dei task da controllare
    loadSceneSourceFiles(files, onSuccess, onError) {
        if (this._zkScene) {
            const zkScene = this._zkScene;
            // FormData per i file da uploadare
            const data = new FormData();
            for (let i = 0; i < files.length; i++) {
                data.append('file-' + i, files[i]);
            }
            // Creo il task subito e lo metto in coda con lo stato di upload
            const task = {
                downloadProgress: 0,
                uploadProgress: 0,
                status: SourceTaskStatus.uploading,
                message: "",
                sceneSourceInfo: {},
                taskID: undefined,
                sourceID: undefined
            };
            this._sceneSourceTasks.push(task);
            // Passo i file sul server creando il relativo task per il recupero dello stato
            jQuery.ajax({
                url: zkScene.getSourceTasksUrl(),
                data: data,
                cache: false,
                contentType: false,
                processData: false,
                type: 'POST',
                xhr: () => {
                    const xhr = new XMLHttpRequest();
                    // Handle progress
                    //Upload progress
                    xhr.upload.addEventListener("progress", (evt) => {
                        if (evt.lengthComputable) {
                            let percentComplete = evt.loaded / evt.total;
                            task.uploadProgress = percentComplete * 100;
                            this.fireSceneSourceTaskCheckEvent();
                        }
                    }, false);
                    //Download progress
                    xhr.addEventListener("progress", (evt) => {
                        if (evt.lengthComputable) {
                            let percentComplete = evt.loaded / evt.total;
                            task.downloadProgress = percentComplete * 100;
                            this.fireSceneSourceTaskCheckEvent();
                        }
                    }, false);
                    return xhr;
                },
                success: (data) => {
                    // Ottengo i dati del task (server) di caricamento creato a partire dai file inviati
                    // e creo il task lato client
                    if (data && data.hasOwnProperty("taskID") && data.hasOwnProperty("sourceID")) {
                        // creo un task nello stato progress
                        task.taskID = data.taskID;
                        task.sourceID = data.sourceID;
                        task.status = SourceTaskStatus.progress;
                        this.fireSceneSourceTaskCheckEvent();
                    }
                    else
                        Logger.info("processo di creazione task non andato a buon fine");
                    if (onSuccess)
                        onSuccess(task);
                },
                error: (xhr, ajaxOptions, thrownError) => {
                    this._sceneSourceTasks = this._sceneSourceTasks.filter((x) => { x !== task; });
                    this.fireSceneSourceTaskCheckEvent();
                    if (onError)
                        onError(thrownError);
                }
            });
            this.fireSceneSourceTaskCheckEvent();
        }
    }
    // Il metodo viene richiamato ogni secondo per il controllo dei task di caricamento file
    // eventualmente presenti in coda
    checkSceneSourceTasks() {
        if (this._scene && this._zkScene && this._sceneSourceTasks && this._sceneSourceTasks.length > 0) {
            const zkScene = this._zkScene;
            for (let i = 0; i < this._sceneSourceTasks.length; i++) {
                let task = this._sceneSourceTasks[i];
                // TASK Definitivamente Completato
                if (task.status == SourceTaskStatus.completed_error || task.status == SourceTaskStatus.completed_success) {
                    // Se il task è completato definitivamente lo elimino dalla lista
                    this._sceneSourceTasks.splice(i--, 1);
                    this.fireSceneSourceTaskCheckEvent();
                    continue;
                }
                // TASK in chiamata AJAX di controllo o di Upload in corso
                if (task.status == SourceTaskStatus.checking || task.status == SourceTaskStatus.uploading)
                    continue;
                // TASK in elaborazione lato server
                if (task.status == SourceTaskStatus.progress) {
                    // Eseguo la chiamata ajax per verificare lo stato del task
                    // cambio lo stato in "checking" in modo da non ripetere la chiamata
                    task.status = SourceTaskStatus.checking;
                    const onError = (task) => {
                        // Il recupero delle informazioni è andato in errore.
                        // Il task può essere eliminato dalla coda
                        task.status = SourceTaskStatus.completed_error;
                        this.fireSceneSourceTaskErrorEvent(task.taskID);
                        this.fireSceneSourceTaskCheckEvent();
                    };
                    // Eseguo la chiamata per ottenere lo stato del task lato server.
                    // Nel caso in cui il task lato server sia completato, avrò anche le informazioni
                    // sui file che sono stati caricati (file di scena sorgente + textures)
                    // Mauro - 07/02/2018: Ho transformato la chiamata in una funzione  perchè altrimenti la task nella callback
                    // potrebbe essere un'altra e non quella da dove era partita dato che in JS lo scope di una var è per function...
                    // lo stesso vale per l'onError
                    var runAjaxCheck = (task) => {
                        jQuery.ajax({
                            url: zkScene.getSourceTaskResultUrl(task.taskID),
                            cache: false,
                            contentType: false,
                            processData: false,
                            type: 'GET',
                            success: (data) => {
                                if (data && data.hasOwnProperty("taskID") && data.hasOwnProperty("state") && data.hasOwnProperty("message") && data.hasOwnProperty("sourceFile")) {
                                    if (data.state == 2) {
                                        // Il task si è completato con successo, salvo le informazioni
                                        // sui file generati sul task client in modo che possano essere 
                                        // importati nella scena corrente
                                        // file di scena sorgente
                                        task.sceneSourceInfo = {
                                            sourceID: data.sourceFile.sourceID,
                                            fileObjectID: data.sourceFile.fileObjectID,
                                            url: data.sourceFile.url,
                                            rootUrl: data.sourceFile.rootUrl,
                                            sceneFileName: data.sourceFile.sceneFileName,
                                            textureFiles: [],
                                        };
                                        // textures
                                        for (let i = 0; i < data.sourceFile.textureFiles.length; i++) {
                                            task.sceneSourceInfo.textureFiles.push({
                                                textureID: data.sourceFile.textureFiles[i].textureID,
                                                fileObjectID: data.sourceFile.textureFiles[i].fileObjectID,
                                                url: data.sourceFile.textureFiles[i].url,
                                            });
                                        }
                                        task.status = SourceTaskStatus.success;
                                    }
                                    else if (data.state == 3) {
                                        // Task server in errore
                                        onError(task);
                                    }
                                    else {
                                        // Task server ancora in esecuzione
                                        task.status = SourceTaskStatus.progress;
                                    }
                                }
                                else {
                                    // Risultato non conforme a quello atteso: errore nella chiamata
                                    onError(task);
                                }
                            },
                            error: function (xhr, ajaxOptions, thrownError) {
                                // Errore nella chiamata ajax
                                onError(task);
                            }
                        });
                    };
                    runAjaxCheck(task);
                }
                // TASK con elaborazione server terminata con successo
                if (task.status == SourceTaskStatus.success) {
                    // Il task server si è concluso con successo. Il task client contiene
                    // i dati sui file generati
                    if (!this._isLoadingSourceFiles) {
                        this._isLoadingSourceFiles = true;
                        if (task.sceneSourceInfo.rootUrl && task.sceneSourceInfo.sceneFileName) {
                            // File di scena sorgente
                            this.updateSceneModelFromSourceTask(task);
                            // Importo i file nella scena Babylon JS corrente
                            this.loadMeshesFromRemoteFiles(task.sceneSourceInfo.rootUrl, task.sceneSourceInfo.sceneFileName, (meshes) => {
                                if (meshes && Object.prototype.toString.call(meshes) === '[object Array]') {
                                    meshes.forEach((mesh) => { mesh.isPickable = true; });
                                }
                                this._isLoadingSourceFiles = false;
                                this.fireSceneSourceTaskSuccessEvent(meshes);
                                this.fireMeshesUpdateEvent();
                                this.fireMaterialsUpdateEvent();
                                this.fireLightsUpdateEvent();
                                task.status = SourceTaskStatus.completed_success;
                            }, (reason) => {
                                Logger.info("Errore nel caricamento delle mesh: " + reason);
                                this._isLoadingSourceFiles = false;
                                this.fireSceneSourceTaskErrorEvent(task.taskID);
                                task.status = SourceTaskStatus.completed_error;
                            });
                        }
                        else {
                            Logger.info("Risultato del task di caricamento non valido");
                            this._isLoadingSourceFiles = false;
                            this.fireSceneSourceTaskErrorEvent(task.taskID);
                            task.status = SourceTaskStatus.completed_error;
                        }
                        this.fireSceneSourceTaskCheckEvent();
                    }
                }
            }
        }
        // il metodo verrà richiamato tra mezzo secondo
        setTimeout(() => this.checkSceneSourceTasks(), 500);
    }
    updateSceneModelFromSourceTask(task) {
        if (this._zkScene) {
            // File di scena sorgente
            const zkSource = new Zakeke.SceneSource();
            zkSource.set("sourceID", task.sceneSourceInfo.sourceID);
            zkSource.set("fileObjectID", task.sceneSourceInfo.fileObjectID);
            zkSource.set("url", task.sceneSourceInfo.url);
            zkSource.set("rootUrl", task.sceneSourceInfo.rootUrl);
            zkSource.set("sceneFileName", task.sceneSourceInfo.sceneFileName);
            // Textures
            for (let i = 0; i < task.sceneSourceInfo.textureFiles.length; i++) {
                const textureFile = task.sceneSourceInfo.textureFiles[i];
                if (textureFile.textureID && textureFile.fileObjectID && textureFile.url) {
                    const zkSourceTexture = new Zakeke.SceneSourceTexture();
                    zkSourceTexture.set("textureID", textureFile.textureID);
                    zkSourceTexture.set("fileObjectID", textureFile.fileObjectID);
                    zkSourceTexture.set("url", textureFile.url);
                    zkSource.get("textures").push(zkSourceTexture);
                }
            }
            this._zkScene.get("sources").push(zkSource);
        }
    }
    // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
    // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
    // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
    // del file di scena
    loadMeshesFromRemoteFiles_NEW(rootUrl, sceneFileName, onSuccess, onError) {
        if (!this._scene || !this._sceneHelper) {
            if (onError)
                onError("No scene to fill with imported meshes");
            return;
        }
        const scene = this._scene;
        const sceneHelper = this._sceneHelper;
        let url = rootUrl + sceneFileName;
        sceneHelper.importMeshesFromUrlAsync(url, null, undefined).then((meshes) => {
            Logger.info("File imported successfully");
            this.checkSceneEmptyEnvironmentTexture();
            this.refreshEnvironment();
            if (onSuccess)
                onSuccess(meshes);
        }).catch(error => {
            Logger.info("Error loading file");
            if (onError)
                onError(error);
        });
        Logger.info("loading finished");
    }
    // Carica i file provenienti da una sorgente nella scena Babylon JS corrente
    // Ad ogni mesh e ad ogni materiale viene assegnato un identificativo univoco (GUID).
    // Inoltre tutte le mesh vengono inserite in un nuovo gruppo il cui nome deriva da quello
    // del file di scena
    loadMeshesFromRemoteFiles(rootUrl, sceneFileName, onSuccess, onError) {
        if (!this._scene || !this._sceneHelper) {
            if (onError)
                onError("No scene to fill with imported meshes");
            return;
        }
        const scene = this._scene;
        const sceneHelper = this._sceneHelper;
        let name = sceneFileName;
        let idx = sceneFileName.lastIndexOf(".");
        if (idx !== -1)
            name = sceneFileName.substr(0, idx);
        // Recupero gli id dei vecchi material in modo da assegnare i nuovi id solo ai nuovi materiali
        const oldMaterialIDs = this._scene.materials.map(m => m.id);
        // Setting up some GLTF values
        let currentPluginName = undefined;
        BABYLON.GLTFFileLoader.IncrementalLoading = false;
        BABYLON.SceneLoader.OnPluginActivatedObservable.add((plugin) => {
            currentPluginName = plugin.name;
        });
        const loader = new BABYLON.AssetsManager(this._scene);
        const task = loader.addMeshTask("mesh-task", "", rootUrl, sceneFileName);
        task.onSuccess = (t) => {
            Logger.info("task completed successfully");
            const meshes = t.loadedMeshes;
            // creo un gruppo in cui inserire tutte le nuove mesh caricate
            const parent = new BABYLON.Mesh(name, scene);
            parent.id = Zakeke.generateUUID();
            parent.metadata = {
                isRealMesh: true,
                isGroup: true
            };
            meshes.forEach((mesh) => {
                if (!mesh.parent)
                    mesh.parent = parent;
                if (!mesh.material)
                    mesh.material = new BABYLON.StandardMaterial(mesh.name + "Mat", scene);
                mesh.id = Zakeke.generateUUID();
            });
            // imposto l'id a tutti i nuovi materiali
            scene.materials.forEach((material) => {
                if (!_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.arrayContains(oldMaterialIDs, material.id))
                    material.id = Zakeke.generateUUID();
            });
            this.checkSceneEmptyEnvironmentTexture();
            this.refreshEnvironment();
            sceneHelper.adjustCamera(currentPluginName, false, false);
            sceneHelper.setupShaderMaterialsCameraPosition();
            if (onSuccess)
                onSuccess(meshes);
        };
        task.onError = (t, message, exception) => {
            Logger.info("task completed with errors");
            if (onError)
                onError(message);
        };
        loader.onFinish = function () {
            Logger.info("loading finished");
        };
        //loader.loadingUIBackgroundColor = "#2c2b29";
        loader.load();
    }
    // Fine importazione Assets
    // ==============================================================================
    isRealMesh(mesh) {
        if (this._sceneHelper)
            return this._sceneHelper.isRealMesh(mesh);
        return false;
    }
    onMeshChanged(evt) {
        this.updateBoundingBox();
        this.setRenderingNeeded();
    }
    onSubMeshChanged(evt) {
        this.updateBoundingBox();
        this.setRenderingNeeded();
    }
    onMaterialChanged(evt) {
        this.setRenderingNeeded();
    }
    onLightChanged(evt) {
        this.setRenderingNeeded();
    }
    getSceneMeshesByName(name) {
        return this._sceneHelper ? this._sceneHelper.getSceneMeshesByName(name) : [];
    }
    getSceneMeshes() {
        return this._sceneHelper ? this._sceneHelper.getSceneMeshes() : [];
    }
    getMeshesUsingMaterial(materialID) {
        return this._sceneHelper ? this._sceneHelper.getMeshesUsingMaterial(materialID) : [];
    }
    getMeshesMaterials(meshes) {
        return this._sceneHelper ? this._sceneHelper.getMeshesMaterials(meshes) : [];
    }
    getMeshMaterials(mesh) {
        return this._sceneHelper ? this._sceneHelper.getMeshMaterials(mesh) : [];
    }
    getAllMaterials() {
        return this._sceneHelper ? this._sceneHelper.getAllMaterials() : [];
    }
    // restituisce un array di gruppi di materiali
    // ogni gruppo è del tipo MaterialGroup, con proprietà 
    // "group"(nome del gruppo) 
    // "materials"(elenco materiali)
    getGroupedMaterials() {
        const groups = [];
        const hash = {};
        const materials = this.getAllMaterials();
        for (let i = 0; i < materials.length; i++) {
            let material = materials[i];
            if (material.id == "groundMaterial")
                continue;
            const groupName = this.getMaterialGroup(material.id);
            let group = null;
            if (hash.hasOwnProperty(groupName))
                group = hash[groupName];
            else {
                group = new MaterialGroup(groupName);
                groups.push(group);
                hash[groupName] = group;
            }
            if (group)
                group.materials.push(material);
        }
        return groups.sort(function (a, b) {
            var nameA = a.groupName.toLowerCase(), nameB = b.groupName.toLowerCase();
            if (nameA < nameB)
                return -1;
            if (nameA > nameB)
                return 1;
            return 0;
        });
    }
    // Assegna il gruppo ad un array di materiali
    setMaterialsGroup(materialIDs, groupName, fireEvent = true) {
        for (let i = 0; i < materialIDs.length; i++) {
            const materialID = materialIDs[i];
            this.setMaterialGroup(materialID, groupName, fireEvent);
        }
    }
    // Assegna il gruppo ad un singolo materiale
    setMaterialGroup(materialID, groupName, fireEvent = true) {
        if (!this._scene)
            return;
        const material = this._scene.getMaterialByID(materialID);
        if (!material)
            return;
        if (!this._scene.metadata)
            this._scene.metadata = {};
        if (!this._scene.metadata.groups)
            this._scene.metadata.groups = {};
        this._scene.metadata.groups[materialID] = groupName;
        if (fireEvent)
            this.fireMaterialsUpdateEvent();
    }
    // Restituisce il gruppo di un materiale
    getMaterialGroup(materialID) {
        if (this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(materialID)) {
            return this._scene.metadata.groups[materialID];
        }
        return SceneEditor.EmptyGroupName;
    }
    // Elimina il gruppo di un materiale
    removeMaterialGroup(materialID) {
        if (this._scene && this._scene.metadata && this._scene.metadata.groups && this._scene.metadata.groups.hasOwnProperty(materialID)) {
            delete this._scene.metadata.groups[materialID];
            this.fireMaterialsUpdateEvent();
        }
    }
    getMaterialsByGroup(groupName) {
        const materials = [];
        const group = !groupName ? SceneEditor.EmptyGroupName : groupName;
        if (this._scene && this._sceneHelper) {
            this._sceneHelper.getAllMaterials().forEach(material => {
                const materialGroupName = this.getMaterialGroup(material.id);
                if (materialGroupName === group)
                    materials.push(material);
            });
        }
        return materials;
    }
    getGroupCenter(parent) {
        return this._sceneHelper ? this._sceneHelper.getMeshHierarchyCenter(parent) : null;
    }
    getGroupBoundingInfo(parent) {
        let boundingBox = parent.getHierarchyBoundingVectors(true);
        return new BABYLON.BoundingInfo(boundingBox.min, boundingBox.max);
    }
    showHideBoundingBox(show) {
        this._showBoundingBox = show;
        this.updateBoundingBox();
        this.setRenderingNeeded();
    }
    updateBoundingBox() {
        this.deleteBoundingBox();
        if (!this.showBoundingBox)
            return;
        this.createSceneBoundingBox(true);
    }
    deleteBoundingBox() {
        let bbox = this.getSceneBoundingBox();
        if (bbox)
            bbox.dispose();
    }
    setCameraPositionScale(scale) {
        if (this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraPositionScale(scale);
            this._sceneHelper.setCameraPositionScale(scale, true);
            this.setRenderingNeeded();
        }
    }
    setCameraLimitLowerRadius(limit) {
        if (this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraLimitLowerRadius(limit);
            this._sceneHelper.setCameraLimitLowerRadius(limit, true);
            this.setRenderingNeeded();
        }
    }
    setCameraZoomEnabled(enabled) {
        if (this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraZoomEnabled(enabled);
            this._sceneHelper.setZoomEnabled(enabled);
            this.setRenderingNeeded();
        }
    }
    setCameraUseMinZoomPercentage(value) {
        if (this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraUseMinZoomPerc(value);
            this._sceneHelper.setMinZoomPerc(value ? this._zkScene.getCameraMinZoomPerc() : undefined);
            this.setRenderingNeeded();
        }
    }
    setCameraMinZoomPercentage(value) {
        if (this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraMinZoomPerc(value);
            var use = this._zkScene.getCameraUseMinZoomPerc();
            this._sceneHelper.setMinZoomPerc(use ? value : undefined);
            this.setRenderingNeeded();
        }
    }
    setCameraUseMaxZoomPercentage(value) {
        if (this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraUseMaxZoomPerc(value);
            this._sceneHelper.setMaxZoomPerc(value ? this._zkScene.getCameraMaxZoomPerc() : undefined);
            this.setRenderingNeeded();
        }
    }
    setCameraMaxZoomPercentage(value) {
        if (this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraMaxZoomPerc(value);
            const use = this._zkScene.getCameraUseMaxZoomPerc();
            this._sceneHelper.setMaxZoomPerc(use ? value : undefined);
            this.setRenderingNeeded();
        }
    }
    lockCameraAlphaAngle() {
        if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            const angle = this._camera.alpha;
            this._zkScene.setCameraLowerAlphaLimit(angle);
            this._zkScene.setCameraUpperAlphaLimit(angle);
            this._sceneHelper.setCameraAlphaLimits(angle, angle);
            this.setRenderingNeeded();
        }
    }
    unlockCameraAlphaAngle() {
        if (this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraLowerAlphaLimit(null);
            this._zkScene.setCameraUpperAlphaLimit(null);
            this._sceneHelper.setCameraAlphaLimits(null, null);
            this.setRenderingNeeded();
        }
    }
    lockCameraBetaAngle() {
        if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            var angle = this._camera.beta;
            this._zkScene.setCameraLowerBetaLimit(angle);
            this._zkScene.setCameraUpperBetaLimit(angle);
            this._sceneHelper.setCameraBetaLimits(angle, angle);
            this.setRenderingNeeded();
        }
    }
    unlockCameraBetaAngle() {
        if (this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraLowerBetaLimit(null);
            this._zkScene.setCameraUpperBetaLimit(null);
            this._sceneHelper.setCameraBetaLimits(null, null);
            this.setRenderingNeeded();
        }
    }
    setCameraLowerAlphaLimit() {
        if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            const angle = this._camera.alpha;
            this._zkScene.setCameraLowerAlphaLimit(angle);
            this._sceneHelper.setCameraLowerAlphaLimit(angle);
            this.setRenderingNeeded();
        }
    }
    unsetCameraLowerAlphaLimit() {
        if (this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraLowerAlphaLimit(null);
            this._sceneHelper.setCameraLowerAlphaLimit(null);
            this.setRenderingNeeded();
        }
    }
    setCameraUpperAlphaLimit() {
        if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            var angle = this._camera.alpha;
            this._zkScene.setCameraUpperAlphaLimit(angle);
            this._sceneHelper.setCameraUpperAlphaLimit(angle);
            this.setRenderingNeeded();
        }
    }
    unsetCameraUpperAlphaLimit() {
        if (this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraUpperAlphaLimit(null);
            this._sceneHelper.setCameraUpperAlphaLimit(null);
            this.setRenderingNeeded();
        }
    }
    setCameraLowerBetaLimit() {
        if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            const angle = this._camera.beta;
            this._zkScene.setCameraLowerBetaLimit(angle);
            this._sceneHelper.setCameraLowerBetaLimit(angle);
            this.setRenderingNeeded();
        }
    }
    unsetCameraLowerBetaLimit() {
        if (this._zkScene && this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraLowerBetaLimit(null);
            this._sceneHelper.setCameraLowerBetaLimit(null);
            this.setRenderingNeeded();
        }
    }
    setCameraUpperBetaLimit() {
        if (this._zkScene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            const angle = this._camera.beta;
            this._zkScene.setCameraUpperBetaLimit(angle);
            this._sceneHelper.setCameraUpperBetaLimit(angle);
            this.setRenderingNeeded();
        }
    }
    unsetCameraUpperBetaLimit() {
        if (this._zkScene && this._sceneHelper) {
            this._zkScene.setCameraUpperBetaLimit(null);
            this._sceneHelper.setCameraUpperBetaLimit(null);
            this.setRenderingNeeded();
        }
    }
    // Mesh selection overrides (the selection logic si a little bit different
    // respect the parent SceneViewer one)
    selectMesh(id) {
        this.selectUnselectMesh(id, true);
    }
    unselectMesh(id) {
        this.selectUnselectMesh(id, false);
    }
    unselectAllMeshes() {
        if (this._scene)
            this._scene.meshes.forEach(mesh => this.unselectSingleMesh(mesh));
    }
    selectUnselectMesh(id, select) {
        if (this._scene) {
            this.deleteBoundingBox();
            this.unselectAllMeshes();
            if (select) {
                const selectWithChildren = (parent) => {
                    this.selectSingleMesh(parent);
                    parent.getChildMeshes().forEach(child => selectWithChildren(child));
                };
                const mesh = this._scene.getMeshByID(id);
                if (mesh)
                    selectWithChildren(mesh);
                this.setManipulatedNode(mesh);
            }
            else {
                this.setManipulatedNode(null);
            }
            this.fireSelectionChangedEvent();
        }
    }
    selectSingleMesh(mesh) {
        mesh["selected"] = true;
        this.highlightMesh(mesh, true);
        this.setRenderingNeeded();
    }
    unselectSingleMesh(mesh) {
        mesh["selected"] = false;
        this.highlightMesh(mesh, false);
        this.setRenderingNeeded();
    }
    isMeshSelected(mesh) {
        return mesh && mesh["selected"] != undefined && mesh["selected"];
    }
    // Show-hide mesh methods
    showMesh(meshID) {
        this.resetRealVisibility();
        this.showHideMesh(meshID, true, true);
    }
    hideMesh(meshID) {
        this.resetRealVisibility();
        this.showHideMesh(meshID, false, true);
    }
    showHideMesh(meshID, show, notifyChanges = true) {
        var _a;
        if (this._scene && this._sceneHelper && this._camera) {
            const scene = this._scene;
            const sceneHelper = this._sceneHelper;
            const camera = this._camera;
            const showHideWithChildren = (parent, show) => {
                parent.isVisible = show;
                Logger.info(parent.name);
                parent.getChildMeshes().forEach(child => showHideWithChildren(child, show));
            };
            const showHide = (mesh, show) => {
                showHideWithChildren(mesh, show);
                const tryAdjustCamera = !(sceneHelper && camera && mesh.metadata && mesh.metadata.isGroup && mesh.getChildMeshes().length === 0);
                if (tryAdjustCamera && show && !camera.isCompletelyInFrustum(mesh)) {
                    sceneHelper.adjustCamera(undefined, false, false);
                    sceneHelper.setupShaderMaterialsCameraPosition();
                }
                if (notifyChanges)
                    this.fireMeshesUpdateEvent();
                this.setRenderingNeeded();
            };
            const mesh = this._scene.getMeshByID(meshID);
            if (mesh) {
                const rootUrl = (_a = this._zkScene) === null || _a === void 0 ? void 0 : _a.get("rootUrl");
                if (rootUrl) {
                    sceneHelper.unsetMeshDummyMaterialAsync(mesh, rootUrl, true).then(() => showHide(mesh, show));
                }
                else {
                    showHide(mesh, show);
                }
            }
            this.refreshInfoPoints();
        }
    }
    // Permette di mostrare esclusivamente la mesh selezionata (e i suoi figli)
    // Lo stato precedente delle mesh viene memorizzato in modo da poter essere
    // ripristinato con la funzione resetRealVisibility
    setTemporaryExclusivelyVisible(meshID) {
        if (this._scene) {
            // Salvo la reale visibilità delle mesh
            this.resetRealVisibility();
            this._realMeshVisibility = {};
            this._scene.meshes.forEach(mesh => {
                this._realMeshVisibility[mesh.id] = mesh.isVisible;
                if (this.isRealMesh(mesh))
                    mesh.isVisible = false;
            });
            this.showHideMesh(meshID, true, false);
        }
    }
    // Reimposto lo stato di visibilità come era precedentemente alla chiamata
    // a setTempraryExclusiveVisible
    resetRealVisibility() {
        if (this._scene && this._sceneHelper && this._realMeshVisibility) {
            const meshes = this._sceneHelper.getSceneMeshes();
            meshes.forEach(mesh => {
                if (this._realMeshVisibility.hasOwnProperty(mesh.id)) {
                    mesh.isVisible = this._realMeshVisibility[mesh.id];
                }
            });
            /*
            this._scene.meshes.forEach(mesh => mesh.isVisible = this._realMeshVisibility[mesh.id]);
            this._realMeshVisibility = {};
            */
            this.setRenderingNeeded();
        }
    }
    // Funzione per modificare il colore di un materiale in modo progressivo (tramite animazione)
    changeMaterialColor(material, propertyName, nextColor) {
        if (this._sceneHelper)
            this._sceneHelper.changeMaterialColor(material, propertyName, nextColor);
    }
    renameMesh(id, name) {
        if (this._scene) {
            const mesh = this._scene.getMeshByID(id);
            if (mesh) {
                mesh.name = name;
                this.fireMeshesUpdateEvent();
            }
        }
    }
    //#region Events
    // PreUpdateEvent
    firePreUpdateEvent() {
        this._preUpdateListeners.forEach(handler => handler());
    }
    addPreUpdateListener(listenerFunction) {
        this._preUpdateListeners.push(listenerFunction);
    }
    removePreUpdateListener(listenerFunction) {
        for (let i = 0; i < this._preUpdateListeners.length; i++) {
            const listener = this._preUpdateListeners[i];
            if (listener == listenerFunction) {
                this._preUpdateListeners.splice(i--, 1);
                break;
            }
        }
    }
    // PostUpdateEvent
    firePostUpdateEvent() {
        this._postUpdateListeners.forEach(handler => handler());
    }
    addPostUpdateListener(listenerFunction) {
        this._postUpdateListeners.push(listenerFunction);
    }
    removePostUpdateListener(listenerFunction) {
        for (let i = 0; i < this._postUpdateListeners.length; i++) {
            const listener = this._postUpdateListeners[i];
            if (listener == listenerFunction) {
                this._postUpdateListeners.splice(i--, 1);
                break;
            }
        }
    }
    // MeshSelected
    fireMeshSelectedEvent(e) {
        this._meshSelectedListeners.forEach(handler => handler(e));
    }
    addMeshSelectedListener(listenerFunction) {
        this._meshSelectedListeners.push(listenerFunction);
    }
    // SelectionChanged
    fireSelectionChangedEvent() {
        this._selectionChangedListeners.forEach(handler => handler());
    }
    addSelectionChangedListener(listenerFunction) {
        this._selectionChangedListeners.push(listenerFunction);
    }
    // LightsSelected
    fireLightSelectedEvent(e) {
        this._lightSelectedListeners.forEach(handler => handler(e));
    }
    addLightSelectedListener(listenerFunction) {
        this._lightSelectedListeners.push(listenerFunction);
    }
    // SceneCreated
    fireSceneCreatedEvent() {
        this._sceneCreatedListeners.forEach(handler => handler());
    }
    addSceneCreatedListener(listenerFunction) {
        this._sceneCreatedListeners.push(listenerFunction);
    }
    // CameraLocationCreated
    fireCameraLocationCreatedEvent(e) {
        this._cameraLocationCreatedListeners.forEach(handler => handler(e));
    }
    addCameraLocationCreatedListener(listenerFunction) {
        this._cameraLocationCreatedListeners.push(listenerFunction);
    }
    // CameraLocationsUpdate
    fireCameraLocationsUpdateEvent(locations) {
        if (!locations && this._scene)
            locations = this.getAllCameraLocations();
        if (!locations)
            throw "Failed firing positions update event: lights are null and no scene present";
        this._cameraLocationsUpdateListeners.forEach(handler => handler(locations));
    }
    addCameraLocationsUpdateListener(listenerFunction) {
        this._cameraLocationsUpdateListeners.push(listenerFunction);
    }
    // SceneSourceTaskSuccess
    fireSceneSourceTaskSuccessEvent(meshes) {
        this._sceneSourceTaskSuccessListeners.forEach(handler => handler(meshes));
    }
    addSceneSourceTaskSuccessListener(listenerFunction) {
        this._sceneSourceTaskSuccessListeners.push(listenerFunction);
    }
    // SceneSourceTaskError
    fireSceneSourceTaskErrorEvent(taskID) {
        this._sceneSourceTaskErrorListeners.forEach(handler => handler(taskID));
    }
    addSceneSourceTaskErrorListener(listenerFunction) {
        this._sceneSourceTaskErrorListeners.push(listenerFunction);
    }
    removeSceneSourceTaskErrorListener(listenerFunction) {
        const idx = this._sceneSourceTaskErrorListeners.indexOf(listenerFunction);
        if (idx != -1)
            this._sceneSourceTaskErrorListeners.splice(idx, 1);
    }
    // SceneSourceTaskCheck
    fireSceneSourceTaskCheckEvent() {
        this._sceneSourceTasksCheckListeners.forEach(handler => handler());
    }
    addSceneSourceTaskCheckListener(listenerFunction) {
        this._sceneSourceTasksCheckListeners.push(listenerFunction);
    }
    // MeshesUpdate
    fireMeshesUpdateEvent(meshes) {
        if (!meshes && this._scene)
            meshes = this.getSceneMeshes();
        if (!meshes)
            throw "Failed firing mesh update event: meshes are null and no scene present";
        this._meshesUpdateListeners.forEach(handler => handler(meshes));
    }
    addMeshesUpdateListener(listenerFunction) {
        this._meshesUpdateListeners.push(listenerFunction);
    }
    // MaterialsUpdate
    fireMaterialsUpdateEvent(materials) {
        if (!materials && this._scene)
            materials = this.getGroupedMaterials();
        if (!materials)
            throw "Failed firing materials update event: materials are null and no scene present";
        this._materialsUpdateListeners.forEach(handler => handler(materials));
    }
    addMaterialsUpdateListener(listenerFunction) {
        this._materialsUpdateListeners.push(listenerFunction);
    }
    // LighsUpdate
    fireLightsUpdateEvent(lights) {
        if (!lights && this._scene)
            lights = this.getAllLights();
        if (!lights)
            throw "Failed firing lights update event: lights are null and no scene present";
        this._lightsUpdateListeners.forEach(handler => handler(lights));
    }
    addLightsUpdateListener(listernerFunction) {
        this._lightsUpdateListeners.push(listernerFunction);
    }
    // MeshLocationCreated
    fireMeshLocationCreatedEvent(location) {
        this._meshLocationCreatedListeners.forEach(handler => handler(location));
    }
    addMeshLocationCreatedListener(listenerFunction) {
        this._meshLocationCreatedListeners.push(listenerFunction);
    }
    // MeshLocationsUpdate
    fireMeshLocationsUpdateEvent(locations) {
        if (!locations && this._scene)
            locations = this.getAllMeshLocations();
        if (locations)
            this._meshLocationsUpdateListeners.forEach(handler => handler(locations));
        else
            throw "Failed firing mesh positions update event: positions are null and no scene present";
    }
    addMeshLocatonsUpdateListener(listenerFunction) {
        this._meshLocationsUpdateListeners.push(listenerFunction);
    }
    // ArTaskSuccess
    fireArTaskSuccessEvent() {
        this._arTaskSuccessListeners.forEach(handler => handler());
    }
    addArTaskSuccessListener(listenerFunction) {
        this._arTaskSuccessListeners.push(listenerFunction);
    }
    // ArTaskError
    fireArTaskErrorEvent() {
        this._arTaskErrorListeners.forEach(handler => handler());
    }
    addArTaskErrorListener(listenerFunction) {
        this._arTaskErrorListeners.push(listenerFunction);
    }
    // ArTaskCheck
    fireArTaskCheckEvent() {
        this._arTasksCheckListeners.forEach(handler => handler());
    }
    addArTaskCheckListener(listenerFunction) {
        this._arTasksCheckListeners.push(listenerFunction);
    }
    // Clear
    clearListeners() {
        this._meshSelectedListeners = [];
        this._selectionChangedListeners = [];
        this._lightSelectedListeners = [];
        this._sceneCreatedListeners = [];
        this._cameraLocationCreatedListeners = [];
        this._sceneSourceTaskSuccessListeners = [];
        this._sceneSourceTaskErrorListeners = [];
        this._sceneSourceTasksCheckListeners = [];
        this._meshesUpdateListeners = [];
        this._materialsUpdateListeners = [];
        this._lightsUpdateListeners = [];
        this._cameraLocationsUpdateListeners = [];
        this._meshLocationCreatedListeners = [];
        this._meshLocationsUpdateListeners = [];
        this._arTaskSuccessListeners = [];
        this._arTaskErrorListeners = [];
        this._arTasksCheckListeners = [];
    }
    //#endregion
    //#region Interazione utente (Pointer Down/Move)
    onPointerDown(evt, pickInfo) {
        if (!this._scene || !this._sceneHelper || this._envMode != _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor) {
            return;
        }
        if (this._selectOnPick) {
            if (pickInfo && pickInfo.hit && pickInfo.pickedMesh && pickInfo.pickedMesh !== this._ground) {
                this.selectMesh(pickInfo.pickedMesh.id);
                const screenPoint = this.convertSceneToScreenPoint(this._scene.pointerX, this._scene.pointerY);
                if (screenPoint) {
                    const event = {
                        name: pickInfo.pickedMesh.name,
                        id: pickInfo.pickedMesh.id,
                        scenePointerX: this._scene.pointerX,
                        scenePointerY: this._scene.pointerY,
                        screenPointerX: screenPoint.X,
                        screenPointerY: screenPoint.Y
                    };
                    this.fireMeshSelectedEvent(event);
                }
            }
        }
    }
    onPointerMove(evt, pickInfo) {
        if (!this._scene || !this._sceneHelper || this._envMode != _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor)
            return;
        this.highlightMeshOver(false);
        if (!this._highlightOver) {
            this._meshOver = null;
            return;
        }
        const info = this._scene.pick(this._scene.pointerX, this._scene.pointerY);
        if (info && info.hit && info.pickedMesh && this._sceneHelper.isRealMesh(info.pickedMesh)) {
            this._meshOver = info.pickedMesh;
            this.highlightMeshOver(true);
        }
    }
    //#endregion
    //#region Element Selection
    getSubMesh(mesh, submeshIdx) {
        if (this._sceneHelper)
            return this._sceneHelper.getSubMesh(mesh, submeshIdx);
        return null;
    }
    getLightByID(id) {
        if (this._scene)
            return this._scene.getLightByID(id);
        return null;
    }
    //#endregion
    //#region Apply material
    applyMaterialByName(name, mesh) {
        if (this._sceneHelper)
            this._sceneHelper.applyMaterialByName(name, mesh);
    }
    applyMaterial(material, mesh) {
        if (this._sceneHelper) {
            this._sceneHelper.applyMaterial(material, mesh);
            this.setLongRenderingNeeded();
        }
    }
    applyMaterialToSubMeshByName(name, mesh, subMesh) {
        if (this._sceneHelper)
            this._sceneHelper.applyMaterialToSubMeshByName(name, mesh, subMesh);
    }
    applyMaterialToSubMesh(material, mesh, subMesh) {
        if (this._sceneHelper)
            this._sceneHelper.applyMaterialToSubMesh(material, mesh, subMesh);
    }
    resetMeshMaterial(mesh, initial) {
        const hash = initial ? this._initialMeshMaterials : this._lastMeshMaterials;
        const resetWithChildren = (parent) => {
            if (parent.subMeshes && parent.subMeshes.length > 0 && parent.material && parent.material instanceof BABYLON.MultiMaterial) {
                for (let i = 0; i < parent.subMeshes.length; i++) {
                    let subMesh = parent.subMeshes[i];
                    this.resetSubMeshMaterial(parent, subMesh, initial);
                }
            }
            else {
                if (hash.hasOwnProperty(parent.id)) {
                    const materialID = hash[parent.id];
                    if (materialID) {
                        const material = this.getMaterialByID(materialID);
                        if (material)
                            parent.material = material;
                    }
                }
            }
            parent.getChildMeshes().forEach(child => resetWithChildren(child));
        };
    }
    resetSubMeshMaterial(mesh, subMesh, initial) {
        const hash = initial ? this._initialSubMeshMaterials : this._lastSubMeshMaterials;
        if (mesh && subMesh && mesh.material instanceof BABYLON.MultiMaterial) {
            const idx = subMesh.materialIndex;
            if (idx >= 0 && idx < mesh.material.subMaterials.length) {
                const key = `${mesh.id}_${idx}`;
                if (hash.hasOwnProperty(key)) {
                    const materialID = hash[key];
                    const material = this.getMaterialByID(materialID);
                    if (material)
                        mesh.material.subMaterials[idx] = material;
                }
            }
        }
        this.setRenderingNeeded();
    }
    //#endregion
    getExtension(name) {
        var idx = name.lastIndexOf(".");
        if (idx !== -1) {
            var ext = name.substring(idx).toLowerCase();
            return ext;
        }
    }
    //#region Caricamento texture da file esterni
    loadMobileTextureFilesAsync(filesToLoad, material, type) {
        return new Promise((resolve, reject) => {
            this.loadMobileTextureFiles(filesToLoad, material, type, () => resolve(), (reason) => reject());
        });
    }
    loadMobileTextureFiles(filesToLoad, material, type, onSuccess, onError) {
        const isCubemap = (filesToLoad.length === 6 || this.getExtension(filesToLoad[0].name) === ".dds" || this.getExtension(filesToLoad[0].name) === ".hdr" || this.getExtension(filesToLoad[0].name) === ".env" || this.getExtension(filesToLoad[0].name) === ".basis");
        this.uploadTextureFiles(filesToLoad, material, type, (zkSceneTextures) => {
            if (zkSceneTextures.length > 0) {
                if (isCubemap)
                    this.setMobileCubeTextureImages(zkSceneTextures, material, type);
                else
                    this.setMobileTextureImage(zkSceneTextures[0], material, type);
            }
            if (onSuccess)
                onSuccess();
        }, onError, false);
    }
    loadTextureFilesAsync(filesToLoad, material, type) {
        return new Promise((resolve, reject) => {
            this.loadTextureFiles(filesToLoad, material, type, () => resolve(), (reason) => reject(reason));
        });
    }
    // Per il caso di texture di ambiente si suppone che material sia null e che type sia
    // uno di "environment", "skybox", "ground"
    loadTextureFiles(filesToLoad, material, type, onSuccess, onError) {
        const isCubemap = (filesToLoad.length === 6 || this.getExtension(filesToLoad[0].name) === ".dds" || this.getExtension(filesToLoad[0].name) === ".hdr" || this.getExtension(filesToLoad[0].name) === ".env" || this.getExtension(filesToLoad[0].name) === ".basis");
        this.uploadTextureFiles(filesToLoad, material, type, (zkSceneTextures) => __awaiter(this, void 0, void 0, function* () {
            if (zkSceneTextures.length > 0) {
                if (isCubemap)
                    yield this.setCubeTextureImages(zkSceneTextures, material, type);
                else {
                    yield this.setTextureImage(zkSceneTextures[0], material, type);
                    if (!material[type + "Texture"].metadata || !material[type + "Texture"].metadata.mobileUrl) {
                        yield new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                            this.uploadTextureFiles(filesToLoad, material, type, (zkSceneTextures) => __awaiter(this, void 0, void 0, function* () {
                                this.setMobileTextureImage(zkSceneTextures[0], material, type);
                                resolve();
                            }), onError, true);
                        }));
                    }
                }
                if (onSuccess) {
                    onSuccess();
                }
            }
        }), onError, false);
    }
    uploadTextureFileAsync(fileToLoad, material) {
        return new Promise((resolve, reject) => {
            if (!this._scene || !this._zkScene || !fileToLoad) {
                resolve(null);
                return;
            }
            const materialID = material ? material.id : Zakeke.getEmptyUUID();
            // Crea l'oggetto backbone relativo alla texture caricata
            const createZkSceneTexture = (data) => {
                if (this._zkScene && data && data.textureID && data.materialID && data.fileObjectID && data.url) {
                    const zkSceneTexture = new Zakeke.SceneTexture();
                    zkSceneTexture.set("textureID", data.textureID);
                    zkSceneTexture.set("materialID", data.materialID);
                    zkSceneTexture.set("fileObjectID", data.fileObjectID);
                    zkSceneTexture.set("url", data.url);
                    this._zkScene.get("textures").push(zkSceneTexture);
                    return zkSceneTexture;
                }
                return null;
            };
            // Upload dei file
            const data = new FormData();
            data.append('file', fileToLoad);
            jQuery.ajax({
                url: this.getTexturesUploadUrl(materialID),
                data: data,
                cache: false,
                contentType: false,
                processData: false,
                type: 'POST',
                success: (data) => __awaiter(this, void 0, void 0, function* () {
                    const zkSceneTextures = [];
                    if (Object.prototype.toString.call(data) === '[object Array]') {
                        const zkSceneTexture = createZkSceneTexture(data[0]);
                        if (zkSceneTexture)
                            resolve(zkSceneTexture);
                        else
                            reject("Immagine non valida");
                    }
                    else
                        reject("Immagine non valida");
                }),
                error: (xhr, textStatus, errorThrown) => {
                    const msg = "An error occurred: " + textStatus + " Error: " + errorThrown;
                    reject(msg);
                }
            });
        });
    }
    uploadTextureFiles(filesToLoad, material, type, onSuccess, onError, resize) {
        if (!this._scene || !this._zkScene || !filesToLoad || filesToLoad.length == 0)
            return;
        const materialID = material ? material.id : Zakeke.getEmptyUUID();
        // Crea l'oggetto backbone relativo alla texture caricata
        const createZkSceneTexture = (data) => {
            if (this._zkScene && data && data.textureID && data.materialID && data.fileObjectID && data.url) {
                const zkSceneTexture = new Zakeke.SceneTexture();
                zkSceneTexture.set("textureID", data.textureID);
                zkSceneTexture.set("materialID", data.materialID);
                zkSceneTexture.set("fileObjectID", data.fileObjectID);
                zkSceneTexture.set("url", data.url);
                this._zkScene.get("textures").push(zkSceneTexture);
                return zkSceneTexture;
            }
            return null;
        };
        // Recupero estensione file
        const getExtension = (name) => {
            const idx = name.lastIndexOf(".");
            if (idx !== -1)
                return name.substring(idx);
            return null;
        };
        // Determina se il nome ha uno dei suffissi standard per le cubmap
        // Le immagini per le cubemap sono 6 e il nome presenta uno dei suffissi "px,py,pz,nx,ny,nz"
        const isCubeImage = (name, suffix) => {
            const idx = name.lastIndexOf(".");
            if (idx !== -1) {
                const nameWithoutExt = name.substring(0, idx);
                return nameWithoutExt.endsWith("_" + suffix);
            }
            return false;
        };
        // Viene identificata come cubemap anche una mappa d'ambiente nel formato dds o hdr
        const firstFileExt = getExtension(filesToLoad[0].name);
        const isCubemap = this.canLoadCubemap(material, type) && (filesToLoad.length == 6 || firstFileExt === ".dds" || firstFileExt === ".hdr" || firstFileExt === ".env" || firstFileExt === ".basis");
        const files = [];
        if (isCubemap && filesToLoad.length == 6) {
            // verfico che ci siano tutte le estensioni accettate dalla cubemap
            const suffixes = ["px", "py", "pz", "nx", "ny", "nz"];
            for (let k = 0; k < filesToLoad.length; k++) {
                const file = filesToLoad[k];
                let lastIdx = -1;
                for (let i = 0; i < suffixes.length; i++) {
                    if (isCubeImage(file.name, suffixes[i])) {
                        files.push(file);
                        lastIdx = i;
                        break;
                    }
                }
                if (lastIdx !== -1)
                    suffixes.splice(lastIdx, 1);
            }
            if (suffixes.length != 0) {
                const msg = "Immagini per la cube map non valide";
                if (onError)
                    onError(msg);
                Logger.info(msg);
                return;
            }
        }
        else {
            // Carico solo la prima selezionata
            files.push(filesToLoad[0]);
        }
        // Upload dei file
        const data = new FormData();
        for (let i = 0; i < files.length; i++) {
            data.append('file-' + i, files[i]);
        }
        jQuery.ajax({
            url: this.getTexturesUploadUrl(materialID) + "?resize=" + resize,
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: (data) => __awaiter(this, void 0, void 0, function* () {
                // Costruisco l'array di Zakeke.SceneTexture
                const zkSceneTextures = [];
                if (Object.prototype.toString.call(data) === '[object Array]') {
                    for (let i = 0; i < data.length; i++) {
                        const zkSceneTexture = createZkSceneTexture(data[i]);
                        if (!zkSceneTexture) {
                            const msg = "Immagini non valide";
                            if (onError) {
                                onError(msg);
                                return;
                            }
                        }
                        if (zkSceneTexture)
                            zkSceneTextures.push(zkSceneTexture);
                    }
                    //if (zkSceneTextures.length > 0) {
                    //    if (isCubemap)
                    //        await this.setCubeTextureImages(zkSceneTextures, material, type);
                    //    else
                    //        await this.setTextureImage(zkSceneTextures[0], material, type);
                    //}
                }
                if (onSuccess)
                    onSuccess(zkSceneTextures);
            }),
            error: (xhr, textStatus, errorThrown) => {
                const msg = "An error occurred: " + textStatus + " Error: " + errorThrown;
                if (onError)
                    onError(msg);
            }
        });
    }
    getTexturesUploadUrl(materialID) {
        if (this._zkScene)
            return this._zkScene.getTexturesUrl(materialID);
        return "";
    }
    removeAllMaterialPhotos(material) {
        if (this._zkScene) {
            const toRemove = [];
            for (let i = 0; i < this._zkScene.get("materialPhotos").length; i++) {
                if (this._zkScene.get("materialPhotos").at(i).get("materialID") === material.id)
                    toRemove.push(this._zkScene.get("materialPhotos").at(i));
            }
            if (toRemove.length > 0)
                this._zkScene.get("materialPhotos").remove(toRemove);
        }
    }
    removeMaterialPhotoAtIndex(material, index) {
        if (this._zkScene) {
            const materialPhotos = [];
            for (let i = 0; i < this._zkScene.get("materialPhotos").length; i++) {
                if (this._zkScene.get("materialPhotos").at(i).get("materialID") === material.id)
                    materialPhotos.push(this._zkScene.get("materialPhotos").at(i));
            }
            if (materialPhotos.length > 0) {
                const materialPhoto = materialPhotos[index];
                this._zkScene.get("materialPhotos").remove(materialPhoto);
            }
        }
    }
    loadMaterialPhotoFiles(filesToLoad, material, onSuccess, onError) {
        this.uploadMaterialPhotoFiles(filesToLoad, material, (zkSceneMaterialPhotos) => {
            this.refreshInfoPoints();
            if (onSuccess)
                onSuccess();
        }, onError);
    }
    uploadMaterialPhotoFiles(filesToLoad, material, onSuccess, onError) {
        if (!this._scene || !this._zkScene || !filesToLoad || filesToLoad.length === 0)
            return;
        const materialID = material.id;
        // Crea l'oggetto backbone relativo alla photo caricata
        const createZkSceneMaterialPhoto = (data) => {
            if (this._zkScene && data && data.photoID && data.materialID && data.fileObjectID && data.url) {
                const zkSceneMaterialPhoto = new Zakeke.SceneMaterialPhoto();
                zkSceneMaterialPhoto.set("photoID", data.photoID);
                zkSceneMaterialPhoto.set("materialID", data.materialID);
                zkSceneMaterialPhoto.set("fileObjectID", data.fileObjectID);
                zkSceneMaterialPhoto.set("url", data.url);
                this._zkScene.get("materialPhotos").push(zkSceneMaterialPhoto);
                return zkSceneMaterialPhoto;
            }
            return null;
        };
        // Recupero estensione file
        const getExtension = (name) => {
            const idx = name.lastIndexOf(".");
            if (idx !== -1)
                return name.substring(idx);
            return null;
        };
        // Upload dei file
        const data = new FormData();
        for (let i = 0; i < filesToLoad.length; i++) {
            const ext = getExtension(filesToLoad[i].name);
            if (ext === ".png" || ext === ".jpg")
                data.append('file-' + i, filesToLoad[i]);
        }
        jQuery.ajax({
            url: this.getMaterialPhotosUploadUrl(materialID),
            data: data,
            cache: false,
            contentType: false,
            processData: false,
            type: 'POST',
            success: (data) => {
                // Costruisco l'array di Zakeke.SceneMaterialPhoto
                const zkSceneMaterialPhotos = [];
                if (Object.prototype.toString.call(data) === '[object Array]') {
                    for (let i = 0; i < data.length; i++) {
                        const zkSceneMaterialPhoto = createZkSceneMaterialPhoto(data[i]);
                        if (!zkSceneMaterialPhoto) {
                            const msg = "Immagini non valide";
                            if (onError) {
                                onError(msg);
                                return;
                            }
                        }
                        if (zkSceneMaterialPhoto)
                            zkSceneMaterialPhotos.push(zkSceneMaterialPhoto);
                    }
                }
                if (onSuccess)
                    onSuccess(zkSceneMaterialPhotos);
            },
            error: (xhr, textStatus, errorThrown) => {
                const msg = "An error occurred: " + textStatus + " Error: " + errorThrown;
                if (onError)
                    onError(msg);
            }
        });
    }
    getMaterialPhotosUploadUrl(materialID) {
        if (this._zkScene)
            return this._zkScene.getMaterialPhotosUrl(materialID);
        return "";
    }
    // Verifica se il material può caricare una cubemap per il tipo di proprietà specificato (type)
    canLoadCubemap(material, type) {
        // Environment
        if (!material)
            return type == "environment" || type == "skybox";
        // Material
        if (material instanceof BABYLON.StandardMaterial &&
            (type == "reflection" || type == "refraction"))
            return true;
        if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
            return type === "environment";
        }
        if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
            return type === "environment";
        }
        if (material instanceof BABYLON.PBRMaterial) {
            return type === "reflection";
        }
        if (material instanceof Zakeke.PBRMaterial) {
            return type === "reflection";
        }
        /*
        if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
            return type == "environment" ||
                type == "normal" ||
                type == "emissive" ||
                type == "occlusion" ||
                type == "base" ||
                type == "metallicRoughness";
        }

        if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
            return type == "environment" ||
                type == "normal" ||
                type == "emissive" ||
                type == "occlusion" ||
                type == "diffuse" ||
                type == "specularGlossiness";
        }

        if (material instanceof BABYLON.PBRMaterial) {
            return type === "albedo" ||
                type === "ambient" ||
                type === "opacity" ||
                type === "reflection" ||
                type === "emissive" ||
                type === "reflectivity" ||
                type === "metallic" ||
                type === "microsurface" ||
                type === "lightmap" ||
                type === "refraction";
        }

        if (material instanceof Zakeke.PBRMaterial) {
            return type === "albedo" ||
                type === "reflection" ||
                type === "matCapReflection" ||
                type === "reflectivity" ||
                type === "microsurface" ||
                type === "ambient" ||
                type === "ao" ||
                type === "opacity";
        }
        */
        if (material instanceof BABYLON.ShaderMaterial)
            return true;
        return false;
    }
    // Aggiorna la configurazione di ambiente impostando l'url di una texture caricata
    setEnvironmentTexture(url, type, extensions, files, onLoad) {
        if (type === "environment") {
            // La mappa d'ambiente di default la imposto direttamente sulla scena
            // in modo che valga sia per la modalità editor che per la modalità viewer
            this.setSceneEnvironmentTexture(url, undefined, extensions, files, onLoad);
            //this.setViewerEnvironmentTexture(url);
        }
        else if (type === "skybox") {
            this.setViewerSkyboxTexture(url, extensions, files);
        }
        else if (type === "ground") {
            this.setViewerGroundTexture(url);
        }
    }
    removeSceneEnvironmentTexture() {
        if (this._scene && this._scene.environmentTexture) {
            this._scene.environmentTexture.dispose();
            this._scene.environmentTexture = null;
            if (this._scene.metadata && this._scene.metadata.environmentTextureRotationY != undefined)
                delete this._scene.metadata.environmentTextureRotationY;
        }
        this.setRenderingNeeded();
    }
    setSceneEnvironmentTextureRotationY(rotationY) {
        if (this._scene && this._scene.environmentTexture &&
            (this._scene.environmentTexture instanceof BABYLON.CubeTexture || this._scene.environmentTexture instanceof BABYLON.HDRCubeTexture)) {
            this._scene.environmentTexture.rotationY = rotationY * Math.PI / 180;
            this.setLongRenderingNeeded();
        }
    }
    // Crea e imposta la singola texture sul materiale per il tipo di proprietà specificato
    setTextureImage(zkSceneTexture, material, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                if (this._scene && zkSceneTexture && zkSceneTexture instanceof Zakeke.SceneTexture) {
                    const url = zkSceneTexture.get("url");
                    if (url) {
                        // Caso environment
                        if (!material) {
                            this.setEnvironmentTexture(url, type);
                        }
                        else {
                            // Crea la texture
                            const oldTexture = this.getMaterialTexture(material, type);
                            let invertY = true;
                            if (oldTexture && oldTexture instanceof BABYLON.Texture)
                                invertY = oldTexture.invertY;
                            const texture = new BABYLON.Texture(url, this._scene, undefined, invertY, undefined, () => this.setRenderingNeeded());
                            if (oldTexture && oldTexture instanceof BABYLON.Texture) {
                                texture.uScale = oldTexture.uScale;
                                texture.vScale = oldTexture.vScale;
                                texture.uOffset = oldTexture.uOffset;
                                texture.vOffset = oldTexture.vOffset;
                                texture.uAng = oldTexture.uAng;
                                texture.vAng = oldTexture.vAng;
                                texture.level = oldTexture.level;
                                texture.coordinatesIndex = oldTexture.coordinatesIndex;
                                texture.coordinatesMode = oldTexture.coordinatesMode;
                                texture.hasAlpha = oldTexture.hasAlpha;
                                texture.wrapU = oldTexture.wrapU;
                                texture.wrapV = oldTexture.wrapV;
                                texture.gammaSpace = oldTexture.gammaSpace;
                            }
                            _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_3__.SceneHelper.whenTextureIsReadyAsync(texture).then(() => {
                                // Applica la texture
                                this.applyTexture(texture, material, type);
                                if (oldTexture && !this.isTextureUsed(oldTexture))
                                    oldTexture.dispose();
                                this.setRenderingNeeded();
                                resolve();
                            });
                        }
                    }
                }
            });
        });
    }
    // Crea la cubemap e la imposta sul materiale e tipo di poprietà specificato
    setCubeTextureImages(zkSceneTextures, material, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise(resolve => {
                if (!this._scene || Object.prototype.toString.call(zkSceneTextures) != '[object Array]')
                    resolve();
                // controllo che si tratti effettivamente di un array di Zakeke.SceneTexture
                for (let i = 0; i < zkSceneTextures.length; i++) {
                    const zkSceneTexture = zkSceneTextures[i];
                    if (!zkSceneTexture || !(zkSceneTexture instanceof Zakeke.SceneTexture))
                        resolve();
                }
                const onImagesLoad = () => this.setLongRenderingNeeded();
                // Crea la texture o aggiorna la configurazione di ambiente
                let texture = null;
                const textureInfo = this.getCubeTextureInfo(zkSceneTextures);
                if (textureInfo.url && this._scene) {
                    if (zkSceneTextures.length === 1) {
                        // Caso environment dds, hdr, env, basis
                        const url = textureInfo.url;
                        if (url) {
                            if (!material) {
                                this.setEnvironmentTexture(url, type);
                            }
                            else {
                                if (url.endsWith(".dds"))
                                    texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene);
                                else if (url.endsWith(".hdr"))
                                    //texture = new BABYLON.HDRCubeTexture(url, this._scene, 512, undefined, undefined, undefined, undefined, onImagesLoad);
                                    texture = new BABYLON.HDRCubeTexture(url, this._scene, 128, undefined, undefined, undefined, undefined, onImagesLoad);
                                else if (url.endsWith(".env")) {
                                    //texture = new BABYLON.CubeTexture(url, this._scene);
                                    //texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene, undefined, undefined);
                                    texture = new BABYLON.CubeTexture(url, this._scene, null, false, null, onImagesLoad, null, undefined, true, undefined, true);
                                    //texture = new BABYLON.CubeTexture(url, this._scene, undefined, undefined, undefined, undefined, onImagesLoad);
                                }
                                else if (url.endsWith(".basis")) {
                                    texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene);
                                }
                            }
                        }
                    }
                    else if (zkSceneTextures.length === 6 && textureInfo.files.length === 6 && textureInfo.extensions.length === 6) {
                        // Caso cubemap px, nx, py, ny, pz, nz
                        if (!material)
                            this.setEnvironmentTexture(textureInfo.url, type, textureInfo.extensions, textureInfo.files, onImagesLoad);
                        else
                            texture = new BABYLON.CubeTexture(textureInfo.url, this._scene, textureInfo.extensions, false, textureInfo.files, onImagesLoad);
                    }
                }
                // Applica la texture
                if (texture) {
                    _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_3__.SceneHelper.whenTextureIsReadyAsync(texture).then(() => {
                        if (material) {
                            const oldTexture = this.getMaterialTexture(material, type);
                            this.applyTexture(texture, material, type);
                            if (oldTexture && !this.isTextureUsed(oldTexture))
                                oldTexture.dispose();
                            this.setRenderingNeeded();
                            resolve();
                        }
                    });
                }
                else {
                    resolve();
                }
            });
        });
    }
    setMobileTextureImage(zkSceneTexture, material, type) {
        if (this._scene && this._sceneHelper) {
            const url = zkSceneTexture.get("url");
            if (url) {
                let texture = null;
                if (!material) {
                    texture = this._scene.environmentTexture;
                }
                else
                    texture = this.getMaterialTexture(material, type);
                if (texture !== null && this._sceneHelper.isTextureWithUrl(texture)) {
                    if (!texture.metadata)
                        texture.metadata = {};
                    texture.metadata.mobileUrl = url;
                }
            }
        }
    }
    setMobileCubeTextureImages(zkSceneTextures, material, type) {
        if (!this._scene || Object.prototype.toString.call(zkSceneTextures) != '[object Array]')
            return;
        // controllo che si tratti effettivamente di un array di Zakeke.SceneTexture
        for (let i = 0; i < zkSceneTextures.length; i++) {
            const zkSceneTexture = zkSceneTextures[i];
            if (!zkSceneTexture || !(zkSceneTexture instanceof Zakeke.SceneTexture))
                return;
        }
        const textureInfo = this.getCubeTextureInfo(zkSceneTextures);
        if (textureInfo.url) {
            let texture = null;
            if (!material)
                texture = this._scene.environmentTexture;
            else
                texture = this.getMaterialTexture(material, type);
            if (texture && texture instanceof BABYLON.CubeTexture) {
                if (!texture.metadata)
                    texture.metadata = {};
                texture.metadata.mobileUrl = textureInfo.url;
                if (textureInfo.files.length === 6) {
                    texture.metadata.mobileFiles = textureInfo.files;
                    texture.metadata.mobileExtensions = textureInfo.extensions;
                }
            }
        }
    }
    // Costruisce l'url della cubemap da utilizzare per la costruzione della texture di Babylon JS
    // Nel caso di cubemap con 6 immagini (_px _nx...), restituisce l'url senza il suffisso
    getCubeTextureInfo(zkSceneTextures) {
        const textureInfo = {
            url: null,
            files: [],
            extensions: []
        };
        if (zkSceneTextures.length === 1) {
            // Caso mappa d'ambiente (dds, hdr o basis)
            textureInfo.url = zkSceneTextures[0].get("url") || null;
        }
        else if (zkSceneTextures.length === 6) {
            // Caso cubemap composta da sei immagini
            const suffixes = ["px", "py", "pz", "nx", "ny", "nz"];
            let rootUrl = null;
            const files = [];
            const extensions = [];
            const containsPrefix = (name, suffix) => {
                const idx = name.lastIndexOf(".");
                if (idx !== -1) {
                    const nameWithoutExt = name.substring(0, idx);
                    return nameWithoutExt.endsWith("_" + suffix);
                }
                return false;
            };
            const getRootUrl = (url, suffix) => {
                const idx = url.lastIndexOf(".");
                if (idx !== -1) {
                    const nameWithoutExt = url.substring(0, idx);
                    if (nameWithoutExt.endsWith("_" + suffix)) {
                        const rootUrl = nameWithoutExt.substring(0, nameWithoutExt.length - ("_" + suffix).length);
                        return rootUrl;
                    }
                }
                return null;
            };
            const getFileExtension = (url, suffix) => {
                const idx = url.lastIndexOf("_" + suffix);
                if (idx !== -1) {
                    return url.substr(idx);
                }
                return null;
            };
            for (let i = 0; i < suffixes.length; i++) {
                const suffix = suffixes[i];
                for (let k = 0; k < zkSceneTextures.length; k++) {
                    const url = zkSceneTextures[k].get("url");
                    if (url) {
                        if (containsPrefix(url, suffix)) {
                            files.push(url);
                            const ext = getFileExtension(url, suffix);
                            if (ext)
                                extensions.push(ext);
                            if (!rootUrl)
                                rootUrl = getRootUrl(url, suffix);
                            break;
                        }
                    }
                }
            }
            textureInfo.url = rootUrl;
            textureInfo.files = files;
            textureInfo.extensions = extensions;
        }
        return textureInfo;
    }
    isTextureUsed(texture) {
        if (this._scene && texture) {
            for (let i = 0; i < this._scene.materials.length; i++) {
                const material = this._scene.materials[i];
                const textures = material.getActiveTextures();
                for (let j = 0; j < textures.length; j++) {
                    const matTexture = textures[j];
                    if (matTexture.uid === texture.uid)
                        return true;
                }
            }
        }
        return false;
    }
    changeTextureInvertYAsync(material, type, invertY) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._scene && this._sceneHelper) {
                var oldTexture = this._sceneHelper.getMaterialTexture(material, type);
                if (oldTexture && oldTexture instanceof BABYLON.Texture && oldTexture.invertY != invertY) {
                    // Costruisco una nuova texture passando il giusto parametro nel costruttore
                    let url = oldTexture.url;
                    if (url) {
                        let absoluteUrl = url;
                        const isAbsolute = /^(?:\/|[a-z]+:\/\/)/.test(url);
                        if (!isAbsolute) {
                            var rootUrl = yield this.getSceneRootUrl();
                            if (rootUrl) {
                                absoluteUrl = rootUrl + url;
                            }
                        }
                        const texture = new BABYLON.Texture(absoluteUrl, this._scene, undefined, invertY, undefined, () => this.setRenderingNeeded());
                        if (oldTexture && oldTexture instanceof BABYLON.Texture) {
                            texture.uScale = oldTexture.uScale;
                            texture.vScale = oldTexture.vScale;
                            texture.uOffset = oldTexture.uOffset;
                            texture.vOffset = oldTexture.vOffset;
                            texture.uAng = oldTexture.uAng;
                            texture.vAng = oldTexture.vAng;
                            texture.level = oldTexture.level;
                            texture.coordinatesIndex = oldTexture.coordinatesIndex;
                            texture.coordinatesMode = oldTexture.coordinatesMode;
                            texture.hasAlpha = oldTexture.hasAlpha;
                            texture.wrapU = oldTexture.wrapU;
                            texture.wrapV = oldTexture.wrapV;
                            texture.gammaSpace = oldTexture.gammaSpace;
                        }
                        yield _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_3__.SceneHelper.whenTextureIsReadyAsync(texture);
                        this.applyTexture(texture, material, type);
                        if (oldTexture && !this.isTextureUsed(oldTexture))
                            oldTexture.dispose();
                        this.setRenderingNeeded();
                    }
                }
            }
        });
    }
    applyTextureByName(name, material, type) {
        if (this._scene) {
            const texture = this._scene.textures.find(t => t.name === name);
            if (texture)
                this.applyTexture(texture, material, type);
        }
    }
    applyTexture(texture, material, type) {
        // Lightmap always on second channel
        if (texture && type == "lightmap") {
            texture.coordinatesIndex = 1;
            if (material instanceof BABYLON.StandardMaterial ||
                material instanceof BABYLON.PBRMaterial ||
                material instanceof BABYLON.PBRBaseSimpleMaterial)
                material.useLightmapAsShadowmap = true;
        }
        // Verificare nome proprietà dinamica
        if (material instanceof BABYLON.StandardMaterial) {
            switch (type) {
                case "diffuse":
                    material.diffuseTexture = texture;
                    break;
                case "emissive":
                    material.emissiveTexture = texture;
                    break;
                case "ambient":
                    material.ambientTexture = texture;
                    break;
                case "lightmap":
                    material.lightmapTexture = texture;
                    break;
                case "opacity":
                    material.opacityTexture = texture;
                    break;
                case "specular":
                    material.specularTexture = texture;
                    break;
                case "reflection":
                    material.reflectionTexture = texture;
                    break;
                case "refraction":
                    material.refractionTexture = texture;
                    break;
                case "bump":
                    material.bumpTexture = texture;
                    break;
            }
        }
        else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
            switch (type) {
                /*
                case "environment":
                    material.environmentTexture = texture;
                    break;
                case "normal":
                    material.normalTexture = texture;
                    break;
                case "emissive":
                    material.emissiveTexture = texture;
                    break;
                case "occlusion":
                    material.occlusionTexture = texture;
                    break;
                case "base":
                    material.baseTexture = texture;
                    break;
                case "metallicRoughness":
                    material.metallicRoughnessTexture = texture;
                    break;
                */
                case "environment":
                case "normal":
                case "emissive":
                case "occlusion":
                case "base":
                case "metallicRoughness":
                    material[`${type}Texture`] = texture;
                    break;
            }
        }
        else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
            switch (type) {
                /*
                case "environment":
                    material.environmentTexture = texture;
                    break;
                case "normal":
                    material.normalTexture = texture;
                    break;
                case "emissive":
                    material.emissiveTexture = texture;
                    break;
                case "occlusion":
                    material.occlusionTexture = texture;
                    break;
                case "diffuse":
                    material.diffuseTexture = texture;
                    break;
                case "specularGlossiness":
                    material.specularGlossinessTexture = texture;
                    break;
                */
                case "environment":
                case "normal":
                case "emissive":
                case "occlusion":
                case "diffuse":
                case "specularGlossiness":
                    material[`${type}Texture`] = texture;
                    break;
            }
        }
        else if (material instanceof BABYLON.PBRMaterial) {
            switch (type) {
                case "cameraColorGrading":
                    material.cameraColorGradingTexture = texture;
                    break;
                /*
                case "albedo":
                    material.albedoTexture = texture;
                    break;
                case "ambient":
                    material.ambientTexture = texture;
                    break;
                case "opacity":
                    material.opacityTexture = texture;
                    break;
                case "reflection":
                    material.reflectionTexture = texture;
                    break;
                case "emissive":
                    material.emissiveTexture = texture;
                    break;
                case "reflectivity":
                    material.reflectivityTexture = texture;
                    break;
                case "metallic":
                    material.metallicTexture = texture;
                    break;
                case "microSurface":
                    material.microSurfaceTexture = texture;
                    break;
                case "bump":
                    material.bumpTexture = texture;
                    break;
                case "lightmap":
                    material.lightmapTexture = texture;
                    break;
                */
                case "albedo":
                case "ambient":
                case "opacity":
                case "reflection":
                case "emissive":
                case "reflectivity":
                case "metallic":
                case "microSurface":
                case "bump":
                case "lightmap":
                    material[`${type}Texture`] = texture;
                    break;
                case "refraction":
                    material.refractionTexture = texture;
                    break;
                case "environmentBRDF":
                    material.environmentBRDFTexture = texture;
                    break;
                case "clearCoat_texture":
                    material.clearCoat.texture = texture;
                    break;
                case "clearCoat_bump":
                    material.clearCoat.bumpTexture = texture;
                    break;
                case "clearCoat_tint":
                    material.clearCoat.tintTexture = texture;
                    break;
                case "clearCoat_textureRoughness":
                    material.clearCoat.textureRoughness = texture;
                    break;
                case "anisotropy_texture":
                    material.anisotropy.texture = texture;
                    break;
                case "sheen_texture":
                    material.sheen.texture = texture;
                    break;
                case "sheen_textureRoughness":
                    material.sheen.textureRoughness = texture;
                    break;
                case "subSurface_thickness":
                    material.subSurface.thicknessTexture = texture;
                    break;
                case "subSurface_translucencyIntensity":
                    material.subSurface.translucencyIntensityTexture = texture;
                    break;
                case "subSurface_refractionIntensity":
                    material.subSurface.refractionIntensityTexture = texture;
                    break;
            }
        }
        else if (material instanceof BABYLON.ShaderMaterial) {
            if (texture && texture instanceof BABYLON.Texture)
                material.setTexture(type, texture);
            else
                material.removeTexture(type);
        }
        else if (material instanceof Zakeke.PBRMaterial) {
            switch (type) {
                case "albedo":
                    material.albedoTexture = texture;
                    break;
                case "bump":
                    material.bumpTexture = texture;
                    break;
                case "reflection":
                    material.reflectionTexture = texture;
                    break;
                case "matCapReflection":
                    material.matCapReflectionTexture = texture;
                    break;
                case "reflectivity":
                    material.reflectivityTexture = texture;
                    break;
                case "microsurface":
                    material.microsurfaceTexture = texture;
                    break;
                case "ambient":
                    material.ambientTexture = texture;
                    break;
                case "ao":
                    material.aoTexture = texture;
                    break;
                case "opacity":
                    material.opacityTexture = texture;
                    break;
            }
        }
        this.setLongRenderingNeeded();
    }
    getMaterialTexture(material, type) {
        if (material instanceof BABYLON.StandardMaterial) {
            switch (type) {
                case "diffuse":
                    return material.diffuseTexture;
                case "emissive":
                    return material.emissiveTexture;
                case "ambient":
                    return material.ambientTexture;
                case "lightmap":
                    return material.lightmapTexture;
                case "opacity":
                    return material.opacityTexture;
                case "specular":
                    return material.specularTexture;
                case "reflection":
                    return material.reflectionTexture;
                case "refraction":
                    return material.refractionTexture;
                case "bump":
                    return material.bumpTexture;
            }
        }
        else if (material instanceof BABYLON.PBRMetallicRoughnessMaterial) {
            switch (type) {
                case "environment":
                    return material.environmentTexture;
                case "normal":
                    return material.normalTexture;
                case "emissive":
                    return material.emissiveTexture;
                case "occlusion":
                    return material.occlusionTexture;
                case "base":
                    return material.baseTexture;
                case "metallicRoughness":
                    return material.metallicRoughnessTexture;
            }
        }
        else if (material instanceof BABYLON.PBRSpecularGlossinessMaterial) {
            switch (type) {
                case "environment":
                    return material.environmentTexture;
                case "normal":
                    return material.normalTexture;
                case "emissive":
                    return material.emissiveTexture;
                case "occlusion":
                    return material.occlusionTexture;
                case "diffuse":
                    return material.diffuseTexture;
                case "specularGlossiness":
                    return material.specularGlossinessTexture;
            }
        }
        else if (material instanceof BABYLON.PBRMaterial) {
            switch (type) {
                case "cameraColorGrading":
                    return material.cameraColorGradingTexture;
                case "albedo":
                    return material.albedoTexture;
                case "ambient":
                    return material.ambientTexture;
                case "opacity":
                    return material.opacityTexture;
                case "reflection":
                    return material.reflectionTexture;
                case "emissive":
                    return material.emissiveTexture;
                case "reflectivity":
                    return material.reflectivityTexture;
                case "metallic":
                    return material.metallicTexture;
                case "microSurface":
                    return material.microSurfaceTexture;
                case "bump":
                    return material.bumpTexture;
                case "lightmap":
                    return material.lightmapTexture;
                case "refraction":
                    return material.refractionTexture;
                case "clearCoat":
                    return material.clearCoat.texture;
                case "clearCoat_bump":
                    return material.clearCoat.bumpTexture;
                case "clearCoat_tint":
                    return material.clearCoat.tintTexture;
                case "clearCoat_textureRoughness":
                    return material.clearCoat.textureRoughness;
                case "clearCoat_texture":
                    return material.clearCoat.texture;
                case "anisotropy_texture":
                    return material.anisotropy.texture;
                case "sheen_texture":
                    return material.sheen.texture;
                case "sheen_textureRoughness":
                    return material.sheen.textureRoughness;
                case "subSurface_thickness":
                    return material.subSurface.thicknessTexture;
                case "subSurface_refractionIntensity":
                    return material.subSurface.refractionIntensityTexture;
                case "subSurface_translucencyIntensity":
                    return material.subSurface.translucencyIntensityTexture;
            }
        }
        else if (material instanceof Zakeke.PBRMaterial) {
            switch (type) {
                case "albedo":
                    return material.albedoTexture;
                case "bump":
                    return material.bumpTexture;
                case "reflection":
                    return material.reflectionTexture;
                case "matCapReflection":
                    return material.matCapReflectionTexture;
                case "reflectivity":
                    return material.reflectivityTexture;
                case "microsurface":
                    return material.microsurfaceTexture;
                case "ambient":
                    return material.ambientTexture;
                case "ao":
                    return material.aoTexture;
                case "opacity":
                    return material.opacityTexture;
            }
        }
        return null;
    }
    removeMaterialTexture(material, type) {
        this.applyTexture(null, material, type);
    }
    removeMaterialMobileTexture(material, type) {
        const texture = this.getMaterialTexture(material, type);
        if (texture && texture.metadata && texture.metadata.mobileUrl) {
            delete texture.metadata.mobileUrl;
            if (texture.metadata.hasOwnProperty("mobileFiles"))
                delete texture.metadata.mobileFiles;
            if (texture.metadata.hasOwnProperty("mobileExtensions"))
                delete texture.metadata.mobileExtensions;
            if (Object.keys(texture.metadata).length === 0 && texture.metadata.constructor === Object)
                delete texture.metadata;
        }
    }
    //#endregion
    //#region Operazioni sugli elementi della scena
    /**
     * Create a group of meshes
     * @param parentId Id of the parent node of the group
     * @param name Name of the group
     * @param children Array of meshes to be included in the group
     */
    createGroup(parentId, name, children) {
        if (this._scene) {
            const group = new BABYLON.Mesh(name, this._scene);
            group.id = Zakeke.generateUUID();
            group.metadata = {
                isRealMesh: true,
                isGroup: true
            };
            if (parentId) {
                const parent = this._scene.getMeshByID(parentId);
                if (parent) {
                    group.parent = parent;
                }
            }
            if (children) {
                children.forEach(m => m.parent = group);
            }
            this.fireMeshesUpdateEvent();
            return group;
        }
        return null;
    }
    deleteMesh(meshID, removeMaterials) {
        const deleted = { meshIDs: [], materialIDs: [] };
        if (this._scene && this._sceneHelper && this._zkScene) {
            const scene = this._scene;
            const sceneHelper = this._sceneHelper;
            const zkScene = this._zkScene;
            const mesh = scene.getMeshByID(meshID);
            if (mesh) {
                const removeMaterialsWithChildren = (parent) => {
                    const materials = this.getMeshMaterials(parent);
                    for (let k = 0; k < materials.length; k++) {
                        // Sometimes, for submeshes for example, we can have an array of nulls
                        const material = materials[k];
                        if (!material)
                            continue;
                        const meshesUsingMaterial = this.getMeshesUsingMaterial(material.id);
                        if (meshesUsingMaterial.length === 1) {
                            if (meshesUsingMaterial.every((meshItem) => sceneHelper.meshHasParent(meshItem.id, mesh.id))) {
                                deleted.materialIDs.push(materials[k].id);
                                materials[k].dispose();
                            }
                        }
                    }
                    // Faccio lo stesso per i figli
                    parent.getChildMeshes().forEach(child => removeMaterialsWithChildren(child));
                };
                if (removeMaterials) {
                    removeMaterialsWithChildren(mesh);
                    this.fireMaterialsUpdateEvent();
                }
                const cameraPivot = sceneHelper.getCameraPivot();
                if (cameraPivot && cameraPivot === mesh) {
                    this.setCameraPivot(null);
                }
                if (this.isMeshSelected(mesh))
                    this.unselectMesh(mesh.id);
                mesh.dispose();
                deleted.meshIDs.push(meshID);
            }
            this.fireMeshesUpdateEvent();
            this.setRenderingNeeded();
            deleted.materialIDs.forEach(materialID => {
                const libraryMaterialID = zkScene.getLibraryShaderMaterialIDForSceneMaterial(materialID);
                if (libraryMaterialID)
                    zkScene.unregisterShaderMaterial(libraryMaterialID);
            });
        }
        return deleted;
    }
    // Cancella tutte le mesh
    deleteAllMeshes() {
        if (this._scene && this._sceneHelper) {
            for (let i = 0; i < this._scene.meshes.length; i++) {
                const mesh = this._scene.meshes[i];
                if (this._sceneHelper.isRealMesh(mesh)) {
                    this._scene.meshes.splice(i--, 1);
                    mesh.dispose();
                }
            }
            this.setCameraPivot(null);
            this.setRenderingNeeded();
        }
    }
    deleteDuplicatedMeshesWithDifferentParent(parentID, removeMaterials) {
        const deleted = { meshIDs: [], materialIDs: [] };
        if (this._scene && this._sceneHelper && this._zkScene) {
            const scene = this._scene;
            const sceneHelper = this._sceneHelper;
            const zkScene = this._zkScene;
            const removeIfDuplicated = (mesh) => {
                const others = this.getSceneMeshesByName(mesh.name);
                let found = false;
                for (let i = 0; i < others.length; i++) {
                    var other = others[i];
                    if (other.id != mesh.id && !sceneHelper.meshHasParent(other.id, parentID)) {
                        // Elimino anche il materiale se la mesh è l'unica ad utilizzarlo
                        if (removeMaterials) {
                            const materials = this.getMeshMaterials(other);
                            for (let k = 0; k < materials.length; k++) {
                                const meshesUsingMaterial = this.getMeshesUsingMaterial(materials[k].id);
                                if (meshesUsingMaterial.length == 1) {
                                    deleted.materialIDs.push(materials[k].id);
                                    materials[k].dispose();
                                }
                            }
                        }
                        deleted.meshIDs.push(other.id);
                        other.dispose();
                        others.splice(i--, 1);
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    mesh.getChildMeshes().forEach(child => removeIfDuplicated(child));
                }
            };
            const parent = scene.getMeshByID(parentID);
            if (parent) {
                parent.getChildMeshes().forEach(child => removeIfDuplicated(child));
            }
            this.setRenderingNeeded();
            deleted.materialIDs.forEach((materialID) => {
                const libraryMaterialID = zkScene.getLibraryShaderMaterialIDForSceneMaterial(materialID);
                if (libraryMaterialID)
                    zkScene.unregisterShaderMaterial(libraryMaterialID);
            });
        }
        return deleted;
    }
    // Cancella tutte le mesh figlie di quella in input 
    // che hanno lo stesso nome di altre mesh con id diverso
    // Questa funzione può essere utile per elminiare oggetti duplicati importati
    // con file diversi
    deleteDuplicatedChildMeshes(parentID, removeMaterials) {
        const deleted = { meshIDs: [], materialIDs: [] };
        if (this._scene && this._sceneHelper && this._zkScene) {
            const scene = this._scene;
            const sceneHelper = this._sceneHelper;
            const zkScene = this._zkScene;
            const removeIfDuplicated = (mesh) => {
                const others = this.getSceneMeshesByName(mesh.name);
                let found = false;
                for (let i = 0; i < others.length; i++) {
                    const other = others[i];
                    if (other.id != mesh.id && !sceneHelper.meshHasParent(other.id, parentID)) {
                        // Elimino anche il materiale se la mesh è l'unica ad utilizzarlo
                        if (removeMaterials) {
                            const materials = this.getMeshMaterials(mesh);
                            for (let k = 0; k < materials.length; k++) {
                                const meshesUsingMaterial = this.getMeshesUsingMaterial(materials[k].id);
                                if (meshesUsingMaterial.length == 1) {
                                    deleted.materialIDs.push(materials[k].id);
                                    materials[k].dispose();
                                }
                            }
                        }
                        deleted.meshIDs.push(mesh.id);
                        mesh.dispose();
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    const childMeshes = mesh.getChildMeshes();
                    for (let i = 0; i < childMeshes.length; i++) {
                        removeIfDuplicated(childMeshes[i]);
                    }
                }
            };
            const parent = scene.getMeshByID(parentID);
            if (parent) {
                parent.getChildMeshes().forEach(child => removeIfDuplicated(child));
            }
            this.setRenderingNeeded();
            deleted.materialIDs.forEach((materialID) => {
                const libraryMaterialID = zkScene.getLibraryShaderMaterialIDForSceneMaterial(materialID);
                if (libraryMaterialID)
                    zkScene.unregisterShaderMaterial(libraryMaterialID);
            });
        }
        return deleted;
    }
    deleteMaterial(materialID) {
        if (this._scene && this._sceneHelper) {
            const material = this._scene.getMaterialByID(materialID);
            if (material) {
                this.deleteMaterialInternal(material);
                this.fireMaterialsUpdateEvent();
                this.setRenderingNeeded();
            }
        }
    }
    deleteMaterialInternal(material) {
        if (this._scene && this._sceneHelper && material) {
            const materialID = material.id;
            if (this._zkScene) {
                const libraryMaterialID = this._zkScene.getLibraryShaderMaterialIDForSceneMaterial(material.id);
                if (libraryMaterialID)
                    this._zkScene.unregisterShaderMaterial(libraryMaterialID);
            }
            const textures = this._sceneHelper.getTexturesExclusivelyForMaterial(material);
            material.dispose();
            for (let i = 0; i < textures.length; i++)
                textures[i].dispose();
            this._sceneHelper.removeSceneMaterialMetadata(materialID);
        }
    }
    deleteAllMaterials() {
        if (this._scene) {
            while (this._scene.materials.length > 0) {
                const material = this._scene.materials.pop();
                if (material)
                    this.deleteMaterialInternal(material);
            }
            this.fireMaterialsUpdateEvent();
            this.setRenderingNeeded();
            this.fireMaterialsUpdateEvent();
        }
    }
    renameMaterial(id, name) {
        if (this._scene) {
            const material = this._scene.getMaterialByID(id);
            if (material)
                material.name = name;
            this.fireMaterialsUpdateEvent();
        }
    }
    cloneMesh(id) {
        let newMesh = null;
        if (this._scene && this._sceneHelper) {
            newMesh = this._sceneHelper.cloneMesh(id, false, false);
            this.setRenderingNeeded();
            this.fireMeshesUpdateEvent();
        }
        return newMesh;
    }
    // Same as clone but with duplicated geometry data too
    duplicateMesh(id, updatable = false) {
        let newMesh = null;
        if (this._scene && this._sceneHelper) {
            newMesh = this._sceneHelper.cloneMesh(id, true, updatable);
            this.setRenderingNeeded();
            this.fireMeshesUpdateEvent();
        }
        return newMesh;
    }
    cloneMaterial(id, newId, newName) {
        let newMaterial = null;
        if (this._scene && this._sceneHelper) {
            const material = this._scene.getMaterialByID(id);
            if (material) {
                const materialName = newName ? newName : material.name + " - clone";
                newMaterial = material.clone(materialName);
                if (newMaterial) {
                    const materialId = newId ? newId : Zakeke.generateUUID();
                    newMaterial.id = materialId;
                    // Verifico se il materiale originario deriva da un materiale di libreria.
                    // Nel caso, devo impostare il mapping in modo da copiare anche le relative textures
                    if (this._zkScene) {
                        const mapping = this._zkScene.getMappingForSceneMaterial(material.id);
                        if (mapping) {
                            var libraryMaterialID = mapping.get("libraryMaterialID");
                            this._zkScene.mapLibraryMaterial(libraryMaterialID, newMaterial.id);
                            const textures = this._sceneHelper.getTexturesForMaterial(newMaterial);
                            for (let i = 0; i < textures.length; i++) {
                                const texture = textures[i];
                                texture["materialMapping"] = { libraryMaterialID: libraryMaterialID, sceneMaterialID: newMaterial.id };
                            }
                        }
                    }
                }
            }
            this.setRenderingNeeded();
            this.fireMaterialsUpdateEvent();
        }
        return newMaterial;
    }
    createMaterial(name, type, group) {
        let material = null;
        if (this._scene) {
            const materialName = name || "new material";
            const materialType = type || "Standard";
            if (materialType === "Standard")
                material = new BABYLON.StandardMaterial(materialName, this._scene);
            else if (materialType === "PBRMetallicRoughness") {
                material = new BABYLON.PBRMetallicRoughnessMaterial(materialName, this._scene);
                material.subSurface.indexOfRefraction = 1;
                material["_imageProcessingConfiguration"].contrast = 1;
            }
            else if (materialType === "PBRSpecularGlossiness")
                material = new BABYLON.PBRSpecularGlossinessMaterial(materialName, this._scene);
            else if (materialType === "PBR") {
                material = new BABYLON.PBRMaterial(materialName, this._scene);
                material.enableSpecularAntiAliasing = true;
                material.metallic = 0.9;
                material.roughness = 0.3;
                material.indexOfRefraction = 1;
            }
            else if (materialType === "NewPBR")
                material = new Zakeke.PBRMaterial(materialName, this._scene);
            if (material) {
                material.id = Zakeke.generateUUID();
                if (group) {
                    if (!material.metadata)
                        material.metadata = {};
                    material.metadata.group = group;
                }
            }
            this.checkSceneEmptyEnvironmentTexture();
            this.setRenderingNeeded();
            this.fireMaterialsUpdateEvent();
        }
        return material;
    }
    changeMeshParent(meshID, newParentID) {
        if (this._scene) {
            const child = this._scene.getMeshByID(meshID);
            if (child && (!child.parent || child.parent.id != newParentID)) {
                const newParent = this._scene.getMeshByID(newParentID);
                child.parent = newParent;
                this.setRenderingNeeded();
                this.fireMeshesUpdateEvent();
            }
        }
    }
    removeMeshParent(meshID) {
        if (this._scene) {
            const child = this._scene.getMeshByID(meshID);
            if (child) {
                child.parent = null;
                this.fireMeshesUpdateEvent();
            }
        }
    }
    setManipulatedNode(node) {
        // If we are just click on another object then don't re-create the edit control
        if (node === this._manipulatedNode)
            return;
        this._manipulatedNode = node;
        this.showHideEditControl(this._editControlVisible); // Refresh edit control
        this.setRenderingNeeded();
    }
    importLibraryMaterial(zkMaterial) {
        if (this._scene && this._sceneHelper && this._zkScene && zkMaterial && zkMaterial instanceof Zakeke.Material) {
            if (zkMaterial.get("shaders"))
                this.checkShaderMaterial(zkMaterial);
            const jsonText = zkMaterial.get("JSON") || zkMaterial.get("json");
            const rootUrl = zkMaterial.get("rootUrl");
            if (jsonText && rootUrl) {
                const jsonObj = JSON.parse(jsonText);
                const material = BABYLON.Material.Parse(jsonObj, this._scene, rootUrl);
                if (material) {
                    material.id = Zakeke.generateUUID();
                    this._zkScene.mapLibraryMaterial(zkMaterial.getMaterialID(), material.id);
                    if (zkMaterial.get("shaders")) {
                        const shaders = zkMaterial.get("shaders");
                        //shaders.get("name"), shaders.get("vertex"), shaders.get("fragment")
                        const shaderName = shaders.get("name");
                        const vertex = shaders.get("vertex");
                        const fragment = shaders.get("fragment");
                        if (shaderName && vertex && fragment) {
                            this._zkScene.registerShaderMaterial(zkMaterial.getMaterialID(), shaderName, vertex, fragment);
                        }
                        this.setupShaderMaterialCameraPosition(material);
                    }
                    const textures = this._sceneHelper.getTexturesForMaterial(material);
                    for (let i = 0; i < textures.length; i++) {
                        var texture = textures[i];
                        texture["materialMapping"] = { libraryMaterialID: zkMaterial.getMaterialID(), sceneMaterialID: material.id };
                    }
                }
            }
            this.fireMaterialsUpdateEvent();
            this.setRenderingNeeded();
        }
    }
    //#endregion
    //#region Recupero Texture
    // I metodi per il recupero delle texture sono stati spostati in SceneHelper
    // Li lascio qui solo momentaneamente
    getTexturesForMaterial(material) {
        return this._sceneHelper ? this._sceneHelper.getTexturesForMaterial(material) : [];
    }
    getStandardMaterialTextures(material) {
        return this._sceneHelper ? this._sceneHelper.getStandardMaterialTextures(material) : [];
    }
    getPBRBaseSimpleMaterialTextures(material) {
        return this._sceneHelper ? this._sceneHelper.getPBRBaseSimpleMaterialTextures(material) : [];
    }
    getPBRMaterialTextures(material) {
        return this._sceneHelper ? this._sceneHelper.getPBRMaterialTextures(material) : [];
    }
    getNewPBRMaterialTextures(material) {
        return this._sceneHelper ? this._sceneHelper.getNewPBRMaterialTextures(material) : [];
    }
    getPBRMetallicRoughnessMaterialTextures(material) {
        return this._sceneHelper ? this._sceneHelper.getPBRMetallicRoughnessMaterialTextures(material) : [];
    }
    getPBRSpecularGlossinessMaterialTextures(material) {
        return this._sceneHelper ? this._sceneHelper.getPBRSpecularGlossinessMaterialTextures(material) : [];
    }
    //#endregion
    //#region Camera Location
    removeCameraLocation(cameraLocation) {
        var _a;
        (_a = this._zkScene) === null || _a === void 0 ? void 0 : _a.get("cameraLocations").remove(cameraLocation);
        this.fireCameraLocationsUpdateEvent();
    }
    saveCameraLocation(name) {
        if (this._zkScene && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            const position = this._camera.position;
            const target = this._camera.target;
            const zkCameraLocation = new Zakeke.SceneCameraLocation();
            zkCameraLocation.set("name", name);
            zkCameraLocation.set("px", position.x);
            zkCameraLocation.set("py", position.y);
            zkCameraLocation.set("pz", position.z);
            zkCameraLocation.set("tx", target.x);
            zkCameraLocation.set("ty", target.y);
            zkCameraLocation.set("tz", target.z);
            this._zkScene.get("cameraLocations").push(zkCameraLocation);
            this.fireCameraLocationCreatedEvent(zkCameraLocation);
            this.fireCameraLocationsUpdateEvent();
        }
    }
    clearCameraLocations() {
        if (this._zkScene) {
            const items = this._zkScene.get("cameraLocations");
            while (items.length > 0)
                items.remove(items.at(0));
            this.fireCameraLocationsUpdateEvent();
        }
    }
    //public setCameraLocation(locationID: string) {
    //    if (this._sceneHelper && this._zkScene) {
    //        const zkCameraLocation = this._zkScene.getCameraLocation(locationID);
    //        if (zkCameraLocation) {
    //            const position = new BABYLON.Vector3(zkCameraLocation.get("px"), zkCameraLocation.get("py"), zkCameraLocation.get("pz"));
    //            const target = new BABYLON.Vector3(zkCameraLocation.get("tx"), zkCameraLocation.get("ty"), zkCameraLocation.get("tz"));
    //            this._sceneHelper.animateCamera(target, position, 0.5);
    //        }
    //    }
    //    this.setRenderingNeeded();
    //}
    getAllCameraLocations() {
        const locations = [];
        if (this._zkScene) {
            for (let i = 0; i < this._zkScene.get("cameraLocations").length; i++)
                locations.push(this._zkScene.get("cameraLocations").at(i));
        }
        return locations;
    }
    //#endregion
    //#region Collapse / Explode (Mesh Locations)
    saveMeshLocation(name) {
        if (this._meshLocationsManager) {
            this._meshLocationsManager.saveMeshLocation(name);
        }
    }
    saveExplodedMeshLocation() {
        if (this._meshLocationsManager) {
            this._meshLocationsManager.saveExplodedMeshLocation();
        }
    }
    saveCollapsedMeshLocation() {
        if (this._meshLocationsManager) {
            this._meshLocationsManager.saveCollapsedMeshLocation();
        }
    }
    onBeforeSaveMeshLocation() {
        this._oldManipulatedNode = this._manipulatedNode;
        this.setManipulatedNode(null);
    }
    onAfterSaveMeshLocation() {
        this.fireMeshLocationsUpdateEvent();
        this.setManipulatedNode(this._oldManipulatedNode);
    }
    clearMeshLocations() {
        if (this._meshLocationsManager) {
            this._meshLocationsManager.clearMeshLocations();
        }
    }
    getAllMeshLocations() {
        const locations = [];
        if (this._zkScene) {
            for (let i = 0; i < this._zkScene.get("meshLocations").length; i++)
                locations.push(this._zkScene.get("meshLocations").at(i));
        }
        return locations;
    }
    //#endregion
    //#region Material Library
    // Nota Bene
    // E' un po' incasinato, c'è da mettere ordine, primo abbozzo di implementazione. 
    // Il problema principale è la gestione delle texture
    // che possono provenire da fonti diverse (sorgenti, librerie e caricate singolarmente dall'utente).
    // In breve: innanzitutto scatta una screenshot del materiale. per fare questo nasconde tutte le mesh,
    // crea una sfera temporanea e una camera temporanea prende la screenshot e poi rattiva le mesh così
    // come erano inialmente. Poi, clona il materiale iniziale (babylon) e lo associa ad un nuovo materiale lato server (zkMaterial).
    // Recupera le texture (babylon) associate al materiale di scena.
    // Per copiare le immagini lato server, recupera i fileObjectID per ognuna delle texture. 
    // (Per una texture babylon possono esserci più file fileObjectID associati. Ad esempio, per una cubemap, ci saranno 6 fileObjectID associati.)
    // Per ogni fileObjectID, memorizza su skMaterial anche la provenienza, in modo che lato server il path possa essere costruito correttamente.
    // Salva il nuovo zkMaterial (lato server avverrà la copia dei file di immagini texture).
    // Alla fine elimina il nuovo materiale creato come clone.
    makeLibraryMaterial(id, name) {
        return new Promise((resolve, reject) => {
            this.getMaterialScreenShotForLibrary(id, (data) => {
                if (data) {
                    this.createLibraryMaterial(id, name, data, resolve);
                }
                else {
                    reject('No data generated for screenshot');
                }
            });
        });
    }
    getMaterialScreenShotForLibrary(id, callback) {
        if (this._scene && this._sceneHelper) {
            this.resetEditorEnvironment();
            this.removeGround();
            if (this._environmentManager) {
                this._environmentManager.dispose();
                this._environmentManager = null;
            }
            const width = 500;
            const height = 500;
            this._sceneHelper.takeMaterialScreenshotAsync(id, width, height).then((data) => {
                _Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.cropImageTransparency(data, width, height, (croppedData) => {
                    this.refreshEnvironment();
                    if (callback)
                        callback(croppedData);
                });
            });
        }
        else {
            if (callback)
                callback(null);
        }
    }
    createLibraryMaterial(id, name, screenshotImageData, callback) {
        // Clone del materiale originale
        let newMaterial = null;
        // Function da chiamare in chiusura di tutto il processo
        const complete = () => {
            if (newMaterial)
                this.deleteMaterial(newMaterial.id);
            if (callback)
                callback();
        };
        if (!this._scene || !this._sceneHelper || !this._zkScene) {
            complete();
            return;
        }
        const scene = this._scene;
        const sceneHelper = this._sceneHelper;
        const zkScene = this._zkScene;
        // Materiale da rendere di libreria
        const material = scene.getMaterialByID(id);
        if (!material) {
            complete();
            return;
        }
        // Creo il nuovo modello di materiale da libreria
        const zkMaterial = new Zakeke.Material();
        zkMaterial.set("name", name);
        zkMaterial.set("imageData", screenshotImageData);
        let originalMaterialID = id;
        let pathOriginalMaterialID = originalMaterialID.replace(/-/g, "");
        const newMaterialID = zkMaterial.getMaterialID();
        const pathNewMaterialID = newMaterialID.replace(/-/g, "");
        // Clono il materiale da serializzare per il salvataggio in libreria
        newMaterial = this.cloneMaterial(id, newMaterialID, name);
        if (!newMaterial) {
            complete();
            return;
        }
        const sourcesIDs = zkScene.getSourcesIDs();
        const allLibraryMaterialIDs = zkScene.getLibraryMaterialIDs();
        // recupero le texture (babylon js) del materiale
        const sceneTextures = sceneHelper.getTexturesForMaterial(newMaterial);
        // recupero i materiali di libreria dai quali derivano le texture del materiale da salvare
        const libraryMaterialIDs = [];
        for (let i = 0; i < sceneTextures.length; i++) {
            const sceneTexture = sceneTextures[i];
            if (sceneTexture["materialMapping"]) {
                const libraryMaterialID = sceneTexture["materialMapping"].libraryMaterialID;
                if (libraryMaterialID)
                    libraryMaterialIDs.push(libraryMaterialID);
            }
        }
        // Materiali di libreria legati al materiale da salvare anch'esso in libreria
        let zkMaterials = new Zakeke.Materials();
        const suffixes = ["px", "py", "pz", "nx", "ny", "nz"];
        const removeCubeTextureSuffix = function (url) {
            const idx = url.lastIndexOf(".");
            if (idx !== -1) {
                const nameWithoutExt = url.substring(0, idx);
                if (suffixes.some((suffix) => nameWithoutExt.endsWith("_" + suffix))) {
                    return nameWithoutExt.substring(0, nameWithoutExt.length - 3);
                }
            }
            return url;
        };
        const checkTextureUrl = (fileUrl, url) => {
            const cleared = removeCubeTextureSuffix(fileUrl);
            return cleared.endsWith(url);
        };
        // La funzione si occupa di modificare l'url delle texture del nuovo materiale
        // e di salvare il materiale serializzato come materiale di libreria
        const saveInLibrary = () => {
            for (let i = 0; i < sceneTextures.length; i++) {
                const sceneTexture = sceneTextures[i];
                if (sceneTexture && sceneHelper.isTextureWithUrl(sceneTexture) && sceneTexture.url) {
                    let sourceID = null;
                    let pathSourceID = null;
                    let libraryMaterialID = null;
                    let pathLibraryMaterialID = null;
                    // Verifico se nell'url è presente un codice sorgente 
                    // (nel qual caso la texture deriva da una sorgente)
                    for (let k = 0; k < sourcesIDs.length; k++) {
                        const sID = sourcesIDs[k].replace(/-/g, "");
                        const idx = sceneTexture.url.indexOf(sID);
                        if (idx != -1) {
                            sourceID = sourcesIDs[k];
                            pathSourceID = sID;
                            break;
                        }
                    }
                    // Verifico se si tratta di una texture proveniente da una libreria di materiali
                    if (sourceID == null) {
                        if (sceneTexture["materialMapping"]) {
                            libraryMaterialID = sceneTexture["materialMapping"].libraryMaterialID;
                            if (libraryMaterialID)
                                pathLibraryMaterialID = libraryMaterialID.replace(/-/g, "");
                        }
                    }
                    // Ora devo recuperare i fileObjects relativi 
                    const fileObjectIDs = [];
                    // Recupero dei fileObjects
                    if (libraryMaterialID) {
                        for (let k = 0; k < zkMaterials.length; k++) {
                            if (zkMaterials.at(k).getMaterialID() == libraryMaterialID) {
                                const zkLibraryMaterial = zkMaterials.at(k);
                                for (let w = 0; w < zkLibraryMaterial.get("textureImages").length; w++) {
                                    const libraryTexture = zkLibraryMaterial.get("textureImages").at(w);
                                    if (checkTextureUrl(libraryTexture.get("imageUrl"), sceneTexture.url))
                                        fileObjectIDs.push(libraryTexture.get("fileObjectID"));
                                }
                            }
                        }
                    }
                    else if (sourceID) {
                        const sceneSource = zkScene.get("sources").findSource(sourceID);
                        if (sceneSource) {
                            for (let k = 0; k < sceneSource.get("textures").length; k++) {
                                const sourceTexture = sceneSource.get("textures").at(k);
                                if (checkTextureUrl(sourceTexture.get("url"), sceneTexture.url))
                                    fileObjectIDs.push(sourceTexture.get("fileObjectID"));
                            }
                        }
                    }
                    else {
                        for (let k = 0; k < zkScene.get("textures").length; k++) {
                            const txt = zkScene.get("textures").at(k);
                            if (checkTextureUrl(txt.get("url"), sceneTexture.url))
                                fileObjectIDs.push(txt.get("fileObjectID"));
                        }
                    }
                    // A questo punto per ogni file object devo creare un oggetto MaterialSourceTextureImage
                    // e aggiungerlo al nuovo zkMaterial
                    for (let j = 0; j < fileObjectIDs.length; j++) {
                        const sourceTextureImage = new Zakeke.MaterialSourceTextureImage();
                        sourceTextureImage.set("fileObjectID", fileObjectIDs[j]);
                        if (libraryMaterialID) {
                            sourceTextureImage.set("materialID", libraryMaterialID);
                        }
                        else if (sourceID) {
                            sourceTextureImage.set("sceneID", zkScene.getSceneID());
                            sourceTextureImage.set("sourceID", sourceID);
                        }
                        else {
                            sourceTextureImage.set("sceneID", zkScene.getSceneID());
                            sourceTextureImage.set("materialID", originalMaterialID);
                        }
                        zkMaterial.get("sourceTextureImages").push(sourceTextureImage);
                    }
                    // Ora devo sostituire il nome alla texture corrente
                    let oldString = "";
                    let newString = "";
                    let name = sceneTexture.name;
                    if (sourceID && pathSourceID) {
                        const idx = sceneTexture.url.indexOf(pathSourceID);
                        if (idx != -1) {
                            name = sceneTexture.url.substring(idx);
                        }
                        oldString = pathSourceID;
                        newString = "textures/" + pathNewMaterialID;
                        sceneTexture.name = name.replace(new RegExp(oldString, 'g'), newString);
                    }
                    else if (libraryMaterialID && pathLibraryMaterialID) {
                        oldString = pathLibraryMaterialID;
                        newString = pathNewMaterialID;
                        sceneTexture.name = name.replace(new RegExp('textures\/([A-Za-z0-9]*)\/(.*)', 'g'), 'textures/' + newString + '/$2');
                    }
                    else {
                        var idx = sceneTexture.url.lastIndexOf("/");
                        if (idx !== -1) {
                            idx = sceneTexture.url.lastIndexOf("/", idx - 1);
                            if (idx !== -1) {
                                idx = sceneTexture.url.lastIndexOf("/", idx - 1);
                                if (idx != -1) {
                                    name = sceneTexture.url.substring(idx + 1);
                                }
                            }
                        }
                        oldString = pathOriginalMaterialID;
                        newString = pathNewMaterialID;
                        sceneTexture.name = name.replace(new RegExp('textures\/([A-Za-z0-9]*)\/(.*)', 'g'), 'textures/' + newString + '/$2');
                    }
                    sceneTexture.url = sceneTexture.name;
                }
            }
            // Ora che le texture sono state "sistemate", posso serializzare e salvare
            if (newMaterial) {
                const jsonObj = newMaterial.serialize();
                const json = JSON.stringify(jsonObj);
                zkMaterial.set("JSON", json);
                zkMaterial.save(null, {
                    success: function (model, response, options) {
                        complete();
                    },
                    error: function (model, response, options) {
                        complete();
                    }
                });
            }
            else
                complete();
            // ---------------------------------
        };
        // Leggo tutti i materiali di libreria interessati
        if (libraryMaterialIDs.length > 0) {
            const data = { ids: libraryMaterialIDs.join(',') };
            try {
                zkMaterials.fetch({
                    success: (collection, response, options) => {
                        zkMaterials = collection;
                        saveInLibrary();
                    },
                    error: (collection, response, options) => {
                        Logger.info("Errore nel salvataggio del materiale di libreria");
                        complete();
                    },
                    data: data
                });
            }
            catch (e) {
            }
        }
        else {
            saveInLibrary();
        }
    }
    //#endregion
    //#region Lights
    lightsLayer_onLightSelected(event) {
        this.fireLightSelectedEvent(event);
    }
    isDefaultLight(light) {
        return this._sceneHelper ? this._sceneHelper.isDefaultLight(light) : false;
    }
    createLight(name, type) {
        let light = null;
        if (this._scene) {
            const lightName = name || "new light";
            const lightType = type || "Point";
            const position = BABYLON.Vector3.Zero();
            const direction = BABYLON.Vector3.Zero();
            const angle = 25 * Math.PI / 180;
            const exponent = 2;
            if (lightType == "Point")
                light = new BABYLON.PointLight(lightName, position, this._scene);
            else if (lightType == "Directional")
                light = new BABYLON.DirectionalLight(lightName, direction, this._scene);
            else if (lightType == "Spot")
                light = new BABYLON.SpotLight(lightName, position, direction, angle, exponent, this._scene);
            else if (lightType == "Hemispheric")
                light = new BABYLON.HemisphericLight(lightName, direction, this._scene);
            if (light)
                light.id = Zakeke.generateUUID();
            if (this._lightsLayer)
                this._lightsLayer.refresh();
            this.setRenderingNeeded();
            this.fireLightsUpdateEvent();
        }
        return light;
    }
    cloneLight(id, newId, newName) {
        let newLight = null;
        if (this._scene) {
            const light = this._scene.getLightByID(id);
            if (light) {
                const lightName = newName ? newName : light.name + " - clone";
                newLight = light.clone(lightName);
                if (newLight) {
                    newLight.name = lightName; // Sometimes the clone parameter don't work
                    const lightId = newId ? newId : Zakeke.generateUUID();
                    newLight.id = lightId;
                    if (this._lightsLayer)
                        this._lightsLayer.refresh();
                }
            }
            this.setRenderingNeeded();
            this.fireLightsUpdateEvent();
        }
        return newLight;
    }
    renameLight(id, name) {
        if (this._scene) {
            const light = this._scene.getLightByID(id);
            if (light) {
                light.name = name;
                if (this._lightsLayer)
                    this._lightsLayer.refresh();
            }
            this.fireLightsUpdateEvent();
        }
    }
    deleteLight(id) {
        if (this._scene) {
            const light = this._scene.getLightByID(id);
            if (light) {
                light.dispose();
                // Per un bug di Babylon che sarà fixato a breve devo segnalare le mesh come da aggiornare per l'illuminazione
                this._scene.meshes.forEach(mesh => mesh._markSubMeshesAsLightDirty());
                if (this._lightsLayer)
                    this._lightsLayer.refresh();
            }
            this.setRenderingNeeded();
            this.fireLightsUpdateEvent();
        }
    }
    getAllLights() {
        return this._scene ? this._scene.lights : [];
    }
    canShowLights() {
        return this._showLights && this._envMode == _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor;
    }
    showHideLights(show) {
        this._showLights = show;
        if (this._lightsLayer)
            this._lightsLayer.refresh();
        this.setRenderingNeeded();
    }
    //#endregion
    //#region Ground
    canShowGround() {
        return this._showGround && this._envMode == _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor;
    }
    removeGround() {
        if (this._ground) {
            this._ground.dispose();
            this._ground = null;
        }
        this.setRenderingNeeded();
    }
    refreshGround() {
        if (!this._scene)
            return;
        this.removeGround();
        if (!this.canShowGround()) {
            this.setRenderingNeeded();
            return;
        }
        const mainColor = this._scene.clearColor;
        const mainColorHex = mainColor.toHexString();
        const lum = _Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.isColorDark(mainColorHex) ? 0.8 : -0.5;
        const gridColor = BABYLON.Color3.FromHexString(_Helpers_utils__WEBPACK_IMPORTED_MODULE_6__.Utils.changeColorLuminosity(mainColorHex, lum));
        let size = 1000;
        let gridRatio = 1;
        if (this.countSceneMeshes() > 0) {
            const worldExtends = this._scene.getWorldExtends(mesh => this.isRealMesh(mesh));
            const worldSize = worldExtends.max.subtract(worldExtends.min);
            const radius = worldSize.length() * 1.5;
            if (isFinite(radius)) {
                size = radius * 20;
                gridRatio = size / 100;
            }
        }
        this._ground = BABYLON.Mesh.CreateGround("ground", size, size, 10, this._scene);
        this._ground.doNotSerialize = true;
        this._ground.isVisible = this.showGround;
        this._ground.isPickable = false;
        this._ground.metadata = {
            isRealMesh: false,
            isGround: true,
        };
        const gridMaterial = new BABYLON.GridMaterial("groundMaterial", this._scene);
        gridMaterial.doNotSerialize = true;
        gridMaterial.backFaceCulling = false;
        gridMaterial.mainColor = new BABYLON.Color3(mainColor.r, mainColor.g, mainColor.b);
        gridMaterial.opacity = 1;
        gridMaterial.gridRatio = gridRatio;
        gridMaterial.lineColor = gridColor;
        gridMaterial.metadata = { isRealMaterial: false };
        this._ground.material = gridMaterial;
        this.setRenderingNeeded();
    }
    showHideGround(show) {
        this.showGround = show;
        this.refreshGround();
    }
    //#endregion
    //#region Axes
    canShowAxes() {
        return this._showAxes && this._envMode == _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor;
    }
    showHideAxes(show) {
        this._showAxes = show;
        if (this._axesLayer)
            this._axesLayer.refresh();
        this.setRenderingNeeded();
    }
    //#endregion
    //#region Highlights
    showHideHighlight(show) {
        this._showHighlight = show;
        const mesh = this.getSelectedRootMesh();
        this.highlightMesh(mesh, show);
        this.setRenderingNeeded();
    }
    setHighlightOver(highlight) {
        this._highlightOver = highlight;
    }
    highlightMesh(mesh, highlight) {
        if (!this._showHighlight || this._envMode != _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor) {
            this.deleteHighlightLayer();
            return;
        }
        if (mesh && mesh instanceof BABYLON.Mesh) {
            if (highlight) {
                if (!this._highlightLayer)
                    this.createHighlightLayer();
                if (this._highlightLayer)
                    this._highlightLayer.addMesh(mesh, BABYLON.Color3.FromHexString(this._highlightColor));
            }
            else {
                if (this._highlightLayer) {
                    this._highlightLayer.removeMesh(mesh);
                }
            }
        }
        this.setLongRenderingNeeded();
    }
    highlightMeshOver(highlight) {
        if (!this._showHighlight || this._envMode != _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor) {
            this.deleteHighlightLayer();
            return;
        }
        if (this._meshOver && this._meshOver instanceof BABYLON.Mesh && !this.isMeshSelected(this._meshOver)) {
            if (highlight && this._highlightOver) {
                if (!this._highlightLayer)
                    this.createHighlightLayer();
                if (this._highlightLayer && !this._highlightLayer.hasMesh(this._meshOver))
                    this._highlightLayer.addMesh(this._meshOver, BABYLON.Color3.FromHexString(this.highlightOverColor));
            }
            else {
                if (this._highlightLayer)
                    this._highlightLayer.removeMesh(this._meshOver);
            }
        }
        this.setLongRenderingNeeded();
    }
    //#endregion
    //#region Edit control (Gizmo)
    showHideEditControl(show) {
        if (this._scene && this._camera && this._canvas) {
            this._editControlVisible = show;
            if (this._editControl && (!show || this._manipulatedNode == null)) {
                this._editControl.detach();
                this._editControl = null;
            }
            if (show && this._manipulatedNode) {
                if (!this._editControl) {
                    this._editControl = new this._EditControl(this._manipulatedNode, this._camera, this._canvas, 0.75, true);
                    //set rotational snap valie in radians
                    this._editControl.setRotSnapValue(3.14 / 18);
                    //set transalation snap value in meters
                    this._editControl.setTransSnapValue(0.5);
                    //set scale snap value in scale ratio
                    this._editControl.setScaleSnapValue(0.25);
                }
                else {
                    this._editControl.switchTo(this._manipulatedNode);
                }
                this.setEditingMode(this._editingMode);
            }
            this.setRenderingNeeded();
        }
    }
    setEditingMode(mode) {
        this._editingMode = mode;
        if (this._editControl) {
            if (mode === _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EditingMode.Translate)
                this._editControl.enableTranslation();
            else if (mode === _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EditingMode.Rotate)
                this._editControl.enableRotation();
            else if (mode === _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EditingMode.Scaling)
                this._editControl.enableScaling();
        }
        this.setRenderingNeeded();
    }
    undoEditing() {
        if (this._editControl) {
            this._editControl.undo();
        }
    }
    redoEditing() {
        if (this._editControl) {
            this._editControl.redo();
        }
    }
    //#endregion
    //#region Environment
    setEnvironmentMode(newMode) {
        if (newMode != this._envMode) {
            this._envMode = newMode;
            this.refreshEnvironment();
        }
    }
    refreshEnvironment() {
        if (!this._scene)
            return;
        this.setRenderingNeeded();
        if (this._envMode == _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode.Editor) {
            this.disableAntialiasing();
            this.resetEditorEnvironment();
            if (this._environmentManager) {
                this._environmentManager.dispose();
                this._environmentManager = null;
            }
        }
        else {
            this.deleteHighlightLayer();
            this.refreshGround();
            if (this._zkScene) {
                if (!this._environmentManager || this._environmentManager.scene != this._scene)
                    this._environmentManager = new _Components_Environment_EnvironmentManager__WEBPACK_IMPORTED_MODULE_0__.EnvironmentManager(this._zkScene, this._scene);
                this._environmentManager.update();
                this.setLongRenderingNeeded();
            }
        }
        this.refreshGround();
        if (this._lightsLayer)
            this._lightsLayer.refresh();
        if (this._axesLayer)
            this._axesLayer.refresh();
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
            this.autoRender = this._camera.useAutoRotationBehavior;
        this.setRenderingNeeded();
    }
    //#endregion
    //#region Zoom & Move camera
    zoomOnMesh(mesh) {
        if (this._sceneHelper)
            this._sceneHelper.zoomOnMesh(mesh);
    }
    // Sperimentale (è difficile capire come muovere la camera per inquadrare un oggetto)
    moveCameraToMeshPosition(mesh) {
        if (this._scene && this._sceneHelper && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            const center = this._sceneHelper.getMeshHierarchyCenter(mesh);
            const target = this._camera.target;
            const radius = this._camera.radius;
            const direction = center.subtract(target);
            const length = direction.length();
            if (isFinite(length)) {
                let radiusVector = direction.normalize();
                let newPosition = target.add(radiusVector.scale(radius));
                const rayPick = new BABYLON.Ray(newPosition, radiusVector.scale(-1), radius);
                const meshFound = this._scene.pickWithRay(rayPick, item => item === mesh);
                if (meshFound && meshFound.hit) {
                    const scale = new BABYLON.Vector3();
                    const rotation = new BABYLON.Quaternion();
                    const position = new BABYLON.Vector3();
                    mesh.getWorldMatrix().decompose(scale, rotation, position);
                    var size = 0.1 / scale.length() * 100;
                    var nlines = [];
                    var v = meshFound.pickedPoint;
                    var n = meshFound.getNormal();
                    if (n) {
                        radiusVector = n.normalize();
                        newPosition = target.add(radiusVector.scale(radius));
                    }
                    // draw
                    //nlines.push([v, v.add(n.scale(size))]);
                    //var meshLines = {};
                    //meshLines.normals = BABYLON.MeshBuilder.CreateLineSystem("normalLines", { lines: nlines }, this.scene);
                }
                this._sceneHelper.animateCamera(target, newPosition, 1);
            }
            this.setRenderingNeeded();
        }
    }
    //#endregion
    //#region Scene & Mesh Export: USDZ, glTF, Obj, AR
    exportMeshToOBJ(meshID) {
        if (!this._scene)
            return;
        const mesh = this._scene.getMeshByID(meshID);
        if (!mesh || !(mesh instanceof BABYLON.Mesh))
            return;
        const objText = BABYLON.OBJExport.OBJ([mesh]);
        this.saveTextAsFile(objText, mesh.name + ".obj");
    }
    exportMeshGeometryToJson(meshID) {
        if (!this._scene)
            return;
        const mesh = this._scene.getMeshByID(meshID);
        if (!mesh || !(mesh instanceof BABYLON.Mesh))
            return;
        const result = {
            positions: mesh.getVerticesData(BABYLON.VertexBuffer.PositionKind),
            normals: mesh.getVerticesData(BABYLON.VertexBuffer.NormalKind),
            colors: mesh.getVerticesData(BABYLON.VertexBuffer.ColorKind),
            uvs: mesh.getVerticesData(BABYLON.VertexBuffer.UVKind),
            uvs2: mesh.getVerticesData(BABYLON.VertexBuffer.UV2Kind),
            indices: mesh.getIndices()
        };
        const json = JSON.stringify(result, null, 0);
        this.saveTextAsFile(json, mesh.name + ".json");
    }
    enableDisableARForMesh(meshID, value) {
        const mesh = this.getMeshByID(meshID);
        if (mesh) {
            if (!mesh.metadata)
                mesh.metadata = {};
            mesh.metadata.AR = value;
        }
    }
    isAREnabledForMesh(meshID) {
        const mesh = this.getMeshByID(meshID);
        if (mesh && mesh.metadata) {
            if (mesh.metadata.AR !== undefined)
                return mesh.metadata.AR;
            else
                return true;
        }
        return false;
    }
    enableDisableTryOnForMesh(meshID, value) {
        const mesh = this.getMeshByID(meshID);
        if (mesh) {
            if (!mesh.metadata)
                mesh.metadata = {};
            mesh.metadata.AR = value;
        }
    }
    isTryOnEnabledForMesh(meshID) {
        const mesh = this.getMeshByID(meshID);
        if (mesh && mesh.metadata) {
            if (mesh.metadata.TryOn !== undefined)
                return mesh.metadata.TryOn;
            else
                return true;
        }
        return false;
    }
    //#endregion
    //#region Utilities
    splitSubMeshes(meshID) {
        if (this._scene && this._sceneHelper) {
            const mesh = this._scene.getMeshByID(meshID);
            if (mesh)
                this._sceneHelper.createMeshesFromSubMeshes(mesh);
        }
    }
    flipMeshFaces(meshID) {
        const parent = this.getMeshByID(meshID);
        if (!parent)
            return;
        const flip = (mesh) => {
            if (mesh instanceof BABYLON.Mesh)
                mesh.flipFaces(true);
            mesh.getChildMeshes().forEach(child => flip(child));
        };
        flip(parent);
    }
    convertSceneToScreenPoint(sceneX, sceneY) {
        if (this._canvas) {
            let offX = 0;
            let offY = 0;
            let node = this._canvas;
            do {
                offX += node.offsetLeft;
                offY += node.offsetTop;
                node = node.offsetParent;
            } while (node);
            return { X: sceneX + offX, Y: sceneY + offY };
        }
        return null;
    }
    saveTextAsFile(text, filename) {
        const textToSave = text;
        const textToSaveAsBlob = new Blob([textToSave], { type: "text/plain" });
        const textToSaveAsURL = window.URL.createObjectURL(textToSaveAsBlob);
        const fileNameToSaveAs = filename;
        this.downloadFile(fileNameToSaveAs, textToSaveAsURL);
    }
    saveBytesAsFile(data, filename) {
        const blob = new Blob([data]);
        const url = window.URL.createObjectURL(blob);
        const fileNameToSaveAs = filename;
        this.downloadFile(filename, url);
    }
    saveBlobAsFile(blob, filename, mimetype) {
        let url = null;
        if (!mimetype)
            url = window.URL.createObjectURL(new Blob([blob]));
        else
            url = window.URL.createObjectURL(new Blob([blob], { type: mimetype }));
        this.downloadFile(filename, url);
    }
    downloadFile(filename, url) {
        var downloadLink = document.createElement("a");
        downloadLink.download = filename;
        downloadLink.innerHTML = "Download File";
        downloadLink.href = url;
        downloadLink.onclick = (ev) => {
            document.body.removeChild(downloadLink);
        };
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click();
    }
    //#endregion
    //#region Draco
    // Test Draco encoding
    exportDracoEncodedToFile(meshID) {
        if (!this._scene)
            return;
        const mesh = this._scene.getMeshByID(meshID);
        if (!mesh)
            return;
        // ArrayBuffer con la codifica Draco della geometria
        const dracoData = this.getDracoEncodedGeometry(mesh);
        if (dracoData)
            this.saveBytesAsFile(dracoData, mesh.name + "_draco.dat");
    }
    // Funzione utile per testare la codifica Draco delle geometrie
    // La codifica reale delle mesh avviene durante il salvataggio e se ne
    // occupa la classe MakeIncremental, utilizzata in un worker thread
    getDracoEncodedGeometry(originalMesh) {
        let outputBuffer = null;
        if (this._scene && originalMesh && originalMesh instanceof BABYLON.Mesh) {
            const positions = originalMesh.getVerticesData(BABYLON.VertexBuffer.PositionKind);
            const normals = originalMesh.getVerticesData(BABYLON.VertexBuffer.NormalKind);
            const colors = originalMesh.getVerticesData(BABYLON.VertexBuffer.ColorKind);
            const uvs = originalMesh.getVerticesData(BABYLON.VertexBuffer.UVKind);
            const uvs2 = originalMesh.getVerticesData(BABYLON.VertexBuffer.UV2Kind);
            const indices = originalMesh.getIndices();
            const mesh = {};
            if (indices)
                mesh.indices = new Uint32Array(indices);
            if (positions)
                mesh.positions = new Float32Array(positions);
            if (normals)
                mesh.normals = new Float32Array(normals);
            if (uvs)
                mesh.uvs = new Float32Array(uvs);
            if (uvs2)
                mesh.uvs2 = new Float32Array(uvs2);
            if (colors)
                mesh.colors = new Uint32Array(colors);
            const encoderModule = DracoEncoderModule();
            const encoder = new encoderModule.Encoder();
            const meshBuilder = new encoderModule.MeshBuilder();
            const dracoMesh = new encoderModule.Mesh();
            const numFaces = mesh.indices.length / 3;
            const numPoints = mesh.positions.length / 3;
            meshBuilder.AddFacesToMesh(dracoMesh, numFaces, mesh.indices);
            meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.POSITION, numPoints, 3, mesh.positions);
            if (mesh.normals) {
                meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.NORMAL, numPoints, 3, mesh.normals);
            }
            if (mesh.colors) {
                meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.COLOR, numPoints, 4, mesh.colors);
            }
            if (mesh.uvs) {
                meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.TEX_COORD, numPoints, 2, mesh.uvs);
            }
            if (mesh.uvs2) {
                meshBuilder.AddFloatAttributeToMesh(dracoMesh, encoderModule.TEX_COORD, numPoints, 2, mesh.uvs2);
            }
            encoder.SetSpeedOptions(5, 5);
            encoder.SetAttributeQuantization(encoderModule.POSITION, 14);
            encoder.SetAttributeQuantization(encoderModule.TEX_COORD, 12);
            encoder.SetAttributeQuantization(encoderModule.NORMAL, 10);
            encoder.SetAttributeQuantization(encoderModule.COLOR, 10);
            encoder.SetAttributeQuantization(encoderModule.GENERIC, 8);
            encoder.SetEncodingMethod(encoderModule.MESH_EDGEBREAKER_ENCODING);
            const encodedData = new encoderModule.DracoInt8Array();
            const encodedLen = encoder.EncodeMeshToDracoBuffer(dracoMesh, encodedData);
            outputBuffer = new ArrayBuffer(encodedLen);
            var outputData = new Int8Array(outputBuffer);
            for (let i = 0; i < encodedLen; ++i) {
                outputData[i] = encodedData.GetValue(i);
            }
            encoderModule.destroy(dracoMesh);
            encoderModule.destroy(encodedData);
            encoderModule.destroy(encoder);
            encoderModule.destroy(meshBuilder);
        }
        return outputBuffer;
    }
    // Decodifica dei dati Draco ereditata da SceneViewer
    //#endregion
    //#region Mesh Creation
    // Crea una mesh (cubo) custom specificandone la geometria
    // utile per comprendere il modo in cui Babylon JS organizza i dati delle geomtrie
    createCustomMesh() {
        let customMesh = null;
        if (this._scene) {
            customMesh = new BABYLON.Mesh("custom", this._scene);
            var positions = [-5, 2, -3, -7, -2, -3, -3, -2, -3, 5, 2, 3, 7, -2, 3, 3, -2, 3];
            var indices = [0, 1, 2, 3, 4, 5];
            var colors = [1, 0, 0, 1, 1, 0, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0, 0, 1, 1, 0, 0, 1, 0, 1]; //color array added
            var uvs = [0, 1, 0, 0, 1, 0];
            //Empty array to contain calculated values or normals added
            var normals = [];
            //Calculations of normals added
            BABYLON.VertexData.ComputeNormals(positions, indices, normals);
            const vertexData = new BABYLON.VertexData();
            vertexData.positions = positions;
            vertexData.indices = indices;
            vertexData.colors = colors; //Assignment of colors to vertexData
            vertexData.normals = normals; //Assignment of normal to vertexData added
            vertexData.uvs = uvs;
            vertexData.applyToMesh(customMesh);
        }
        return customMesh;
    }
    createBox(parentID, name) {
        let mesh = null;
        let parent = null;
        if (this._scene && this._sceneHelper) {
            if (parentID)
                parent = this._scene.getMeshByID(parentID);
            mesh = this._sceneHelper.createBox(parent, name);
            this.setLongRenderingNeeded();
        }
        return mesh;
    }
    getSceneBoundingBox() {
        let bbox = null;
        if (this._scene) {
            for (let i = 0; i < this._scene.meshes.length; i++) {
                const mesh = this._scene.meshes[i];
                if (mesh && mesh.metadata && mesh.metadata.sceneBoundingBox) {
                    bbox = mesh;
                    break;
                }
            }
        }
        return bbox;
    }
    getOrCreateSceneBoundingBox(visible = true) {
        let bbox = this.getSceneBoundingBox();
        if (!bbox) {
            bbox = this.createBoundingBox(null, "SceneBoundingBox", visible);
            if (bbox) {
                if (!bbox.metadata)
                    bbox.metadata = {};
                bbox.metadata.boundingBox = true;
                bbox.metadata.sceneBoundingBox = true;
            }
        }
        return bbox;
    }
    createSceneBoundingBox(visible = true) {
        let bbox = this.getSceneBoundingBox();
        if (bbox)
            bbox.isVisible = visible;
        else {
            bbox = this.createBoundingBox(null, "SceneBoundingBox", visible);
            if (bbox) {
                if (!bbox.metadata)
                    bbox.metadata = {};
                bbox.metadata.boundingBox = true;
                bbox.metadata.sceneBoundingBox = true;
            }
        }
        return bbox;
    }
    createBoundingBox(meshID, name, visible = true) {
        let mesh = null;
        if (meshID)
            mesh = this.getMeshByID(meshID);
        if (this._sceneHelper) {
            var newMesh = this._sceneHelper.createBoundingBox(mesh, name);
            if (newMesh)
                newMesh.isVisible = visible;
            this.setLongRenderingNeeded();
            return newMesh;
        }
        return null;
    }
    createSphere(parentID, name) {
        let mesh = null;
        let parent = null;
        if (this._scene && parentID)
            parent = this._scene.getMeshById(parentID);
        if (this._sceneHelper) {
            mesh = this._sceneHelper.createSphere(parent, name);
            this.setLongRenderingNeeded();
        }
        return mesh;
    }
    createPlane(parentID, name) {
        let mesh = null;
        let parent = null;
        if (this._scene && parentID)
            parent = this._scene.getMeshById(parentID);
        if (this._sceneHelper) {
            mesh = this._sceneHelper.createPlane(parent, name);
            this.setLongRenderingNeeded();
        }
        return mesh;
    }
    createDisc(parentID, name) {
        let mesh = null;
        let parent = null;
        if (this._scene && parentID)
            parent = this._scene.getMeshById(parentID);
        if (this._sceneHelper) {
            mesh = this._sceneHelper.createDisc(parent, name);
            this.setLongRenderingNeeded();
        }
        return mesh;
    }
    createCylinder(parentID, name) {
        let mesh = null;
        let parent = null;
        if (this._scene && parentID)
            parent = this._scene.getMeshById(parentID);
        if (this._sceneHelper) {
            mesh = this._sceneHelper.createCylinder(parent, name);
            this.setLongRenderingNeeded();
        }
        return mesh;
    }
    createTorus(parentID, name) {
        let mesh = null;
        let parent = null;
        if (this._scene && parentID)
            parent = this._scene.getMeshById(parentID);
        if (this._sceneHelper) {
            mesh = this._sceneHelper.createTorus(parent, name);
            this.setLongRenderingNeeded();
        }
        return mesh;
    }
    createKnot(parentID, name) {
        let mesh = null;
        let parent = null;
        if (this._scene && parentID)
            parent = this._scene.getMeshById(parentID);
        if (this._sceneHelper) {
            mesh = this._sceneHelper.createKnot(parent, name);
            this.setLongRenderingNeeded();
        }
        return mesh;
    }
    createRibbon(parentID, name) {
        let mesh = null;
        let parent = null;
        if (this._scene && parentID)
            parent = this._scene.getMeshById(parentID);
        if (this._sceneHelper) {
            mesh = this._sceneHelper.createRibbon(parent, name);
            this.setLongRenderingNeeded();
        }
        return mesh;
    }
    createRoundedCubeAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createRoundedCubeAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    createRoundedCylinderAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createRoundedCylinderAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    createMatBallAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createMatBallAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    createMaleHeadAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createMaleHeadAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    createFemaleHeadAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createFemaleHeadAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    createPokemonBallAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createPokemonBallAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    createShaderBallAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createShaderBallAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    createBootsAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createBootsAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    createSuzanneAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createSuzanneAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    createStepPyramidAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createStepPyramidAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    createTeapotAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createTeapotAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    createAlloyWheelAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createAlloyWheelAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    createTryonReferenceGlassesFrameAsync(parentID, name) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.createTryonReferenceGlassesFrameAsync(parent, name);
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    importMeshesFromUrlAsync(parentID, url) {
        return __awaiter(this, void 0, void 0, function* () {
            let meshes = [];
            let parent = null;
            if (this._scene && parentID)
                parent = this._scene.getMeshById(parentID);
            if (this._sceneHelper) {
                meshes = yield this._sceneHelper.importMeshesFromUrlAsync(url, parent);
                this.checkSceneEmptyEnvironmentTexture();
                this.setLongRenderingNeeded();
            }
            return meshes;
        });
    }
    //#endregion
    //#region 2D Design Rendering
    connectMeshToModelSideAsync(meshID, submeshID, sideID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneDesignManager) {
                this._sceneDesignManager.connectMeshToModelSideAsync(meshID, submeshID, sideID);
            }
        });
    }
    clearMeshDesignManagers() {
        if (this._sceneDesignManager) {
            this._sceneDesignManager.clearMeshDesignManagers();
        }
    }
    getMeshDesignMananger(mesh, subMesh) {
        var _a;
        if (this._sceneDesignManager && this.scene) {
            return (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.getMeshDesignMananger(mesh, subMesh);
        }
        else {
            return null;
        }
    }
    // -------------------------------------------------------------
    // Design view transformation
    // -------------------------------------------------------------
    translateDesignView(mesh, submesh, dx, dy) {
        if (this._sceneDesignManager) {
            this._sceneDesignManager.translateDesignView(mesh, submesh, dx, dy);
        }
    }
    rotateDesignView(mesh, submesh, angle, centerX, centerY) {
        if (this._sceneDesignManager) {
            this._sceneDesignManager.rotateDesignView(mesh, submesh, angle, centerX, centerY);
        }
    }
    scaleDesignView(mesh, submesh, hor, ver, centerX, centerY) {
        if (this._sceneDesignManager) {
            this._sceneDesignManager.scaleDesignView(mesh, submesh, hor, ver, centerX, centerY);
        }
    }
    setDesignViewTextureUVChannelAsync(mesh, submesh, uvChannel) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneDesignManager) {
                yield this._sceneDesignManager.setDesignViewTextureUVChannelAsync(mesh, submesh, uvChannel);
            }
        });
    }
    setDesignViewFormFactorAsync(mesh, submesh, percWidth, percHeight) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneDesignManager) {
                yield this._sceneDesignManager.setDesignViewFormFactorAsync(mesh, submesh, percWidth, percHeight);
            }
        });
    }
    //#endregion
    //#region Mesh measuring
    setSceneSizeCm(size, sizeType) {
        const mesh = this.getOrCreateSceneBoundingBox(false);
        if (mesh)
            this.setMeshSizeCm(mesh.id, size, sizeType);
    }
    getSceneWidthCm() {
        const mesh = this.getSceneBoundingBox();
        if (mesh && mesh.metadata && mesh.metadata.sizecm && mesh.metadata.sizecm.width)
            return mesh.metadata.sizecm.width;
        return null;
    }
    getSceneHeightCm() {
        const mesh = this.getSceneBoundingBox();
        if (mesh && mesh.metadata && mesh.metadata.sizecm && mesh.metadata.sizecm.height)
            return mesh.metadata.sizecm.height;
        return null;
    }
    getSceneDepthCm() {
        const mesh = this.getSceneBoundingBox();
        if (mesh && mesh.metadata && mesh.metadata.sizecm && mesh.metadata.sizecm.depth)
            return mesh.metadata.sizecm.depth;
        return null;
    }
    setMeshSizeCm(meshId, size, sizeType) {
        const mesh = this.getMeshByID(meshId);
        if (mesh) {
            let sizeObj = null;
            if (size && typeof size === "number" && !isNaN(size)) {
                if (sizeType === "width")
                    sizeObj = { width: size };
                else if (sizeType === "height")
                    sizeObj = { height: size };
                else if (sizeType === "depth")
                    sizeObj = { depth: size };
            }
            if (!mesh.metadata)
                mesh.metadata = {};
            mesh.metadata.sizecm = sizeObj;
        }
    }
    getMeshWidthCm(meshID) {
        const mesh = this.getMeshByID(meshID);
        if (mesh && mesh.metadata && mesh.metadata.sizecm && mesh.metadata.sizecm.width)
            return mesh.metadata.sizecm.width;
        return null;
    }
    getMeshHeightCm(meshID) {
        const mesh = this.getMeshByID(meshID);
        if (mesh && mesh.metadata && mesh.metadata.sizecm && mesh.metadata.sizecm.height)
            return mesh.metadata.sizecm.height;
        return null;
    }
    getMeshDepthCm(meshID) {
        const mesh = this.getMeshByID(meshID);
        if (mesh && mesh.metadata && mesh.metadata.sizecm && mesh.metadata.sizecm.depth)
            return mesh.metadata.sizecm.depth;
        return null;
    }
    //#endregion
    //#region Material Previews
    getMaterialsPreviewsAsync(materialIDs, width, height, crop, createBlobs = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const results = [];
            if (this._scene && this._sceneHelper && this._zkScene) {
                const rootUrl = yield this.getSceneRootUrl();
                if (rootUrl) {
                    const data = yield _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_2__.MaterialsPreview.getPreviewsAsync(this._scene, rootUrl, materialIDs, { width, height }, true);
                    for (var filename in data.previewFiles)
                        results.push(data.previewFiles[filename]);
                }
            }
            return results;
        });
    }
    getAllMaterialsPreviewsAsync(width, height, crop, createBlobs = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const results = [];
            if (this._scene && this._sceneHelper && this._zkScene) {
                const materials = this._sceneHelper.getAllMaterials();
                const materialIDs = materials.map(m => m.id);
                return this.getMaterialsPreviewsAsync(materialIDs, width, height, crop, createBlobs);
            }
            return results;
        });
    }
    downloadMaterialsPreviewsAsync(materialIDs, width, height, crop) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._scene && this._sceneHelper && this._zkScene) {
                const rootUrl = yield this.getSceneRootUrl();
                if (rootUrl) {
                    yield _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_2__.MaterialsPreview.downloadPreviewsAsync(this._scene, rootUrl, materialIDs, { width, height, crop });
                }
            }
        });
    }
    downloadAllMaterialsPreviewsAsync(width, height, crop) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._scene && this._sceneHelper && this._zkScene) {
                const materials = this._sceneHelper.getAllMaterials();
                const materialIDs = materials.map(m => m.id);
                yield this.downloadMaterialsPreviewsAsync(materialIDs, width, height, crop);
            }
        });
    }
    //#endregion
    createEnvelopeMesh(meshID) {
        if (this._scene && this._sceneHelper) {
            const mesh = this._scene.getMeshByID(meshID);
            if (mesh && mesh instanceof BABYLON.Mesh) {
                return this._sceneHelper.createEnvelopeMesh(mesh);
            }
        }
        return null;
    }
    expandMesh(meshID, delta) {
        if (this._scene && this._sceneHelper) {
            const mesh = this._scene.getMeshByID(meshID);
            if (mesh && mesh instanceof BABYLON.Mesh) {
                this._sceneHelper.expandMesh(mesh, delta);
            }
        }
    }
    enableDisableMeshFacetData(meshID, enable) {
        if (this._scene && this._sceneHelper) {
            const mesh = this._scene.getMeshByID(meshID);
            if (mesh) {
                enable ? mesh.updateFacetData() : mesh.disableFacetData();
            }
        }
    }
    enableDisableDepthSortFacets(meshID, enable) {
        if (this._scene && this._sceneHelper) {
            const mesh = this._scene.getMeshByID(meshID);
            if (mesh) {
                mesh.mustDepthSortFacets = enable;
            }
        }
    }
}
SceneEditor.EmptyGroupName = "_dummy_";


/***/ }),

/***/ "../../3D/src/Viewers/SceneViewer.ts":
/*!*******************************************!*\
  !*** ../../3D/src/Viewers/SceneViewer.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BroadcastChannelEventType": () => (/* binding */ BroadcastChannelEventType),
/* harmony export */   "SceneViewer": () => (/* binding */ SceneViewer)
/* harmony export */ });
/* harmony import */ var _Components_ActionExecutor_SceneActionExecutor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../Components/ActionExecutor/SceneActionExecutor */ "../../3D/src/Components/ActionExecutor/SceneActionExecutor.ts");
/* harmony import */ var _Components_CollapseExplode_MeshLocationsManager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../Components/CollapseExplode/MeshLocationsManager */ "../../3D/src/Components/CollapseExplode/MeshLocationsManager.ts");
/* harmony import */ var _Components_DesignManagers_SceneDesignManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../Components/DesignManagers/SceneDesignManager */ "../../3D/src/Components/DesignManagers/SceneDesignManager.ts");
/* harmony import */ var _Components_Draco_DracoCompression__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../Components/Draco/DracoCompression */ "../../3D/src/Components/Draco/DracoCompression.ts");
/* harmony import */ var _Components_Environment_EnvironmentManager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../Components/Environment/EnvironmentManager */ "../../3D/src/Components/Environment/EnvironmentManager.ts");
/* harmony import */ var _Components_Glow_GlowManager__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../Components/Glow/GlowManager */ "../../3D/src/Components/Glow/GlowManager.ts");
/* harmony import */ var _Components_InfoPointsManager_InfoPointsManager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../Components/InfoPointsManager/InfoPointsManager */ "../../3D/src/Components/InfoPointsManager/InfoPointsManager.ts");
/* harmony import */ var _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../Components/MaterialsPreview/MaterialsPreview */ "../../3D/src/Components/MaterialsPreview/MaterialsPreview.ts");
/* harmony import */ var _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../Components/SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
/* harmony import */ var _Components_ScenePreview_ScenePreview__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../Components/ScenePreview/ScenePreview */ "../../3D/src/Components/ScenePreview/ScenePreview.ts");
/* harmony import */ var _Components_Selector_ElementSelector__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../Components/Selector/ElementSelector */ "../../3D/src/Components/Selector/ElementSelector.ts");
/* harmony import */ var _Helpers_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../Helpers/utils */ "../../3D/src/Helpers/utils.ts");
/* harmony import */ var _Misc_Database__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../Misc/Database */ "../../3D/src/Misc/Database.ts");
/* harmony import */ var _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../Misc/DefaultAssetUrls */ "../../3D/src/Misc/DefaultAssetUrls.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};














var BroadcastChannelEventType;
(function (BroadcastChannelEventType) {
    BroadcastChannelEventType["CameraMovement"] = "camera-movement";
    BroadcastChannelEventType["ScriptExecution"] = "script-execution";
    BroadcastChannelEventType["DesignChanged"] = "design-changed";
})(BroadcastChannelEventType || (BroadcastChannelEventType = {}));
class SceneViewer {
    constructor(options) {
        // Zakeke Scene Model
        this._zkScene = null;
        // Zakeke Product Model
        this._zkModel = null;
        this._canvasID = "zakeke-canvas-viewer3D-" + Zakeke.makeID(5);
        this._canvas = null;
        this._domElement = null;
        this._lastWidth = Number.MIN_VALUE;
        this._lastHeight = Number.MIN_VALUE;
        this._engine = null;
        this._scene = null;
        this._bindedResize = null;
        this._sceneHelper = null;
        this._environmentManager = null;
        this._glowManager = null; // Gestisce l'effetto glow sulle mesh con materiali emissivi
        this._sceneActionsExecutor = null; // Esegue lo script di configurazione sulla scena
        this._renderingNeeded = false;
        this._renderingPaused = false;
        this._autoRender = false;
        this._antialias = true;
        this._postProcesses = [];
        this._camera = null;
        this._hemiLight = null;
        this._pointLight = null;
        this._highlightColor = "#00ff00";
        this._highlightSize = 2;
        this._highlightLayer = null;
        this._highlightBlurHorizontalSize = 1;
        this._highlightBlurVerticalSize = 1;
        this._highlightAnimationID = null;
        this._highlightCurrentMeshes = [];
        this._highlightNextMeshes = [];
        this._deviceType = MPlaza.DeviceType.All;
        this._destroyed = false;
        this._sceneDesignManager = null;
        this._meshLocationsManager = null;
        // Eventi
        this._groupPickedListeners = [];
        this._focusAttributesListeners = [];
        this._designNotifyMessageListeners = [];
        this._designRemoveMessageListeners = [];
        this._designEventMessages = [];
        this._onDelayLoadingStart = null;
        this._onDelayLoadingProgress = null;
        this._onDelayLoadingSuccess = null;
        this._onDelayLoadingError = null;
        this._infoPointPickedListeners = [];
        this._infoPointContentShownListeners = [];
        this._infoPointContentHiddenListeners = [];
        this._beginAssetsLoadingListeners = [];
        this._endAssetsLoadingListeners = [];
        this._beginSceneLoadingListeners = [];
        this._endSceneLoadingListeners = [];
        this._arFileUrls = {}; // cache degli url dei file per AR (USDZ, glb, glTF)
        this._configPreview = false;
        this._defaultBackgroundColor = null;
        this._grids = [];
        this._dracoCompression = null;
        this._infoPointsManager = null;
        this._infoPointsManagerStyle = null;
        this._canShowInfoPoints = true;
        this._canShowInfoPointsContent = true;
        this._broadcastChannel = null;
        this._isHologramSource = false;
        this._isHologram = false;
        this.setCameraLocked = (isBlocked) => {
            if (this._zkScene && this._sceneHelper && this._scene) {
                this._sceneHelper.setupCamera();
                this._camera = this._scene.activeCamera;
                if (this._camera) {
                    if (isBlocked) {
                        this._sceneHelper.setCameraLimitLowerRadius(true);
                        this._sceneHelper.setMinZoomPerc(1);
                        this._sceneHelper.setMaxZoomPerc(1);
                    }
                    else {
                        this._sceneHelper.setCameraLimitLowerRadius(false);
                        this._sceneHelper.setMinZoomPerc(1);
                        this._sceneHelper.setMaxZoomPerc(1.5);
                    }
                }
            }
        };
        if (options != undefined) {
            if (typeof options == "boolean")
                this._configPreview = options;
            else {
                this._configPreview = options.configPreview;
                if (options.defaultBackgroundColor)
                    this._defaultBackgroundColor = BABYLON.Color4.FromHexString(options.defaultBackgroundColor);
            }
        }
        this._elementSelector = new _Components_Selector_ElementSelector__WEBPACK_IMPORTED_MODULE_10__.ElementSelector();
        // metodo init reso asincrono, necessita factory method
        //this.init();
    }
    get zkScene() {
        return this._zkScene;
    }
    get zkModel() {
        return this._zkModel;
    }
    get canvas() {
        return this._canvas;
    }
    get engine() {
        return this._engine;
    }
    get scene() {
        return this._scene;
    }
    get autoRender() {
        return this._autoRender;
    }
    set autoRender(value) {
        this._autoRender = value;
    }
    get antialias() {
        return this._antialias;
    }
    set antialias(value) {
        this._antialias = value;
    }
    get isHologramSource() {
        return this.isHologramSource;
    }
    set isHologramSource(value) {
        this._isHologramSource = value;
        if (value) {
            this._isHologram = false;
            this.detachBroadcastChannelEventHandlers();
        }
    }
    get isHologram() {
        return this._isHologram;
    }
    set isHologram(value) {
        this._isHologram = value;
        if (value) {
            this._isHologramSource = false;
            this.attachBroadcastChannelEventHandlers();
        }
        else {
            this.detachBroadcastChannelEventHandlers();
        }
        this.refreshEnvironment();
    }
    getAntialiasEnabled() {
        let def = true;
        if (this._zkScene) {
            let val = this._zkScene.getAntialiasEnabled();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setAntialiasEnabled(value) {
        if (this._zkScene) {
            this._zkScene.setAntialiasEnabled(value);
            value ? this.enableAntialiasing() : this.disableAntialiasing();
        }
    }
    // Per coerenza con tutto il resto inserisco questi metodi set & get, 
    // andrebbero usate solo le proprietà, ma questo anche in SceneEditor
    getARScale() {
        let def = true;
        if (this._zkScene) {
            let val = this._zkScene.getARScale();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setARScale(value) {
        if (this._zkScene) {
            this._zkScene.setARScale(value);
        }
    }
    getUseMaterialOffloading() {
        let def = false;
        if (this.zkScene) {
            let val = this.zkScene.getUseMaterialOffloading();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setUseMaterialOffloading(value) {
        if (this._zkScene) {
            this._zkScene.setUseMaterialOffloading(value);
        }
    }
    getPrefetchMeshes() {
        const def = true;
        if (this.zkScene) {
            const val = this.zkScene.getPrefetchMeshes();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setPrefetchMeshes(value) {
        if (this._zkScene) {
            this._zkScene.setPrefetchMeshes(value);
        }
    }
    getPrefetchMaterials() {
        const def = true;
        if (this.zkScene) {
            const val = this.zkScene.getPrefetchMaterials();
            if (val === undefined || val === null)
                return def;
            return val;
        }
        return def;
    }
    setPrefetchMaterials(value) {
        if (this._zkScene) {
            this._zkScene.setPrefetchMaterials(value);
        }
    }
    getShowHideInfoPoints() {
        return this.canShowInfoPoints;
    }
    setShowHideInfoPoints(value) {
        this.canShowInfoPoints = value;
    }
    get camera() {
        return this._camera;
    }
    get deviceType() {
        return this._deviceType;
    }
    set deviceType(value) {
        this._deviceType = value;
    }
    getDeviceType() {
        return this.deviceType;
    }
    get highlightColor() {
        return this._highlightColor;
    }
    set highlightColor(value) {
        this._highlightColor = value;
    }
    get highlightSize() {
        return this._highlightSize;
    }
    set highlightSize(value) {
        this._highlightSize = value;
    }
    get destroyed() {
        return this._destroyed;
    }
    get onDelayLoadingStart() {
        return this._onDelayLoadingStart;
    }
    set onDelayLoadingStart(callback) {
        this._onDelayLoadingStart = callback;
    }
    get onDelayLoadingProgress() {
        return this._onDelayLoadingProgress;
    }
    set onDelayLoadingProgress(callback) {
        this._onDelayLoadingProgress = callback;
    }
    get onDelayLoadingSuccess() {
        return this._onDelayLoadingSuccess;
    }
    set onDelayLoadingSuccess(callback) {
        this._onDelayLoadingSuccess = callback;
    }
    get onDelayLoadingError() {
        return this._onDelayLoadingError;
    }
    set onDelayLoadingError(callback) {
        this._onDelayLoadingError = callback;
    }
    get dracoCompression() {
        if (!this._dracoCompression) {
            this._dracoCompression = _Components_Draco_DracoCompression__WEBPACK_IMPORTED_MODULE_3__.DracoCompression.Default;
            //this._dracoCompression = new DracoCompression(1);
        }
        return this._dracoCompression;
    }
    get infoPointsShown() {
        if (this._infoPointsManager)
            return this._infoPointsManager.infoPointsShown;
        return false;
    }
    get infoPointsManagerStyle() {
        return this._infoPointsManagerStyle;
    }
    set infoPointsManagerStyle(style) {
        this._infoPointsManagerStyle = style;
        this.updateInfoPointsManagerStyle();
    }
    get canShowInfoPoints() {
        return this._canShowInfoPoints;
    }
    set canShowInfoPoints(value) {
        this._canShowInfoPoints = value;
        this.refreshInfoPoints();
    }
    get canShowInfoPointsContent() {
        return this._canShowInfoPointsContent;
    }
    set canShowInfoPointsContent(value) {
        this._canShowInfoPointsContent = value;
        if (this._infoPointsManager)
            this._infoPointsManager.canShowInfoPointsContent = value;
    }
    static createSceneViewerAsync(options) {
        return __awaiter(this, void 0, void 0, function* () {
            const sceneViewer = new SceneViewer(options);
            yield sceneViewer.initAsync();
            return sceneViewer;
        });
    }
    dispose() {
        this.closeBroadcastChannel();
        this.removeCanvas();
        this.removeDomElement();
        this.deleteScene();
        this.deleteEngine();
    }
    initAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this._bindedResize = this.resize.bind(this);
            Zakeke.Tools.Init();
            BABYLON.Geometry.onDelayLoadingStart = (evt) => {
                if (this._onDelayLoadingStart)
                    this._onDelayLoadingStart(evt);
            };
            BABYLON.Geometry.onDelayLoadingProgress = (evt) => {
                if (this._onDelayLoadingProgress)
                    this._onDelayLoadingProgress(evt);
            };
            BABYLON.Geometry.onDelayLoadingSuccess = (evt) => {
                if (this._onDelayLoadingSuccess)
                    this._onDelayLoadingSuccess(evt);
            };
            BABYLON.Geometry.onDelayLoadingError = (evt) => {
                if (this._onDelayLoadingError)
                    this._onDelayLoadingError(evt);
            };
            BABYLON.Geometry.dracoDecodingFunction = (filename, dataToDecode, callback) => {
                this.dracoDecodingFunction(filename, dataToDecode, callback);
            };
            this.createCanvas();
            this.createDOMElement();
            yield this.init3DEngineAsync();
        });
    }
    init3DEngineAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            this.createEngine();
            yield this.createEmptySceneAsync();
            this._destroyed = false;
        });
    }
    createCanvas() {
        this._canvas = document.createElement('canvas');
        this._canvas.setAttribute("id", this._canvasID);
        this._canvas.setAttribute("touch-action", "none");
        this._canvas.addEventListener("dblclick", (e) => this.setRenderingNeeded());
        return this._canvas;
    }
    removeCanvas() {
        if (this._canvas) {
            this._canvas.remove();
            this._canvas = null;
        }
    }
    deleteEngine() {
        if (this._engine) {
            this._engine.dispose();
            this._engine = null;
        }
        this._destroyed = true;
        $(window).off("resize", this._bindedResize);
    }
    deleteScene() {
        this.deleteComponents();
        if (this._scene) {
            this._scene.dispose();
            this._scene = null;
        }
    }
    deleteComponents() {
        this.emptyArFileCache();
        this.disposeInfoPointsManager();
        if (this._meshLocationsManager) {
            this._meshLocationsManager.dispose();
            this._meshLocationsManager = null;
        }
        if (this._sceneDesignManager) {
            this._sceneDesignManager.dispose();
            this._sceneDesignManager = null;
        }
        if (this._sceneHelper) {
            this._sceneHelper.dispose();
            this._sceneHelper = null;
        }
        if (this._environmentManager) {
            this._environmentManager.dispose();
            this._environmentManager = null;
        }
        if (this._glowManager) {
            this._glowManager.dispose();
            this._glowManager = null;
        }
        if (this._sceneActionsExecutor) {
            this._sceneActionsExecutor.dispose();
            this._sceneActionsExecutor = null;
        }
        this.disposePostProcesses();
    }
    disposeInfoPointsManager() {
        if (this._infoPointsManager) {
            this._infoPointsManager.dispose();
            this._infoPointsManager = null;
        }
    }
    disposePostProcesses() {
        while (this._postProcesses.length > 0) {
            var postProcess = this._postProcesses.pop();
            if (postProcess)
                postProcess.dispose();
        }
    }
    emptyArFileCache() {
        this._arFileUrls = {};
    }
    resetSceneAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.init3DEngineAsync();
        });
    }
    closeBroadcastChannel() {
        if (this._broadcastChannel) {
            this._broadcastChannel.close();
            this._broadcastChannel = null;
        }
    }
    openBroadcastChannel() {
        if (!this._broadcastChannel && window['BroadcastChannel']) {
            try {
                this._broadcastChannel = new BroadcastChannel("zakeke-broadcast-channel");
            }
            catch (ex) {
                console.error('Failed opening broadcast channel');
                console.error(ex);
            }
        }
    }
    getOrCreateBroadcastChannel() {
        this.openBroadcastChannel();
        return this._broadcastChannel;
    }
    createEngine() {
        this.deleteScene();
        this.deleteEngine();
        // Se preserveDrawingBuffer = false (default) ci sono problemi nel recupero
        // dello screenshot. D'altra parte, preserveDrawingBuffer = true peggiora le 
        // performance in quanto WebGL è costretto a copiare e non a swappare i buffer di disegno (drawing)
        // e di visualizzazione.
        //this.engine = new BABYLON.Engine(this.canvas, true, { preserveDrawingBuffer: false });
        this._engine = new BABYLON.Engine(this._canvas, true, { stencil: true, preserveDrawingBuffer: true });
        this._engine.enableOfflineSupport = false;
        Logger.info("WebGL version: " + this._engine.webGLVersion);
        //BABYLON.SceneLoader.ForceFullSceneLoadingForIncremental = true;
        $(window).resize(this._bindedResize);
        $(window).on("orientationchange", () => { setTimeout(() => this._bindedResize(), 100); });
    }
    createEmptySceneAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            //this._zkScene = null;
            this.deleteScene();
            if (this._engine) {
                this._scene = new BABYLON.Scene(this._engine);
                if (this._defaultBackgroundColor) {
                    this._scene.clearColor.copyFrom(this._defaultBackgroundColor);
                }
                yield this.setupSceneAsync();
            }
        });
    }
    setupSceneAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._engine && this._scene) {
                this._sceneHelper = new _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_8__.SceneHelper(this._scene);
                const cameraPositionScale = this._zkScene ? this._zkScene.getCameraPositionScale() : undefined;
                const cameraLimitLowerRadius = this._zkScene ? this._zkScene.getCameraLimitLowerRadius() : undefined;
                const zoomEnabled = this._zkScene ? this._zkScene.getCameraZoomEnabled() : undefined;
                const useMinZoomPerc = this._zkScene ? this._zkScene.getCameraUseMinZoomPerc() : false;
                const minZoomPerc = this._zkScene ? this._zkScene.getCameraMinZoomPerc() : 1.0;
                const useMaxZoomPerc = this._zkScene ? this._zkScene.getCameraUseMaxZoomPerc() : false;
                const maxZoomPerc = this._zkScene ? this._zkScene.getCameraMaxZoomPerc() : 1.5;
                const lowerAlphaLimit = this._zkScene ? this._zkScene.getCameraLowerAlphaLimit() : null;
                const upperAlphaLimit = this._zkScene ? this._zkScene.getCameraUpperAlphaLimit() : null;
                const lowerBetaLimit = this._zkScene ? this._zkScene.getCameraLowerBetaLimit() : null;
                const upperBetaLimit = this._zkScene ? this._zkScene.getCameraUpperBetaLimit() : null;
                if (cameraPositionScale != undefined && cameraPositionScale != null)
                    this._sceneHelper.setCameraPositionScale(cameraPositionScale, false);
                if (cameraLimitLowerRadius != undefined && cameraLimitLowerRadius != null)
                    this._sceneHelper.setCameraLimitLowerRadius(cameraLimitLowerRadius, false);
                if (zoomEnabled != undefined && zoomEnabled != null)
                    this._sceneHelper.setZoomEnabled(zoomEnabled);
                this._sceneHelper.setupCamera();
                this._camera = this._scene.activeCamera;
                if (this._camera) {
                    if (useMinZoomPerc)
                        this._sceneHelper.setMinZoomPerc(minZoomPerc);
                    else
                        this._sceneHelper.setMinZoomPerc(null);
                    if (useMaxZoomPerc)
                        this._sceneHelper.setMaxZoomPerc(maxZoomPerc);
                    else
                        this._sceneHelper.setMaxZoomPerc(null);
                    this._sceneHelper.setCameraAlphaLimits(lowerAlphaLimit, upperAlphaLimit);
                    this._sceneHelper.setCameraBetaLimits(lowerBetaLimit, upperBetaLimit);
                    this._camera.onViewMatrixChangedObservable.add(() => {
                        this.notifyCameraMovement();
                    });
                    this._camera.onRestoreStateObservable.add(() => {
                        this.setupShaderMaterialsCameraPosition();
                        this.setRenderingNeeded();
                    });
                }
                this._sceneHelper.setupLights();
                this.createHighlightLayer();
                this.fixEnvironmentTexture();
                this.refreshEnvironment();
                this.setupGlowManager();
                if (this._zkScene) {
                    this._meshLocationsManager = new _Components_CollapseExplode_MeshLocationsManager__WEBPACK_IMPORTED_MODULE_1__.MeshLocationsManager();
                    this._meshLocationsManager.setModelAndScene(this._zkScene, this._scene);
                    this._meshLocationsManager.addMeshAnimationCompletedListener(() => this.setRenderingNeeded());
                }
                yield this.setupSceneActionsExecutorAsync();
                this.setRenderingOnDelayLoaded();
                this.setupAntialiasPostProcesses();
                this._scene.onPointerDown = (evt, pickInfo) => this.onPointerDown(evt, pickInfo);
                this._scene.registerBeforeRender(() => {
                    this.onBeforeRender();
                });
                this.refreshInfoPoints();
                // Stop the automatic rendering
                this._engine.stopRenderLoop();
                // Render the first frame.
                this.render();
                //start main render loop
                this._engine.runRenderLoop(() => { this.checkRendering(); });
                /*
                this.engine.runRenderLoop(function() {
                    this._scene.render();
                });
                */
            }
        });
    }
    onBeforeRender() {
        if (this._scene && this._sceneHelper) {
            if (this._camera) {
                const pointLight = this._sceneHelper.getDefaultPointLight();
                if (pointLight)
                    pointLight.position = this._camera.position;
            }
            this._scene.meshes.forEach(m => {
                if (m.mustDepthSortFacets && m.isFacetDataEnabled)
                    m.updateFacetData();
            });
        }
    }
    render() {
        if (this._scene && !this._scene.isDisposed && !this._renderingPaused)
            this._scene.render();
    }
    // Disabilito il post-processing quando la camera è in movimento 
    checkRendering() {
        if (this._scene) {
            if (this._autoRender ||
                this._renderingNeeded ||
                this._scene._activeAnimatables.length !== 0 ||
                (this._sceneHelper && this._sceneHelper.userIsMoving())) {
                if (this._autoRender ||
                    this._scene._activeAnimatables.length !== 0 ||
                    (this._sceneHelper && this._sceneHelper.userIsMoving() /*&& !this.sceneHelper.cameraLimitsReached()*/)) {
                    this.disableAntialiasing();
                }
                else
                    this.enableAntialiasing();
                this.render();
                if (this._renderingNeeded)
                    this._renderingNeeded = false;
            }
            else {
                if (!this._scene.postProcessesEnabled && this.canEnableAntialiasing()) {
                    this.enableAntialiasing();
                    this.render();
                }
            }
            if (this._infoPointsManager) {
                const updated = this._infoPointsManager.updateInfoPointsVisibility();
                if (updated)
                    this.render();
            }
        }
    }
    setupAntialiasPostProcesses() {
        if (this._antialias && this.getAntialiasEnabled()) {
            this.createAntialiasPostProcesses();
        }
    }
    createAntialiasPostProcesses() {
        if (this._camera && this._postProcesses.length === 0) {
            var is_firefox = /firefox/i.test(navigator.userAgent);
            if (!is_firefox)
                this._postProcesses.push(new BABYLON.PassPostProcess("scale_pass", 4.0, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE));
            this._postProcesses.push(new BABYLON.PassPostProcess("scale_pass", 2.0, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE));
            this._postProcesses.push(new BABYLON.PassPostProcess("scale_pass", 1.0, this._camera, BABYLON.Texture.BILINEAR_SAMPLINGMODE));
        }
    }
    canEnableAntialiasing() {
        return (this._scene && this._antialias && this.getAntialiasEnabled());
    }
    enableAntialiasing() {
        if (this._scene && this.canEnableAntialiasing()) {
            this.createAntialiasPostProcesses();
            this._scene.postProcessesEnabled = true;
        }
    }
    disableAntialiasing(clearPostProcessed = false) {
        if (this._scene && this._antialias) {
            this._scene.postProcessesEnabled = false;
        }
        if (clearPostProcessed)
            this.disposePostProcesses();
    }
    setRenderingNeeded() {
        this._renderingNeeded = true;
    }
    setLongRenderingNeeded() {
        this.setRenderingNeeded();
        for (let t = 50; t <= 1000; t += 200) {
            setTimeout(() => this.setRenderingNeeded(), t);
        }
    }
    refreshRendering() {
        this.setLongRenderingNeeded();
    }
    pauseRendering() {
        this._renderingPaused = true;
    }
    resumeRendering() {
        this._renderingPaused = false;
        this.setRenderingNeeded();
    }
    setLoadingScreen(loadingScreen) {
        if (this._engine)
            this._engine.loadingScreen = loadingScreen;
    }
    setRenderingOnDelayLoaded() {
        if (this._scene) {
            var _this = this;
            this._scene.getGeometries().forEach(function (geometry) {
                var origCallback = geometry.onGeometryUpdated;
                geometry.onGeometryUpdated = function (geom, kind) {
                    _this.setLongRenderingNeeded();
                    if (origCallback)
                        origCallback.apply(this, [geom, kind]);
                };
            });
        }
    }
    createHighlightLayer() {
        if (this._scene) {
            this._highlightLayer = new BABYLON.HighlightLayer("hl1", this._scene);
            this.setupHighlightLayerIntensity();
        }
    }
    setupHighlightLayerIntensity() {
        if (this._highlightLayer) {
            this._highlightLayer.blurHorizontalSize = this._highlightSize;
            this._highlightLayer.blurVerticalSize = this._highlightSize;
            this._highlightBlurHorizontalSize = this._highlightSize;
            this._highlightBlurVerticalSize = this._highlightSize;
        }
    }
    createDOMElement() {
        if (this._canvas) {
            this._domElement = document.createElement('div');
            this._domElement.setAttribute("id", "zakeke-canvas-viewer3D-div-" + Zakeke.makeID(5));
            this._domElement.appendChild(this._canvas);
            this._domElement.style.position = "absolute";
            this._domElement.style.width = "100%";
            this._domElement.style.height = "100%";
            this._domElement.style.left = "0";
            this._domElement.style.top = "0";
        }
    }
    removeDomElement() {
        if (this._domElement) {
            this.detach();
            this._domElement.remove();
            this._domElement = null;
        }
    }
    appendTo(element) {
        if (this._domElement) {
            if (element.firstChild)
                element.insertBefore(this._domElement, element.firstChild);
            else
                element.appendChild(this._domElement);
            element.appendChild(this._domElement);
            // Senza la doppia chiamata al resize si hanno dei problemi su mobile
            // In particolare gli eventi vengono catturati ad una frequenza molto bassa
            this.resize();
            this.resize();
        }
    }
    detach() {
        if (this._domElement && this._domElement.parentNode)
            this._domElement.parentNode.removeChild(this._domElement);
    }
    updateView(adjustCamera = true) {
        this.resize(adjustCamera);
    }
    resize(adjustCamera = true) {
        if (!this._canvas)
            return;
        this.disableAntialiasing(true);
        var parent = this._canvas.parentNode;
        if (!parent || !(parent instanceof HTMLElement))
            return;
        var parentWidth = parent.offsetWidth;
        var parentHeight = parent.offsetHeight;
        // Avoid adjusting camera when we trigger the resize and nothing as changed
        if (parentWidth != this._lastWidth || parentHeight != this._lastHeight) {
            this._canvas.style.width = "100%";
            this._canvas.style.height = "100%";
            if (this._engine) {
                this._engine.resize();
                if (adjustCamera) {
                    if (this._scene)
                        this.adjustCamera(false);
                    this.setupShaderMaterialsCameraPosition();
                }
                this.setRenderingNeeded();
            }
            //Logger.info("SceneViewer.resize - Canvas width: " + this._canvas.width + " - height: " + this._canvas.height);
        }
        this._lastWidth = parentWidth;
        this._lastHeight = parentHeight;
        this.enableAntialiasing();
    }
    switchFullScreen(parent) {
        if (this._sceneHelper)
            this._sceneHelper.switchFullScreen(parent);
    }
    setupGlowManager() {
        if (this._glowManager) {
            this._glowManager.dispose();
            this._glowManager = null;
        }
        if (this._zkScene && this._scene) {
            this._glowManager = new _Components_Glow_GlowManager__WEBPACK_IMPORTED_MODULE_5__.GlowManager(this._zkScene, this._scene);
            this._glowManager.update();
            this.setRenderingNeeded();
        }
    }
    setupSceneActionsExecutorAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._zkScene && this._scene) {
                this._sceneActionsExecutor = new _Components_ActionExecutor_SceneActionExecutor__WEBPACK_IMPORTED_MODULE_0__.SceneActionsExecutor(this._zkScene, this._scene);
                this._sceneActionsExecutor.deviceType = this.deviceType;
                this._sceneActionsExecutor.useMaterialOffloading = !this._configPreview && this.getUseMaterialOffloading();
                this._sceneActionsExecutor.prefetchMeshes = this.getPrefetchMeshes();
                this._sceneActionsExecutor.prefetchMaterials = this.getPrefetchMaterials();
                this._sceneActionsExecutor.addMeshDesignRefreshRequiredListeners((evt) => __awaiter(this, void 0, void 0, function* () {
                    yield this.refreshMeshesDesignAsync(evt.meshes, evt.effect);
                }));
                this._sceneActionsExecutor.addBeginAssetsLoadingListener(() => this.fireBeginAssetsLoadingEvent());
                this._sceneActionsExecutor.addEndAssetsLoadingListener(() => this.fireEndAssetsLoadingEvent());
            }
        });
    }
    restoreCameraState() {
        if (this._sceneHelper) {
            this._sceneHelper.restoreCameraState();
            this._sceneHelper.setupShaderMaterialsCameraPosition();
            this.setRenderingNeeded();
        }
    }
    fixEnvironmentTexture() {
        if (this._scene && this._scene.environmentTexture && this._scene.environmentTexture["url"] && typeof this._scene.environmentTexture["url"] === "string") {
            const url = this._scene.environmentTexture["url"];
            const count = (url.match(/http/g) || []).length;
            let newUrl = url;
            if (count > 1) {
                let idx = url.lastIndexOf("http");
                if (idx >= 0) {
                    newUrl = url.substring(idx);
                }
            }
            // Le informazioni sulla rotazione e sugli eventuali file della cubemap sono salvati
            // nei metadatadi della scena perché c'è un bug babylon in fase di serializzazione.
            // Li recupero ler settarli sull'environment con l'url sistemato
            let rotationY = undefined;
            let extensions = undefined;
            let files = undefined;
            if (this._scene && this._scene.metadata) {
                if (this._scene.metadata.environmentTextureRotationY !== undefined && typeof this._scene.metadata.environmentTextureRotationY === "number") {
                    rotationY = this._scene.metadata.environmentTextureRotationY;
                }
                if (this._scene.metadata.environmentTextureExtensions)
                    extensions = this._scene.metadata.environmentTextureExtensions;
                if (this._scene.metadata.environmentTextureFiles)
                    files = this._scene.metadata.environmentTextureFiles;
            }
            this.setSceneEnvironmentTexture(newUrl, rotationY, extensions, files);
        }
        else {
            this.checkSceneEmptyEnvironmentTexture();
        }
    }
    checkSceneEmptyEnvironmentTexture() {
        // Controlla se la scena contiene materiali PBR ma ha la EnvironmentTexture vuota
        if (this._scene && this._sceneHelper && this._sceneHelper.containsPBRMaterials() && !this._scene.environmentTexture) {
            this.setDefaultSceneEnvironmentTexture();
        }
    }
    setDefaultSceneEnvironmentTexture() {
        const url = _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_13__.DefaultAssetUrls.Environment.EnvironmentTextureCDNUrl;
        this.setSceneEnvironmentTexture(url);
    }
    setSceneEnvironmentTexture(url, rotationY, extensions, files, onLoad) {
        if (this._scene && this._sceneHelper) {
            if (this._scene.environmentTexture &&
                this._sceneHelper.isTextureWithUrl(this._scene.environmentTexture) &&
                this._scene.environmentTexture.url &&
                this._scene.environmentTexture.url != url) {
                this._scene.environmentTexture.dispose();
                this._scene.environmentTexture = null;
            }
            const onImagesLoad = () => {
                if (onLoad)
                    onLoad();
                this.setLongRenderingNeeded();
            };
            if (!this._scene.metadata)
                this._scene.metadata = {};
            delete this._scene.metadata.environmentTextureType;
            delete this._scene.metadata.environmentTextureSize;
            delete this._scene.metadata.environmentTextureExtensions;
            delete this._scene.metadata.environmentTextureFiles;
            //const environmentTexture = new BABYLON.CubeTexture(url, this._scene, undefined, undefined, undefined, undefined, () => { this.setLongRenderingNeeded() });
            let environmentTexture = null;
            if (url.endsWith(".dds"))
                environmentTexture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene);
            else if (url.endsWith(".hdr")) {
                environmentTexture = new BABYLON.HDRCubeTexture(url, this._scene, 128, undefined, undefined, undefined, undefined, onImagesLoad);
                this._scene.metadata.environmentTextureType = "BABYLON.HDRCubeTexture";
                this._scene.metadata.environmentTextureSize = 128;
            }
            else if (url.endsWith(".env")) {
                //texture = new BABYLON.CubeTexture(url, this._scene);
                //texture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene, undefined, undefined);
                environmentTexture = new BABYLON.CubeTexture(url, this._scene, null, false, null, onImagesLoad, null, undefined, true, undefined, true);
                //texture = new BABYLON.CubeTexture(url, this._scene, undefined, undefined, undefined, undefined, onImagesLoad);
            }
            else if (url.endsWith(".basis")) {
                environmentTexture = BABYLON.CubeTexture.CreateFromPrefilteredData(url, this._scene);
            }
            else if (extensions && extensions.length === 6 && files && files.length === 6) {
                environmentTexture = new BABYLON.CubeTexture(url, this._scene, extensions, false, files, onImagesLoad);
                this._scene.metadata.environmentTextureExtensions = extensions;
                this._scene.metadata.environmentTextureFiles = files;
            }
            if (environmentTexture) {
                _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_8__.SceneHelper.whenTextureIsReadyAsync(environmentTexture).then(() => {
                    if (environmentTexture && this._scene) {
                        if (rotationY != undefined)
                            environmentTexture.rotationY = rotationY;
                        else {
                            if (this._scene.metadata && this._scene.metadata.environmentTextureRotationY != undefined)
                                delete this._scene.metadata.environmentTextureRotationY;
                        }
                        this._scene.environmentTexture = environmentTexture;
                        // TEST Default SkyBox
                        //this._scene.createDefaultSkybox(this._scene.environmentTexture, true, (this._scene.activeCamera!.maxZ - this._scene.activeCamera!.minZ) / 2, 0.3, false);
                        //this._scene.createDefaultSkybox(this._scene.environmentTexture, true, (this._scene.activeCamera!.maxZ - this._scene.activeCamera!.minZ) / 2, 0.1, false);
                        this.setRenderingNeeded();
                    }
                });
            }
        }
    }
    loadSceneFromModelAsync(zkModel, zkScene, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (zkModel && zkModel instanceof MPlaza.Model) {
                this._zkModel = zkModel;
            }
            if (zkScene && zkScene instanceof Zakeke.Scene) {
                this._zkScene = zkScene;
                this.checkSceneShaderMaterials(zkScene);
                const rootUrl = zkScene.get("rootUrl");
                const sceneFileName = zkScene.get("sceneFileName");
                if (rootUrl && sceneFileName)
                    yield this.loadSceneFromRemoteFilesAsync(rootUrl, sceneFileName, onProgress);
            }
        });
    }
    loadSceneFromModelDataAsync(zkModel, zkScene, sceneJson, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (zkModel && zkModel instanceof MPlaza.Model) {
                this._zkModel = zkModel;
            }
            if (zkScene && zkScene instanceof Zakeke.Scene) {
                this._zkScene = zkScene;
                this.checkSceneShaderMaterials(zkScene);
                var sceneFileName = "data:" + sceneJson;
                const rootUrl = zkScene.get("rootUrl");
                if (rootUrl)
                    yield this.loadSceneFromRemoteFilesAsync(rootUrl, sceneFileName, onProgress);
            }
        });
    }
    preSceneFileLoading() {
    }
    postSceneFileLoading() {
    }
    // Carica la scena Babylon JS tramite rootUrl e sceneFilename
    // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
    // il path in base a rootUrl e al nome della texture
    // textureUrl = rootUrl + texture.name
    loadSceneFromRemoteFilesAsync(rootUrl, sceneFileName, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._engine)
                throw new Error("Unable to load scene when the 3D engine is null");
            try {
                this.fireBeginSceneLoadingEvent();
                this.preSceneFileLoading();
                this.pauseRendering();
                // Per problema useDelayedTextureLoading
                this._engine["sceneFileRootUrl"] = rootUrl;
                let newScene = yield BABYLON.SceneLoader.LoadAsync(rootUrl, sceneFileName, this._engine, onProgress);
                if (this._destroyed) {
                    Logger.info("Loading scene engine destroyed");
                    newScene.dispose();
                    return;
                }
                yield new Promise(resolve => newScene.executeWhenReady(() => resolve()));
                if (this._destroyed) {
                    Logger.info("Loading scene engine destroyed");
                    newScene.dispose();
                    throw new Error("Engine destroyed while loading scene");
                }
                const requireDelayLoading = _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_8__.SceneHelper.visibleMeshesRequireDelayedLoading(newScene);
                if (requireDelayLoading)
                    this.fireBeginAssetsLoadingEvent();
                yield _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_8__.SceneHelper.whenAllVisibleMeshesAreReadyAsync(newScene);
                if (requireDelayLoading)
                    this.fireEndAssetsLoadingEvent();
                this.deleteScene();
                this._scene = newScene;
                // useDelayedTextureLoading
                for (let i = 0; i < this._scene.textures.length; i++) {
                    const texture = this._scene.textures[i];
                    if (texture instanceof BABYLON.Texture) {
                        if (texture.onLoadObservable) {
                            texture.onLoadObservable.add((txt) => {
                                this.setLongRenderingNeeded();
                            });
                        }
                    }
                }
                yield this.setupSceneAsync();
                if (this._sceneHelper) {
                    // Carico i materiali delayed
                    if (this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials) {
                        yield this._sceneHelper.loadAllDelayedMaterialsAsync(rootUrl);
                    }
                    // Carico gli eventuali materiali offloaded
                    if (this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
                        this._sceneHelper.loadAllOffloadedMaterials(rootUrl);
                    }
                    // Ripristino i materiali originali per le mesh nascoste
                    if (this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
                        this._sceneHelper.unsetAllDummyMaterials();
                    }
                    this._sceneHelper.setupShaderMaterialsCameraPosition();
                    // Trying to reload texture with loading errors
                    try {
                        yield this.reloadAllLoadingErrorTexturesAsync();
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
                if (this._environmentManager) {
                    const skyboxTexture = this._environmentManager.getSkyboxTexture();
                    if (skyboxTexture) {
                        yield _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_8__.SceneHelper.whenTextureIsReadyAsync(skyboxTexture);
                    }
                }
            }
            finally {
                this.resumeRendering();
                this.postSceneFileLoading();
                this.fireEndSceneLoadingEvent();
            }
        });
    }
    getSkyboxTexture() {
        var _a;
        return (_a = this._environmentManager) === null || _a === void 0 ? void 0 : _a.getSkyboxTexture();
    }
    // Carica la scena Babylon JS tramite rootUrl e sceneFilename
    // La scena verrà caricata direttamente da Babylon JS. Le texture verranno lette risolvendo
    // il path in base a rootUrl e al nome della texture
    // textureUrl = rootUrl + texture.name
    loadSceneFromRemoteFilesAsync_OLD(rootUrl, sceneFileName, onProgress) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (!this._engine)
                    reject();
                this.preSceneFileLoading();
                // Per problema useDelayedTextureLoading
                this._engine["sceneFileRootUrl"] = rootUrl;
                let newScene = yield BABYLON.SceneLoader.LoadAsync(rootUrl, sceneFileName, this._engine, onProgress);
                if (this._destroyed) {
                    Logger.info("Loading scene engine destroyed");
                    newScene.dispose();
                    return;
                }
                newScene.executeWhenReady(() => __awaiter(this, void 0, void 0, function* () {
                    if (this._destroyed) {
                        Logger.info("Loading scene engine destroyed");
                        newScene.dispose();
                        reject();
                    }
                    const requireDelayLoading = _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_8__.SceneHelper.visibleMeshesRequireDelayedLoading(newScene);
                    if (requireDelayLoading)
                        this.fireBeginAssetsLoadingEvent();
                    yield _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_8__.SceneHelper.whenAllVisibleMeshesAreReadyAsync(newScene);
                    if (requireDelayLoading)
                        this.fireEndAssetsLoadingEvent();
                    this.deleteScene();
                    this._scene = newScene;
                    // useDelayedTextureLoading
                    for (let i = 0; i < this._scene.textures.length; i++) {
                        const texture = this._scene.textures[i];
                        if (texture instanceof BABYLON.Texture) {
                            if (texture.onLoadObservable) {
                                texture.onLoadObservable.add((txt) => {
                                    this.setLongRenderingNeeded();
                                });
                            }
                        }
                    }
                    yield this.setupSceneAsync();
                    if (this._sceneHelper) {
                        // Carico i materiali delayed
                        if (this._configPreview && this._scene.metadata && this._scene.metadata.delayedMaterials) {
                            yield this._sceneHelper.loadAllDelayedMaterialsAsync(rootUrl);
                        }
                        // Carico gli eventuali materiali offloaded
                        if (this._configPreview && this._scene.metadata && this._scene.metadata.offloadedMaterials) {
                            this._sceneHelper.loadAllOffloadedMaterials(rootUrl);
                        }
                        // Ripristino i materiali originali per le mesh nascoste
                        if (this._configPreview && this._scene.metadata && this._scene.metadata.originalMeshMaterials) {
                            this._sceneHelper.unsetAllDummyMaterials();
                        }
                        this._sceneHelper.setupShaderMaterialsCameraPosition();
                    }
                    this.postSceneFileLoading();
                    resolve();
                }));
            }));
        });
    }
    checkSceneShaderMaterials(zkScene) {
        if (zkScene instanceof Zakeke.Scene && zkScene.get("shaderMaterials")) {
            for (let i = 0; i < zkScene.get("shaderMaterials").length; i++) {
                const shaderMaterial = zkScene.get("shaderMaterials").at(i);
                const name = shaderMaterial.get("name");
                const vertex = shaderMaterial.get("vertex");
                const fragment = shaderMaterial.get("fragment");
                if (name && vertex && fragment) {
                    const shaderInfo = { name, vertex, fragment };
                    this.setupShadersStore(shaderInfo);
                }
            }
        }
    }
    checkShaderMaterial(zkMaterial) {
        if (zkMaterial && zkMaterial instanceof Zakeke.Material) {
            let shaders = zkMaterial.get("shaders");
            if (shaders) {
                const name = zkMaterial.get("shaders").get("name");
                const vertex = zkMaterial.get("shaders").get("vertex");
                const fragment = zkMaterial.get("shaders").get("fragment");
                if (name && vertex && fragment) {
                    const shaderInfo = { name, vertex, fragment };
                    this.setupShadersStore(shaderInfo);
                }
            }
        }
    }
    setupShadersStore(shaderInfo) {
        if (shaderInfo && shaderInfo.hasOwnProperty("name") && shaderInfo.hasOwnProperty("vertex") && shaderInfo.hasOwnProperty("fragment")) {
            var vertexPath = shaderInfo.name + "VertexShader";
            var fragmentPath = shaderInfo.name + "FragmentShader";
            BABYLON.Effect.ShadersStore[vertexPath] = shaderInfo.vertex;
            BABYLON.Effect.ShadersStore[fragmentPath] = shaderInfo.fragment;
        }
    }
    isRealMesh(mesh) {
        if (this._sceneHelper)
            return this._sceneHelper.isRealMesh(mesh);
        return false;
    }
    countSceneMeshes() {
        return this._sceneHelper ? this._sceneHelper.countSceneMeshes() : 0;
    }
    getVisibleMeshes() {
        return this._sceneHelper ? this._sceneHelper.getVisibleMeshes() : [];
    }
    getSceneBoundingInfo() {
        if (this._sceneHelper)
            return this._sceneHelper.getSceneBoundingInfo();
        return null;
    }
    selectMesh(id) {
        this.selectUnselectMesh(id, true);
    }
    unselectMesh(id) {
        this.selectUnselectMesh(id, false);
    }
    unselectAllMeshes() {
        if (this._scene) {
            this._scene.meshes.forEach((mesh) => this.unselectSingleMesh(mesh));
            this.fireFocusAttributesEvent({ groups: [] });
        }
    }
    selectUnselectMesh(id, select) {
        if (this._scene) {
            this._scene.meshes.forEach(mesh => this.unselectSingleMesh(mesh));
            if (select) {
                let selectWithChildren = (parent) => {
                    this.selectSingleMesh(parent);
                    const children = parent.getChildMeshes();
                    if (children) {
                        children.forEach(child => selectWithChildren(child));
                    }
                };
                const mesh = this._scene.getMeshByID(id);
                if (mesh) {
                    selectWithChildren(mesh);
                    const group = this.getGroupForMesh(mesh);
                    if (group) {
                        this.highlightGroupForMesh(mesh);
                        this.fireGroupPickedEvent({ groupID: group.get("groupID") });
                    }
                    var groups = this.getVisibleHiddenAttributesForMesh(mesh);
                    this.fireFocusAttributesEvent({ groups: groups });
                    if (groups.length > 0)
                        this.highlightMeshes([mesh]);
                }
            }
        }
    }
    selectSingleMesh(mesh) {
        this.setRenderingNeeded();
        mesh["selected"] = true;
    }
    unselectSingleMesh(mesh) {
        this.setRenderingNeeded();
        mesh["selected"] = false;
    }
    selectMeshesWithMaterial(materialID) {
        this.selectUnselectMeshesWithMaterial(materialID, true);
    }
    unselectMeshesWithMaterial(materialID) {
        this.selectUnselectMeshesWithMaterial(materialID, false);
    }
    selectUnselectMeshesWithMaterial(materialID, select) {
        if (!this._scene)
            return;
        this._scene.meshes.forEach(mesh => this.unselectSingleMesh(mesh));
        if (select) {
            let checkMeshWithChildren = (parent) => {
                if (parent.material && parent.material.id === materialID)
                    this.selectSingleMesh(parent);
                const children = parent.getChildMeshes();
                if (children) {
                    children.forEach(child => {
                        checkMeshWithChildren(child);
                    });
                }
            };
            this._scene.meshes.forEach(mesh => {
                checkMeshWithChildren(mesh);
            });
        }
    }
    onPointerDown(evt, pickInfo) {
        if (pickInfo.hit && pickInfo.pickedMesh) {
            this.selectMesh(pickInfo.pickedMesh.id);
        }
        else {
            this.unselectAllMeshes();
        }
    }
    getSelectedRootMesh() {
        if (this._scene) {
            for (let i = 0; i < this._scene.meshes.length; i++) {
                const mesh = this._scene.meshes[i];
                if (mesh["selected"]) {
                    const parent = mesh.parent;
                    if (!parent || !parent["selected"])
                        return mesh;
                }
            }
        }
        return null;
    }
    getMeshByID(id) {
        if (this._scene)
            return this._scene.getMeshByID(id);
        return null;
    }
    getMeshByName(id) {
        if (this._scene)
            return this._scene.getMeshByName(id);
        return null;
    }
    getMaterialByID(id) {
        if (this._scene)
            return this._scene.getMaterialByID(id);
        return null;
    }
    setCameraLocation(locationID, onlyAngleOfView = false, animate = true) {
        if (this._zkScene && this._sceneHelper) {
            const zkCameraLocation = this._zkScene.getCameraLocation(locationID);
            if (zkCameraLocation) {
                const position = new BABYLON.Vector3(zkCameraLocation.get("px"), zkCameraLocation.get("py"), zkCameraLocation.get("pz"));
                const target = new BABYLON.Vector3(zkCameraLocation.get("tx"), zkCameraLocation.get("ty"), zkCameraLocation.get("tz"));
                if (animate) {
                    // Animation
                    if (!onlyAngleOfView) {
                        this._sceneHelper.animateCamera(target, position, 0.5);
                    }
                    else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
                        const angleOfView = this._sceneHelper.computeCameraAngleOfView(target, position);
                        this._sceneHelper.animateCameraToFinalParamters(angleOfView.alpha, angleOfView.beta, this._camera.radius, this._camera.target, 0.5);
                    }
                }
                else {
                    // No animation
                    if (!onlyAngleOfView) {
                        this._sceneHelper.moveCamera(target, position);
                    }
                    else if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
                        const angleOfView = this._sceneHelper.computeCameraAngleOfView(target, position);
                        this._sceneHelper.moveCameraToFinalParameters(angleOfView.alpha, angleOfView.beta, this._camera.radius, this._camera.target);
                    }
                }
            }
        }
        this.setRenderingNeeded();
    }
    adjustCamera(animate) {
        if (this._sceneHelper) {
            if (animate != undefined && animate != null && typeof (animate) === "boolean")
                this._sceneHelper.adjustCamera(undefined, undefined, undefined, animate);
            else
                this._sceneHelper.adjustCamera();
            this.setupShaderMaterialsCameraPosition();
            this.setRenderingNeeded();
        }
    }
    zoomIn() {
        if (this._sceneHelper)
            this._sceneHelper.zoomIn();
    }
    zoomOut() {
        if (this._sceneHelper)
            this._sceneHelper.zoomOut();
    }
    zoom(perc) {
        if (this._sceneHelper)
            this._sceneHelper.zoom(perc);
    }
    setCameraPivot(meshID) {
        if (this._scene && this._sceneHelper) {
            const mesh = meshID ? this._scene.getMeshByID(meshID) : null;
            this._sceneHelper.setCameraPivot(mesh);
        }
    }
    setCameraZoomEnabled(enabled) {
        if (this._scene && this._sceneHelper) {
            this._sceneHelper.setZoomEnabled(enabled);
            this.setRenderingNeeded();
        }
    }
    executeScriptAsync(script) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneActionsExecutor) {
                yield this._sceneActionsExecutor.executeScriptAsync(script);
                this.notifyScriptExecution(script);
                this.setupShaderMaterialsCameraPosition();
                this.refreshInfoPoints();
                this.setLongRenderingNeeded();
            }
        });
    }
    executeActionsAsync(attributeID, selectedValue, actions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneActionsExecutor) {
                yield this._sceneActionsExecutor.executeActionsAsync(attributeID, selectedValue, actions);
                this.notifyActionExecution(attributeID, selectedValue, actions);
                this.setupShaderMaterialsCameraPosition();
                this.refreshInfoPoints();
                this.setLongRenderingNeeded();
            }
        });
    }
    prefetchMeshesForUnselectedOptionsAsync(actions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneActionsExecutor)
                yield this._sceneActionsExecutor.prefetchMeshesForUnselectedOptionsAsync(actions);
        });
    }
    prefetchDataForUnselectedOptionsAsync(actions) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneActionsExecutor)
                yield this._sceneActionsExecutor.prefetchDataForUnselectedOptionsAsync(actions);
        });
    }
    refreshEnvironment() {
        if (this._zkScene && this._scene) {
            if (!this._environmentManager || this._environmentManager.scene != this._scene || this._environmentManager.isHologram != this._isHologram)
                this._environmentManager = new _Components_Environment_EnvironmentManager__WEBPACK_IMPORTED_MODULE_4__.EnvironmentManager(this._zkScene, this._scene, this._isHologram);
            this._environmentManager.update();
            this.setLongRenderingNeeded();
            if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera)
                this._autoRender = this._camera.useAutoRotationBehavior;
            this.setRenderingNeeded();
        }
    }
    highlightMeshes(meshes) {
        if (!meshes || Object.prototype.toString.call(meshes) !== '[object Array]' || this._highlightSize == 0)
            return;
        const startHorSize = this._highlightBlurHorizontalSize;
        const startVerSize = this._highlightBlurVerticalSize;
        const addWithChildren = (parent) => {
            if (parent.isVisible && this._highlightLayer)
                this._highlightLayer.addMesh(parent, BABYLON.Color3.FromHexString(this._highlightColor));
            const children = parent.getChildMeshes();
            children.forEach(child => {
                if (child instanceof BABYLON.Mesh)
                    addWithChildren(child);
            });
        };
        const removeWithChildren = (parent) => {
            if (this._highlightLayer)
                this._highlightLayer.removeMesh(parent);
            const children = parent.getChildMeshes();
            children.forEach((child) => {
                if (child instanceof BABYLON.Mesh)
                    removeWithChildren(child);
            });
        };
        // Ferma l'eventuale highlighting in corso e ne avvia un altro
        const stop = () => {
            if (this._highlightAnimationID) {
                // Ferma l'animazione corrente
                clearInterval(this._highlightAnimationID);
                this._highlightAnimationID = null;
            }
            // riporta le mesh evidenziate allo stato normale
            if (this._highlightCurrentMeshes)
                this._highlightCurrentMeshes.forEach((mesh) => {
                    if (mesh instanceof BABYLON.Mesh)
                        removeWithChildren(mesh);
                });
            // Riporta i valori normali di highlighting
            if (this._highlightLayer) {
                this._highlightLayer.blurHorizontalSize = startHorSize;
                this._highlightLayer.blurVerticalSize = startVerSize;
            }
            // Eventualmente lancia l'highlight in attesa
            if (this._highlightNextMeshes) {
                const nextMeshes = this._highlightNextMeshes;
                this._highlightNextMeshes = [];
                this.highlightMeshes(nextMeshes);
            }
        };
        if (this._highlightAnimationID) {
            // Animazione in corso. metto la mesh in coda e stoppo l'animazione
            this._highlightNextMeshes = meshes;
            stop();
            return;
        }
        if (!this._highlightLayer)
            this.createHighlightLayer();
        if (this._highlightLayer) {
            this._highlightCurrentMeshes = meshes;
            meshes.forEach((mesh) => {
                if (mesh instanceof BABYLON.Mesh)
                    addWithChildren(mesh);
            });
            const duration = 800.0; // durata totale dell'animazione in millisecondi
            const step = 20.0; // tempo tra un frame e l'altro in millisecondi
            const delta = step / duration; // percentuale di decremento del blur
            let horSize = startHorSize;
            let verSize = startVerSize;
            this._highlightAnimationID = window.setInterval(() => {
                if (this._highlightLayer) {
                    horSize -= startHorSize * delta;
                    verSize -= startVerSize * delta;
                    horSize = Math.max(0, horSize);
                    verSize = Math.max(0, verSize);
                    if (horSize >= 0)
                        this._highlightLayer.blurHorizontalSize = horSize;
                    if (verSize >= 0)
                        this._highlightLayer.blurVerticalSize = verSize;
                    if (horSize == 0 || verSize == 0)
                        stop();
                    this.setRenderingNeeded();
                }
            }, step);
            this.setRenderingNeeded();
        }
    }
    highlightGroupForMesh(mesh) {
        const zkGroup = this.getGroupForMesh(mesh);
        this.highlightGroup(zkGroup);
    }
    highlightGroupByID(groupID) {
        if (this._zkModel) {
            const group = this._zkModel.get("attributeGroups").findWhere({ groupID });
            group ? this.highlightGroup(group) : this.highlightGroup(null);
        }
    }
    highlightGroup(zkGroup) {
        if (this._zkScene && this._scene && zkGroup) {
            const selector = zkGroup.get("meshSelector");
            if (selector) {
                var meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, selector, MPlaza.SceneElementType.Mesh);
                this.highlightMeshes(meshes);
            }
        }
    }
    getGroupForMesh(mesh) {
        if (this._zkModel && this._zkScene && this._scene && mesh && this._sceneHelper) {
            const groups = this._zkModel.get("attributeGroups");
            for (let i = 0; i < groups.length; i++) {
                const group = groups.at(i);
                const selector = group.get("meshSelector");
                if (selector) {
                    const meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, selector, MPlaza.SceneElementType.Mesh);
                    for (let k = 0; k < meshes.length; k++) {
                        let groupMesh = meshes[k];
                        if (mesh.id == groupMesh.id || this._sceneHelper.meshHasParent(mesh.id, groupMesh.id)) {
                            return group;
                        }
                    }
                }
            }
        }
        return null;
    }
    highlightAttributeByID(attributeID) {
        if (this._zkModel) {
            const attribute = this._zkModel.get("attributes").findWhere({ attributeID });
            attribute ? this.highlightAttribute(attribute) : this.highlightAttribute(null);
        }
    }
    highlightAttribute(zkAttribute) {
        if (this._zkScene && this._scene && zkAttribute) {
            const selector = zkAttribute.get("meshSelector");
            if (selector) {
                var meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, selector, MPlaza.SceneElementType.Mesh);
                this.highlightMeshes(meshes);
            }
        }
    }
    getVisibleHiddenAttributesForMesh(mesh) {
        const groups = [];
        const getOrCreateGroup = (groupId) => {
            let group = groups.find(x => x.groupId == groupId);
            if (!group) {
                group = { groupId, visibleAttributes: [], hiddenAttributes: [] };
                groups.push(group);
            }
            return group;
        };
        if (this._zkModel && this._zkScene && this._scene && mesh) {
            const attributes = this._zkModel.get("attributes");
            for (let i = 0; i < attributes.length; i++) {
                const attribute = attributes.at(i);
                const attributeID = attribute.get("attributeID");
                const selector = attribute.get("meshSelector");
                if (selector) {
                    const group = getOrCreateGroup(attribute.get("groupID"));
                    var meshes = this._elementSelector.getMeshElements(this._zkScene, this._scene, null, selector, MPlaza.SceneElementType.Mesh);
                    // If this attribute selector contains this mesh, then is in visible attributes, else is hidden.
                    const found = meshes.find(attributeMesh => {
                        if (this._sceneHelper)
                            return mesh.id == attributeMesh.id || this._sceneHelper.meshHasParent(mesh.id, attributeMesh.id);
                        else
                            return false;
                    });
                    if (found)
                        group.visibleAttributes.push(attributeID);
                    else
                        group.hiddenAttributes.push(attributeID);
                }
            }
        }
        // If all attributes are hidden for a group and there are no visible attributes than we clicked on a mesh
        // that is not attached to any attribute. Then filter them because that
        // mean that nothing must be done
        return groups.filter(x => x.visibleAttributes.length > 0);
    }
    // -------------------------------------------------------------
    // Events 
    // -------------------------------------------------------------
    fireGroupPickedEvent(e) {
        for (let i = 0; i < this._groupPickedListeners.length; i++)
            this._groupPickedListeners[i](e);
    }
    addGroupPickedListener(listenerFunction) {
        this._groupPickedListeners.push(listenerFunction);
    }
    fireFocusAttributesEvent(e) {
        for (let i = 0; i < this._focusAttributesListeners.length; i++)
            this._focusAttributesListeners[i](e);
    }
    addFocusAttributesListener(listenerFunction) {
        this._focusAttributesListeners.push(listenerFunction);
    }
    addNotifyMessageListener(listener) {
        this._designNotifyMessageListeners.push(listener);
        if (this._sceneDesignManager)
            this._sceneDesignManager.addNotifyMessageListener(listener);
    }
    addRemoveMessageListener(listener) {
        this._designRemoveMessageListeners.push(listener);
        if (this._sceneDesignManager)
            this._sceneDesignManager.addRemoveMessageListener(listener);
    }
    setEventMessages(eventMessages) {
        this._designEventMessages = eventMessages;
        if (this._sceneDesignManager)
            this._sceneDesignManager.setEventMessages(eventMessages);
    }
    addInfoPointPickedListener(listenerFunction) {
        this._infoPointPickedListeners.push(listenerFunction);
        if (this._infoPointsManager)
            this._infoPointsManager.addInfoPointPickedListener(listenerFunction);
    }
    addInfoPointContentShownListener(listenerFunction) {
        this._infoPointContentShownListeners.push(listenerFunction);
        if (this._infoPointsManager)
            this._infoPointsManager.addInfoPointContentShownListener(listenerFunction);
    }
    addInfoPointContentHiddenListener(listenerFunction) {
        this._infoPointContentHiddenListeners.push(listenerFunction);
        if (this._infoPointsManager)
            this._infoPointsManager.addInfoPointContentHiddenListener(listenerFunction);
    }
    // begin assets loading
    addBeginAssetsLoadingListener(callback) {
        this._beginAssetsLoadingListeners.push(callback);
    }
    fireBeginAssetsLoadingEvent() {
        Logger.info("Begin Assets Loading");
        for (let i = 0; i < this._beginAssetsLoadingListeners.length; ++i) {
            this._beginAssetsLoadingListeners[i]();
        }
    }
    addEndAssetsLoadingListener(callback) {
        this._endAssetsLoadingListeners.push(callback);
    }
    fireEndAssetsLoadingEvent() {
        Logger.info("End Assets Loading");
        for (let i = 0; i < this._endAssetsLoadingListeners.length; ++i) {
            this._endAssetsLoadingListeners[i]();
        }
    }
    addBeginSceneLoadingListener(callback) {
        this._beginAssetsLoadingListeners.push(callback);
    }
    fireBeginSceneLoadingEvent() {
        Logger.info("Begin Scene Loading");
        for (let i = 0; i < this._beginAssetsLoadingListeners.length; ++i) {
            this._beginAssetsLoadingListeners[i]();
        }
    }
    addEndSceneLoadingListener(callback) {
        this._endAssetsLoadingListeners.push(callback);
    }
    fireEndSceneLoadingEvent() {
        Logger.info("End Scene Loading");
        for (let i = 0; i < this._endAssetsLoadingListeners.length; ++i) {
            this._endAssetsLoadingListeners[i]();
        }
    }
    // --------------------------------------------------------------
    getSceneScreenshotAsync(width, height) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneHelper) {
                this.setRenderingNeeded();
                return yield this._sceneHelper.takeScreenshotAsync(width, height);
            }
            return null;
        });
    }
    getSceneContentScreenshotAsync(width, height, padding = 0, zkDesign, legacyScreenshot, camera) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._sceneHelper || !this.scene || !this.zkModel || !this.zkScene)
                return null;
            this.preSceneContentScreenshot();
            if (this._environmentManager) {
                this._environmentManager.dispose();
                this._environmentManager = null;
            }
            this.setRenderingNeeded();
            const canvasMeshesOriginalMeshesIds = this.scene.meshes.filter(x => { var _a; return (_a = x.metadata) === null || _a === void 0 ? void 0 : _a.iscanvasMesh; }).map(x => x.metadata.originalMeshID);
            let dataUrl = '';
            if (legacyScreenshot) {
                dataUrl = yield this._sceneHelper.takeContentScreenshotAsync(width, height);
            }
            else {
                const result = yield _Components_ScenePreview_ScenePreview__WEBPACK_IMPORTED_MODULE_9__.ScenesPreview.getPreviewsAsync(this.scene, this._zkScene.get("rootUrl"), {
                    width: 1024,
                    height: 1024,
                    camera: camera ? {
                        position: new BABYLON.Vector3(camera.get("px"), camera.get("py"), camera.get("pz")),
                        target: new BABYLON.Vector3(camera.get("tx"), camera.get("ty"), camera.get("tz")),
                    } : {
                        position: this._scene.activeCamera.position,
                        target: this._scene.activeCamera.target,
                    },
                    zkScene: this._zkScene,
                    zkModel: this._zkModel,
                    zkDesign: zkDesign,
                    meshesWithCustomizationIds: canvasMeshesOriginalMeshesIds,
                });
                dataUrl = result.previewFile;
            }
            // Trim image
            let image = yield _Helpers_utils__WEBPACK_IMPORTED_MODULE_11__.Utils.trimImageAsync(dataUrl);
            if (!image)
                throw new Error(`Failed cropping image. DataUrl: ${dataUrl} ${legacyScreenshot}, trimImage:${image}`);
            // Place on a fixed size canvas
            image = yield _Helpers_utils__WEBPACK_IMPORTED_MODULE_11__.Utils.resizeImageFromDataUri(image, width, height, padding);
            if (!image)
                throw new Error('Failed resizing image.');
            this.refreshEnvironment();
            this.postSceneContentScreenshot();
            return image;
        });
    }
    preSceneContentScreenshot() {
    }
    postSceneContentScreenshot() {
    }
    preSceneMaterialScreenshot() {
        if (this._environmentManager) {
            this._environmentManager.dispose();
            this._environmentManager = null;
        }
    }
    postSceneMaterialScreenshot() {
        this.refreshEnvironment();
    }
    getMaterialScreenshotAsync(materialID, width, height) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._scene || !this._sceneHelper)
                return null;
            this.preSceneMaterialScreenshot();
            let dataUri = null;
            const rootUrl = yield this.getSceneRootUrl();
            if (rootUrl) {
                const previewData = yield _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_7__.MaterialsPreview.getPreviewsAsync(this._scene, rootUrl, [materialID], {
                    width, height, crop: true
                }, false);
                const keys = Object.keys(previewData.previewFiles);
                if (keys.length == 1)
                    dataUri = previewData.previewFiles[keys[0]];
            }
            else {
                const data = yield this._sceneHelper.takeMaterialScreenshotAsync(materialID, width, height);
                const cropped = yield _Helpers_utils__WEBPACK_IMPORTED_MODULE_11__.Utils.trimImageAsync(data);
                if (cropped)
                    dataUri = cropped;
            }
            this.postSceneMaterialScreenshot();
            return dataUri;
        });
    }
    // Used to avoid multiple listeners when using react redraw
    clearListeners() {
        this._groupPickedListeners = [];
        this._focusAttributesListeners = [];
    }
    // Il parametro showDesign è stato aggiunto per impedire la visualizzazione dei design sugli oggetti.
    // Un utilizzo di questo parametro viene fatto quando si vogliono ottenere le informazioni sugli item
    // del design senza volerli visualizzare perché ad esempio potrebbero essere elementi di testo con
    // dei font ancora non caricati. In tal caso andrebbero prima caricati i font e poi visualizzato il design
    renderDesignAsync(zkDesign, showDesign = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._scene && this._zkScene && this._zkModel && zkDesign) {
                if (this._sceneDesignManager && this._sceneDesignManager.isForModels(this._scene, this._zkModel, zkDesign)) {
                    this._sceneDesignManager.showDesign = showDesign;
                    yield this._sceneDesignManager.refreshAsync();
                }
                else {
                    this.emptyArFileCache();
                    if (this._sceneDesignManager) {
                        this._sceneDesignManager.dispose();
                        this._sceneDesignManager = null;
                    }
                    this._sceneDesignManager = new _Components_DesignManagers_SceneDesignManager__WEBPACK_IMPORTED_MODULE_2__.SceneDesignManager(this._scene, this._zkScene, this._zkModel, zkDesign, showDesign);
                    this._sceneDesignManager.addRenderingNeededListener(() => {
                        this.setLongRenderingNeeded();
                        this.notifyDesignChanged(zkDesign);
                    });
                    this._sceneDesignManager.setCustomizerGrids(this._grids);
                    this._sceneDesignManager.setEventMessages(this._designEventMessages);
                    for (const listener of this._designNotifyMessageListeners)
                        this._sceneDesignManager.addNotifyMessageListener(listener);
                    for (const listener of this._designRemoveMessageListeners)
                        this._sceneDesignManager.addRemoveMessageListener(listener);
                    yield this._sceneDesignManager.refreshAsync();
                }
                this.setLongRenderingNeeded();
            }
        });
    }
    resetDesign() {
        if (this._scene && this._zkScene && this._zkModel) {
            if (this._sceneDesignManager) {
                this._sceneDesignManager.dispose();
                this._sceneDesignManager = null;
            }
            this.setLongRenderingNeeded();
        }
    }
    clearMeshDesignManagers() {
        if (this._sceneDesignManager) {
            this._sceneDesignManager.clearMeshDesignManagers();
        }
    }
    refreshMeshesDesignAsync(meshes, effect) {
        return __awaiter(this, void 0, void 0, function* () {
            if (meshes && Object.prototype.toString.call(meshes) === '[object Array]') {
                meshes.forEach((mesh) => __awaiter(this, void 0, void 0, function* () { return yield this.refreshMeshDesignAsync(mesh.id, undefined, effect || undefined); }));
            }
        });
    }
    refreshMeshDesignAsync(meshID, submeshID = 0, effect) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.refreshMeshDesignAsync(meshID, submeshID, effect);
        });
    }
    setCustomizerGrids(grids) {
        var _a;
        this._grids = grids;
        (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.setCustomizerGrids(grids);
    }
    removeDesignItem(guid) {
        var _a;
        (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.removeItem(guid);
    }
    addDesignItemText(settings, sideId) {
        var _a;
        return (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.addItemText(settings, sideId);
    }
    addDesignItemImage(imageID, sideId) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield ((_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.addItemImage(imageID, sideId));
        });
    }
    getDesignItemsInfo() {
        var _a, _b;
        return (_b = (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.getItemsInfo()) !== null && _b !== void 0 ? _b : [];
    }
    setDesignItemText(guid, text) {
        var _a;
        (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.setItemText(guid, text);
    }
    setDesignItemBold(guid, bold) {
        var _a;
        (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.setItemBold(guid, bold);
    }
    setDesignItemItalic(guid, italic) {
        var _a;
        (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.setItemItalic(guid, italic);
    }
    setDesignItemColor(guid, color) {
        var _a;
        (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.setItemColor(guid, color);
    }
    setDesignItemFontFamily(guid, fontFamily) {
        var _a;
        (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.setItemFontFamily(guid, fontFamily);
    }
    setDesignItemImage(guid, image) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            yield ((_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.setItemImage(guid, image));
        });
    }
    setItemTextOnPath(guid, areaId, value) {
        var _a;
        (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.setItemTextOnPath(guid, areaId, value);
    }
    removeDesignItemImage(guid) {
        var _a;
        (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.removeItemImage(guid);
    }
    setDesignVisibility(meshId, opacity) {
        var _a;
        (_a = this._sceneDesignManager) === null || _a === void 0 ? void 0 : _a.setDesignVisibility(meshId, opacity);
    }
    setupShaderMaterialsCameraPosition() {
        if (this._scene) {
            for (let i = 0; i < this._scene.materials.length; i++) {
                const material = this._scene.materials[i];
                this.setupShaderMaterialCameraPosition(material);
            }
        }
    }
    setupShaderMaterialCameraPosition(material) {
        if (this._scene && this._scene.activeCamera && material && material instanceof BABYLON.ShaderMaterial) {
            material.setVector3("cameraPosition", this._scene.activeCamera.position);
        }
    }
    setMeshLocation(locationID) {
        if (this._meshLocationsManager) {
            this._meshLocationsManager.setMeshLocationByID(locationID);
        }
    }
    explodeMeshes() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._meshLocationsManager) {
                yield this._meshLocationsManager.explodeMeshes();
            }
        });
    }
    collapseMeshes() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._meshLocationsManager) {
                yield this._meshLocationsManager.collapseMeshes();
            }
        });
    }
    dracoDecodingFunction(filename, fileBytes, callback) {
        this.decodeDracoFile(filename, fileBytes, callback);
    }
    decodeDracoFile(filename, fileBytes, callback) {
        var start = new Date().getTime();
        var fileContentView = new Uint8Array(fileBytes);
        var fileContent = msgpack.decode(fileContentView);
        //var dracoCompression = new DracoCompression();
        this.dracoCompression.decodeMeshAsync(fileContent.data).then(function (vertexData) {
            let result = {};
            // Da testare il passaggio diretto di VertexData
            if (vertexData) {
                if (vertexData.indices)
                    result.indices = vertexData.indices;
                if (vertexData.positions)
                    result.positions = vertexData.positions;
                if (vertexData.normals)
                    result.normals = vertexData.normals;
                if (vertexData.uvs)
                    result.uvs = vertexData.uvs;
                if (vertexData.uvs2)
                    result.uvs2 = vertexData.uvs2;
            }
            var date = new Date();
            var time = date.getTime();
            var elapsed = time - start;
            var timeText = date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + "." + date.getMilliseconds();
            Logger.info("Draco Decoding [" + timeText + "] - " + filename + "\t" + fileBytes.byteLength + "\t" + elapsed + " ms");
            if (callback)
                callback(result);
        });
    }
    exportSceneToBabylon() {
        if (!this._zkScene || !this._sceneHelper)
            return null;
        return this._sceneHelper.exportSceneToBabylon();
    }
    exportVisibleMeshesToBabylon() {
        if (!this._zkScene || !this._sceneHelper)
            return null;
        return this._sceneHelper.exportVisibleMeshesToBabylon();
    }
    exportMeshesForTyOnToBabylon() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._zkScene || !this._sceneHelper)
                return null;
            return yield this._sceneHelper.exportMeshesForTyOnToBabylon();
        });
    }
    exportMeshToBabylon(meshID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._scene || !this._zkScene || !this._sceneHelper)
                return null;
            const mesh = this._scene.getMeshById(meshID);
            if (mesh)
                return yield this._sceneHelper.exportMeshToBabylon(mesh);
            return null;
        });
    }
    downloadMeshToBabylon(meshID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._scene || !this._zkScene || !this._sceneHelper)
                return;
            const mesh = this._scene.getMeshById(meshID);
            if (mesh)
                yield this._sceneHelper.downloadMeshBabylonAsync(mesh);
        });
    }
    saveSceneOnDatabaseAsync(fileId) {
        return __awaiter(this, void 0, void 0, function* () {
            const json = this.exportSceneToBabylon();
            if (json) {
                const db = new _Misc_Database__WEBPACK_IMPORTED_MODULE_12__.Database(); // carico il file json da IndexedDB
                yield db.openAsync();
                yield db.saveFileAsync(fileId, json);
            }
        });
    }
    saveVisibleMeshesOnDatabaseAsync(fileId) {
        return __awaiter(this, void 0, void 0, function* () {
            //const json = this.exportVisibleMeshesToBabylon();
            const json = yield this.exportMeshesForTyOnToBabylon();
            if (json) {
                const db = new _Misc_Database__WEBPACK_IMPORTED_MODULE_12__.Database(); // carico il file json da IndexedDB
                yield db.openAsync();
                yield db.saveFileAsync(fileId, json);
            }
        });
    }
    saveGlbOnDatabaseAsync(fileId) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield this.exportSceneToLocalGLBAsync();
            if (data) {
                const db = new _Misc_Database__WEBPACK_IMPORTED_MODULE_12__.Database();
                yield db.openAsync();
                yield db.saveFileAsync(fileId, data);
            }
        });
    }
    getArFileUrlCacheKey(sceneID, sceneCode, format = 'usdz') {
        let key = "scene_" + sceneID;
        if (sceneCode)
            key += "_code_" + sceneCode;
        if (this._sceneDesignManager) {
            var json = this._sceneDesignManager.getDesignItemsJson();
            if (json) {
                var hash = CryptoJS.SHA1(json).toString();
                key += "_design_" + this._sceneDesignManager.getDesignID() + "_" + hash;
            }
        }
        key += "_" + format;
        return key;
    }
    getCachedArFileUrl(sceneID, sceneCode, format = 'usdz') {
        var key = this.getArFileUrlCacheKey(sceneID, sceneCode, format);
        if (this._arFileUrls.hasOwnProperty(key))
            return this._arFileUrls[key];
        return null;
    }
    cacheArFileUrl(sceneID, sceneCode, format, url) {
        if (url) {
            var key = this.getArFileUrlCacheKey(sceneID, sceneCode || undefined, format);
            this._arFileUrls[key] = url;
        }
    }
    exportSceneToUsdzAsync(sceneID, sceneCode, useCacheWithDesign) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._zkScene || !this._sceneHelper)
                return null;
            const format = "usdz";
            let url = null;
            if (sceneID && (!this._sceneDesignManager || useCacheWithDesign))
                url = this.getCachedArFileUrl(sceneID, sceneCode, format);
            if (url)
                return url;
            let sceneName = null;
            let sceneRootUrl = null;
            const sn = this._zkScene.get("name");
            if (sn)
                sceneName = sn;
            const sru = this._zkScene.get("rootUrl");
            if (sru)
                sceneRootUrl = sru;
            if (this._sceneDesignManager)
                this._sceneDesignManager.expandCanvasMeshes();
            url = yield this._sceneHelper.exportSceneToUsdzAsync(sceneName, sceneRootUrl, this._sceneDesignManager && !useCacheWithDesign ? undefined : sceneID, this._sceneDesignManager && !useCacheWithDesign ? undefined : sceneCode, (_a = this._zkScene) === null || _a === void 0 ? void 0 : _a.getARScale());
            if (this._sceneDesignManager)
                this._sceneDesignManager.contractCanvasMeshes();
            if (url && sceneID && !this._sceneDesignManager)
                this.cacheArFileUrl(sceneID, sceneCode || null, format, url);
            return url;
        });
    }
    exportMeshToUsdzAsync(meshID) {
        return __awaiter(this, void 0, void 0, function* () {
            const mesh = this.getMeshByID(meshID);
            if (mesh && this._zkScene && this._sceneHelper) {
                let sceneRootUrl = null;
                const sru = this._zkScene.get("rootUrl");
                if (sru)
                    sceneRootUrl = sru;
                const url = yield this._sceneHelper.exportMeshToUsdzAsync(sceneRootUrl, mesh, this.getARScale());
                Logger.info("USDZ: " + url);
                return url;
            }
            return null;
        });
    }
    exportSceneToRemoteGlTFAsync(sceneID, sceneCode, useCacheWithDesign) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._sceneHelper)
                return null;
            const format = "glTF";
            let url = null;
            if (sceneID && (!this._sceneDesignManager || useCacheWithDesign))
                url = this.getCachedArFileUrl(sceneID, sceneCode, format);
            if (url)
                return url;
            let sceneName = null;
            let sceneRootUrl = null;
            if (this._zkScene) {
                const sn = this._zkScene.get("name");
                if (sn)
                    sceneName = sn;
                const sru = this._zkScene.get("rootUrl");
                if (sru)
                    sceneRootUrl = sru;
            }
            if (this._sceneDesignManager)
                this._sceneDesignManager.expandCanvasMeshes();
            url = yield this._sceneHelper.exportSceneToRemoteGlTFAsync(sceneName, sceneRootUrl, this._sceneDesignManager && !useCacheWithDesign ? undefined : sceneID, this._sceneDesignManager && !useCacheWithDesign ? undefined : sceneCode, (_a = this._zkScene) === null || _a === void 0 ? void 0 : _a.getARScale());
            if (this._sceneDesignManager)
                this._sceneDesignManager.contractCanvasMeshes();
            if (url && sceneID && !this._sceneDesignManager)
                this.cacheArFileUrl(sceneID, sceneCode || null, format, url);
            Logger.info("GlTF: " + url);
            return url;
        });
    }
    exportMeshToRemoteGlTFAsync(meshID) {
        return __awaiter(this, void 0, void 0, function* () {
            const mesh = this.getMeshByID(meshID);
            if (mesh && this._zkScene && this._sceneHelper) {
                let sceneRootUrl = null;
                const sru = this._zkScene.get("rootUrl");
                if (sru)
                    sceneRootUrl = sru;
                const url = yield this._sceneHelper.exportMeshToRemoteGlTFAsync(sceneRootUrl, mesh, this.getARScale());
                Logger.info("GlTF: " + url);
                return url;
            }
            return null;
        });
    }
    exportSceneToRemoteGLBAsync(sceneID, sceneCode, useCacheWithDesign) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this._sceneHelper)
                return null;
            const format = "glb";
            let url = null;
            if (sceneID && (!this._sceneDesignManager || useCacheWithDesign))
                url = this.getCachedArFileUrl(sceneID, sceneCode, format);
            if (url)
                return url;
            let sceneName = null;
            let sceneRootUrl = null;
            if (this._zkScene) {
                const sn = this._zkScene.get("name");
                if (sn)
                    sceneName = sn;
                const sru = this._zkScene.get("rootUrl");
                if (sru)
                    sceneRootUrl = sru;
            }
            if (this._sceneDesignManager)
                this._sceneDesignManager.expandCanvasMeshes();
            url = yield this._sceneHelper.exportSceneToRemoteGLBAsync(sceneName, sceneRootUrl, this._sceneDesignManager && !useCacheWithDesign ? undefined : sceneID, this._sceneDesignManager && !useCacheWithDesign ? undefined : sceneCode, (_a = this._zkScene) === null || _a === void 0 ? void 0 : _a.getARScale());
            if (this._sceneDesignManager)
                this._sceneDesignManager.contractCanvasMeshes();
            if (url && sceneID && !this._sceneDesignManager)
                this.cacheArFileUrl(sceneID, sceneCode || null, format, url);
            Logger.info("GLB: " + url);
            return url;
        });
    }
    exportMeshToRemoteGLBAsync(meshID) {
        return __awaiter(this, void 0, void 0, function* () {
            const mesh = this.getMeshByID(meshID);
            if (mesh && this._zkScene && this._sceneHelper) {
                let sceneRootUrl = null;
                const sru = this._zkScene.get("rootUrl");
                if (sru)
                    sceneRootUrl = sru;
                const url = yield this._sceneHelper.exportMeshToRemoteGLBAsync(sceneRootUrl, mesh, this.getARScale());
                Logger.info("GlTF: " + url);
                return url;
            }
            return null;
        });
    }
    // Esporta la scena nei formati glb e usdz utili per visualizzarli con model-viewer
    // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
    exportSceneToARAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            let result = [];
            if (!this._sceneHelper)
                return result;
            let sceneName = null;
            let sceneRootUrl = null;
            if (this._zkScene) {
                const sn = this._zkScene.get("name");
                if (sn)
                    sceneName = sn;
                const sru = this._zkScene.get("rootUrl");
                if (sru)
                    sceneRootUrl = sru;
            }
            if (this._sceneDesignManager)
                this._sceneDesignManager.expandCanvasMeshes();
            result = yield this._sceneHelper.exportSceneToARMultiformatAsync(sceneName, sceneRootUrl, ["usdz", "glb"]);
            if (this._sceneDesignManager)
                this._sceneDesignManager.contractCanvasMeshes();
            return result;
        });
    }
    // Esporta la mesh nei formati glb e usdz utili per visualizzarli con model-viewer
    // il formato png viene richiesto per ottenere un poster del modello da visualizzare inizialmente
    exportMeshToARAsync(meshID) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = [];
            const mesh = this.getMeshByID(meshID);
            if (mesh && this._zkScene && this._sceneHelper) {
                let sceneRootUrl = null;
                const sru = this._zkScene.get("rootUrl");
                if (sru)
                    sceneRootUrl = sru;
                result = yield this._sceneHelper.exportMeshToARMultiformatAsync(sceneRootUrl, mesh, ["usdz", "glb"], this.getARScale());
            }
            return result;
        });
    }
    isAREnabled() {
        if (!this._zkScene)
            return false;
        let enabled = this._zkScene.getAREnabled();
        return enabled !== null &&
            enabled !== undefined &&
            enabled &&
            this._sceneHelper != null &&
            this._sceneHelper.getMeshesForAR().length > 0 &&
            this._sceneHelper.checkMaterialsForAR();
    }
    exportSceneToLocalGLBAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneDesignManager)
                this._sceneDesignManager.expandCanvasMeshes();
            let result = null;
            if (this._sceneHelper)
                result = yield this._sceneHelper.exportSceneToLocalGLBBlobAsync();
            if (this._sceneDesignManager)
                this._sceneDesignManager.contractCanvasMeshes();
            return result;
        });
    }
    downloadSceneLocalGLBAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneDesignManager)
                this._sceneDesignManager.expandCanvasMeshes();
            if (this._sceneHelper)
                yield this._sceneHelper.downloadSceneLocalGLBAsync();
            if (this._sceneDesignManager)
                this._sceneDesignManager.contractCanvasMeshes();
        });
    }
    exportSceneToLocalUSDZAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneDesignManager)
                this._sceneDesignManager.expandCanvasMeshes();
            let result = null;
            if (this._sceneHelper)
                result = yield this._sceneHelper.exportSceneToLocalUSDZUrlAsync();
            if (this._sceneDesignManager)
                this._sceneDesignManager.contractCanvasMeshes();
            return result;
        });
    }
    downloadSceneLocalUSDZAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._sceneDesignManager)
                this._sceneDesignManager.expandCanvasMeshes();
            if (this._sceneHelper)
                yield this._sceneHelper.downloadSceneLocalUSDZAsync();
            if (this._sceneDesignManager)
                this._sceneDesignManager.contractCanvasMeshes();
        });
    }
    getSceneRootUrl() {
        return new Promise((resolve, reject) => {
            let rootUrl = null;
            if (this._zkScene) {
                rootUrl = this._zkScene.get("rootUrl") || null;
                if (rootUrl)
                    resolve(rootUrl);
                else {
                    jQuery.ajax({
                        url: this._zkScene.getSceneRootUrlApiUrl(),
                        type: 'GET',
                        success: function (data) {
                            rootUrl = data;
                            resolve(rootUrl);
                        },
                        error: function (xhr, textStatus, errorThrown) {
                            reject(errorThrown);
                        }
                    });
                }
            }
            else {
                resolve(rootUrl);
            }
        });
    }
    refreshInfoPoints() {
        const enabled = this._zkScene && this._zkScene.getInfoPointsEnabled() && this.canShowInfoPoints;
        if (!enabled) {
            this.disposeInfoPointsManager();
            this.setLongRenderingNeeded();
            return;
        }
        const style = this.getInfoPointsManagerStyle();
        let antialias = null;
        if (!this._infoPointsManager) {
            if (this._scene && this._zkScene) {
                this._infoPointsManager = new _Components_InfoPointsManager_InfoPointsManager__WEBPACK_IMPORTED_MODULE_6__.InfoPointsManager(this._zkScene, this._scene, style);
                if (this._infoPointPickedListeners && this._infoPointPickedListeners.length > 0)
                    this._infoPointsManager.addInfoPointPickedListenerRange(this._infoPointPickedListeners);
                if (this._infoPointContentShownListeners && this._infoPointContentShownListeners.length > 0)
                    this._infoPointsManager.addInfoPointContentShownListenerRange(this._infoPointContentShownListeners);
                if (this._infoPointContentShownListeners && this._infoPointContentShownListeners.length > 0)
                    this._infoPointsManager.addInfoPointContentShownListenerRange(this._infoPointContentShownListeners);
                this._infoPointsManager.onBeforeShowImages = () => {
                    if (antialias === null)
                        antialias = this.antialias;
                    this.antialias = false;
                    this.disableAntialiasing();
                };
                this._infoPointsManager.onAfterShowImages = () => {
                    this.antialias = antialias;
                    antialias = null;
                    this.enableAntialiasing();
                    this.setLongRenderingNeeded();
                };
                this._infoPointsManager.addRenderingNeededListener(() => this.setRenderingNeeded());
            }
        }
        if (this._infoPointsManager) {
            this.updateInfoPointsManagerStyle();
            this._infoPointsManager.canShowInfoPointsContent = this.canShowInfoPointsContent;
            this._infoPointsManager.refresh();
        }
        this.setLongRenderingNeeded();
    }
    getInfoPointsManagerStyle() {
        const style = this._infoPointsManagerStyle ? this._infoPointsManagerStyle : {};
        if (this._zkScene) {
            const pointsStyle = this._zkScene.getInfoPointsStyleConfig();
            if (pointsStyle) {
                if (!style.infoPointsStyle)
                    style.infoPointsStyle = {};
                if (pointsStyle.get("borderColor"))
                    style.infoPointsStyle.borderColor = pointsStyle.get("borderColor");
                if (pointsStyle.get("innerPointColor"))
                    style.infoPointsStyle.innerPointColor = pointsStyle.get("innerPointColor");
                if (pointsStyle.get("color"))
                    style.infoPointsStyle.color = pointsStyle.get("color");
                if (pointsStyle.get("highlightColor"))
                    style.infoPointsStyle.highlightColor = pointsStyle.get("highlightColor");
            }
        }
        return style;
    }
    updateInfoPointsManagerStyle() {
        if (this._infoPointsManager) {
            const style = this.getInfoPointsManagerStyle();
            this._infoPointsManager.applyStyle(style);
        }
    }
    showInfoPoints() {
        if (this._infoPointsManager) {
            this._infoPointsManager.showInfoPoints();
            this.render();
            this.setRenderingNeeded();
        }
    }
    hideInfoPoints() {
        if (this._infoPointsManager) {
            this._infoPointsManager.hideInfoPoints();
            this.render();
            this.setRenderingNeeded();
        }
    }
    // try to reload all textures with loading errors
    reloadAllLoadingErrorTexturesAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._zkScene && this._sceneHelper) {
                const rootUrl = this._zkScene.get("rootUrl");
                if (rootUrl)
                    yield this._sceneHelper.reloadAllLoadingErrorTexturesAsync(rootUrl);
            }
        });
    }
    // try to reload the material textures with loading errors
    reloadMaterialLoadingErrorTexturesAsync(material) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._zkScene && this._sceneHelper) {
                const rootUrl = this._zkScene.get("rootUrl");
                if (rootUrl)
                    yield this._sceneHelper.reloadMaterialLoadingErrorTexturesAsync(rootUrl, material);
            }
        });
    }
    // try to reload the texture having loading errors
    reloadLoadingErrorTextureAsync(texture) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._zkScene && this._sceneHelper) {
                const rootUrl = this._zkScene.get("rootUrl");
                if (rootUrl)
                    yield this._sceneHelper.reloadLoadingErrorTextureAsync(rootUrl, texture);
            }
        });
    }
    // were there any loading errors for the texture?
    isTextureLoadingError(texture) {
        return this._sceneHelper ? this._sceneHelper.isTextureLoadingError(texture) : false;
    }
    // the material has some texture with loading errors
    materialHasLoadingErrorTextues(material) {
        return this._sceneHelper ? this._sceneHelper.materialHasLoadingErrorTextues(material) : false;
    }
    notifyCameraMovement() {
        if (this._isHologramSource && this._camera && this._camera instanceof BABYLON.ArcRotateCamera) {
            let bc = this.getOrCreateBroadcastChannel();
            if (!bc)
                return;
            bc.postMessage({
                type: BroadcastChannelEventType.CameraMovement,
                target: { x: this._camera.target.x, y: this._camera.target.y, z: this._camera.target.z },
                alpha: this._camera.alpha,
                beta: this._camera.beta,
                radius: this._camera.radius
            });
        }
    }
    notifyScriptExecution(script) {
        if (this._isHologramSource) {
            const scriptJson = script.map(s => ({
                attributeID: s.attributeID,
                selectedValue: s.selectedValue,
                actions: s.actions.map(a => a.toJSON())
                /*
                actions: s.actions.map(a => ({
                    attributeGuid: a.get("actionGuid"),
                    name: a.get("name"),
                    actionTypeID: a.get("actionTypeID"),
                    sceneElementTypeID: a.get("sceneElementTypeID"),
                    selector: a.get("selector"),
                    propertyName: a.get("propertyName"),
                    value: a.get("value"),
                    execOrder: a.get("execOrder"),
                    deviceTypes: a.get("deviceTypes")
                }))
                */
            }));
            let bc = this.getOrCreateBroadcastChannel();
            if (!bc)
                return;
            bc.postMessage({
                type: BroadcastChannelEventType.ScriptExecution,
                script: scriptJson
            });
        }
    }
    notifyDesignChanged(zkDesign) {
        if (this._isHologramSource) {
            let bc = this.getOrCreateBroadcastChannel();
            if (!bc)
                return;
            bc.postMessage({
                type: BroadcastChannelEventType.DesignChanged,
                design: zkDesign.toJSON()
            });
        }
    }
    notifyActionExecution(attributeID, selectedValue, actions) {
        this.notifyScriptExecution([{
                attributeID,
                selectedValue,
                actions
            }]);
    }
    attachBroadcastChannelEventHandlers() {
        if (this._isHologram && !this._isHologramSource) {
            var bc = this.getOrCreateBroadcastChannel();
            if (!bc)
                return;
            bc.onmessage = (event) => this.onBroadcastMessageReceived(event);
        }
    }
    detachBroadcastChannelEventHandlers() {
        if (this._broadcastChannel)
            this._broadcastChannel.onmessage = null;
    }
    onBroadcastMessageReceived(event) {
        if (this._isHologram && event && event.data && event.data.type) {
            if (event.data.type === BroadcastChannelEventType.CameraMovement) {
                this.processCameraMovementEvent(event);
            }
            else if (event.data.type === BroadcastChannelEventType.ScriptExecution) {
                this.processScriptExecution(event);
            }
            else if (event.data.type === BroadcastChannelEventType.DesignChanged) {
                this.processDesignChanged(event);
            }
        }
    }
    processCameraMovementEvent(event) {
        if (this._camera && this._camera instanceof BABYLON.ArcRotateCamera && event && event.data) {
            this._camera.target = new BABYLON.Vector3(event.data.target.x, event.data.target.y, event.data.target.z);
            this._camera.alpha = event.data.alpha;
            this._camera.beta = event.data.beta;
            this._camera.radius = event.data.radius;
            this.setRenderingNeeded();
        }
    }
    processScriptExecution(event) {
        if (event && event.data && event.data.script && Object.prototype.toString.call(event.data.script) === '[object Array]') {
            var composerScript = event.data.script.map(s => ({
                attributeID: s.attributeID,
                selectedValue: s.selectedValue,
                actions: s.actions.map(a => new MPlaza.AttributeSceneAction(a))
            }));
            this.executeScriptAsync(composerScript);
        }
    }
    processDesignChanged(event) {
        if (event && event.data && event.data.design) {
            let zkDesign = new MPlaza.Design(event.data.design);
            this.renderDesignAsync(zkDesign);
        }
    }
}


/***/ }),

/***/ "../../3D/src/index.ts":
/*!*****************************!*\
  !*** ../../3D/src/index.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AndroidAR": () => (/* reexport safe */ _Components_AR_AndroidAR__WEBPACK_IMPORTED_MODULE_33__.AndroidAR),
/* harmony export */   "AxesLayer": () => (/* reexport safe */ _Layers_AxesLayer__WEBPACK_IMPORTED_MODULE_41__.AxesLayer),
/* harmony export */   "BlendProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_BlendProceduralTexture__WEBPACK_IMPORTED_MODULE_14__.BlendProceduralTexture),
/* harmony export */   "BlurXProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_6__.BlurXProceduralTexture),
/* harmony export */   "BlurYProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_7__.BlurYProceduralTexture),
/* harmony export */   "BroadcastChannelEventType": () => (/* reexport safe */ _Viewers_SceneViewer__WEBPACK_IMPORTED_MODULE_48__.BroadcastChannelEventType),
/* harmony export */   "Database": () => (/* reexport safe */ _Misc_Database__WEBPACK_IMPORTED_MODULE_47__.Database),
/* harmony export */   "DefaultAssetUrls": () => (/* reexport safe */ _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_43__.DefaultAssetUrls),
/* harmony export */   "DracoCompression": () => (/* reexport safe */ _Components_Draco_DracoCompression__WEBPACK_IMPORTED_MODULE_27__.DracoCompression),
/* harmony export */   "EditingMode": () => (/* reexport safe */ _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EditingMode),
/* harmony export */   "EditorMeshType": () => (/* reexport safe */ _Viewers_MaterialEditor__WEBPACK_IMPORTED_MODULE_50__.EditorMeshType),
/* harmony export */   "ElementSelector": () => (/* reexport safe */ _Components_Selector_ElementSelector__WEBPACK_IMPORTED_MODULE_28__.ElementSelector),
/* harmony export */   "EnvironmentManager": () => (/* reexport safe */ _Components_Environment_EnvironmentManager__WEBPACK_IMPORTED_MODULE_29__.EnvironmentManager),
/* harmony export */   "EnvironmentMode": () => (/* reexport safe */ _Enumerations__WEBPACK_IMPORTED_MODULE_5__.EnvironmentMode),
/* harmony export */   "EventState": () => (/* reexport safe */ _Misc_Observable__WEBPACK_IMPORTED_MODULE_45__.EventState),
/* harmony export */   "ForegroundBackgroundProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_8__.ForegroundBackgroundProceduralTexture),
/* harmony export */   "GlowManager": () => (/* reexport safe */ _Components_Glow_GlowManager__WEBPACK_IMPORTED_MODULE_17__.GlowManager),
/* harmony export */   "IncrementalFiles": () => (/* reexport safe */ _Components_IncrementalFiles_IncrementalFiles__WEBPACK_IMPORTED_MODULE_19__.IncrementalFiles),
/* harmony export */   "InfoPointsManager": () => (/* reexport safe */ _Components_InfoPointsManager_InfoPointsManager__WEBPACK_IMPORTED_MODULE_34__.InfoPointsManager),
/* harmony export */   "InnerShadow": () => (/* reexport safe */ _Components_Shadows_InnerShadow__WEBPACK_IMPORTED_MODULE_22__.InnerShadow),
/* harmony export */   "LightsLayer": () => (/* reexport safe */ _Layers_LightsLayer__WEBPACK_IMPORTED_MODULE_42__.LightsLayer),
/* harmony export */   "MakeIncremental": () => (/* reexport safe */ _Components_IncrementalFiles_MakeIncremental__WEBPACK_IMPORTED_MODULE_18__.MakeIncremental),
/* harmony export */   "MaterialEditor": () => (/* reexport safe */ _Viewers_MaterialEditor__WEBPACK_IMPORTED_MODULE_50__.MaterialEditor),
/* harmony export */   "MaterialGroup": () => (/* reexport safe */ _Viewers_SceneEditor__WEBPACK_IMPORTED_MODULE_49__.MaterialGroup),
/* harmony export */   "MaterialPreviewData": () => (/* reexport safe */ _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_20__.MaterialPreviewData),
/* harmony export */   "MaterialsPreview": () => (/* reexport safe */ _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_20__.MaterialsPreview),
/* harmony export */   "MeshDesignManager": () => (/* reexport safe */ _Components_DesignManagers_MeshDesignManager__WEBPACK_IMPORTED_MODULE_24__.MeshDesignManager),
/* harmony export */   "MeshExpander": () => (/* reexport safe */ _Components_MeshExpander_MeshExpander__WEBPACK_IMPORTED_MODULE_30__.MeshExpander),
/* harmony export */   "MeshLocationsManager": () => (/* reexport safe */ _Components_CollapseExplode_MeshLocationsManager__WEBPACK_IMPORTED_MODULE_16__.MeshLocationsManager),
/* harmony export */   "MoveProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_MoveProceduralTexture__WEBPACK_IMPORTED_MODULE_9__.MoveProceduralTexture),
/* harmony export */   "MultiObserver": () => (/* reexport safe */ _Misc_Observable__WEBPACK_IMPORTED_MODULE_45__.MultiObserver),
/* harmony export */   "MultiplyProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_10__.MultiplyProceduralTexture),
/* harmony export */   "NormalMapProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_NormalMapProceduralTexture__WEBPACK_IMPORTED_MODULE_11__.NormalMapProceduralTexture),
/* harmony export */   "Observable": () => (/* reexport safe */ _Misc_Observable__WEBPACK_IMPORTED_MODULE_45__.Observable),
/* harmony export */   "Observer": () => (/* reexport safe */ _Misc_Observable__WEBPACK_IMPORTED_MODULE_45__.Observer),
/* harmony export */   "OpacityProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_OpacityProceduralTexture__WEBPACK_IMPORTED_MODULE_12__.OpacityProceduralTexture),
/* harmony export */   "OuterShadow": () => (/* reexport safe */ _Components_Shadows_OuterShadow__WEBPACK_IMPORTED_MODULE_23__.OuterShadow),
/* harmony export */   "OverlayProceduralTexture": () => (/* reexport safe */ _Components_ProceduralTextures_OverlayProceduralTexture__WEBPACK_IMPORTED_MODULE_13__.OverlayProceduralTexture),
/* harmony export */   "Preview3DConfigurationManager": () => (/* reexport safe */ _Components_Preview3D_Preview3DConfigurationManager__WEBPACK_IMPORTED_MODULE_26__.Preview3DConfigurationManager),
/* harmony export */   "ProceduralNormalMap": () => (/* reexport safe */ _Components_NormalMap_ProceduralNormalMap__WEBPACK_IMPORTED_MODULE_21__.ProceduralNormalMap),
/* harmony export */   "SceneActionsExecutor": () => (/* reexport safe */ _Components_ActionExecutor_SceneActionExecutor__WEBPACK_IMPORTED_MODULE_15__.SceneActionsExecutor),
/* harmony export */   "SceneDesignManager": () => (/* reexport safe */ _Components_DesignManagers_SceneDesignManager__WEBPACK_IMPORTED_MODULE_25__.SceneDesignManager),
/* harmony export */   "SceneEditor": () => (/* reexport safe */ _Viewers_SceneEditor__WEBPACK_IMPORTED_MODULE_49__.SceneEditor),
/* harmony export */   "SceneHelper": () => (/* reexport safe */ _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_31__.SceneHelper),
/* harmony export */   "SceneToBlobs": () => (/* reexport safe */ _Components_SceneToBlobs_SceneToBlobs__WEBPACK_IMPORTED_MODULE_32__.SceneToBlobs),
/* harmony export */   "SceneViewer": () => (/* reexport safe */ _Viewers_SceneViewer__WEBPACK_IMPORTED_MODULE_48__.SceneViewer),
/* harmony export */   "SourceTaskStatus": () => (/* reexport safe */ _Viewers_SceneEditor__WEBPACK_IMPORTED_MODULE_49__.SourceTaskStatus),
/* harmony export */   "StringTools": () => (/* reexport safe */ _Misc_StringTools__WEBPACK_IMPORTED_MODULE_44__.StringTools),
/* harmony export */   "Task": () => (/* reexport safe */ _composer_Components_ChunkedTask__WEBPACK_IMPORTED_MODULE_51__.Task),
/* harmony export */   "UsdzHelper": () => (/* reexport safe */ _Components_USDZ_UsdzHelper__WEBPACK_IMPORTED_MODULE_35__.UsdzHelper),
/* harmony export */   "Utils": () => (/* reexport safe */ _Helpers_utils__WEBPACK_IMPORTED_MODULE_37__.Utils),
/* harmony export */   "WorkerPool": () => (/* reexport safe */ _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_46__.WorkerPool),
/* harmony export */   "ZakekeEnvironment": () => (/* reexport safe */ _Enumerations__WEBPACK_IMPORTED_MODULE_5__.ZakekeEnvironment),
/* harmony export */   "debounce": () => (/* reexport safe */ _Helpers_debounce__WEBPACK_IMPORTED_MODULE_36__.debounce)
/* harmony export */ });
/* harmony import */ var _Polyfills_Array_Array_prototype_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Polyfills/Array/Array.prototype.find */ "../../3D/src/Polyfills/Array/Array.prototype.find.js");
/* harmony import */ var _Polyfills_Array_Array_prototype_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Polyfills_Array_Array_prototype_find__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Polyfills_Array_Array_prototype_includes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Polyfills/Array/Array.prototype.includes */ "../../3D/src/Polyfills/Array/Array.prototype.includes.js");
/* harmony import */ var _Polyfills_Array_Array_prototype_includes__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Polyfills_Array_Array_prototype_includes__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Polyfills_Array_Array_prototype_map__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Polyfills/Array/Array.prototype.map */ "../../3D/src/Polyfills/Array/Array.prototype.map.js");
/* harmony import */ var _Polyfills_Array_Array_prototype_map__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Polyfills_Array_Array_prototype_map__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Polyfills_String_String_prototype_startsWith__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Polyfills/String/String.prototype.startsWith */ "../../3D/src/Polyfills/String/String.prototype.startsWith.js");
/* harmony import */ var _Polyfills_String_String_prototype_startsWith__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Polyfills_String_String_prototype_startsWith__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Polyfills_String_String_prototype_endsWith__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Polyfills/String/String.prototype.endsWith */ "../../3D/src/Polyfills/String/String.prototype.endsWith.js");
/* harmony import */ var _Polyfills_String_String_prototype_endsWith__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Polyfills_String_String_prototype_endsWith__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Enumerations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Enumerations */ "../../3D/src/Enumerations.ts");
/* harmony import */ var _Components_ProceduralTextures_BlurXProceduralTexture__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Components/ProceduralTextures/BlurXProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurXProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_BlurYProceduralTexture__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Components/ProceduralTextures/BlurYProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlurYProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_ForegroundBackgroundProceduralTexture__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Components/ProceduralTextures/ForegroundBackgroundProceduralTexture */ "../../3D/src/Components/ProceduralTextures/ForegroundBackgroundProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_MoveProceduralTexture__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Components/ProceduralTextures/MoveProceduralTexture */ "../../3D/src/Components/ProceduralTextures/MoveProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_MultiplyProceduralTexture__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Components/ProceduralTextures/MultiplyProceduralTexture */ "../../3D/src/Components/ProceduralTextures/MultiplyProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_NormalMapProceduralTexture__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Components/ProceduralTextures/NormalMapProceduralTexture */ "../../3D/src/Components/ProceduralTextures/NormalMapProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_OpacityProceduralTexture__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Components/ProceduralTextures/OpacityProceduralTexture */ "../../3D/src/Components/ProceduralTextures/OpacityProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_OverlayProceduralTexture__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Components/ProceduralTextures/OverlayProceduralTexture */ "../../3D/src/Components/ProceduralTextures/OverlayProceduralTexture.ts");
/* harmony import */ var _Components_ProceduralTextures_BlendProceduralTexture__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./Components/ProceduralTextures/BlendProceduralTexture */ "../../3D/src/Components/ProceduralTextures/BlendProceduralTexture.ts");
/* harmony import */ var _Components_ActionExecutor_SceneActionExecutor__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Components/ActionExecutor/SceneActionExecutor */ "../../3D/src/Components/ActionExecutor/SceneActionExecutor.ts");
/* harmony import */ var _Components_CollapseExplode_MeshLocationsManager__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./Components/CollapseExplode/MeshLocationsManager */ "../../3D/src/Components/CollapseExplode/MeshLocationsManager.ts");
/* harmony import */ var _Components_Glow_GlowManager__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./Components/Glow/GlowManager */ "../../3D/src/Components/Glow/GlowManager.ts");
/* harmony import */ var _Components_IncrementalFiles_MakeIncremental__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./Components/IncrementalFiles/MakeIncremental */ "../../3D/src/Components/IncrementalFiles/MakeIncremental.ts");
/* harmony import */ var _Components_IncrementalFiles_IncrementalFiles__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./Components/IncrementalFiles/IncrementalFiles */ "../../3D/src/Components/IncrementalFiles/IncrementalFiles.ts");
/* harmony import */ var _Components_MaterialsPreview_MaterialsPreview__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./Components/MaterialsPreview/MaterialsPreview */ "../../3D/src/Components/MaterialsPreview/MaterialsPreview.ts");
/* harmony import */ var _Components_NormalMap_ProceduralNormalMap__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./Components/NormalMap/ProceduralNormalMap */ "../../3D/src/Components/NormalMap/ProceduralNormalMap.ts");
/* harmony import */ var _Components_Shadows_InnerShadow__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./Components/Shadows/InnerShadow */ "../../3D/src/Components/Shadows/InnerShadow.ts");
/* harmony import */ var _Components_Shadows_OuterShadow__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./Components/Shadows/OuterShadow */ "../../3D/src/Components/Shadows/OuterShadow.ts");
/* harmony import */ var _Components_DesignManagers_MeshDesignManager__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./Components/DesignManagers/MeshDesignManager */ "../../3D/src/Components/DesignManagers/MeshDesignManager.ts");
/* harmony import */ var _Components_DesignManagers_SceneDesignManager__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./Components/DesignManagers/SceneDesignManager */ "../../3D/src/Components/DesignManagers/SceneDesignManager.ts");
/* harmony import */ var _Components_Preview3D_Preview3DConfigurationManager__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./Components/Preview3D/Preview3DConfigurationManager */ "../../3D/src/Components/Preview3D/Preview3DConfigurationManager.ts");
/* harmony import */ var _Components_Draco_DracoCompression__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./Components/Draco/DracoCompression */ "../../3D/src/Components/Draco/DracoCompression.ts");
/* harmony import */ var _Components_Selector_ElementSelector__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./Components/Selector/ElementSelector */ "../../3D/src/Components/Selector/ElementSelector.ts");
/* harmony import */ var _Components_Environment_EnvironmentManager__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./Components/Environment/EnvironmentManager */ "../../3D/src/Components/Environment/EnvironmentManager.ts");
/* harmony import */ var _Components_MeshExpander_MeshExpander__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./Components/MeshExpander/MeshExpander */ "../../3D/src/Components/MeshExpander/MeshExpander.ts");
/* harmony import */ var _Components_SceneHelper__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./Components/SceneHelper */ "../../3D/src/Components/SceneHelper.ts");
/* harmony import */ var _Components_SceneToBlobs_SceneToBlobs__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./Components/SceneToBlobs/SceneToBlobs */ "../../3D/src/Components/SceneToBlobs/SceneToBlobs.ts");
/* harmony import */ var _Components_AR_AndroidAR__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./Components/AR/AndroidAR */ "../../3D/src/Components/AR/AndroidAR.ts");
/* harmony import */ var _Components_InfoPointsManager_InfoPointsManager__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./Components/InfoPointsManager/InfoPointsManager */ "../../3D/src/Components/InfoPointsManager/InfoPointsManager.ts");
/* harmony import */ var _Components_USDZ_UsdzHelper__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./Components/USDZ/UsdzHelper */ "../../3D/src/Components/USDZ/UsdzHelper.ts");
/* harmony import */ var _Helpers_debounce__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./Helpers/debounce */ "../../3D/src/Helpers/debounce.ts");
/* harmony import */ var _Helpers_utils__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./Helpers/utils */ "../../3D/src/Helpers/utils.ts");
/* harmony import */ var _Interfaces_IDisposable__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./Interfaces/IDisposable */ "../../3D/src/Interfaces/IDisposable.ts");
/* harmony import */ var _Interfaces_IDisposable__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_Interfaces_IDisposable__WEBPACK_IMPORTED_MODULE_38__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _Interfaces_IDisposable__WEBPACK_IMPORTED_MODULE_38__) if(["default","EditingMode","EnvironmentMode","ZakekeEnvironment","BlurXProceduralTexture","BlurYProceduralTexture","ForegroundBackgroundProceduralTexture","MoveProceduralTexture","MultiplyProceduralTexture","NormalMapProceduralTexture","OpacityProceduralTexture","OverlayProceduralTexture","BlendProceduralTexture","SceneActionsExecutor","MeshLocationsManager","GlowManager","MakeIncremental","IncrementalFiles","MaterialPreviewData","MaterialsPreview","ProceduralNormalMap","InnerShadow","OuterShadow","MeshDesignManager","SceneDesignManager","Preview3DConfigurationManager","DracoCompression","ElementSelector","EnvironmentManager","MeshExpander","SceneHelper","SceneToBlobs","AndroidAR","InfoPointsManager","UsdzHelper","debounce","Utils"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _Interfaces_IDisposable__WEBPACK_IMPORTED_MODULE_38__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
/* harmony import */ var _Interfaces_ISupportInitialize__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./Interfaces/ISupportInitialize */ "../../3D/src/Interfaces/ISupportInitialize.ts");
/* harmony import */ var _Interfaces_ISupportInitialize__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_Interfaces_ISupportInitialize__WEBPACK_IMPORTED_MODULE_39__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _Interfaces_ISupportInitialize__WEBPACK_IMPORTED_MODULE_39__) if(["default","EditingMode","EnvironmentMode","ZakekeEnvironment","BlurXProceduralTexture","BlurYProceduralTexture","ForegroundBackgroundProceduralTexture","MoveProceduralTexture","MultiplyProceduralTexture","NormalMapProceduralTexture","OpacityProceduralTexture","OverlayProceduralTexture","BlendProceduralTexture","SceneActionsExecutor","MeshLocationsManager","GlowManager","MakeIncremental","IncrementalFiles","MaterialPreviewData","MaterialsPreview","ProceduralNormalMap","InnerShadow","OuterShadow","MeshDesignManager","SceneDesignManager","Preview3DConfigurationManager","DracoCompression","ElementSelector","EnvironmentManager","MeshExpander","SceneHelper","SceneToBlobs","AndroidAR","InfoPointsManager","UsdzHelper","debounce","Utils"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _Interfaces_ISupportInitialize__WEBPACK_IMPORTED_MODULE_39__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
/* harmony import */ var _Interfaces_ISceneEditor__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./Interfaces/ISceneEditor */ "../../3D/src/Interfaces/ISceneEditor.ts");
/* harmony import */ var _Interfaces_ISceneEditor__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_Interfaces_ISceneEditor__WEBPACK_IMPORTED_MODULE_40__);
/* harmony reexport (unknown) */ var __WEBPACK_REEXPORT_OBJECT__ = {};
/* harmony reexport (unknown) */ for(const __WEBPACK_IMPORT_KEY__ in _Interfaces_ISceneEditor__WEBPACK_IMPORTED_MODULE_40__) if(["default","EditingMode","EnvironmentMode","ZakekeEnvironment","BlurXProceduralTexture","BlurYProceduralTexture","ForegroundBackgroundProceduralTexture","MoveProceduralTexture","MultiplyProceduralTexture","NormalMapProceduralTexture","OpacityProceduralTexture","OverlayProceduralTexture","BlendProceduralTexture","SceneActionsExecutor","MeshLocationsManager","GlowManager","MakeIncremental","IncrementalFiles","MaterialPreviewData","MaterialsPreview","ProceduralNormalMap","InnerShadow","OuterShadow","MeshDesignManager","SceneDesignManager","Preview3DConfigurationManager","DracoCompression","ElementSelector","EnvironmentManager","MeshExpander","SceneHelper","SceneToBlobs","AndroidAR","InfoPointsManager","UsdzHelper","debounce","Utils"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) __WEBPACK_REEXPORT_OBJECT__[__WEBPACK_IMPORT_KEY__] = () => _Interfaces_ISceneEditor__WEBPACK_IMPORTED_MODULE_40__[__WEBPACK_IMPORT_KEY__]
/* harmony reexport (unknown) */ __webpack_require__.d(__webpack_exports__, __WEBPACK_REEXPORT_OBJECT__);
/* harmony import */ var _Layers_AxesLayer__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./Layers/AxesLayer */ "../../3D/src/Layers/AxesLayer.ts");
/* harmony import */ var _Layers_LightsLayer__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./Layers/LightsLayer */ "../../3D/src/Layers/LightsLayer.ts");
/* harmony import */ var _Misc_DefaultAssetUrls__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./Misc/DefaultAssetUrls */ "../../3D/src/Misc/DefaultAssetUrls.ts");
/* harmony import */ var _Misc_StringTools__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./Misc/StringTools */ "../../3D/src/Misc/StringTools.ts");
/* harmony import */ var _Misc_Observable__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./Misc/Observable */ "../../3D/src/Misc/Observable.ts");
/* harmony import */ var _Misc_WorkerPool__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./Misc/WorkerPool */ "../../3D/src/Misc/WorkerPool.ts");
/* harmony import */ var _Misc_Database__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./Misc/Database */ "../../3D/src/Misc/Database.ts");
/* harmony import */ var _Viewers_SceneViewer__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./Viewers/SceneViewer */ "../../3D/src/Viewers/SceneViewer.ts");
/* harmony import */ var _Viewers_SceneEditor__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./Viewers/SceneEditor */ "../../3D/src/Viewers/SceneEditor.ts");
/* harmony import */ var _Viewers_MaterialEditor__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./Viewers/MaterialEditor */ "../../3D/src/Viewers/MaterialEditor.ts");
/* harmony import */ var _composer_Components_ChunkedTask__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../../composer/Components/ChunkedTask */ "../Components/ChunkedTask.ts");
/// <reference path="../../libs/babylonjs/5.0.0-alpha.57/babylon.d.ts" />
/// <reference path="../../libs/babylonjs/5.0.0-alpha.57/babylonjs.serializers.d.ts" />
/// <reference path="../../libs/babylonjs/5.0.0-alpha.57/babylonjs.loaders.d.ts" />
/// <reference path="../../libs/babylonjs/5.0.0-alpha.57/babylonjs.materials.d.ts" />
/// <reference path="../../libs/babylonjs/5.0.0-alpha.57/babylon.gui.d.ts" />
/// <reference path="../../libs/jszip/jszip.d.ts" />
/// <reference path="./declarations/General/Backbone.Model.d.ts" />
/// <reference path="./declarations/MPlaza/All.d.ts" />
/// <reference path="./declarations/Zakeke/All.d.ts" />





// root

// Components






























// helpers


// interfaces



// Layers


// misc





// Viewers



// ChunkedTasks



/***/ }),

/***/ "../Components/ChunkedTask.ts":
/*!************************************!*\
  !*** ../Components/ChunkedTask.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Task": () => (/* binding */ Task)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "../../../node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
// ChunckedTask
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

class Task {
    constructor(tasksUrl, token, isOwin = true) {
        this.tasksUrl = tasksUrl;
        this.token = token;
        this.upload = (file, options) => __awaiter(this, void 0, void 0, function* () {
            return yield this.uploadFileChunked(file, file.type, Zakeke.generateUUID(), options);
        });
        this.uploadFileChunked = (imageFile, mimeType, fileID, options, progressCallaback) => __awaiter(this, void 0, void 0, function* () {
            let status = yield this.resumableUpload(imageFile, mimeType, fileID, progressCallaback);
            if (status === 'OK') {
                let taskID = yield this.createTask(fileID, options);
                if (taskID !== -1) {
                    let responseTaskImage = yield this.getResultFromTask(taskID);
                    if (responseTaskImage) {
                        return responseTaskImage.files;
                    }
                }
                else {
                    throw "Upload failed";
                }
            }
            return null;
        });
        this.resumableUpload = (imageFile, mimeType, fileID, progressCallback) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                let r = new Resumable({
                    target: Zakeke.config.baseApiUrl + "filechunks/upload",
                    generateUniqueIdentifier: function () {
                        return fileID;
                    },
                    maxFiles: 1,
                    testChunks: false,
                    headers: this.headers,
                    query: { 'resumableType': mimeType },
                    simultaneousUploads: 3
                });
                // Adding file
                r.addFile(imageFile);
                // Event Upload handlers
                r.on('fileError', function (file, message) {
                    resolve('KO');
                    console.error('fileError', file, message);
                });
                r.on('error', function (message, file) {
                    resolve('KO');
                    console.error('error', message, file);
                });
                r.on('progress', function () {
                    let percentage = (r.progress() * 100);
                    if (progressCallback)
                        progressCallback(percentage);
                });
                r.on('fileAdded', function (file, event) {
                    r.upload();
                });
                r.on('complete', function () {
                    resolve('OK');
                });
            });
        });
        this.createTask = (fileID, options) => __awaiter(this, void 0, void 0, function* () {
            let imageTask = { 'fileID': fileID, 'options': options };
            let response = yield axios__WEBPACK_IMPORTED_MODULE_0___default().post(Zakeke.config.baseApiUrl + this.tasksUrl, imageTask, { headers: this.headers });
            return (response) ? response.data.taskID : -1;
        });
        this.getResultFromTask = (taskID) => __awaiter(this, void 0, void 0, function* () {
            let times = 0;
            for (;;) {
                try {
                    let response = yield axios__WEBPACK_IMPORTED_MODULE_0___default().get(Zakeke.config.baseApiUrl + this.tasksUrl + "/results/" + taskID, { headers: this.headers });
                    if (response && response.data.state === 2) {
                        return response.data;
                    }
                    else if (response && response.data.state === 3) {
                        return null;
                    }
                }
                catch (ex) {
                    return null;
                }
                times++;
                if (times > 200) {
                    return null;
                }
                // Delay 1s
                yield new Promise(resolve => setTimeout(resolve, 1000));
            }
        });
        if (isOwin) {
            this.headers = {
                'Authorization': 'Bearer ' + this.token,
                "Accept-Language": "en-US"
            };
        }
        else {
            this.headers = {
                'X-Auth-Token': this.token,
                "Accept-Language": "en-US"
            };
        }
    }
}


/***/ }),

/***/ "./src/api.ts":
/*!********************!*\
  !*** ./src/api.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "axiosApi": () => (/* binding */ axiosApi),
/* harmony export */   "setupApi": () => (/* binding */ setupApi)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "./node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helpers */ "./src/helpers.tsx");



let axiosApi;
function setupApi(culture, token) {
    axiosApi = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
        baseURL: Zakeke.config.baseApiUrl,
        timeout: 120000,
        withCredentials: true,
        headers: {
            "Authorization": "Bearer " + token,
            "Accept-Language": culture
        }
    });
    $.ajaxSetup({
        xhrFields: { withCredentials: true },
        headers: {
            "Authorization": "Bearer " + token,
            "Accept-Language": culture
        }
    });
    axiosApi.interceptors.response.use(function (response) {
        // Convert all to camelCase
        if (response.data && (lodash__WEBPACK_IMPORTED_MODULE_1___default().isObject(response.data) || lodash__WEBPACK_IMPORTED_MODULE_1___default().isArray(response.data)))
            response.data = _helpers__WEBPACK_IMPORTED_MODULE_2__.StringHelper.pascalToCamel(response.data);
        return response;
    }, function (error) {
        // Convert all to camelCase
        if (error.response && error.response.data) {
            error.response.data = _helpers__WEBPACK_IMPORTED_MODULE_2__.StringHelper.pascalToCamel(error.response.data);
        }
        return Promise.reject(error);
    });
}


/***/ }),

/***/ "./src/components/customizer.tsx":
/*!***************************************!*\
  !*** ./src/components/customizer.tsx ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZakekeDesigner": () => (/* binding */ ZakekeDesigner)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers */ "./src/helpers.tsx");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../state/provider */ "./src/state/provider.tsx");





const ZakekeDesignerContainer = (styled_components__WEBPACK_IMPORTED_MODULE_1___default().div) `
    width: 100%;
    height: 100%;
    position: relative;
    outline: none !important;
    
    canvas {
        outline: none !important;
    }
`;
// Persistent mode will keep the SceneEditor alive after unmount.
// You should save the current editor with the ref
const ZakekeDesigner = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
    const [guid] = react__WEBPACK_IMPORTED_MODULE_0__.useState((0,_helpers__WEBPACK_IMPORTED_MODULE_2__.uuid)());
    const { designUpdate, internalProduct, currentTemplate, internalCurrentTemplate } = (0,_state_provider__WEBPACK_IMPORTED_MODULE_3__.useZakeke)();
    const [customizer, setCustomizer] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        const container = document.getElementById('zakeke-designer-container-' + guid);
        const newCustomizer = new MPlaza.Customizer(false, false, null, true);
        newCustomizer.showSideImage = false;
        newCustomizer.addItemChangedListener(handleItemChanged);
        newCustomizer.addItemRemovedListener(handleItemRemoved);
        // Hide DPI warnings
        newCustomizer.setCustomizedMessages([{
                Description: "",
                EventID: MPlaza.EventMessages.DPIWarning,
                Visible: false
            }]);
        newCustomizer.appendTo(container);
        setCustomizer(newCustomizer);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (internalProduct) {
            const side = internalProduct.get("colors").at(0).get("sides").find(x => x.get('sideID') == props.areaId);
            if (side && customizer && internalCurrentTemplate) {
                customizer.model = internalProduct;
                customizer.setDesign(internalCurrentTemplate);
                customizer.setSide(side).then(() => {
                    customizer.adaptZoomToSideAreas(false);
                });
            }
        }
    }, [props.areaId, currentTemplate, !!customizer]);
    const handleItemChanged = () => {
        designUpdate();
    };
    const handleItemRemoved = () => {
        designUpdate();
    };
    const zoomIn = () => {
        if (customizer)
            customizer.zoomIn();
    };
    const zoomOut = () => {
        if (customizer)
            customizer.zoomOut();
    };
    // Expose the zoom methods to ref
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useImperativeHandle)(ref, () => ({
        zoomIn,
        zoomOut
    }), []);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZakekeDesignerContainer, { id: 'zakeke-designer-container-' + guid });
});


/***/ }),

/***/ "./src/components/sceneViewer.tsx":
/*!****************************************!*\
  !*** ./src/components/sceneViewer.tsx ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZakekeViewer": () => (/* binding */ ZakekeViewer)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../state/provider */ "./src/state/provider.tsx");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../helpers */ "./src/helpers.tsx");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! styled-components */ "styled-components");
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_3__);





const ZakekeViewerContainer = (styled_components__WEBPACK_IMPORTED_MODULE_3___default().div) `
    width: 100%;
    height: 100%;
    position: relative;
    outline: none !important;
    
    canvas {
        outline: none !important;
    }
`;
// Persistent mode will keep the SceneEditor alive after unmount.
// You should save the current editor with the ref
const ZakekeViewer = ({ className }) => {
    const [guid] = react__WEBPACK_IMPORTED_MODULE_0__.useState((0,_helpers__WEBPACK_IMPORTED_MODULE_2__.uuid)());
    const { isViewerReady, internalAppendViewer } = (0,_state_provider__WEBPACK_IMPORTED_MODULE_1__.useZakeke)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
        if (isViewerReady)
            internalAppendViewer(document.getElementById('zakeke-viewer-container-' + guid));
    }, [isViewerReady]);
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZakekeViewerContainer, { id: 'zakeke-viewer-container-' + guid, className: className });
};


/***/ }),

/***/ "./src/environment.tsx":
/*!*****************************!*\
  !*** ./src/environment.tsx ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZakekeEnvironment": () => (/* binding */ ZakekeEnvironment)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! . */ "./src/index.tsx");
/* harmony import */ var _3D_src__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../3D/src */ "../../3D/src/index.ts");
/* harmony import */ var _libs_pricingRuleBase_DesignPriceCalculatorRuleBased__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased */ "../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased.tsx");
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./api */ "./src/api.ts");
/* harmony import */ var _exceptions__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./exceptions */ "./src/exceptions.tsx");
/* harmony import */ var _fontsManager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./fontsManager */ "./src/fontsManager.ts");
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./helpers */ "./src/helpers.tsx");
/* harmony import */ var _imageUploadTask__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./imageUploadTask */ "./src/imageUploadTask.ts");
/* harmony import */ var _integrations_Helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./integrations/Helpers */ "./src/integrations/Helpers.ts");
/* harmony import */ var _integrations_Integration__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./integrations/Integration */ "./src/integrations/Integration.ts");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./models */ "./src/models.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};












class ZakekeEnvironment {
    constructor() {
        this.platformAttributesSelection = [];
        this.previewWidth = 768;
        this.previewHeight = 768;
        this.clientPreviewWidth = 1024;
        this.clientPreviewHeight = 1024;
        this.shareUrlPrefix = null;
        this.events = [];
        this.zkProduct = null;
        this.zkScene = null;
        this.zkCurrentTemplate = null;
        this.zkTemplates = [];
        this.internalIsFullscreen = false;
        this.highlightSettings = null;
        this.previousMeshesVisibleStates = {};
        this.lastCameraLocation = null;
        this.enableShareCompositionUrl = false;
        this.sharedCompositionDocId = null;
        this.savedCompositions = null;
        this.isDraftEditor = false;
        this.isViewerMode = false;
        this.draftCompositionDocId = null;
        this.undoStack = [];
        this.redoStack = [];
        this.currentAttributesSelection = null;
        this.currentCompositionInfo = null;
        this.copyrightMessageLocalStorageKey = "";
        this.sellerSettings = null;
        this.themeCompositions = null;
        this.currency = 'EUR';
        this.groups = [];
        this.fonts = [];
        this.disableTextColors = false;
        this.textColors = [];
        this.defaultColor = '';
        this.quantity = 1;
        this.quantityRule = null;
        this.culture = "en-US";
        this.price = 0;
        this.compositionId = null;
        this.templates = [];
        this.currentTemplate = null;
        this.product = null;
        this.cameras = [];
        this.isExplodedMode = false;
        this.isAssetsLoading = false;
        this.extensionFields = [];
        this.translations = {
            statics: [],
            dynamics: []
        };
        this.publicTranslations = null;
        this.useLegacyScreenshot = false;
        this.eventMessages = null;
        this.parseParameters = (parameters) => {
            console.info("Parameters", parameters);
            // From parameters or URL
            if (parameters) {
                for (const key in parameters) {
                    const value = parameters[key];
                    switch (key) {
                        case "name":
                            this.productName = value.replace(/\+/g, '%20');
                            break;
                        case "ecommerce":
                            this.platform = value;
                            break;
                        case "qty":
                            this.quantity = value;
                            break;
                        case "culture":
                            this.culture = value;
                            break;
                        case "currency":
                            this.currency = value;
                            break;
                        case "token":
                            this.token = value;
                            break;
                        case "compositionId":
                            this.compositionId = value;
                            break;
                        case "modelCode":
                            this.productCode = value;
                            break;
                        case "previewWidth":
                            this.previewWidth = value;
                            break;
                        case "previewHeight":
                            this.previewHeight = value;
                            break;
                        case "shareUrlPrefix":
                            this.shareUrlPrefix = value;
                            break;
                        case "sharedCompositionDocId":
                            this.sharedCompositionDocId = value;
                            break;
                        case "enableShareCompositionUrl":
                            this.enableShareCompositionUrl = value;
                            break;
                        case "isDraftEditor":
                            this.isDraftEditor = value;
                            break;
                        case "draftCompositionDocId":
                            this.draftCompositionDocId = value;
                            break;
                        case "viewerMode":
                            this.isViewerMode = value;
                            break;
                        case "legacyScreenshot":
                            this.useLegacyScreenshot = value == 1;
                            break;
                    }
                    // Attributes collection
                    if (key.indexOf("attributes") == 0) {
                        for (let attr of value) { // For each attribute/option
                            this.platformAttributesSelection.push(new _integrations_Integration__WEBPACK_IMPORTED_MODULE_10__.PlatformAttributeSelection(JSON.stringify(attr[0]), JSON.stringify(attr[1]), "", "", true, true));
                        }
                    }
                }
            }
            else {
                let queryString = window.location.href.substring(window.location.href.lastIndexOf("?") + 1);
                let pieces = queryString.split("&");
                for (let i = 0; i < pieces.length; i++) {
                    let index = pieces[i].indexOf("=");
                    if (index == -1) {
                        throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.ParametersParseFailException(pieces[i]);
                    }
                    let key = decodeURIComponent(pieces[i].substring(0, index));
                    let value = pieces[i].substring(index + 1);
                    switch (key) {
                        case "name":
                            this.productName = decodeURIComponent(value.replace(/\+/g, '%20'));
                            break;
                        case "ecommerce":
                            this.platform = decodeURIComponent(value);
                            break;
                        case "qty":
                            this.quantity = parseFloat(decodeURIComponent(value));
                            break;
                        case "culture":
                            this.culture = decodeURIComponent(value);
                            break;
                        case "currency":
                            this.currency = decodeURIComponent(value);
                            break;
                        case "token":
                            this.token = decodeURIComponent(value);
                            break;
                        case "compositionId":
                            this.compositionId = decodeURIComponent(value);
                            break;
                        case "modelCode":
                            this.productCode = decodeURIComponent(value.replace(/\+/g, '%20'));
                            break;
                        case "previewWidth":
                            this.previewWidth = parseInt(decodeURIComponent(value.replace(/\+/g, '%20')));
                            break;
                        case "previewHeight":
                            this.previewHeight = parseInt(decodeURIComponent(value.replace(/\+/g, '%20')));
                            break;
                        case "shareUrlPrefix":
                            this.shareUrlPrefix = decodeURIComponent(value.replace(/\+/g, '%20'));
                            break;
                        case "sharedCompositionDocId":
                            this.sharedCompositionDocId = decodeURIComponent(value.replace(/\+/g, '%20'));
                            ;
                            break;
                        case "isDraftEditor":
                            this.isDraftEditor = true;
                            break;
                        case "enableShareCompositionUrl":
                            this.enableShareCompositionUrl = true;
                            break;
                        case "draftCompositionDocId":
                            this.draftCompositionDocId = value;
                            break;
                        case "viewerMode":
                            this.isViewerMode = true;
                            break;
                        case "legacyScreenshot":
                            this.useLegacyScreenshot = value == '1';
                            break;
                    }
                    // Attributes collection
                    if (key.indexOf("attributes") == 0) {
                        let data = decodeURIComponent(value.replace(/\+/g, '%20'));
                        if (data && data != "") {
                            let json = JSON.parse(data);
                            for (let attr of json)
                                this.platformAttributesSelection.push(new _integrations_Integration__WEBPACK_IMPORTED_MODULE_10__.PlatformAttributeSelection(JSON.stringify(attr[0]), JSON.stringify(attr[1]), "", "", true, true));
                        }
                    }
                }
            }
            // Parameter validation
            const requiredParams = {
                "culture (in xx_XX format)": this.culture,
                "currency": this.currency,
                "name (product name)": this.productName,
                "ecommerce": this.platform,
                "qty (product quantity)": this.quantity,
                "token": this.token,
                "modelCode": this.productCode
            };
            for (const key in requiredParams) {
                if (!requiredParams[key])
                    throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception("Missing parameter: " + key);
            }
            window["token"] = this.token;
            window["isOwin"] = true;
            return true;
        };
        // Get product
        this.getProduct = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.productCode || this.productCode == "")
                throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception("Loading product but no SKU found");
            return new Promise((resolve, reject) => {
                const zkModel = new MPlaza.Model();
                zkModel.set("modelID", 1);
                zkModel.fetch({
                    success: () => {
                        resolve(zkModel);
                    },
                    error: () => {
                        reject(new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception("Failed loading product"));
                    },
                    data: {
                        c: this.productCode
                    }
                });
            });
        });
        // Get scene
        this.getScene = (product) => __awaiter(this, void 0, void 0, function* () {
            if (!product)
                throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception("Loading scene but no product found");
            if (product.get("scenes").length == 0)
                throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception("The product don't have any scene configured");
            const zkScene = new Zakeke.Scene();
            zkScene.set("sceneID", product.get("scenes").at(0).get("sceneID"));
            return new Promise((resolve, reject) => {
                zkScene.fetch({
                    success: (zkScene) => {
                        resolve(zkScene);
                    },
                    error: () => {
                        reject(new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception("Failed loading scene"));
                    }
                });
            });
        });
        // Get composer models
        this.getComposerModels = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.productCode || this.productCode == "")
                throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception("Loading product but no SKU found");
            return new Promise((resolve, reject) => {
                const models = new Zakeke.ComposerModels();
                models.set("modelID", 1);
                models.fetch({
                    success: () => {
                        resolve(models);
                    },
                    error: () => {
                        reject(new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception("Failed loading product"));
                    },
                    data: {
                        c: this.productCode
                    }
                });
            });
        });
        // Get fonts
        this.getFonts = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            let fonts = (yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.baseApiUrl + "fontfamilies/")).data;
            let productFonts = (_b = (_a = this.zkProduct) === null || _a === void 0 ? void 0 : _a.get("printTypes").at(0).get("fonts").map(x => x.get("fontFamilyID"))) !== null && _b !== void 0 ? _b : [];
            if (productFonts.length > 0)
                fonts = fonts.filter(font => productFonts.indexOf(font.fontFamilyID) != -1);
            return fonts;
        });
        // Get settings
        this.getSettings = () => __awaiter(this, void 0, void 0, function* () {
            const settings = (yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.baseApiUrl + "customizerinfo/")).data;
            return settings;
        });
        this.getSellerSetting = () => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                // Fetch the seller setting
                const sellerSetting = (yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get("sellerSetting/")).data;
                resolve(sellerSetting);
            }));
        });
        // Create quote for composition
        this.createQuote = (formData) => __awaiter(this, void 0, void 0, function* () {
            var _c, _e;
            let quote = new _models__WEBPACK_IMPORTED_MODULE_11__.Quote();
            quote.formData = JSON.stringify(formData);
            quote.quantity = this.quantity;
            quote.compositionDocID = this.composition.get('docID');
            quote.modelPrice = (_c = yield this.integration.getPrice(this.composition, this.zkCurrentTemplate, this.zkProduct, this.platformAttributesSelection, 0, 1)) !== null && _c !== void 0 ? _c : 0;
            quote.variantName = (_e = this.product.name) !== null && _e !== void 0 ? _e : "";
            const quoteCreated = (yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + "quotes", quote)).data;
            return quoteCreated;
        });
        this.getTranslations = () => __awaiter(this, void 0, void 0, function* () {
            try {
                var url = Zakeke.config.baseApiUrl + "SellerLocalizations/customizer-localizations";
                const response = yield $.ajax({
                    url: url,
                    data: JSON.stringify({}),
                    method: "GET",
                    contentType: "application/json",
                    dataType: "json"
                });
                if (response != null) {
                    // console.log(`getTranslations response is OK: ${JSON.stringify(response)}`);
                    return response;
                }
                else {
                    console.log('getTranslations response is empty');
                }
            }
            catch (e) {
                console.error(e);
            }
        });
        this.loadLocalization = () => __awaiter(this, void 0, void 0, function* () {
            let lang = this.culture;
            // Try zh-TW
            if (Zakeke.config.avaibleLanguages.indexOf(lang) == -1)
                lang = this.culture.substring(0, 2);
            // Try zh
            if (Zakeke.config.avaibleLanguages.lastIndexOf(lang) == -1)
                lang = "en";
            yield this.loadScript(Zakeke.config.baseUrl + `Scripts/localizations/${lang.toLowerCase()}/composer.js`);
        });
        this.loadScript = (src) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var script = document.createElement("script");
                script.onload = resolve;
                script.src = src;
                document.body.appendChild(script);
            });
        });
        this.setCopyrightMessageAccepted = (copyrightMandatoryCheckbox) => {
            try {
                if (copyrightMandatoryCheckbox)
                    window.localStorage.setItem(this.copyrightMessageLocalStorageKey, (copyrightMandatoryCheckbox).toString());
                else
                    window.localStorage.removeItem(this.copyrightMessageLocalStorageKey);
            }
            catch (e) { }
        };
        this.getCopyrightMessageAccepted = () => {
            let copyrightMessageAccepted = false;
            try {
                copyrightMessageAccepted = window.localStorage.getItem(this.copyrightMessageLocalStorageKey) ? true : false;
            }
            catch (e) { }
            ;
            return copyrightMessageAccepted;
        };
        this.boot = (parameters) => __awaiter(this, void 0, void 0, function* () {
            var _f, _g;
            this.parseParameters(parameters);
            (0,_api__WEBPACK_IMPORTED_MODULE_4__.setupApi)(this.culture, this.token);
            yield this.loadLocalization();
            this.settings = yield this.getSettings();
            this.copyrightMessageLocalStorageKey = this.settings.userID + "_copyright_accepted";
            this.eventMessages = this.settings.eventMessages.map(message => ___WEBPACK_IMPORTED_MODULE_1__.EventMessage.fromMessage(message));
            this.trigger("change");
            this.translations = yield this.getTranslations();
            const staticTranslations = new Map(this.translations.statics.map(staticTranslation => [staticTranslation.original, staticTranslation.localization]));
            const dynamicTranslations = new Map(this.translations.dynamics.map(staticTranslation => [staticTranslation.original, staticTranslation.localization]));
            this.publicTranslations = {
                statics: staticTranslations,
                dynamics: dynamicTranslations
            };
            _helpers__WEBPACK_IMPORTED_MODULE_7__.T.translations = this.publicTranslations;
            this.trigger("change");
            const composerModels = yield this.getComposerModels();
            this.zkScene = composerModels.get('scene');
            this.zkProduct = composerModels.get('model');
            this.product = _models__WEBPACK_IMPORTED_MODULE_11__.Product.fromProduct(this.zkProduct);
            this.quantityRule = this.zkProduct.get("quantityRule") ? _models__WEBPACK_IMPORTED_MODULE_11__.ProductQuantityRule.fromQuantityRule(this.zkProduct.get("quantityRule")) : null;
            this.integration = yield (0,_integrations_Helpers__WEBPACK_IMPORTED_MODULE_9__.integrationFor)(this.platform);
            this.sellerSettings = yield this.getSellerSetting();
            if (!this.zkScene)
                throw new Error('Product has no 3D scene.');
            this.trigger("change");
            this.fonts = yield this.getFonts();
            this.defaultColor = this.getDefaultColor();
            this.disableTextColors = this.getDisableTextColors();
            this.textColors = this.getTextColors();
            this.trigger("change");
            this.zkTemplates = yield this.getTemplates();
            this.templates = this.zkTemplates.map(zkTemplate => _models__WEBPACK_IMPORTED_MODULE_11__.Template.fromTemplate(zkTemplate));
            this.cameras = (_g = (_f = this.zkScene) === null || _f === void 0 ? void 0 : _f.get('cameraLocations').map(x => _models__WEBPACK_IMPORTED_MODULE_11__.Camera.fromZkCamera(x))) !== null && _g !== void 0 ? _g : [];
            this.trigger("change");
            this.viewer = yield _3D_src__WEBPACK_IMPORTED_MODULE_2__.SceneViewer.createSceneViewerAsync();
            this.viewer.isHologramSource = true;
            this.viewer.addBeginAssetsLoadingListener(() => {
                this.isAssetsLoading = true;
                this.trigger("change");
            });
            this.viewer.addEndAssetsLoadingListener(() => {
                this.isAssetsLoading = false;
                this.trigger("change");
            });
            if (this.highlightSettings) {
                this.viewer.highlightColor = this.highlightSettings.color;
                this.viewer.highlightSize = this.highlightSettings.size;
            }
            this.viewer.setLoadingScreen({
                displayLoadingUI: () => null,
                hideLoadingUI: () => null,
                loadingUIBackgroundColor: 'black',
                loadingUIText: 'black'
            });
            this.viewer.infoPointsManagerStyle = {
                imagePanelStyle: {
                    backgroundColor: "white",
                    loadingTextColor: "#cccccc",
                    buttonsBorderColor: "#dddddd",
                    buttonsBorderHighlightColor: "#eeeeee",
                    buttonsColor: "#888888",
                    buttonsHighlightColor: "#555555",
                    buttonsIconColor: "white"
                }
            };
            // Set transparent background
            this.zkScene.getOrCreateEnvironmentConfig().set("mainColor", '#000000');
            this.zkScene.getOrCreateGeneralConfig().set("backgroundColor", '#000000');
            this.zkScene.getOrCreateGeneralConfig().set("backgroundAlpha", 0);
            // Pricing calculator
            this.pricingCalculator = yield _libs_pricingRuleBase_DesignPriceCalculatorRuleBased__WEBPACK_IMPORTED_MODULE_3__.DesignPriceCalculatorRuleFactory.create(this.zkProduct, Zakeke.config.baseApiUrl, this.token, true, Zakeke.config.cloudFlareApiUrl);
            this.pricingCalculator.colorID = this.zkProduct.get('colors').at(0).get('colorID');
            this.integration.setPricingCalculator(this.pricingCalculator);
            yield this.viewer.loadSceneFromModelAsync(this.zkProduct, this.zkScene);
            this.trigger("change");
            yield this.handleSceneLoaded();
        });
        this.appendViewer = (container) => {
            if (this.viewer)
                this.viewer.appendTo(container);
        };
        this.setHighlightSettings = (settings) => {
            this.highlightSettings = settings;
            if (this.viewer) {
                this.viewer.highlightColor = settings.color;
                this.viewer.highlightSize = settings.size;
            }
        };
        this.renderDesign = lodash__WEBPACK_IMPORTED_MODULE_0___default().throttle(() => __awaiter(this, void 0, void 0, function* () {
            if (this.viewer && this.zkCurrentTemplate) {
                yield this.viewer.renderDesignAsync(this.zkCurrentTemplate);
                this.fireItemsChange();
            }
        }), 300);
        this.resize = () => {
            if (!this.viewer)
                return;
            //this.viewer.updateView(false);
            // Restore last camera locazione
            if (this.lastCameraLocation && this.lastCameraLocation !== Zakeke.getEmptyUUID()) {
                console.log("Restoring last camera location " + this.lastCameraLocation + " ...");
                this.setCamera(this.lastCameraLocation, false, false);
            }
            else {
                this.viewer.adjustCamera(false);
            }
        };
        this.buildRecapProps = lodash__WEBPACK_IMPORTED_MODULE_0___default().debounce((selectedOptions) => {
            if (!this.sellerSettings || !this.sellerSettings.isCompositionRecapEnabled)
                return;
            const storeAttr = this.zkProduct.get("attributes");
            const storeGroups = this.zkProduct.get("attributeGroups");
            const storeSteps = this.zkProduct.get("attributeSteps");
            const recapProps = {};
            selectedOptions.forEach((item) => {
                const currentAttr = storeAttr.find(attr => attr.get("attributeID") == item.attributeID);
                const currentOption = currentAttr.get("options").find(opt => opt.get("optionID") == item.optionID);
                const currentGroup = storeGroups.find(group => group.get("groupID") == currentAttr.get('groupID'));
                const currentStep = storeSteps.find(step => step.get("stepID") == currentAttr.get('stepID'));
                let label = "";
                let isOptionEnabled = false;
                this.selection.get("groups").each(group => {
                    group.get("attributes").each(attr => {
                        var _a, _b, _c, _e;
                        const option = attr.get("options").find(x => x.get('optionID') == currentOption.get("optionID"));
                        if (option && attr.get("enabled")) {
                            isOptionEnabled = this.isOptionEnabled(currentOption.get("optionID"));
                            label = group.get("groupID") !== -1 ? (_helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(group.get("name")) + " " + _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(currentAttr.get("name"))) : _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(currentAttr.get("name"));
                            recapProps[`${label}`] = {
                                groupDisplayOrder: (_a = currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.get('displayOrder')) !== null && _a !== void 0 ? _a : 0,
                                stepDisplayOrder: (_b = currentStep === null || currentStep === void 0 ? void 0 : currentStep.get('displayOrder')) !== null && _b !== void 0 ? _b : 0,
                                attributeDisplayOrder: (_c = currentAttr === null || currentAttr === void 0 ? void 0 : currentAttr.get('displayOrder')) !== null && _c !== void 0 ? _c : 0,
                                optionDisplayOrder: (_e = currentOption === null || currentOption === void 0 ? void 0 : currentOption.get('displayOrder')) !== null && _e !== void 0 ? _e : 0,
                                value: _helpers__WEBPACK_IMPORTED_MODULE_7__.T._d(currentOption.get("name")),
                            };
                        }
                    });
                });
            });
            this.currentAttributesSelection = recapProps;
        }, 200);
        this.updateRecapAndExtensionField = () => {
            const selectedOptions = [];
            this.selection.getAllAttributeSelections().forEach(attribute => {
                attribute.get("options").forEach((option) => {
                    if (option.get("selected")) {
                        selectedOptions.push({
                            attributeID: option.get("attributeID"),
                            optionID: option.get("optionID"),
                        });
                    }
                });
            });
            this.getCurrentExtensionFields(selectedOptions);
            this.buildRecapProps(selectedOptions);
            this.trigger('change');
        };
        this.getCurrentExtensionFields = (options) => {
            const propsValues = [];
            const propsMap = {};
            const storeAttr = this.zkProduct.get("attributes");
            options.forEach(item => {
                const currentAttr = storeAttr.find(attr => attr.get("attributeID") == item.attributeID);
                const currentOption = currentAttr.get("options").find(opt => opt.get("optionID") == item.optionID);
                if (currentOption.get("extensionFields").length) {
                    currentOption.get("extensionFields").forEach((item) => {
                        if (propsValues.length === 0 || propsValues.indexOf(item.name) == -1) {
                            propsValues.push(item.name);
                            propsMap[item.name] = {
                                value: 0,
                                label: item.label,
                                formatString: item.formatString,
                            };
                        }
                        let val;
                        if (item.dataTypeID === _models__WEBPACK_IMPORTED_MODULE_11__.ExtensionFieldDataType.Integer) {
                            val = parseInt(item.value);
                        }
                        else {
                            val = parseFloat(item.value);
                        }
                        propsMap[item.name].value += val;
                    });
                }
            });
            let itemsArray = Object.keys(propsMap)
                .map(function (key) {
                return (propsMap[key]);
            });
            this.extensionFields = itemsArray;
        };
        this.handleSceneLoaded = () => __awaiter(this, void 0, void 0, function* () {
            var _h, _j;
            window.addEventListener("resize", this.resize);
            console.log("Scene loaded");
            this.selection = Zakeke.ComposerSelection.CreateComposerSelection(this.zkProduct);
            let currentCompositionId = this.draftCompositionDocId || this.sharedCompositionDocId || this.compositionId;
            if (this.initialSelection == undefined) {
                this.initialSelection = this.cloneSelection(this.selection);
            }
            yield this.internalLoadComposition(currentCompositionId);
            this.trigger("change");
            this.buildStructure();
            // Trigger quantity update
            this.setQuantity(this.quantity);
            this.renderDesign();
            //this.viewer.addNotifyMessageListener((sideID, itemGuid, type, title, message, closabled, requiredWidth, requiredHeight) => this.trigger("change"));
            //this.viewer.addRemoveMessageListener((sideID, itemGuid) => this.trigger("change"));
            // this.viewer.setEventMessages(this.settings.eventMessages.map(x => ({
            //     AddToCartDisabledIfVisible: x.addToCartDisabledIfVisible,
            //     AdditionalData: x.additionalData,
            //     Closeable: x.closeable,
            //     Description: x.description,
            //     EnableCheckForSellerImages: x.enableCheckForSellerImages,
            //     EventID: x.eventID,
            //     Visible: x.visible
            // })));
            if (this.sellerSettings) {
                this.addHotjarScript((_h = this.sellerSettings) === null || _h === void 0 ? void 0 : _h.hotjarSiteID);
                this.addGoogleTagManagerID((_j = this.sellerSettings) === null || _j === void 0 ? void 0 : _j.googleTagManagerID);
            }
            if (this.sharedCompositionDocId) {
                this.composition.set("docID", null);
                this.composition.set("designDocID", null);
            }
            this.registerView();
            yield this.updateSavedCompositions();
            setTimeout(() => this.updateRecapAndExtensionField(), 1000);
        });
        this.getComposition = (id) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const composition = new MPlaza.Composition();
                composition.set("docID", id);
                composition.fetch({
                    success: (model) => {
                        resolve(model);
                    },
                    error: () => {
                        reject();
                    }
                });
            });
        });
        this.getDesign = (id) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                const design = new MPlaza.Design();
                design.set("docID", id);
                design.fetch({
                    success: (model) => {
                        resolve(model);
                    },
                    error: () => {
                        reject();
                    },
                    data: {
                        frombackoffice: (this.isDraftEditor ? true : false)
                    }
                });
                design.addEventListener('change', this.updatePrice);
            });
        });
        this.internalLoadDesign = (id) => __awaiter(this, void 0, void 0, function* () {
            this.zkCurrentTemplate = yield this.getDesign(this.composition.get("designDocID"));
            yield (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.downloadFontsOfDesign)(this.zkCurrentTemplate, this.fonts);
            this.renderDesign();
        });
        this.loadComposition = (id) => __awaiter(this, void 0, void 0, function* () {
            yield this.internalLoadComposition(id);
            this.buildStructure();
        });
        this.internalLoadComposition = (id) => __awaiter(this, void 0, void 0, function* () {
            // Get or create a new composition
            if (id) {
                this.composition = yield this.getComposition(id);
                this.selection.setupOnComposition(this.composition);
                if (this.composition.get("designDocID")) {
                    yield this.internalLoadDesign(this.composition.get("designDocID"));
                }
                else if (this.templates.length > 0) {
                    this.setTemplate(this.templates[0].id);
                }
            }
            else {
                this.composition = this.selection.buildComposition();
                // Select initial values from platform
                for (let platformSelection of this.platformAttributesSelection) {
                    // Search the attribute
                    this.zkProduct.get("attributes").each(attribute => {
                        if ((0,_helpers__WEBPACK_IMPORTED_MODULE_7__.isPlatformCode)(attribute.get("attributeCode"))) {
                            try {
                                if ((0,_helpers__WEBPACK_IMPORTED_MODULE_7__.compare)(JSON.parse(attribute.get("attributeCode")), JSON.parse(platformSelection.attributeCode))) {
                                    let option = attribute.get("options").find(option => {
                                        return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.compare)(JSON.parse(option.get("optionCode")), JSON.parse(platformSelection.optionCode));
                                    });
                                    if (option) {
                                        this.selection.selectAttributeValue(attribute.get('attributeID'), option.get('optionID'));
                                        // Update here the labels because events are not attached yet (attached below)
                                        platformSelection.attributeLabel = attribute.get("name");
                                        platformSelection.optionLabel = option.get("name");
                                    }
                                }
                            }
                            catch (ex) {
                                console.error("Failed parsing attribute from data:", platformSelection);
                                console.error(ex);
                            }
                        }
                    });
                }
                if (this.templates.length > 0)
                    this.setTemplate(this.templates[0].id);
            }
            // Add all composition attributes to the platformAttributes that we will send to the plugin
            this.selection.get("groups").each(group => {
                group.get("attributes").each(attribute => {
                    // Here we check if this attributes was already passed from the parameters.
                    // If yes, we ignore it because the correct value was already selected in the previous rows.
                    // else we add it to the list of attributes selections
                    let oldAttribute = this.platformAttributesSelection.find(x => {
                        return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attribute.get("attributeCode"));
                    });
                    if ((!oldAttribute)) {
                        let selectedOption = attribute.get("options").findWhere({ selected: true });
                        if (selectedOption)
                            this.platformAttributesSelection.push(new _integrations_Integration__WEBPACK_IMPORTED_MODULE_10__.PlatformAttributeSelection(attribute.get("attributeCode"), selectedOption.get("optionCode"), attribute.get("name"), selectedOption.get("name"), attribute.get("enabled"), selectedOption.get("enabled")));
                    }
                });
            });
            const script = this.selection.getAllAttributeTransformationScript();
            this.viewer.adjustCamera(false);
            yield this.viewer.executeScriptAsync(script);
            this.selection.on("attributeSelectionChanged", (e) => {
                this.handleAttributeSelectionChanged(e);
            });
            this.selection.on("attributeEnabled", (e) => {
                this.handleAttributeEnabled(e.attributeID);
            });
            this.selection.on("attributeDisabled", (e) => {
                this.handleAttributeDisabled(e.attributeID);
            });
            this.selection.on("attributeOptionEnabled", (e) => {
                this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            this.selection.on("attributeOptionDisabled", (e) => {
                this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            this.updateComposition();
            this.updateRecapAndExtensionField();
        });
        this.cloneSelection = (selection) => {
            const clone = new Zakeke.ComposerSelection();
            clone.set('zkModel', this.zkProduct);
            clone.set('attributeDependencies', selection.get('attributeDependencies'));
            clone.set('optionDependencies', selection.get('optionDependencies'));
            clone.get('groups').reset();
            selection.get('groups').each(group => {
                var cloneGroup = new Zakeke.AttributeGroupSelection();
                for (const key in group.attributes) {
                    cloneGroup.set(key, group.attributes[key]);
                }
                clone.get('groups').add(cloneGroup);
            });
            let idx = 0;
            clone.get("groups").each((group) => {
                group.set("attributes", selection.get("groups").at(idx).get("attributes").clone());
                group.get('attributes').reset();
                selection.get("groups").at(idx).get("attributes").each(attribute => {
                    var cloneAttribute = new Zakeke.AttributeSelection();
                    for (const key in attribute.attributes) {
                        cloneAttribute.set(key, attribute.attributes[key]);
                    }
                    group.get('attributes').add(cloneAttribute);
                });
                let idx2 = 0;
                group.get("attributes").each((attribute) => {
                    attribute.set("options", selection.get("groups").at(idx).get("attributes").at(idx2).get("options").clone());
                    attribute.get('options').reset();
                    selection.get("groups").at(idx).get("attributes").at(idx2).get("options").each(option => {
                        var cloneOption = new Zakeke.OptionSelection();
                        for (const key in option.attributes) {
                            cloneOption.set(key, option.attributes[key]);
                        }
                        attribute.get('options').add(cloneOption);
                    });
                    idx2++;
                });
                idx++;
            });
            return clone;
        };
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            let selection = (this.undoStack && this.undoStack.length > 0 ? this.undoStack.pop() : null);
            if (!selection)
                return;
            this.redoStack.push(this.selection);
            this.selection = selection;
            this.selection.on("attributeSelectionChanged", (e) => {
                this.handleAttributeSelectionChanged(e);
            });
            this.selection.on("attributeEnabled", (e) => {
                this.handleAttributeEnabled(e.attributeID);
            });
            this.selection.on("attributeDisabled", (e) => {
                this.handleAttributeDisabled(e.attributeID);
            });
            this.selection.on("attributeOptionEnabled", (e) => {
                this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            this.selection.on("attributeOptionDisabled", (e) => {
                this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            this.selection.attachEvents();
            let script = this.selection.getAllAttributeTransformationScript();
            yield this.viewer.executeScriptAsync(script);
            this.buildStructure();
            this.updateComposition();
            this.updateRecapAndExtensionField();
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            let selection = (this.redoStack && this.redoStack.length > 0 ? this.redoStack.pop() : null);
            if (!selection)
                return;
            this.undoStack.push(this.selection);
            this.selection = selection;
            this.selection.on("attributeSelectionChanged", (e) => {
                this.handleAttributeSelectionChanged(e);
            });
            this.selection.on("attributeEnabled", (e) => {
                this.handleAttributeEnabled(e.attributeID);
            });
            this.selection.on("attributeDisabled", (e) => {
                this.handleAttributeDisabled(e.attributeID);
            });
            this.selection.on("attributeOptionEnabled", (e) => {
                this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            this.selection.on("attributeOptionDisabled", (e) => {
                this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            this.selection.attachEvents();
            let script = this.selection.getAllAttributeTransformationScript();
            yield this.viewer.executeScriptAsync(script);
            this.buildStructure();
            this.updateComposition();
            this.updateRecapAndExtensionField();
        });
        this.reset = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.initialSelection)
                return;
            this.undoStack = [];
            this.redoStack = [];
            this.selection = this.cloneSelection(this.initialSelection);
            this.selection.attachEvents();
            this.selection.on("attributeSelectionChanged", (e) => {
                this.handleAttributeSelectionChanged(e);
            });
            this.selection.on("attributeEnabled", (e) => {
                this.handleAttributeEnabled(e.attributeID);
            });
            this.selection.on("attributeDisabled", (e) => {
                this.handleAttributeDisabled(e.attributeID);
            });
            this.selection.on("attributeOptionEnabled", (e) => {
                this.handleAttributeOptionEnabled(e.attributeID, e.optionID);
            });
            this.selection.on("attributeOptionDisabled", (e) => {
                this.handleAttributeOptionDisabled(e.attributeID, e.optionID);
            });
            let script = this.selection.getAllAttributeTransformationScript();
            yield this.viewer.executeScriptAsync(script);
            this.buildStructure();
            this.updateComposition();
            this.updateRecapAndExtensionField();
        });
        this.handleAttributeSelectionChanged = (e) => __awaiter(this, void 0, void 0, function* () {
            yield this.viewer.executeActionsAsync(e.attributeID, e.selectedValue, e.actions);
            this.updateComposition();
            const attribute = this.zkProduct.get("attributes").find(attribute => attribute.get('attributeID') == e.attributeID);
            if (attribute) {
                const option = attribute.get("options").find(option => option.get('optionID') == e.selectedValue);
                if (option) {
                    // Change platform selection
                    let platformSelection = this.platformAttributesSelection.find(x => {
                        return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(x.attributeCode, attribute.get("attributeCode"));
                    });
                    if (platformSelection) {
                        platformSelection.optionCode = option.get("optionCode");
                        platformSelection.optionLabel = option.get("name");
                    }
                    this.setOptionSelectionEnabled(attribute.get('attributeID'), option.get('optionID'), this.isOptionEnabled(option.get('optionID')));
                }
            }
            this.buildStructure();
            this.renderDesign();
        });
        this.handleAttributeEnabled = (attributeId) => {
            this.updateComposition();
            this.setAttributeSelectionEnabled(attributeId, true);
            this.buildStructure();
            this.renderDesign();
        };
        this.handleAttributeDisabled = (attributeId) => {
            this.updateComposition();
            this.setAttributeSelectionEnabled(attributeId, false);
            this.buildStructure();
            this.renderDesign();
        };
        this.handleAttributeOptionEnabled = (attributeId, optionId) => {
            this.updateComposition();
            this.setOptionSelectionEnabled(attributeId, optionId, true);
            this.buildStructure();
            this.renderDesign();
        };
        this.handleAttributeOptionDisabled = (attributeId, optionId) => {
            this.updateComposition();
            this.setOptionSelectionEnabled(attributeId, optionId, false);
            this.buildStructure();
            this.renderDesign();
        };
        // Set the current attribute platform selection as enabled or not
        this.setAttributeSelectionEnabled = (attributeId, isEnabled) => {
            let attribute = this.zkProduct.get("attributes").find(attribute => attribute.get('attributeID') == attributeId);
            if (attribute) {
                let attributePlatformSelection = this.platformAttributesSelection.find(selection => {
                    return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(selection.attributeCode, attribute.get("attributeCode"));
                });
                if (attributePlatformSelection) {
                    attributePlatformSelection.attributeIsEnabled = isEnabled;
                }
                // Set all options as disabled too in platfrom attributes
                attribute.get("options").each(option => {
                    this.setOptionSelectionEnabled(attributeId, option.get('optionID'), isEnabled);
                });
            }
        };
        // Set the current option platform selection as enabled or not but only if it's the selected option
        this.setOptionSelectionEnabled = (attributeId, optionId, isEnabled) => {
            let attribute = this.zkProduct.get("attributes").find(attribute => attribute.get('attributeID') == attributeId);
            if (attribute) {
                let option = attribute.get("options").find(option => option.get('optionID') == optionId);
                if (option) {
                    let attributePlatformSelection = this.platformAttributesSelection.find(selection => {
                        return (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(selection.attributeCode, attribute.get("attributeCode"));
                    });
                    if (attributePlatformSelection && (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.matchCodes)(attributePlatformSelection.optionCode, option.get("optionCode"))) {
                        attributePlatformSelection.optionIsEnabled = isEnabled;
                    }
                }
            }
            this.updateRecapAndExtensionField();
        };
        this.isOptionEnabled = (optionId) => {
            let enabled = false;
            this.selection.get("groups").each(group => {
                group.get("attributes").each(attr => {
                    let option = attr.get("options").find(x => x.id == optionId);
                    if (option)
                        enabled = option.get("enabled");
                });
            });
            return enabled;
        };
        this.updateComposition = () => {
            this.selection.updateComposition(this.composition);
            this.updatePrice();
        };
        this._updatePrice = () => __awaiter(this, void 0, void 0, function* () {
            var price = 0;
            if (this.composition && this.zkProduct) {
                let compositionPrice = this.composition.getPrice(this.zkProduct, this.quantity);
                price = yield this.integration.getPrice(this.composition, this.zkCurrentTemplate, this.zkProduct, this.platformAttributesSelection, compositionPrice, this.quantity);
            }
            this.price = price;
            this.trigger("change");
        });
        this.updatePrice = lodash__WEBPACK_IMPORTED_MODULE_0___default().debounce(this._updatePrice, 300);
        this.buildStructure = () => {
            let data = [];
            if (this.selection) {
                for (var i = 0; i < this.selection.get("groups").length; i++) {
                    var group = this.selection.get("groups").at(i);
                    var groupData = this.createGroupFromSelection(group);
                    data.push(groupData);
                }
                data.sort((a, b) => a.displayOrder - b.displayOrder);
            }
            this.groups = data;
            this.trigger("change");
        };
        this.createGroupFromSelection = (groupSelection) => {
            let zakekeGroup = this.zkProduct.get("attributeGroups").get(groupSelection.get("groupID"));
            let imageUrl = zakekeGroup ? zakekeGroup.get("imageUrl") : null;
            let group = new _models__WEBPACK_IMPORTED_MODULE_11__.Group();
            group.id = zakekeGroup ? zakekeGroup.get('groupID') : -1;
            group.guid = zakekeGroup ? zakekeGroup.get("groupGuid") : '-1';
            group.name = zakekeGroup ? zakekeGroup.get("name") : "Other";
            group.imageUrl = imageUrl;
            group.enabled = true;
            group.cameraLocationId = zakekeGroup ? zakekeGroup.get("sceneCameraLocationID") : null;
            group.steps = this.zkProduct.get("attributeSteps")
                .filter(step => step.get("groupID") == group.id)
                .map(step => this.createStep(step, groupSelection));
            if (zakekeGroup) {
                group.displayOrder = zakekeGroup.get("displayOrder");
                group.direction = zakekeGroup.get("direction");
                group.attributesAlwaysOpened = zakekeGroup.get("attributesAlwaysOpened");
            }
            for (var i = 0; i < groupSelection.get("attributes").length; i++) {
                let attributeSelection = groupSelection.get("attributes").at(i);
                let zakekeAttribute = this.zkProduct.get("attributes").find(attribute => attribute.get('attributeID') == attributeSelection.id);
                if (zakekeAttribute.get("stepID") == -1) {
                    let attribute = this.createAttributeFromSelection(attributeSelection);
                    group.attributes.push(attribute);
                }
            }
            group.attributes.sort((a, b) => a.displayOrder - b.displayOrder);
            return group;
        };
        this.createAttributeFromSelection = (attributeSelection) => {
            let zakekeAttribute = this.zkProduct.get("attributes").get(attributeSelection.get("attributeID"));
            var attribute = new _models__WEBPACK_IMPORTED_MODULE_11__.Attribute();
            attribute.id = zakekeAttribute.get('attributeID');
            attribute.guid = zakekeAttribute.get("attributeGuid");
            attribute.code = zakekeAttribute.get("attributeCode");
            attribute.name = zakekeAttribute.get("name") || '';
            attribute.description = zakekeAttribute.get("description") || '';
            attribute.optionShapeType = zakekeAttribute.get("optionPreviewShapeID") == 1 ? _models__WEBPACK_IMPORTED_MODULE_11__.AttributeOptionShapeType.Round : _models__WEBPACK_IMPORTED_MODULE_11__.AttributeOptionShapeType.Square;
            attribute.displayOrder = zakekeAttribute.get("displayOrder");
            attribute.enabled = attributeSelection.get("enabled");
            attribute.groupId = zakekeAttribute.get("groupID");
            attribute.stepId = zakekeAttribute.get("stepID");
            attribute.hideOptionsLabel = zakekeAttribute.get("hideOptionsLabel");
            attribute.cameraLocationId = zakekeAttribute ? zakekeAttribute.get("sceneCameraLocationID") : null;
            // Options
            for (var i = 0; i < attributeSelection.get("options").length; i++) {
                let optionSelection = attributeSelection.get("options").at(i);
                let option = this.createOptionFromSelection(optionSelection);
                option.attribute = attribute;
                attribute.options.push(option);
            }
            if (attributeSelection.get("attributeTypeID") == MPlaza.AttributeType.Options) {
                attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Select;
            }
            else if (attributeSelection.get("attributeTypeID") == MPlaza.AttributeType.Color) {
                attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Colorpicker;
                attribute.value = attributeSelection.get("selectedValue");
            }
            else if (attributeSelection.get("attributeTypeID") == MPlaza.AttributeType.Number) {
                attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Colorpicker;
                attribute.value = attributeSelection.get("selectedValue");
                attribute.numberFormat = "";
            }
            else if (attributeSelection.get("attributeTypeID") == MPlaza.AttributeType.String) {
                attribute.type = _models__WEBPACK_IMPORTED_MODULE_11__.AttributeType.Colorpicker;
                attribute.value = attributeSelection.get("selectedValue");
                attribute.numberFormat = "";
            }
            attribute.options.sort((a, b) => a.displayOrder - b.displayOrder);
            return attribute;
        };
        this.createOptionFromSelection = (optionSelection) => {
            var zakekeOption = this.zkProduct.get("attributes").get(optionSelection.get("attributeID")).get("options").get(optionSelection.get("optionID"));
            var option = new _models__WEBPACK_IMPORTED_MODULE_11__.Option();
            option.id = zakekeOption.get('optionID');
            option.guid = zakekeOption.get("optionGuid");
            option.code = zakekeOption.get("optionCode");
            option.name = zakekeOption.get("name") || '';
            option.description = zakekeOption.get("description") || '';
            option.imageUrl = zakekeOption.get("imageUrl");
            option.displayOrder = zakekeOption.get("displayOrder");
            option.selected = optionSelection.get("selected");
            option.enabled = optionSelection.get("enabled");
            return option;
        };
        this.saveDesignBackbone = () => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                let design = this.zkCurrentTemplate;
                if (!design) {
                    resolve();
                    return;
                }
                design.save(null, {
                    success: (model) => {
                        this.composition.set("designDocID", model.get("docID"));
                        resolve();
                    },
                    error: () => {
                        reject();
                    },
                    headers: {
                        fromBackOffice: (this.isDraftEditor ? true : false)
                    }
                });
            });
        });
        this.saveCompositionBackbone = () => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                this.composition.save(null, {
                    success: (model, response, options) => {
                        resolve();
                    },
                    error: (model, response, options) => {
                        reject();
                    },
                    headers: {
                        fromBackOffice: this.isDraftEditor ? true : false
                    }
                });
            });
        });
        // Events 
        this.trigger = (event, ...params) => {
            for (let handler of this.events.filter(x => x.event == event)) {
                if (handler.callback)
                    handler.callback.apply(this, params);
                else
                    console.error("Event handler can't be null or undefined");
            }
        };
        this.on = (event, callback) => {
            this.events.push(new _models__WEBPACK_IMPORTED_MODULE_11__.ZakekeEvent(event, callback));
        };
        this.off = (event, callback) => {
            this.events = this.events.filter(x => {
                return x.event == event && x.callback == callback;
            });
        };
        this.setTemplate = (templateId) => {
            this.zkCurrentTemplate = this.zkTemplates.find(x => x.get("templateDesignID") == templateId);
            this.currentTemplate = this.templates.find(x => x.id == templateId) || null;
            this.renderDesign();
        };
        this.getTemplateUploadRestrictictions = (templateId, areaId) => {
            var _a, _b, _c, _e, _f, _g, _h;
            const design = this.zkTemplates.find(x => x.get("templateDesignID") == templateId);
            if (!design)
                throw "Template does not exists with id " + templateId;
            const designSide = design.getDesignSide(this.zkProduct.get("colors").at(0).get("sides").get(areaId));
            const getUploadRestriction = (restriction) => {
                var _a, _b;
                if (designSide && designSide.get("uploadRestrictions"))
                    return (_a = designSide.get("uploadRestrictions")) === null || _a === void 0 ? void 0 : _a[restriction];
                else if (design.get("uploadRestrictions"))
                    (_b = design.get("uploadRestrictions")) === null || _b === void 0 ? void 0 : _b[restriction];
                else
                    return null;
            };
            const pdfAddonEnabled = this.settings.addons.find(x => x.addonName === 'PDF' || x.addonName === 'PDF_EPS');
            const epsAddonEnabled = this.settings.addons.find(x => x.addonName === 'EPS' || x.addonName === 'PDF_EPS');
            return {
                isUserImageAllowed: (_a = getUploadRestriction("isUserImageAllowed")) !== null && _a !== void 0 ? _a : true,
                isJpgAllowed: (_b = getUploadRestriction("isJpgAllowed")) !== null && _b !== void 0 ? _b : true,
                isPngAllowed: (_c = getUploadRestriction("isPngAllowed")) !== null && _c !== void 0 ? _c : true,
                isSvgAllowed: (_e = getUploadRestriction("isSvgAllowed")) !== null && _e !== void 0 ? _e : true,
                isPdfAllowed: ((_f = getUploadRestriction("isPdfAllowed")) !== null && _f !== void 0 ? _f : true) && !!pdfAddonEnabled,
                isEpsAllowed: ((_g = getUploadRestriction("isEpsAllowed")) !== null && _g !== void 0 ? _g : true) && !!epsAddonEnabled,
                isPdfWithRasterAllowed: ((_h = getUploadRestriction("isPdfWithRasterAllowed")) !== null && _h !== void 0 ? _h : true) && !!pdfAddonEnabled
            };
        };
        // Get template
        this.getTemplates = () => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                // Fetch the design
                let templatesList = (yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get("designs/templates/" + this.zkProduct.get('modelID'))).data;
                let templates = [];
                // Build a new design
                if (templatesList.length > 0) {
                    for (const _template of templatesList[0].categories[0].templates) {
                        const template = yield this.getTemplate(_template.designID);
                        yield (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.downloadFontsOfDesign)(template, this.fonts);
                        templates.push(template);
                    }
                }
                resolve(templates);
            }));
        });
        // Get single template
        this.getTemplate = (templateId) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                let design = new MPlaza.Design();
                design.set("docID", templateId);
                design.fetch({
                    success: () => __awaiter(this, void 0, void 0, function* () {
                        resolve(design);
                    }),
                    error: () => null,
                    data: {
                        template: true
                    }
                });
                design.addEventListener('change', this.updatePrice);
            });
        });
        // Public methods
        this.updateView = () => {
            this.viewer.updateView();
        };
        this.selectOption = (optionId) => {
            const clone = this.cloneSelection(this.selection);
            this.undoStack.push(clone);
            let option;
            let attribute;
            this.zkProduct.get("attributes").each(attr => {
                let _option = attr.get("options").find(option => option.get('optionID') == optionId);
                if (_option) {
                    option = _option;
                    attribute = attr;
                }
            });
            if (option) {
                // Don' t reselect it.
                if (option.selected)
                    return;
                this.selection.selectAttributeValue(attribute.get('attributeID'), optionId);
            }
            else {
                throw new _exceptions__WEBPACK_IMPORTED_MODULE_5__.Exception("Invalid option with id " + optionId);
            }
        };
        // Focus a group executing some camera movements
        this.focusGroup = (groupId) => {
            const sceneGroup = this.groups.find(x => x.id == groupId);
            if (sceneGroup && sceneGroup.cameraLocationId) {
                this.viewer.setCameraLocation(sceneGroup.cameraLocationId);
                this.lastCameraLocation = sceneGroup.cameraLocationId;
            }
        };
        this.focusAttribute = (attributeId) => __awaiter(this, void 0, void 0, function* () {
            const unselectedOptionsActions = this.selection.getAttributeUnselectedOptionsSceneActions(attributeId);
            yield this.viewer.prefetchDataForUnselectedOptionsAsync(unselectedOptionsActions);
            const attribute = this.zkProduct.get("attributes").find(attribute => attribute.get('attributeID') == attributeId);
            if (attribute && attribute.get("sceneCameraLocationID") && attribute.get("sceneCameraLocationID") != Zakeke.getEmptyUUID()) {
                this.viewer.setCameraLocation(attribute.get("sceneCameraLocationID"));
                this.lastCameraLocation = attribute.get("sceneCameraLocationID");
            }
        });
        this.base64StringToFile = (base64String, filename) => {
            var arr = base64String.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        };
        this.addToCart = (additionalProperties, onBeforeSendDataToParent, legacyScreenshot) => __awaiter(this, void 0, void 0, function* () {
            var _k;
            yield this.setExplodedMode(false);
            this.composition.set("compositionClientPreviews", []);
            const compositionClientPreviews = [];
            let sortedBuyScreenshotCameras = [];
            const buyScreenshotCameras = (_k = this.zkScene) === null || _k === void 0 ? void 0 : _k.get("cameraLocations").filter(x => { var _a; return ((_a = x.get("name")) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf("buy_screenshot_camera_")) !== -1; });
            if (buyScreenshotCameras)
                sortedBuyScreenshotCameras = lodash__WEBPACK_IMPORTED_MODULE_0___default().sortBy(buyScreenshotCameras, a => { return a.get("name"); });
            if (sortedBuyScreenshotCameras && sortedBuyScreenshotCameras.length > 0) {
                for (const camera of sortedBuyScreenshotCameras) {
                    const preview = yield this.viewer.getSceneContentScreenshotAsync(this.clientPreviewWidth, this.clientPreviewHeight, 0, this.zkCurrentTemplate, legacyScreenshot, camera);
                    const formData = new FormData();
                    const file = this.base64StringToFile(preview, camera + ".png");
                    formData.set("file", file);
                    const previewCameraFile = (yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + "designs/upload-client-preview", formData)).data;
                    compositionClientPreviews.push({ fileObjectID: previewCameraFile.id, cameraName: camera.get("name"), url: previewCameraFile.url });
                    yield (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.sleep)(1);
                }
                this.composition.set("compositionClientPreviews", compositionClientPreviews);
            }
            if (this.composition.get("isDraft") && !this.isDraftEditor) {
                this.composition.set("docID", null);
                this.composition.set("designDocID", null);
                this.composition.set("isDraft", false);
                if (this.zkCurrentTemplate)
                    this.zkCurrentTemplate.set("docID", null);
            }
            // Save composition
            yield this.saveComposition(undefined, legacyScreenshot);
            if (onBeforeSendDataToParent) {
                yield onBeforeSendDataToParent({
                    composition: this.composition.id,
                    preview: this.composition.get('previewImageUrl'),
                    attributes: this.platformAttributesSelection,
                    designItems: this.getDesignItemsInfo(),
                    quantity: this.quantity,
                    additionalProperties
                });
            }
            // Add to cart
            this.integration.addToCart(this.composition, this.zkCurrentTemplate, this.zkProduct, this.platformAttributesSelection, this.getDesignItemsInfo(), this.quantity, additionalProperties);
        });
        this.zoomIn = () => {
            if (this.viewer)
                this.viewer.zoomIn();
        };
        this.zoomOut = () => {
            if (this.viewer)
                this.viewer.zoomOut();
        };
        this.isFullscreenEnabled = () => {
            return !_helpers__WEBPACK_IMPORTED_MODULE_7__.iOS;
        };
        this.switchFullscreen = () => {
            let interval = null;
            this.viewer.switchFullScreen(document.getElementById("zakeke-viewer-container"));
            if (!interval) {
                //eslint-disable-next-line
                interval = setInterval(() => {
                    if (this.isFullscreenMode && this.internalIsFullscreen == false) {
                        setTimeout(() => {
                            this.viewer.updateView();
                            this.internalIsFullscreen = true;
                            console.info("Fullscreen enabled");
                        }, 10);
                    }
                    if (!this.isFullscreenMode && this.internalIsFullscreen == true) {
                        clearInterval(interval);
                        interval = null;
                        setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                            this.internalIsFullscreen = false;
                            // Update layout for two seconds
                            yield this.extendedUpdate();
                            this.viewer.updateView();
                            console.info("Fullscreen disabled");
                        }), 10);
                    }
                }, 100);
            }
        };
        this.openSecondScreen = () => {
            const url = Zakeke.config.baseUrl + "en/SecondScreen?token=" + this.token + "&modelID=" + this.zkProduct.get('modelID');
            window.open(url);
        };
        this.extendedUpdate = () => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                let count = 0;
                let interval = setInterval(() => {
                    this.viewer.updateView();
                    if (++count > 20) { // After two seconds
                        clearInterval(interval);
                        resolve();
                    }
                }, 100);
            });
        });
        this.exportSceneToUsdz = (hash) => __awaiter(this, void 0, void 0, function* () {
            if (this.viewer && this.viewer.zkScene)
                return this.viewer.exportSceneToUsdzAsync(this.viewer.zkScene.get("sceneID"), hash);
        });
        this.exportSceneToGlb = () => __awaiter(this, void 0, void 0, function* () {
            return this.viewer.exportSceneToLocalGLBAsync();
        });
        this.setExplodedMode = (explodedMode) => __awaiter(this, void 0, void 0, function* () {
            if (this.viewer) {
                if (explodedMode)
                    yield this.viewer.explodeMeshes();
                else
                    yield this.viewer.collapseMeshes();
            }
            this.isExplodedMode = explodedMode;
        });
        this.hasExplodedMode = () => {
            let zkScene = this.zkScene;
            if (zkScene)
                return !!zkScene.getFirstExplodedMeshLocation();
            else
                return false;
        };
        this.setBackgroundColor = (color, alpha) => {
            let zkScene = this.zkScene;
            if (color.indexOf("rgb") == 0) {
                let values = color.replace("rgb(", "").replace(")", "").split(",");
                color = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.rgb2hex)(values[0], values[1], values[2]);
            }
            if (this.viewer && zkScene) {
                zkScene.getOrCreateEnvironmentConfig().set("mainColor", color);
                zkScene.getOrCreateGeneralConfig().set("backgroundColor", color);
                zkScene.getOrCreateGeneralConfig().set("backgroundAlpha", alpha);
                this.viewer.refreshEnvironment();
            }
        };
        this.getCurrentSelection = () => {
            return lodash__WEBPACK_IMPORTED_MODULE_0___default().cloneDeep(this.platformAttributesSelection);
        };
        this.getScreenshot = (width = 1024, height = 1024, legacyScreenshot, backgroundColor = null, padding = 0) => __awaiter(this, void 0, void 0, function* () {
            let url = yield this.viewer.getSceneContentScreenshotAsync(width, height, padding, this.zkCurrentTemplate, legacyScreenshot);
            if (!url)
                throw new Error('Failed generating screenshot');
            if (backgroundColor) {
                yield new Promise(resolve => {
                    const img = new Image();
                    img.onload = () => {
                        const canvas = document.createElement("canvas");
                        canvas.width = img.width;
                        canvas.height = img.height;
                        const ctx = canvas.getContext("2d");
                        if (ctx) {
                            ctx.fillStyle = backgroundColor;
                            ctx.fillRect(0, 0, img.width, img.height);
                            ctx.drawImage(img, 0, 0);
                            url = canvas.toDataURL();
                            resolve();
                        }
                    };
                    img.src = url;
                });
            }
            return url;
        });
        this.fireItemsChange = () => {
            this.trigger("change");
        };
        this.removeItem = (guid) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                if (this.viewer) {
                    this.viewer.removeDesignItem(guid);
                    this.fireItemsChange();
                    resolve();
                }
                else {
                    reject("Called remove item but no viewer or viewer not ready");
                }
            });
        });
        this.setItemText = (guid, text) => {
            if (this.viewer) {
                this.viewer.setDesignItemText(guid, text);
            }
            else
                throw "Called set item text but no viewer or viewer not ready";
        };
        this.setItemItalic = (guid, italic) => {
            if (this.viewer) {
                this.viewer.setDesignItemItalic(guid, italic);
            }
            else
                throw "Called set item italic but no viewer or viewer not ready";
        };
        this.setItemBold = (guid, bold) => {
            if (this.viewer) {
                this.viewer.setDesignItemBold(guid, bold);
            }
            else
                throw "Called set item bold but no viewer or viewer not ready";
        };
        this.setItemColor = (guid, color) => {
            if (this.viewer) {
                this.viewer.setDesignItemColor(guid, color);
            }
            else
                throw "Called set item color but no viewer or viewer not ready";
        };
        this.setItemFontFamily = (guid, fontFamily) => __awaiter(this, void 0, void 0, function* () {
            if (this.viewer) {
                const font = this.fonts.find(x => x.name === fontFamily);
                if (font) {
                    yield (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.loadFonts)([font]);
                    this.viewer.setDesignItemFontFamily(guid, fontFamily);
                    this.fireItemsChange();
                }
                else {
                    console.warn(`No font found for ${fontFamily}`);
                }
            }
            else
                throw "Called set item font family but no viewer or viewer not ready";
        });
        this.setItemTextOnPath = (guid, areaId, value) => {
            if (this.viewer) {
                this.viewer.setItemTextOnPath(guid, areaId, value);
                this.fireItemsChange();
            }
            else
                throw "Called toggleItemTextOnPath but no viewer or viewer not ready";
        };
        this.createImage = (file, progress) => __awaiter(this, void 0, void 0, function* () {
            if (this.viewer) {
                const imageTask = new _imageUploadTask__WEBPACK_IMPORTED_MODULE_8__["default"](this.culture, this.token);
                const result = yield imageTask.upload(file, progress);
                const image = result ? result[0] : null;
                return image;
            }
            else
                throw "Called create image but no viewer or viewer not ready";
        });
        this.createImageFromUrl = (url) => __awaiter(this, void 0, void 0, function* () {
            if (this.viewer) {
                const result = (yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + "images/import/url", {
                    url
                })).data;
                return result;
            }
            else
                throw "Called create image from url but no viewer or viewer not ready";
        });
        this.addItemImage = (id, areaId) => __awaiter(this, void 0, void 0, function* () {
            if (this.viewer) {
                yield this.viewer.addDesignItemImage(id, areaId);
                yield this.renderDesign();
                this.fireItemsChange();
            }
            else
                throw "Called add item text but no viewer or viewer not ready";
        });
        this.setItemImageFromFile = (guid, file, progress) => __awaiter(this, void 0, void 0, function* () {
            if (this.viewer) {
                const image = yield this.createImage(file, progress);
                yield this.setItemImage(guid, image.imageID);
                this.fireItemsChange();
            }
            else
                throw "Called set item image but no viewer or viewer not ready";
        });
        // For preview only!!
        this.setItemImageFromBase64 = (guid, base64) => __awaiter(this, void 0, void 0, function* () {
            if (this.viewer) {
                const image = new MPlaza.Image();
                image.set("imageID", -1);
                image.set("previewUrl", base64);
                yield this.viewer.setDesignItemImage(guid, image);
                this.fireItemsChange();
            }
            else
                throw "Called set item image but no viewer or viewer not ready";
        });
        this.setItemImage = (guid, id) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (this.viewer) {
                    const image = new MPlaza.Image();
                    image.set("imageID", id);
                    image.fetch({
                        success: (model, response, opts) => __awaiter(this, void 0, void 0, function* () {
                            yield this.viewer.setDesignItemImage(guid, image);
                            this.fireItemsChange();
                            resolve();
                        }),
                        error: (model, response, opts) => null
                    });
                }
                else {
                    throw "Called set item image but no viewer or viewer not ready";
                }
            }));
        });
        this.getMacroCategories = () => __awaiter(this, void 0, void 0, function* () {
            let macroCategories = (yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.baseApiUrl + "imagemacrocategories/")).data;
            macroCategories = macroCategories.filter(x => x.hasImages);
            for (let macroCategory of macroCategories)
                macroCategory.categories = macroCategory.categories.filter(x => x.hasImages);
            return macroCategories;
        });
        this.getImages = (categoryId) => __awaiter(this, void 0, void 0, function* () {
            return (yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(Zakeke.config.baseApiUrl + "images/", {
                params: {
                    type: 'lib',
                    c: categoryId
                }
            })).data;
        });
        this.getPDF = () => __awaiter(this, void 0, void 0, function* () {
            var _l;
            const data = yield this.getScreenshot(2048, 2048);
            const items = this.getDesignItemsInfo();
            const areas = (_l = this.product) === null || _l === void 0 ? void 0 : _l.areas.filter(x => this.isAreaVisible(x.id)).map(x => ({
                name: x.name,
                textItems: items.filter(i => i.areaId == x.id && i.type === ___WEBPACK_IMPORTED_MODULE_1__.ItemType.Text)
            })).filter(x => x.textItems.length > 0);
            const selectedOptions = this.platformAttributesSelection.filter(x => x.attributeIsEnabled && x.attributeIsEnabled).map(({ attributeLabel, attributeCode, optionCode, optionLabel }) => ({
                attributeLabel,
                attributeCode: !(0,_helpers__WEBPACK_IMPORTED_MODULE_7__.isPlatformCode)(attributeCode) ? attributeCode : '',
                optionLabel,
                optionCode: !(0,_helpers__WEBPACK_IMPORTED_MODULE_7__.isPlatformCode)(optionCode) ? optionCode : '',
            }));
            const params = {
                environment: 2,
                productName: this.zkProduct.get('name'),
                previewImage: data,
                sides: [],
                areas,
                selectedOptions,
            };
            const pdf = (yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + "previewdesigns/pdf", params, {
                transformResponse: (res) => res,
                responseType: "text"
            })).data.replace(/"/g, "");
            return pdf;
        });
        this.rewriteShareUrl = (url) => {
            const path = url.split("/SharedPreview")[1];
            if (this.shareUrlPrefix) {
                return this.shareUrlPrefix + path;
            }
            if (document.referrer && this.settings.referrerID === 2) {
                const regex = /(apps\/configurator\/)(.*)/gms;
                let firstPart = document.referrer.replace(regex, '$1');
                if (!firstPart.endsWith('\/'))
                    firstPart += '/';
                return firstPart + path;
            }
            return url;
        };
        this.getShareCompositionUrl = () => __awaiter(this, void 0, void 0, function* () {
            // salvo (e riassegno dopo la creazione dello share url) l'id , per evitare problemi in caso di add to cart e edit
            // in questo modo ogni composizione condivisa è sempre diversa da quella di partenza
            var _m;
            const isDraft = (_m = this.composition.get("isDraft")) !== null && _m !== void 0 ? _m : false;
            this.composition.set("isDraft", false);
            const docID = yield this.saveCompositionCopy();
            this.composition.set("isDraft", isDraft);
            const result = yield this.integration.getSharedCompositionUrl(docID);
            //link for local test
            //const result = "https://localhost:44363/scripts/composer/Themes/DefaultTheme/public/index.html?name=Test%20Elena%203D&modelCode=65&currency=EUR&ecommerce=preview&qty=1&culture=en-US&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiU2VsbGVyIiwiUGVybUJpdHMiOiIwMTAwMTExMDAxMTAwMTExMTExMTAxIiwidW5pcXVlX25hbWUiOiJuaWNvbGV0dG8iLCJVc2VySUQiOiIyNCIsIlVzZXJOYW1lIjoibmljb2xldHRvIiwiZW1haWwiOiJuLmJpenpvY2FAZnV0dXJlbmV4dC5pdCIsIlVzZXJUeXBlSUQiOiIzIiwiSXNzdWVEYXRlIjoiMDgtMDctMjAyMiAwOC0xMi01OFoiLCJVc2VyVmVyc2lvbiI6IjIwMjIwNzA3MTczOTU4IiwiY2xpZW50SUQiOiIyNjM0Iiwic2FsZXNDaGFubmVsSUQiOiIxIiwiY3VzdG9tZXJjb2RlIjoidGVzdCBjdXN0b21lciIsImFjY2Vzc1R5cGUiOiJTMlMiLCJuYmYiOjE2NTcyNjc5NzgsImV4cCI6MTY1NzM1NDM3OCwiaWF0IjoxNjU3MjY3OTc4LCJpc3MiOiJ3d3cuemFrZWtlLmNvbSIsImF1ZCI6Imh0dHBzOi8vd3d3Lnpha2VrZS5jb20ifQ.jQynLW6sZi3mtk5f05DaebVKfcwtbSyPT_JMd1HDM88&fromUrl=1&viewerMode=1&sharedCompositionDocId="+ docID;
            return result.url;
        });
        this.saveCompositionCopy = () => __awaiter(this, void 0, void 0, function* () {
            let docId = null;
            let designDocId = null;
            let currentTemplate = this.zkCurrentTemplate;
            if (currentTemplate) {
                designDocId = currentTemplate.get("docID");
                currentTemplate.set("docID", null);
            }
            docId = this.composition.get("docID");
            this.composition.set("docID", null);
            this.composition.set("designDocID", null);
            yield this.saveComposition();
            const newCompositionDocId = this.composition.get("docID");
            this.composition.set("docID", docId);
            this.composition.set("designDocID", designDocId);
            if (currentTemplate)
                currentTemplate.set("docID", designDocId);
            return newCompositionDocId;
        });
        this.getOnlineScreenshot = (width, height, legacyScreenshot, backgroundColor, padding = 30) => __awaiter(this, void 0, void 0, function* () {
            const preview = yield this.getScreenshot(width, height, legacyScreenshot, backgroundColor, padding);
            const { url: originalUrl } = (yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + "designs/save-share-preview", { preview })).data;
            const rewrittenUrl = this.rewriteShareUrl(originalUrl);
            return {
                originalUrl,
                rewrittenUrl,
            };
        });
        // AR - Augmented Reality
        this.isSceneArOnTheFly = () => {
            var _a;
            if (this.viewer)
                return (_a = this.zkScene) === null || _a === void 0 ? void 0 : _a.getArOnTheFly();
            return false;
        };
        this.isArDeviceCompliant = () => _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_AR_DEVICE_COMPLIANT;
        this.isAndroidOrIOS = () => (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID || _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS);
        this.isAndroid = _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID;
        this.isIOS = _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS;
        this.buildModelViewerUrl = (fileInfos) => {
            const url = Zakeke.config.baseUrl + "ModelViewer";
            const link = new URL(url);
            let search = "";
            for (const file of fileInfos) {
                if (file.format && file.arFileUrl) {
                    const encodedUrl = encodeURIComponent(file.arFileUrl);
                    let searchFile = '';
                    switch (file.format) {
                        case "gltf":
                        case "glb":
                            searchFile = "gltf=" + encodedUrl;
                            break;
                        case "usdz":
                            searchFile = "usdz=" + encodedUrl;
                            break;
                        case "png":
                            searchFile = "poster=" + encodedUrl;
                            break;
                    }
                    if (searchFile)
                        search += (search ? '&' : '') + searchFile;
                }
            }
            search += '&arScale=' + (this.zkScene.getARScale() ? 1 : 0);
            link.search += search;
            const pageUrl = link.toString();
            return pageUrl;
        };
        this.isSceneArEnabled = () => {
            if (this.zkScene)
                return this.zkScene.getAREnabled() || false;
            return false;
        };
        this.getPregeneratedARUrl = (fileType) => {
            var _a, _b, _c;
            return (_c = (_b = (_a = this.zkScene) === null || _a === void 0 ? void 0 : _a.get('arFiles')) === null || _b === void 0 ? void 0 : _b.find(x => x.get('fileType') == fileType)) === null || _c === void 0 ? void 0 : _c.get('url');
        };
        this.getQrCodeArUrl = (device) => __awaiter(this, void 0, void 0, function* () {
            let fileInfos = [];
            if (device == 'Android') {
                const url = this.getPregeneratedARUrl('glb') || (yield this.viewer.exportSceneToRemoteGLBAsync());
                fileInfos = [{ format: "gltf", arFileUrl: url }];
            }
            else {
                const glb = this.getPregeneratedARUrl('glb');
                const usdz = this.getPregeneratedARUrl('usdz');
                if (glb && usdz)
                    fileInfos = [
                        { format: "glb", arFileUrl: glb },
                        { format: "usdz", arFileUrl: usdz }
                    ];
                else
                    fileInfos = yield this.viewer.exportSceneToARAsync();
            }
            return this.buildModelViewerUrl(fileInfos);
        });
        this.getMobileArUrl = (onFlyArUrl) => __awaiter(this, void 0, void 0, function* () {
            let url = null;
            if (this.isSceneArOnTheFly()) {
                url = yield this.getMobileLocalArUrl(onFlyArUrl);
            }
            else {
                if (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
                    url = yield this.viewer.exportSceneToUsdzAsync(this.zkScene.get("sceneID"), this.selection.getCompositionHashCode());
                }
                else {
                    url = yield this.viewer.exportSceneToRemoteGLBAsync(this.zkScene.get("sceneID"), this.selection.getCompositionHashCode());
                }
            }
            return url;
        });
        this.getMobileLocalArUrl = (onFlyArUrl) => {
            return new Promise(resolve => {
                if (this.zkScene && this.viewer) {
                    const fileId = this.zkScene.getSceneID();
                    this.viewer.getSceneRootUrl().then((rootUrl) => __awaiter(this, void 0, void 0, function* () {
                        if (!rootUrl)
                            return;
                        if (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
                            const url = yield this.viewer.exportSceneToLocalUSDZAsync();
                            if (!url) {
                                (0,lodash__WEBPACK_IMPORTED_MODULE_0__.reject)(url);
                            }
                            else {
                                resolve(url);
                            }
                        }
                        else {
                            if (!onFlyArUrl)
                                throw new Error("no url defined for the ar on fly");
                            this.viewer.saveGlbOnDatabaseAsync(fileId).then(() => {
                                const link = new URL(onFlyArUrl);
                                let search = "id=" + fileId;
                                search += '&rootUrl=' + encodeURIComponent(rootUrl);
                                search += '&productId=' + this.product.id;
                                search += '&environment=' + this.product.environment;
                                search += '&token=' + this.token;
                                link.search += search;
                                const pageUrl = link.toString();
                                resolve(pageUrl);
                            });
                        }
                    }));
                }
            });
        };
        this.openArMobile = (url) => {
            if (this.viewer && this.zkScene) {
                if (this.isSceneArOnTheFly() && _helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID)
                    window.open(url);
                else if (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_IOS) {
                    if (url && !this.zkScene.getARScale())
                        url += '#allowsContentScaling=0';
                    const anchor = document.createElement('a');
                    anchor.setAttribute('rel', 'ar');
                    anchor.setAttribute('href', url);
                    anchor.appendChild(document.createElement('img'));
                    anchor.click();
                }
                else if (_helpers__WEBPACK_IMPORTED_MODULE_7__.IS_ANDROID) {
                    _3D_src__WEBPACK_IMPORTED_MODULE_2__.AndroidAR.openSceneViewer(url, () => {
                        alert('Device not supported.');
                    }, this.zkScene.getARScale());
                }
            }
        };
        this.registerView = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.zkProduct || this.isViewerMode)
                return;
            try {
                yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.post(Zakeke.config.baseApiUrl + 'viewscount/addview', {
                    productID: this.zkProduct.get('modelID'),
                    environment: this.zkProduct.get('environment'),
                    ecommerceID: this.settings.ecommerceID
                });
            }
            catch (ex) {
                console.error('Failed registering view', ex);
            }
        });
        // Manipulate scene
        this.getMeshIDbyName = (name) => {
            var _a, _b;
            return (_b = (_a = this.viewer) === null || _a === void 0 ? void 0 : _a.getMeshByName(name)) === null || _b === void 0 ? void 0 : _b.id;
        };
        /**
         * Hide a mesh and its children and save the state
         * @param meshId The mesh and childs to hide
         */
        this.hideMeshAndSaveState = (meshId) => {
            if (this.viewer.scene) {
                const rootMesh = this.viewer.getMeshByID(meshId);
                // Add mesh and all submesh visibility to previousMeshVisibileStates
                if (rootMesh) {
                    const meshes = [rootMesh, ...rootMesh.getChildMeshes()];
                    for (const mesh of meshes) {
                        this.previousMeshesVisibleStates[mesh.id] = mesh.isVisible;
                        mesh.isVisible = false;
                    }
                    this.viewer.setRenderingNeeded();
                }
            }
        };
        /**
         * Restore a mesh visibility state from a previous saved one (see hideMeshAndSaveState)
         * @param meshId The mesh and childs to show
         */
        this.restoreMeshVisibility = (meshId) => {
            if (this.viewer.scene) {
                const rootMesh = this.viewer.getMeshByID(meshId);
                // Add mesh and all submesh visibility to previousMeshVisibileStates
                if (rootMesh && this.previousMeshesVisibleStates[rootMesh.id] !== undefined) {
                    const meshes = [rootMesh, ...rootMesh.getChildMeshes()];
                    for (const mesh of meshes) {
                        mesh.isVisible = this.previousMeshesVisibleStates[mesh.id];
                        delete this.previousMeshesVisibleStates[mesh.id];
                    }
                    this.viewer.setRenderingNeeded();
                }
            }
        };
        /**
         * Change opacity for a specific mesh
         * @param meshId The mesh to change the opacity
         * @param opacity The opacity to set
         */
        this.setMeshDesignVisibility = (meshId, visible) => {
            if (this.viewer) {
                this.viewer.setDesignVisibility(meshId, visible);
                this.viewer.setRenderingNeeded();
            }
        };
        // Events
        this.addFocusAttributesListener = (listenerFunction) => {
            if (this.viewer)
                this.viewer.addFocusAttributesListener(listenerFunction);
        };
        this.clearListeners = () => {
            if (this.viewer)
                this.viewer.clearListeners();
        };
        this.setCameraLocked = (isBlocked) => {
            return this.viewer.setCameraLocked(isBlocked);
        };
        this.isSceneTryOnEnabled = () => {
            var _a;
            if (this.viewer)
                if (this.zkScene)
                    return (_a = this.zkScene.getTryOnEnabled()) !== null && _a !== void 0 ? _a : false;
            return false;
        };
        this.getTryOnUrl = (tryOnUrl) => {
            return new Promise(resolve => {
                if (this.zkScene && this.viewer) {
                    const fileId = this.zkScene.getSceneID();
                    this.viewer.getSceneRootUrl().then((rootUrl) => {
                        if (!rootUrl)
                            return;
                        const attachmentPoint = 'noseBridge';
                        // Salvo le mesh su IndexedDB
                        this.viewer.saveVisibleMeshesOnDatabaseAsync(fileId).then(() => {
                            const url = tryOnUrl !== null && tryOnUrl !== void 0 ? tryOnUrl : "https://zakekecdn.blob.core.windows.net/cdn/c/tryon/index.html";
                            const link = new URL(url);
                            let search = "id=" + fileId;
                            search += '&rootUrl=' + encodeURIComponent(rootUrl);
                            search += '&attachmentPoint=' + attachmentPoint;
                            search += '&productId=' + this.zkProduct.get('modelID');
                            search += '&environment=' + this.zkProduct.get('environment');
                            search += '&token=' + this.token;
                            link.search += search;
                            const pageUrl = link.toString();
                            resolve(pageUrl);
                        });
                    });
                }
            });
        };
        this.getDisableTextColors = () => {
            var _a, _b;
            try {
                let disableTextColors = (_b = (_a = this.zkProduct.get("printTypes").at(0).get("printTypeRestrictions")) === null || _a === void 0 ? void 0 : _a.get("disableTextColors")) !== null && _b !== void 0 ? _b : false;
                return disableTextColors;
            }
            catch (ex) {
                console.log(ex);
                throw "Failed loading restrictions";
            }
        };
        this.getTextColors = () => {
            var _a, _b;
            try {
                let textColors = (_b = (_a = this.zkProduct.get("printTypes").at(0).get("printTypeRestrictions")) === null || _a === void 0 ? void 0 : _a.get("textColors")) !== null && _b !== void 0 ? _b : [];
                let defaultColor = { colorCode: this.defaultColor, isDefault: true };
                if (!textColors.find(color => color.colorCode === defaultColor.colorCode))
                    textColors.push(defaultColor);
                return textColors;
            }
            catch (ex) {
                console.log(ex);
                throw "Failed loading restrictions";
            }
        };
        this.getDefaultColor = () => {
            var _a, _b;
            try {
                let defaultColor = (_b = (_a = this.zkProduct.get("printTypes").at(0).get("printTypeRestrictions")) === null || _a === void 0 ? void 0 : _a.get("defaultColor")) !== null && _b !== void 0 ? _b : '#000000';
                return defaultColor;
            }
            catch (ex) {
                console.log(ex);
                throw "Failed loading restrictions";
            }
        };
        this.saveComposition = (customPreviewSize, legacyScreenshot) => __awaiter(this, void 0, void 0, function* () {
            var _o, _p, _q;
            console.log("Saving...");
            const buyScreenshotCamera = (_o = this.zkScene) === null || _o === void 0 ? void 0 : _o.get("cameraLocations").find(x => { var _a; return ((_a = x.get("name")) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "buy_screenshot_camera"; });
            if (!buyScreenshotCamera)
                this.viewer.restoreCameraState();
            yield (0,_helpers__WEBPACK_IMPORTED_MODULE_7__.sleep)(1);
            // Save image
            const data = yield this.viewer.getSceneContentScreenshotAsync((_p = customPreviewSize === null || customPreviewSize === void 0 ? void 0 : customPreviewSize.customCartPreviewHeight) !== null && _p !== void 0 ? _p : this.previewWidth, (_q = customPreviewSize === null || customPreviewSize === void 0 ? void 0 : customPreviewSize.customCartPreviewWidth) !== null && _q !== void 0 ? _q : this.previewHeight, 0, this.zkCurrentTemplate, legacyScreenshot, buyScreenshotCamera);
            this.composition.set("previewImageData", data);
            // Save composition
            yield this.saveDesignBackbone();
            yield this.saveCompositionBackbone();
            console.log("Composition saved!");
        });
        this.bootstrapComposition = (composition) => __awaiter(this, void 0, void 0, function* () {
            this.selection = Zakeke.ComposerSelection.CreateComposerSelection(this.zkProduct);
            this.composition = composition;
            yield this.internalLoadComposition(this.composition.id);
            if (!this.currentCompositionInfo)
                this.currentCompositionInfo = {
                    compositionId: "",
                    compositionName: "",
                    compositionTags: []
                };
            this.currentCompositionInfo.compositionId = this.compositionId;
            this.currentCompositionInfo.compositionName = this.composition.get("name");
            this.currentCompositionInfo.compositionTags = this.composition.get("tags");
        });
        this.loadSavedComposition = (docID) => __awaiter(this, void 0, void 0, function* () {
            var _r;
            const composition = (_r = this.savedCompositions) === null || _r === void 0 ? void 0 : _r.find(x => x.docID == docID);
            if (composition)
                yield this.bootstrapComposition(new MPlaza.Composition(composition));
        });
        this.updateSavedCompositions = () => __awaiter(this, void 0, void 0, function* () {
            const savedCompositions = (yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi.get(`compositiondocs/product/${this.zkProduct.get("modelID")}`, {
                params: {
                    draft: true
                }
            })).data;
            this.savedCompositions = savedCompositions;
            if (savedCompositions) {
                const themeCompositions = this.themeCompositionsFromSavedCompositions(savedCompositions);
                this.themeCompositions = themeCompositions;
            }
            this.trigger("change");
        });
        this.themeCompositionsFromSavedCompositions = (compositions) => {
            const themeCompositions = compositions.map(composition => {
                return {
                    name: composition.name,
                    docID: composition.docID,
                    previewImageUrl: composition.previewImageUrl,
                    tags: composition.tags
                };
            });
            return themeCompositions;
        };
        this.saveDraftsComposition = (name, tags, isCopy) => __awaiter(this, void 0, void 0, function* () {
            this.composition.set("name", name);
            this.composition.set("tags", tags);
            this.composition.set("isDraft", true);
            if (isCopy)
                yield this.saveCompositionCopy();
            else
                yield this.saveComposition(undefined);
            return this.updateSavedCompositions();
        });
        this.deleteSavedComposition = (docId) => __awaiter(this, void 0, void 0, function* () {
            yield _api__WEBPACK_IMPORTED_MODULE_4__.axiosApi["delete"](`compositiondocs/${docId}/`);
            this.updateSavedCompositions();
        });
    }
    get internalProduct() {
        return this.zkProduct;
    }
    get internalScene() {
        return this.zkScene;
    }
    get internalCurrentTemplate() {
        return this.zkCurrentTemplate;
    }
    get isFullscreenMode() {
        let doc = document;
        return Boolean(doc.fullscreenElement ||
            doc.webkitFullscreenElement ||
            doc.mozFullScreenElement ||
            doc.msFullscreenElement);
    }
    get isViewerReady() {
        return !!this.viewer;
    }
    addHotjarScript(siteID) {
        if (siteID && siteID.length > 0 && this.platform && this.platform.toLowerCase() !== "preview") {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.innerHTML =
                `(function(h,o,t,j,a,r){
                    h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                    h._hjSettings={hjid:${siteID},hjsv:6};
                    a=o.getElementsByTagName('head')[0];
                    r=o.createElement('script');r.async=1;
                    r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                    a.appendChild(r);
                })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    }
    addGoogleTagManagerID(siteID) {
        if (siteID && siteID.length > 0 && this.platform && this.platform.toLowerCase() !== "preview") {
            $('head').append("<script>" +
                `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${siteID}')`
                + "<\/script>");
            var noscript = document.createElement("noscript");
            var iframe = document.createElement("iframe");
            iframe.src = `https://www.googletagmanager.com/ns.html?id=${siteID}`;
            iframe.height = "0";
            iframe.width = "0";
            iframe.style.cssText = "display:none;visibility:hidden";
            noscript.appendChild(iframe);
            document.body.insertBefore(noscript, document.body.firstChild);
        }
    }
    setQuantity(quantity) {
        // Adapt quantity to rules
        let quantityRule = this.zkProduct.get("quantityRule");
        if (quantityRule) {
            const min = quantityRule.get("minQuantity");
            const max = quantityRule.get("maxQuantity");
            const step = quantityRule.get("step");
            if (min && quantity < min)
                quantity = min;
            if (max && quantity > max)
                quantity = max;
            if (step) {
                quantity = Math.round(quantity / step) * step;
                if (quantity < step)
                    quantity = step;
            }
        }
        this.quantity = quantity;
        this.trigger("change");
        this.updatePrice();
    }
    createStep(zkStep, groupSelection) {
        let step = new _models__WEBPACK_IMPORTED_MODULE_11__.Step();
        step.id = zkStep.get("stepID");
        step.guid = zkStep.get("stepGuid");
        step.name = zkStep.get("name");
        step.displayOrder = zkStep.get("displayOrder");
        // The attributes in a step must have the group ID too or the group selection will be empty
        for (var i = 0; i < this.zkProduct.get("attributes").length; i++) {
            let zakekeAttribute = this.zkProduct.get("attributes").at(i);
            let attributeSelection = groupSelection.get("attributes").find(attr => attr.get("attributeID") == zakekeAttribute.get('attributeID'));
            if (attributeSelection && zakekeAttribute.get("stepID") == zkStep.id) {
                let attribute = this.createAttributeFromSelection(attributeSelection);
                step.attributes.push(attribute);
            }
        }
        step.attributes.sort((a, b) => a.displayOrder - b.displayOrder);
        return step;
    }
    setCamera(cameraLocationId, onlyAngleOfView, animate) {
        this.viewer.setCameraLocation(cameraLocationId, onlyAngleOfView, animate);
        this.lastCameraLocation = cameraLocationId;
    }
    getCameraByName(name) {
        var _a;
        const location = (_a = this.zkScene) === null || _a === void 0 ? void 0 : _a.get("cameraLocations").find(x => x.get("name") == name);
        return location;
    }
    setCameraLocation(name, animate = true) {
        const location = this.getCameraByName(name);
        if (!location)
            throw new Error(`Camera with name ${name} does not exists.`);
        this.viewer.setCameraLocation(location.get("locationID"), false, animate);
        this.lastCameraLocation = location.get("locationID");
    }
    getDesignItemsInfo() {
        var _a, _b;
        let items = [];
        if (this.viewer) {
            items = (_b = (_a = this.viewer.getDesignItemsInfo()) === null || _a === void 0 ? void 0 : _a.map(item => {
                return item instanceof MPlaza.ImageItemInfo ? new _models__WEBPACK_IMPORTED_MODULE_11__.ImageItem(item) : new _models__WEBPACK_IMPORTED_MODULE_11__.TextItem(item);
            })) !== null && _b !== void 0 ? _b : [];
        }
        return items;
    }
    isAreaVisible(areaId) {
        // Get the mesh side
        const meshSides = this.zkProduct.get("scenes").at(0).get("meshSides").filter(x => x.get("sideID") == areaId);
        for (const meshSide of meshSides) {
            const meshId = meshSide.get("meshID");
            if (meshId) {
                const mesh = this.viewer.scene.getMeshByID(meshId);
                if (mesh && mesh.isVisible)
                    return true;
            }
        }
        return false;
    }
    addItemText(settings, areaId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.viewer) {
                // First download the font
                const font = this.fonts.find(x => x.name === settings.fontFamily);
                if (font) {
                    yield (0,_fontsManager__WEBPACK_IMPORTED_MODULE_6__.loadFonts)([font]);
                    this.viewer.addDesignItemText(Object.assign(Object.assign({}, settings), { content: settings.text }), areaId);
                    this.renderDesign();
                }
                else {
                    console.warn(`No font found for ${settings.fontFamily}`);
                }
            }
            else
                throw "Called add item text but no viewer or viewer not ready";
        });
    }
    setCameraPivot(meshID) {
        this.viewer.setCameraPivot(meshID);
    }
    resetCameraPivot() {
        this.viewer.setCameraPivot(null);
    }
    setCameraZoomEnabled(enabled) {
        this.viewer.setCameraZoomEnabled(enabled);
    }
    setCameraByName(name, onlyAngleOfView, animate) {
        if (this.zkScene) {
            const location = this.zkScene.get("cameraLocations").find(x => x.get("name") == name);
            if (location)
                this.viewer.setCameraLocation(location.get("locationID"), onlyAngleOfView, animate);
        }
    }
    findObjectByName(name) {
        if (this.viewer && this.viewer.scene)
            return this.viewer.scene.meshes.find(x => x.name == name);
        else
            return null;
    }
    hightlightGroup(groupId) {
        var _a;
        (_a = this.viewer) === null || _a === void 0 ? void 0 : _a.highlightGroupByID(groupId);
    }
    highlightAttribute(attributeId) {
        var _a;
        (_a = this.viewer) === null || _a === void 0 ? void 0 : _a.highlightAttributeByID(attributeId);
    }
}


/***/ }),

/***/ "./src/exceptions.tsx":
/*!****************************!*\
  !*** ./src/exceptions.tsx ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Exception": () => (/* binding */ Exception),
/* harmony export */   "NonSquarePixelException": () => (/* binding */ NonSquarePixelException),
/* harmony export */   "ParametersParseFailException": () => (/* binding */ ParametersParseFailException),
/* harmony export */   "UnsupportedPlatformException": () => (/* binding */ UnsupportedPlatformException),
/* harmony export */   "UploadFailedExpection": () => (/* binding */ UploadFailedExpection)
/* harmony export */ });
// Exceptions
class Exception {
    constructor(message) {
        this.message = message;
    }
}
class ParametersParseFailException extends Exception {
    constructor(parameter) {
        super("Failed parsing parameters: " + parameter);
        this.parameter = parameter;
    }
}
class UnsupportedPlatformException extends Exception {
    constructor(platform) {
        super("Platform " + platform.toString() + " not supported.");
        this.platform = platform;
    }
}
class UploadFailedExpection extends Exception {
    constructor() {
        super("Upload failed.");
    }
}
class NonSquarePixelException extends Exception {
    constructor() {
        super("The image is not supported (non-square pixels)");
    }
}


/***/ }),

/***/ "./src/fontsManager.ts":
/*!*****************************!*\
  !*** ./src/fontsManager.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "downloadFontsOfDesign": () => (/* binding */ downloadFontsOfDesign),
/* harmony export */   "loadFonts": () => (/* binding */ loadFonts)
/* harmony export */ });
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * Download a list of font families so that are available for the browser
 */
function loadFonts(fontFamilies) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise((resolve) => {
            WebFont.load({
                timeout: 200000,
                custom: {
                    families: fontFamilies.map(x => { return x.name + (x.variations && x.variations != "" ? ":" + x.variations : ""); }),
                    urls: fontFamilies.map(x => { return x.cssUrl; })
                },
                active: () => {
                    resolve();
                }
            });
        });
    });
}
/**
 * Downlod all fonts used in a design
 *
 * @param design Design to load fonts for
 * @param downloadedFonts A list of downloaded fonts
 */
function downloadFontsOfDesign(design, downloadedFonts) {
    return __awaiter(this, void 0, void 0, function* () {
        // Get all the fonts first
        let fonts = [];
        for (let item of design.get("designItems").models) {
            let data = JSON.parse(item.get("json"));
            var attributes = data[1];
            //Get the global font family or from the first letter (in case of curved text)
            var fontFamily = attributes.fontFamily || (attributes.children && attributes.children.length > 0 && attributes.children[0].length > 1 ? attributes.children[0][1].fontFamily : null);
            if (fontFamily)
                fonts.push(fontFamily.replace(/"/g, ""));
        }
        let fontFamilies = fonts.map(fontName => downloadedFonts.find(fontFamily => fontFamily.name == fontName) || null).filter(x => x != null);
        if (fontFamilies.length > 0) {
            yield loadFonts(fontFamilies);
        }
    });
}


/***/ }),

/***/ "./src/helpers.tsx":
/*!*************************!*\
  !*** ./src/helpers.tsx ***!
  \*************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Browser": () => (/* binding */ Browser),
/* harmony export */   "IS_ANDROID": () => (/* binding */ IS_ANDROID),
/* harmony export */   "IS_AR_DEVICE_COMPLIANT": () => (/* binding */ IS_AR_DEVICE_COMPLIANT),
/* harmony export */   "IS_IOS": () => (/* binding */ IS_IOS),
/* harmony export */   "Pagination": () => (/* binding */ Pagination),
/* harmony export */   "StringHelper": () => (/* binding */ StringHelper),
/* harmony export */   "T": () => (/* binding */ T),
/* harmony export */   "compare": () => (/* binding */ compare),
/* harmony export */   "copy": () => (/* binding */ copy),
/* harmony export */   "dataURLtoFile": () => (/* binding */ dataURLtoFile),
/* harmony export */   "getPlatformSettings": () => (/* binding */ getPlatformSettings),
/* harmony export */   "hex2rgb": () => (/* binding */ hex2rgb),
/* harmony export */   "hslToRgb": () => (/* binding */ hslToRgb),
/* harmony export */   "hsvToRgb": () => (/* binding */ hsvToRgb),
/* harmony export */   "hue2rgb": () => (/* binding */ hue2rgb),
/* harmony export */   "iOS": () => (/* binding */ iOS),
/* harmony export */   "isPlatformCode": () => (/* binding */ isPlatformCode),
/* harmony export */   "isValidJSON": () => (/* binding */ isValidJSON),
/* harmony export */   "matchCodes": () => (/* binding */ matchCodes),
/* harmony export */   "rgb2hex": () => (/* binding */ rgb2hex),
/* harmony export */   "rgbToHsl": () => (/* binding */ rgbToHsl),
/* harmony export */   "rgbToHsv": () => (/* binding */ rgbToHsv),
/* harmony export */   "sleep": () => (/* binding */ sleep),
/* harmony export */   "uuid": () => (/* binding */ uuid)
/* harmony export */ });
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class T {
    static _(str, domain) {
        var _a, _b;
        if ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.statics) {
            const keys = Array.from((_b = this.translations) === null || _b === void 0 ? void 0 : _b.statics.keys());
            for (let key of keys) {
                if (key.toLowerCase() === str.toLowerCase())
                    return this.translations.statics.get(key);
            }
        }
        let gt = window.gt;
        return gt ? gt.dgettext(domain, str) : str;
    }
    static _d(str) {
        var _a, _b;
        let string = str;
        if ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.dynamics) {
            const keys = Array.from((_b = this.translations) === null || _b === void 0 ? void 0 : _b.dynamics.keys());
            for (let key of keys) {
                if (key.toLowerCase() === str.toLowerCase()) {
                    if (this.translations.dynamics.get(key))
                        string = this.translations.dynamics.get(key);
                }
            }
        }
        return string;
    }
}
T.translations = null;
function dataURLtoFile(dataurl, filename) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
}
class StringHelper {
    static padLeft(str, width, char) {
        var newStr = str.toString();
        for (var i = 0; i < width - newStr.length; i++)
            newStr = char + newStr;
        return newStr;
    }
    static padRight(str, width, char) {
        var newStr = str.toString();
        for (var i = 0; i < width - newStr.length; i++)
            newStr = newStr + char;
        return newStr;
    }
    static format(str, ...args) {
        return args.reduce((prev, current, idx) => prev.replace(`{${idx}}`, current), str);
    }
    static camelToSnake(o) {
        let newO = {}, origKey, newKey, value;
        if (o instanceof Array) {
            newO = [];
            for (origKey in o) {
                value = o[origKey];
                if (typeof value === "object") {
                    value = StringHelper.camelToSnake(value);
                }
                newO.push(value);
            }
        }
        else {
            newO = {};
            for (origKey in o) {
                if (o.hasOwnProperty(origKey)) {
                    newKey = origKey.replace(/\.?([A-Z]+)/g, function (x, y) {
                        return "_" + y.toLowerCase();
                    }).replace(/^_/, "");
                    value = o[origKey];
                    if (value)
                        if (value && value instanceof Array || (value !== null && value.constructor === Object)) {
                            value = StringHelper.camelToSnake(value);
                        }
                    newO[newKey] = value;
                }
            }
        }
        return newO;
    }
    static pascalToCamel(o) {
        let newO = {}, origKey, newKey, value;
        if (o instanceof Array) {
            newO = [];
            for (origKey in o) {
                value = o[origKey];
                if (typeof value === "object") {
                    value = StringHelper.pascalToCamel(value);
                }
                newO.push(value);
            }
        }
        else {
            newO = {};
            for (origKey in o) {
                if (o.hasOwnProperty(origKey)) {
                    newKey = origKey.replace(/^([A-Z])/g, function (x, y) {
                        return y.toLowerCase();
                    });
                    value = o[origKey];
                    if (value)
                        if (value && value instanceof Array || (value !== null && value.constructor === Object)) {
                            value = StringHelper.pascalToCamel(value);
                        }
                    newO[newKey] = value;
                }
            }
        }
        return newO;
    }
}
class Browser {
    static openWindow(url, width, height) {
        return window.open(url, "width=" + width + ",height=" + height + ";menubar=no,location=no,status=no,toolbar=no");
    }
}
class Pagination {
    static nextPage(headerLink) {
        const matches = /.*<(.*)>; rel="next".*/.exec(headerLink);
        if (!matches) {
            return null;
        }
        return matches[1];
    }
}
function hex2rgb(c) {
    var c = c.substring(1); // strip #
    var rgb = parseInt(c, 16); // convert rrggbb to decimal
    var r = (rgb >> 16) & 0xff; // extract red
    var g = (rgb >> 8) & 0xff; // extract green
    var b = (rgb >> 0) & 0xff; // extract blue
    return { r, g, b };
}
function rgb2hex(r, g, b) {
    return "#" + ("0" + parseInt(r).toString(16)).slice(-2) + ("0" + parseInt(g).toString(16)).slice(-2) + ("0" + parseInt(b).toString(16)).slice(-2);
}
function rgbToHsl(r, g, b) {
    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return [h, s, l];
}
function hslToRgb(h, s, l) {
    var r, g, b;
    if (s == 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return [r * 255, g * 255, b * 255];
}
function hue2rgb(p, q, t) {
    if (t < 0)
        t += 1;
    if (t > 1)
        t -= 1;
    if (t < 1 / 6)
        return p + (q - p) * 6 * t;
    if (t < 1 / 2)
        return q;
    if (t < 2 / 3)
        return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function rgbToHsv(r, g, b) {
    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, v = max;
    var d = max - min;
    s = max == 0 ? 0 : d / max;
    if (max == min) {
        h = 0; // achromatic
    }
    else {
        switch (max) {
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return [h, s, v];
}
function hsvToRgb(h, s, v) {
    var r, g, b;
    var i = Math.floor(h * 6);
    var f = h * 6 - i;
    var p = v * (1 - s);
    var q = v * (1 - f * s);
    var t = v * (1 - (1 - f) * s);
    switch (i % 6) {
        case 0:
            r = v, g = t, b = p;
            break;
        case 1:
            r = q, g = v, b = p;
            break;
        case 2:
            r = p, g = v, b = t;
            break;
        case 3:
            r = p, g = q, b = v;
            break;
        case 4:
            r = t, g = p, b = v;
            break;
        case 5:
            r = v, g = p, b = q;
            break;
    }
    return [r * 255, g * 255, b * 255];
}
const iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
function copy(obj) {
    if (!obj) {
        return obj;
    }
    var bObject, v, k;
    bObject = Array.isArray(obj) ? [] : {};
    for (k in obj) {
        v = obj[k];
        bObject[k] = (typeof v === "object") ? copy(v) : v;
    }
    return bObject;
}
function compare(_obj1, _obj2) {
    if (!_obj1 || !_obj2) {
        return false;
    }
    let obj1 = copy(_obj1);
    let obj2 = copy(_obj2);
    // Special DIS case, where the code is a object with id and other parameters.
    // We need to expand it
    try {
        const idJson1 = JSON.parse(obj1.id);
        if (typeof idJson1 === 'object' && idJson1.id) {
            obj1 = idJson1;
            console.log("Code is a valid json with Id for obj1, use json instead", obj1, obj2);
        }
        const idJson2 = JSON.parse(obj2.id);
        if (typeof idJson2 === 'object' && idJson2.id) {
            obj2 = idJson2;
            console.log("Code is a valid json with Id for obj2, use json instead", obj1, obj2);
        }
    }
    catch (ex) { }
    // Remove dummy property
    delete obj1.zakekePlatform;
    delete obj2.zakekePlatform;
    delete obj1.label;
    delete obj2.label;
    delete obj1.isGlobal;
    delete obj2.isGlobal;
    if (Object.keys(obj1).length != Object.keys(obj2).length)
        return false;
    var v, k;
    var same = true;
    for (k in obj1) {
        v = obj1[k];
        if (typeof obj2[k] === "undefined")
            same = false;
        if (v != obj2[k])
            same = false;
        // Check if are valid json
        if (typeof v === "object" && typeof obj2[k] === "object") {
            same = compare(v, obj2[k]);
        }
        if (isValidJSON(v) || isValidJSON(obj2[k])) {
            try {
                const a = typeof v === "object" ? v : JSON.parse(v);
                const b = typeof obj2[k] === "object" ? obj2[k] : JSON.parse(obj2[k]);
                if (typeof a == 'object' && typeof b == 'object')
                    same = compare(a, b);
            }
            catch (_a) { }
        }
        if (!same)
            break;
    }
    return same;
}
function isValidJSON(code) {
    try {
        JSON.parse(code);
        return true;
    }
    catch (ex) {
    }
    return false;
}
function isPlatformCode(code) {
    let json = null;
    try {
        json = JSON.parse(code);
        return json.zakekePlatform;
    }
    catch (ex) {
    }
    return false;
}
function matchCodes(code1, code2) {
    if (isPlatformCode(code1) && isPlatformCode(code2))
        return compare(JSON.parse(code1), JSON.parse(code2));
    else
        return code1 == code2;
}
function getPlatformSettings() {
    return CURRENT_REDUX_STORE.getState().platformSettings;
}
const IS_ANDROID = /android/i.test(navigator.userAgent);
const IS_IOS = (/iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
const IS_AR_DEVICE_COMPLIANT = (() => {
    const tempAnchor = document.createElement('a');
    return Boolean(tempAnchor.relList && tempAnchor.relList.supports &&
        tempAnchor.relList.supports('ar'));
})();
function uuid() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x7 | 0x8)).toString(16);
    });
    return uuid;
}
;
function sleep(ms) {
    return __awaiter(this, void 0, void 0, function* () {
        return new Promise(resolve => setTimeout(resolve, ms));
    });
}


/***/ }),

/***/ "./src/imageUploadTask.ts":
/*!********************************!*\
  !*** ./src/imageUploadTask.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ ImageUploadTask)
/* harmony export */ });
/* harmony import */ var _exceptions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./exceptions */ "./src/exceptions.tsx");
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./api */ "./src/api.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


class ImageUploadTask {
    constructor(culture, token) {
        this.culture = culture;
        this.token = token;
        this.upload = (file, onProgress) => __awaiter(this, void 0, void 0, function* () {
            return yield this.uploadFileChunked(file, file.type, Zakeke.generateUUID(), {}, onProgress);
        });
        this.uploadFileChunked = (imageFile, mimeType, fileID, options, progressCallaback) => __awaiter(this, void 0, void 0, function* () {
            let status = yield this.resumableUpload(imageFile, mimeType, fileID, progressCallaback);
            if (status === 'OK') {
                let taskID = yield this.createImageTask(fileID, options);
                if (taskID !== -1) {
                    let responseTaskImage = yield this.getImageFromTask(taskID);
                    if (options.IsPreview) {
                        if (responseTaskImage)
                            return responseTaskImage.previewUrls;
                    }
                    else {
                        if (responseTaskImage && responseTaskImage.images) {
                            return responseTaskImage.images;
                        }
                    }
                }
                else {
                    throw new _exceptions__WEBPACK_IMPORTED_MODULE_0__.UploadFailedExpection();
                }
            }
            return null;
        });
        this.resumableUpload = (imageFile, mimeType, fileID, progressCallback) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => {
                var headersRequest = {
                    'Authorization': 'Bearer ' + this.token,
                    "Accept-Language": this.culture
                };
                let r = new Resumable({
                    target: Zakeke.config.baseImagesUploadApiUrl + "filechunks/upload",
                    generateUniqueIdentifier: function () {
                        return fileID;
                    },
                    maxFiles: 1,
                    testChunks: false,
                    headers: headersRequest,
                    query: { 'resumableType': mimeType },
                    simultaneousUploads: 3
                });
                // Adding file
                r.addFile(imageFile);
                // Event Upload handlers
                r.on('fileError', function (file, message) {
                    resolve('KO');
                    console.error('fileError', file, message);
                });
                r.on('error', function (message, file) {
                    resolve('KO');
                    console.error('error', message, file);
                });
                r.on('progress', function () {
                    let percentage = (r.progress() * 100);
                    if (progressCallback)
                        progressCallback(percentage);
                });
                r.on('fileAdded', function (file, event) {
                    r.upload();
                });
                r.on('complete', function () {
                    resolve('OK');
                });
            });
        });
        this.createImageTask = (fileID, options) => __awaiter(this, void 0, void 0, function* () {
            let imageTask = { 'fileID': fileID, 'options': options };
            let response = yield _api__WEBPACK_IMPORTED_MODULE_1__.axiosApi.post(Zakeke.config.baseImagesUploadApiUrl + "monolithimagetasks", imageTask);
            return (response) ? response.data.taskID : -1;
        });
        this.getImageFromTask = (taskID) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            let times = 0;
            for (;;) {
                try {
                    let response = yield _api__WEBPACK_IMPORTED_MODULE_1__.axiosApi.get(Zakeke.config.baseImagesUploadApiUrl + "monolithimagetasks/results/" + taskID);
                    if (response && response.data.state === 2) {
                        return response.data;
                    }
                    else if (response && response.data.state === 3) {
                        return null;
                    }
                }
                catch (ex) {
                    if (((_a = ex.response) === null || _a === void 0 ? void 0 : _a.status) == 406)
                        throw new _exceptions__WEBPACK_IMPORTED_MODULE_0__.NonSquarePixelException();
                    else
                        return null;
                }
                times++;
                if (times > 100) {
                    return null;
                }
                // Delay 1s
                yield new Promise(resolve => setTimeout(resolve, 1000));
            }
        });
    }
}


/***/ }),

/***/ "./src/index.tsx":
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Attribute": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Attribute),
/* harmony export */   "AttributeOptionShapeType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.AttributeOptionShapeType),
/* harmony export */   "AttributeType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.AttributeType),
/* harmony export */   "Camera": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Camera),
/* harmony export */   "Composition": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Composition),
/* harmony export */   "CompositionItem": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.CompositionItem),
/* harmony export */   "EventMessage": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.EventMessage),
/* harmony export */   "EventMessageType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.EventMessageType),
/* harmony export */   "ExtensionFieldDataType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.ExtensionFieldDataType),
/* harmony export */   "Group": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Group),
/* harmony export */   "ImageItem": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.ImageItem),
/* harmony export */   "ItemType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.ItemType),
/* harmony export */   "Option": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Option),
/* harmony export */   "Platform": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Platform),
/* harmony export */   "PlatformPriceType": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.PlatformPriceType),
/* harmony export */   "PlatformSettings": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.PlatformSettings),
/* harmony export */   "Product": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Product),
/* harmony export */   "ProductArea": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.ProductArea),
/* harmony export */   "ProductQuantityRule": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.ProductQuantityRule),
/* harmony export */   "Quote": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Quote),
/* harmony export */   "QuoteRule": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.QuoteRule),
/* harmony export */   "Step": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Step),
/* harmony export */   "Template": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Template),
/* harmony export */   "TemplateArea": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.TemplateArea),
/* harmony export */   "TemplateConstraints": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.TemplateConstraints),
/* harmony export */   "TextItem": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.TextItem),
/* harmony export */   "User": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.User),
/* harmony export */   "Variant": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.Variant),
/* harmony export */   "ZakekeDesigner": () => (/* reexport safe */ _components_customizer__WEBPACK_IMPORTED_MODULE_2__.ZakekeDesigner),
/* harmony export */   "ZakekeEnvironment": () => (/* reexport safe */ _environment__WEBPACK_IMPORTED_MODULE_0__.ZakekeEnvironment),
/* harmony export */   "ZakekeEvent": () => (/* reexport safe */ _models__WEBPACK_IMPORTED_MODULE_4__.ZakekeEvent),
/* harmony export */   "ZakekeProvider": () => (/* reexport safe */ _state_provider__WEBPACK_IMPORTED_MODULE_3__.ZakekeProvider),
/* harmony export */   "ZakekeViewer": () => (/* reexport safe */ _components_sceneViewer__WEBPACK_IMPORTED_MODULE_1__.ZakekeViewer),
/* harmony export */   "useInternalState": () => (/* reexport safe */ _state_provider__WEBPACK_IMPORTED_MODULE_3__.useInternalState),
/* harmony export */   "useZakeke": () => (/* reexport safe */ _state_provider__WEBPACK_IMPORTED_MODULE_3__.useZakeke)
/* harmony export */ });
/* harmony import */ var _environment__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./environment */ "./src/environment.tsx");
/* harmony import */ var _components_sceneViewer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/sceneViewer */ "./src/components/sceneViewer.tsx");
/* harmony import */ var _components_customizer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/customizer */ "./src/components/customizer.tsx");
/* harmony import */ var _state_provider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./state/provider */ "./src/state/provider.tsx");
/* harmony import */ var _models__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./models */ "./src/models.ts");







/***/ }),

/***/ "./src/integrations/Helpers.ts":
/*!*************************************!*\
  !*** ./src/integrations/Helpers.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "integrationFor": () => (/* binding */ integrationFor)
/* harmony export */ });
/* harmony import */ var _preview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./preview */ "./src/integrations/preview.ts");
/* harmony import */ var _generic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./generic */ "./src/integrations/generic.ts");


function integrationFor(platform) {
    return new Promise((resolve, reject) => {
        switch (platform) {
            case "preview":
                resolve(new _preview__WEBPACK_IMPORTED_MODULE_0__["default"]());
                break;
            default:
                resolve(new _generic__WEBPACK_IMPORTED_MODULE_1__["default"]());
        }
    });
}


/***/ }),

/***/ "./src/integrations/Integration.ts":
/*!*****************************************!*\
  !*** ./src/integrations/Integration.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PlatformAttributeSelection": () => (/* binding */ PlatformAttributeSelection)
/* harmony export */ });
class PlatformAttributeSelection {
    constructor(attributeCode, optionCode, attributeLabel, optionLabel, attributeIsEnabled, optionIsEnabled) {
        this.attributeCode = attributeCode;
        this.optionCode = optionCode;
        this.attributeLabel = attributeLabel;
        this.optionLabel = optionLabel;
        this.attributeIsEnabled = attributeIsEnabled;
        this.optionIsEnabled = optionIsEnabled;
    }
}


/***/ }),

/***/ "./src/integrations/generic.ts":
/*!*************************************!*\
  !*** ./src/integrations/generic.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MerchantIntegrationGeneric)
/* harmony export */ });
var MessageType;
(function (MessageType) {
    MessageType["AddToCart"] = "AddToCart";
    MessageType["Price"] = "Price";
    MessageType["Close"] = "Close";
    MessageType["SharedComposition"] = "SharedComposition";
})(MessageType || (MessageType = {}));
class MerchantIntegrationGeneric {
    constructor() {
        this.callbacks = new Map();
        this.messageIds = 0;
        this.pricingCalculator = null;
        window.addEventListener('message', event => {
            const eventType = event.data.zakekeMessageType;
            if (eventType === MessageType.Price || eventType === MessageType.SharedComposition) {
                const messageId = event.data.messageId;
                if (!this.callbacks.has(messageId)) {
                    return;
                }
                const callback = this.callbacks.get(messageId);
                this.callbacks.delete(messageId);
                callback(event.data.message);
            }
        });
    }
    addToCart(composition, design, model, attributes, designItems, quantity, additionalProperties) {
        const designPrice = this.pricingCalculator && design ? this.pricingCalculator.calculate(design, quantity) : 0;
        window.parent.postMessage({
            zakekeMessageType: MessageType.AddToCart,
            message: {
                composition: composition.id,
                preview: composition.get('previewImageUrl'),
                designPrice,
                attributes,
                designItems,
                quantity,
                additionalProperties
            }
        }, '*');
    }
    getPrice(composition, design, model, attributes, compositionPrice, quantity) {
        return new Promise((resolve, reject) => {
            const messageId = this.messageIds++;
            this.callbacks.set(messageId, resolve);
            const designPrice = this.pricingCalculator && design ? this.pricingCalculator.calculate(design, quantity) : 0;
            const conditions = this.pricingCalculator && design ? this.pricingCalculator.getMatchedConditions(design, quantity, true) : [];
            window.parent.postMessage({
                zakekeMessageType: MessageType.Price,
                messageId,
                message: {
                    attributes,
                    compositionPrice: compositionPrice + designPrice,
                    designPrice,
                    conditions,
                    quantity
                }
            }, '*');
        });
    }
    getSharedCompositionUrl(compositionDocID) {
        return new Promise((resolve, reject) => {
            const messageId = this.messageIds++;
            this.callbacks.set(messageId, resolve);
            window.parent.postMessage({
                zakekeMessageType: MessageType.SharedComposition,
                messageId,
                message: {
                    compositionDocID
                }
            }, '*');
        });
    }
    setPricingCalculator(pricingCalculator) {
        this.pricingCalculator = pricingCalculator;
    }
    close() {
        window.parent.postMessage({
            zakekeMessageType: MessageType.Close,
        }, '*');
    }
}


/***/ }),

/***/ "./src/integrations/preview.ts":
/*!*************************************!*\
  !*** ./src/integrations/preview.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ MerchantIntegrationPreview)
/* harmony export */ });
var MessageType;
(function (MessageType) {
    MessageType["Close"] = "Close";
})(MessageType || (MessageType = {}));
class MerchantIntegrationPreview {
    constructor() {
    }
    addToCart(composition, design, model, attributes, designItems, quantity, additionalProperties) {
        // Not implemented
    }
    getPrice(composition, design, model, attributes, compositionPrice, quantity) {
        return new Promise((resolve, reject) => {
            resolve(compositionPrice);
        });
    }
    getSharedCompositionUrl(compositionDocID) {
        return new Promise((resolve, reject) => {
        });
    }
    setPricingCalculator(pricingCalculator) {
        // Not implemented
    }
    close() {
        window.parent.postMessage({
            zakekeMessageType: MessageType.Close,
        }, '*');
    }
}


/***/ }),

/***/ "./src/models.ts":
/*!***********************!*\
  !*** ./src/models.ts ***!
  \***********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Attribute": () => (/* binding */ Attribute),
/* harmony export */   "AttributeOptionShapeType": () => (/* binding */ AttributeOptionShapeType),
/* harmony export */   "AttributeType": () => (/* binding */ AttributeType),
/* harmony export */   "Camera": () => (/* binding */ Camera),
/* harmony export */   "Composition": () => (/* binding */ Composition),
/* harmony export */   "CompositionItem": () => (/* binding */ CompositionItem),
/* harmony export */   "EventMessage": () => (/* binding */ EventMessage),
/* harmony export */   "EventMessageType": () => (/* binding */ EventMessageType),
/* harmony export */   "ExtensionFieldDataType": () => (/* binding */ ExtensionFieldDataType),
/* harmony export */   "Group": () => (/* binding */ Group),
/* harmony export */   "ImageItem": () => (/* binding */ ImageItem),
/* harmony export */   "ItemType": () => (/* binding */ ItemType),
/* harmony export */   "Option": () => (/* binding */ Option),
/* harmony export */   "Platform": () => (/* binding */ Platform),
/* harmony export */   "PlatformPriceType": () => (/* binding */ PlatformPriceType),
/* harmony export */   "PlatformSettings": () => (/* binding */ PlatformSettings),
/* harmony export */   "Product": () => (/* binding */ Product),
/* harmony export */   "ProductArea": () => (/* binding */ ProductArea),
/* harmony export */   "ProductQuantityRule": () => (/* binding */ ProductQuantityRule),
/* harmony export */   "Quote": () => (/* binding */ Quote),
/* harmony export */   "QuoteRule": () => (/* binding */ QuoteRule),
/* harmony export */   "Step": () => (/* binding */ Step),
/* harmony export */   "Template": () => (/* binding */ Template),
/* harmony export */   "TemplateArea": () => (/* binding */ TemplateArea),
/* harmony export */   "TemplateConstraints": () => (/* binding */ TemplateConstraints),
/* harmony export */   "TextItem": () => (/* binding */ TextItem),
/* harmony export */   "User": () => (/* binding */ User),
/* harmony export */   "Variant": () => (/* binding */ Variant),
/* harmony export */   "ZakekeEvent": () => (/* binding */ ZakekeEvent)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _exceptions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./exceptions */ "./src/exceptions.tsx");


var Platform;
(function (Platform) {
    Platform[Platform["Magento1"] = 5] = "Magento1";
    Platform[Platform["Magento2"] = 1] = "Magento2";
    Platform[Platform["Shopify"] = 3] = "Shopify";
    Platform[Platform["WooCommerce"] = 2] = "WooCommerce";
})(Platform || (Platform = {}));
var PlatformPriceType;
(function (PlatformPriceType) {
    PlatformPriceType[PlatformPriceType["Standard"] = 0] = "Standard";
    PlatformPriceType[PlatformPriceType["Inline"] = 1] = "Inline";
})(PlatformPriceType || (PlatformPriceType = {}));
class User {
    constructor(id, username, name) {
        this.id = id;
        this.username = username;
        this.name = name;
    }
}
var ZakekeEnvironment;
(function (ZakekeEnvironment) {
    ZakekeEnvironment[ZakekeEnvironment["Customizer"] = 1] = "Customizer";
    ZakekeEnvironment[ZakekeEnvironment["Composer"] = 2] = "Composer";
    ZakekeEnvironment[ZakekeEnvironment["Viewer"] = 3] = "Viewer";
})(ZakekeEnvironment || (ZakekeEnvironment = {}));
class Product {
    constructor() {
        this.areas = [];
        this.quantityRule = null;
        this.quoteRule = null;
        this.environment = null;
        this.isShowSecondScreenEnabled = false;
    }
    static fromProduct(zkProduct) {
        const product = new Product();
        product.id = zkProduct.id;
        product.sku = zkProduct.get("code");
        product.name = zkProduct.get("name");
        product.previewUrl = zkProduct.get("largeImageUrl");
        product.quantityRule = zkProduct.get("quantityRule") ? ProductQuantityRule.fromQuantityRule(zkProduct.get("quantityRule")) : null;
        product.areas = zkProduct.get("colors").length > 0 ? zkProduct.get("colors").at(0).get("sides").map(side => ProductArea.fromSide(side)) : [];
        product.quoteRule = zkProduct.get("quoteRule") ? new QuoteRule(zkProduct.get("quoteRule")) : null;
        product.environment = zkProduct.get("environment");
        product.isShowSecondScreenEnabled = zkProduct.get("isShowSecondScreenEnabled");
        return product;
    }
}
class QuoteRule {
    constructor(quoteRule) {
        this.quoteRuleID = quoteRule.quoteRuleID;
        this.name = quoteRule.name;
        this.sellerID = quoteRule.sellerID;
        this.formControlsData = quoteRule.formControlsData;
        this.isValidForAllProducts = quoteRule.isValidForAllProducts;
        this.allowAddToCart = quoteRule.allowAddToCart;
        this.products = quoteRule.products;
    }
}
class Quote {
    constructor() {
        this.statusID = 1;
        this.quantity = 1;
        this.modelPrice = 0;
    }
}
class ProductArea {
    static fromSide(modelSide) {
        let area = new ProductArea();
        area.id = modelSide.id;
        area.name = modelSide.get("name");
        return area;
    }
}
class ProductQuantityRule {
    constructor() {
        this.minQuantity = null;
        this.maxQuantity = null;
        this.step = null;
    }
    static fromQuantityRule(quantityRule) {
        if (!quantityRule)
            throw "Invalid quantity rule";
        let rule = new ProductQuantityRule();
        rule.minQuantity = quantityRule.get("minQuantity");
        rule.maxQuantity = quantityRule.get("maxQuantity");
        rule.step = quantityRule.get("step");
        return rule;
    }
}
class Variant {
    constructor(id, sku, name, price, metadata) {
        this.id = id;
        this.sku = sku;
        this.name = name;
        this.price = price;
        this.metadata = metadata;
    }
}
class ZakekeEvent {
    constructor(event, callback) {
        this.event = event;
        this.callback = callback;
    }
}
class TemplateConstraints {
    constructor() {
        this.isUserImageAllowed = true;
    }
}
class TemplateArea {
    constructor() {
        this.id = -1;
        this.uploadRestrictions = new TemplateConstraints();
        this.disableSellerImages = false;
        this.canAddImage = true;
        this.canAddText = true;
    }
    static fromTemplateArea(zkSide) {
        let side = new TemplateArea();
        side.id = zkSide.get("sideID");
        side.disableSellerImages = zkSide.get("disableSellerImages");
        side.canAddImage = zkSide.get("canAddImage");
        side.canAddText = zkSide.get("canAddText");
        if (zkSide.get("uploadRestrictions"))
            side.uploadRestrictions = lodash__WEBPACK_IMPORTED_MODULE_0___default().mergeWith(new TemplateConstraints(), zkSide.get("uploadRestrictions"), (a, b) => b != undefined ? b : a);
        return side;
    }
}
class Template {
    constructor() {
        this.id = -1;
        this.name = "";
        this.areas = [];
    }
    static fromTemplate(zkTemplate) {
        let template = new Template();
        template.id = zkTemplate.get("templateDesignID");
        template.name = zkTemplate.get("name");
        template.areas = zkTemplate.get("sides").map(x => TemplateArea.fromTemplateArea(x));
        return template;
    }
}
var ItemType;
(function (ItemType) {
    ItemType[ItemType["Text"] = 0] = "Text";
    ItemType[ItemType["Image"] = 1] = "Image";
})(ItemType || (ItemType = {}));
class TextItem {
    constructor(item) {
        this.constraints = null;
        this.type = ItemType.Text;
        this.areaId = item.sideID;
        this.guid = item.itemGuid;
        this.name = item.designItem.get("name");
        this.text = item.text;
        this.strokeColor = item.strokeColor;
        this.strokeWidth = item.strokeWidth;
        this.fillColor = item.fillColor;
        this.fontFamily = item.fontFamily;
        this.fontSize = item.fontSize;
        this.fontWeight = item.fontWeight;
        this.fontStyle = item.fontStyle;
        this.fontStretch = item.fontStretch;
        this.justification = item.justification;
        this.isTextOnPath = item.isTextOnPath;
        this.constraints = item.constraints;
    }
}
class ImageItem {
    constructor(item) {
        this.constraints = null;
        this.type = ItemType.Image;
        this.imageID = item.imageID;
        this.areaId = item.sideID;
        this.guid = item.itemGuid;
        this.name = item.designItem.get("name");
        this.url = item.url;
        this.deleted = !item.visible;
        this.constraints = item.constraints;
    }
}
class PlatformSettings {
    constructor(ecommerceId, currencyId, apiKey, apiSecret, accessKey, accessSecret, remoteUrl, username, password, adminPath) {
        this.ecommerceId = ecommerceId;
        this.currencyId = currencyId;
        this.apiKey = apiKey;
        this.apiSecret = apiSecret;
        this.accessKey = accessKey;
        this.accessSecret = accessSecret;
        this.remoteUrl = remoteUrl;
        this.username = username;
        this.password = password;
        this.adminPath = adminPath;
    }
    get platform() {
        return this.ecommerceId;
    }
    static fromData(settings) {
        if (!settings)
            throw new _exceptions__WEBPACK_IMPORTED_MODULE_1__.Exception("Cannot create platform settings from null");
        return new PlatformSettings(settings.ecommerceId, settings.currencyId, settings.apiKey, settings.accessSecret, settings.accessKey, settings.accessSecret, settings.remoteUrl, settings.username, settings.password, settings.adminPath);
    }
}
PlatformSettings.Empty = new PlatformSettings(-1, -1, "", "", "", "", "", "", "", "");
class EventMessage {
    constructor() {
        this.eventID = -1;
        this.description = "";
        this.closeable = false;
        this.visible = false;
        this.addToCartDisabledIfVisible = false;
    }
    static fromMessage(message) {
        const eventMessage = new EventMessage;
        eventMessage.eventID = message.eventID;
        eventMessage.description = message.description;
        eventMessage.closeable = message.closeable;
        eventMessage.visible = message.visible;
        eventMessage.addToCartDisabledIfVisible = message.addToCartDisabledIfVisible;
        eventMessage.additionalData = message.additionalData !== "" && message.additionalData !== null ? JSON.parse(message.additionalData) : "";
        return eventMessage;
    }
}
var EventMessageType;
(function (EventMessageType) {
    EventMessageType[EventMessageType["ImageQualityWarning"] = 1] = "ImageQualityWarning";
    EventMessageType[EventMessageType["Welcome"] = 3] = "Welcome";
    EventMessageType[EventMessageType["AddToCart"] = 4] = "AddToCart";
    EventMessageType[EventMessageType["Copyright"] = 8] = "Copyright";
})(EventMessageType || (EventMessageType = {}));
class Camera {
    constructor() {
        this.id = '';
        this.name = '';
    }
    static fromZkCamera(zkCamera) {
        const camera = new Camera();
        camera.id = zkCamera.get('locationID');
        camera.name = zkCamera.get('name');
        return camera;
    }
}
class Group {
    constructor() {
        this.id = -1;
        this.guid = "";
        this.name = "Group";
        this.enabled = false;
        this.imageUrl = null;
        this.icon = null;
        this.attributes = [];
        this.steps = [];
        this.cameraLocationId = null;
        this.displayOrder = 1;
        this.direction = 0;
        this.attributesAlwaysOpened = false;
    }
}
class Step {
    constructor() {
        this.id = -1;
        this.guid = "";
        this.name = "Step";
        this.displayOrder = 1;
        this.attributes = [];
    }
}
var AttributeType;
(function (AttributeType) {
    AttributeType[AttributeType["Select"] = 0] = "Select";
    AttributeType[AttributeType["Input"] = 1] = "Input";
    AttributeType[AttributeType["Colorpicker"] = 2] = "Colorpicker";
})(AttributeType || (AttributeType = {}));
var AttributeOptionShapeType;
(function (AttributeOptionShapeType) {
    AttributeOptionShapeType[AttributeOptionShapeType["Round"] = 1] = "Round";
    AttributeOptionShapeType[AttributeOptionShapeType["Square"] = 2] = "Square";
})(AttributeOptionShapeType || (AttributeOptionShapeType = {}));
class Attribute {
    constructor() {
        this.id = -1;
        this.guid = "";
        this.code = "";
        this.name = "Attribute";
        this.description = '';
        this.enabled = false;
        this.imageUrl = null;
        this.groupId = -1;
        this.stepId = -1;
        this.options = [];
        this.value = null;
        this.numberFormat = "";
        this.type = AttributeType.Select;
        this.optionShapeType = AttributeOptionShapeType.Round;
        this.displayOrder = 1;
        this.hideOptionsLabel = false;
        this.cameraLocationId = null;
    }
}
class Option {
    constructor() {
        this.id = -1;
        this.guid = "";
        this.code = "";
        this.name = "Option";
        this.description = '';
        this.enabled = false;
        this.selected = false;
        this.imageUrl = null;
        this.displayOrder = 1;
    }
}
class CompositionItem {
    constructor() {
        this.attributeID = -1;
        this.attributeName = "";
        this.attributeCode = "";
        this.selectedOptionName = "";
        this.selectedOptionCode = "";
    }
}
class Composition {
    constructor() {
        this.name = "";
        this.docID = '';
        this.compositionID = -1;
        this.compositionItems = [];
        this.previewImageUrl = "";
        this.designID = null;
        this.tags = [];
    }
    static fromJSON(json) {
        let composition = new Composition();
        lodash__WEBPACK_IMPORTED_MODULE_0___default().assign(composition, json);
        return composition;
    }
}
var ExtensionFieldDataType;
(function (ExtensionFieldDataType) {
    ExtensionFieldDataType[ExtensionFieldDataType["Money"] = 1] = "Money";
    ExtensionFieldDataType[ExtensionFieldDataType["Integer"] = 2] = "Integer";
    ExtensionFieldDataType[ExtensionFieldDataType["Decimal"] = 3] = "Decimal";
})(ExtensionFieldDataType || (ExtensionFieldDataType = {}));


/***/ }),

/***/ "./src/state/boot.tsx":
/*!****************************!*\
  !*** ./src/state/boot.tsx ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! qs */ "./node_modules/qs/lib/index.js");
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! .. */ "./src/index.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



// Handle boot when provider is ready
const Boot = ({ children }) => {
    const internalState = (0,___WEBPACK_IMPORTED_MODULE_2__.useInternalState)();
    const stateRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(internalState);
    stateRef.current = internalState;
    const boot = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((parameters) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        (_a = stateRef.current) === null || _a === void 0 ? void 0 : _a.dispatch({ type: 'IS_SCENE_LOADING', isLoading: true });
        // Register to environment changes
        (_b = stateRef.current) === null || _b === void 0 ? void 0 : _b.state.environment.on('change', () => { var _a; return (_a = stateRef.current) === null || _a === void 0 ? void 0 : _a.dispatch({ type: 'UPDATE' }); });
        yield ((_c = stateRef.current) === null || _c === void 0 ? void 0 : _c.state.environment.boot(parameters));
        (_d = stateRef.current) === null || _d === void 0 ? void 0 : _d.dispatch({ type: 'IS_SCENE_LOADING', isLoading: false });
    }), []);
    const handleMessageReceived = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((e) => __awaiter(void 0, void 0, void 0, function* () {
        var _e, _f;
        if (e.data.type == "load" && !((_e = stateRef.current) === null || _e === void 0 ? void 0 : _e.state.parametersReceived)) {
            (_f = stateRef.current) === null || _f === void 0 ? void 0 : _f.dispatch({ type: 'PARAMETERS_RECEIVED' });
            boot(e.data.parameters);
            window.parent.postMessage({ zakekeType: "loaded" }, "*");
        }
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
        const query = qs__WEBPACK_IMPORTED_MODULE_0___default().parse(window.location.search);
        if (query && query.ecommerce && query.ecommerce == 'preview') {
            boot(null);
        }
        else {
            window.addEventListener("message", handleMessageReceived);
        }
        return () => window.removeEventListener("message", handleMessageReceived);
    }, []);
    return react__WEBPACK_IMPORTED_MODULE_1___default().createElement((react__WEBPACK_IMPORTED_MODULE_1___default().Fragment), null, children);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Boot);


/***/ }),

/***/ "./src/state/provider.tsx":
/*!********************************!*\
  !*** ./src/state/provider.tsx ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZakekeProvider": () => (/* binding */ ZakekeProvider),
/* harmony export */   "useInternalState": () => (/* binding */ useInternalState),
/* harmony export */   "useZakeke": () => (/* binding */ useZakeke)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _boot__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./boot */ "./src/state/boot.tsx");
/* harmony import */ var _providerValue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./providerValue */ "./src/state/providerValue.ts");
/* harmony import */ var _reducer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reducer */ "./src/state/reducer.ts");




const context = react__WEBPACK_IMPORTED_MODULE_0___default().createContext(null);
const internalContext = react__WEBPACK_IMPORTED_MODULE_0___default().createContext(null);
// Use zakeke hook
const useZakeke = () => {
    const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(context);
    if (!value)
        throw 'Corrupted Zakeke state';
    return value;
};
// Use zakeke hook
const useInternalState = () => {
    const value = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(internalContext);
    if (!value)
        throw 'Corrupted Zakeke state';
    return value;
};
// ZakekeProvider
const ZakekeProvider = ({ environment, children }) => {
    const [state, dispatch] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)(_reducer__WEBPACK_IMPORTED_MODULE_3__.reducer, {
        environment,
        isAddToCartLoading: false,
        isSceneLoading: false,
        parametersReceived: false,
    });
    // Create the provider value exposed to developer
    const value = (0,_providerValue__WEBPACK_IMPORTED_MODULE_2__.createProviderValue)(state, dispatch);
    return react__WEBPACK_IMPORTED_MODULE_0___default().createElement(context.Provider, { value: value },
        react__WEBPACK_IMPORTED_MODULE_0___default().createElement(internalContext.Provider, { value: { state, dispatch } },
            react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_boot__WEBPACK_IMPORTED_MODULE_1__["default"], null, children)));
};



/***/ }),

/***/ "./src/state/providerValue.ts":
/*!************************************!*\
  !*** ./src/state/providerValue.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "createProviderValue": () => (/* binding */ createProviderValue)
/* harmony export */ });
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers */ "./src/helpers.tsx");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

const createProviderValue = (state, dispatch) => {
    if (!state.environment)
        throw new Error('Invalid Zakeke environment.');
    return {
        price: state.environment.price,
        currency: state.environment.currency,
        culture: state.environment.culture,
        useLegacyScreenshot: state.environment.useLegacyScreenshot,
        quantity: state.environment.quantity,
        quantityRule: state.environment.quantityRule,
        internalProduct: state.environment.internalProduct,
        internalScene: state.environment.internalScene,
        internalCurrentTemplate: state.environment.internalCurrentTemplate,
        draftCompositions: state.environment.themeCompositions,
        currentAttributesSelection: state.environment.currentAttributesSelection,
        isSceneLoading: state.isSceneLoading,
        isAddToCartLoading: state.isAddToCartLoading,
        fonts: state.environment.fonts,
        disableTextColors: state.environment.disableTextColors,
        defaultColor: state.environment.defaultColor,
        textColors: state.environment.textColors,
        groups: state.environment.groups,
        templates: state.environment.templates,
        currentTemplate: state.environment.currentTemplate,
        isViewerReady: state.environment.isViewerReady,
        publicTranslations: state.environment.publicTranslations,
        items: state.environment.getDesignItemsInfo(),
        productName: state.environment.productName,
        productCode: state.environment.productCode,
        product: state.environment.product,
        cameras: state.environment.cameras,
        sellerSettings: state.environment.sellerSettings,
        eventMessages: state.environment.eventMessages,
        isAssetsLoading: state.environment.isAssetsLoading,
        extensionFields: state.environment.extensionFields,
        currentCompositionInfo: state.environment.currentCompositionInfo,
        saveComposition: state.environment.saveComposition,
        loadComposition: state.environment.loadComposition,
        getPDF: state.environment.getPDF.bind(state.environment),
        getOnlineScreenshot: state.environment.getOnlineScreenshot.bind(state.environment),
        reset: state.environment.reset.bind(state.environment),
        undo: state.environment.undo.bind(state.environment),
        redo: state.environment.redo.bind(state.environment),
        setCamera: state.environment.setCamera.bind(state.environment),
        setCameraByName: state.environment.setCameraByName.bind(state.environment),
        setCameraZoomEnabled: state.environment.setCameraZoomEnabled.bind(state.environment),
        resetCameraPivot: state.environment.resetCameraPivot.bind(state.environment),
        setCameraPivot: state.environment.setCameraPivot.bind(state.environment),
        setQuantity: state.environment.setQuantity.bind(state.environment),
        getImages: state.environment.getImages.bind(state.environment),
        openSecondScreen: state.environment.openSecondScreen.bind(state.environment),
        getMacroCategories: state.environment.getMacroCategories.bind(state.environment),
        createQuote: state.environment.createQuote,
        previewOnly__setItemImageFromBase64: (guid, base64) => __awaiter(void 0, void 0, void 0, function* () { return dispatch({ type: 'SET_ITEM_IMAGE_FROM_BASE64', guid, base64 }); }),
        setItemImageFromFile: (guid, file) => __awaiter(void 0, void 0, void 0, function* () { return dispatch({ type: 'SET_ITEM_IMAGE_FROM_FILE', guid, file }); }),
        addItemImage: (imageId, areaId) => __awaiter(void 0, void 0, void 0, function* () { return dispatch({ type: 'ADD_ITEM_IMAGE', imageId, areaId }); }),
        createImage: state.environment.createImage.bind(state.environment),
        createImageFromUrl: state.environment.createImageFromUrl.bind(state.environment),
        setItemImage: (guid, imageId) => __awaiter(void 0, void 0, void 0, function* () { return dispatch({ type: 'SET_ITEM_IMAGE', guid, imageId }); }),
        setItemFontFamily: (guid, fontFamily) => dispatch({ type: 'SET_ITEM_FONT_FAMILY', guid, fontFamily }),
        setItemColor: (guid, color) => dispatch({ type: 'SET_ITEM_COLOR', guid, color }),
        setItemBold: (guid, bold) => dispatch({ type: 'SET_ITEM_BOLD', guid, bold }),
        setItemItalic: (guid, italic) => dispatch({ type: 'SET_ITEM_ITALIC', guid, italic }),
        setItemTextOnPath: (guid, areaId, value) => dispatch({ type: 'SET_ITEM_TEXT_PATH', guid, areaId, value }),
        setItemText: (guid, text) => dispatch({ type: 'SET_ITEM_TEXT', guid, text }),
        addItemText: (settings, areaId) => __awaiter(void 0, void 0, void 0, function* () { return dispatch({ type: 'ADD_ITEM_TEXT', settings, areaId }); }),
        removeItem: (guid) => __awaiter(void 0, void 0, void 0, function* () { return dispatch({ type: 'REMOVE_ITEM', guid }); }),
        isFullscreenMode: state.environment.isFullscreenMode,
        switchFullscreen: () => dispatch({ type: 'SWITCH_FULLSCREEN' }),
        zoomIn: () => dispatch({ type: 'ZOOM_IN' }),
        zoomOut: () => dispatch({ type: 'ZOOM_OUT' }),
        setHighlightSettings: (settings) => dispatch({ type: 'SET_HIGHLIGHT_SETTINGS', settings }),
        updateView: (adjustCamera) => dispatch({ type: 'UPDATE_VIEW', adjustCamera }),
        hasExplodedMode: state.environment.hasExplodedMode,
        isExplodedMode: state.environment.isExplodedMode,
        setExplodedMode: (exploded) => dispatch({ type: 'SET_EXPLODED_MODE', exploded }),
        internalAppendViewer: (container) => dispatch({ type: 'APPEND_VIEWER', container }),
        designUpdate: () => dispatch({ type: 'DESIGN_UPDATE' }),
        selectOption: (optionId) => dispatch({ type: 'SELECT_OPTION', optionId }),
        isAreaVisible: state.environment.isAreaVisible.bind(state.environment),
        setTemplate: (templateId) => dispatch({ type: 'SET_TEMPLATE', templateId }),
        addToCart: (...params) => __awaiter(void 0, void 0, void 0, function* () {
            dispatch({ type: 'IS_ADD_TO_CART_LOADING', isLoading: true });
            yield state.environment.addToCart(...params);
            dispatch({ type: 'IS_ADD_TO_CART_LOADING', isLoading: false });
        }),
        // save compositions
        loadSavedComposition: state.environment.loadSavedComposition,
        saveDraftsComposition: state.environment.saveDraftsComposition,
        deleteSavedComposition: state.environment.deleteSavedComposition,
        // Scene manipulation
        getMeshIDbyName: state.environment.getMeshIDbyName.bind(state.environment),
        hideMeshAndSaveState: state.environment.hideMeshAndSaveState.bind(state.environment),
        restoreMeshVisibility: state.environment.restoreMeshVisibility.bind(state.environment),
        setMeshDesignVisibility: state.environment.setMeshDesignVisibility.bind(state.environment),
        exportSceneToGlb: state.environment.exportSceneToGlb,
        // Events
        clearListeners: state.environment.clearListeners,
        addFocusAttributesListener: state.environment.addFocusAttributesListener,
        focusAttribute: state.environment.focusAttribute,
        // Highlight
        highlightGroup: state.environment.hightlightGroup.bind(state.environment),
        highlightAttribute: state.environment.highlightAttribute.bind(state.environment),
        // AR
        getQrCodeArUrl: state.environment.getQrCodeArUrl,
        getMobileArUrl: state.environment.getMobileArUrl,
        openArMobile: state.environment.openArMobile,
        isSceneArEnabled: state.environment.isSceneArEnabled,
        isArDeviceCompliant: state.environment.isArDeviceCompliant,
        IS_ANDROID: _helpers__WEBPACK_IMPORTED_MODULE_0__.IS_ANDROID,
        IS_IOS: _helpers__WEBPACK_IMPORTED_MODULE_0__.IS_IOS,
        setBackgroundColor: state.environment.setBackgroundColor.bind(state.environment),
        // TRY ON
        getTryOnUrl: state.environment.getTryOnUrl.bind(state.environment),
        isSceneTryOnEnabled: state.environment.isSceneTryOnEnabled.bind(state.environment),
        setCameraLocked: state.environment.setCameraLocked.bind(state.environment),
        getTemplateUploadRestrictictions: state.environment.getTemplateUploadRestrictictions.bind(state.environment),
        getShareCompositionUrl: state.environment.getShareCompositionUrl.bind(state.environment),
        getCopyrightMessageAccepted: state.environment.getCopyrightMessageAccepted.bind(state.environment),
        setCopyrightMessageAccepted: state.environment.setCopyrightMessageAccepted.bind(state.environment)
    };
};


/***/ }),

/***/ "./src/state/reducer.ts":
/*!******************************!*\
  !*** ./src/state/reducer.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "reducer": () => (/* binding */ reducer)
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash */ "./node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

// Reducer
function reducer(prevState, action) {
    const newState = lodash__WEBPACK_IMPORTED_MODULE_0___default().clone(prevState);
    switch (action.type) {
        case 'BOOT_COMPLETED':
        case 'UPDATE':
            break;
        case 'DESIGN_UPDATE':
            newState.environment.renderDesign();
            break;
        case 'PARAMETERS_RECEIVED':
            newState.parametersReceived = true;
            break;
        case 'UPDATE_VIEW':
            newState.environment.updateView();
            break;
        case 'SWITCH_FULLSCREEN':
            newState.environment.switchFullscreen();
            break;
        case 'SELECT_OPTION':
            newState.environment.selectOption(action.optionId);
            break;
        case 'APPEND_VIEWER':
            newState.environment.appendViewer(action.container);
            break;
        case 'SET_HIGHLIGHT_SETTINGS':
            newState.environment.setHighlightSettings(action.settings);
        case 'IS_SCENE_LOADING':
            newState.isSceneLoading = action.isLoading;
            break;
        case 'IS_ADD_TO_CART_LOADING':
            newState.isAddToCartLoading = action.isLoading;
            break;
        case 'SET_TEMPLATE':
            newState.environment.setTemplate(action.templateId);
            break;
        case 'SET_ITEM_IMAGE_FROM_BASE64':
            newState.environment.setItemImageFromBase64(action.guid, action.base64);
            break;
        case 'SET_ITEM_IMAGE_FROM_FILE':
            newState.environment.setItemImageFromFile(action.guid, action.file);
            break;
        case 'ADD_ITEM_IMAGE':
            newState.environment.addItemImage(action.imageId, action.areaId);
            break;
        case 'SET_ITEM_IMAGE':
            newState.environment.setItemImage(action.guid, action.imageId);
            break;
        case 'SET_ITEM_FONT_FAMILY':
            newState.environment.setItemFontFamily(action.guid, action.fontFamily);
            break;
        case 'SET_ITEM_COLOR':
            newState.environment.setItemColor(action.guid, action.color);
            break;
        case 'SET_ITEM_BOLD':
            newState.environment.setItemBold(action.guid, action.bold);
            break;
        case 'SET_ITEM_ITALIC':
            newState.environment.setItemItalic(action.guid, action.italic);
            break;
        case 'SET_ITEM_TEXT_PATH':
            newState.environment.setItemTextOnPath(action.guid, action.areaId, action.value);
            break;
        case 'SET_ITEM_TEXT':
            newState.environment.setItemText(action.guid, action.text);
            break;
        case 'ADD_ITEM_TEXT':
            newState.environment.addItemText(action.settings, action.areaId);
            break;
        case 'REMOVE_ITEM':
            newState.environment.removeItem(action.guid);
            break;
        case 'ZOOM_IN':
            newState.environment.zoomIn();
            break;
        case 'ZOOM_OUT':
            newState.environment.zoomOut();
            break;
        case 'SET_EXPLODED_MODE':
            newState.environment.setExplodedMode(action.exploded);
            break;
        default:
            throw new Error(`Invalid reducer action ${action.type}.`);
    }
    return newState;
}


/***/ }),

/***/ "../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased.tsx":
/*!*********************************************************************!*\
  !*** ../../libs/pricingRuleBase/DesignPriceCalculatorRuleBased.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DesignPriceCalculatorRuleBased": () => (/* binding */ DesignPriceCalculatorRuleBased),
/* harmony export */   "DesignPriceCalculatorRuleFactory": () => (/* binding */ DesignPriceCalculatorRuleFactory)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "../../../node_modules/axios/index.js");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash */ "../../../node_modules/lodash/lodash.js");
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_rectangle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/rectangle */ "../../utils/rectangle.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};



var PricingElements;
(function (PricingElements) {
    PricingElements[PricingElements["Tutti"] = 1] = "Tutti";
    PricingElements[PricingElements["AllElementsNoTemplateItems"] = 18] = "AllElementsNoTemplateItems";
    PricingElements[PricingElements["AllTexts"] = 8] = "AllTexts";
    PricingElements[PricingElements["AllCustomText"] = 9] = "AllCustomText";
    PricingElements[PricingElements["SingleElement"] = 10] = "SingleElement";
    PricingElements[PricingElements["AllImages"] = 11] = "AllImages";
    PricingElements[PricingElements["UploadedImages"] = 12] = "UploadedImages";
    PricingElements[PricingElements["AllTextArt"] = 13] = "AllTextArt";
    PricingElements[PricingElements["AllCustomTextArt"] = 14] = "AllCustomTextArt";
    PricingElements[PricingElements["AllCustomElements"] = 15] = "AllCustomElements";
    PricingElements[PricingElements["ClipartImages"] = 16] = "ClipartImages";
    PricingElements[PricingElements["TemplatesImages"] = 17] = "TemplatesImages";
})(PricingElements || (PricingElements = {}));
const operatorsFunctions = (operator) => {
    var _a;
    const func = (_a = [
        { operator: ">", func: (a, b) => a > b },
        { operator: "<", func: (a, b) => a < b },
        { operator: "=", func: (a, b) => a == b },
        { operator: ">=", func: (a, b) => a >= b },
        { operator: "<=", func: (a, b) => a <= b }
    ].find(of => of.operator == operator)) === null || _a === void 0 ? void 0 : _a.func;
    if (func == null)
        throw new Error(`Function  for operator ${operator} not found`);
    return func;
};
// type PricingRuleConditionsModel = Pick<pricing_model['rules'][0], 'conditions'>;
// type PricingRuleConditionModel = Pick<PricingRuleConditionsModel[0],''>;
class DesignPriceCalculatorRuleFactory {
}
DesignPriceCalculatorRuleFactory.create = (product, apiUrl, token, isOwin, cloudFlareApiUrl) => __awaiter(void 0, void 0, void 0, function* () {
    let calculator = new DesignPriceCalculatorRuleBased(apiUrl, token, isOwin, cloudFlareApiUrl);
    yield calculator.init(product).catch(e => console.log(e));
    return calculator;
});
class DesignPriceCalculatorRuleBased {
    constructor(apiUrl, token, isOwin, cloudFlareApiUrl) {
        this.colorID = -1;
        this.config = {
            isOwin: true,
            apiUrl: 'https://test-api.zakeke.com/api/graphql',
            cloudFlareApiUrl: null,
            token: "Gw6IL2Q7e66r3osC16_T6XSlsrnuUAHmw59Y3-qJv2LaPPV-nuzDkC0eOGAU8ef_i94HLlu8vDVXpk9MAWBtwrXWN7_XizPAeIfKXArfol19Ek7wmZMR3zRQWwHChqPmYDJMrI3WeCIQGRJxsR7q8hh5xywTqdOwVi6LT7_8-qP9jkc_tdBUPiMUrT6HI1i1ygnEGEk6Eoa97zvbVGRE3NRt-W5nXKGv4_INB_VBdpOihHVXIzl7PtchqPyBr7AaW5Hdrbh_KoFwEhLTcTixXpxfzOcjecbyqFHw20fNFlg2ny6Cb375i7hpnFWD7Q4lj9xI3R6jbkpFHsQEFfBK-UF1f9vli0liCWQ3WdAYGQEmUYx7QjCy240GuR_cK6c28JHoabSGQdW91K7KEAug4o19nokKfzbWoZM7WD4T4RVXNB_ob_gjeYKsK7EJIt6qGiPpnJEbSeFCjz1EhE31Jw6MO-oawNSASxgYk1D6Z3XkLw1G"
        };
        this.init = (product) => {
            this.product = product;
            return new Promise((resolve, reject) => {
                try {
                    this.getPricings(product, (pricings, properties) => {
                        this.pricings = pricings;
                        this.properties = properties;
                        resolve();
                    });
                }
                catch (error) {
                    reject(error);
                }
            });
        };
        this.getPricings = (product, callback) => __awaiter(this, void 0, void 0, function* () {
            if (this.pricings) {
                callback(this.pricings, this.properties);
            }
            else {
                const query = {
                    name: 'pricingsConfigurationQuery',
                    query: `query pricingsQuery($first: Int!, $productID: Long!) {
                                    pricingProperties { propertyID functionName }
                                    pricingsDetailed(first: $first, productID: $productID, isForFrontEnd: true) {
                                        edges {
                                            node {
                                                id
                                                description
                                                infoPricingText
                                                priceDescriptionEnabled
                                                priceStructure
                                                products {
                                                    productID
                                                }
                                                printTypes {
                                                    printTypeID
                                                }
                                                rules {
                                                    ruleID
                                                    propertyID
                                                    allMatchType
                                                    elementID
                                                    elementTitle
                                                    isSetupPrice
                                                    priceType
                                                    targets {
                                                        area
                                                        color
                                                        side
                                                        targetID
                                                    }
                                                    conditions {
                                                        conditionID
                                                        formula
                                                        position
                                                        priceToAdd
                                                        quantity
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }`,
                    variables: { first: 50, productID: product.get('modelID') }
                };
                const axiosConfig = {
                    'headers': {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                };
                if (this.config.isOwin) {
                    axiosConfig['headers']['Authorization'] = 'Bearer ' + this.config.token;
                }
                else {
                    axiosConfig['headers']['X-Auth-Token'] = this.config.token;
                }
                const requestData = {
                    type: 'POST',
                    url: this.config.apiUrl,
                    data: JSON.stringify(query),
                    contentType: "application/json",
                    dataType: 'json'
                };
                if (this.config.isOwin) {
                    requestData['Authorization'] = 'Bearer ' + this.config.token;
                }
                else {
                    requestData['X-Auth-Token'] = this.config.token;
                }
                try {
                    if (typeof this.config.cloudFlareApiUrl !== 'undefined' && this.config.cloudFlareApiUrl !== null && this.config.cloudFlareApiUrl !== '') {
                        const responseCF = yield axios__WEBPACK_IMPORTED_MODULE_0___default().post(this.config.cloudFlareApiUrl, query, axiosConfig);
                        callback(responseCF.data.data.pricingsDetailed.edges.map(edge => edge.node), responseCF.data.data.pricingProperties);
                        return;
                    }
                }
                catch (error) {
                }
                try {
                    const response = yield axios__WEBPACK_IMPORTED_MODULE_0___default().post(this.config.apiUrl, query, axiosConfig);
                    callback(response.data.data.pricingsDetailed.edges.map(edge => edge.node), response.data.data.pricingProperties);
                }
                catch (error) {
                    console.log(error);
                }
            }
        });
        this.getPricing = (design) => {
            if (this.pricings) {
                // cerco prima il pricing associato al prodotto
                let pricings = this.pricings.filter(pricing => pricing.products.filter(p => p.productID == this.product.get('modelID')).length > 0);
                // se non trovo il pricing associato al prodotto cerco quello associato al print type
                if (pricings.length == 0)
                    pricings = this.pricings.filter(pricing => pricing.printTypes.filter(p => p.printTypeID == design.get('printTypeID')).length > 0);
                // console.log("pricing", (pricings.length>0) ? pricings[0] : pricings);
                return (pricings.length > 0) ? pricings[0] : undefined;
            }
        };
        this.distinct = (value, index, self) => self.indexOf(value) === index;
        this.ElementSizeFunction = (pContext, formula) => {
            let result = { result: false, multiplier: 0, items: pContext.items };
            //qui dentro il mio context contiene già tutti gli item di tipo text, image o textart (eventualmente saranno già filtrati dagli 
            //elements della rule. In ogni caso il calcolo della size in cm sarà lo stesso:
            //quidni basta fare width / side.ppcm e sai i cm (width viene preso dal json del designitem)
            //e height / side.ppcm;
            //poi confronto i valore ottenuti ognuno col valore corrispondente dell'action (che quindi in questo caso ha 2 valori)            
            if (!formula.values || formula.values.length == 0)
                throw ("values missing in formula");
            if (formula.values == null || (formula.values.length == 0))
                throw ("ElementSize invalid value");
            pContext.items.forEach(item => {
                //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
                const myJson = JSON.parse(item.get('json'))[1];
                var width = myJson.data.transformsData.dimensions.width;
                var height = myJson.data.transformsData.dimensions.height;
                //qui dentro tutti i designItemAreas del'item stanno per forza sullo stesso lato, quindi basta prendere il primo
                var sideID = item.get('areas').at(0).get('sideID');
                var modelSide = pContext.sides.find(s => s.get('sideID') == sideID);
                if (width != null && height != null && modelSide != null && modelSide.get('ppcm') > 0) {
                    var itemWidth = width / modelSide.get('ppcm');
                    var itemHeight = height / modelSide.get('ppcm');
                    var itemArea = itemHeight * itemWidth;
                    if (operatorsFunctions(formula.operator)(itemArea, formula.values[0])) {
                        result.result = true;
                        result.multiplier += 1;
                        result.items = result.items.filter(x => x != item);
                    }
                }
            });
            return result;
        };
        this.NumberOfElementsSimplifiedFunction = (pContext, formula) => {
            return {
                result: pContext.items.length > 0,
                multiplier: pContext.items.length,
                items: pContext.items
            };
        };
        this.LinesLengthFunction = (pContext, formula) => {
            //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
            //in questo caso la lunghezza dei caratteri inseriti con il valore inserito nella action dal seller
            //per ora sono escluse le textart
            let result = { result: false, multiplier: 0 };
            //qui dentro il mio context contiene già item di tipo text (o di custom text)
            //in ogni deisgnitem prendo gli elemnti di testo e conto il i caratteri
            if (!formula.values || formula.values.length == 0)
                throw ("values missing in formula");
            pContext.items.forEach(item => {
                //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
                const myJson = JSON.parse(item.get('json'))[1];
                var isText = myJson.data.isText;
                var isTextArea = myJson.data.isTextArea;
                var isTextOnPath = myJson.data.isTextOnPath;
                let isTextArt = myJson.data.isTextArt;
                let testo = "";
                if (isText != null && isText)
                    testo = myJson.content.toString();
                else if ((isTextArea != null && isTextArea) || (isTextOnPath != null && isTextOnPath))
                    testo = myJson.data.text.toString();
                if (isTextArt != null && isTextArt)
                    testo = item.get("textArt").get("text");
                if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(testo)) {
                    //zero fine riga significa una riga
                    const numLines = testo.split("\n").length;
                    if (operatorsFunctions(formula.operator)(numLines, formula.values[0])) {
                        result.result = true;
                        result.multiplier += 1;
                    }
                }
            });
            return result;
        };
        this.AmountOfElementsFunction = (pContext, formula) => {
            //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
            //in questo caso saranno il numero di elementi e il valore inserito nella action dal seller
            let result = { result: false, multiplier: 0 };
            ////in questa funzione si contano tutti gli items quindi non ci saranno items da escludere nella eventuale successiva action
            //result.MatchedItems = items;        
            if (!formula.values || formula.values.length == 0)
                throw ("values missing in formula");
            if (operatorsFunctions(formula.operator)(pContext.items.length, formula.values[0])) {
                result.result = true;
                result.multiplier = 1;
            }
            return result;
        };
        this.AmountOfUsedColorsFunction = (pContext, formula) => {
            /*, i colori sono univoci ma per elemento: devi calcolare quelli per design:
        
                esempio:
        
                immagine1 = ['rosso', 'verde']
                immagine2 = ['verde', 'giallo']
        
                effettivamente hai usato 3 colori, rosso, verde e giallo.
             */
            let result = { result: false, multiplier: 0 };
            if (!formula.values || formula.values.length == 0)
                throw ("values missing in formula");
            ////in questa funzione si contano tutti gli items quindi non ci saranno items da escludere nella eventuale successiva action
            ////a prescindere dal risultato 
            // let colors: string[] = [];
            // pContext.items.forEach(item => {
            //     if (item.get('itemColors') && !isEmpty(item.get('itemColors'))) 
            //         colors.push(item.get('itemColors'));
            // });
            const colors = (0,lodash__WEBPACK_IMPORTED_MODULE_1__.uniq)(pContext.items
                .filter(item => item.get('itemColors') && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(item.get('itemColors')))
                .flatMap(item => item.get('itemColors')));
            if (operatorsFunctions(formula.operator)(colors.filter(this.distinct).length, formula.values[0])) {
                result.result = true;
                result.multiplier = 1;
            }
            return result;
        };
        this.CanvasSizeFunction = (pContext, formula) => {
            let result = { result: false, multiplier: 0 };
            if (!formula.values || formula.values.length == 0)
                throw ("values missing in formula");
            if (pContext.sides && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(pContext.sides)) {
                let areas = pContext.sides.flatMap(s => s.get('areas').models);
                let customizedAreas = [];
                //prendiamo le aree con almeno un item (ricorda che gli items del context sono già filtrati per target/elements)
                areas.forEach(area => {
                    //per ogni area cerco, fra tutti gli items quelli che stanno su quell'area.
                    if (pContext.items.filter(i => i.get('areas').filter(a => a.get('colorID') == area.getColorID() &&
                        a.get('sideID') == area.getSideID() &&
                        a.get('areaID') == area.get('areaID')).length > 0).length > 0) {
                        customizedAreas = [...customizedAreas, area];
                    }
                });
                //a questo punto , per ogni area mi calcolo le misure in cm (dividendo i bound dell'area per i ppcm del side a cui appartiene
                //e eseguo la funzione con l'operatore e i due values del seller
                customizedAreas.forEach(area => {
                    var width = area.get('boundsWidth');
                    var height = area.get('boundsHeight');
                    var modelSide = pContext.sides.find(s => s.get('sideID') == area.getSideID());
                    if (modelSide != null && modelSide.get('ppcm') > 0) {
                        var areaWidth = width / modelSide.get('ppcm');
                        var areaHeight = height / modelSide.get('ppcm');
                        // Round 2 decs
                        areaWidth = Math.round(areaWidth * 100) / 100;
                        areaHeight = Math.round(areaHeight * 100) / 100;
                        if (operatorsFunctions(formula.operator)(areaWidth, formula.values[0]) && operatorsFunctions(formula.operator)(areaHeight, formula.values[1])) {
                            result.result = true;
                            result.multiplier += 1;
                        }
                    }
                });
            }
            return result;
        };
        this.DesignSizeFunction = (pContext, formula) => {
            let result = { result: false, multiplier: 0 };
            let itemsArea = 0;
            if (!formula.values || formula.values.length == 0)
                throw ("values missing in formula");
            if (pContext.sides && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(pContext.sides)) {
                let areas = pContext.sides.flatMap(s => s.get('areas').models);
                //prendiamo le aree con almeno un item (ricorda che gli items del context sono già filtrati per target/elements)
                areas.forEach(area => {
                    //per ogni area cerco, fra tutti gli items quelli che stanno su quell'area.
                    let items = pContext.items.filter(i => i.get('areas').filter(a => a.get('colorID') == area.getColorID() &&
                        a.get('sideID') == area.getSideID() &&
                        a.get('areaID') == area.get('areaID')).length > 0);
                    // seconda versione somma delle aree di ogni item
                    let modelSide = pContext.sides.find(s => s.get('sideID') == area.getSideID());
                    if (modelSide != null && modelSide.get('ppcm') > 0) {
                        const itemsRectangles = items.map(item => {
                            const json = JSON.parse(item.get('json'))[1];
                            const width = json.data.transformsData.dimensions.width;
                            const height = json.data.transformsData.dimensions.height;
                            const xPosition = json.data.transformsData.position.x;
                            const yPosition = json.data.transformsData.position.y;
                            return new _utils_rectangle__WEBPACK_IMPORTED_MODULE_2__.Rectangle(width, height, xPosition, yPosition);
                        });
                        itemsArea = itemsArea + (0,_utils_rectangle__WEBPACK_IMPORTED_MODULE_2__.rectanglesDistinctArea)(itemsRectangles, modelSide.get('ppcm'));
                        console.log("itemsArea", itemsArea);
                    }
                });
            }
            if (itemsArea > 0 && operatorsFunctions(formula.operator)(itemsArea, formula.values[0])) {
                result.result = true;
                result.multiplier += 1;
            }
            return result;
        };
        this.DesignTextLengthFunction = (pContext, formula) => {
            let result = { result: false, multiplier: 0 };
            //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
            //in questo caso saranno il totale dei caratteri di tutto il design (quindi non sul singolo item) 
            //e il valore inserito nella action dal seller
            if (!formula.values || formula.values.length == 0)
                throw ("values missing in formula");
            let totalLength = 0;
            pContext.items.forEach(item => {
                //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
                const myJson = JSON.parse(item.get('json'))[1];
                let isText = myJson.data.isText;
                let isTextArea = myJson.data.isTextArea;
                let isTextOnPath = myJson.data.isTextOnPath;
                let isTextArt = myJson.data.isTextArt;
                let testo = "";
                if (isText != null && isText)
                    testo = myJson.content.toString();
                else if ((isTextArea != null && isTextArea) ||
                    (isTextOnPath != null && isTextOnPath))
                    testo = myJson.data.text.toString();
                else if (isTextArt != null && isTextArt)
                    testo = item.get("textArt").get("text");
                if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(testo)) {
                    totalLength += testo.trim()
                        .split(" ").join("")
                        .replace(/(\r\n|\n|\r)/gm, "")
                        .length;
                }
            });
            //questo è un caso  in cui il moltiplicatore può essere solo zero oppure uno e i matcheditems non devono influenzare
            //l'eventuale action successiva
            if (operatorsFunctions(formula.operator)(totalLength, formula.values[0])) {
                result.result = true;
                result.multiplier = 1;
            }
            return result;
        };
        this.CustomizedSidesFunction = (pContext, formula) => {
            //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
            //in questo caso saranno il numero di elementi e il valore inserito nella action dal seller
            let result = { result: false, multiplier: 0 };
            if (!formula.values || formula.values.length == 0)
                throw ("values missing in formula");
            //var modelSides = ((ModelSideInfoList)pContext["sides"]).ToList();
            let customizedSides = 0;
            //elimina il foreach
            pContext.sides.forEach(side => {
                //dato un certo side e un certo designItem, per sapere se quel side ha elementi personalizzati 
                if (pContext.items.filter(item => item.get('areas').filter(area => area.get('sideID') == side.get('sideID')).length > 0).length > 0) {
                    customizedSides++;
                }
            });
            // We must check that we have at last one side to check.
            // If pContext.sides.length == 0 then this mean that the current rule is not valid for this
            // variation
            if (pContext.sides.length > 0 && operatorsFunctions(formula.operator)(customizedSides, formula.values[0])) {
                result.result = true;
                result.multiplier = 1;
            }
            return result;
        };
        this.TextLengthFunction = (pContext, formula) => {
            //fai tutto quello che devi fare in modo da ottenere sempre i due numeri da cofrontare
            //in questo caso la lunghezza dei caratteri inseriti con il valore inserito nella action dal seller
            //per ora sono escluse le textart
            let result = { result: false, multiplier: 0 };
            //qui dentro il mio context contiene già item di tipo text (o di custom text)
            //in ogni deisgnitem prendo gli elemnti di testo e conto il i caratteri
            if (!formula.values || formula.values.length == 0)
                throw ("values missing in formula");
            pContext.items.forEach(item => {
                //prendo il json, lo leggo , mi prendo il testo e conto i caratteri
                // Newtonsoft.Json.Linq.JToken myJson =
                //                    Newtonsoft.Json.JsonConvert.DeserializeObject<List<Newtonsoft.Json.Linq.JToken>>(
                //                        item.Json)[1];
                let myJson = JSON.parse(item.get('json'))[1];
                let isText = myJson.data.isText;
                let isTextArea = myJson.data.isTextArea;
                let isTextOnPath = myJson.data.isTextOnPath;
                let isTextArt = myJson.data.isTextArt;
                let testo = "";
                if (isText != null && isText)
                    testo = myJson.content.toString();
                else if ((isTextArea != null && isTextArea) || (isTextOnPath != null && isTextOnPath))
                    testo = myJson.data.text.toString();
                else if (isTextArt != null && isTextArt)
                    testo = item.get("textArt").get("text");
                if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(testo) && operatorsFunctions(formula.operator)(testo.trim().split(" ").join("").length, formula.values[0])) {
                    result.result = true;
                    result.multiplier += 1;
                }
            });
            return result;
        };
        this.conditionsToConditionsGroupByFormula = (conditions) => {
            const gb = lodash__WEBPACK_IMPORTED_MODULE_1___default().groupBy(conditions, c => (c === null || c === void 0 ? void 0 : c.formula) ? c === null || c === void 0 ? void 0 : c.formula : "");
            return Object.keys(gb).map(k => { var _a; return { formula: k, position: (_a = gb[k][0]) === null || _a === void 0 ? void 0 : _a.position, conditions: gb[k] }; });
        };
        this.getFunctionName = (properties, rule) => {
            try {
                return properties === null || properties === void 0 ? void 0 : properties.filter(p => p.propertyID == rule.propertyID).map(p => p.functionName)[0];
            }
            catch (error) {
                throw ("function or operator don't exist in dictionaries");
            }
        };
        this.clearPricings = () => {
            this.pricing = undefined;
            this.pricings = undefined;
        };
        // property functions    
        // functions = [
        //     {"TextLength":  this.TextLengthFunction},
        //     {"ElementSize":  this.ElementSizeFunction},
        //     {"LinesLength":  this.LinesLengthFunction},                    
        //     {"AmountOfElements":  this.AmountOfElementsFunction},
        //     {"AmountOfUsedColors":  this.AmountOfUsedColorsFunction},
        //     {"CanvasSize":  this.CanvasSizeFunction},
        //     {"DesignTextLength":  this.DesignTextLengthFunction},
        //     {"CustomizedSides":  this.CustomizedSidesFunction},
        //     {"DesignSizeFunction":  this.DesignSizeFunction}, new
        // ]
        this.GetContextForRule = (rule, product, design) => {
            let context = { sides: [], items: [] };
            let allItems = design.get('designItems').toArray();
            var selectedItems = []; // Item1, item 2, Item3, Item4
            //verifichiamo prima i targets e poi gli elements
            let colorName = ""; //ci serve per i target
            const colore = product.get('colors').find(c => c.get('colorID') == this.colorID);
            if (colore == null || colore == undefined)
                return context;
            colorName = colore.get('name');
            const sides = colore.get('sides');
            context.sides = [];
            if (rule.targets.length == 0) {
                // Se non ho target vuol dire che non sto filtrando per nulla 
                //e quindi devo prendere TUTTI gli item di TUTTO il prodotto personalizzato (a prescindere da area, lato o  variante)
                selectedItems = allItems;
                context.sides = sides.toArray();
            }
            else {
                rule.targets.forEach(target => {
                    let skip = false;
                    let side = null;
                    let currentItems = allItems;
                    // Se il target filtra per variante e la mia non corrisponde, salto completamente questo target e non aggiungo nulla ai selectedtItems
                    //altrimenti per ora mi tengo tutti gli items del design (che ora stanno in sideItems)
                    if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(target.color) && target.color.toLowerCase() != colorName.toLowerCase()) {
                        skip = true; //continue;
                    }
                    else {
                        // Add sides of this color
                        for (const side of sides.toArray()) {
                            if (context.sides.indexOf(side) === -1)
                                context.sides.push(side);
                        }
                    }
                    // se c'è un filtro per side name selezioni gli item che stanno solo su quel side
                    if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(target.side)) {
                        side = sides.find(s => s.get('name').toLowerCase() == target.side.toLowerCase());
                        if (side == null || !side.get('areas'))
                            skip = true; //continue;
                        else {
                            let areaItems = [];
                            // All items that touches the area filter
                            const filter = (item, area) => item.get('areas').filter(a => {
                                return a.get('modelID') == product.get('modelID') &&
                                    a.get('colorID') == area.getSide().getColor().get('colorID') &&
                                    a.get('sideID') == area.getSide().get('sideID') &&
                                    a.get('areaID') == area.get('areaID');
                            }).length > 0;
                            side.get('areas').forEach(area => {
                                areaItems = areaItems.concat(allItems.filter(item => filter(item, area)));
                            });
                            currentItems = areaItems;
                        }
                    }
                    // se c'è un filtro per area name selezioni gli item che stanno su quell'area
                    if (!(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(target.area)) {
                        let areaItems = [];
                        //se ci sono due lati, e un area su ogni lato con lo stesso nome. IN questo caso li voglio tutti e due gli item
                        let areas = [];
                        sides.forEach(side => {
                            areas = areas.concat(side.get('areas').filter(a => a.get('name').toLowerCase() == target.area.toLowerCase()));
                        });
                        areas.forEach((area) => {
                            //currentItems potrebbe essere già filtrato per lato, altrimenti contiene tutti gli item (allItems)
                            areaItems = [...currentItems.filter(i => i.get('areas').filter(a => a.get('modelID') == product.get('modelID') &&
                                    a.get('colorID') == area.getSide().getColor().get('colorID') &&
                                    a.get('sideID') == area.getSide().get('sideID') &&
                                    a.get('areaID') == area.get('areaID')).length > 0)];
                        });
                        //raggruppiamo alla fine
                        currentItems = areaItems;
                    }
                    //eliminiamo eventuali duplicati (raggruppa su ItemGuid perchè su cosmos (a livello di carrello siamo ancora su cosmosDb)
                    //l'itemId non esiste ancora
                    // currentItems = currentItems.GroupBy(c => c.ItemGuid, (key, c) => c.FirstOrDefault()).ToList();
                    if (!skip) {
                        selectedItems = [...selectedItems, ...currentItems];
                    }
                } //fine foreach target
                );
            }
            //chiedi come mettere gli id corretti nell'enumerativo degli elemnts
            if (rule.elementID == PricingElements.AllTexts) {
                selectedItems = selectedItems.filter(p => {
                    let j = JSON.parse(p.get('json'))[1];
                    return ((j.data.isText != null && j.data.isText) ||
                        (j.data.isTextArea != null && j.data.isTextArea) ||
                        (j.data.isTextOnPath != null && j.data.isTextOnPath) ||
                        (j.data.isTextArt != null && j.data.isTextArt));
                });
            }
            else if (rule.elementID == PricingElements.AllElementsNoTemplateItems) {
                selectedItems = selectedItems.filter(p => {
                    let j = JSON.parse(p.get('json'))[1];
                    return (!j.data.isTemplateElement);
                });
            }
            else if (rule.elementID == PricingElements.AllCustomText) {
                //per gestire i vecchi casi in cui isTemplateElement non c'era: i null li considero custom
                selectedItems = selectedItems.filter(p => {
                    var j = JSON.parse(p.get('json'))[1];
                    return (((j.data.isTemplateElement != null && !j.data.isTemplateElement) &&
                        ((j.data.isText != null && j.data.isText) ||
                            (j.data.isTextArea != null && j.data.isTextArea) ||
                            (j.data.isTextOnPath != null && j.data.isTextOnPath) ||
                            (j.data.isTextArt != null && j.data.isTextArt))) ||
                        ((j.data.isTemplateElement == null) &&
                            ((j.data.isText != null && j.data.isText) ||
                                (j.data.isTextArea != null && j.data.isTextArea) ||
                                (j.data.isTextOnPath != null && j.data.isTextOnPath) ||
                                (j.data.isTextArt != null && j.data.isTextArt))));
                });
            }
            else if (rule.elementID == PricingElements.AllImages) {
                selectedItems = selectedItems
                    .filter(i => i.get('imageID') > 0)
                    .filter(i => {
                    const json = JSON.parse(i.get('json'))[1];
                    return !json.data.isTemplateElement;
                });
            }
            else if (rule.elementID == PricingElements.UploadedImages) {
                selectedItems = selectedItems
                    .filter(p => p.get('imageID') > 0 && (p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0))
                    .filter(i => {
                    const json = JSON.parse(i.get('json'))[1];
                    return !json.data.isTemplateElement;
                });
            }
            else if (rule.elementID == PricingElements.ClipartImages) {
                selectedItems = selectedItems
                    .filter(p => p.get('imageID') > 0 && p.get('imageVisitorID') <= 0 && p.get('imageCustomerID') <= 0)
                    .filter(i => {
                    const json = JSON.parse(i.get('json'))[1];
                    return !json.data.isTemplateElement;
                });
            }
            else if (rule.elementID == PricingElements.TemplatesImages) {
                selectedItems = selectedItems
                    .filter(p => p.get('imageID') > 0)
                    .filter(i => {
                    const json = JSON.parse(i.get('json'))[1];
                    return json.data.isTemplateElement;
                });
            }
            else if (rule.elementID == PricingElements.SingleElement) {
                selectedItems = selectedItems.filter(i => i.get('name').toLowerCase() == rule.elementTitle.toLowerCase());
            }
            else if (rule.elementID == PricingElements.AllTextArt) {
                selectedItems = selectedItems.filter(p => {
                    let json = JSON.parse(p.get('json'))[1];
                    return (json.data.isTextArt != null && json.data.isTextArt);
                });
            }
            else if (rule.elementID == PricingElements.AllCustomTextArt) {
                //selectedtItems = selectedtItems.Where(x => x.isTexArt == true && item.isCustom);
            }
            else if (rule.elementID == PricingElements.AllCustomElements) {
                selectedItems = selectedItems.filter(p => {
                    const json = JSON.parse(p.get('json'))[1];
                    return (p.get('imageID') > 0 && !json.data.isTemplateElement && (p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0)) ||
                        ((json.data.isTemplateElement != null && !json.data.isTemplateElement) &&
                            ((json.data.isText != null && json.data.isText) ||
                                (json.data.isTextArea != null && json.data.isTextArea) ||
                                (json.data.isTextOnPath != null && json.data.isTextOnPath) ||
                                (json.data.isTextArt != null && json.data.isTextArt))) ||
                        ((json.data.isTemplateElement == null) &&
                            ((json.data.isText != null && json.data.isText) ||
                                (json.data.isTextArea != null && json.data.isTextArea) ||
                                (json.data.isTextOnPath != null && json.data.isTextOnPath) ||
                                (json.data.isTextArt != null && json.data.isTextArt)));
                });
            }
            else if (rule.elementID == PricingElements.UploadedImages) {
                selectedItems = selectedItems.filter(p => {
                    return p.get('imageID') > 0 && (p.get('imageVisitorID') > 0 || p.get('imageCustomerID') > 0);
                });
            }
            // eseguo una distinct
            const selectedItemsGroupByItemGuild = lodash__WEBPACK_IMPORTED_MODULE_1___default().groupBy(selectedItems, c => c.get('itemGuid'));
            context.items = Object.keys(selectedItemsGroupByItemGuild).map(k => selectedItemsGroupByItemGuild[k][0]);
            return context;
        };
        this.isUsingAmountOfColors = (design) => {
            this.pricing = this.getPricing(design);
            if (this.pricing)
                return this.pricing.rules.find(r => r.propertyID == 10) != undefined;
            else
                return false;
        };
        this.getPremiumPhotosPrice = (design, quantity) => {
            var _a;
            // Aggiungo il prezzo delle immagini esterne utilizzate
            const imageItemsGroups = [];
            let price = 0;
            for (var i = 0; i < design.get('designItems').length; i++) {
                const item = design.get('designItems').at(i);
                if (item.get("imageID") > 0 && item.get("imagePrice") > 0 && item.get("providerImageID") != null && ((_a = item.get("providerImageID")) === null || _a === void 0 ? void 0 : _a.length) > 0 && !imageItemsGroups.find(x => x.get("providerImageID") === item.get("providerImageID"))) {
                    imageItemsGroups.push(item);
                    let pricePerImage = item.get("imagePrice");
                    if (!this.product.get("hasAdditionalFeeOnImagesProvider"))
                        pricePerImage = (item.get("applyImagePriceForQuantity") === null || item.get("applyImagePriceForQuantity")) ? item.get("imagePrice") * quantity : item.get("imagePrice");
                    else
                        pricePerImage = item.get("imagePrice") * quantity;
                    price += pricePerImage;
                }
            }
            Logger.info('Premium photo price: ', price);
            return price;
        };
        /**
         * Get Image Price
         *
         * Metodo che calcola il prezzo per le immagini nel design a cui a backoffice
         * è stato valorizzato un prezzo
         *
         * @author f.checchia
         *
         * @param design Il design in input
         * @param {number} quantity La quantità del prodotto che si sta acquistando
         *
         * @return {number} Il prezzo complessivo delle immagini per la quantità
         *
         * */
        this.getImagePrice = (design, quantity) => {
            // Aggiungo il prezzo delle immagini utilizzate
            let price = 0;
            for (var i = 0; i < design.get('designItems').length; i++) {
                const item = design.get('designItems').at(i);
                if (item.get("imageID") > 0 && item.get("imagePrice") > 0 && !item.get("providerImageID")) {
                    let pricePerImage = item.get("imagePrice");
                    pricePerImage = item.get("imagePrice") * quantity;
                    price += pricePerImage;
                }
            }
            Logger.info('Image price: ', price);
            return price;
        };
        this.getMatchedConditions = (design, quantity, includePercentage) => {
            this.pricing = this.getPricing(design);
            if (!this.pricing)
                return [];
            let matchedConditions = [];
            this.pricing.rules.forEach(rule => {
                if (!includePercentage && rule.priceType == 1)
                    return;
                const context = this.GetContextForRule(rule, this.product, design);
                // If we don't have sides to check, we are in the wrong
                // variant probably, just skip it.
                if (context.sides.length === 0)
                    return;
                const conditionsGroupByformula = this.conditionsToConditionsGroupByFormula(rule.conditions);
                let forEachBreakException = {};
                try {
                    conditionsGroupByformula.sort((c1, c2) => c1 && c2 && c1.position > c2.position ? 1 : -1).forEach(conditionGroupByFormula => {
                        //per ogni gruppo (le cui conditions avranno tutte la stessa formula) estraggo dalla formula l'operatore e il values e richiamo la function
                        let formulaObject = JSON.parse(conditionGroupByFormula.formula);
                        if (!formulaObject.operator)
                            throw ("operator missing in formula");
                        // if (!formulaObject.values || formulaObject.values.length == 0) throw ("values missing in formula");
                        // conditionGroupByFormula.conditions.forEach( condition => {
                        const functionName = this.getFunctionName(this.properties, rule) + "Function";
                        //richiama la funzione col nome preso dalla property e con l'operatore preso dalla conditions (che in questo gruppo hanno la stessa formula)
                        const result = this[functionName](context, formulaObject);
                        // //sia nel caso any che all mi calcolo il prezzo da aggiungere. 
                        // //Nel caso any se il risultato è true non vado alla successiva condition
                        if (result.result) {
                            //in ogni gruppo prendo il priceToAdd della condition con la quantità più vicina alla quantità acquistata.                        
                            let condition = conditionGroupByFormula.conditions.filter(g => g.quantity <= quantity).sort((c1, c2) => c2.quantity - c1.quantity)[0];
                            //controlla condition: se è null vai avanti
                            if (condition != null) {
                                const priceToAdd = condition.priceToAdd;
                                const isSetupPrice = rule.isSetupPrice;
                                const multiplier = result.multiplier;
                                const priceType = rule.priceType;
                                matchedConditions.push({
                                    priceToAdd,
                                    isSetupPrice,
                                    multiplier,
                                    priceType
                                });
                                // If some itemes were not matched with this condition, we must continue to check 
                                // for other conditions
                                const functionMatchedAllItems = !result.items || result.items.length == 0;
                                if (!rule.allMatchType && result.items)
                                    context.items = result.items;
                                if (!rule.allMatchType && functionMatchedAllItems)
                                    throw forEachBreakException;
                            }
                        }
                    });
                }
                catch (e) {
                    if (e !== forEachBreakException)
                        throw e;
                }
            });
            return matchedConditions;
        };
        this.calculate = (design, quantity) => {
            let matchedConditions = [];
            let totalPriceToAdd = this.getPremiumPhotosPrice(design, quantity);
            totalPriceToAdd += this.getImagePrice(design, quantity);
            matchedConditions = this.getMatchedConditions(design, quantity, false);
            matchedConditions.forEach(matchedCondition => {
                let conditionPrice = matchedCondition.priceToAdd * matchedCondition.multiplier;
                if (!matchedCondition.isSetupPrice)
                    conditionPrice *= quantity;
                totalPriceToAdd += conditionPrice;
            });
            Logger.info('Total custom price: ', totalPriceToAdd);
            return totalPriceToAdd;
        };
        this.getPricingAdditionalInfo = (design) => {
            if (!design)
                return;
            let pricing = this.getPricing(design);
            if (!pricing)
                return;
            return {
                description: pricing.description,
                priceDescriptionEnabled: pricing.priceDescriptionEnabled,
                infoPricingText: pricing.infoPricingText,
                priceStructure: pricing.priceStructure
            };
        };
        if (apiUrl !== undefined)
            this.config.apiUrl = apiUrl + "graphql";
        if (token !== undefined)
            this.config.token = token;
        if (isOwin !== undefined)
            this.config.isOwin = isOwin;
        if (cloudFlareApiUrl)
            this.config.cloudFlareApiUrl = cloudFlareApiUrl + "graphql";
    }
}


/***/ }),

/***/ "../../utils/rectangle.ts":
/*!********************************!*\
  !*** ../../utils/rectangle.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rectangle": () => (/* binding */ Rectangle),
/* harmony export */   "rectangleArea": () => (/* binding */ rectangleArea),
/* harmony export */   "rectanglesDistinctArea": () => (/* binding */ rectanglesDistinctArea)
/* harmony export */ });
class Rectangle {
    constructor(width, height, x, y) {
        this.maxX = () => this.x + this.width;
        this.maxY = () => this.y + this.height;
        this.area = () => this.width * this.height;
        this.areaPPCM = (ppcm) => (this.width / ppcm) * (this.height / ppcm);
        this.equals = (rectangleToCompare) => this.width == rectangleToCompare.width &&
            this.height == rectangleToCompare.height &&
            this.x == rectangleToCompare.x &&
            this.y == rectangleToCompare.y;
        this.width = width;
        this.height = height;
        this.x = x;
        this.y = y;
    }
}
const distinct = (n, i, array) => array.indexOf(n) === i;
const rectangleArea = (r) => r.width * r.height;
const rectangleSplitAtXPosition = (rectangle, x) => {
    if (x <= rectangle.x || x >= rectangle.x + rectangle.width) {
        return [rectangle];
    }
    let rect1 = new Rectangle(x - rectangle.x, rectangle.height, rectangle.x, rectangle.y);
    let rect2 = new Rectangle(rectangle.maxX() - x, rectangle.height, x, rectangle.y);
    return [rect1, rect2];
};
const rectangleSplitAtYPosition = (rectangle, y) => {
    if (y <= rectangle.y || y >= rectangle.y + rectangle.height) {
        return [rectangle];
    }
    let rect1 = new Rectangle(rectangle.width, y - rectangle.y, rectangle.x, rectangle.y);
    let rect2 = new Rectangle(rectangle.width, rectangle.maxY() - y, rectangle.x, y);
    return [rect1, rect2];
};
const rectangleIncludeXPosition = (rectangle, x) => rectangle.x < x && rectangle.maxX() > x;
const rectangleIncludeYPosition = (rectangle, y) => rectangle.y < y && rectangle.maxY() > y;
const rectangleNotIncludeXPosition = (rectangle, x) => rectangle.x >= x || rectangle.maxX() <= x;
const rectangleNotIncludeYPosition = (rectangle, y) => rectangle.y >= y || rectangle.maxY() <= y;
const rectanglesDistinctArea = (rectangles, ppcm) => {
    // all x values
    const xPositions = rectangles.reduce((acc, rectangle) => [...acc, rectangle.x, rectangle.maxX()], [])
        .filter(distinct)
        .sort((v1, v2) => v1 - v2);
    let rectanglesOutputByXPosition = [...rectangles];
    xPositions.forEach(xPosition => {
        const rectanglesToDivide = rectanglesOutputByXPosition.filter(rectangle => rectangleIncludeXPosition(rectangle, xPosition));
        const rectanglesToNotDivide = rectanglesOutputByXPosition.filter(rectangle => rectangleNotIncludeXPosition(rectangle, xPosition));
        const rectanglesDivided = rectanglesToDivide.map(rectangle => rectangleSplitAtXPosition(rectangle, xPosition))
            .reduce((acc, val) => acc.concat(val), []); // flatMap
        rectanglesOutputByXPosition = [...rectanglesToNotDivide, ...rectanglesDivided];
    });
    const yPositions = rectanglesOutputByXPosition.reduce((acc, rectangle) => [...acc, rectangle.y, rectangle.maxY()], [])
        .filter(distinct)
        .sort((v1, v2) => v1 - v2);
    let rectanglesOutputByYPosition = [...rectanglesOutputByXPosition];
    yPositions.forEach(yPosition => {
        const rectanglesToDivide = rectanglesOutputByYPosition.filter(rectangle => rectangleIncludeYPosition(rectangle, yPosition));
        const rectanglesToNotDivide = rectanglesOutputByYPosition.filter(rectangle => rectangleNotIncludeYPosition(rectangle, yPosition));
        const rectanglesDivided = rectanglesToDivide.map(rectangle => rectangleSplitAtYPosition(rectangle, yPosition))
            .reduce((acc, val) => acc.concat(val), []); // flatMap
        rectanglesOutputByYPosition = [...rectanglesToNotDivide, ...rectanglesDivided];
    });
    return rectanglesOutputByYPosition
        .filter((rect, index, arr) => arr.findIndex(r => r.equals(rect)) == index) // distinct rectangle
        .reduce((acc, rect) => ppcm ? acc + rect.areaPPCM(ppcm) : acc + rect.area(), 0); // sum all rectangles area
};


/***/ }),

/***/ "../../3D/src/Polyfills/Array/Array.prototype.find.js":
/*!************************************************************!*\
  !*** ../../3D/src/Polyfills/Array/Array.prototype.find.js ***!
  \************************************************************/
/***/ (() => {

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, 'find', {
    value: function (predicate) {
      'use strict';

      if (this == null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      for (var i = 0; i !== length; i++) {
        if (predicate.call(thisArg, this[i], i, list)) {
          return this[i];
        }
      }
      return undefined;
    }
  });
}

/***/ }),

/***/ "../../3D/src/Polyfills/Array/Array.prototype.includes.js":
/*!****************************************************************!*\
  !*** ../../3D/src/Polyfills/Array/Array.prototype.includes.js ***!
  \****************************************************************/
/***/ (() => {

if (!Array.prototype.includes) {
  Array.prototype.includes = function (searchElement /*, fromIndex*/) {
    'use strict';

    if (this == null) {
      throw new TypeError('Array.prototype.includes called on null or undefined');
    }
    var O = Object(this);
    var len = parseInt(O.length, 10) || 0;
    if (len === 0) {
      return false;
    }
    var n = parseInt(arguments[1], 10) || 0;
    var k;
    if (n >= 0) {
      k = n;
    } else {
      k = len + n;
      if (k < 0) {
        k = 0;
      }
    }
    var currentElement;
    while (k < len) {
      currentElement = O[k];
      if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) {
        // NaN !== NaN
        return true;
      }
      k++;
    }
    return false;
  };
}

/***/ }),

/***/ "../../3D/src/Polyfills/Array/Array.prototype.map.js":
/*!***********************************************************!*\
  !*** ../../3D/src/Polyfills/Array/Array.prototype.map.js ***!
  \***********************************************************/
/***/ (() => {

// Production steps of ECMA-262, Edition 5, 15.4.4.19
// Reference: http://es5.github.io/#x15.4.4.19
if (!Array.prototype.map) {
  Array.prototype.map = function (callback /*, thisArg*/) {
    var T, A, k;
    if (this == null) {
      throw new TypeError('this is null or not defined');
    }

    // 1. Let O be the result of calling ToObject passing the |this| 
    //    value as the argument.
    var O = Object(this);

    // 2. Let lenValue be the result of calling the Get internal 
    //    method of O with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    var len = O.length >>> 0;

    // 4. If IsCallable(callback) is false, throw a TypeError exception.
    // See: http://es5.github.com/#x9.11
    if (typeof callback !== 'function') {
      throw new TypeError(callback + ' is not a function');
    }

    // 5. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if (arguments.length > 1) {
      T = arguments[1];
    }

    // 6. Let A be a new array created as if by the expression new Array(len) 
    //    where Array is the standard built-in constructor with that name and 
    //    len is the value of len.
    A = new Array(len);

    // 7. Let k be 0
    k = 0;

    // 8. Repeat, while k < len
    while (k < len) {
      var kValue, mappedValue;

      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the HasProperty internal 
      //    method of O with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then
      if (k in O) {
        // i. Let kValue be the result of calling the Get internal 
        //    method of O with argument Pk.
        kValue = O[k];

        // ii. Let mappedValue be the result of calling the Call internal 
        //     method of callback with T as the this value and argument 
        //     list containing kValue, k, and O.
        mappedValue = callback.call(T, kValue, k, O);

        // iii. Call the DefineOwnProperty internal method of A with arguments
        // Pk, Property Descriptor
        // { Value: mappedValue,
        //   Writable: true,
        //   Enumerable: true,
        //   Configurable: true },
        // and false.

        // In browsers that support Object.defineProperty, use the following:
        // Object.defineProperty(A, k, {
        //   value: mappedValue,
        //   writable: true,
        //   enumerable: true,
        //   configurable: true
        // });

        // For best browser support, use the following:
        A[k] = mappedValue;
      }
      // d. Increase k by 1.
      k++;
    }

    // 9. return A
    return A;
  };
}

/***/ }),

/***/ "../../3D/src/Polyfills/String/String.prototype.endsWith.js":
/*!******************************************************************!*\
  !*** ../../3D/src/Polyfills/String/String.prototype.endsWith.js ***!
  \******************************************************************/
/***/ (() => {

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (search, this_len) {
    if (this_len === undefined || this_len > this.length) {
      this_len = this.length;
    }
    return this.substring(this_len - search.length, this_len) === search;
  };
}

/***/ }),

/***/ "../../3D/src/Polyfills/String/String.prototype.startsWith.js":
/*!********************************************************************!*\
  !*** ../../3D/src/Polyfills/String/String.prototype.startsWith.js ***!
  \********************************************************************/
/***/ (() => {

if (!String.prototype.startsWith) {
  Object.defineProperty(String.prototype, 'startsWith', {
    value: function (search, rawPos) {
      var pos = rawPos > 0 ? rawPos | 0 : 0;
      return this.substring(pos, pos + search.length) === search;
    }
  });
}

/***/ }),

/***/ "./node_modules/axios/index.js":
/*!*************************************!*\
  !*** ./node_modules/axios/index.js ***!
  \*************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(/*! ./lib/axios */ "./node_modules/axios/lib/axios.js");

/***/ }),

/***/ "./node_modules/axios/lib/adapters/xhr.js":
/*!************************************************!*\
  !*** ./node_modules/axios/lib/adapters/xhr.js ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/axios/lib/utils.js");
var settle = __webpack_require__(/*! ./../core/settle */ "./node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__(/*! ./../helpers/buildURL */ "./node_modules/axios/lib/helpers/buildURL.js");
var parseHeaders = __webpack_require__(/*! ./../helpers/parseHeaders */ "./node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__(/*! ./../helpers/isURLSameOrigin */ "./node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__(/*! ../core/createError */ "./node_modules/axios/lib/core/createError.js");
module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }
    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(/*! ./../helpers/cookies */ "./node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }
    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }
        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }
    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),

/***/ "./node_modules/axios/lib/axios.js":
/*!*****************************************!*\
  !*** ./node_modules/axios/lib/axios.js ***!
  \*****************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "./node_modules/axios/lib/utils.js");
var bind = __webpack_require__(/*! ./helpers/bind */ "./node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__(/*! ./core/Axios */ "./node_modules/axios/lib/core/Axios.js");
var defaults = __webpack_require__(/*! ./defaults */ "./node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);
  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(/*! ./cancel/Cancel */ "./node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__(/*! ./cancel/CancelToken */ "./node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__(/*! ./cancel/isCancel */ "./node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(/*! ./helpers/spread */ "./node_modules/axios/lib/helpers/spread.js");
module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;

/***/ }),

/***/ "./node_modules/axios/lib/cancel/Cancel.js":
/*!*************************************************!*\
  !*** ./node_modules/axios/lib/cancel/Cancel.js ***!
  \*************************************************/
/***/ ((module) => {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}
Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};
Cancel.prototype.__CANCEL__ = true;
module.exports = Cancel;

/***/ }),

/***/ "./node_modules/axios/lib/cancel/CancelToken.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/cancel/CancelToken.js ***!
  \******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var Cancel = __webpack_require__(/*! ./Cancel */ "./node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }
    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};
module.exports = CancelToken;

/***/ }),

/***/ "./node_modules/axios/lib/cancel/isCancel.js":
/*!***************************************************!*\
  !*** ./node_modules/axios/lib/cancel/isCancel.js ***!
  \***************************************************/
/***/ ((module) => {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),

/***/ "./node_modules/axios/lib/core/Axios.js":
/*!**********************************************!*\
  !*** ./node_modules/axios/lib/core/Axios.js ***!
  \**********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var defaults = __webpack_require__(/*! ./../defaults */ "./node_modules/axios/lib/defaults.js");
var utils = __webpack_require__(/*! ./../utils */ "./node_modules/axios/lib/utils.js");
var InterceptorManager = __webpack_require__(/*! ./InterceptorManager */ "./node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__(/*! ./dispatchRequest */ "./node_modules/axios/lib/core/dispatchRequest.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }
  config = utils.merge(defaults, {
    method: 'get'
  }, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });
  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }
  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});
module.exports = Axios;

/***/ }),

/***/ "./node_modules/axios/lib/core/InterceptorManager.js":
/*!***********************************************************!*\
  !*** ./node_modules/axios/lib/core/InterceptorManager.js ***!
  \***********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/axios/lib/utils.js");
function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};
module.exports = InterceptorManager;

/***/ }),

/***/ "./node_modules/axios/lib/core/createError.js":
/*!****************************************************!*\
  !*** ./node_modules/axios/lib/core/createError.js ***!
  \****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var enhanceError = __webpack_require__(/*! ./enhanceError */ "./node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),

/***/ "./node_modules/axios/lib/core/dispatchRequest.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/core/dispatchRequest.js ***!
  \********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/axios/lib/utils.js");
var transformData = __webpack_require__(/*! ./transformData */ "./node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__(/*! ../cancel/isCancel */ "./node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__(/*! ../defaults */ "./node_modules/axios/lib/defaults.js");
var isAbsoluteURL = __webpack_require__(/*! ./../helpers/isAbsoluteURL */ "./node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__(/*! ./../helpers/combineURLs */ "./node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});
  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};

/***/ }),

/***/ "./node_modules/axios/lib/core/enhanceError.js":
/*!*****************************************************!*\
  !*** ./node_modules/axios/lib/core/enhanceError.js ***!
  \*****************************************************/
/***/ ((module) => {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};

/***/ }),

/***/ "./node_modules/axios/lib/core/settle.js":
/*!***********************************************!*\
  !*** ./node_modules/axios/lib/core/settle.js ***!
  \***********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var createError = __webpack_require__(/*! ./createError */ "./node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),

/***/ "./node_modules/axios/lib/core/transformData.js":
/*!******************************************************!*\
  !*** ./node_modules/axios/lib/core/transformData.js ***!
  \******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });
  return data;
};

/***/ }),

/***/ "./node_modules/axios/lib/defaults.js":
/*!********************************************!*\
  !*** ./node_modules/axios/lib/defaults.js ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "./node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__(/*! ./helpers/normalizeHeaderName */ "./node_modules/axios/lib/helpers/normalizeHeaderName.js");
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};
function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(/*! ./adapters/xhr */ "./node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(/*! ./adapters/http */ "./node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}
var defaults = {
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
module.exports = defaults;

/***/ }),

/***/ "./node_modules/axios/lib/helpers/bind.js":
/*!************************************************!*\
  !*** ./node_modules/axios/lib/helpers/bind.js ***!
  \************************************************/
/***/ ((module) => {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),

/***/ "./node_modules/axios/lib/helpers/buildURL.js":
/*!****************************************************!*\
  !*** ./node_modules/axios/lib/helpers/buildURL.js ***!
  \****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/axios/lib/utils.js");
function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }
      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }
      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });
    serializedParams = parts.join('&');
  }
  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }
  return url;
};

/***/ }),

/***/ "./node_modules/axios/lib/helpers/combineURLs.js":
/*!*******************************************************!*\
  !*** ./node_modules/axios/lib/helpers/combineURLs.js ***!
  \*******************************************************/
/***/ ((module) => {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),

/***/ "./node_modules/axios/lib/helpers/cookies.js":
/*!***************************************************!*\
  !*** ./node_modules/axios/lib/helpers/cookies.js ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/axios/lib/utils.js");
module.exports = utils.isStandardBrowserEnv() ?
// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));
      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }
      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }
      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }
      if (secure === true) {
        cookie.push('secure');
      }
      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :
// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),

/***/ "./node_modules/axios/lib/helpers/isAbsoluteURL.js":
/*!*********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \*********************************************************/
/***/ ((module) => {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/***/ }),

/***/ "./node_modules/axios/lib/helpers/isURLSameOrigin.js":
/*!***********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \***********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/axios/lib/utils.js");
module.exports = utils.isStandardBrowserEnv() ?
// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;
    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :
// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),

/***/ "./node_modules/axios/lib/helpers/normalizeHeaderName.js":
/*!***************************************************************!*\
  !*** ./node_modules/axios/lib/helpers/normalizeHeaderName.js ***!
  \***************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "./node_modules/axios/lib/utils.js");
module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),

/***/ "./node_modules/axios/lib/helpers/parseHeaders.js":
/*!********************************************************!*\
  !*** ./node_modules/axios/lib/helpers/parseHeaders.js ***!
  \********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "./node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;
  if (!headers) {
    return parsed;
  }
  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

/***/ }),

/***/ "./node_modules/axios/lib/helpers/spread.js":
/*!**************************************************!*\
  !*** ./node_modules/axios/lib/helpers/spread.js ***!
  \**************************************************/
/***/ ((module) => {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),

/***/ "./node_modules/axios/lib/utils.js":
/*!*****************************************!*\
  !*** ./node_modules/axios/lib/utils.js ***!
  \*****************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! ./helpers/bind */ "./node_modules/axios/lib/helpers/bind.js");
var isBuffer = __webpack_require__(/*! is-buffer */ "./node_modules/axios/node_modules/is-buffer/index.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }
  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function /* obj1, obj2, obj3, ... */
merge() {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

/***/ }),

/***/ "./node_modules/axios/node_modules/is-buffer/index.js":
/*!************************************************************!*\
  !*** ./node_modules/axios/node_modules/is-buffer/index.js ***!
  \************************************************************/
/***/ ((module) => {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer(obj) {
  return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

/***/ }),

/***/ "./node_modules/call-bind/callBound.js":
/*!*********************************************!*\
  !*** ./node_modules/call-bind/callBound.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(/*! get-intrinsic */ "./node_modules/get-intrinsic/index.js");
var callBind = __webpack_require__(/*! ./ */ "./node_modules/call-bind/index.js");
var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
  var intrinsic = GetIntrinsic(name, !!allowMissing);
  if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
    return callBind(intrinsic);
  }
  return intrinsic;
};

/***/ }),

/***/ "./node_modules/call-bind/index.js":
/*!*****************************************!*\
  !*** ./node_modules/call-bind/index.js ***!
  \*****************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");
var GetIntrinsic = __webpack_require__(/*! get-intrinsic */ "./node_modules/get-intrinsic/index.js");
var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');
if ($defineProperty) {
  try {
    $defineProperty({}, 'a', {
      value: 1
    });
  } catch (e) {
    // IE 8 has a broken defineProperty
    $defineProperty = null;
  }
}
module.exports = function callBind(originalFunction) {
  var func = $reflectApply(bind, $call, arguments);
  if ($gOPD && $defineProperty) {
    var desc = $gOPD(func, 'length');
    if (desc.configurable) {
      // original length, plus the receiver, minus any additional arguments (after the receiver)
      $defineProperty(func, 'length', {
        value: 1 + $max(0, originalFunction.length - (arguments.length - 1))
      });
    }
  }
  return func;
};
var applyBind = function applyBind() {
  return $reflectApply(bind, $apply, arguments);
};
if ($defineProperty) {
  $defineProperty(module.exports, 'apply', {
    value: applyBind
  });
} else {
  module.exports.apply = applyBind;
}

/***/ }),

/***/ "./node_modules/function-bind/implementation.js":
/*!******************************************************!*\
  !*** ./node_modules/function-bind/implementation.js ***!
  \******************************************************/
/***/ ((module) => {

"use strict";


/* eslint no-invalid-this: 1 */
var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr = Object.prototype.toString;
var funcType = '[object Function]';
module.exports = function bind(that) {
  var target = this;
  if (typeof target !== 'function' || toStr.call(target) !== funcType) {
    throw new TypeError(ERROR_MESSAGE + target);
  }
  var args = slice.call(arguments, 1);
  var bound;
  var binder = function () {
    if (this instanceof bound) {
      var result = target.apply(this, args.concat(slice.call(arguments)));
      if (Object(result) === result) {
        return result;
      }
      return this;
    } else {
      return target.apply(that, args.concat(slice.call(arguments)));
    }
  };
  var boundLength = Math.max(0, target.length - args.length);
  var boundArgs = [];
  for (var i = 0; i < boundLength; i++) {
    boundArgs.push('$' + i);
  }
  bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
  if (target.prototype) {
    var Empty = function Empty() {};
    Empty.prototype = target.prototype;
    bound.prototype = new Empty();
    Empty.prototype = null;
  }
  return bound;
};

/***/ }),

/***/ "./node_modules/function-bind/index.js":
/*!*********************************************!*\
  !*** ./node_modules/function-bind/index.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var implementation = __webpack_require__(/*! ./implementation */ "./node_modules/function-bind/implementation.js");
module.exports = Function.prototype.bind || implementation;

/***/ }),

/***/ "./node_modules/get-intrinsic/index.js":
/*!*********************************************!*\
  !*** ./node_modules/get-intrinsic/index.js ***!
  \*********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var undefined;
var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
  try {
    return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
  } catch (e) {}
};
var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
  try {
    $gOPD({}, '');
  } catch (e) {
    $gOPD = null; // this is IE 8, which has a broken gOPD
  }
}

var throwTypeError = function () {
  throw new $TypeError();
};
var ThrowTypeError = $gOPD ? function () {
  try {
    // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
    arguments.callee; // IE 8 does not throw here
    return throwTypeError;
  } catch (calleeThrows) {
    try {
      // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
      return $gOPD(arguments, 'callee').get;
    } catch (gOPDthrows) {
      return throwTypeError;
    }
  }
}() : throwTypeError;
var hasSymbols = __webpack_require__(/*! has-symbols */ "./node_modules/has-symbols/index.js")();
var getProto = Object.getPrototypeOf || function (x) {
  return x.__proto__;
}; // eslint-disable-line no-proto

var needsEval = {};
var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
var INTRINSICS = {
  '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
  '%Array%': Array,
  '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
  '%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
  '%AsyncFromSyncIteratorPrototype%': undefined,
  '%AsyncFunction%': needsEval,
  '%AsyncGenerator%': needsEval,
  '%AsyncGeneratorFunction%': needsEval,
  '%AsyncIteratorPrototype%': needsEval,
  '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
  '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
  '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
  '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
  '%Boolean%': Boolean,
  '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
  '%Date%': Date,
  '%decodeURI%': decodeURI,
  '%decodeURIComponent%': decodeURIComponent,
  '%encodeURI%': encodeURI,
  '%encodeURIComponent%': encodeURIComponent,
  '%Error%': Error,
  '%eval%': eval,
  // eslint-disable-line no-eval
  '%EvalError%': EvalError,
  '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
  '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
  '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
  '%Function%': $Function,
  '%GeneratorFunction%': needsEval,
  '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
  '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
  '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
  '%isFinite%': isFinite,
  '%isNaN%': isNaN,
  '%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
  '%JSON%': typeof JSON === 'object' ? JSON : undefined,
  '%Map%': typeof Map === 'undefined' ? undefined : Map,
  '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
  '%Math%': Math,
  '%Number%': Number,
  '%Object%': Object,
  '%parseFloat%': parseFloat,
  '%parseInt%': parseInt,
  '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
  '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
  '%RangeError%': RangeError,
  '%ReferenceError%': ReferenceError,
  '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
  '%RegExp%': RegExp,
  '%Set%': typeof Set === 'undefined' ? undefined : Set,
  '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
  '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
  '%String%': String,
  '%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
  '%Symbol%': hasSymbols ? Symbol : undefined,
  '%SyntaxError%': $SyntaxError,
  '%ThrowTypeError%': ThrowTypeError,
  '%TypedArray%': TypedArray,
  '%TypeError%': $TypeError,
  '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
  '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
  '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
  '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
  '%URIError%': URIError,
  '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
  '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
  '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
};
try {
  null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
  // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
  var errorProto = getProto(getProto(e));
  INTRINSICS['%Error.prototype%'] = errorProto;
}
var doEval = function doEval(name) {
  var value;
  if (name === '%AsyncFunction%') {
    value = getEvalledConstructor('async function () {}');
  } else if (name === '%GeneratorFunction%') {
    value = getEvalledConstructor('function* () {}');
  } else if (name === '%AsyncGeneratorFunction%') {
    value = getEvalledConstructor('async function* () {}');
  } else if (name === '%AsyncGenerator%') {
    var fn = doEval('%AsyncGeneratorFunction%');
    if (fn) {
      value = fn.prototype;
    }
  } else if (name === '%AsyncIteratorPrototype%') {
    var gen = doEval('%AsyncGenerator%');
    if (gen) {
      value = getProto(gen.prototype);
    }
  }
  INTRINSICS[name] = value;
  return value;
};
var LEGACY_ALIASES = {
  '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
  '%ArrayPrototype%': ['Array', 'prototype'],
  '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
  '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
  '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
  '%ArrayProto_values%': ['Array', 'prototype', 'values'],
  '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
  '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
  '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
  '%BooleanPrototype%': ['Boolean', 'prototype'],
  '%DataViewPrototype%': ['DataView', 'prototype'],
  '%DatePrototype%': ['Date', 'prototype'],
  '%ErrorPrototype%': ['Error', 'prototype'],
  '%EvalErrorPrototype%': ['EvalError', 'prototype'],
  '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
  '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
  '%FunctionPrototype%': ['Function', 'prototype'],
  '%Generator%': ['GeneratorFunction', 'prototype'],
  '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
  '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
  '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
  '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
  '%JSONParse%': ['JSON', 'parse'],
  '%JSONStringify%': ['JSON', 'stringify'],
  '%MapPrototype%': ['Map', 'prototype'],
  '%NumberPrototype%': ['Number', 'prototype'],
  '%ObjectPrototype%': ['Object', 'prototype'],
  '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
  '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
  '%PromisePrototype%': ['Promise', 'prototype'],
  '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
  '%Promise_all%': ['Promise', 'all'],
  '%Promise_reject%': ['Promise', 'reject'],
  '%Promise_resolve%': ['Promise', 'resolve'],
  '%RangeErrorPrototype%': ['RangeError', 'prototype'],
  '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
  '%RegExpPrototype%': ['RegExp', 'prototype'],
  '%SetPrototype%': ['Set', 'prototype'],
  '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
  '%StringPrototype%': ['String', 'prototype'],
  '%SymbolPrototype%': ['Symbol', 'prototype'],
  '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
  '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
  '%TypeErrorPrototype%': ['TypeError', 'prototype'],
  '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
  '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
  '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
  '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
  '%URIErrorPrototype%': ['URIError', 'prototype'],
  '%WeakMapPrototype%': ['WeakMap', 'prototype'],
  '%WeakSetPrototype%': ['WeakSet', 'prototype']
};
var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");
var hasOwn = __webpack_require__(/*! has */ "./node_modules/has/src/index.js");
var $concat = bind.call(Function.call, Array.prototype.concat);
var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
var $replace = bind.call(Function.call, String.prototype.replace);
var $strSlice = bind.call(Function.call, String.prototype.slice);
var $exec = bind.call(Function.call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
  var first = $strSlice(string, 0, 1);
  var last = $strSlice(string, -1);
  if (first === '%' && last !== '%') {
    throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
  } else if (last === '%' && first !== '%') {
    throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
  }
  var result = [];
  $replace(string, rePropName, function (match, number, quote, subString) {
    result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
  });
  return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
  var intrinsicName = name;
  var alias;
  if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
    alias = LEGACY_ALIASES[intrinsicName];
    intrinsicName = '%' + alias[0] + '%';
  }
  if (hasOwn(INTRINSICS, intrinsicName)) {
    var value = INTRINSICS[intrinsicName];
    if (value === needsEval) {
      value = doEval(intrinsicName);
    }
    if (typeof value === 'undefined' && !allowMissing) {
      throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
    }
    return {
      alias: alias,
      name: intrinsicName,
      value: value
    };
  }
  throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
  if (typeof name !== 'string' || name.length === 0) {
    throw new $TypeError('intrinsic name must be a non-empty string');
  }
  if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
    throw new $TypeError('"allowMissing" argument must be a boolean');
  }
  if ($exec(/^%?[^%]*%?$/, name) === null) {
    throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
  }
  var parts = stringToPath(name);
  var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
  var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
  var intrinsicRealName = intrinsic.name;
  var value = intrinsic.value;
  var skipFurtherCaching = false;
  var alias = intrinsic.alias;
  if (alias) {
    intrinsicBaseName = alias[0];
    $spliceApply(parts, $concat([0, 1], alias));
  }
  for (var i = 1, isOwn = true; i < parts.length; i += 1) {
    var part = parts[i];
    var first = $strSlice(part, 0, 1);
    var last = $strSlice(part, -1);
    if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
      throw new $SyntaxError('property names with quotes must have matching quotes');
    }
    if (part === 'constructor' || !isOwn) {
      skipFurtherCaching = true;
    }
    intrinsicBaseName += '.' + part;
    intrinsicRealName = '%' + intrinsicBaseName + '%';
    if (hasOwn(INTRINSICS, intrinsicRealName)) {
      value = INTRINSICS[intrinsicRealName];
    } else if (value != null) {
      if (!(part in value)) {
        if (!allowMissing) {
          throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
        }
        return void undefined;
      }
      if ($gOPD && i + 1 >= parts.length) {
        var desc = $gOPD(value, part);
        isOwn = !!desc;

        // By convention, when a data property is converted to an accessor
        // property to emulate a data property that does not suffer from
        // the override mistake, that accessor's getter is marked with
        // an `originalValue` property. Here, when we detect this, we
        // uphold the illusion by pretending to see that original data
        // property, i.e., returning the value rather than the getter
        // itself.
        if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
          value = desc.get;
        } else {
          value = value[part];
        }
      } else {
        isOwn = hasOwn(value, part);
        value = value[part];
      }
      if (isOwn && !skipFurtherCaching) {
        INTRINSICS[intrinsicRealName] = value;
      }
    }
  }
  return value;
};

/***/ }),

/***/ "./node_modules/has-symbols/index.js":
/*!*******************************************!*\
  !*** ./node_modules/has-symbols/index.js ***!
  \*******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(/*! ./shams */ "./node_modules/has-symbols/shams.js");
module.exports = function hasNativeSymbols() {
  if (typeof origSymbol !== 'function') {
    return false;
  }
  if (typeof Symbol !== 'function') {
    return false;
  }
  if (typeof origSymbol('foo') !== 'symbol') {
    return false;
  }
  if (typeof Symbol('bar') !== 'symbol') {
    return false;
  }
  return hasSymbolSham();
};

/***/ }),

/***/ "./node_modules/has-symbols/shams.js":
/*!*******************************************!*\
  !*** ./node_modules/has-symbols/shams.js ***!
  \*******************************************/
/***/ ((module) => {

"use strict";


/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
  if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
    return false;
  }
  if (typeof Symbol.iterator === 'symbol') {
    return true;
  }
  var obj = {};
  var sym = Symbol('test');
  var symObj = Object(sym);
  if (typeof sym === 'string') {
    return false;
  }
  if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
    return false;
  }
  if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
    return false;
  }

  // temp disabled per https://github.com/ljharb/object.assign/issues/17
  // if (sym instanceof Symbol) { return false; }
  // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
  // if (!(symObj instanceof Symbol)) { return false; }

  // if (typeof Symbol.prototype.toString !== 'function') { return false; }
  // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

  var symVal = 42;
  obj[sym] = symVal;
  for (sym in obj) {
    return false;
  } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
  if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
    return false;
  }
  if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
    return false;
  }
  var syms = Object.getOwnPropertySymbols(obj);
  if (syms.length !== 1 || syms[0] !== sym) {
    return false;
  }
  if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
    return false;
  }
  if (typeof Object.getOwnPropertyDescriptor === 'function') {
    var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
    if (descriptor.value !== symVal || descriptor.enumerable !== true) {
      return false;
    }
  }
  return true;
};

/***/ }),

/***/ "./node_modules/has/src/index.js":
/*!***************************************!*\
  !*** ./node_modules/has/src/index.js ***!
  \***************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! function-bind */ "./node_modules/function-bind/index.js");
module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);

/***/ }),

/***/ "./node_modules/lodash/lodash.js":
/*!***************************************!*\
  !*** ./node_modules/lodash/lodash.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */;(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined;/** Used as the semantic version number. */var VERSION='4.17.21';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',FUNC_ERROR_TEXT='Expected a function',INVALID_TEMPL_VAR_ERROR_TEXT='Invalid `variable` option passed into `_.template`';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** Used to compose bitmasks for value comparisons. */var COMPARE_PARTIAL_FLAG=1,COMPARE_UNORDERED_FLAG=2;/** Used to compose bitmasks for function metadata. */var WRAP_BIND_FLAG=1,WRAP_BIND_KEY_FLAG=2,WRAP_CURRY_BOUND_FLAG=4,WRAP_CURRY_FLAG=8,WRAP_CURRY_RIGHT_FLAG=16,WRAP_PARTIAL_FLAG=32,WRAP_PARTIAL_RIGHT_FLAG=64,WRAP_ARY_FLAG=128,WRAP_REARG_FLAG=256,WRAP_FLIP_FLAG=512;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',WRAP_ARY_FLAG],['bind',WRAP_BIND_FLAG],['bindKey',WRAP_BIND_KEY_FLAG],['curry',WRAP_CURRY_FLAG],['curryRight',WRAP_CURRY_RIGHT_FLAG],['flip',WRAP_FLIP_FLAG],['partial',WRAP_PARTIAL_FLAG],['partialRight',WRAP_PARTIAL_RIGHT_FLAG],['rearg',WRAP_REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',asyncTag='[object AsyncFunction]',boolTag='[object Boolean]',dateTag='[object Date]',domExcTag='[object DOMException]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',nullTag='[object Null]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',undefinedTag='[object Undefined]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading whitespace. */var reTrimStart=/^\s+/;/** Used to match a single whitespace character. */var reWhitespace=/\s/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */var reForbiddenIdentifierChars=/[()=,{}\[\]\/\s]/;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange='\\ud800-\\udfff',rsComboMarksRange='\\u0300-\\u036f',reComboHalfMarksRange='\\ufe20-\\ufe2f',rsComboSymbolsRange='\\u20d0-\\u20ff',rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,rsDingbatRange='\\u2700-\\u27bf',rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange='\\u2000-\\u206f',rsSpaceRange=' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange='\\ufe0e\\ufe0f',rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos="['\u2019]",rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz='\\ud83c[\\udffb-\\udfff]',rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional='(?:\\ud83c[\\udde6-\\uddff]){2}',rsSurrPair='[\\ud800-\\udbff][\\udc00-\\udfff]',rsUpper='['+rsUpperRange+']',rsZWJ='\\u200d';/** Used to compose unicode regexes. */var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsOrdLower='\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',rsOrdUpper='\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,rsUpper+'+'+rsOptContrUpper,rsOrdUpper,rsOrdLower,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
'\u0100':'A','\u0102':'A','\u0104':'A','\u0101':'a','\u0103':'a','\u0105':'a','\u0106':'C','\u0108':'C','\u010a':'C','\u010c':'C','\u0107':'c','\u0109':'c','\u010b':'c','\u010d':'c','\u010e':'D','\u0110':'D','\u010f':'d','\u0111':'d','\u0112':'E','\u0114':'E','\u0116':'E','\u0118':'E','\u011a':'E','\u0113':'e','\u0115':'e','\u0117':'e','\u0119':'e','\u011b':'e','\u011c':'G','\u011e':'G','\u0120':'G','\u0122':'G','\u011d':'g','\u011f':'g','\u0121':'g','\u0123':'g','\u0124':'H','\u0126':'H','\u0125':'h','\u0127':'h','\u0128':'I','\u012a':'I','\u012c':'I','\u012e':'I','\u0130':'I','\u0129':'i','\u012b':'i','\u012d':'i','\u012f':'i','\u0131':'i','\u0134':'J','\u0135':'j','\u0136':'K','\u0137':'k','\u0138':'k','\u0139':'L','\u013b':'L','\u013d':'L','\u013f':'L','\u0141':'L','\u013a':'l','\u013c':'l','\u013e':'l','\u0140':'l','\u0142':'l','\u0143':'N','\u0145':'N','\u0147':'N','\u014a':'N','\u0144':'n','\u0146':'n','\u0148':'n','\u014b':'n','\u014c':'O','\u014e':'O','\u0150':'O','\u014d':'o','\u014f':'o','\u0151':'o','\u0154':'R','\u0156':'R','\u0158':'R','\u0155':'r','\u0157':'r','\u0159':'r','\u015a':'S','\u015c':'S','\u015e':'S','\u0160':'S','\u015b':'s','\u015d':'s','\u015f':'s','\u0161':'s','\u0162':'T','\u0164':'T','\u0166':'T','\u0163':'t','\u0165':'t','\u0167':'t','\u0168':'U','\u016a':'U','\u016c':'U','\u016e':'U','\u0170':'U','\u0172':'U','\u0169':'u','\u016b':'u','\u016d':'u','\u016f':'u','\u0171':'u','\u0173':'u','\u0174':'W','\u0175':'w','\u0176':'Y','\u0177':'y','\u0178':'Y','\u0179':'Z','\u017b':'Z','\u017d':'Z','\u017a':'z','\u017c':'z','\u017e':'z','\u0132':'IJ','\u0133':'ij','\u0152':'Oe','\u0153':'oe','\u0149':"'n",'\u017f':'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r','\u2028':'u2028','\u2029':'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=typeof __webpack_require__.g=='object'&&__webpack_require__.g&&__webpack_require__.g.Object===Object&&__webpack_require__.g;/** Detect free variable `self`. */var freeSelf=typeof self=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports= true&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&"object"=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{// Use `util.types` for Node.js 10+.
var types=freeModule&&freeModule.require&&freeModule.require('util').types;if(types){return types;}// Legacy `process.binding('util')` for Node.js < 10.
return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array==null?0:array.length;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEachRight(array,iteratee){var length=array==null?0:array.length;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */function arrayEvery(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludes(array,value){var length=array==null?0:array.length;return!!length&&baseIndexOf(array,value,0)>-1;}/**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array==null?0:array.length;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array==null?0:array.length;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array==null?0:array.length;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */function arraySome(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */var asciiSize=baseProperty('length');/**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function asciiToArray(string){return string.split('');}/**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return-1;}/**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return-1;}/**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */function baseIsNaN(value){return value!==value;}/**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */function baseMean(array,iteratee){var length=array==null?0:array.length;return length?baseSum(array,iteratee)/length:NAN;}/**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */function baseProperty(key){return function(object){return object==null?undefined:object[key];};}/**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */function basePropertyOf(object){return function(key){return object==null?undefined:object[key];};}/**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined){result=result===undefined?current:result+current;}}return result;}/**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */function baseToPairs(object,props){return arrayMap(props,function(key){return[key,object[key]];});}/**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */function baseTrim(string){return string?string.slice(0,trimmedEndIndex(string)+1).replace(reTrimStart,''):string;}/**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */function baseUnary(func){return function(value){return func(value);};}/**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */function cacheHas(cache,key){return cache.has(key);}/**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */var deburrLetter=basePropertyOf(deburredLetters);/**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */function escapeStringChar(chr){return'\\'+stringEscapes[chr];}/**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */function getValue(object,key){return object==null?undefined:object[key];}/**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */function hasUnicode(string){return reHasUnicode.test(string);}/**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return-1;}/**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */function trimmedEndIndex(string){var index=string.length;while(index--&&reWhitespace.test(string.charAt(index))){}return index;}/**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */var runInContext=function runInContext(context){context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */var nativeObjectToString=objectProto.toString;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined,Symbol=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=Symbol?Symbol.isConcatSpreadable:undefined,symIterator=Symbol?Symbol.iterator:undefined,symToStringTag=Symbol?Symbol.toStringTag:undefined;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=Symbol?Symbol.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();/**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */function baseLodash(){// No operation performed.
}/**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined;}/**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */lodash.templateSettings={/**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'escape':reEscape,/**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'evaluate':reEvaluate,/**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'interpolate':reInterpolate,/**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */'variable':'',/**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */'imports':{/**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else{result=this.clone();result.__dir__*=-1;}return result;}/**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||!isRight&&arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else{break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}/**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}/**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */function listCacheClear(){this.__data__=[];this.size=0;}/**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}/**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}/**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}// Add methods to `ListCache`.
ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */function SetCache(values){var index=-1,length=values==null?0:values.length;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function stackGet(key){return this.__data__.get(key);}/**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function stackHas(key){return this.__data__.has(key);}/**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
isIndex(key,length)))){result.push(key);}}return result;}/**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined;}/**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}/**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}/**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else{object[key]=value;}}/**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */function baseAt(object,paths){var index=-1,length=paths.length,result=Array(length),skip=object==null;while(++index<length){result[index]=skip?undefined:get(object,paths[index]);}return result;}/**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined){number=number<=upper?number:upper;}if(lower!==undefined){number=number>=lower?number:lower;}}return number;}/**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,isDeep);}}// Check for circular references and return its corresponding clone.
stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(isSet(value)){value.forEach(function(subValue){result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));});}else if(isMap(value)){value.forEach(function(subValue,key){result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));});}var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}/**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return!length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined&&!(key in object)||!predicate(value)){return false;}}return true;}/**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined,args);},wait);}/**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee==null?value:iteratee(value);value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEach=createBaseEach(baseForOwn);/**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
baseFlatten(value,depth-1,predicate,isStrict,result);}else{arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseFor=createBaseFor();/**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseForRight=createBaseFor(true);/**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */function baseGet(object,path){path=castPath(path,object);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined;}/**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */function baseGetTag(value){if(value==null){return value===undefined?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}/**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */function baseGt(value,other){return value>other;}/**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */function baseInvoke(object,path,args){path=castPath(path,object);object=parent(object,path);var func=object==null?object:object[toKey(last(path))];return func==null?undefined:apply(func,object,args);}/**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}/**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */function baseIsArrayBuffer(value){return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;}/**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */function baseIsDate(value){return isObjectLike(value)&&baseGetTag(value)==dateTag;}/**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */function baseIsEqual(value,other,bitmask,customizer,stack){if(value===other){return true;}if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);}/**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=objIsArr?arrayTag:getTag(object),othTag=othIsArr?arrayTag:getTag(other);objTag=objTag==argsTag?objectTag:objTag;othTag=othTag==argsTag?objectTag:othTag;var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,bitmask,customizer,equalFunc,stack):equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);}if(!(bitmask&COMPARE_PARTIAL_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,bitmask,customizer,equalFunc,stack);}/**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return!length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined&&!(key in object)){return false;}}else{var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined?baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):result)){return false;}}}return true;}/**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */function baseIsRegExp(value){return isObjectLike(value)&&baseGetTag(value)==regexpTag;}/**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}/**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
if(typeof value=='function'){return value;}if(value==null){return identity;}if(typeof value=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */function baseLt(value,other){return value<other;}/**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);};}/**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){stack||(stack=new Stack());if(isObject(srcValue)){baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(safeGet(object,key),srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=safeGet(object,key),srcValue=safeGet(source,key),stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined;}/**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */function baseOrderBy(collection,iteratees,orders){if(iteratees.length){iteratees=arrayMap(iteratees,function(iteratee){if(isArray(iteratee)){return function(value){return baseGet(value,iteratee.length===1?iteratee[0]:iteratee);};}return iteratee;});}else{iteratees=[identity];}var index=-1;iteratees=arrayMap(iteratees,baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return{'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */function basePick(object,paths){return basePickBy(object,paths,function(value,path){return hasIn(object,path);});}/**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */function basePickBy(object,paths,predicate){var index=-1,length=paths.length,result={};while(++index<length){var path=paths[index],value=baseGet(object,path);if(predicate(value,path)){baseSet(result,castPath(path,object),value);}}return result;}/**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else{baseUnset(array,index);}}}return array;}/**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */function baseSample(collection){return arraySample(values(collection));}/**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=castPath(path,object);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(key==='__proto__'||key==='constructor'||key==='prototype'){return object;}if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined;if(newValue===undefined){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};/**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return!result;});return!!result;}/**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndex(array,value,retHighest){var low=0,high=array==null?low:array.length;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else{high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndexBy(array,value,iteratee,retHighest){var low=0,high=array==null?0:array.length;if(high===0){return 0;}value=iteratee(value);var valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else{setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else{high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return+value;}/**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else{seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */function baseUnset(object,path){path=castPath(path,object);object=parent(object,path);return object==null||delete object[toKey(last(path))];}/**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */function baseXor(arrays,iteratee,comparator){var length=arrays.length;if(length<2){return length?baseUniq(arrays[0]):[];}var index=-1,result=Array(length);while(++index<length){var array=arrays[index],othIndex=-1;while(++othIndex<length){if(othIndex!=index){result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);}}}return baseUniq(baseFlatten(result,1),iteratee,comparator);}/**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined;assignFunc(result,props[index],value);}return result;}/**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */function castFunction(value){return typeof value=='function'?value:identity;}/**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */function castPath(value,object){if(isArray(value)){return value;}return isKey(value,object)?[value]:stringToPath(toString(value));}/**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */var castRest=baseRest;/**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */function castSlice(array,start,end){var length=array.length;end=end===undefined?length:end;return!start&&end>=length?array:baseSlice(array,start,end);}/**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return-1;}}return 0;}/**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
// that causes it, under certain circumstances, to provide the same value for
// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
// for more details.
//
// This also ensures a stable sort in V8 and other engines.
// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
return object.index-other.index;}/**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}/**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}/**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createBind(func,bitmask,thisArg){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
// for more details.
var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
// See https://es5.github.io/#x13.2.2 for more details.
return isObject(result)?result:thisBinding;};}/**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined,args,holders,undefined,undefined,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined;};}/**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined;if(data&&isLaziable(data[0])&&data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else{wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&WRAP_ARY_FLAG,isBind=bitmask&WRAP_BIND_FLAG,isBindKey=bitmask&WRAP_BIND_KEY_FLAG,isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),isFlip=bitmask&WRAP_FLIP_FLAG,Ctor=isBindKey?undefined:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined&&other===undefined){return defaultValue;}if(value!==undefined){result=value;}if(other!==undefined){if(result===undefined){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else{value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */function createPadding(length,chars){chars=chars===undefined?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined;}// Ensure the sign of `-0` is preserved.
start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}step=step===undefined?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&WRAP_CURRY_FLAG,newHolders=isCurry?holders:undefined,newHoldersRight=isCurry?undefined:holders,newPartials=isCurry?partials:undefined,newPartialsRight=isCurry?undefined:partials;bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=precision==null?0:nativeMin(toInteger(precision),292);if(precision&&nativeIsFinite(number)){// Shift with exponential notation to avoid floating-point issues.
// See [MDN](https://mdn.io/round#Examples) for more details.
var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return+(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);partials=holders=undefined;}ary=ary===undefined?ary:nativeMax(toInteger(ary),0);arity=arity===undefined?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined;}var data=isBindKey?undefined:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]===undefined?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==WRAP_BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else{result=createHybrid.apply(undefined,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */function customDefaultsAssignIn(objValue,srcValue,key,object){if(objValue===undefined||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */function customDefaultsMerge(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined,customDefaultsMerge,stack);stack['delete'](srcValue);}return objValue;}/**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */function customOmitClone(value){return isPlainObject(value)?undefined:value;}/**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */function equalArrays(array,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Check that cyclic values are equal.
var arrStacked=stack.get(array);var othStacked=stack.get(other);if(arrStacked&&othStacked){return arrStacked==other&&othStacked==array;}var index=-1,result=true,seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
// Invalid dates are coerced to `NaN`.
return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
// for more details.
return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&COMPARE_PARTIAL_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=COMPARE_UNORDERED_FLAG;// Recursively compare objects (susceptible to call stack limits).
stack.set(object,other);var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalObjects(object,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,objProps=getAllKeys(object),objLength=objProps.length,othProps=getAllKeys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Check that cyclic values are equal.
var objStacked=stack.get(object);var othStacked=stack.get(other);if(objStacked&&othStacked){return objStacked==other&&othStacked==object;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
if(!(compared===undefined?objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */function flatRest(func){return setToString(overRest(func,undefined,flatten),func+'');}/**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}/**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else{delete value[symToStringTag];}}return result;}/**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return[];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};/**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return{'start':start,'end':end};}/**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */function hasPath(object,path,hasFunc){path=castPath(path,object);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object==null?0:object.length;return!!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */function initCloneArray(array){var length=array.length,result=new array.constructor(length);// Add properties assigned by `RegExp#exec`.
if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return new Ctor();case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return new Ctor();case symbolTag:return cloneSymbol(object);}}/**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */function isIndex(value,length){var type=typeof value;length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(type=='number'||type!='symbol'&&reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=typeof index;if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */function isKey(value,object){if(isArray(value)){return false;}var type=typeof value;if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */function isKeyable(value){var type=typeof value;return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return!!data&&func===data[0];}/**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}/**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */var isMaskable=coreJsData?isFunction:stubFalse;/**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined||key in Object(object));};}/**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);var isCombo=srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;// Exit early if metadata can't be merged.
if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
if(srcBitmask&WRAP_BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;}// Compose partial arguments.
var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
if(srcBitmask&WRAP_ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
data[0]=source[0];data[1]=newBitmask;return data;}/**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */function objectToString(value){return nativeObjectToString.call(value);}/**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */function parent(object,path){return path.length<2?object:baseGet(object,baseSlice(path,0,-1));}/**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined;}return array;}/**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */function safeGet(object,key){if(key==='constructor'&&typeof object[key]==='function'){return;}if(key=='__proto__'){return;}return object[key];}/**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var setData=shortOut(baseSetData);/**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */var setToString=shortOut(baseSetToString);/**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}/**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */var stringToPath=memoizeCapped(function(string){var result=[];if(string.charCodeAt(0)===46/* . */){result.push('');}string.replace(rePropName,function(match,number,quote,subString){result.push(quote?subString.replace(reEscapeChar,'$1'):number||match);});return result;});/**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}/**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined){size=1;}else{size=nativeMax(toInteger(size),0);}var length=array==null?0:array.length;if(!length||size<1){return[];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */function compact(array){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */function concat(){var length=arguments.length;if(!length){return[];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined,comparator):[];});/**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function drop(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function dropRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */function fill(array,value,start,end){var length=array==null?0:array.length;if(!length){return[];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */function findIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */function findLastIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length-1;if(fromIndex!==undefined){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */function flatten(array){var length=array==null?0:array.length;return length?baseFlatten(array,1):[];}/**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */function flattenDeep(array){var length=array==null?0:array.length;return length?baseFlatten(array,INFINITY):[];}/**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */function flattenDepth(array,depth){var length=array==null?0:array.length;if(!length){return[];}depth=depth===undefined?1:toInteger(depth);return baseFlatten(array,depth);}/**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */function fromPairs(pairs){var index=-1,length=pairs==null?0:pairs.length,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */function head(array){return array&&array.length?array[0]:undefined;}/**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */function indexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */function initial(array){var length=array==null?0:array.length;return length?baseSlice(array,0,-1):[];}/**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);comparator=typeof comparator=='function'?comparator:undefined;if(comparator){mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined,comparator):[];});/**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */function join(array,separator){return array==null?'':nativeJoin.call(array,separator);}/**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */function last(array){var length=array==null?0:array.length;return length?array[length-1]:undefined;}/**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */function lastIndexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length;if(fromIndex!==undefined){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined;}/**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */var pull=baseRest(pullAll);/**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined,comparator):array;}/**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */var pullAt=flatRest(function(array,indexes){var length=array==null?0:array.length,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function reverse(array){return array==null?array:nativeReverse.call(array);}/**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function slice(array,start,end){var length=array==null?0:array.length;if(!length){return[];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else{start=start==null?0:toInteger(start);end=end===undefined?length:toInteger(end);}return baseSlice(array,start,end);}/**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */function sortedIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return-1;}/**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */function sortedLastIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return-1;}/**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */function tail(array){var length=array==null?0:array.length;return length?baseSlice(array,1,length):[];}/**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */function take(array,n,guard){if(!(array&&array.length)){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */function takeRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined,comparator);});/**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */function uniqWith(array,comparator){comparator=typeof comparator=='function'?comparator:undefined;return array&&array.length?baseUniq(array,undefined,comparator):[];}/**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */function unzip(array){if(!(array&&array.length)){return[];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */function unzipWith(array,iteratee){if(!(array&&array.length)){return[];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined,group);});}/**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined,comparator);});/**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */var zip=baseRest(unzip);/**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */function tap(value,interceptor){interceptor(value);return value;}/**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */function thru(value,interceptor){return interceptor(value);}/**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined);}return array;});});/**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */function wrapperChain(){return chain(this);}/**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */function wrapperNext(){if(this.__values__===undefined){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined:this.__values__[this.__index__++];return{'done':done,'value':value};}/**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */function wrapperToIterator(){return this;}/**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined;if(result){previous.__wrapped__=clone;}else{result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else{baseAssignValue(result,key,1);}});/**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */var find=createFind(findIndex);/**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */var findLast=createFind(findLastIndex);/**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else{baseAssignValue(result,key,[value]);}});/**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);});return result;});/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return[];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return[[],[]];});/**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined){n=1;}else{n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return[];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */function ary(func,n,guard){n=guard?undefined:n;n=func&&n==null?func.length:n;return createWrap(func,WRAP_ARY_FLAG,undefined,undefined,undefined,undefined,n);}/**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined;}return result;};}/**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */var bind=baseRest(function(func,thisArg,partials){var bitmask=WRAP_BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */var bindKey=baseRest(function(object,key,partials){var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */function curry(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curry.placeholder;return result;}/**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */function curryRight(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curryRight.placeholder;return result;}/**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
lastInvokeTime=time;// Start the timer for the trailing edge.
timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,timeWaiting=wait-timeSinceLastCall;return maxing?nativeMin(timeWaiting,maxWait-timeSinceLastInvoke):timeWaiting;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
// trailing edge, the system time has gone backwards and we're treating
// it as the trailing edge, or we've hit the `maxWait` limit.
return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
// debounced at least once.
if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
clearTimeout(timerId);timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */function flip(func){return createWrap(func,WRAP_FLIP_FLAG);}/**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */function memoize(func,resolver){if(typeof func!='function'||resolver!=null&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
memoize.Cache=MapCache;/**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return!predicate.call(this);case 1:return!predicate.call(this,args[0]);case 2:return!predicate.call(this,args[0],args[1]);case 3:return!predicate.call(this,args[0],args[1],args[2]);}return!predicate.apply(this,args);};}/**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */function once(func){return before(2,func);}/**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,WRAP_PARTIAL_FLAG,undefined,partials,holders);});/**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined,partials,holders);});/**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */var rearg=flatRest(function(func,indexes){return createWrap(func,WRAP_REARG_FLAG,undefined,undefined,undefined,indexes);});/**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?start:toInteger(start);return baseRest(func,start);}/**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start==null?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */function unary(func){return ary(func,1);}/**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */function wrap(value,wrapper){return partial(castFunction(wrapper),value);}/*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */function castArray(){if(!arguments.length){return[];}var value=arguments[0];return isArray(value)?value:[value];}/**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */function clone(value){return baseClone(value,CLONE_SYMBOLS_FLAG);}/**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */function cloneWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);}/**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}/**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */function cloneDeepWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);}/**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */var gt=createRelationalOperation(baseGt);/**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */var isArray=Array.isArray;/**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&baseGetTag(value)==boolTag;}/**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */var isBuffer=nativeIsBuffer||stubFalse;/**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */function isElement(value){return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);}/**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */function isEmpty(value){if(value==null){return true;}if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return!value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return!value.size;}if(isPrototype(value)){return!baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */function isEqual(value,other){return baseIsEqual(value,other);}/**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined;var result=customizer?customizer(value,other):undefined;return result===undefined?baseIsEqual(value,other,undefined,customizer):!!result;}/**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */function isError(value){if(!isObjectLike(value)){return false;}var tag=baseGetTag(value);return tag==errorTag||tag==domExcTag||typeof value.message=='string'&&typeof value.name=='string'&&!isPlainObject(value);}/**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
// in Safari 9 which returns 'object' for typed arrays and other constructors.
var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}/**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */function isObject(value){var type=typeof value;return value!=null&&(type=='object'||type=='function');}/**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */function isObjectLike(value){return value!=null&&typeof value=='object';}/**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
// Perform the `toStringTag` check first to avoid errors with some
// ActiveX objects in IE.
return isNumber(value)&&value!=+value;}/**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */function isNull(value){return value===null;}/**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */function isNil(value){return value==null;}/**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&baseGetTag(value)==numberTag;}/**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}/**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */function isSymbol(value){return typeof value=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}/**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */function isUndefined(value){return value===undefined;}/**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */function isWeakSet(value){return isObjectLike(value)&&baseGetTag(value)==weakSetTag;}/**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */var lt=createRelationalOperation(baseLt);/**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */function toArray(value){if(!value){return[];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(symIterator&&value[symIterator]){return iteratorToArray(value[symIterator]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=baseTrim(value);var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */function toSafeInteger(value){return value?baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):value===0?value:0;}/**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */var at=flatRest(baseAt);/**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */function create(prototype,properties){var result=baseCreate(prototype);return properties==null?result:baseAssign(result,properties);}/**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var defaults=baseRest(function(object,sources){object=Object(object);var index=-1;var length=sources.length;var guard=length>2?sources[2]:undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){length=1;}while(++index<length){var source=sources[index];var props=keysIn(source);var propsIndex=-1;var propsLength=props.length;while(++propsIndex<propsLength){var key=props[propsIndex];var value=object[key];if(value===undefined||eq(value,objectProto[key])&&!hasOwnProperty.call(object,key)){object[key]=source[key];}}}return object;});/**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */var defaultsDeep=baseRest(function(args){args.push(undefined,customDefaultsMerge);return apply(mergeWith,undefined,args);});/**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */function get(object,path,defaultValue){var result=object==null?undefined:baseGet(object,path);return result===undefined?defaultValue:result;}/**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */var invert=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}result[value]=key;},constant(identity));/**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */var invertBy=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}if(hasOwnProperty.call(result,value)){result[value].push(key);}else{result[value]=[key];}},getIteratee);/**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */var invoke=baseRest(baseInvoke);/**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */var omit=flatRest(function(object,paths){var result={};if(object==null){return result;}var isDeep=false;paths=arrayMap(paths,function(path){path=castPath(path,object);isDeep||(isDeep=path.length>1);return path;});copyObject(object,getAllKeysIn(object),result);if(isDeep){result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);}var length=paths.length;while(length--){baseUnset(result,paths[length]);}return result;});/**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */var pick=flatRest(function(object,paths){return object==null?{}:basePick(object,paths);});/**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */function pickBy(object,predicate){if(object==null){return{};}var props=arrayMap(getAllKeysIn(object),function(prop){return[prop];});predicate=getIteratee(predicate);return basePickBy(object,props,function(value,path){return predicate(value,path[0]);});}/**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */function result(object,path,defaultValue){path=castPath(path,object);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
if(!length){length=1;object=undefined;}while(++index<length){var value=object==null?undefined:object[toKey(path[index])];if(value===undefined){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseSet(object,path,value,customizer);}/**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */var toPairs=createToPairs(keys);/**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */var toPairsIn=createToPairs(keysIn);/**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else{accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */function values(object){return object==null?[]:baseValues(object,keys(object));}/**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */function clamp(number,lower,upper){if(upper===undefined){upper=lower;lower=undefined;}if(upper!==undefined){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */function inRange(number,start,end){start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined;}if(floating===undefined){if(typeof upper=='boolean'){floating=upper;upper=undefined;}else if(typeof lower=='boolean'){floating=lower;lower=undefined;}}if(lower===undefined&&upper===undefined){lower=0;upper=1;}else{lower=toFinite(lower);if(upper===undefined){upper=lower;lower=0;}else{upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */var lowerFirst=createCaseFirst('toLowerCase');/**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined){n=1;}else{n=toInteger(n);}return baseRepeat(toString(string),n);}/**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined;}limit=limit===undefined?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return[];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */function startsWith(string,target,position){string=toString(string);position=position==null?0:baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
// (http://ejohn.org/blog/javascript-micro-templating/)
// and Laura Doktorova's doT.js (https://github.com/olado/doT).
var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined;}string=toString(string);options=assignInWith({},options,settings,customDefaultsAssignIn);var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
// The sourceURL gets injected into the source that's eval-ed, so be careful
// to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
// and escape the comment, thus injecting code that gets evaled.
var sourceURL='//# sourceURL='+(hasOwnProperty.call(options,'sourceURL')?(options.sourceURL+'').replace(/\s/g,' '):'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
// order to produce the correct `offset` value.
return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
// code to add the data object to the top of the scope chain.
var variable=hasOwnProperty.call(options,'variable')&&options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Throw an error if a forbidden character was found in `variable`, to prevent
// potential command injection attacks.
else if(reForbiddenIdentifierChars.test(variable)){throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);}// Cleanup code by stripping empty strings.
source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined,importsValues);});// Provide the compiled function's source by its `toString` method or
// the `source` property as a convenience for inlining compiled templates.
result.source=source;if(isError(result)){throw result;}return result;}/**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */function toLower(value){return toString(value).toLowerCase();}/**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */function toUpper(value){return toString(value).toUpperCase();}/**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return baseTrim(string);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.slice(0,trimmedEndIndex(string)+1);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */var upperFirst=createCaseFirst('toUpperCase');/**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined:pattern;if(pattern===undefined){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */var attempt=baseRest(function(func,args){try{return apply(func,undefined,args);}catch(e){return isError(e)?e:new Error(e);}});/**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */function cond(pairs){var length=pairs==null?0:pairs.length,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return[toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */function conforms(source){return baseConforms(baseClone(source,CLONE_DEEP_FLAG));}/**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */function constant(value){return function(){return value;};}/**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */var flow=createFlow();/**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */var flowRight=createFlow(true);/**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */function identity(value){return value;}/**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,CLONE_DEEP_FLAG));}/**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */function matches(source){return baseMatches(baseClone(source,CLONE_DEEP_FLAG));}/**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));}/**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */function noop(){// No operation performed.
}/**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */var over=createOver(arrayMap);/**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */var overEvery=createOver(arrayEvery);/**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */var overSome=createOver(arraySome);/**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */function propertyOf(object){return function(path){return object==null?undefined:baseGet(object,path);};}/**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */var range=createRange();/**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */var rangeRight=createRange(true);/**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */function stubArray(){return[];}/**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */function stubFalse(){return false;}/**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */function stubObject(){return{};}/**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */function stubString(){return'';}/**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */function stubTrue(){return true;}/**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return[];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));}/**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */var ceil=createRound('ceil');/**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */var floor=createRound('floor');/**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined;}/**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined;}/**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */function mean(array){return baseMean(array,identity);}/**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined;}/**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined;}/**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */var round=createRound('round');/**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
mixin(lodash,lodash);/*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */lodash.VERSION=VERSION;// Assign default placeholders.
arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){n=n===undefined?1:nativeMax(toInteger(n),0);var result=this.__filtered__&&!index?new LazyWrapper(this):this.clone();if(result.__filtered__){result.__takeCount__=nativeMin(n,result.__takeCount__);}else{result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'';if(!hasOwnProperty.call(realNames,key)){realNames[key]=[];}realNames[key].push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined,WRAP_BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined}];// Add methods to `LazyWrapper`.
LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
lodash.prototype.first=lodash.prototype.head;if(symIterator){lodash.prototype[symIterator]=wrapperToIterator;}return lodash;};/*--------------------------------------------------------------------------*/ // Export lodash.
var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
if(true){// Expose Lodash on the global object to prevent errors when Lodash is
// loaded by a script tag in the presence of an AMD loader.
// See http://requirejs.org/docs/errors.html#mismatch for more details.
// Use `_.noConflict` to remove Lodash from the global object.
root._=_;// Define as an anonymous module so, through path mapping, it can be
// referenced as the "underscore" module.
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return _;}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// Check for `exports` after `define` in case a build optimizer adds it.
else {}}).call(this);

/***/ }),

/***/ "./node_modules/object-inspect/index.js":
/*!**********************************************!*\
  !*** ./node_modules/object-inspect/index.js ***!
  \**********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;
var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
? function (O) {
  return O.__proto__; // eslint-disable-line no-proto
} : null);
function addNumericSeparator(num, str) {
  if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) {
    return str;
  }
  var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
  if (typeof num === 'number') {
    var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
    if (int !== num) {
      var intStr = String(int);
      var dec = $slice.call(str, intStr.length + 1);
      return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
    }
  }
  return $replace.call(str, sepRegex, '$&_');
}
var utilInspect = __webpack_require__(/*! ./util.inspect */ "?4f7e");
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
  var opts = options || {};
  if (has(opts, 'quoteStyle') && opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double') {
    throw new TypeError('option "quoteStyle" must be "single" or "double"');
  }
  if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
    throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
  }
  var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
  if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
    throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
  }
  if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
    throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
  }
  if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
    throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
  }
  var numericSeparator = opts.numericSeparator;
  if (typeof obj === 'undefined') {
    return 'undefined';
  }
  if (obj === null) {
    return 'null';
  }
  if (typeof obj === 'boolean') {
    return obj ? 'true' : 'false';
  }
  if (typeof obj === 'string') {
    return inspectString(obj, opts);
  }
  if (typeof obj === 'number') {
    if (obj === 0) {
      return Infinity / obj > 0 ? '0' : '-0';
    }
    var str = String(obj);
    return numericSeparator ? addNumericSeparator(obj, str) : str;
  }
  if (typeof obj === 'bigint') {
    var bigIntStr = String(obj) + 'n';
    return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
  }
  var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
  if (typeof depth === 'undefined') {
    depth = 0;
  }
  if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
    return isArray(obj) ? '[Array]' : '[Object]';
  }
  var indent = getIndent(opts, depth);
  if (typeof seen === 'undefined') {
    seen = [];
  } else if (indexOf(seen, obj) >= 0) {
    return '[Circular]';
  }
  function inspect(value, from, noIndent) {
    if (from) {
      seen = $arrSlice.call(seen);
      seen.push(from);
    }
    if (noIndent) {
      var newOpts = {
        depth: opts.depth
      };
      if (has(opts, 'quoteStyle')) {
        newOpts.quoteStyle = opts.quoteStyle;
      }
      return inspect_(value, newOpts, depth + 1, seen);
    }
    return inspect_(value, opts, depth + 1, seen);
  }
  if (typeof obj === 'function' && !isRegExp(obj)) {
    // in older engines, regexes are callable
    var name = nameOf(obj);
    var keys = arrObjKeys(obj, inspect);
    return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
  }
  if (isSymbol(obj)) {
    var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
    return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
  }
  if (isElement(obj)) {
    var s = '<' + $toLowerCase.call(String(obj.nodeName));
    var attrs = obj.attributes || [];
    for (var i = 0; i < attrs.length; i++) {
      s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
    }
    s += '>';
    if (obj.childNodes && obj.childNodes.length) {
      s += '...';
    }
    s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
    return s;
  }
  if (isArray(obj)) {
    if (obj.length === 0) {
      return '[]';
    }
    var xs = arrObjKeys(obj, inspect);
    if (indent && !singleLineValues(xs)) {
      return '[' + indentedJoin(xs, indent) + ']';
    }
    return '[ ' + $join.call(xs, ', ') + ' ]';
  }
  if (isError(obj)) {
    var parts = arrObjKeys(obj, inspect);
    if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
      return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
    }
    if (parts.length === 0) {
      return '[' + String(obj) + ']';
    }
    return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
  }
  if (typeof obj === 'object' && customInspect) {
    if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
      return utilInspect(obj, {
        depth: maxDepth - depth
      });
    } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
      return obj.inspect();
    }
  }
  if (isMap(obj)) {
    var mapParts = [];
    if (mapForEach) {
      mapForEach.call(obj, function (value, key) {
        mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
      });
    }
    return collectionOf('Map', mapSize.call(obj), mapParts, indent);
  }
  if (isSet(obj)) {
    var setParts = [];
    if (setForEach) {
      setForEach.call(obj, function (value) {
        setParts.push(inspect(value, obj));
      });
    }
    return collectionOf('Set', setSize.call(obj), setParts, indent);
  }
  if (isWeakMap(obj)) {
    return weakCollectionOf('WeakMap');
  }
  if (isWeakSet(obj)) {
    return weakCollectionOf('WeakSet');
  }
  if (isWeakRef(obj)) {
    return weakCollectionOf('WeakRef');
  }
  if (isNumber(obj)) {
    return markBoxed(inspect(Number(obj)));
  }
  if (isBigInt(obj)) {
    return markBoxed(inspect(bigIntValueOf.call(obj)));
  }
  if (isBoolean(obj)) {
    return markBoxed(booleanValueOf.call(obj));
  }
  if (isString(obj)) {
    return markBoxed(inspect(String(obj)));
  }
  if (!isDate(obj) && !isRegExp(obj)) {
    var ys = arrObjKeys(obj, inspect);
    var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
    var protoTag = obj instanceof Object ? '' : 'null prototype';
    var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
    var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
    var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
    if (ys.length === 0) {
      return tag + '{}';
    }
    if (indent) {
      return tag + '{' + indentedJoin(ys, indent) + '}';
    }
    return tag + '{ ' + $join.call(ys, ', ') + ' }';
  }
  return String(obj);
};
function wrapQuotes(s, defaultStyle, opts) {
  var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
  return quoteChar + s + quoteChar;
}
function quote(s) {
  return $replace.call(String(s), /"/g, '&quot;');
}
function isArray(obj) {
  return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isDate(obj) {
  return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isRegExp(obj) {
  return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isError(obj) {
  return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isString(obj) {
  return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isNumber(obj) {
  return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}
function isBoolean(obj) {
  return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
}

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
  if (hasShammedSymbols) {
    return obj && typeof obj === 'object' && obj instanceof Symbol;
  }
  if (typeof obj === 'symbol') {
    return true;
  }
  if (!obj || typeof obj !== 'object' || !symToString) {
    return false;
  }
  try {
    symToString.call(obj);
    return true;
  } catch (e) {}
  return false;
}
function isBigInt(obj) {
  if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
    return false;
  }
  try {
    bigIntValueOf.call(obj);
    return true;
  } catch (e) {}
  return false;
}
var hasOwn = Object.prototype.hasOwnProperty || function (key) {
  return key in this;
};
function has(obj, key) {
  return hasOwn.call(obj, key);
}
function toStr(obj) {
  return objectToString.call(obj);
}
function nameOf(f) {
  if (f.name) {
    return f.name;
  }
  var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
  if (m) {
    return m[1];
  }
  return null;
}
function indexOf(xs, x) {
  if (xs.indexOf) {
    return xs.indexOf(x);
  }
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) {
      return i;
    }
  }
  return -1;
}
function isMap(x) {
  if (!mapSize || !x || typeof x !== 'object') {
    return false;
  }
  try {
    mapSize.call(x);
    try {
      setSize.call(x);
    } catch (s) {
      return true;
    }
    return x instanceof Map; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
}
function isWeakMap(x) {
  if (!weakMapHas || !x || typeof x !== 'object') {
    return false;
  }
  try {
    weakMapHas.call(x, weakMapHas);
    try {
      weakSetHas.call(x, weakSetHas);
    } catch (s) {
      return true;
    }
    return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
}
function isWeakRef(x) {
  if (!weakRefDeref || !x || typeof x !== 'object') {
    return false;
  }
  try {
    weakRefDeref.call(x);
    return true;
  } catch (e) {}
  return false;
}
function isSet(x) {
  if (!setSize || !x || typeof x !== 'object') {
    return false;
  }
  try {
    setSize.call(x);
    try {
      mapSize.call(x);
    } catch (m) {
      return true;
    }
    return x instanceof Set; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
}
function isWeakSet(x) {
  if (!weakSetHas || !x || typeof x !== 'object') {
    return false;
  }
  try {
    weakSetHas.call(x, weakSetHas);
    try {
      weakMapHas.call(x, weakMapHas);
    } catch (s) {
      return true;
    }
    return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
  } catch (e) {}
  return false;
}
function isElement(x) {
  if (!x || typeof x !== 'object') {
    return false;
  }
  if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
    return true;
  }
  return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function inspectString(str, opts) {
  if (str.length > opts.maxStringLength) {
    var remaining = str.length - opts.maxStringLength;
    var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
    return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
  }
  // eslint-disable-next-line no-control-regex
  var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
  return wrapQuotes(s, 'single', opts);
}
function lowbyte(c) {
  var n = c.charCodeAt(0);
  var x = {
    8: 'b',
    9: 't',
    10: 'n',
    12: 'f',
    13: 'r'
  }[n];
  if (x) {
    return '\\' + x;
  }
  return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}
function markBoxed(str) {
  return 'Object(' + str + ')';
}
function weakCollectionOf(type) {
  return type + ' { ? }';
}
function collectionOf(type, size, entries, indent) {
  var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
  return type + ' (' + size + ') {' + joinedEntries + '}';
}
function singleLineValues(xs) {
  for (var i = 0; i < xs.length; i++) {
    if (indexOf(xs[i], '\n') >= 0) {
      return false;
    }
  }
  return true;
}
function getIndent(opts, depth) {
  var baseIndent;
  if (opts.indent === '\t') {
    baseIndent = '\t';
  } else if (typeof opts.indent === 'number' && opts.indent > 0) {
    baseIndent = $join.call(Array(opts.indent + 1), ' ');
  } else {
    return null;
  }
  return {
    base: baseIndent,
    prev: $join.call(Array(depth + 1), baseIndent)
  };
}
function indentedJoin(xs, indent) {
  if (xs.length === 0) {
    return '';
  }
  var lineJoiner = '\n' + indent.prev + indent.base;
  return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function arrObjKeys(obj, inspect) {
  var isArr = isArray(obj);
  var xs = [];
  if (isArr) {
    xs.length = obj.length;
    for (var i = 0; i < obj.length; i++) {
      xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
    }
  }
  var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
  var symMap;
  if (hasShammedSymbols) {
    symMap = {};
    for (var k = 0; k < syms.length; k++) {
      symMap['$' + syms[k]] = syms[k];
    }
  }
  for (var key in obj) {
    // eslint-disable-line no-restricted-syntax
    if (!has(obj, key)) {
      continue;
    } // eslint-disable-line no-restricted-syntax, no-continue
    if (isArr && String(Number(key)) === key && key < obj.length) {
      continue;
    } // eslint-disable-line no-restricted-syntax, no-continue
    if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
      // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
      continue; // eslint-disable-line no-restricted-syntax, no-continue
    } else if ($test.call(/[^\w$]/, key)) {
      xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
    } else {
      xs.push(key + ': ' + inspect(obj[key], obj));
    }
  }
  if (typeof gOPS === 'function') {
    for (var j = 0; j < syms.length; j++) {
      if (isEnumerable.call(obj, syms[j])) {
        xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
      }
    }
  }
  return xs;
}

/***/ }),

/***/ "./node_modules/qs/lib/formats.js":
/*!****************************************!*\
  !*** ./node_modules/qs/lib/formats.js ***!
  \****************************************/
/***/ ((module) => {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;
var Format = {
  RFC1738: 'RFC1738',
  RFC3986: 'RFC3986'
};
module.exports = {
  'default': Format.RFC3986,
  formatters: {
    RFC1738: function (value) {
      return replace.call(value, percentTwenties, '+');
    },
    RFC3986: function (value) {
      return String(value);
    }
  },
  RFC1738: Format.RFC1738,
  RFC3986: Format.RFC3986
};

/***/ }),

/***/ "./node_modules/qs/lib/index.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/index.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(/*! ./stringify */ "./node_modules/qs/lib/stringify.js");
var parse = __webpack_require__(/*! ./parse */ "./node_modules/qs/lib/parse.js");
var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");
module.exports = {
  formats: formats,
  parse: parse,
  stringify: stringify
};

/***/ }),

/***/ "./node_modules/qs/lib/parse.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/parse.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "./node_modules/qs/lib/utils.js");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var defaults = {
  allowDots: false,
  allowPrototypes: false,
  allowSparse: false,
  arrayLimit: 20,
  charset: 'utf-8',
  charsetSentinel: false,
  comma: false,
  decoder: utils.decode,
  delimiter: '&',
  depth: 5,
  ignoreQueryPrefix: false,
  interpretNumericEntities: false,
  parameterLimit: 1000,
  parseArrays: true,
  plainObjects: false,
  strictNullHandling: false
};
var interpretNumericEntities = function (str) {
  return str.replace(/&#(\d+);/g, function ($0, numberStr) {
    return String.fromCharCode(parseInt(numberStr, 10));
  });
};
var parseArrayValue = function (val, options) {
  if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
    return val.split(',');
  }
  return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
  var obj = {};
  var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
  var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
  var parts = cleanStr.split(options.delimiter, limit);
  var skipIndex = -1; // Keep track of where the utf8 sentinel was found
  var i;
  var charset = options.charset;
  if (options.charsetSentinel) {
    for (i = 0; i < parts.length; ++i) {
      if (parts[i].indexOf('utf8=') === 0) {
        if (parts[i] === charsetSentinel) {
          charset = 'utf-8';
        } else if (parts[i] === isoSentinel) {
          charset = 'iso-8859-1';
        }
        skipIndex = i;
        i = parts.length; // The eslint settings do not allow break;
      }
    }
  }

  for (i = 0; i < parts.length; ++i) {
    if (i === skipIndex) {
      continue;
    }
    var part = parts[i];
    var bracketEqualsPos = part.indexOf(']=');
    var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
    var key, val;
    if (pos === -1) {
      key = options.decoder(part, defaults.decoder, charset, 'key');
      val = options.strictNullHandling ? null : '';
    } else {
      key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
      val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function (encodedVal) {
        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
      });
    }
    if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
      val = interpretNumericEntities(val);
    }
    if (part.indexOf('[]=') > -1) {
      val = isArray(val) ? [val] : val;
    }
    if (has.call(obj, key)) {
      obj[key] = utils.combine(obj[key], val);
    } else {
      obj[key] = val;
    }
  }
  return obj;
};
var parseObject = function (chain, val, options, valuesParsed) {
  var leaf = valuesParsed ? val : parseArrayValue(val, options);
  for (var i = chain.length - 1; i >= 0; --i) {
    var obj;
    var root = chain[i];
    if (root === '[]' && options.parseArrays) {
      obj = [].concat(leaf);
    } else {
      obj = options.plainObjects ? Object.create(null) : {};
      var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
      var index = parseInt(cleanRoot, 10);
      if (!options.parseArrays && cleanRoot === '') {
        obj = {
          0: leaf
        };
      } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
        obj = [];
        obj[index] = leaf;
      } else if (cleanRoot !== '__proto__') {
        obj[cleanRoot] = leaf;
      }
    }
    leaf = obj;
  }
  return leaf;
};
var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
  if (!givenKey) {
    return;
  }

  // Transform dot notation to bracket notation
  var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

  // The regex chunks

  var brackets = /(\[[^[\]]*])/;
  var child = /(\[[^[\]]*])/g;

  // Get the parent

  var segment = options.depth > 0 && brackets.exec(key);
  var parent = segment ? key.slice(0, segment.index) : key;

  // Stash the parent if it exists

  var keys = [];
  if (parent) {
    // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
    if (!options.plainObjects && has.call(Object.prototype, parent)) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys.push(parent);
  }

  // Loop through children appending to the array until we hit depth

  var i = 0;
  while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
    i += 1;
    if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
      if (!options.allowPrototypes) {
        return;
      }
    }
    keys.push(segment[1]);
  }

  // If there's a remainder, just add whatever is left

  if (segment) {
    keys.push('[' + key.slice(segment.index) + ']');
  }
  return parseObject(keys, val, options, valuesParsed);
};
var normalizeParseOptions = function normalizeParseOptions(opts) {
  if (!opts) {
    return defaults;
  }
  if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
    throw new TypeError('Decoder has to be a function.');
  }
  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
  }
  var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
  return {
    allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
    allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
    allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
    arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
    comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
    decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
    delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
    // eslint-disable-next-line no-implicit-coercion, no-extra-parens
    depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults.depth,
    ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
    interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
    parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
    parseArrays: opts.parseArrays !== false,
    plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
  };
};
module.exports = function (str, opts) {
  var options = normalizeParseOptions(opts);
  if (str === '' || str === null || typeof str === 'undefined') {
    return options.plainObjects ? Object.create(null) : {};
  }
  var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
  var obj = options.plainObjects ? Object.create(null) : {};

  // Iterate over the keys and setup the new object

  var keys = Object.keys(tempObj);
  for (var i = 0; i < keys.length; ++i) {
    var key = keys[i];
    var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
    obj = utils.merge(obj, newObj, options);
  }
  if (options.allowSparse === true) {
    return obj;
  }
  return utils.compact(obj);
};

/***/ }),

/***/ "./node_modules/qs/lib/stringify.js":
/*!******************************************!*\
  !*** ./node_modules/qs/lib/stringify.js ***!
  \******************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var getSideChannel = __webpack_require__(/*! side-channel */ "./node_modules/side-channel/index.js");
var utils = __webpack_require__(/*! ./utils */ "./node_modules/qs/lib/utils.js");
var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");
var has = Object.prototype.hasOwnProperty;
var arrayPrefixGenerators = {
  brackets: function brackets(prefix) {
    return prefix + '[]';
  },
  comma: 'comma',
  indices: function indices(prefix, key) {
    return prefix + '[' + key + ']';
  },
  repeat: function repeat(prefix) {
    return prefix;
  }
};
var isArray = Array.isArray;
var split = String.prototype.split;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
  push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};
var toISO = Date.prototype.toISOString;
var defaultFormat = formats['default'];
var defaults = {
  addQueryPrefix: false,
  allowDots: false,
  charset: 'utf-8',
  charsetSentinel: false,
  delimiter: '&',
  encode: true,
  encoder: utils.encode,
  encodeValuesOnly: false,
  format: defaultFormat,
  formatter: formats.formatters[defaultFormat],
  // deprecated
  indices: false,
  serializeDate: function serializeDate(date) {
    return toISO.call(date);
  },
  skipNulls: false,
  strictNullHandling: false
};
var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
  return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var sentinel = {};
var stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
  var obj = object;
  var tmpSc = sideChannel;
  var step = 0;
  var findFlag = false;
  while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
    // Where object last appeared in the ref tree
    var pos = tmpSc.get(object);
    step += 1;
    if (typeof pos !== 'undefined') {
      if (pos === step) {
        throw new RangeError('Cyclic object value');
      } else {
        findFlag = true; // Break while
      }
    }

    if (typeof tmpSc.get(sentinel) === 'undefined') {
      step = 0;
    }
  }
  if (typeof filter === 'function') {
    obj = filter(prefix, obj);
  } else if (obj instanceof Date) {
    obj = serializeDate(obj);
  } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
    obj = utils.maybeMap(obj, function (value) {
      if (value instanceof Date) {
        return serializeDate(value);
      }
      return value;
    });
  }
  if (obj === null) {
    if (strictNullHandling) {
      return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
    }
    obj = '';
  }
  if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
    if (encoder) {
      var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
      if (generateArrayPrefix === 'comma' && encodeValuesOnly) {
        var valuesArray = split.call(String(obj), ',');
        var valuesJoined = '';
        for (var i = 0; i < valuesArray.length; ++i) {
          valuesJoined += (i === 0 ? '' : ',') + formatter(encoder(valuesArray[i], defaults.encoder, charset, 'value', format));
        }
        return [formatter(keyValue) + (commaRoundTrip && isArray(obj) && valuesArray.length === 1 ? '[]' : '') + '=' + valuesJoined];
      }
      return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
    }
    return [formatter(prefix) + '=' + formatter(String(obj))];
  }
  var values = [];
  if (typeof obj === 'undefined') {
    return values;
  }
  var objKeys;
  if (generateArrayPrefix === 'comma' && isArray(obj)) {
    // we need to join elements in
    objKeys = [{
      value: obj.length > 0 ? obj.join(',') || null : void undefined
    }];
  } else if (isArray(filter)) {
    objKeys = filter;
  } else {
    var keys = Object.keys(obj);
    objKeys = sort ? keys.sort(sort) : keys;
  }
  var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;
  for (var j = 0; j < objKeys.length; ++j) {
    var key = objKeys[j];
    var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];
    if (skipNulls && value === null) {
      continue;
    }
    var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');
    sideChannel.set(object, step);
    var valueSideChannel = getSideChannel();
    valueSideChannel.set(sentinel, sideChannel);
    pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
  }
  return values;
};
var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
  if (!opts) {
    return defaults;
  }
  if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
    throw new TypeError('Encoder has to be a function.');
  }
  var charset = opts.charset || defaults.charset;
  if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
    throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
  }
  var format = formats['default'];
  if (typeof opts.format !== 'undefined') {
    if (!has.call(formats.formatters, opts.format)) {
      throw new TypeError('Unknown format option provided.');
    }
    format = opts.format;
  }
  var formatter = formats.formatters[format];
  var filter = defaults.filter;
  if (typeof opts.filter === 'function' || isArray(opts.filter)) {
    filter = opts.filter;
  }
  return {
    addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
    allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
    charset: charset,
    charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
    delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
    encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
    encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
    encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
    filter: filter,
    format: format,
    formatter: formatter,
    serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
    skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
    sort: typeof opts.sort === 'function' ? opts.sort : null,
    strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
  };
};
module.exports = function (object, opts) {
  var obj = object;
  var options = normalizeStringifyOptions(opts);
  var objKeys;
  var filter;
  if (typeof options.filter === 'function') {
    filter = options.filter;
    obj = filter('', obj);
  } else if (isArray(options.filter)) {
    filter = options.filter;
    objKeys = filter;
  }
  var keys = [];
  if (typeof obj !== 'object' || obj === null) {
    return '';
  }
  var arrayFormat;
  if (opts && opts.arrayFormat in arrayPrefixGenerators) {
    arrayFormat = opts.arrayFormat;
  } else if (opts && 'indices' in opts) {
    arrayFormat = opts.indices ? 'indices' : 'repeat';
  } else {
    arrayFormat = 'indices';
  }
  var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];
  if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
    throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
  }
  var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;
  if (!objKeys) {
    objKeys = Object.keys(obj);
  }
  if (options.sort) {
    objKeys.sort(options.sort);
  }
  var sideChannel = getSideChannel();
  for (var i = 0; i < objKeys.length; ++i) {
    var key = objKeys[i];
    if (options.skipNulls && obj[key] === null) {
      continue;
    }
    pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
  }
  var joined = keys.join(options.delimiter);
  var prefix = options.addQueryPrefix === true ? '?' : '';
  if (options.charsetSentinel) {
    if (options.charset === 'iso-8859-1') {
      // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
      prefix += 'utf8=%26%2310003%3B&';
    } else {
      // encodeURIComponent('✓')
      prefix += 'utf8=%E2%9C%93&';
    }
  }
  return joined.length > 0 ? prefix + joined : '';
};

/***/ }),

/***/ "./node_modules/qs/lib/utils.js":
/*!**************************************!*\
  !*** ./node_modules/qs/lib/utils.js ***!
  \**************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formats = __webpack_require__(/*! ./formats */ "./node_modules/qs/lib/formats.js");
var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;
var hexTable = function () {
  var array = [];
  for (var i = 0; i < 256; ++i) {
    array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
  }
  return array;
}();
var compactQueue = function compactQueue(queue) {
  while (queue.length > 1) {
    var item = queue.pop();
    var obj = item.obj[item.prop];
    if (isArray(obj)) {
      var compacted = [];
      for (var j = 0; j < obj.length; ++j) {
        if (typeof obj[j] !== 'undefined') {
          compacted.push(obj[j]);
        }
      }
      item.obj[item.prop] = compacted;
    }
  }
};
var arrayToObject = function arrayToObject(source, options) {
  var obj = options && options.plainObjects ? Object.create(null) : {};
  for (var i = 0; i < source.length; ++i) {
    if (typeof source[i] !== 'undefined') {
      obj[i] = source[i];
    }
  }
  return obj;
};
var merge = function merge(target, source, options) {
  /* eslint no-param-reassign: 0 */
  if (!source) {
    return target;
  }
  if (typeof source !== 'object') {
    if (isArray(target)) {
      target.push(source);
    } else if (target && typeof target === 'object') {
      if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) {
        target[source] = true;
      }
    } else {
      return [target, source];
    }
    return target;
  }
  if (!target || typeof target !== 'object') {
    return [target].concat(source);
  }
  var mergeTarget = target;
  if (isArray(target) && !isArray(source)) {
    mergeTarget = arrayToObject(target, options);
  }
  if (isArray(target) && isArray(source)) {
    source.forEach(function (item, i) {
      if (has.call(target, i)) {
        var targetItem = target[i];
        if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
          target[i] = merge(targetItem, item, options);
        } else {
          target.push(item);
        }
      } else {
        target[i] = item;
      }
    });
    return target;
  }
  return Object.keys(source).reduce(function (acc, key) {
    var value = source[key];
    if (has.call(acc, key)) {
      acc[key] = merge(acc[key], value, options);
    } else {
      acc[key] = value;
    }
    return acc;
  }, mergeTarget);
};
var assign = function assignSingleSource(target, source) {
  return Object.keys(source).reduce(function (acc, key) {
    acc[key] = source[key];
    return acc;
  }, target);
};
var decode = function (str, decoder, charset) {
  var strWithoutPlus = str.replace(/\+/g, ' ');
  if (charset === 'iso-8859-1') {
    // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
  }
  // utf-8
  try {
    return decodeURIComponent(strWithoutPlus);
  } catch (e) {
    return strWithoutPlus;
  }
};
var encode = function encode(str, defaultEncoder, charset, kind, format) {
  // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
  // It has been adapted here for stricter adherence to RFC 3986
  if (str.length === 0) {
    return str;
  }
  var string = str;
  if (typeof str === 'symbol') {
    string = Symbol.prototype.toString.call(str);
  } else if (typeof str !== 'string') {
    string = String(str);
  }
  if (charset === 'iso-8859-1') {
    return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
      return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
  }
  var out = '';
  for (var i = 0; i < string.length; ++i) {
    var c = string.charCodeAt(i);
    if (c === 0x2D // -
    || c === 0x2E // .
    || c === 0x5F // _
    || c === 0x7E // ~
    || c >= 0x30 && c <= 0x39 // 0-9
    || c >= 0x41 && c <= 0x5A // a-z
    || c >= 0x61 && c <= 0x7A // A-Z
    || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
    ) {
      out += string.charAt(i);
      continue;
    }
    if (c < 0x80) {
      out = out + hexTable[c];
      continue;
    }
    if (c < 0x800) {
      out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
      continue;
    }
    if (c < 0xD800 || c >= 0xE000) {
      out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
      continue;
    }
    i += 1;
    c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
    /* eslint operator-linebreak: [2, "before"] */
    out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
  }
  return out;
};
var compact = function compact(value) {
  var queue = [{
    obj: {
      o: value
    },
    prop: 'o'
  }];
  var refs = [];
  for (var i = 0; i < queue.length; ++i) {
    var item = queue[i];
    var obj = item.obj[item.prop];
    var keys = Object.keys(obj);
    for (var j = 0; j < keys.length; ++j) {
      var key = keys[j];
      var val = obj[key];
      if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
        queue.push({
          obj: obj,
          prop: key
        });
        refs.push(val);
      }
    }
  }
  compactQueue(queue);
  return value;
};
var isRegExp = function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var isBuffer = function isBuffer(obj) {
  if (!obj || typeof obj !== 'object') {
    return false;
  }
  return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var combine = function combine(a, b) {
  return [].concat(a, b);
};
var maybeMap = function maybeMap(val, fn) {
  if (isArray(val)) {
    var mapped = [];
    for (var i = 0; i < val.length; i += 1) {
      mapped.push(fn(val[i]));
    }
    return mapped;
  }
  return fn(val);
};
module.exports = {
  arrayToObject: arrayToObject,
  assign: assign,
  combine: combine,
  compact: compact,
  decode: decode,
  encode: encode,
  isBuffer: isBuffer,
  isRegExp: isRegExp,
  maybeMap: maybeMap,
  merge: merge
};

/***/ }),

/***/ "./node_modules/side-channel/index.js":
/*!********************************************!*\
  !*** ./node_modules/side-channel/index.js ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var GetIntrinsic = __webpack_require__(/*! get-intrinsic */ "./node_modules/get-intrinsic/index.js");
var callBound = __webpack_require__(/*! call-bind/callBound */ "./node_modules/call-bind/callBound.js");
var inspect = __webpack_require__(/*! object-inspect */ "./node_modules/object-inspect/index.js");
var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);
var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) {
  // eslint-disable-line consistent-return
  for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
    if (curr.key === key) {
      prev.next = curr.next;
      curr.next = list.next;
      list.next = curr; // eslint-disable-line no-param-reassign
      return curr;
    }
  }
};
var listGet = function (objects, key) {
  var node = listGetNode(objects, key);
  return node && node.value;
};
var listSet = function (objects, key, value) {
  var node = listGetNode(objects, key);
  if (node) {
    node.value = value;
  } else {
    // Prepend the new node to the beginning of the list
    objects.next = {
      // eslint-disable-line no-param-reassign
      key: key,
      next: objects.next,
      value: value
    };
  }
};
var listHas = function (objects, key) {
  return !!listGetNode(objects, key);
};
module.exports = function getSideChannel() {
  var $wm;
  var $m;
  var $o;
  var channel = {
    assert: function (key) {
      if (!channel.has(key)) {
        throw new $TypeError('Side channel does not contain ' + inspect(key));
      }
    },
    get: function (key) {
      // eslint-disable-line consistent-return
      if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
        if ($wm) {
          return $weakMapGet($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapGet($m, key);
        }
      } else {
        if ($o) {
          // eslint-disable-line no-lonely-if
          return listGet($o, key);
        }
      }
    },
    has: function (key) {
      if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
        if ($wm) {
          return $weakMapHas($wm, key);
        }
      } else if ($Map) {
        if ($m) {
          return $mapHas($m, key);
        }
      } else {
        if ($o) {
          // eslint-disable-line no-lonely-if
          return listHas($o, key);
        }
      }
      return false;
    },
    set: function (key, value) {
      if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
        if (!$wm) {
          $wm = new $WeakMap();
        }
        $weakMapSet($wm, key, value);
      } else if ($Map) {
        if (!$m) {
          $m = new $Map();
        }
        $mapSet($m, key, value);
      } else {
        if (!$o) {
          /*
           * Initialize the linked list as an empty node, so that we don't have
           * to special-case handling of the first node: we can always refer to
           * it as (previous node).next, instead of something like (list).head
           */
          $o = {
            key: {},
            next: null
          };
        }
        listSet($o, key, value);
      }
    }
  };
  return channel;
};

/***/ }),

/***/ "../../../node_modules/@gltf-transform/core/dist/core.modern.js":
/*!**********************************************************************!*\
  !*** ../../../node_modules/@gltf-transform/core/dist/core.modern.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Accessor": () => (/* binding */ P),
/* harmony export */   "Animation": () => (/* binding */ U),
/* harmony export */   "AnimationChannel": () => (/* binding */ k),
/* harmony export */   "AnimationSampler": () => (/* binding */ F),
/* harmony export */   "AttributeLink": () => (/* binding */ J),
/* harmony export */   "Buffer": () => (/* binding */ G),
/* harmony export */   "BufferUtils": () => (/* binding */ T),
/* harmony export */   "COPY_IDENTITY": () => (/* binding */ O),
/* harmony export */   "Camera": () => (/* binding */ j),
/* harmony export */   "ColorUtils": () => (/* binding */ y),
/* harmony export */   "Document": () => (/* binding */ ht),
/* harmony export */   "Extension": () => (/* binding */ ot),
/* harmony export */   "ExtensionProperty": () => (/* binding */ D),
/* harmony export */   "FileUtils": () => (/* binding */ A),
/* harmony export */   "Format": () => (/* binding */ a),
/* harmony export */   "GLB_BUFFER": () => (/* binding */ h),
/* harmony export */   "Graph": () => (/* binding */ d),
/* harmony export */   "GraphChild": () => (/* binding */ p),
/* harmony export */   "GraphChildList": () => (/* binding */ g),
/* harmony export */   "ImageUtils": () => (/* binding */ x),
/* harmony export */   "IndexLink": () => (/* binding */ z),
/* harmony export */   "Link": () => (/* binding */ f),
/* harmony export */   "Logger": () => (/* binding */ I),
/* harmony export */   "Material": () => (/* binding */ K),
/* harmony export */   "MathUtils": () => (/* binding */ M),
/* harmony export */   "Mesh": () => (/* binding */ Q),
/* harmony export */   "Node": () => (/* binding */ X),
/* harmony export */   "NodeIO": () => (/* binding */ yt),
/* harmony export */   "PlatformIO": () => (/* binding */ Tt),
/* harmony export */   "Primitive": () => (/* binding */ tt),
/* harmony export */   "PrimitiveTarget": () => (/* binding */ st),
/* harmony export */   "Property": () => (/* binding */ _),
/* harmony export */   "PropertyType": () => (/* binding */ o),
/* harmony export */   "ReaderContext": () => (/* binding */ ct),
/* harmony export */   "Root": () => (/* binding */ nt),
/* harmony export */   "Scene": () => (/* binding */ et),
/* harmony export */   "Skin": () => (/* binding */ it),
/* harmony export */   "Texture": () => (/* binding */ rt),
/* harmony export */   "TextureChannel": () => (/* binding */ c),
/* harmony export */   "TextureInfo": () => (/* binding */ W),
/* harmony export */   "TextureLink": () => (/* binding */ $),
/* harmony export */   "VERSION": () => (/* binding */ n),
/* harmony export */   "VertexLayout": () => (/* binding */ u),
/* harmony export */   "WebIO": () => (/* binding */ Et),
/* harmony export */   "WriterContext": () => (/* binding */ gt),
/* harmony export */   "bounds": () => (/* binding */ w),
/* harmony export */   "uuid": () => (/* binding */ C)
/* harmony export */ });
/* harmony import */ var gl_matrix_vec3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! gl-matrix/vec3 */ "../../../node_modules/gl-matrix/esm/vec3.js");
/* harmony import */ var gl_matrix_mat4__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! gl-matrix/mat4 */ "../../../node_modules/gl-matrix/esm/mat4.js");


const n = "v1.2.4",
  h = "@glb.bin";
var o, u, c, a;
function l(t, s, e, i) {
  var r,
    n = arguments.length,
    h = n < 3 ? s : null === i ? i = Object.getOwnPropertyDescriptor(s, e) : i;
  if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) h = Reflect.decorate(t, s, e, i);else for (var o = t.length - 1; o >= 0; o--) (r = t[o]) && (h = (n < 3 ? r(h) : n > 3 ? r(s, e, h) : r(s, e)) || h);
  return n > 3 && h && Object.defineProperty(s, e, h), h;
}
!function (t) {
  t.ACCESSOR = "Accessor", t.ANIMATION = "Animation", t.ANIMATION_CHANNEL = "AnimationChannel", t.ANIMATION_SAMPLER = "AnimationSampler", t.BUFFER = "Buffer", t.CAMERA = "Camera", t.MATERIAL = "Material", t.MESH = "Mesh", t.PRIMITIVE = "Primitive", t.PRIMITIVE_TARGET = "PrimitiveTarget", t.NODE = "Node", t.ROOT = "Root", t.SCENE = "Scene", t.SKIN = "Skin", t.TEXTURE = "Texture", t.TEXTURE_INFO = "TextureInfo";
}(o || (o = {})), function (t) {
  t.INTERLEAVED = "interleaved", t.SEPARATE = "separate";
}(u || (u = {})), function (t) {
  t[t.R = 4096] = "R", t[t.G = 256] = "G", t[t.B = 16] = "B", t[t.A = 1] = "A";
}(c || (c = {})), function (t) {
  t.GLTF = "GLTF", t.GLB = "GLB";
}(a || (a = {}));
class f {
  constructor(t, s, e) {
    if (this.t = void 0, this.i = void 0, this.h = void 0, this.o = !1, this.u = [], this.t = t, this.i = s, this.h = e, !s.canLink(e)) throw new Error("Cannot link disconnected graphs/documents.");
  }
  getName() {
    return this.t;
  }
  getParent() {
    return this.i;
  }
  getChild() {
    return this.h;
  }
  setChild(t) {
    return this.h = t, this;
  }
  dispose() {
    this.o || (this.o = !0, this.u.forEach(t => t()), this.u.length = 0);
  }
  onDispose(t) {
    return this.u.push(t), this;
  }
  isDisposed() {
    return this.o;
  }
}
class d {
  constructor() {
    this.l = new Set(), this.p = new Set(), this.g = new Map(), this.v = new Map(), this.u = {};
  }
  on(t, s) {
    return this.u[t] = this.u[t] || [], this.u[t].push(s), this;
  }
  emit(t, s) {
    for (const e of this.u[t] || []) e(s);
    return this;
  }
  getLinks() {
    return Array.from(this.p);
  }
  listParentLinks(t) {
    return Array.from(this.v.get(t) || this.l);
  }
  listParents(t) {
    return this.listParentLinks(t).map(t => t.getParent());
  }
  listChildLinks(t) {
    return Array.from(this.g.get(t) || this.l);
  }
  listChildren(t) {
    return this.listChildLinks(t).map(t => t.getChild());
  }
  disconnectChildren(t) {
    return (this.g.get(t) || this.l).forEach(t => t.dispose()), this;
  }
  disconnectParents(t, s) {
    let e = Array.from(this.v.get(t) || this.l);
    return s && (e = e.filter(t => s(t.getParent()))), e.forEach(t => t.dispose()), this;
  }
  swapChild(t, s, e) {
    const i = this.g.get(t) || this.l;
    return Array.from(i).filter(t => t.getChild() === s).forEach(t => {
      this.v.get(s).delete(t), t.setChild(e), this.v.has(e) || this.v.set(e, new Set()), this.v.get(e).add(t);
    }), this;
  }
  link(t, s, e) {
    if (!e) return null;
    const i = new f(t, s, e);
    return this.registerLink(i), i;
  }
  registerLink(t) {
    this.p.add(t);
    const s = t.getParent();
    this.g.has(s) || this.g.set(s, new Set()), this.g.get(s).add(t);
    const e = t.getChild();
    return this.v.has(e) || this.v.set(e, new Set()), this.v.get(e).add(t), t.onDispose(() => this.unlink(t)), t;
  }
  unlink(t) {
    return this.p.delete(t), this.g.get(t.getParent()).delete(t), this.v.get(t.getChild()).delete(t), this;
  }
}
function p(t, s) {
  Object.defineProperty(t, s, {
    get: function () {
      return this["__" + s];
    },
    set: function (t) {
      const e = this["__" + s];
      e && !Array.isArray(e) && e.dispose(), t && !Array.isArray(t) && t.onDispose(() => {
        this["__" + s] = null;
      }), this["__" + s] = t;
    },
    enumerable: !0
  });
}
function g(t, s) {}
function w(t) {
  const s = {
      min: [Infinity, Infinity, Infinity],
      max: [-Infinity, -Infinity, -Infinity]
    },
    e = t.propertyType === o.NODE ? [t] : t.listChildren();
  for (const t of e) t.traverse(t => {
    const e = t.getMesh();
    if (!e) return;
    const i = v(e, t.getWorldMatrix());
    m(i.min, s), m(i.max, s);
  });
  return s;
}
function v(s, e) {
  const i = {
    min: [Infinity, Infinity, Infinity],
    max: [-Infinity, -Infinity, -Infinity]
  };
  for (const r of s.listPrimitives()) {
    const s = r.getAttribute("POSITION");
    if (!s) continue;
    let n = [0, 0, 0],
      h = [0, 0, 0];
    for (let r = 0; r < s.getCount(); r++) n = s.getElement(r, n), h = (0,gl_matrix_vec3__WEBPACK_IMPORTED_MODULE_0__.transformMat4)(h, n, e), m(h, i);
  }
  return i;
}
function m(t, s) {
  for (let e = 0; e < 3; e++) s.min[e] = Math.min(t[e], s.min[e]), s.max[e] = Math.max(t[e], s.max[e]);
}
class T {
  static createBufferFromDataURI(t) {
    if ("undefined" == typeof Buffer) {
      const s = atob(t.split(",")[1]),
        e = new Uint8Array(s.length);
      for (let t = 0; t < s.length; t++) e[t] = s.charCodeAt(t);
      return e.buffer;
    }
    {
      const s = t.split(",")[1],
        e = t.indexOf("base64") >= 0;
      return this.trim(Buffer.from(s, e ? "base64" : "utf8"));
    }
  }
  static encodeText(t) {
    return "undefined" != typeof TextEncoder ? new TextEncoder().encode(t).buffer : this.trim(Buffer.from(t));
  }
  static decodeText(t) {
    return "undefined" != typeof TextDecoder ? new TextDecoder().decode(t) : Buffer.from(t).toString("utf8");
  }
  static trim(t) {
    const {
      byteOffset: s,
      byteLength: e
    } = t;
    return t.buffer.slice(s, s + e);
  }
  static concat(t) {
    let s = 0;
    for (const e of t) s += e.byteLength;
    const e = new Uint8Array(s);
    let i = 0;
    for (const s of t) e.set(new Uint8Array(s), i), i += s.byteLength;
    return e.buffer;
  }
  static pad(t, s = 0) {
    const e = this.padNumber(t.byteLength);
    if (e !== t.byteLength) {
      const i = new Uint8Array(e);
      if (i.set(new Uint8Array(t)), 0 !== s) for (let r = t.byteLength; r < e; r++) i[r] = s;
      return i.buffer;
    }
    return t;
  }
  static padNumber(t) {
    return 4 * Math.ceil(t / 4);
  }
  static equals(t, s) {
    if (t === s) return !0;
    if (t.byteLength !== s.byteLength) return !1;
    const e = new DataView(t),
      i = new DataView(s);
    let r = t.byteLength;
    for (; r--;) if (e.getUint8(r) !== i.getUint8(r)) return !1;
    return !0;
  }
}
class y {
  static hexToFactor(t, s) {
    t = Math.floor(t);
    const e = s;
    return e[0] = (t >> 16 & 255) / 255, e[1] = (t >> 8 & 255) / 255, e[2] = (255 & t) / 255, this.convertSRGBToLinear(s, s);
  }
  static factorToHex(t) {
    const s = [...t],
      [e, i, r] = this.convertLinearToSRGB(t, s);
    return 255 * e << 16 ^ 255 * i << 8 ^ 255 * r << 0;
  }
  static convertSRGBToLinear(t, s) {
    const e = t,
      i = s;
    for (let t = 0; t < 3; t++) i[t] = e[t] < .04045 ? .0773993808 * e[t] : Math.pow(.9478672986 * e[t] + .0521327014, 2.4);
    return s;
  }
  static convertLinearToSRGB(t, s) {
    const e = t,
      i = s;
    for (let t = 0; t < 3; t++) i[t] = e[t] < .0031308 ? 12.92 * e[t] : 1.055 * Math.pow(e[t], .41666) - .055;
    return s;
  }
}
class A {
  static basename(t) {
    const s = t.split(/[\\/]/).pop();
    return s.substr(0, s.lastIndexOf("."));
  }
  static extension(t) {
    return 0 !== t.indexOf("data:") ? t.split(/[\\/]/).pop().split(/[.]/).pop() : 0 === t.indexOf("data:image/png") ? "png" : 0 === t.indexOf("data:image/jpeg") ? "jpeg" : "bin";
  }
}
class E {
  match(t) {
    const s = new Uint8Array(t);
    return s.length >= 8 && 137 === s[0] && 80 === s[1] && 78 === s[2] && 71 === s[3] && 13 === s[4] && 10 === s[5] && 26 === s[6] && 10 === s[7];
  }
  getSize(t) {
    const s = new DataView(t);
    return T.decodeText(t.slice(12, 16)) === E.PNG_FRIED_CHUNK_NAME ? [s.getUint32(32, !1), s.getUint32(36, !1)] : [s.getUint32(16, !1), s.getUint32(20, !1)];
  }
  getChannels(t) {
    return 4;
  }
}
E.PNG_FRIED_CHUNK_NAME = "CgBI";
class x {
  static registerFormat(t, s) {
    this.impls[t] = s;
  }
  static getMimeType(t) {
    for (const s in this.impls) if (this.impls[s].match(t)) return s;
    return null;
  }
  static getSize(t, s) {
    return this.impls[s] ? this.impls[s].getSize(t) : null;
  }
  static getChannels(t, s) {
    return this.impls[s] ? this.impls[s].getChannels(t) : null;
  }
  static getMemSize(t, s) {
    if (!this.impls[s]) return null;
    if (this.impls[s].getGPUByteLength) return this.impls[s].getGPUByteLength(t);
    let e = 0;
    const i = this.getSize(t, s);
    if (!i) return null;
    for (; i[0] > 1 || i[1] > 1;) e += i[0] * i[1] * 4, i[0] = Math.max(Math.floor(i[0] / 2), 1), i[1] = Math.max(Math.floor(i[1] / 2), 1);
    return e += 4, e;
  }
  static mimeTypeToExtension(t) {
    return "image/jpeg" === t ? "jpg" : t.split("/").pop();
  }
  static extensionToMimeType(t) {
    return "jpg" === t ? "image/jpeg" : `image/${t}`;
  }
}
function S(t, s) {
  if (s > t.byteLength) throw new TypeError("Corrupt JPG, exceeded buffer limits");
  if (255 !== t.getUint8(s)) throw new TypeError("Invalid JPG, marker table corrupted");
  return t;
}
x.impls = {
  "image/jpeg": new class {
    match(t) {
      const s = new Uint8Array(t);
      return s.length >= 3 && 255 === s[0] && 216 === s[1] && 255 === s[2];
    }
    getSize(t) {
      let s,
        e,
        i = new DataView(t, 4);
      for (; i.byteLength;) {
        if (s = i.getUint16(0, !1), S(i, s), e = i.getUint8(s + 1), 192 === e || 193 === e || 194 === e) return [i.getUint16(s + 7, !1), i.getUint16(s + 5, !1)];
        i = new DataView(t, i.byteOffset + s + 2);
      }
      throw new TypeError("Invalid JPG, no size found");
    }
    getChannels(t) {
      return 3;
    }
  }(),
  "image/png": new E()
};
class M {
  static identity(t) {
    return t;
  }
  static eq(t, s) {
    if (t.length !== s.length) return !1;
    for (let e = 0; e < t.length; e++) if (Math.abs(t[e] - s[e]) > 1e-5) return !1;
    return !0;
  }
  static denormalize(t, s) {
    switch (s) {
      case 5126:
        return t;
      case 5123:
        return t / 65535;
      case 5121:
        return t / 255;
      case 5122:
        return Math.max(t / 32767, -1);
      case 5120:
        return Math.max(t / 127, -1);
      default:
        throw new Error("Invalid component type.");
    }
  }
  static normalize(t, s) {
    switch (s) {
      case 5126:
        return t;
      case 5123:
        return Math.round(65535 * t);
      case 5121:
        return Math.round(255 * t);
      case 5122:
        return Math.round(32767 * t);
      case 5120:
        return Math.round(127 * t);
      default:
        throw new Error("Invalid component type.");
    }
  }
  static decompose(t, r, n, h) {
    let o = (0,gl_matrix_vec3__WEBPACK_IMPORTED_MODULE_0__.length)([t[0], t[1], t[2]]);
    const u = (0,gl_matrix_vec3__WEBPACK_IMPORTED_MODULE_0__.length)([t[4], t[5], t[6]]),
      c = (0,gl_matrix_vec3__WEBPACK_IMPORTED_MODULE_0__.length)([t[8], t[9], t[10]]);
    (0,gl_matrix_mat4__WEBPACK_IMPORTED_MODULE_1__.determinant)(t) < 0 && (o = -o), r[0] = t[12], r[1] = t[13], r[2] = t[14];
    const a = t.slice(),
      l = 1 / o,
      f = 1 / u,
      d = 1 / c;
    a[0] *= l, a[1] *= l, a[2] *= l, a[4] *= f, a[5] *= f, a[6] *= f, a[8] *= d, a[9] *= d, a[10] *= d, (0,gl_matrix_mat4__WEBPACK_IMPORTED_MODULE_1__.getRotation)(n, a), h[0] = o, h[1] = u, h[2] = c;
  }
  static compose(t, s, e, i) {
    const r = i,
      n = s[0],
      h = s[1],
      o = s[2],
      u = s[3],
      c = n + n,
      a = h + h,
      l = o + o,
      f = n * c,
      d = n * a,
      p = n * l,
      g = h * a,
      w = h * l,
      v = o * l,
      m = u * c,
      T = u * a,
      y = u * l,
      A = e[0],
      E = e[1],
      x = e[2];
    return r[0] = (1 - (g + v)) * A, r[1] = (d + y) * A, r[2] = (p - T) * A, r[3] = 0, r[4] = (d - y) * E, r[5] = (1 - (f + v)) * E, r[6] = (w + m) * E, r[7] = 0, r[8] = (p + T) * x, r[9] = (w - m) * x, r[10] = (1 - (f + g)) * x, r[11] = 0, r[12] = t[0], r[13] = t[1], r[14] = t[2], r[15] = 1, r;
  }
}
class I {
  constructor(t) {
    this.verbosity = void 0, this.verbosity = t;
  }
  debug(t) {
    this.verbosity <= I.Verbosity.DEBUG && console.debug(t);
  }
  info(t) {
    this.verbosity <= I.Verbosity.INFO && console.info(t);
  }
  warn(t) {
    this.verbosity <= I.Verbosity.WARN && console.warn(t);
  }
  error(t) {
    this.verbosity <= I.Verbosity.ERROR && console.error(t);
  }
}
I.Verbosity = {
  SILENT: 4,
  ERROR: 3,
  WARN: 2,
  INFO: 1,
  DEBUG: 0
}, I.DEFAULT_INSTANCE = new I(I.Verbosity.INFO);
const b = "23456789abdegjkmnpqrvwxyzABDEGJKMNPQRVWXYZ",
  R = new Set(),
  N = function () {
    let t = "";
    for (let s = 0; s < 6; s++) t += b.charAt(Math.floor(Math.random() * b.length));
    return t;
  },
  C = function () {
    for (let t = 0; t < 999; t++) {
      const t = N();
      if (!R.has(t)) return R.add(t), t;
    }
    return "";
  },
  O = t => t;
class _ extends class {
  constructor(t) {
    this.graph = void 0, this.o = !1, this.graph = t, this.graph = t;
  }
  canLink(t) {
    return this.graph === t.graph;
  }
  isDisposed() {
    return this.o;
  }
  dispose() {
    this.graph.disconnectChildren(this), this.graph.disconnectParents(this), this.o = !0, this.graph.emit("dispose", this);
  }
  detach() {
    return this.graph.disconnectParents(this), this;
  }
  swap(t, s) {
    return this.graph.swapChild(this, t, s), this;
  }
  addGraphChild(t, s) {
    return t.push(s), s.onDispose(() => {
      const e = t.filter(t => t !== s);
      t.length = 0;
      for (const s of e) t.push(s);
    }), this;
  }
  removeGraphChild(t, s) {
    return t.filter(t => t.getChild() === s).forEach(t => t.dispose()), this;
  }
  clearGraphChildList(t) {
    for (; t.length > 0;) t[0].dispose();
    return this;
  }
  listGraphParents() {
    return this.graph.listParents(this);
  }
} {
  constructor(t, s = "") {
    super(t), this.graph = void 0, this.m = {}, this.t = "", this.graph = t, this.t = s;
  }
  getName() {
    return this.t;
  }
  setName(t) {
    return this.t = t, this;
  }
  getExtras() {
    return this.m;
  }
  setExtras(t) {
    return this.m = t, this;
  }
  clone() {
    const t = new (0, this.constructor)(this.graph).copy(this, O);
    return this.graph.emit("clone", t), t;
  }
  copy(t, s = O) {
    return this.t = t.t, this.m = JSON.parse(JSON.stringify(t.m)), this;
  }
  detach() {
    return this.graph.disconnectParents(this, t => "Root" !== t.propertyType), this;
  }
  listParents() {
    return this.listGraphParents();
  }
}
const B = "Pass extension name (string) as lookup token, not a constructor.";
class L extends _ {
  constructor(...t) {
    super(...t), this.extensions = [];
  }
  copy(t, s = O) {
    return super.copy(t, s), this.clearGraphChildList(this.extensions), t.extensions.forEach(t => {
      const e = t.getChild();
      this.setExtension(e.extensionName, s(e));
    }), this;
  }
  getExtension(t) {
    if ("string" != typeof t) throw new Error(B);
    const s = this.extensions.find(s => s.getChild().extensionName === t);
    return s ? s.getChild() : null;
  }
  setExtension(t, s) {
    if ("string" != typeof t) throw new Error(B);
    const e = this.getExtension(t);
    return e && this.removeGraphChild(this.extensions, e), s ? (s.T(this), this.addGraphChild(this.extensions, this.graph.link(t, this, s))) : this;
  }
  listExtensions() {
    return this.extensions.map(t => t.getChild());
  }
}
l([g], L.prototype, "extensions", void 0);
class P extends L {
  constructor(...t) {
    super(...t), this.propertyType = o.ACCESSOR, this.S = null, this.M = P.Type.SCALAR, this.I = P.ComponentType.FLOAT, this.N = !1, this.C = M.identity, this.O = M.identity, this.buffer = null;
  }
  copy(t, s = O) {
    return super.copy(t, s), this.M = t.M, this.I = t.I, this.N = t.N, this.C = t.C, this.O = t.O, t.S && (this.S = t.S.slice()), this.setBuffer(t.buffer ? s(t.buffer.getChild()) : null), this;
  }
  static getElementSize(t) {
    switch (t) {
      case P.Type.SCALAR:
        return 1;
      case P.Type.VEC2:
        return 2;
      case P.Type.VEC3:
        return 3;
      case P.Type.VEC4:
      case P.Type.MAT2:
        return 4;
      case P.Type.MAT3:
        return 9;
      case P.Type.MAT4:
        return 16;
      default:
        throw new Error("Unexpected type: " + t);
    }
  }
  static getComponentSize(t) {
    switch (t) {
      case P.ComponentType.BYTE:
      case P.ComponentType.UNSIGNED_BYTE:
        return 1;
      case P.ComponentType.SHORT:
      case P.ComponentType.UNSIGNED_SHORT:
        return 2;
      case P.ComponentType.UNSIGNED_INT:
      case P.ComponentType.FLOAT:
        return 4;
      default:
        throw new Error("Unexpected component type: " + t);
    }
  }
  getMinNormalized(t) {
    const s = this.getElementSize();
    this.getMin(t);
    for (let e = 0; e < s; e++) t[e] = this.O(t[e]);
    return t;
  }
  getMin(t) {
    const s = this.getCount(),
      e = this.getElementSize();
    for (let s = 0; s < e; s++) t[s] = Infinity;
    for (let i = 0; i < s * e; i += e) for (let s = 0; s < e; s++) {
      const e = this.S[i + s];
      Number.isFinite(e) && (t[s] = Math.min(t[s], e));
    }
    return t;
  }
  getMaxNormalized(t) {
    const s = this.getElementSize();
    this.getMax(t);
    for (let e = 0; e < s; e++) t[e] = this.O(t[e]);
    return t;
  }
  getMax(t) {
    const s = this.getCount(),
      e = this.getElementSize();
    for (let s = 0; s < e; s++) t[s] = -Infinity;
    for (let i = 0; i < s * e; i += e) for (let s = 0; s < e; s++) {
      const e = this.S[i + s];
      Number.isFinite(e) && (t[s] = Math.max(t[s], e));
    }
    return t;
  }
  getCount() {
    return this.S ? this.S.length / this.getElementSize() : 0;
  }
  getType() {
    return this.M;
  }
  setType(t) {
    return this.M = t, this;
  }
  getElementSize() {
    return P.getElementSize(this.M);
  }
  getComponentSize() {
    return this.S.BYTES_PER_ELEMENT;
  }
  getComponentType() {
    return this.I;
  }
  getNormalized() {
    return this.N;
  }
  setNormalized(t) {
    return this.N = t, t ? (this.O = t => M.denormalize(t, this.I), this.C = t => M.normalize(t, this.I)) : (this.O = M.identity, this.C = M.identity), this;
  }
  getScalar(t) {
    const s = this.getElementSize();
    return this.O(this.S[t * s]);
  }
  setScalar(t, s) {
    return this.S[t * this.getElementSize()] = this.C(s), this;
  }
  getElement(t, s) {
    const e = this.getElementSize();
    for (let i = 0; i < e; i++) s[i] = this.O(this.S[t * e + i]);
    return s;
  }
  setElement(t, s) {
    const e = this.getElementSize();
    for (let i = 0; i < e; i++) this.S[t * e + i] = this.C(s[i]);
    return this;
  }
  getBuffer() {
    return this.buffer ? this.buffer.getChild() : null;
  }
  setBuffer(t) {
    return this.buffer = this.graph.link("buffer", this, t), this;
  }
  getArray() {
    return this.S;
  }
  setArray(t) {
    return this.I = t ? function (t) {
      switch (t.constructor) {
        case Float32Array:
          return P.ComponentType.FLOAT;
        case Uint32Array:
          return P.ComponentType.UNSIGNED_INT;
        case Uint16Array:
          return P.ComponentType.UNSIGNED_SHORT;
        case Uint8Array:
          return P.ComponentType.UNSIGNED_BYTE;
        case Int16Array:
          return P.ComponentType.SHORT;
        case Int8Array:
          return P.ComponentType.BYTE;
        default:
          throw new Error("Unknown accessor componentType.");
      }
    }(t) : P.ComponentType.FLOAT, this.S = t, this;
  }
  getByteLength() {
    return this.S ? this.S.byteLength : 0;
  }
}
P.Type = {
  SCALAR: "SCALAR",
  VEC2: "VEC2",
  VEC3: "VEC3",
  VEC4: "VEC4",
  MAT2: "MAT2",
  MAT3: "MAT3",
  MAT4: "MAT4"
}, P.ComponentType = {
  BYTE: 5120,
  UNSIGNED_BYTE: 5121,
  SHORT: 5122,
  UNSIGNED_SHORT: 5123,
  UNSIGNED_INT: 5125,
  FLOAT: 5126
}, l([p], P.prototype, "buffer", void 0);
class U extends L {
  constructor(...t) {
    super(...t), this.propertyType = o.ANIMATION, this.channels = [], this.samplers = [];
  }
  copy(t, s = O) {
    return super.copy(t, s), this.clearGraphChildList(this.channels), this.clearGraphChildList(this.samplers), t.channels.forEach(t => this.addChannel(s(t.getChild()))), t.samplers.forEach(t => this.addSampler(s(t.getChild()))), this;
  }
  addChannel(t) {
    const s = this.graph.link("channel", this, t);
    return this.addGraphChild(this.channels, s);
  }
  removeChannel(t) {
    return this.removeGraphChild(this.channels, t);
  }
  listChannels() {
    return this.channels.map(t => t.getChild());
  }
  addSampler(t) {
    const s = this.graph.link("sampler", this, t);
    return this.addGraphChild(this.samplers, s);
  }
  removeSampler(t) {
    return this.removeGraphChild(this.samplers, t);
  }
  listSamplers() {
    return this.samplers.map(t => t.getChild());
  }
}
l([g], U.prototype, "channels", void 0), l([g], U.prototype, "samplers", void 0);
class k extends _ {
  constructor(...t) {
    super(...t), this.propertyType = o.ANIMATION_CHANNEL, this._ = null, this.targetNode = null, this.sampler = null;
  }
  copy(t, s = O) {
    return super.copy(t, s), this._ = t._, this.setTargetNode(t.targetNode ? s(t.targetNode.getChild()) : null), this.setSampler(t.sampler ? s(t.sampler.getChild()) : null), this;
  }
  getTargetPath() {
    return this._;
  }
  setTargetPath(t) {
    return this._ = t, this;
  }
  getTargetNode() {
    return this.targetNode ? this.targetNode.getChild() : null;
  }
  setTargetNode(t) {
    return this.targetNode = this.graph.link("target.node", this, t), this;
  }
  getSampler() {
    return this.sampler ? this.sampler.getChild() : null;
  }
  setSampler(t) {
    return this.sampler = this.graph.link("sampler", this, t), this;
  }
}
k.TargetPath = {
  TRANSLATION: "translation",
  ROTATION: "rotation",
  SCALE: "scale",
  WEIGHTS: "weights"
}, l([p], k.prototype, "targetNode", void 0), l([p], k.prototype, "sampler", void 0);
class F extends _ {
  constructor(...t) {
    super(...t), this.propertyType = o.ANIMATION_SAMPLER, this.L = F.Interpolation.LINEAR, this.input = null, this.output = null;
  }
  copy(t, s = O) {
    return super.copy(t, s), this.L = t.L, this.setInput(t.input ? s(t.input.getChild()) : null), this.setOutput(t.output ? s(t.output.getChild()) : null), this;
  }
  getInterpolation() {
    return this.L;
  }
  setInterpolation(t) {
    return this.L = t, this;
  }
  getInput() {
    return this.input ? this.input.getChild() : null;
  }
  setInput(t) {
    return this.input = this.graph.link("input", this, t), this;
  }
  getOutput() {
    return this.output ? this.output.getChild() : null;
  }
  setOutput(t) {
    return this.output = this.graph.link("output", this, t), this;
  }
}
F.Interpolation = {
  LINEAR: "LINEAR",
  STEP: "STEP",
  CUBICSPLINE: "CUBICSPLINE"
}, l([p], F.prototype, "input", void 0), l([p], F.prototype, "output", void 0);
class G extends L {
  constructor(...t) {
    super(...t), this.propertyType = o.BUFFER, this.P = "";
  }
  copy(t, s = O) {
    return super.copy(t, s), this.P = t.P, this;
  }
  getURI() {
    return this.P;
  }
  setURI(t) {
    return this.P = t, this;
  }
}
class j extends L {
  constructor(...t) {
    super(...t), this.propertyType = o.CAMERA, this.M = j.Type.PERSPECTIVE, this.U = .1, this.k = 100, this.F = null, this.j = 2 * Math.PI * 50 / 360, this.D = 1, this.J = 1;
  }
  copy(t, s = O) {
    return super.copy(t, s), this.M = t.M, this.U = t.U, this.k = t.k, this.F = t.F, this.j = t.j, this.D = t.D, this.J = t.J, this;
  }
  getType() {
    return this.M;
  }
  setType(t) {
    return this.M = t, this;
  }
  getZNear() {
    return this.U;
  }
  setZNear(t) {
    return this.U = t, this;
  }
  getZFar() {
    return this.k;
  }
  setZFar(t) {
    return this.k = t, this;
  }
  getAspectRatio() {
    return this.F;
  }
  setAspectRatio(t) {
    return this.F = t, this;
  }
  getYFov() {
    return this.j;
  }
  setYFov(t) {
    return this.j = t, this;
  }
  getXMag() {
    return this.D;
  }
  setXMag(t) {
    return this.D = t, this;
  }
  getYMag() {
    return this.J;
  }
  setYMag(t) {
    return this.J = t, this;
  }
}
j.Type = {
  PERSPECTIVE: "perspective",
  ORTHOGRAPHIC: "orthographic"
};
class D extends _ {
  constructor(t, s) {
    super(t), this.$ = void 0, this.$ = s, this.$.addExtensionProperty(this);
  }
  clone() {
    const t = new (0, this.constructor)(this.graph, this.$).copy(this, O);
    return this.graph.emit("clone", t), t;
  }
  dispose() {
    this.$.removeExtensionProperty(this), super.dispose();
  }
  T(t) {
    if (!this.parentTypes.includes(t.propertyType)) throw new Error(`Parent "${t.propertyType}" invalid for child "${this.propertyType}".`);
  }
}
D.EXTENSION_NAME = void 0;
class J extends f {
  constructor(...t) {
    super(...t), this.semantic = "";
  }
  copy(t) {
    return this.semantic = t.semantic, this;
  }
}
class z extends f {
  copy(t) {
    return this;
  }
}
class $ extends f {
  constructor(...t) {
    super(...t), this.channels = 0;
  }
  copy(t) {
    return this.channels = t.channels, this;
  }
}
class V extends d {
  linkAttribute(t, s, e) {
    if (!e) return null;
    const i = new J(t, s, e);
    return i.semantic = t, this.registerLink(i), i;
  }
  linkIndex(t, s, e) {
    if (!e) return null;
    const i = new z(t, s, e);
    return this.registerLink(i), i;
  }
  linkTexture(t, s, e, i) {
    if (!i) return null;
    const r = new $(t, e, i);
    return r.channels = s, this.registerLink(r), r;
  }
}
class W extends L {
  constructor(...t) {
    super(...t), this.propertyType = o.TEXTURE_INFO, this.V = 0, this.W = null, this.q = null, this.Y = W.WrapMode.REPEAT, this.H = W.WrapMode.REPEAT;
  }
  copy(t, s = O) {
    return super.copy(t, s), this.V = t.V, this.W = t.W, this.q = t.q, this.Y = t.Y, this.H = t.H, this;
  }
  equals(t) {
    return this.getTexCoord() === t.getTexCoord() && this.getMagFilter() === t.getMagFilter() && this.getMinFilter() === t.getMinFilter() && this.getWrapS() === t.getWrapS() && this.getWrapT() === t.getWrapT();
  }
  getTexCoord() {
    return this.V;
  }
  setTexCoord(t) {
    return this.V = t, this;
  }
  getMagFilter() {
    return this.W;
  }
  setMagFilter(t) {
    return this.W = t, this;
  }
  getMinFilter() {
    return this.q;
  }
  setMinFilter(t) {
    return this.q = t, this;
  }
  getWrapS() {
    return this.Y;
  }
  setWrapS(t) {
    return this.Y = t, this;
  }
  getWrapT() {
    return this.H;
  }
  setWrapT(t) {
    return this.H = t, this;
  }
}
W.WrapMode = {
  CLAMP_TO_EDGE: 33071,
  MIRRORED_REPEAT: 33648,
  REPEAT: 10497
}, W.MagFilter = {
  NEAREST: 9728,
  LINEAR: 9729
}, W.MinFilter = {
  NEAREST: 9728,
  LINEAR: 9729,
  NEAREST_MIPMAP_NEAREST: 9984,
  LINEAR_MIPMAP_NEAREST: 9985,
  NEAREST_MIPMAP_LINEAR: 9986,
  LINEAR_MIPMAP_LINEAR: 9987
};
const {
  R: q,
  G: Y,
  B: H,
  A: Z
} = c;
class K extends L {
  constructor(...t) {
    super(...t), this.propertyType = o.MATERIAL, this.Z = K.AlphaMode.OPAQUE, this.K = .5, this.X = !1, this.tt = [1, 1, 1, 1], this.st = [0, 0, 0], this.et = 1, this.it = 1, this.rt = 1, this.nt = 1, this.baseColorTexture = null, this.baseColorTextureInfo = this.graph.link("baseColorTextureInfo", this, new W(this.graph)), this.emissiveTexture = null, this.emissiveTextureInfo = this.graph.link("emissiveTextureInfo", this, new W(this.graph)), this.normalTexture = null, this.normalTextureInfo = this.graph.link("normalTextureInfo", this, new W(this.graph)), this.occlusionTexture = null, this.occlusionTextureInfo = this.graph.link("occlusionTextureInfo", this, new W(this.graph)), this.metallicRoughnessTexture = null, this.metallicRoughnessTextureInfo = this.graph.link("metallicRoughnessTextureInfo", this, new W(this.graph));
  }
  copy(t, s = O) {
    return super.copy(t, s), this.Z = t.Z, this.K = t.K, this.X = t.X, this.tt = [...t.tt], this.st = [...t.st], this.et = t.et, this.it = t.it, this.rt = t.rt, this.nt = t.nt, this.setBaseColorTexture(t.baseColorTexture ? s(t.baseColorTexture.getChild()) : null), this.baseColorTextureInfo.getChild().copy(s(t.baseColorTextureInfo.getChild()), s), this.setEmissiveTexture(t.emissiveTexture ? s(t.emissiveTexture.getChild()) : null), this.emissiveTextureInfo.getChild().copy(s(t.emissiveTextureInfo.getChild()), s), this.setNormalTexture(t.normalTexture ? s(t.normalTexture.getChild()) : null), this.normalTextureInfo.getChild().copy(s(t.normalTextureInfo.getChild()), s), this.setOcclusionTexture(t.occlusionTexture ? s(t.occlusionTexture.getChild()) : null), this.occlusionTextureInfo.getChild().copy(s(t.occlusionTextureInfo.getChild()), s), this.setMetallicRoughnessTexture(t.metallicRoughnessTexture ? s(t.metallicRoughnessTexture.getChild()) : null), this.metallicRoughnessTextureInfo.getChild().copy(s(t.metallicRoughnessTextureInfo.getChild()), s), this;
  }
  equals(t) {
    if (this.getAlphaMode() !== t.getAlphaMode()) return !1;
    if (this.getAlphaCutoff() !== t.getAlphaCutoff()) return !1;
    if (this.getDoubleSided() !== t.getDoubleSided()) return !1;
    if (!M.eq(this.getBaseColorFactor(), t.getBaseColorFactor())) return !1;
    if (!M.eq(this.getEmissiveFactor(), t.getEmissiveFactor())) return !1;
    if (this.getNormalScale() !== t.getNormalScale()) return !1;
    if (this.getOcclusionStrength() !== t.getOcclusionStrength()) return !1;
    if (this.getRoughnessFactor() !== t.getRoughnessFactor()) return !1;
    if (this.getMetallicFactor() !== t.getMetallicFactor()) return !1;
    if (this.getBaseColorTexture() || t.getBaseColorTexture()) {
      if (this.getBaseColorTexture() !== t.getBaseColorTexture()) return !1;
      if (this.getBaseColorTexture() && !this.getBaseColorTextureInfo().equals(t.getBaseColorTextureInfo())) return !1;
    }
    if (this.getEmissiveTexture() || t.getEmissiveTexture()) {
      if (this.getEmissiveTexture() !== t.getEmissiveTexture()) return !1;
      if (this.getEmissiveTexture() && !this.getEmissiveTextureInfo().equals(t.getEmissiveTextureInfo())) return !1;
    }
    if (this.getNormalTexture() || t.getNormalTexture()) {
      if (this.getNormalTexture() !== t.getNormalTexture()) return !1;
      if (this.getNormalTexture() && !this.getNormalTextureInfo().equals(t.getNormalTextureInfo())) return !1;
    }
    if (this.getOcclusionTexture() || t.getOcclusionTexture()) {
      if (this.getOcclusionTexture() !== t.getOcclusionTexture()) return !1;
      if (this.getOcclusionTexture() && !this.getOcclusionTextureInfo().equals(t.getOcclusionTextureInfo())) return !1;
    }
    if (this.getMetallicRoughnessTexture() || t.getMetallicRoughnessTexture()) {
      if (this.getMetallicRoughnessTexture() !== t.getMetallicRoughnessTexture()) return !1;
      if (this.getMetallicRoughnessTexture() && !this.getMetallicRoughnessTextureInfo().equals(t.getMetallicRoughnessTextureInfo())) return !1;
    }
    const s = this.listExtensions(),
      e = t.listExtensions();
    if (s.length !== e.length) return !1;
    for (let t = 0; t < s.length; t++) if (s[t] !== e[t]) return !1;
    return !0;
  }
  dispose() {
    this.baseColorTextureInfo.getChild().dispose(), this.emissiveTextureInfo.getChild().dispose(), this.normalTextureInfo.getChild().dispose(), this.occlusionTextureInfo.getChild().dispose(), this.metallicRoughnessTextureInfo.getChild().dispose(), super.dispose();
  }
  getDoubleSided() {
    return this.X;
  }
  setDoubleSided(t) {
    return this.X = t, this;
  }
  getAlpha() {
    return this.tt[3];
  }
  setAlpha(t) {
    return this.tt[3] = t, this;
  }
  getAlphaMode() {
    return this.Z;
  }
  setAlphaMode(t) {
    return this.Z = t, this;
  }
  getAlphaCutoff() {
    return this.K;
  }
  setAlphaCutoff(t) {
    return this.K = t, this;
  }
  getBaseColorFactor() {
    return this.tt;
  }
  setBaseColorFactor(t) {
    return this.tt = t, this;
  }
  getBaseColorHex() {
    return y.factorToHex(this.tt);
  }
  setBaseColorHex(t) {
    return y.hexToFactor(t, this.tt), this;
  }
  getBaseColorTexture() {
    return this.baseColorTexture ? this.baseColorTexture.getChild() : null;
  }
  getBaseColorTextureInfo() {
    return this.baseColorTexture ? this.baseColorTextureInfo.getChild() : null;
  }
  setBaseColorTexture(t) {
    return this.baseColorTexture = this.graph.linkTexture("baseColorTexture", q | Y | H | Z, this, t), this;
  }
  getEmissiveFactor() {
    return this.st;
  }
  setEmissiveFactor(t) {
    return this.st = t, this;
  }
  getEmissiveHex() {
    return y.factorToHex(this.st);
  }
  setEmissiveHex(t) {
    return y.hexToFactor(t, this.st), this;
  }
  getEmissiveTexture() {
    return this.emissiveTexture ? this.emissiveTexture.getChild() : null;
  }
  getEmissiveTextureInfo() {
    return this.emissiveTexture ? this.emissiveTextureInfo.getChild() : null;
  }
  setEmissiveTexture(t) {
    return this.emissiveTexture = this.graph.linkTexture("emissiveTexture", q | Y | H, this, t), this;
  }
  getNormalScale() {
    return this.et;
  }
  setNormalScale(t) {
    return this.et = t, this;
  }
  getNormalTexture() {
    return this.normalTexture ? this.normalTexture.getChild() : null;
  }
  getNormalTextureInfo() {
    return this.normalTexture ? this.normalTextureInfo.getChild() : null;
  }
  setNormalTexture(t) {
    return this.normalTexture = this.graph.linkTexture("normalTexture", q | Y | H, this, t), this;
  }
  getOcclusionStrength() {
    return this.it;
  }
  setOcclusionStrength(t) {
    return this.it = t, this;
  }
  getOcclusionTexture() {
    return this.occlusionTexture ? this.occlusionTexture.getChild() : null;
  }
  getOcclusionTextureInfo() {
    return this.occlusionTexture ? this.occlusionTextureInfo.getChild() : null;
  }
  setOcclusionTexture(t) {
    return this.occlusionTexture = this.graph.linkTexture("occlusionTexture", q, this, t), this;
  }
  getRoughnessFactor() {
    return this.rt;
  }
  setRoughnessFactor(t) {
    return this.rt = t, this;
  }
  getMetallicFactor() {
    return this.nt;
  }
  setMetallicFactor(t) {
    return this.nt = t, this;
  }
  getMetallicRoughnessTexture() {
    return this.metallicRoughnessTexture ? this.metallicRoughnessTexture.getChild() : null;
  }
  getMetallicRoughnessTextureInfo() {
    return this.metallicRoughnessTexture ? this.metallicRoughnessTextureInfo.getChild() : null;
  }
  setMetallicRoughnessTexture(t) {
    return this.metallicRoughnessTexture = this.graph.linkTexture("metallicRoughnessTexture", Y | H, this, t), this;
  }
}
K.AlphaMode = {
  OPAQUE: "OPAQUE",
  MASK: "MASK",
  BLEND: "BLEND"
}, l([p], K.prototype, "baseColorTexture", void 0), l([p], K.prototype, "baseColorTextureInfo", void 0), l([p], K.prototype, "emissiveTexture", void 0), l([p], K.prototype, "emissiveTextureInfo", void 0), l([p], K.prototype, "normalTexture", void 0), l([p], K.prototype, "normalTextureInfo", void 0), l([p], K.prototype, "occlusionTexture", void 0), l([p], K.prototype, "occlusionTextureInfo", void 0), l([p], K.prototype, "metallicRoughnessTexture", void 0), l([p], K.prototype, "metallicRoughnessTextureInfo", void 0);
class Q extends L {
  constructor(...t) {
    super(...t), this.propertyType = o.MESH, this.ht = [], this.primitives = [];
  }
  copy(t, s = O) {
    return super.copy(t, s), this.ht = [...t.ht], this.clearGraphChildList(this.primitives), t.primitives.forEach(t => this.addPrimitive(s(t.getChild()))), this;
  }
  addPrimitive(t) {
    return this.addGraphChild(this.primitives, this.graph.link("primitive", this, t));
  }
  removePrimitive(t) {
    return this.removeGraphChild(this.primitives, t);
  }
  listPrimitives() {
    return this.primitives.map(t => t.getChild());
  }
  getWeights() {
    return this.ht;
  }
  setWeights(t) {
    return this.ht = t, this;
  }
}
l([g], Q.prototype, "primitives", void 0);
class X extends L {
  constructor(...t) {
    super(...t), this.propertyType = o.NODE, this.ot = [0, 0, 0], this.ut = [0, 0, 0, 1], this.ct = [1, 1, 1], this.ht = [], this.i = null, this.camera = null, this.mesh = null, this.skin = null, this.children = [];
  }
  copy(t, s = O) {
    return super.copy(t, s), this.ot = [...t.ot], this.ut = [...t.ut], this.ct = [...t.ct], this.ht = [...t.ht], this.setCamera(t.camera ? s(t.camera.getChild()) : null), this.setMesh(t.mesh ? s(t.mesh.getChild()) : null), this.setSkin(t.skin ? s(t.skin.getChild()) : null), s !== O && (this.clearGraphChildList(this.children), t.children.forEach(t => this.addChild(s(t.getChild())))), this;
  }
  getTranslation() {
    return this.ot;
  }
  getRotation() {
    return this.ut;
  }
  getScale() {
    return this.ct;
  }
  setTranslation(t) {
    return this.ot = t, this;
  }
  setRotation(t) {
    return this.ut = t, this;
  }
  setScale(t) {
    return this.ct = t, this;
  }
  getMatrix() {
    return M.compose(this.ot, this.ut, this.ct, []);
  }
  setMatrix(t) {
    return M.decompose(t, this.ot, this.ut, this.ct), this;
  }
  getWorldTranslation() {
    const t = [0, 0, 0];
    return M.decompose(this.getWorldMatrix(), t, [0, 0, 0, 1], [1, 1, 1]), t;
  }
  getWorldRotation() {
    const t = [0, 0, 0, 1];
    return M.decompose(this.getWorldMatrix(), [0, 0, 0], t, [1, 1, 1]), t;
  }
  getWorldScale() {
    const t = [1, 1, 1];
    return M.decompose(this.getWorldMatrix(), [0, 0, 0], [0, 0, 0, 1], t), t;
  }
  getWorldMatrix() {
    const t = [];
    for (let s = this; s instanceof X; s = s.i) t.push(s);
    let s;
    const e = t.pop().getMatrix();
    for (; s = t.pop();) (0,gl_matrix_mat4__WEBPACK_IMPORTED_MODULE_1__.multiply)(e, e, s.getMatrix());
    return e;
  }
  addChild(t) {
    t.i && t.i.removeChild(t);
    const s = this.graph.link("child", this, t);
    return this.addGraphChild(this.children, s), t.i = this, s.onDispose(() => t.i = null), this;
  }
  removeChild(t) {
    return this.removeGraphChild(this.children, t);
  }
  listChildren() {
    return this.children.map(t => t.getChild());
  }
  getParent() {
    return this.i;
  }
  getMesh() {
    return this.mesh ? this.mesh.getChild() : null;
  }
  setMesh(t) {
    return this.mesh = this.graph.link("mesh", this, t), this;
  }
  getCamera() {
    return this.camera ? this.camera.getChild() : null;
  }
  setCamera(t) {
    return this.camera = this.graph.link("camera", this, t), this;
  }
  getSkin() {
    return this.skin ? this.skin.getChild() : null;
  }
  setSkin(t) {
    return this.skin = this.graph.link("skin", this, t), this;
  }
  getWeights() {
    return this.ht;
  }
  setWeights(t) {
    return this.ht = t, this;
  }
  traverse(t) {
    t(this);
    for (const s of this.listChildren()) s.traverse(t);
    return this;
  }
}
l([p], X.prototype, "camera", void 0), l([p], X.prototype, "mesh", void 0), l([p], X.prototype, "skin", void 0), l([g], X.prototype, "children", void 0);
class tt extends L {
  constructor(...t) {
    super(...t), this.propertyType = o.PRIMITIVE, this.at = tt.Mode.TRIANGLES, this.material = null, this.indices = null, this.attributes = [], this.targets = [];
  }
  copy(t, s = O) {
    return super.copy(t, s), this.at = t.at, this.setIndices(t.indices ? s(t.indices.getChild()) : null), this.setMaterial(t.material ? s(t.material.getChild()) : null), this.clearGraphChildList(this.attributes), t.listSemantics().forEach(e => {
      this.setAttribute(e, s(t.getAttribute(e)));
    }), this.clearGraphChildList(this.targets), t.targets.forEach(t => this.addTarget(s(t.getChild()))), this;
  }
  getIndices() {
    return this.indices ? this.indices.getChild() : null;
  }
  setIndices(t) {
    return this.indices = this.graph.linkIndex("indices", this, t), this;
  }
  getAttribute(t) {
    const s = this.attributes.find(s => s.semantic === t);
    return s ? s.getChild() : null;
  }
  setAttribute(t, s) {
    const e = this.getAttribute(t);
    if (e && this.removeGraphChild(this.attributes, e), !s) return this;
    const i = this.graph.linkAttribute(t, this, s);
    return this.addGraphChild(this.attributes, i);
  }
  listAttributes() {
    return this.attributes.map(t => t.getChild());
  }
  listSemantics() {
    return this.attributes.map(t => t.semantic);
  }
  getMaterial() {
    return this.material ? this.material.getChild() : null;
  }
  setMaterial(t) {
    return this.material = this.graph.link("material", this, t), this;
  }
  getMode() {
    return this.at;
  }
  setMode(t) {
    return this.at = t, this;
  }
  listTargets() {
    return this.targets.map(t => t.getChild());
  }
  addTarget(t) {
    return this.addGraphChild(this.targets, this.graph.link("target", this, t)), this;
  }
  removeTarget(t) {
    return this.removeGraphChild(this.targets, t);
  }
}
tt.Mode = {
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6
}, l([p], tt.prototype, "material", void 0), l([p], tt.prototype, "indices", void 0), l([g], tt.prototype, "attributes", void 0), l([g], tt.prototype, "targets", void 0);
class st extends _ {
  constructor(...t) {
    super(...t), this.propertyType = o.PRIMITIVE_TARGET, this.attributes = [];
  }
  copy(t, s = O) {
    return super.copy(t, s), this.clearGraphChildList(this.attributes), t.listSemantics().forEach(e => {
      this.setAttribute(e, s(t.getAttribute(e)));
    }), this;
  }
  getAttribute(t) {
    const s = this.attributes.find(s => s.semantic === t);
    return s ? s.getChild() : null;
  }
  setAttribute(t, s) {
    const e = this.getAttribute(t);
    if (e && this.removeGraphChild(this.attributes, e), !s) return this;
    const i = this.graph.linkAttribute(t, this, s);
    return i.semantic = t, this.addGraphChild(this.attributes, i);
  }
  listAttributes() {
    return this.attributes.map(t => t.getChild());
  }
  listSemantics() {
    return this.attributes.map(t => t.semantic);
  }
}
l([g], st.prototype, "attributes", void 0);
class et extends L {
  constructor(...t) {
    super(...t), this.propertyType = o.SCENE, this.children = [];
  }
  copy(t, s = O) {
    return super.copy(t, s), s !== O && (this.clearGraphChildList(this.children), t.children.forEach(t => this.addChild(s(t.getChild())))), this;
  }
  addChild(t) {
    t.i && t.i.removeChild(t);
    const s = this.graph.link("child", this, t);
    return this.addGraphChild(this.children, s), t.i = this, s.onDispose(() => t.i = null), this;
  }
  removeChild(t) {
    return this.removeGraphChild(this.children, t);
  }
  listChildren() {
    return this.children.map(t => t.getChild());
  }
  traverse(t) {
    for (const s of this.listChildren()) s.traverse(t);
    return this;
  }
}
l([g], et.prototype, "children", void 0);
class it extends L {
  constructor(...t) {
    super(...t), this.propertyType = o.SKIN, this.skeleton = null, this.inverseBindMatrices = null, this.joints = [];
  }
  copy(t, s = O) {
    return super.copy(t, s), this.setSkeleton(t.skeleton ? s(t.skeleton.getChild()) : null), this.setInverseBindMatrices(t.inverseBindMatrices ? s(t.inverseBindMatrices.getChild()) : null), this.clearGraphChildList(this.joints), t.joints.forEach(t => this.addJoint(s(t.getChild()))), this;
  }
  getSkeleton() {
    return this.skeleton ? this.skeleton.getChild() : null;
  }
  setSkeleton(t) {
    return this.skeleton = this.graph.link("skeleton", this, t), this;
  }
  getInverseBindMatrices() {
    return this.inverseBindMatrices ? this.inverseBindMatrices.getChild() : null;
  }
  setInverseBindMatrices(t) {
    return this.inverseBindMatrices = this.graph.link("inverseBindMatrices", this, t), this;
  }
  addJoint(t) {
    const s = this.graph.link("joint", this, t);
    return this.addGraphChild(this.joints, s);
  }
  removeJoint(t) {
    return this.removeGraphChild(this.joints, t);
  }
  listJoints() {
    return this.joints.map(t => t.getChild());
  }
}
l([p], it.prototype, "skeleton", void 0), l([p], it.prototype, "inverseBindMatrices", void 0), l([g], it.prototype, "joints", void 0);
class rt extends L {
  constructor(...t) {
    super(...t), this.propertyType = o.TEXTURE, this.lt = null, this.ft = "", this.P = "";
  }
  copy(t, s = O) {
    return super.copy(t, s), this.ft = t.ft, this.P = t.P, t.lt && (this.lt = t.lt.slice(0)), this;
  }
  getMimeType() {
    return this.ft || x.extensionToMimeType(A.extension(this.P));
  }
  setMimeType(t) {
    return this.ft = t, this;
  }
  getURI() {
    return this.P;
  }
  setURI(t) {
    return this.P = t, this.ft = x.extensionToMimeType(A.extension(t)), this;
  }
  getImage() {
    return this.lt;
  }
  setImage(t) {
    return this.lt = t, this;
  }
  getSize() {
    return this.lt ? x.getSize(this.lt, this.getMimeType()) : null;
  }
}
class nt extends _ {
  constructor(t) {
    super(t), this.propertyType = o.ROOT, this.dt = {
      generator: "glTF-Transform v1.2.4",
      version: "2.0"
    }, this.gt = new Set(), this.defaultScene = null, this.accessors = [], this.animations = [], this.buffers = [], this.cameras = [], this.materials = [], this.meshes = [], this.nodes = [], this.scenes = [], this.skins = [], this.textures = [], t.on("clone", t => this.wt(t));
  }
  clone() {
    throw new Error("Root cannot be cloned.");
  }
  copy(t, s = O) {
    if (super.copy(t, s), s === O) throw new Error("Root cannot be copied.");
    return Object.assign(this.dt, t.dt), t.accessors.forEach(t => this.vt(s(t.getChild()))), t.animations.forEach(t => this.Tt(s(t.getChild()))), t.buffers.forEach(t => this.yt(s(t.getChild()))), t.cameras.forEach(t => this.At(s(t.getChild()))), t.materials.forEach(t => this.Et(s(t.getChild()))), t.meshes.forEach(t => this.xt(s(t.getChild()))), t.nodes.forEach(t => this.St(s(t.getChild()))), t.scenes.forEach(t => this.Mt(s(t.getChild()))), t.skins.forEach(t => this.It(s(t.getChild()))), t.textures.forEach(t => this.bt(s(t.getChild()))), this.setDefaultScene(t.defaultScene ? s(t.defaultScene.getChild()) : null), this;
  }
  wt(t) {
    return t instanceof et ? this.Mt(t) : t instanceof X ? this.St(t) : t instanceof j ? this.At(t) : t instanceof it ? this.It(t) : t instanceof Q ? this.xt(t) : t instanceof K ? this.Et(t) : t instanceof rt ? this.bt(t) : t instanceof U ? this.Tt(t) : t instanceof P ? this.vt(t) : t instanceof G && this.yt(t), this;
  }
  getAsset() {
    return this.dt;
  }
  listExtensionsUsed() {
    return Array.from(this.gt);
  }
  listExtensionsRequired() {
    return this.listExtensionsUsed().filter(t => t.isRequired());
  }
  Rt(t) {
    return this.gt.add(t), this;
  }
  Nt(t) {
    return this.gt.delete(t), this;
  }
  Mt(t) {
    return this.addGraphChild(this.scenes, this.graph.link("scene", this, t));
  }
  listScenes() {
    return this.scenes.map(t => t.getChild());
  }
  setDefaultScene(t) {
    return this.defaultScene = this.graph.link("scene", this, t), this;
  }
  getDefaultScene() {
    return this.defaultScene ? this.defaultScene.getChild() : null;
  }
  St(t) {
    return this.addGraphChild(this.nodes, this.graph.link("node", this, t));
  }
  listNodes() {
    return this.nodes.map(t => t.getChild());
  }
  At(t) {
    return this.addGraphChild(this.cameras, this.graph.link("camera", this, t));
  }
  listCameras() {
    return this.cameras.map(t => t.getChild());
  }
  It(t) {
    return this.addGraphChild(this.skins, this.graph.link("skin", this, t));
  }
  listSkins() {
    return this.skins.map(t => t.getChild());
  }
  xt(t) {
    return this.addGraphChild(this.meshes, this.graph.link("mesh", this, t));
  }
  listMeshes() {
    return this.meshes.map(t => t.getChild());
  }
  Et(t) {
    return this.addGraphChild(this.materials, this.graph.link("material", this, t));
  }
  listMaterials() {
    return this.materials.map(t => t.getChild());
  }
  bt(t) {
    return this.addGraphChild(this.textures, this.graph.link("texture", this, t));
  }
  listTextures() {
    return this.textures.map(t => t.getChild());
  }
  Tt(t) {
    return this.addGraphChild(this.animations, this.graph.link("animation", this, t));
  }
  listAnimations() {
    return this.animations.map(t => t.getChild());
  }
  vt(t) {
    return this.addGraphChild(this.accessors, this.graph.link("accessor", this, t));
  }
  listAccessors() {
    return this.accessors.map(t => t.getChild());
  }
  yt(t) {
    return this.addGraphChild(this.buffers, this.graph.link("buffer", this, t));
  }
  listBuffers() {
    return this.buffers.map(t => t.getChild());
  }
}
l([p], nt.prototype, "defaultScene", void 0), l([g], nt.prototype, "accessors", void 0), l([g], nt.prototype, "animations", void 0), l([g], nt.prototype, "buffers", void 0), l([g], nt.prototype, "cameras", void 0), l([g], nt.prototype, "materials", void 0), l([g], nt.prototype, "meshes", void 0), l([g], nt.prototype, "nodes", void 0), l([g], nt.prototype, "scenes", void 0), l([g], nt.prototype, "skins", void 0), l([g], nt.prototype, "textures", void 0);
class ht {
  constructor() {
    this.Ct = new V(), this.Ot = new nt(this.Ct), this._t = I.DEFAULT_INSTANCE;
  }
  getRoot() {
    return this.Ot;
  }
  getGraph() {
    return this.Ct;
  }
  getLogger() {
    return this._t;
  }
  setLogger(t) {
    return this._t = t, this;
  }
  clone() {
    return new ht().merge(this).setLogger(this._t);
  }
  merge(t) {
    const s = {};
    for (const e of t.getRoot().listExtensionsUsed()) {
      const t = this.createExtension(e.constructor);
      e.isRequired() && t.setRequired(!0), s[t.extensionName] = t;
    }
    const e = new Set(),
      i = new Map();
    e.add(t.Ot), i.set(t.Ot, this.Ot);
    for (const r of t.Ct.getLinks()) for (const t of [r.getParent(), r.getChild()]) {
      if (e.has(t)) continue;
      let r;
      if (t.propertyType === o.TEXTURE_INFO) r = t;else {
        const e = t.constructor;
        r = t instanceof D ? new e(this.Ct, s[t.extensionName]) : new e(this.Ct);
      }
      i.set(t, r), e.add(t);
    }
    const r = t => {
      const s = i.get(t);
      if (!s) throw new Error("Could resolve property.");
      return s;
    };
    for (const t of e) {
      const s = i.get(t);
      if (!s) throw new Error("Could resolve property.");
      s.copy(t, r);
    }
    return this;
  }
  async transform(...t) {
    const s = t.map(t => t.name);
    for (const e of t) await e(this, {
      stack: s
    });
    return this;
  }
  createExtension(t) {
    const s = t.EXTENSION_NAME;
    return this.getRoot().listExtensionsUsed().find(t => t.extensionName === s) || new t(this);
  }
  createScene(t = "") {
    const s = new et(this.Ct, t);
    return this.Ot.Mt(s), s;
  }
  createNode(t = "") {
    const s = new X(this.Ct, t);
    return this.Ot.St(s), s;
  }
  createCamera(t = "") {
    const s = new j(this.Ct, t);
    return this.Ot.At(s), s;
  }
  createSkin(t = "") {
    const s = new it(this.Ct, t);
    return this.Ot.It(s), s;
  }
  createMesh(t = "") {
    const s = new Q(this.Ct, t);
    return this.Ot.xt(s), s;
  }
  createPrimitive() {
    return new tt(this.Ct);
  }
  createPrimitiveTarget(t = "") {
    return new st(this.Ct, t);
  }
  createMaterial(t = "") {
    const s = new K(this.Ct, t);
    return this.Ot.Et(s), s;
  }
  createTexture(t = "") {
    const s = new rt(this.Ct, t);
    return this.Ot.bt(s), s;
  }
  createAnimation(t = "") {
    const s = new U(this.Ct, t);
    return this.Ot.Tt(s), s;
  }
  createAnimationChannel(t = "") {
    return new k(this.Ct, t);
  }
  createAnimationSampler(t = "") {
    return new F(this.Ct, t);
  }
  createAccessor(t = "", s = null) {
    s || (s = this.getRoot().listBuffers()[0]);
    const e = new P(this.Ct, t).setBuffer(s);
    return this.Ot.vt(e), e;
  }
  createBuffer(t = "") {
    const s = new G(this.Ct, t);
    return this.Ot.yt(s), s;
  }
}
class ot {
  constructor(t) {
    this.doc = void 0, this.extensionName = "", this.prereadTypes = [], this.prewriteTypes = [], this.readDependencies = [], this.writeDependencies = [], this.required = !1, this.properties = new Set(), this.doc = t, t.getRoot().Rt(this);
  }
  dispose() {
    this.doc.getRoot().Nt(this);
    for (const t of this.properties) t.dispose();
  }
  static register() {}
  isRequired() {
    return this.required;
  }
  setRequired(t) {
    return this.required = t, this;
  }
  addExtensionProperty(t) {
    return this.properties.add(t), this;
  }
  removeExtensionProperty(t) {
    return this.properties.delete(t), this;
  }
  install(t, s) {
    return this;
  }
  preread(t, s) {
    return this;
  }
  prewrite(t, s) {
    return this;
  }
}
function ut() {
  return (ut = Object.assign || function (t) {
    for (var s = 1; s < arguments.length; s++) {
      var e = arguments[s];
      for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
    }
    return t;
  }).apply(this, arguments);
}
ot.EXTENSION_NAME = void 0;
class ct {
  constructor(t) {
    this.jsonDoc = void 0, this.buffers = [], this.bufferViews = [], this.bufferViewBuffers = [], this.accessors = [], this.textures = [], this.textureInfos = new Map(), this.materials = [], this.meshes = [], this.cameras = [], this.nodes = [], this.skins = [], this.animations = [], this.scenes = [], this.jsonDoc = t;
  }
  setTextureInfo(t, s) {
    this.textureInfos.set(t, s), void 0 !== s.texCoord && t.setTexCoord(s.texCoord);
    const e = this.jsonDoc.json.textures[s.index];
    if (void 0 === e.sampler) return;
    const i = this.jsonDoc.json.samplers[e.sampler];
    void 0 !== i.magFilter && t.setMagFilter(i.magFilter), void 0 !== i.minFilter && t.setMinFilter(i.minFilter), void 0 !== i.wrapS && t.setWrapS(i.wrapS), void 0 !== i.wrapT && t.setWrapT(i.wrapT);
  }
}
const at = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
  },
  lt = {
    logger: I.DEFAULT_INSTANCE,
    extensions: [],
    dependencies: {}
  };
function ft(t, s) {
  const e = s.bufferViews[t.bufferView],
    i = s.jsonDoc.json.bufferViews[t.bufferView],
    r = at[t.componentType],
    n = P.getElementSize(t.type),
    h = r.BYTES_PER_ELEMENT;
  if (void 0 !== i.byteStride && i.byteStride !== n * h) return function (t, s) {
    const e = s.bufferViews[t.bufferView],
      i = s.jsonDoc.json.bufferViews[t.bufferView],
      r = at[t.componentType],
      n = P.getElementSize(t.type),
      h = r.BYTES_PER_ELEMENT,
      o = t.byteOffset || 0,
      u = new r(t.count * n),
      c = new DataView(e.buffer, e.byteOffset, e.byteLength),
      a = i.byteStride;
    for (let s = 0; s < t.count; s++) for (let e = 0; e < n; e++) {
      const i = o + s * a + e * h;
      let r;
      switch (t.componentType) {
        case P.ComponentType.FLOAT:
          r = c.getFloat32(i, !0);
          break;
        case P.ComponentType.UNSIGNED_INT:
          r = c.getUint32(i, !0);
          break;
        case P.ComponentType.UNSIGNED_SHORT:
          r = c.getUint16(i, !0);
          break;
        case P.ComponentType.UNSIGNED_BYTE:
          r = c.getUint8(i);
          break;
        case P.ComponentType.SHORT:
          r = c.getInt16(i, !0);
          break;
        case P.ComponentType.BYTE:
          r = c.getInt8(i);
          break;
        default:
          throw new Error(`Unexpected componentType "${t.componentType}".`);
      }
      u[s * n + e] = r;
    }
    return u;
  }(t, s);
  const o = e.byteOffset + (t.byteOffset || 0);
  return new r(e.buffer.slice(o, o + t.count * n * h));
}
var dt, pt;
!function (t) {
  t[t.ARRAY_BUFFER = 34962] = "ARRAY_BUFFER", t[t.ELEMENT_ARRAY_BUFFER = 34963] = "ELEMENT_ARRAY_BUFFER";
}(dt || (dt = {})), function (t) {
  t.ARRAY_BUFFER = "ARRAY_BUFFER", t.ELEMENT_ARRAY_BUFFER = "ELEMENT_ARRAY_BUFFER", t.INVERSE_BIND_MATRICES = "INVERSE_BIND_MATRICES", t.OTHER = "OTHER";
}(pt || (pt = {}));
class gt {
  constructor(t, s, e) {
    this.Bt = void 0, this.jsonDoc = void 0, this.options = void 0, this.accessorIndexMap = new Map(), this.bufferIndexMap = new Map(), this.cameraIndexMap = new Map(), this.skinIndexMap = new Map(), this.materialIndexMap = new Map(), this.meshIndexMap = new Map(), this.nodeIndexMap = new Map(), this.imageIndexMap = new Map(), this.textureDefIndexMap = new Map(), this.textureInfoDefMap = new Map(), this.samplerDefIndexMap = new Map(), this.imageBufferViews = [], this.otherBufferViews = new Map(), this.otherBufferViewsIndexMap = new Map(), this.extensionData = {}, this.bufferURIGenerator = void 0, this.imageURIGenerator = void 0, this.logger = void 0, this.Lt = new Map(), this.accessorUsageGroupedByParent = new Set(["ARRAY_BUFFER"]), this.accessorParents = new Map(), this.Bt = t, this.jsonDoc = s, this.options = e;
    const i = t.getRoot(),
      r = i.listBuffers().length,
      n = i.listTextures().length;
    this.bufferURIGenerator = new wt(r > 1, e.basename), this.imageURIGenerator = new wt(n > 1, e.basename), this.logger = t.getLogger();
  }
  createTextureInfoDef(t, s) {
    const e = {
        magFilter: s.getMagFilter() || void 0,
        minFilter: s.getMinFilter() || void 0,
        wrapS: s.getWrapS(),
        wrapT: s.getWrapT()
      },
      i = JSON.stringify(e);
    this.samplerDefIndexMap.has(i) || (this.samplerDefIndexMap.set(i, this.jsonDoc.json.samplers.length), this.jsonDoc.json.samplers.push(e));
    const r = {
        source: this.imageIndexMap.get(t),
        sampler: this.samplerDefIndexMap.get(i)
      },
      n = JSON.stringify(r);
    this.textureDefIndexMap.has(n) || (this.textureDefIndexMap.set(n, this.jsonDoc.json.textures.length), this.jsonDoc.json.textures.push(r));
    const h = {
      index: this.textureDefIndexMap.get(n)
    };
    return 0 !== s.getTexCoord() && (h.texCoord = s.getTexCoord()), this.textureInfoDefMap.set(s, h), h;
  }
  createPropertyDef(t) {
    const s = {};
    return t.getName() && (s.name = t.getName()), Object.keys(t.getExtras()).length > 0 && (s.extras = t.getExtras()), s;
  }
  createAccessorDef(t) {
    const s = this.createPropertyDef(t);
    return s.type = t.getType(), s.componentType = t.getComponentType(), s.count = t.getCount(), this.Bt.getGraph().listParentLinks(t).some(t => "POSITION" === t.getName() || "input" === t.getName()) && (s.max = t.getMax([]).map(Math.fround), s.min = t.getMin([]).map(Math.fround)), t.getNormalized() && (s.normalized = t.getNormalized()), s;
  }
  createImageData(t, s, e) {
    if (this.options.format === a.GLB) this.imageBufferViews.push(s), t.bufferView = this.jsonDoc.json.bufferViews.length, this.jsonDoc.json.bufferViews.push({
      buffer: 0,
      byteOffset: -1,
      byteLength: s.byteLength
    });else {
      const i = x.mimeTypeToExtension(e.getMimeType());
      t.uri = this.imageURIGenerator.createURI(e, i), this.jsonDoc.resources[t.uri] = s;
    }
  }
  getAccessorUsage(t) {
    const s = this.Lt.get(t);
    if (s) return s;
    for (const s of this.Bt.getGraph().listParentLinks(t)) {
      if ("inverseBindMatrices" === s.getName()) return gt.BufferViewUsage.INVERSE_BIND_MATRICES;
      if (s instanceof J) return gt.BufferViewUsage.ARRAY_BUFFER;
      if (s instanceof z) return gt.BufferViewUsage.ELEMENT_ARRAY_BUFFER;
    }
    return gt.BufferViewUsage.OTHER;
  }
  addAccessorToUsageGroup(t, s) {
    const e = this.Lt.get(t);
    if (e && e !== s) throw new Error(`Accessor with usage "${e}" cannot be reused as "${s}".`);
    return this.Lt.set(t, s), this;
  }
  listAccessorUsageGroups() {
    const t = {};
    for (const [s, e] of Array.from(this.Lt.entries())) t[e] = t[e] || [], t[e].push(s);
    return t;
  }
}
gt.BufferViewTarget = dt, gt.BufferViewUsage = pt, gt.USAGE_TO_TARGET = {
  [pt.ARRAY_BUFFER]: dt.ARRAY_BUFFER,
  [pt.ELEMENT_ARRAY_BUFFER]: dt.ELEMENT_ARRAY_BUFFER
};
class wt {
  constructor(t, s) {
    this.multiple = void 0, this.basename = void 0, this.counter = 1, this.multiple = t, this.basename = s;
  }
  createURI(t, s) {
    return t.getURI() ? t.getURI() : this.multiple ? `${this.basename}_${this.counter++}.${s}` : `${this.basename}.${s}`;
  }
}
const {
  BufferViewUsage: vt
} = gt;
var mt;
!function (t) {
  t[t.JSON = 1313821514] = "JSON", t[t.BIN = 5130562] = "BIN";
}(mt || (mt = {}));
class Tt {
  constructor() {
    this._t = I.DEFAULT_INSTANCE, this.gt = new Set(), this.Pt = {}, this.Ut = u.INTERLEAVED;
  }
  setLogger(t) {
    return this._t = t, this;
  }
  registerExtensions(t) {
    for (const s of t) this.gt.add(s), s.register();
    return this;
  }
  registerDependencies(t) {
    return Object.assign(this.Pt, t), this;
  }
  setVertexLayout(t) {
    return this.Ut = t, this;
  }
  kt(t) {
    function s(s) {
      if (s.uri && !(s.uri in t.resources) && s.uri.match(/data:/)) {
        const e = `__${C()}.${A.extension(s.uri)}`;
        t.resources[e] = T.createBufferFromDataURI(s.uri), s.uri = e;
      }
    }
    (t.json.images || []).forEach(t => {
      if (void 0 === t.bufferView && void 0 === t.uri) throw new Error("Missing resource URI or buffer view.");
      s(t);
    }), (t.json.buffers || []).forEach(s);
  }
  readJSON(t) {
    return t = this.Ft(t), this.kt(t), class {
      static read(t, s = lt) {
        const e = ut({}, lt, s),
          {
            json: i
          } = t,
          r = new ht();
        this.validate(t, e);
        const n = new ct(t),
          h = i.asset,
          u = r.getRoot().getAsset();
        h.copyright && (u.copyright = h.copyright), h.extras && (u.extras = h.extras), void 0 !== i.extras && r.getRoot().setExtras(ut({}, i.extras));
        const c = i.extensionsUsed || [],
          a = i.extensionsRequired || [];
        for (const t of e.extensions) if (c.includes(t.EXTENSION_NAME)) {
          const s = r.createExtension(t).setRequired(a.includes(t.EXTENSION_NAME));
          for (const t of s.readDependencies) s.install(t, e.dependencies[t]);
        }
        const l = i.buffers || [];
        r.getRoot().listExtensionsUsed().filter(t => t.prereadTypes.includes(o.BUFFER)).forEach(t => t.preread(n, o.BUFFER)), n.buffers = l.map(t => {
          const s = r.createBuffer(t.name);
          return t.extras && s.setExtras(t.extras), t.uri && 0 !== t.uri.indexOf("__") && s.setURI(t.uri), s;
        }), n.bufferViewBuffers = (i.bufferViews || []).map((s, e) => {
          if (!n.bufferViews[e]) {
            const i = t.json.buffers[s.buffer],
              r = new Uint8Array(i.uri ? t.resources[i.uri] : t.resources["@glb.bin"], s.byteOffset || 0, s.byteLength);
            n.bufferViews[e] = r;
          }
          return n.buffers[s.buffer];
        }), n.accessors = (i.accessors || []).map(t => {
          const s = r.createAccessor(t.name, n.bufferViewBuffers[t.bufferView]).setType(t.type);
          if (t.extras && s.setExtras(t.extras), void 0 !== t.normalized && s.setNormalized(t.normalized), void 0 === t.bufferView && !t.sparse) return s;
          let e;
          return e = void 0 !== t.sparse ? function (t, s) {
            const e = at[t.componentType],
              i = P.getElementSize(t.type);
            let r;
            r = void 0 !== t.bufferView ? ft(t, s) : new e(t.count * i);
            const n = t.sparse,
              h = n.count,
              o = ut({}, t, n.indices, {
                count: h,
                type: "SCALAR"
              }),
              u = ut({}, t, n.values, {
                count: h
              }),
              c = ft(o, s),
              a = ft(u, s);
            for (let t = 0; t < o.count; t++) for (let s = 0; s < i; s++) r[c[t] * i + s] = a[t * i + s];
            return r;
          }(t, n) : ft(t, n), s.setArray(e), s;
        });
        const f = i.images || [],
          d = i.textures || [];
        r.getRoot().listExtensionsUsed().filter(t => t.prereadTypes.includes(o.TEXTURE)).forEach(t => t.preread(n, o.TEXTURE)), n.textures = f.map(s => {
          const e = r.createTexture(s.name);
          if (s.extras && e.setExtras(s.extras), void 0 !== s.bufferView) {
            const r = i.bufferViews[s.bufferView],
              n = t.json.buffers[r.buffer],
              h = r.byteOffset || 0,
              o = (n.uri ? t.resources[n.uri] : t.resources["@glb.bin"]).slice(h, h + r.byteLength);
            e.setImage(o);
          } else void 0 !== s.uri && (e.setImage(t.resources[s.uri]), 0 !== s.uri.indexOf("__") && e.setURI(s.uri));
          if (void 0 !== s.mimeType) e.setMimeType(s.mimeType);else if (s.uri) {
            const t = A.extension(s.uri);
            e.setMimeType(x.extensionToMimeType(t));
          }
          return e;
        }), n.materials = (i.materials || []).map(t => {
          const s = r.createMaterial(t.name);
          t.extras && s.setExtras(t.extras), void 0 !== t.alphaMode && s.setAlphaMode(t.alphaMode), void 0 !== t.alphaCutoff && s.setAlphaCutoff(t.alphaCutoff), void 0 !== t.doubleSided && s.setDoubleSided(t.doubleSided);
          const e = t.pbrMetallicRoughness || {};
          if (void 0 !== e.baseColorFactor && s.setBaseColorFactor(e.baseColorFactor), void 0 !== t.emissiveFactor && s.setEmissiveFactor(t.emissiveFactor), void 0 !== e.metallicFactor && s.setMetallicFactor(e.metallicFactor), void 0 !== e.roughnessFactor && s.setRoughnessFactor(e.roughnessFactor), void 0 !== e.baseColorTexture) {
            const t = e.baseColorTexture;
            s.setBaseColorTexture(n.textures[d[t.index].source]), n.setTextureInfo(s.getBaseColorTextureInfo(), t);
          }
          if (void 0 !== t.emissiveTexture) {
            const e = t.emissiveTexture;
            s.setEmissiveTexture(n.textures[d[e.index].source]), n.setTextureInfo(s.getEmissiveTextureInfo(), e);
          }
          if (void 0 !== t.normalTexture) {
            const e = t.normalTexture;
            s.setNormalTexture(n.textures[d[e.index].source]), n.setTextureInfo(s.getNormalTextureInfo(), e), void 0 !== t.normalTexture.scale && s.setNormalScale(t.normalTexture.scale);
          }
          if (void 0 !== t.occlusionTexture) {
            const e = t.occlusionTexture;
            s.setOcclusionTexture(n.textures[d[e.index].source]), n.setTextureInfo(s.getOcclusionTextureInfo(), e), void 0 !== t.occlusionTexture.strength && s.setOcclusionStrength(t.occlusionTexture.strength);
          }
          if (void 0 !== e.metallicRoughnessTexture) {
            const t = e.metallicRoughnessTexture;
            s.setMetallicRoughnessTexture(n.textures[d[t.index].source]), n.setTextureInfo(s.getMetallicRoughnessTextureInfo(), t);
          }
          return s;
        });
        const p = i.meshes || [];
        r.getRoot().listExtensionsUsed().filter(t => t.prereadTypes.includes(o.PRIMITIVE)).forEach(t => t.preread(n, o.PRIMITIVE)), n.meshes = p.map(t => {
          const s = r.createMesh(t.name);
          return t.extras && s.setExtras(t.extras), void 0 !== t.weights && s.setWeights(t.weights), (t.primitives || []).forEach(e => {
            const i = r.createPrimitive();
            e.extras && i.setExtras(e.extras), void 0 !== e.material && i.setMaterial(n.materials[e.material]), void 0 !== e.mode && i.setMode(e.mode);
            for (const [t, s] of Object.entries(e.attributes || {})) i.setAttribute(t, n.accessors[s]);
            void 0 !== e.indices && i.setIndices(n.accessors[e.indices]);
            const h = t.extras && t.extras.targetNames || [];
            (e.targets || []).forEach((t, s) => {
              const e = h[s] || s.toString(),
                o = r.createPrimitiveTarget(e);
              for (const [s, e] of Object.entries(t)) o.setAttribute(s, n.accessors[e]);
              i.addTarget(o);
            }), s.addPrimitive(i);
          }), s;
        }), n.cameras = (i.cameras || []).map(t => {
          const s = r.createCamera(t.name).setType(t.type);
          if (t.extras && s.setExtras(t.extras), t.type === j.Type.PERSPECTIVE) {
            const e = t.perspective;
            s.setYFov(e.yfov), s.setZNear(e.znear), void 0 !== e.zfar && s.setZFar(e.zfar), void 0 !== e.aspectRatio && s.setAspectRatio(e.aspectRatio);
          } else {
            const e = t.orthographic;
            s.setZNear(e.znear).setZFar(e.zfar).setXMag(e.xmag).setYMag(e.ymag);
          }
          return s;
        });
        const g = i.nodes || [];
        r.getRoot().listExtensionsUsed().filter(t => t.prereadTypes.includes(o.NODE)).forEach(t => t.preread(n, o.NODE)), n.nodes = g.map(t => {
          const s = r.createNode(t.name);
          if (t.extras && s.setExtras(t.extras), void 0 !== t.translation && s.setTranslation(t.translation), void 0 !== t.rotation && s.setRotation(t.rotation), void 0 !== t.scale && s.setScale(t.scale), void 0 !== t.matrix) {
            const e = [0, 0, 0],
              i = [0, 0, 0, 1],
              r = [1, 1, 1];
            M.decompose(t.matrix, e, i, r), s.setTranslation(e), s.setRotation(i), s.setScale(r);
          }
          return void 0 !== t.weights && s.setWeights(t.weights), s;
        }), n.skins = (i.skins || []).map(t => {
          const s = r.createSkin(t.name);
          t.extras && s.setExtras(t.extras), void 0 !== t.inverseBindMatrices && s.setInverseBindMatrices(n.accessors[t.inverseBindMatrices]), void 0 !== t.skeleton && s.setSkeleton(n.nodes[t.skeleton]);
          for (const e of t.joints) s.addJoint(n.nodes[e]);
          return s;
        }), g.map((t, s) => {
          const e = n.nodes[s];
          (t.children || []).forEach(t => e.addChild(n.nodes[t])), void 0 !== t.mesh && e.setMesh(n.meshes[t.mesh]), void 0 !== t.camera && e.setCamera(n.cameras[t.camera]), void 0 !== t.skin && e.setSkin(n.skins[t.skin]);
        }), n.animations = (i.animations || []).map(t => {
          const s = r.createAnimation(t.name);
          t.extras && s.setExtras(t.extras);
          const e = (t.samplers || []).map(t => {
            const e = r.createAnimationSampler().setInput(n.accessors[t.input]).setOutput(n.accessors[t.output]).setInterpolation(t.interpolation || F.Interpolation.LINEAR);
            return t.extras && e.setExtras(t.extras), s.addSampler(e), e;
          });
          return (t.channels || []).forEach(t => {
            const i = r.createAnimationChannel().setSampler(e[t.sampler]).setTargetNode(n.nodes[t.target.node]).setTargetPath(t.target.path);
            t.extras && i.setExtras(t.extras), s.addChannel(i);
          }), s;
        });
        const w = i.scenes || [];
        return r.getRoot().listExtensionsUsed().filter(t => t.prereadTypes.includes(o.SCENE)).forEach(t => t.preread(n, o.SCENE)), n.scenes = w.map(t => {
          const s = r.createScene(t.name);
          return t.extras && s.setExtras(t.extras), (t.nodes || []).map(t => n.nodes[t]).forEach(t => s.addChild(t)), s;
        }), void 0 !== i.scene && r.getRoot().setDefaultScene(n.scenes[i.scene]), r.getRoot().listExtensionsUsed().forEach(t => t.read(n)), r;
      }
      static validate(t, s) {
        const e = t.json;
        if ("2.0" !== e.asset.version) throw new Error(`Unsupported glTF version, "${e.asset.version}".`);
        if (e.extensionsRequired) for (const t of e.extensionsRequired) if (!s.extensions.find(s => s.EXTENSION_NAME === t)) throw new Error(`Missing required extension, "${t}".`);
        if (e.extensionsUsed) for (const t of e.extensionsUsed) s.extensions.find(s => s.EXTENSION_NAME === t) || s.logger.warn(`Missing optional extension, "${t}".`);
      }
    }.read(t, {
      extensions: Array.from(this.gt),
      dependencies: this.Pt,
      logger: this._t
    });
  }
  writeJSON(t, s = {}) {
    if (s.format === a.GLB && t.getRoot().listBuffers().length > 1) throw new Error("GLB must have 0–1 buffers.");
    return class {
      static write(t, s) {
        const e = t.getRoot(),
          i = {
            asset: ut({
              generator: "glTF-Transform v1.2.4"
            }, e.getAsset()),
            extras: ut({}, e.getExtras())
          },
          r = {
            json: i,
            resources: {}
          },
          n = new gt(t, r, s),
          h = s.logger || I.DEFAULT_INSTANCE,
          c = new Set(s.extensions.map(t => t.EXTENSION_NAME)),
          l = t.getRoot().listExtensionsUsed().filter(t => c.has(t.extensionName)),
          f = t.getRoot().listExtensionsRequired().filter(t => c.has(t.extensionName));
        l.length < t.getRoot().listExtensionsUsed().length && h.debug("Some extensions were not registered for I/O, and will not be written.");
        for (const t of l) for (const e of t.writeDependencies) t.install(e, s.dependencies[e]);
        function d(t, s, e, r) {
          const h = [];
          let o = 0;
          for (const s of t) {
            const t = n.createAccessorDef(s);
            t.bufferView = i.bufferViews.length;
            const e = T.pad(s.getArray().buffer);
            t.byteOffset = o, o += e.byteLength, h.push(e), n.accessorIndexMap.set(s, i.accessors.length), i.accessors.push(t);
          }
          const u = {
            buffer: s,
            byteOffset: e,
            byteLength: T.concat(h).byteLength
          };
          return r && (u.target = r), i.bufferViews.push(u), {
            buffers: h,
            byteLength: o
          };
        }
        function p(t, s, e) {
          const r = t[0].getCount();
          let h = 0;
          for (const s of t) {
            const t = n.createAccessorDef(s);
            t.bufferView = i.bufferViews.length, t.byteOffset = h;
            const e = s.getElementSize(),
              r = s.getComponentSize();
            h += T.padNumber(e * r), n.accessorIndexMap.set(s, i.accessors.length), i.accessors.push(t);
          }
          const o = r * h,
            u = new ArrayBuffer(o),
            c = new DataView(u);
          for (let s = 0; s < r; s++) {
            let e = 0;
            for (const i of t) {
              const t = i.getElementSize(),
                r = i.getComponentSize(),
                n = i.getComponentType(),
                o = i.getArray();
              for (let i = 0; i < t; i++) {
                const u = s * h + e + i * r,
                  a = o[s * t + i];
                switch (n) {
                  case P.ComponentType.FLOAT:
                    c.setFloat32(u, a, !0);
                    break;
                  case P.ComponentType.BYTE:
                    c.setInt8(u, a);
                    break;
                  case P.ComponentType.SHORT:
                    c.setInt16(u, a, !0);
                    break;
                  case P.ComponentType.UNSIGNED_BYTE:
                    c.setUint8(u, a);
                    break;
                  case P.ComponentType.UNSIGNED_SHORT:
                    c.setUint16(u, a, !0);
                    break;
                  case P.ComponentType.UNSIGNED_INT:
                    c.setUint32(u, a, !0);
                    break;
                  default:
                    throw new Error("Unexpected component type: " + n);
                }
              }
              e += T.padNumber(t * r);
            }
          }
          return i.bufferViews.push({
            buffer: s,
            byteOffset: e,
            byteLength: o,
            byteStride: h,
            target: gt.BufferViewTarget.ARRAY_BUFFER
          }), {
            byteLength: o,
            buffers: [u]
          };
        }
        const g = new Map();
        for (const s of t.getGraph().getLinks()) {
          if (s.getParent() === e) continue;
          const t = s.getChild();
          if (t instanceof P) {
            const e = g.get(t) || [];
            e.push(s), g.set(t, e);
          }
        }
        if (i.accessors = [], i.bufferViews = [], i.samplers = [], i.textures = [], i.images = e.listTextures().map((t, s) => {
          const e = n.createPropertyDef(t);
          t.getMimeType() && (e.mimeType = t.getMimeType());
          const i = t.getImage();
          return i && n.createImageData(e, i, t), n.imageIndexMap.set(t, s), e;
        }), l.filter(t => t.prewriteTypes.includes(o.ACCESSOR)).forEach(t => t.prewrite(n, o.ACCESSOR)), e.listAccessors().forEach(t => {
          const s = n.accessorUsageGroupedByParent,
            e = n.accessorParents;
          if (n.accessorIndexMap.has(t)) return;
          const i = g.get(t) || [],
            r = n.getAccessorUsage(t);
          if (n.addAccessorToUsageGroup(t, r), s.has(r)) {
            const s = i[0].getParent(),
              r = e.get(s) || new Set();
            r.add(t), e.set(s, r);
          }
        }), l.filter(t => t.prewriteTypes.includes(o.BUFFER)).forEach(t => t.prewrite(n, o.BUFFER)), (e.listAccessors().length > 0 || e.listTextures().length > 0 || n.otherBufferViews.size > 0) && 0 === e.listBuffers().length) throw new Error("Buffer required for Document resources, but none was found.");
        i.buffers = [], e.listBuffers().forEach((t, e) => {
          const h = n.createPropertyDef(t),
            o = n.accessorUsageGroupedByParent,
            c = n.accessorParents,
            l = t.listParents().filter(t => t instanceof P),
            f = new Set(l),
            g = [],
            w = i.buffers.length;
          let v = 0;
          const m = n.listAccessorUsageGroups();
          for (const t in m) if (o.has(t)) for (const e of Array.from(c.values())) {
            const i = Array.from(e).filter(t => f.has(t)).filter(s => n.getAccessorUsage(s) === t);
            if (i.length) if (t !== vt.ARRAY_BUFFER || s.vertexLayout === u.INTERLEAVED) {
              const s = t === vt.ARRAY_BUFFER ? p(i, w, v) : d(i, w, v);
              v += s.byteLength, g.push(...s.buffers);
            } else for (const t of i) {
              const s = p([t], w, v);
              v += s.byteLength, g.push(...s.buffers);
            }
          } else {
            const s = m[t].filter(t => f.has(t));
            if (!s.length) continue;
            const e = d(s, w, v, t === vt.ELEMENT_ARRAY_BUFFER ? gt.BufferViewTarget.ELEMENT_ARRAY_BUFFER : void 0);
            v += e.byteLength, g.push(...e.buffers);
          }
          if (n.imageBufferViews.length && 0 === e) for (let t = 0; t < n.imageBufferViews.length; t++) if (i.bufferViews[i.images[t].bufferView].byteOffset = v, v += n.imageBufferViews[t].byteLength, g.push(n.imageBufferViews[t]), v % 8) {
            const t = 8 - v % 8;
            v += t, g.push(new ArrayBuffer(t));
          }
          if (n.otherBufferViews.has(t)) for (const s of n.otherBufferViews.get(t)) i.bufferViews.push({
            buffer: w,
            byteOffset: v,
            byteLength: s.byteLength
          }), n.otherBufferViewsIndexMap.set(s, i.bufferViews.length - 1), v += s.byteLength, g.push(s);
          if (v) {
            let e;
            s.format === a.GLB ? e = "@glb.bin" : (e = n.bufferURIGenerator.createURI(t, "bin"), h.uri = e), h.byteLength = v, r.resources[e] = T.concat(g);
          }
          i.buffers.push(h), n.bufferIndexMap.set(t, e);
        }), e.listAccessors().find(t => !t.getBuffer()) && h.warn("Skipped writing one or more Accessors: no Buffer assigned."), i.materials = e.listMaterials().map((t, s) => {
          const e = n.createPropertyDef(t);
          if (t.getAlphaMode() !== K.AlphaMode.OPAQUE && (e.alphaMode = t.getAlphaMode()), t.getAlphaMode() === K.AlphaMode.MASK && (e.alphaCutoff = t.getAlphaCutoff()), t.getDoubleSided() && (e.doubleSided = !0), e.pbrMetallicRoughness = {}, M.eq(t.getBaseColorFactor(), [1, 1, 1, 1]) || (e.pbrMetallicRoughness.baseColorFactor = t.getBaseColorFactor()), M.eq(t.getEmissiveFactor(), [0, 0, 0]) || (e.emissiveFactor = t.getEmissiveFactor()), 1 !== t.getRoughnessFactor() && (e.pbrMetallicRoughness.roughnessFactor = t.getRoughnessFactor()), 1 !== t.getMetallicFactor() && (e.pbrMetallicRoughness.metallicFactor = t.getMetallicFactor()), t.getBaseColorTexture()) {
            const s = t.getBaseColorTexture(),
              i = t.getBaseColorTextureInfo();
            e.pbrMetallicRoughness.baseColorTexture = n.createTextureInfoDef(s, i);
          }
          if (t.getEmissiveTexture()) {
            const s = t.getEmissiveTexture(),
              i = t.getEmissiveTextureInfo();
            e.emissiveTexture = n.createTextureInfoDef(s, i);
          }
          if (t.getNormalTexture()) {
            const s = t.getNormalTexture(),
              i = t.getNormalTextureInfo(),
              r = n.createTextureInfoDef(s, i);
            1 !== t.getNormalScale() && (r.scale = t.getNormalScale()), e.normalTexture = r;
          }
          if (t.getOcclusionTexture()) {
            const s = t.getOcclusionTexture(),
              i = t.getOcclusionTextureInfo(),
              r = n.createTextureInfoDef(s, i);
            1 !== t.getOcclusionStrength() && (r.strength = t.getOcclusionStrength()), e.occlusionTexture = r;
          }
          if (t.getMetallicRoughnessTexture()) {
            const s = t.getMetallicRoughnessTexture(),
              i = t.getMetallicRoughnessTextureInfo();
            e.pbrMetallicRoughness.metallicRoughnessTexture = n.createTextureInfoDef(s, i);
          }
          return n.materialIndexMap.set(t, s), e;
        }), i.meshes = e.listMeshes().map((t, s) => {
          const e = n.createPropertyDef(t);
          let i = null;
          return e.primitives = t.listPrimitives().map(t => {
            const s = {
              attributes: {}
            };
            s.mode = t.getMode();
            const e = t.getMaterial();
            e && (s.material = n.materialIndexMap.get(e)), Object.keys(t.getExtras()).length && (s.extras = t.getExtras());
            const r = t.getIndices();
            r && (s.indices = n.accessorIndexMap.get(r));
            for (const e of t.listSemantics()) s.attributes[e] = n.accessorIndexMap.get(t.getAttribute(e));
            for (const e of t.listTargets()) {
              const t = {};
              for (const s of e.listSemantics()) t[s] = n.accessorIndexMap.get(e.getAttribute(s));
              s.targets = s.targets || [], s.targets.push(t);
            }
            return t.listTargets().length && !i && (i = t.listTargets().map(t => t.getName())), s;
          }), t.getWeights().length && (e.weights = t.getWeights()), i && (e.extras = e.extras || {}, e.extras.targetNames = i), n.meshIndexMap.set(t, s), e;
        }), i.cameras = e.listCameras().map((t, s) => {
          const e = n.createPropertyDef(t);
          if (e.type = t.getType(), e.type === j.Type.PERSPECTIVE) {
            e.perspective = {
              znear: t.getZNear(),
              zfar: t.getZFar(),
              yfov: t.getYFov()
            };
            const s = t.getAspectRatio();
            null !== s && (e.perspective.aspectRatio = s);
          } else e.orthographic = {
            znear: t.getZNear(),
            zfar: t.getZFar(),
            xmag: t.getXMag(),
            ymag: t.getYMag()
          };
          return n.cameraIndexMap.set(t, s), e;
        }), i.nodes = e.listNodes().map((t, s) => {
          const e = n.createPropertyDef(t);
          return M.eq(t.getTranslation(), [0, 0, 0]) || (e.translation = t.getTranslation()), M.eq(t.getRotation(), [0, 0, 0, 1]) || (e.rotation = t.getRotation()), M.eq(t.getScale(), [1, 1, 1]) || (e.scale = t.getScale()), t.getWeights().length && (e.weights = t.getWeights()), n.nodeIndexMap.set(t, s), e;
        }), i.skins = e.listSkins().map((t, s) => {
          const e = n.createPropertyDef(t),
            i = t.getInverseBindMatrices();
          i && (e.inverseBindMatrices = n.accessorIndexMap.get(i));
          const r = t.getSkeleton();
          return r && (e.skeleton = n.nodeIndexMap.get(r)), e.joints = t.listJoints().map(t => n.nodeIndexMap.get(t)), n.skinIndexMap.set(t, s), e;
        }), e.listNodes().forEach((t, s) => {
          const e = i.nodes[s],
            r = t.getMesh();
          r && (e.mesh = n.meshIndexMap.get(r));
          const h = t.getCamera();
          h && (e.camera = n.cameraIndexMap.get(h));
          const o = t.getSkin();
          o && (e.skin = n.skinIndexMap.get(o)), t.listChildren().length > 0 && (e.children = t.listChildren().map(t => n.nodeIndexMap.get(t)));
        }), i.animations = e.listAnimations().map(t => {
          const s = n.createPropertyDef(t),
            e = new Map();
          return s.samplers = t.listSamplers().map((t, s) => {
            const i = n.createPropertyDef(t);
            return i.input = n.accessorIndexMap.get(t.getInput()), i.output = n.accessorIndexMap.get(t.getOutput()), i.interpolation = t.getInterpolation(), e.set(t, s), i;
          }), s.channels = t.listChannels().map(t => {
            const s = n.createPropertyDef(t);
            return s.sampler = e.get(t.getSampler()), s.target = {
              node: n.nodeIndexMap.get(t.getTargetNode()),
              path: t.getTargetPath()
            }, s;
          }), s;
        }), i.scenes = e.listScenes().map(t => {
          const s = n.createPropertyDef(t);
          return s.nodes = t.listChildren().map(t => n.nodeIndexMap.get(t)), s;
        });
        const w = e.getDefaultScene();
        return w && (i.scene = e.listScenes().indexOf(w)), i.extensionsUsed = l.map(t => t.extensionName), i.extensionsRequired = f.map(t => t.extensionName), l.forEach(t => t.write(n)), function (t) {
          const s = [];
          for (const e in t) {
            const i = t[e];
            (Array.isArray(i) && 0 === i.length || null === i || "" === i || i && "object" == typeof i && 0 === Object.keys(i).length) && s.push(e);
          }
          for (const e of s) delete t[e];
        }(i), r;
      }
    }.write(t, {
      format: s.format || a.GLTF,
      basename: s.basename || "",
      logger: this._t,
      vertexLayout: this.Ut,
      dependencies: ut({}, this.Pt),
      extensions: Array.from(this.gt)
    });
  }
  Ft(t) {
    const {
      images: s,
      buffers: e
    } = t.json;
    return t = {
      json: ut({}, t.json),
      resources: ut({}, t.resources)
    }, s && (t.json.images = s.map(t => ut({}, t))), e && (t.json.buffers = e.map(t => ut({}, t))), t;
  }
  binaryToJSON(t) {
    const s = this.Gt(t);
    this.kt(s);
    const e = s.json;
    if (e.buffers && e.buffers.some(t => function (t, s) {
      return void 0 !== s.uri && !(s.uri in t.resources);
    }(s, t))) throw new Error("Cannot resolve external buffers with binaryToJSON().");
    if (e.images && e.images.some(t => function (t, s) {
      return void 0 !== s.uri && !(s.uri in t.resources) && void 0 === s.bufferView;
    }(s, t))) throw new Error("Cannot resolve external images with binaryToJSON().");
    return s;
  }
  Gt(t) {
    const s = new Uint32Array(t, 0, 3);
    if (1179937895 !== s[0]) throw new Error("Invalid glTF asset.");
    if (2 !== s[1]) throw new Error(`Unsupported glTF binary version, "${s[1]}".`);
    const e = new Uint32Array(t, 12, 2);
    if (e[1] !== mt.JSON) throw new Error("Missing required GLB JSON chunk.");
    const i = e[0],
      r = T.decodeText(t.slice(20, 20 + i)),
      n = JSON.parse(r),
      h = 20 + i;
    if (t.byteLength <= h) return {
      json: n,
      resources: {}
    };
    const o = new Uint32Array(t, h, 2);
    if (o[1] !== mt.BIN) throw new Error("Expected GLB BIN in second chunk.");
    return {
      json: n,
      resources: {
        "@glb.bin": t.slice(h + 8, h + 8 + o[0])
      }
    };
  }
  readBinary(t) {
    return this.readJSON(this.binaryToJSON(t));
  }
  writeBinary(t) {
    const {
        json: s,
        resources: e
      } = this.writeJSON(t, {
        format: a.GLB
      }),
      i = new Uint32Array([1179937895, 2, 12]),
      r = JSON.stringify(s),
      n = T.pad(T.encodeText(r), 32),
      h = new Uint32Array([n.byteLength, 1313821514]).buffer,
      o = T.concat([h, n]);
    i[i.length - 1] += o.byteLength;
    const u = Object.values(e)[0];
    if (!u || !u.byteLength) return T.concat([i.buffer, o]);
    const c = T.pad(u, 0),
      l = new Uint32Array([c.byteLength, 5130562]).buffer,
      f = T.concat([l, c]);
    return i[i.length - 1] += f.byteLength, T.concat([i.buffer, o, f]);
  }
}
class yt extends Tt {
  constructor() {
    super(), this.jt = void 0, this.Dt = void 0, this.lastReadBytes = 0, this.lastWriteBytes = 0, this.jt = __webpack_require__(/*! fs */ "?ec06"), this.Dt = __webpack_require__(/*! path */ "?f46d");
  }
  read(t) {
    return this.readJSON(this.readAsJSON(t));
  }
  readAsJSON(t) {
    return t.match(/\.glb$/) || t.match(/^data:application\/octet-stream;/) ? this.Jt(t) : this.zt(t);
  }
  write(t, s) {
    t.match(/\.glb$/) ? this.$t(t, s) : this.Vt(t, s);
  }
  Wt(t, s) {
    [...(t.json.images || []), ...(t.json.buffers || [])].forEach(e => {
      if (e.uri && !e.uri.match(/data:/)) {
        const i = this.Dt.resolve(s, e.uri);
        t.resources[e.uri] = T.trim(this.jt.readFileSync(i)), this.lastReadBytes += t.resources[e.uri].byteLength;
      }
    });
  }
  Jt(t) {
    const s = this.jt.readFileSync(t),
      e = T.trim(s);
    this.lastReadBytes = e.byteLength;
    const i = this.Gt(e);
    return this.Wt(i, this.Dt.dirname(t)), this.kt(i), i;
  }
  zt(t) {
    this.lastReadBytes = 0;
    const s = this.jt.readFileSync(t, "utf8");
    this.lastReadBytes += s.length;
    const e = {
      json: JSON.parse(s),
      resources: {}
    };
    return this.Wt(e, this.Dt.dirname(t)), this.kt(e), e;
  }
  Vt(t, s) {
    this.lastWriteBytes = 0;
    const {
        json: e,
        resources: i
      } = this.writeJSON(s, {
        format: a.GLTF,
        basename: A.basename(t)
      }),
      {
        jt: r,
        Dt: n
      } = this,
      h = n.dirname(t),
      o = JSON.stringify(e, null, 2);
    this.lastWriteBytes += o.length, r.writeFileSync(t, o), Object.keys(i).forEach(t => {
      const s = Buffer.from(i[t]);
      r.writeFileSync(n.join(h, t), s), this.lastWriteBytes += s.byteLength;
    });
  }
  $t(t, s) {
    const e = Buffer.from(this.writeBinary(s));
    this.jt.writeFileSync(t, e), this.lastWriteBytes = e.byteLength;
  }
}
const At = {};
class Et extends Tt {
  constructor(t = At) {
    super(), this.qt = void 0, this.qt = t;
  }
  read(t) {
    return this.readAsJSON(t).then(t => this.readJSON(t));
  }
  readAsJSON(t) {
    return t.match(/^data:application\/octet-stream;/) || new URL(t, window.location.href).pathname.match(/\.glb$/) ? this.Jt(t) : this.zt(t);
  }
  Wt(t, s) {
    const e = [...(t.json.images || []), ...(t.json.buffers || [])].map(e => {
      const i = e.uri;
      return !i || i.match(/data:/) ? Promise.resolve() : fetch(function (t, s) {
        if (!function (t) {
          return !/^(?:[a-zA-Z]+:)?\//.test(t);
        }(s)) return s;
        const e = t.split("/"),
          i = s.split("/");
        e.pop();
        for (let t = 0; t < i.length; t++) "." !== i[t] && (".." === i[t] ? e.pop() : e.push(i[t]));
        return e.join("/");
      }(s, i), this.qt).then(t => t.arrayBuffer()).then(s => {
        t.resources[i] = s;
      });
    });
    return Promise.all(e).then(() => {});
  }
  zt(t) {
    var s = this;
    const e = {
      json: {},
      resources: {}
    };
    return fetch(t, this.qt).then(t => t.json()).then(async function (i) {
      return e.json = i, await s.Wt(e, xt(t)), s.kt(e), e;
    });
  }
  Jt(t) {
    var s = this;
    return fetch(t, this.qt).then(t => t.arrayBuffer()).then(async function (e) {
      const i = s.Gt(e);
      return await s.Wt(i, xt(t)), s.kt(i), i;
    });
  }
}
function xt(t) {
  const s = t.lastIndexOf("/");
  return -1 === s ? "./" : t.substr(0, s + 1);
}


/***/ }),

/***/ "../../../node_modules/axios/index.js":
/*!********************************************!*\
  !*** ../../../node_modules/axios/index.js ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(/*! ./lib/axios */ "../../../node_modules/axios/lib/axios.js");

/***/ }),

/***/ "../../../node_modules/axios/lib/adapters/xhr.js":
/*!*******************************************************!*\
  !*** ../../../node_modules/axios/lib/adapters/xhr.js ***!
  \*******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");
var settle = __webpack_require__(/*! ./../core/settle */ "../../../node_modules/axios/lib/core/settle.js");
var buildURL = __webpack_require__(/*! ./../helpers/buildURL */ "../../../node_modules/axios/lib/helpers/buildURL.js");
var parseHeaders = __webpack_require__(/*! ./../helpers/parseHeaders */ "../../../node_modules/axios/lib/helpers/parseHeaders.js");
var isURLSameOrigin = __webpack_require__(/*! ./../helpers/isURLSameOrigin */ "../../../node_modules/axios/lib/helpers/isURLSameOrigin.js");
var createError = __webpack_require__(/*! ../core/createError */ "../../../node_modules/axios/lib/core/createError.js");
module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }
    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };
      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(/*! ./../helpers/cookies */ "../../../node_modules/axios/lib/helpers/cookies.js");

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }
    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }
        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }
    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),

/***/ "../../../node_modules/axios/lib/axios.js":
/*!************************************************!*\
  !*** ../../../node_modules/axios/lib/axios.js ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "../../../node_modules/axios/lib/utils.js");
var bind = __webpack_require__(/*! ./helpers/bind */ "../../../node_modules/axios/lib/helpers/bind.js");
var Axios = __webpack_require__(/*! ./core/Axios */ "../../../node_modules/axios/lib/core/Axios.js");
var defaults = __webpack_require__(/*! ./defaults */ "../../../node_modules/axios/lib/defaults.js");

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);
  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(/*! ./cancel/Cancel */ "../../../node_modules/axios/lib/cancel/Cancel.js");
axios.CancelToken = __webpack_require__(/*! ./cancel/CancelToken */ "../../../node_modules/axios/lib/cancel/CancelToken.js");
axios.isCancel = __webpack_require__(/*! ./cancel/isCancel */ "../../../node_modules/axios/lib/cancel/isCancel.js");

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(/*! ./helpers/spread */ "../../../node_modules/axios/lib/helpers/spread.js");
module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;

/***/ }),

/***/ "../../../node_modules/axios/lib/cancel/Cancel.js":
/*!********************************************************!*\
  !*** ../../../node_modules/axios/lib/cancel/Cancel.js ***!
  \********************************************************/
/***/ ((module) => {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}
Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};
Cancel.prototype.__CANCEL__ = true;
module.exports = Cancel;

/***/ }),

/***/ "../../../node_modules/axios/lib/cancel/CancelToken.js":
/*!*************************************************************!*\
  !*** ../../../node_modules/axios/lib/cancel/CancelToken.js ***!
  \*************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var Cancel = __webpack_require__(/*! ./Cancel */ "../../../node_modules/axios/lib/cancel/Cancel.js");

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }
  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });
  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }
    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};
module.exports = CancelToken;

/***/ }),

/***/ "../../../node_modules/axios/lib/cancel/isCancel.js":
/*!**********************************************************!*\
  !*** ../../../node_modules/axios/lib/cancel/isCancel.js ***!
  \**********************************************************/
/***/ ((module) => {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),

/***/ "../../../node_modules/axios/lib/core/Axios.js":
/*!*****************************************************!*\
  !*** ../../../node_modules/axios/lib/core/Axios.js ***!
  \*****************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var defaults = __webpack_require__(/*! ./../defaults */ "../../../node_modules/axios/lib/defaults.js");
var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");
var InterceptorManager = __webpack_require__(/*! ./InterceptorManager */ "../../../node_modules/axios/lib/core/InterceptorManager.js");
var dispatchRequest = __webpack_require__(/*! ./dispatchRequest */ "../../../node_modules/axios/lib/core/dispatchRequest.js");

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }
  config = utils.merge(defaults, {
    method: 'get'
  }, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });
  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }
  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});
module.exports = Axios;

/***/ }),

/***/ "../../../node_modules/axios/lib/core/InterceptorManager.js":
/*!******************************************************************!*\
  !*** ../../../node_modules/axios/lib/core/InterceptorManager.js ***!
  \******************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");
function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};
module.exports = InterceptorManager;

/***/ }),

/***/ "../../../node_modules/axios/lib/core/createError.js":
/*!***********************************************************!*\
  !*** ../../../node_modules/axios/lib/core/createError.js ***!
  \***********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var enhanceError = __webpack_require__(/*! ./enhanceError */ "../../../node_modules/axios/lib/core/enhanceError.js");

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),

/***/ "../../../node_modules/axios/lib/core/dispatchRequest.js":
/*!***************************************************************!*\
  !*** ../../../node_modules/axios/lib/core/dispatchRequest.js ***!
  \***************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");
var transformData = __webpack_require__(/*! ./transformData */ "../../../node_modules/axios/lib/core/transformData.js");
var isCancel = __webpack_require__(/*! ../cancel/isCancel */ "../../../node_modules/axios/lib/cancel/isCancel.js");
var defaults = __webpack_require__(/*! ../defaults */ "../../../node_modules/axios/lib/defaults.js");
var isAbsoluteURL = __webpack_require__(/*! ./../helpers/isAbsoluteURL */ "../../../node_modules/axios/lib/helpers/isAbsoluteURL.js");
var combineURLs = __webpack_require__(/*! ./../helpers/combineURLs */ "../../../node_modules/axios/lib/helpers/combineURLs.js");

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});
  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });
  var adapter = config.adapter || defaults.adapter;
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }
    return Promise.reject(reason);
  });
};

/***/ }),

/***/ "../../../node_modules/axios/lib/core/enhanceError.js":
/*!************************************************************!*\
  !*** ../../../node_modules/axios/lib/core/enhanceError.js ***!
  \************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};

/***/ }),

/***/ "../../../node_modules/axios/lib/core/settle.js":
/*!******************************************************!*\
  !*** ../../../node_modules/axios/lib/core/settle.js ***!
  \******************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var createError = __webpack_require__(/*! ./createError */ "../../../node_modules/axios/lib/core/createError.js");

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),

/***/ "../../../node_modules/axios/lib/core/transformData.js":
/*!*************************************************************!*\
  !*** ../../../node_modules/axios/lib/core/transformData.js ***!
  \*************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });
  return data;
};

/***/ }),

/***/ "../../../node_modules/axios/lib/defaults.js":
/*!***************************************************!*\
  !*** ../../../node_modules/axios/lib/defaults.js ***!
  \***************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./utils */ "../../../node_modules/axios/lib/utils.js");
var normalizeHeaderName = __webpack_require__(/*! ./helpers/normalizeHeaderName */ "../../../node_modules/axios/lib/helpers/normalizeHeaderName.js");
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};
function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}
function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(/*! ./adapters/xhr */ "../../../node_modules/axios/lib/adapters/xhr.js");
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(/*! ./adapters/http */ "../../../node_modules/axios/lib/adapters/xhr.js");
  }
  return adapter;
}
var defaults = {
  adapter: getDefaultAdapter(),
  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],
  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
  maxContentLength: -1,
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};
defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});
utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});
module.exports = defaults;

/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/bind.js":
/*!*******************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/bind.js ***!
  \*******************************************************/
/***/ ((module) => {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/buildURL.js":
/*!***********************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/buildURL.js ***!
  \***********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");
function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }
  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];
    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }
      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }
      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });
    serializedParams = parts.join('&');
  }
  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }
  return url;
};

/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/combineURLs.js":
/*!**************************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/combineURLs.js ***!
  \**************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/cookies.js":
/*!**********************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/cookies.js ***!
  \**********************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");
module.exports = utils.isStandardBrowserEnv() ?
// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));
      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }
      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }
      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }
      if (secure === true) {
        cookie.push('secure');
      }
      document.cookie = cookie.join('; ');
    },
    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },
    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :
// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/isAbsoluteURL.js":
/*!****************************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/isAbsoluteURL.js ***!
  \****************************************************************/
/***/ ((module) => {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/isURLSameOrigin.js":
/*!******************************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/isURLSameOrigin.js ***!
  \******************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");
module.exports = utils.isStandardBrowserEnv() ?
// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;
    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }
  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :
// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/normalizeHeaderName.js":
/*!**********************************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/normalizeHeaderName.js ***!
  \**********************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ../utils */ "../../../node_modules/axios/lib/utils.js");
module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/parseHeaders.js":
/*!***************************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/parseHeaders.js ***!
  \***************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var utils = __webpack_require__(/*! ./../utils */ "../../../node_modules/axios/lib/utils.js");

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = ['age', 'authorization', 'content-length', 'content-type', 'etag', 'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since', 'last-modified', 'location', 'max-forwards', 'proxy-authorization', 'referer', 'retry-after', 'user-agent'];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;
  if (!headers) {
    return parsed;
  }
  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));
    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });
  return parsed;
};

/***/ }),

/***/ "../../../node_modules/axios/lib/helpers/spread.js":
/*!*********************************************************!*\
  !*** ../../../node_modules/axios/lib/helpers/spread.js ***!
  \*********************************************************/
/***/ ((module) => {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),

/***/ "../../../node_modules/axios/lib/utils.js":
/*!************************************************!*\
  !*** ../../../node_modules/axios/lib/utils.js ***!
  \************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var bind = __webpack_require__(/*! ./helpers/bind */ "../../../node_modules/axios/lib/helpers/bind.js");
var isBuffer = __webpack_require__(/*! is-buffer */ "../../../node_modules/is-buffer/index.js");

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }
  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function /* obj1, obj2, obj3, ... */
merge() {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }
  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}
module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

/***/ }),

/***/ "../../../node_modules/gl-matrix/esm/common.js":
/*!*****************************************************!*\
  !*** ../../../node_modules/gl-matrix/esm/common.js ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ARRAY_TYPE": () => (/* binding */ ARRAY_TYPE),
/* harmony export */   "EPSILON": () => (/* binding */ EPSILON),
/* harmony export */   "RANDOM": () => (/* binding */ RANDOM),
/* harmony export */   "equals": () => (/* binding */ equals),
/* harmony export */   "setMatrixArrayType": () => (/* binding */ setMatrixArrayType),
/* harmony export */   "toRadian": () => (/* binding */ toRadian)
/* harmony export */ });
/**
 * Common utilities
 * @module glMatrix
 */
// Configuration Constants
var EPSILON = 0.000001;
var ARRAY_TYPE = typeof Float32Array !== 'undefined' ? Float32Array : Array;
var RANDOM = Math.random;
/**
 * Sets the type of array used when creating new vectors and matrices
 *
 * @param {Float32ArrayConstructor | ArrayConstructor} type Array type, such as Float32Array or Array
 */

function setMatrixArrayType(type) {
  ARRAY_TYPE = type;
}
var degree = Math.PI / 180;
/**
 * Convert Degree To Radian
 *
 * @param {Number} a Angle in Degrees
 */

function toRadian(a) {
  return a * degree;
}
/**
 * Tests whether or not the arguments have approximately the same value, within an absolute
 * or relative tolerance of glMatrix.EPSILON (an absolute tolerance is used for values less
 * than or equal to 1.0, and a relative tolerance is used for larger values)
 *
 * @param {Number} a The first number to test.
 * @param {Number} b The second number to test.
 * @returns {Boolean} True if the numbers are approximately equal, false otherwise.
 */

function equals(a, b) {
  return Math.abs(a - b) <= EPSILON * Math.max(1.0, Math.abs(a), Math.abs(b));
}
if (!Math.hypot) Math.hypot = function () {
  var y = 0,
    i = arguments.length;
  while (i--) {
    y += arguments[i] * arguments[i];
  }
  return Math.sqrt(y);
};

/***/ }),

/***/ "../../../node_modules/gl-matrix/esm/mat4.js":
/*!***************************************************!*\
  !*** ../../../node_modules/gl-matrix/esm/mat4.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "add": () => (/* binding */ add),
/* harmony export */   "adjoint": () => (/* binding */ adjoint),
/* harmony export */   "clone": () => (/* binding */ clone),
/* harmony export */   "copy": () => (/* binding */ copy),
/* harmony export */   "create": () => (/* binding */ create),
/* harmony export */   "determinant": () => (/* binding */ determinant),
/* harmony export */   "equals": () => (/* binding */ equals),
/* harmony export */   "exactEquals": () => (/* binding */ exactEquals),
/* harmony export */   "frob": () => (/* binding */ frob),
/* harmony export */   "fromQuat": () => (/* binding */ fromQuat),
/* harmony export */   "fromQuat2": () => (/* binding */ fromQuat2),
/* harmony export */   "fromRotation": () => (/* binding */ fromRotation),
/* harmony export */   "fromRotationTranslation": () => (/* binding */ fromRotationTranslation),
/* harmony export */   "fromRotationTranslationScale": () => (/* binding */ fromRotationTranslationScale),
/* harmony export */   "fromRotationTranslationScaleOrigin": () => (/* binding */ fromRotationTranslationScaleOrigin),
/* harmony export */   "fromScaling": () => (/* binding */ fromScaling),
/* harmony export */   "fromTranslation": () => (/* binding */ fromTranslation),
/* harmony export */   "fromValues": () => (/* binding */ fromValues),
/* harmony export */   "fromXRotation": () => (/* binding */ fromXRotation),
/* harmony export */   "fromYRotation": () => (/* binding */ fromYRotation),
/* harmony export */   "fromZRotation": () => (/* binding */ fromZRotation),
/* harmony export */   "frustum": () => (/* binding */ frustum),
/* harmony export */   "getRotation": () => (/* binding */ getRotation),
/* harmony export */   "getScaling": () => (/* binding */ getScaling),
/* harmony export */   "getTranslation": () => (/* binding */ getTranslation),
/* harmony export */   "identity": () => (/* binding */ identity),
/* harmony export */   "invert": () => (/* binding */ invert),
/* harmony export */   "lookAt": () => (/* binding */ lookAt),
/* harmony export */   "mul": () => (/* binding */ mul),
/* harmony export */   "multiply": () => (/* binding */ multiply),
/* harmony export */   "multiplyScalar": () => (/* binding */ multiplyScalar),
/* harmony export */   "multiplyScalarAndAdd": () => (/* binding */ multiplyScalarAndAdd),
/* harmony export */   "ortho": () => (/* binding */ ortho),
/* harmony export */   "orthoNO": () => (/* binding */ orthoNO),
/* harmony export */   "orthoZO": () => (/* binding */ orthoZO),
/* harmony export */   "perspective": () => (/* binding */ perspective),
/* harmony export */   "perspectiveFromFieldOfView": () => (/* binding */ perspectiveFromFieldOfView),
/* harmony export */   "perspectiveNO": () => (/* binding */ perspectiveNO),
/* harmony export */   "perspectiveZO": () => (/* binding */ perspectiveZO),
/* harmony export */   "rotate": () => (/* binding */ rotate),
/* harmony export */   "rotateX": () => (/* binding */ rotateX),
/* harmony export */   "rotateY": () => (/* binding */ rotateY),
/* harmony export */   "rotateZ": () => (/* binding */ rotateZ),
/* harmony export */   "scale": () => (/* binding */ scale),
/* harmony export */   "set": () => (/* binding */ set),
/* harmony export */   "str": () => (/* binding */ str),
/* harmony export */   "sub": () => (/* binding */ sub),
/* harmony export */   "subtract": () => (/* binding */ subtract),
/* harmony export */   "targetTo": () => (/* binding */ targetTo),
/* harmony export */   "translate": () => (/* binding */ translate),
/* harmony export */   "transpose": () => (/* binding */ transpose)
/* harmony export */ });
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common.js */ "../../../node_modules/gl-matrix/esm/common.js");

/**
 * 4x4 Matrix<br>Format: column-major, when typed out it looks like row-major<br>The matrices are being post multiplied.
 * @module mat4
 */

/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */

function create() {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(16);
  if (_common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE != Float32Array) {
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
  }
  out[0] = 1;
  out[5] = 1;
  out[10] = 1;
  out[15] = 1;
  return out;
}
/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {ReadonlyMat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */

function clone(a) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(16);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  out[3] = a[3];
  out[4] = a[4];
  out[5] = a[5];
  out[6] = a[6];
  out[7] = a[7];
  out[8] = a[8];
  out[9] = a[9];
  out[10] = a[10];
  out[11] = a[11];
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Create a new mat4 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} A new mat4
 */

function fromValues(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(16);
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}
/**
 * Set the components of a mat4 to the given values
 *
 * @param {mat4} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} out
 */

function set(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
  out[0] = m00;
  out[1] = m01;
  out[2] = m02;
  out[3] = m03;
  out[4] = m10;
  out[5] = m11;
  out[6] = m12;
  out[7] = m13;
  out[8] = m20;
  out[9] = m21;
  out[10] = m22;
  out[11] = m23;
  out[12] = m30;
  out[13] = m31;
  out[14] = m32;
  out[15] = m33;
  return out;
}
/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */

function identity(out) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Transpose the values of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function transpose(out, a) {
  // If we are transposing ourselves we can skip a few steps but have to cache some values
  if (out === a) {
    var a01 = a[1],
      a02 = a[2],
      a03 = a[3];
    var a12 = a[6],
      a13 = a[7];
    var a23 = a[11];
    out[1] = a[4];
    out[2] = a[8];
    out[3] = a[12];
    out[4] = a01;
    out[6] = a[9];
    out[7] = a[13];
    out[8] = a02;
    out[9] = a12;
    out[11] = a[14];
    out[12] = a03;
    out[13] = a13;
    out[14] = a23;
  } else {
    out[0] = a[0];
    out[1] = a[4];
    out[2] = a[8];
    out[3] = a[12];
    out[4] = a[1];
    out[5] = a[5];
    out[6] = a[9];
    out[7] = a[13];
    out[8] = a[2];
    out[9] = a[6];
    out[10] = a[10];
    out[11] = a[14];
    out[12] = a[3];
    out[13] = a[7];
    out[14] = a[11];
    out[15] = a[15];
  }
  return out;
}
/**
 * Inverts a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function invert(out, a) {
  var a00 = a[0],
    a01 = a[1],
    a02 = a[2],
    a03 = a[3];
  var a10 = a[4],
    a11 = a[5],
    a12 = a[6],
    a13 = a[7];
  var a20 = a[8],
    a21 = a[9],
    a22 = a[10],
    a23 = a[11];
  var a30 = a[12],
    a31 = a[13],
    a32 = a[14],
    a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
  if (!det) {
    return null;
  }
  det = 1.0 / det;
  out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
  out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
  out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
  out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
  out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
  out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
  out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
  out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
  out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
  out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
  out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
  out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
  out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
  out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
  out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
  out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;
  return out;
}
/**
 * Calculates the adjugate of a mat4
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the source matrix
 * @returns {mat4} out
 */

function adjoint(out, a) {
  var a00 = a[0],
    a01 = a[1],
    a02 = a[2],
    a03 = a[3];
  var a10 = a[4],
    a11 = a[5],
    a12 = a[6],
    a13 = a[7];
  var a20 = a[8],
    a21 = a[9],
    a22 = a[10],
    a23 = a[11];
  var a30 = a[12],
    a31 = a[13],
    a32 = a[14],
    a33 = a[15];
  out[0] = a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22);
  out[1] = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
  out[2] = a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12);
  out[3] = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
  out[4] = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
  out[5] = a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22);
  out[6] = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
  out[7] = a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12);
  out[8] = a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21);
  out[9] = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
  out[10] = a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11);
  out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
  out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
  out[13] = a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21);
  out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
  out[15] = a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11);
  return out;
}
/**
 * Calculates the determinant of a mat4
 *
 * @param {ReadonlyMat4} a the source matrix
 * @returns {Number} determinant of a
 */

function determinant(a) {
  var a00 = a[0],
    a01 = a[1],
    a02 = a[2],
    a03 = a[3];
  var a10 = a[4],
    a11 = a[5],
    a12 = a[6],
    a13 = a[7];
  var a20 = a[8],
    a21 = a[9],
    a22 = a[10],
    a23 = a[11];
  var a30 = a[12],
    a31 = a[13],
    a32 = a[14],
    a33 = a[15];
  var b00 = a00 * a11 - a01 * a10;
  var b01 = a00 * a12 - a02 * a10;
  var b02 = a00 * a13 - a03 * a10;
  var b03 = a01 * a12 - a02 * a11;
  var b04 = a01 * a13 - a03 * a11;
  var b05 = a02 * a13 - a03 * a12;
  var b06 = a20 * a31 - a21 * a30;
  var b07 = a20 * a32 - a22 * a30;
  var b08 = a20 * a33 - a23 * a30;
  var b09 = a21 * a32 - a22 * a31;
  var b10 = a21 * a33 - a23 * a31;
  var b11 = a22 * a33 - a23 * a32; // Calculate the determinant

  return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
}
/**
 * Multiplies two mat4s
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function multiply(out, a, b) {
  var a00 = a[0],
    a01 = a[1],
    a02 = a[2],
    a03 = a[3];
  var a10 = a[4],
    a11 = a[5],
    a12 = a[6],
    a13 = a[7];
  var a20 = a[8],
    a21 = a[9],
    a22 = a[10],
    a23 = a[11];
  var a30 = a[12],
    a31 = a[13],
    a32 = a[14],
    a33 = a[15]; // Cache only the current line of the second matrix

  var b0 = b[0],
    b1 = b[1],
    b2 = b[2],
    b3 = b[3];
  out[0] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[1] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[2] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[3] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[4];
  b1 = b[5];
  b2 = b[6];
  b3 = b[7];
  out[4] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[5] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[6] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[7] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[8];
  b1 = b[9];
  b2 = b[10];
  b3 = b[11];
  out[8] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[9] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[10] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[11] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  b0 = b[12];
  b1 = b[13];
  b2 = b[14];
  b3 = b[15];
  out[12] = b0 * a00 + b1 * a10 + b2 * a20 + b3 * a30;
  out[13] = b0 * a01 + b1 * a11 + b2 * a21 + b3 * a31;
  out[14] = b0 * a02 + b1 * a12 + b2 * a22 + b3 * a32;
  out[15] = b0 * a03 + b1 * a13 + b2 * a23 + b3 * a33;
  return out;
}
/**
 * Translate a mat4 by the given vector
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to translate
 * @param {ReadonlyVec3} v vector to translate by
 * @returns {mat4} out
 */

function translate(out, a, v) {
  var x = v[0],
    y = v[1],
    z = v[2];
  var a00, a01, a02, a03;
  var a10, a11, a12, a13;
  var a20, a21, a22, a23;
  if (a === out) {
    out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
    out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
    out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
    out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
  } else {
    a00 = a[0];
    a01 = a[1];
    a02 = a[2];
    a03 = a[3];
    a10 = a[4];
    a11 = a[5];
    a12 = a[6];
    a13 = a[7];
    a20 = a[8];
    a21 = a[9];
    a22 = a[10];
    a23 = a[11];
    out[0] = a00;
    out[1] = a01;
    out[2] = a02;
    out[3] = a03;
    out[4] = a10;
    out[5] = a11;
    out[6] = a12;
    out[7] = a13;
    out[8] = a20;
    out[9] = a21;
    out[10] = a22;
    out[11] = a23;
    out[12] = a00 * x + a10 * y + a20 * z + a[12];
    out[13] = a01 * x + a11 * y + a21 * z + a[13];
    out[14] = a02 * x + a12 * y + a22 * z + a[14];
    out[15] = a03 * x + a13 * y + a23 * z + a[15];
  }
  return out;
}
/**
 * Scales the mat4 by the dimensions in the given vec3 not using vectorization
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {ReadonlyVec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/

function scale(out, a, v) {
  var x = v[0],
    y = v[1],
    z = v[2];
  out[0] = a[0] * x;
  out[1] = a[1] * x;
  out[2] = a[2] * x;
  out[3] = a[3] * x;
  out[4] = a[4] * y;
  out[5] = a[5] * y;
  out[6] = a[6] * y;
  out[7] = a[7] * y;
  out[8] = a[8] * z;
  out[9] = a[9] * z;
  out[10] = a[10] * z;
  out[11] = a[11] * z;
  out[12] = a[12];
  out[13] = a[13];
  out[14] = a[14];
  out[15] = a[15];
  return out;
}
/**
 * Rotates a mat4 by the given angle around the given axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @returns {mat4} out
 */

function rotate(out, a, rad, axis) {
  var x = axis[0],
    y = axis[1],
    z = axis[2];
  var len = Math.hypot(x, y, z);
  var s, c, t;
  var a00, a01, a02, a03;
  var a10, a11, a12, a13;
  var a20, a21, a22, a23;
  var b00, b01, b02;
  var b10, b11, b12;
  var b20, b21, b22;
  if (len < _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON) {
    return null;
  }
  len = 1 / len;
  x *= len;
  y *= len;
  z *= len;
  s = Math.sin(rad);
  c = Math.cos(rad);
  t = 1 - c;
  a00 = a[0];
  a01 = a[1];
  a02 = a[2];
  a03 = a[3];
  a10 = a[4];
  a11 = a[5];
  a12 = a[6];
  a13 = a[7];
  a20 = a[8];
  a21 = a[9];
  a22 = a[10];
  a23 = a[11]; // Construct the elements of the rotation matrix

  b00 = x * x * t + c;
  b01 = y * x * t + z * s;
  b02 = z * x * t - y * s;
  b10 = x * y * t - z * s;
  b11 = y * y * t + c;
  b12 = z * y * t + x * s;
  b20 = x * z * t + y * s;
  b21 = y * z * t - x * s;
  b22 = z * z * t + c; // Perform rotation-specific matrix multiplication

  out[0] = a00 * b00 + a10 * b01 + a20 * b02;
  out[1] = a01 * b00 + a11 * b01 + a21 * b02;
  out[2] = a02 * b00 + a12 * b01 + a22 * b02;
  out[3] = a03 * b00 + a13 * b01 + a23 * b02;
  out[4] = a00 * b10 + a10 * b11 + a20 * b12;
  out[5] = a01 * b10 + a11 * b11 + a21 * b12;
  out[6] = a02 * b10 + a12 * b11 + a22 * b12;
  out[7] = a03 * b10 + a13 * b11 + a23 * b12;
  out[8] = a00 * b20 + a10 * b21 + a20 * b22;
  out[9] = a01 * b20 + a11 * b21 + a21 * b22;
  out[10] = a02 * b20 + a12 * b21 + a22 * b22;
  out[11] = a03 * b20 + a13 * b21 + a23 * b22;
  if (a !== out) {
    // If the source and destination differ, copy the unchanged last row
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  }
  return out;
}
/**
 * Rotates a matrix by the given angle around the X axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateX(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a10 = a[4];
  var a11 = a[5];
  var a12 = a[6];
  var a13 = a[7];
  var a20 = a[8];
  var a21 = a[9];
  var a22 = a[10];
  var a23 = a[11];
  if (a !== out) {
    // If the source and destination differ, copy the unchanged rows
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication

  out[4] = a10 * c + a20 * s;
  out[5] = a11 * c + a21 * s;
  out[6] = a12 * c + a22 * s;
  out[7] = a13 * c + a23 * s;
  out[8] = a20 * c - a10 * s;
  out[9] = a21 * c - a11 * s;
  out[10] = a22 * c - a12 * s;
  out[11] = a23 * c - a13 * s;
  return out;
}
/**
 * Rotates a matrix by the given angle around the Y axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateY(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a00 = a[0];
  var a01 = a[1];
  var a02 = a[2];
  var a03 = a[3];
  var a20 = a[8];
  var a21 = a[9];
  var a22 = a[10];
  var a23 = a[11];
  if (a !== out) {
    // If the source and destination differ, copy the unchanged rows
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication

  out[0] = a00 * c - a20 * s;
  out[1] = a01 * c - a21 * s;
  out[2] = a02 * c - a22 * s;
  out[3] = a03 * c - a23 * s;
  out[8] = a00 * s + a20 * c;
  out[9] = a01 * s + a21 * c;
  out[10] = a02 * s + a22 * c;
  out[11] = a03 * s + a23 * c;
  return out;
}
/**
 * Rotates a matrix by the given angle around the Z axis
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function rotateZ(out, a, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad);
  var a00 = a[0];
  var a01 = a[1];
  var a02 = a[2];
  var a03 = a[3];
  var a10 = a[4];
  var a11 = a[5];
  var a12 = a[6];
  var a13 = a[7];
  if (a !== out) {
    // If the source and destination differ, copy the unchanged last row
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
  } // Perform axis-specific matrix multiplication

  out[0] = a00 * c + a10 * s;
  out[1] = a01 * c + a11 * s;
  out[2] = a02 * c + a12 * s;
  out[3] = a03 * c + a13 * s;
  out[4] = a10 * c - a00 * s;
  out[5] = a11 * c - a01 * s;
  out[6] = a12 * c - a02 * s;
  out[7] = a13 * c - a03 * s;
  return out;
}
/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */

function fromTranslation(out, v) {
  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.scale(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyVec3} v Scaling vector
 * @returns {mat4} out
 */

function fromScaling(out, v) {
  out[0] = v[0];
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = v[1];
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = v[2];
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a given angle around a given axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotate(dest, dest, rad, axis);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @param {ReadonlyVec3} axis the axis to rotate around
 * @returns {mat4} out
 */

function fromRotation(out, rad, axis) {
  var x = axis[0],
    y = axis[1],
    z = axis[2];
  var len = Math.hypot(x, y, z);
  var s, c, t;
  if (len < _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON) {
    return null;
  }
  len = 1 / len;
  x *= len;
  y *= len;
  z *= len;
  s = Math.sin(rad);
  c = Math.cos(rad);
  t = 1 - c; // Perform rotation-specific matrix multiplication

  out[0] = x * x * t + c;
  out[1] = y * x * t + z * s;
  out[2] = z * x * t - y * s;
  out[3] = 0;
  out[4] = x * y * t - z * s;
  out[5] = y * y * t + c;
  out[6] = z * y * t + x * s;
  out[7] = 0;
  out[8] = x * z * t + y * s;
  out[9] = y * z * t - x * s;
  out[10] = z * z * t + c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the X axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateX(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromXRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = 1;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = c;
  out[6] = s;
  out[7] = 0;
  out[8] = 0;
  out[9] = -s;
  out[10] = c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the Y axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateY(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromYRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = c;
  out[1] = 0;
  out[2] = -s;
  out[3] = 0;
  out[4] = 0;
  out[5] = 1;
  out[6] = 0;
  out[7] = 0;
  out[8] = s;
  out[9] = 0;
  out[10] = c;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from the given angle around the Z axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateZ(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */

function fromZRotation(out, rad) {
  var s = Math.sin(rad);
  var c = Math.cos(rad); // Perform axis-specific matrix multiplication

  out[0] = c;
  out[1] = s;
  out[2] = 0;
  out[3] = 0;
  out[4] = -s;
  out[5] = c;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 1;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @returns {mat4} out
 */

function fromRotationTranslation(out, q, v) {
  // Quaternion math
  var x = q[0],
    y = q[1],
    z = q[2],
    w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - (yy + zz);
  out[1] = xy + wz;
  out[2] = xz - wy;
  out[3] = 0;
  out[4] = xy - wz;
  out[5] = 1 - (xx + zz);
  out[6] = yz + wx;
  out[7] = 0;
  out[8] = xz + wy;
  out[9] = yz - wx;
  out[10] = 1 - (xx + yy);
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a new mat4 from a dual quat.
 *
 * @param {mat4} out Matrix
 * @param {ReadonlyQuat2} a Dual Quaternion
 * @returns {mat4} mat4 receiving operation result
 */

function fromQuat2(out, a) {
  var translation = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(3);
  var bx = -a[0],
    by = -a[1],
    bz = -a[2],
    bw = a[3],
    ax = a[4],
    ay = a[5],
    az = a[6],
    aw = a[7];
  var magnitude = bx * bx + by * by + bz * bz + bw * bw; //Only scale if it makes sense

  if (magnitude > 0) {
    translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2 / magnitude;
    translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2 / magnitude;
    translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2 / magnitude;
  } else {
    translation[0] = (ax * bw + aw * bx + ay * bz - az * by) * 2;
    translation[1] = (ay * bw + aw * by + az * bx - ax * bz) * 2;
    translation[2] = (az * bw + aw * bz + ax * by - ay * bx) * 2;
  }
  fromRotationTranslation(out, a, translation);
  return out;
}
/**
 * Returns the translation vector component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslation,
 *  the returned vector will be the same as the translation vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive translation component
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */

function getTranslation(out, mat) {
  out[0] = mat[12];
  out[1] = mat[13];
  out[2] = mat[14];
  return out;
}
/**
 * Returns the scaling factor component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslationScale
 *  with a normalized Quaternion paramter, the returned vector will be
 *  the same as the scaling vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive scaling factor component
 * @param  {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */

function getScaling(out, mat) {
  var m11 = mat[0];
  var m12 = mat[1];
  var m13 = mat[2];
  var m21 = mat[4];
  var m22 = mat[5];
  var m23 = mat[6];
  var m31 = mat[8];
  var m32 = mat[9];
  var m33 = mat[10];
  out[0] = Math.hypot(m11, m12, m13);
  out[1] = Math.hypot(m21, m22, m23);
  out[2] = Math.hypot(m31, m32, m33);
  return out;
}
/**
 * Returns a quaternion representing the rotational component
 *  of a transformation matrix. If a matrix is built with
 *  fromRotationTranslation, the returned quaternion will be the
 *  same as the quaternion originally supplied.
 * @param {quat} out Quaternion to receive the rotation component
 * @param {ReadonlyMat4} mat Matrix to be decomposed (input)
 * @return {quat} out
 */

function getRotation(out, mat) {
  var scaling = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(3);
  getScaling(scaling, mat);
  var is1 = 1 / scaling[0];
  var is2 = 1 / scaling[1];
  var is3 = 1 / scaling[2];
  var sm11 = mat[0] * is1;
  var sm12 = mat[1] * is2;
  var sm13 = mat[2] * is3;
  var sm21 = mat[4] * is1;
  var sm22 = mat[5] * is2;
  var sm23 = mat[6] * is3;
  var sm31 = mat[8] * is1;
  var sm32 = mat[9] * is2;
  var sm33 = mat[10] * is3;
  var trace = sm11 + sm22 + sm33;
  var S = 0;
  if (trace > 0) {
    S = Math.sqrt(trace + 1.0) * 2;
    out[3] = 0.25 * S;
    out[0] = (sm23 - sm32) / S;
    out[1] = (sm31 - sm13) / S;
    out[2] = (sm12 - sm21) / S;
  } else if (sm11 > sm22 && sm11 > sm33) {
    S = Math.sqrt(1.0 + sm11 - sm22 - sm33) * 2;
    out[3] = (sm23 - sm32) / S;
    out[0] = 0.25 * S;
    out[1] = (sm12 + sm21) / S;
    out[2] = (sm31 + sm13) / S;
  } else if (sm22 > sm33) {
    S = Math.sqrt(1.0 + sm22 - sm11 - sm33) * 2;
    out[3] = (sm31 - sm13) / S;
    out[0] = (sm12 + sm21) / S;
    out[1] = 0.25 * S;
    out[2] = (sm23 + sm32) / S;
  } else {
    S = Math.sqrt(1.0 + sm33 - sm11 - sm22) * 2;
    out[3] = (sm12 - sm21) / S;
    out[0] = (sm31 + sm13) / S;
    out[1] = (sm23 + sm32) / S;
    out[2] = 0.25 * S;
  }
  return out;
}
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @param {ReadonlyVec3} s Scaling vector
 * @returns {mat4} out
 */

function fromRotationTranslationScale(out, q, v, s) {
  // Quaternion math
  var x = q[0],
    y = q[1],
    z = q[2],
    w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  var sx = s[0];
  var sy = s[1];
  var sz = s[2];
  out[0] = (1 - (yy + zz)) * sx;
  out[1] = (xy + wz) * sx;
  out[2] = (xz - wy) * sx;
  out[3] = 0;
  out[4] = (xy - wz) * sy;
  out[5] = (1 - (xx + zz)) * sy;
  out[6] = (yz + wx) * sy;
  out[7] = 0;
  out[8] = (xz + wy) * sz;
  out[9] = (yz - wx) * sz;
  out[10] = (1 - (xx + yy)) * sz;
  out[11] = 0;
  out[12] = v[0];
  out[13] = v[1];
  out[14] = v[2];
  out[15] = 1;
  return out;
}
/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale, rotating and scaling around the given origin
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     mat4.translate(dest, origin);
 *     let quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *     mat4.translate(dest, negativeOrigin);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {ReadonlyVec3} v Translation vector
 * @param {ReadonlyVec3} s Scaling vector
 * @param {ReadonlyVec3} o The origin vector around which to scale and rotate
 * @returns {mat4} out
 */

function fromRotationTranslationScaleOrigin(out, q, v, s, o) {
  // Quaternion math
  var x = q[0],
    y = q[1],
    z = q[2],
    w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var xy = x * y2;
  var xz = x * z2;
  var yy = y * y2;
  var yz = y * z2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  var sx = s[0];
  var sy = s[1];
  var sz = s[2];
  var ox = o[0];
  var oy = o[1];
  var oz = o[2];
  var out0 = (1 - (yy + zz)) * sx;
  var out1 = (xy + wz) * sx;
  var out2 = (xz - wy) * sx;
  var out4 = (xy - wz) * sy;
  var out5 = (1 - (xx + zz)) * sy;
  var out6 = (yz + wx) * sy;
  var out8 = (xz + wy) * sz;
  var out9 = (yz - wx) * sz;
  var out10 = (1 - (xx + yy)) * sz;
  out[0] = out0;
  out[1] = out1;
  out[2] = out2;
  out[3] = 0;
  out[4] = out4;
  out[5] = out5;
  out[6] = out6;
  out[7] = 0;
  out[8] = out8;
  out[9] = out9;
  out[10] = out10;
  out[11] = 0;
  out[12] = v[0] + ox - (out0 * ox + out4 * oy + out8 * oz);
  out[13] = v[1] + oy - (out1 * ox + out5 * oy + out9 * oz);
  out[14] = v[2] + oz - (out2 * ox + out6 * oy + out10 * oz);
  out[15] = 1;
  return out;
}
/**
 * Calculates a 4x4 matrix from the given quaternion
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {ReadonlyQuat} q Quaternion to create matrix from
 *
 * @returns {mat4} out
 */

function fromQuat(out, q) {
  var x = q[0],
    y = q[1],
    z = q[2],
    w = q[3];
  var x2 = x + x;
  var y2 = y + y;
  var z2 = z + z;
  var xx = x * x2;
  var yx = y * x2;
  var yy = y * y2;
  var zx = z * x2;
  var zy = z * y2;
  var zz = z * z2;
  var wx = w * x2;
  var wy = w * y2;
  var wz = w * z2;
  out[0] = 1 - yy - zz;
  out[1] = yx + wz;
  out[2] = zx - wy;
  out[3] = 0;
  out[4] = yx - wz;
  out[5] = 1 - xx - zz;
  out[6] = zy + wx;
  out[7] = 0;
  out[8] = zx + wy;
  out[9] = zy - wx;
  out[10] = 1 - xx - yy;
  out[11] = 0;
  out[12] = 0;
  out[13] = 0;
  out[14] = 0;
  out[15] = 1;
  return out;
}
/**
 * Generates a frustum matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Number} left Left bound of the frustum
 * @param {Number} right Right bound of the frustum
 * @param {Number} bottom Bottom bound of the frustum
 * @param {Number} top Top bound of the frustum
 * @param {Number} near Near bound of the frustum
 * @param {Number} far Far bound of the frustum
 * @returns {mat4} out
 */

function frustum(out, left, right, bottom, top, near, far) {
  var rl = 1 / (right - left);
  var tb = 1 / (top - bottom);
  var nf = 1 / (near - far);
  out[0] = near * 2 * rl;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = near * 2 * tb;
  out[6] = 0;
  out[7] = 0;
  out[8] = (right + left) * rl;
  out[9] = (top + bottom) * tb;
  out[10] = (far + near) * nf;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[14] = far * near * 2 * nf;
  out[15] = 0;
  return out;
}
/**
 * Generates a perspective projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [-1, 1],
 * which matches WebGL/OpenGL's clip volume.
 * Passing null/undefined/no value for far will generate infinite projection matrix.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum, can be null or Infinity
 * @returns {mat4} out
 */

function perspectiveNO(out, fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2),
    nf;
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[15] = 0;
  if (far != null && far !== Infinity) {
    nf = 1 / (near - far);
    out[10] = (far + near) * nf;
    out[14] = 2 * far * near * nf;
  } else {
    out[10] = -1;
    out[14] = -2 * near;
  }
  return out;
}
/**
 * Alias for {@link mat4.perspectiveNO}
 * @function
 */

var perspective = perspectiveNO;
/**
 * Generates a perspective projection matrix suitable for WebGPU with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [0, 1],
 * which matches WebGPU/Vulkan/DirectX/Metal's clip volume.
 * Passing null/undefined/no value for far will generate infinite projection matrix.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum, can be null or Infinity
 * @returns {mat4} out
 */

function perspectiveZO(out, fovy, aspect, near, far) {
  var f = 1.0 / Math.tan(fovy / 2),
    nf;
  out[0] = f / aspect;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = f;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[11] = -1;
  out[12] = 0;
  out[13] = 0;
  out[15] = 0;
  if (far != null && far !== Infinity) {
    nf = 1 / (near - far);
    out[10] = far * nf;
    out[14] = far * near * nf;
  } else {
    out[10] = -1;
    out[14] = -near;
  }
  return out;
}
/**
 * Generates a perspective projection matrix with the given field of view.
 * This is primarily useful for generating projection matrices to be used
 * with the still experiemental WebVR API.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Object} fov Object containing the following values: upDegrees, downDegrees, leftDegrees, rightDegrees
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function perspectiveFromFieldOfView(out, fov, near, far) {
  var upTan = Math.tan(fov.upDegrees * Math.PI / 180.0);
  var downTan = Math.tan(fov.downDegrees * Math.PI / 180.0);
  var leftTan = Math.tan(fov.leftDegrees * Math.PI / 180.0);
  var rightTan = Math.tan(fov.rightDegrees * Math.PI / 180.0);
  var xScale = 2.0 / (leftTan + rightTan);
  var yScale = 2.0 / (upTan + downTan);
  out[0] = xScale;
  out[1] = 0.0;
  out[2] = 0.0;
  out[3] = 0.0;
  out[4] = 0.0;
  out[5] = yScale;
  out[6] = 0.0;
  out[7] = 0.0;
  out[8] = -((leftTan - rightTan) * xScale * 0.5);
  out[9] = (upTan - downTan) * yScale * 0.5;
  out[10] = far / (near - far);
  out[11] = -1.0;
  out[12] = 0.0;
  out[13] = 0.0;
  out[14] = far * near / (near - far);
  out[15] = 0.0;
  return out;
}
/**
 * Generates a orthogonal projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [-1, 1],
 * which matches WebGL/OpenGL's clip volume.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function orthoNO(out, left, right, bottom, top, near, far) {
  var lr = 1 / (left - right);
  var bt = 1 / (bottom - top);
  var nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = 2 * nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = (far + near) * nf;
  out[15] = 1;
  return out;
}
/**
 * Alias for {@link mat4.orthoNO}
 * @function
 */

var ortho = orthoNO;
/**
 * Generates a orthogonal projection matrix with the given bounds.
 * The near/far clip planes correspond to a normalized device coordinate Z range of [0, 1],
 * which matches WebGPU/Vulkan/DirectX/Metal's clip volume.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */

function orthoZO(out, left, right, bottom, top, near, far) {
  var lr = 1 / (left - right);
  var bt = 1 / (bottom - top);
  var nf = 1 / (near - far);
  out[0] = -2 * lr;
  out[1] = 0;
  out[2] = 0;
  out[3] = 0;
  out[4] = 0;
  out[5] = -2 * bt;
  out[6] = 0;
  out[7] = 0;
  out[8] = 0;
  out[9] = 0;
  out[10] = nf;
  out[11] = 0;
  out[12] = (left + right) * lr;
  out[13] = (top + bottom) * bt;
  out[14] = near * nf;
  out[15] = 1;
  return out;
}
/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis.
 * If you want a matrix that actually makes an object look at another object, you should use targetTo instead.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {ReadonlyVec3} eye Position of the viewer
 * @param {ReadonlyVec3} center Point the viewer is looking at
 * @param {ReadonlyVec3} up vec3 pointing up
 * @returns {mat4} out
 */

function lookAt(out, eye, center, up) {
  var x0, x1, x2, y0, y1, y2, z0, z1, z2, len;
  var eyex = eye[0];
  var eyey = eye[1];
  var eyez = eye[2];
  var upx = up[0];
  var upy = up[1];
  var upz = up[2];
  var centerx = center[0];
  var centery = center[1];
  var centerz = center[2];
  if (Math.abs(eyex - centerx) < _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON && Math.abs(eyey - centery) < _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON && Math.abs(eyez - centerz) < _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON) {
    return identity(out);
  }
  z0 = eyex - centerx;
  z1 = eyey - centery;
  z2 = eyez - centerz;
  len = 1 / Math.hypot(z0, z1, z2);
  z0 *= len;
  z1 *= len;
  z2 *= len;
  x0 = upy * z2 - upz * z1;
  x1 = upz * z0 - upx * z2;
  x2 = upx * z1 - upy * z0;
  len = Math.hypot(x0, x1, x2);
  if (!len) {
    x0 = 0;
    x1 = 0;
    x2 = 0;
  } else {
    len = 1 / len;
    x0 *= len;
    x1 *= len;
    x2 *= len;
  }
  y0 = z1 * x2 - z2 * x1;
  y1 = z2 * x0 - z0 * x2;
  y2 = z0 * x1 - z1 * x0;
  len = Math.hypot(y0, y1, y2);
  if (!len) {
    y0 = 0;
    y1 = 0;
    y2 = 0;
  } else {
    len = 1 / len;
    y0 *= len;
    y1 *= len;
    y2 *= len;
  }
  out[0] = x0;
  out[1] = y0;
  out[2] = z0;
  out[3] = 0;
  out[4] = x1;
  out[5] = y1;
  out[6] = z1;
  out[7] = 0;
  out[8] = x2;
  out[9] = y2;
  out[10] = z2;
  out[11] = 0;
  out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
  out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
  out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
  out[15] = 1;
  return out;
}
/**
 * Generates a matrix that makes something look at something else.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {ReadonlyVec3} eye Position of the viewer
 * @param {ReadonlyVec3} center Point the viewer is looking at
 * @param {ReadonlyVec3} up vec3 pointing up
 * @returns {mat4} out
 */

function targetTo(out, eye, target, up) {
  var eyex = eye[0],
    eyey = eye[1],
    eyez = eye[2],
    upx = up[0],
    upy = up[1],
    upz = up[2];
  var z0 = eyex - target[0],
    z1 = eyey - target[1],
    z2 = eyez - target[2];
  var len = z0 * z0 + z1 * z1 + z2 * z2;
  if (len > 0) {
    len = 1 / Math.sqrt(len);
    z0 *= len;
    z1 *= len;
    z2 *= len;
  }
  var x0 = upy * z2 - upz * z1,
    x1 = upz * z0 - upx * z2,
    x2 = upx * z1 - upy * z0;
  len = x0 * x0 + x1 * x1 + x2 * x2;
  if (len > 0) {
    len = 1 / Math.sqrt(len);
    x0 *= len;
    x1 *= len;
    x2 *= len;
  }
  out[0] = x0;
  out[1] = x1;
  out[2] = x2;
  out[3] = 0;
  out[4] = z1 * x2 - z2 * x1;
  out[5] = z2 * x0 - z0 * x2;
  out[6] = z0 * x1 - z1 * x0;
  out[7] = 0;
  out[8] = z0;
  out[9] = z1;
  out[10] = z2;
  out[11] = 0;
  out[12] = eyex;
  out[13] = eyey;
  out[14] = eyez;
  out[15] = 1;
  return out;
}
/**
 * Returns a string representation of a mat4
 *
 * @param {ReadonlyMat4} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */

function str(a) {
  return "mat4(" + a[0] + ", " + a[1] + ", " + a[2] + ", " + a[3] + ", " + a[4] + ", " + a[5] + ", " + a[6] + ", " + a[7] + ", " + a[8] + ", " + a[9] + ", " + a[10] + ", " + a[11] + ", " + a[12] + ", " + a[13] + ", " + a[14] + ", " + a[15] + ")";
}
/**
 * Returns Frobenius norm of a mat4
 *
 * @param {ReadonlyMat4} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */

function frob(a) {
  return Math.hypot(a[0], a[1], a[2], a[3], a[4], a[5], a[6], a[7], a[8], a[9], a[10], a[11], a[12], a[13], a[14], a[15]);
}
/**
 * Adds two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  out[3] = a[3] + b[3];
  out[4] = a[4] + b[4];
  out[5] = a[5] + b[5];
  out[6] = a[6] + b[6];
  out[7] = a[7] + b[7];
  out[8] = a[8] + b[8];
  out[9] = a[9] + b[9];
  out[10] = a[10] + b[10];
  out[11] = a[11] + b[11];
  out[12] = a[12] + b[12];
  out[13] = a[13] + b[13];
  out[14] = a[14] + b[14];
  out[15] = a[15] + b[15];
  return out;
}
/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @returns {mat4} out
 */

function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  out[3] = a[3] - b[3];
  out[4] = a[4] - b[4];
  out[5] = a[5] - b[5];
  out[6] = a[6] - b[6];
  out[7] = a[7] - b[7];
  out[8] = a[8] - b[8];
  out[9] = a[9] - b[9];
  out[10] = a[10] - b[10];
  out[11] = a[11] - b[11];
  out[12] = a[12] - b[12];
  out[13] = a[13] - b[13];
  out[14] = a[14] - b[14];
  out[15] = a[15] - b[15];
  return out;
}
/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat4} out the receiving matrix
 * @param {ReadonlyMat4} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat4} out
 */

function multiplyScalar(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  out[3] = a[3] * b;
  out[4] = a[4] * b;
  out[5] = a[5] * b;
  out[6] = a[6] * b;
  out[7] = a[7] * b;
  out[8] = a[8] * b;
  out[9] = a[9] * b;
  out[10] = a[10] * b;
  out[11] = a[11] * b;
  out[12] = a[12] * b;
  out[13] = a[13] * b;
  out[14] = a[14] * b;
  out[15] = a[15] * b;
  return out;
}
/**
 * Adds two mat4's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat4} out the receiving vector
 * @param {ReadonlyMat4} a the first operand
 * @param {ReadonlyMat4} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat4} out
 */

function multiplyScalarAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  out[3] = a[3] + b[3] * scale;
  out[4] = a[4] + b[4] * scale;
  out[5] = a[5] + b[5] * scale;
  out[6] = a[6] + b[6] * scale;
  out[7] = a[7] + b[7] * scale;
  out[8] = a[8] + b[8] * scale;
  out[9] = a[9] + b[9] * scale;
  out[10] = a[10] + b[10] * scale;
  out[11] = a[11] + b[11] * scale;
  out[12] = a[12] + b[12] * scale;
  out[13] = a[13] + b[13] * scale;
  out[14] = a[14] + b[14] * scale;
  out[15] = a[15] + b[15] * scale;
  return out;
}
/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] && a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
}
/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {ReadonlyMat4} a The first matrix.
 * @param {ReadonlyMat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */

function equals(a, b) {
  var a0 = a[0],
    a1 = a[1],
    a2 = a[2],
    a3 = a[3];
  var a4 = a[4],
    a5 = a[5],
    a6 = a[6],
    a7 = a[7];
  var a8 = a[8],
    a9 = a[9],
    a10 = a[10],
    a11 = a[11];
  var a12 = a[12],
    a13 = a[13],
    a14 = a[14],
    a15 = a[15];
  var b0 = b[0],
    b1 = b[1],
    b2 = b[2],
    b3 = b[3];
  var b4 = b[4],
    b5 = b[5],
    b6 = b[6],
    b7 = b[7];
  var b8 = b[8],
    b9 = b[9],
    b10 = b[10],
    b11 = b[11];
  var b12 = b[12],
    b13 = b[13],
    b14 = b[14],
    b15 = b[15];
  return Math.abs(a0 - b0) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2)) && Math.abs(a3 - b3) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a3), Math.abs(b3)) && Math.abs(a4 - b4) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a4), Math.abs(b4)) && Math.abs(a5 - b5) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a5), Math.abs(b5)) && Math.abs(a6 - b6) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a6), Math.abs(b6)) && Math.abs(a7 - b7) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a7), Math.abs(b7)) && Math.abs(a8 - b8) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a8), Math.abs(b8)) && Math.abs(a9 - b9) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a9), Math.abs(b9)) && Math.abs(a10 - b10) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a10), Math.abs(b10)) && Math.abs(a11 - b11) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a11), Math.abs(b11)) && Math.abs(a12 - b12) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a12), Math.abs(b12)) && Math.abs(a13 - b13) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a13), Math.abs(b13)) && Math.abs(a14 - b14) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a14), Math.abs(b14)) && Math.abs(a15 - b15) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a15), Math.abs(b15));
}
/**
 * Alias for {@link mat4.multiply}
 * @function
 */

var mul = multiply;
/**
 * Alias for {@link mat4.subtract}
 * @function
 */

var sub = subtract;

/***/ }),

/***/ "../../../node_modules/gl-matrix/esm/vec3.js":
/*!***************************************************!*\
  !*** ../../../node_modules/gl-matrix/esm/vec3.js ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "add": () => (/* binding */ add),
/* harmony export */   "angle": () => (/* binding */ angle),
/* harmony export */   "bezier": () => (/* binding */ bezier),
/* harmony export */   "ceil": () => (/* binding */ ceil),
/* harmony export */   "clone": () => (/* binding */ clone),
/* harmony export */   "copy": () => (/* binding */ copy),
/* harmony export */   "create": () => (/* binding */ create),
/* harmony export */   "cross": () => (/* binding */ cross),
/* harmony export */   "dist": () => (/* binding */ dist),
/* harmony export */   "distance": () => (/* binding */ distance),
/* harmony export */   "div": () => (/* binding */ div),
/* harmony export */   "divide": () => (/* binding */ divide),
/* harmony export */   "dot": () => (/* binding */ dot),
/* harmony export */   "equals": () => (/* binding */ equals),
/* harmony export */   "exactEquals": () => (/* binding */ exactEquals),
/* harmony export */   "floor": () => (/* binding */ floor),
/* harmony export */   "forEach": () => (/* binding */ forEach),
/* harmony export */   "fromValues": () => (/* binding */ fromValues),
/* harmony export */   "hermite": () => (/* binding */ hermite),
/* harmony export */   "inverse": () => (/* binding */ inverse),
/* harmony export */   "len": () => (/* binding */ len),
/* harmony export */   "length": () => (/* binding */ length),
/* harmony export */   "lerp": () => (/* binding */ lerp),
/* harmony export */   "max": () => (/* binding */ max),
/* harmony export */   "min": () => (/* binding */ min),
/* harmony export */   "mul": () => (/* binding */ mul),
/* harmony export */   "multiply": () => (/* binding */ multiply),
/* harmony export */   "negate": () => (/* binding */ negate),
/* harmony export */   "normalize": () => (/* binding */ normalize),
/* harmony export */   "random": () => (/* binding */ random),
/* harmony export */   "rotateX": () => (/* binding */ rotateX),
/* harmony export */   "rotateY": () => (/* binding */ rotateY),
/* harmony export */   "rotateZ": () => (/* binding */ rotateZ),
/* harmony export */   "round": () => (/* binding */ round),
/* harmony export */   "scale": () => (/* binding */ scale),
/* harmony export */   "scaleAndAdd": () => (/* binding */ scaleAndAdd),
/* harmony export */   "set": () => (/* binding */ set),
/* harmony export */   "sqrDist": () => (/* binding */ sqrDist),
/* harmony export */   "sqrLen": () => (/* binding */ sqrLen),
/* harmony export */   "squaredDistance": () => (/* binding */ squaredDistance),
/* harmony export */   "squaredLength": () => (/* binding */ squaredLength),
/* harmony export */   "str": () => (/* binding */ str),
/* harmony export */   "sub": () => (/* binding */ sub),
/* harmony export */   "subtract": () => (/* binding */ subtract),
/* harmony export */   "transformMat3": () => (/* binding */ transformMat3),
/* harmony export */   "transformMat4": () => (/* binding */ transformMat4),
/* harmony export */   "transformQuat": () => (/* binding */ transformQuat),
/* harmony export */   "zero": () => (/* binding */ zero)
/* harmony export */ });
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./common.js */ "../../../node_modules/gl-matrix/esm/common.js");

/**
 * 3 Dimensional Vector
 * @module vec3
 */

/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */

function create() {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(3);
  if (_common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE != Float32Array) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
  }
  return out;
}
/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {ReadonlyVec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */

function clone(a) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(3);
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Calculates the length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate length of
 * @returns {Number} length of a
 */

function length(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  return Math.hypot(x, y, z);
}
/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */

function fromValues(x, y, z) {
  var out = new _common_js__WEBPACK_IMPORTED_MODULE_0__.ARRAY_TYPE(3);
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the source vector
 * @returns {vec3} out
 */

function copy(out, a) {
  out[0] = a[0];
  out[1] = a[1];
  out[2] = a[2];
  return out;
}
/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */

function set(out, x, y, z) {
  out[0] = x;
  out[1] = y;
  out[2] = z;
  return out;
}
/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function add(out, a, b) {
  out[0] = a[0] + b[0];
  out[1] = a[1] + b[1];
  out[2] = a[2] + b[2];
  return out;
}
/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function subtract(out, a, b) {
  out[0] = a[0] - b[0];
  out[1] = a[1] - b[1];
  out[2] = a[2] - b[2];
  return out;
}
/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function multiply(out, a, b) {
  out[0] = a[0] * b[0];
  out[1] = a[1] * b[1];
  out[2] = a[2] * b[2];
  return out;
}
/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function divide(out, a, b) {
  out[0] = a[0] / b[0];
  out[1] = a[1] / b[1];
  out[2] = a[2] / b[2];
  return out;
}
/**
 * Math.ceil the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to ceil
 * @returns {vec3} out
 */

function ceil(out, a) {
  out[0] = Math.ceil(a[0]);
  out[1] = Math.ceil(a[1]);
  out[2] = Math.ceil(a[2]);
  return out;
}
/**
 * Math.floor the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to floor
 * @returns {vec3} out
 */

function floor(out, a) {
  out[0] = Math.floor(a[0]);
  out[1] = Math.floor(a[1]);
  out[2] = Math.floor(a[2]);
  return out;
}
/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function min(out, a, b) {
  out[0] = Math.min(a[0], b[0]);
  out[1] = Math.min(a[1], b[1]);
  out[2] = Math.min(a[2], b[2]);
  return out;
}
/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function max(out, a, b) {
  out[0] = Math.max(a[0], b[0]);
  out[1] = Math.max(a[1], b[1]);
  out[2] = Math.max(a[2], b[2]);
  return out;
}
/**
 * Math.round the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to round
 * @returns {vec3} out
 */

function round(out, a) {
  out[0] = Math.round(a[0]);
  out[1] = Math.round(a[1]);
  out[2] = Math.round(a[2]);
  return out;
}
/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */

function scale(out, a, b) {
  out[0] = a[0] * b;
  out[1] = a[1] * b;
  out[2] = a[2] * b;
  return out;
}
/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */

function scaleAndAdd(out, a, b, scale) {
  out[0] = a[0] + b[0] * scale;
  out[1] = a[1] + b[1] * scale;
  out[2] = a[2] + b[2] * scale;
  return out;
}
/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} distance between a and b
 */

function distance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return Math.hypot(x, y, z);
}
/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} squared distance between a and b
 */

function squaredDistance(a, b) {
  var x = b[0] - a[0];
  var y = b[1] - a[1];
  var z = b[2] - a[2];
  return x * x + y * y + z * z;
}
/**
 * Calculates the squared length of a vec3
 *
 * @param {ReadonlyVec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */

function squaredLength(a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  return x * x + y * y + z * z;
}
/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to negate
 * @returns {vec3} out
 */

function negate(out, a) {
  out[0] = -a[0];
  out[1] = -a[1];
  out[2] = -a[2];
  return out;
}
/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to invert
 * @returns {vec3} out
 */

function inverse(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  return out;
}
/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a vector to normalize
 * @returns {vec3} out
 */

function normalize(out, a) {
  var x = a[0];
  var y = a[1];
  var z = a[2];
  var len = x * x + y * y + z * z;
  if (len > 0) {
    //TODO: evaluate use of glm_invsqrt here?
    len = 1 / Math.sqrt(len);
  }
  out[0] = a[0] * len;
  out[1] = a[1] * len;
  out[2] = a[2] * len;
  return out;
}
/**
 * Calculates the dot product of two vec3's
 *
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {Number} dot product of a and b
 */

function dot(a, b) {
  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
}
/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @returns {vec3} out
 */

function cross(out, a, b) {
  var ax = a[0],
    ay = a[1],
    az = a[2];
  var bx = b[0],
    by = b[1],
    bz = b[2];
  out[0] = ay * bz - az * by;
  out[1] = az * bx - ax * bz;
  out[2] = ax * by - ay * bx;
  return out;
}
/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function lerp(out, a, b, t) {
  var ax = a[0];
  var ay = a[1];
  var az = a[2];
  out[0] = ax + t * (b[0] - ax);
  out[1] = ay + t * (b[1] - ay);
  out[2] = az + t * (b[2] - az);
  return out;
}
/**
 * Performs a hermite interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function hermite(out, a, b, c, d, t) {
  var factorTimes2 = t * t;
  var factor1 = factorTimes2 * (2 * t - 3) + 1;
  var factor2 = factorTimes2 * (t - 2) + t;
  var factor3 = factorTimes2 * (t - 1);
  var factor4 = factorTimes2 * (3 - 2 * t);
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  return out;
}
/**
 * Performs a bezier interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the first operand
 * @param {ReadonlyVec3} b the second operand
 * @param {ReadonlyVec3} c the third operand
 * @param {ReadonlyVec3} d the fourth operand
 * @param {Number} t interpolation amount, in the range [0-1], between the two inputs
 * @returns {vec3} out
 */

function bezier(out, a, b, c, d, t) {
  var inverseFactor = 1 - t;
  var inverseFactorTimesTwo = inverseFactor * inverseFactor;
  var factorTimes2 = t * t;
  var factor1 = inverseFactorTimesTwo * inverseFactor;
  var factor2 = 3 * t * inverseFactorTimesTwo;
  var factor3 = 3 * factorTimes2 * inverseFactor;
  var factor4 = factorTimes2 * t;
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  return out;
}
/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec3} out
 */

function random(out, scale) {
  scale = scale || 1.0;
  var r = _common_js__WEBPACK_IMPORTED_MODULE_0__.RANDOM() * 2.0 * Math.PI;
  var z = _common_js__WEBPACK_IMPORTED_MODULE_0__.RANDOM() * 2.0 - 1.0;
  var zScale = Math.sqrt(1.0 - z * z) * scale;
  out[0] = Math.cos(r) * zScale;
  out[1] = Math.sin(r) * zScale;
  out[2] = z * scale;
  return out;
}
/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat4} m matrix to transform with
 * @returns {vec3} out
 */

function transformMat4(out, a, m) {
  var x = a[0],
    y = a[1],
    z = a[2];
  var w = m[3] * x + m[7] * y + m[11] * z + m[15];
  w = w || 1.0;
  out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
  out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
  out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
  return out;
}
/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyMat3} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */

function transformMat3(out, a, m) {
  var x = a[0],
    y = a[1],
    z = a[2];
  out[0] = x * m[0] + y * m[3] + z * m[6];
  out[1] = x * m[1] + y * m[4] + z * m[7];
  out[2] = x * m[2] + y * m[5] + z * m[8];
  return out;
}
/**
 * Transforms the vec3 with a quat
 * Can also be used for dual quaternions. (Multiply it with the real part)
 *
 * @param {vec3} out the receiving vector
 * @param {ReadonlyVec3} a the vector to transform
 * @param {ReadonlyQuat} q quaternion to transform with
 * @returns {vec3} out
 */

function transformQuat(out, a, q) {
  // benchmarks: https://jsperf.com/quaternion-transform-vec3-implementations-fixed
  var qx = q[0],
    qy = q[1],
    qz = q[2],
    qw = q[3];
  var x = a[0],
    y = a[1],
    z = a[2]; // var qvec = [qx, qy, qz];
  // var uv = vec3.cross([], qvec, a);

  var uvx = qy * z - qz * y,
    uvy = qz * x - qx * z,
    uvz = qx * y - qy * x; // var uuv = vec3.cross([], qvec, uv);

  var uuvx = qy * uvz - qz * uvy,
    uuvy = qz * uvx - qx * uvz,
    uuvz = qx * uvy - qy * uvx; // vec3.scale(uv, uv, 2 * w);

  var w2 = qw * 2;
  uvx *= w2;
  uvy *= w2;
  uvz *= w2; // vec3.scale(uuv, uuv, 2);

  uuvx *= 2;
  uuvy *= 2;
  uuvz *= 2; // return vec3.add(out, a, vec3.add(out, uv, uuv));

  out[0] = x + uvx + uuvx;
  out[1] = y + uvy + uuvy;
  out[2] = z + uvz + uuvz;
  return out;
}
/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function rotateX(out, a, b, rad) {
  var p = [],
    r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[0];
  r[1] = p[1] * Math.cos(rad) - p[2] * Math.sin(rad);
  r[2] = p[1] * Math.sin(rad) + p[2] * Math.cos(rad); //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function rotateY(out, a, b, rad) {
  var p = [],
    r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[2] * Math.sin(rad) + p[0] * Math.cos(rad);
  r[1] = p[1];
  r[2] = p[2] * Math.cos(rad) - p[0] * Math.sin(rad); //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {ReadonlyVec3} a The vec3 point to rotate
 * @param {ReadonlyVec3} b The origin of the rotation
 * @param {Number} rad The angle of rotation in radians
 * @returns {vec3} out
 */

function rotateZ(out, a, b, rad) {
  var p = [],
    r = []; //Translate point to the origin

  p[0] = a[0] - b[0];
  p[1] = a[1] - b[1];
  p[2] = a[2] - b[2]; //perform rotation

  r[0] = p[0] * Math.cos(rad) - p[1] * Math.sin(rad);
  r[1] = p[0] * Math.sin(rad) + p[1] * Math.cos(rad);
  r[2] = p[2]; //translate to correct position

  out[0] = r[0] + b[0];
  out[1] = r[1] + b[1];
  out[2] = r[2] + b[2];
  return out;
}
/**
 * Get the angle between two 3D vectors
 * @param {ReadonlyVec3} a The first operand
 * @param {ReadonlyVec3} b The second operand
 * @returns {Number} The angle in radians
 */

function angle(a, b) {
  var ax = a[0],
    ay = a[1],
    az = a[2],
    bx = b[0],
    by = b[1],
    bz = b[2],
    mag1 = Math.sqrt(ax * ax + ay * ay + az * az),
    mag2 = Math.sqrt(bx * bx + by * by + bz * bz),
    mag = mag1 * mag2,
    cosine = mag && dot(a, b) / mag;
  return Math.acos(Math.min(Math.max(cosine, -1), 1));
}
/**
 * Set the components of a vec3 to zero
 *
 * @param {vec3} out the receiving vector
 * @returns {vec3} out
 */

function zero(out) {
  out[0] = 0.0;
  out[1] = 0.0;
  out[2] = 0.0;
  return out;
}
/**
 * Returns a string representation of a vector
 *
 * @param {ReadonlyVec3} a vector to represent as a string
 * @returns {String} string representation of the vector
 */

function str(a) {
  return "vec3(" + a[0] + ", " + a[1] + ", " + a[2] + ")";
}
/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function exactEquals(a, b) {
  return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
}
/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {ReadonlyVec3} a The first vector.
 * @param {ReadonlyVec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */

function equals(a, b) {
  var a0 = a[0],
    a1 = a[1],
    a2 = a[2];
  var b0 = b[0],
    b1 = b[1],
    b2 = b[2];
  return Math.abs(a0 - b0) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a0), Math.abs(b0)) && Math.abs(a1 - b1) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a1), Math.abs(b1)) && Math.abs(a2 - b2) <= _common_js__WEBPACK_IMPORTED_MODULE_0__.EPSILON * Math.max(1.0, Math.abs(a2), Math.abs(b2));
}
/**
 * Alias for {@link vec3.subtract}
 * @function
 */

var sub = subtract;
/**
 * Alias for {@link vec3.multiply}
 * @function
 */

var mul = multiply;
/**
 * Alias for {@link vec3.divide}
 * @function
 */

var div = divide;
/**
 * Alias for {@link vec3.distance}
 * @function
 */

var dist = distance;
/**
 * Alias for {@link vec3.squaredDistance}
 * @function
 */

var sqrDist = squaredDistance;
/**
 * Alias for {@link vec3.length}
 * @function
 */

var len = length;
/**
 * Alias for {@link vec3.squaredLength}
 * @function
 */

var sqrLen = squaredLength;
/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */

var forEach = function () {
  var vec = create();
  return function (a, stride, offset, count, fn, arg) {
    var i, l;
    if (!stride) {
      stride = 3;
    }
    if (!offset) {
      offset = 0;
    }
    if (count) {
      l = Math.min(count * stride + offset, a.length);
    } else {
      l = a.length;
    }
    for (i = offset; i < l; i += stride) {
      vec[0] = a[i];
      vec[1] = a[i + 1];
      vec[2] = a[i + 2];
      fn(vec, vec, arg);
      a[i] = vec[0];
      a[i + 1] = vec[1];
      a[i + 2] = vec[2];
    }
    return a;
  };
}();

/***/ }),

/***/ "../../../node_modules/is-buffer/index.js":
/*!************************************************!*\
  !*** ../../../node_modules/is-buffer/index.js ***!
  \************************************************/
/***/ ((module) => {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer(obj) {
  return obj != null && obj.constructor != null && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
};

/***/ }),

/***/ "../../../node_modules/lodash/lodash.js":
/*!**********************************************!*\
  !*** ../../../node_modules/lodash/lodash.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */;(function(){/** Used as a safe reference for `undefined` in pre-ES5 environments. */var undefined;/** Used as the semantic version number. */var VERSION='4.17.21';/** Used as the size to enable large array optimizations. */var LARGE_ARRAY_SIZE=200;/** Error message constants. */var CORE_ERROR_TEXT='Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',FUNC_ERROR_TEXT='Expected a function',INVALID_TEMPL_VAR_ERROR_TEXT='Invalid `variable` option passed into `_.template`';/** Used to stand-in for `undefined` hash values. */var HASH_UNDEFINED='__lodash_hash_undefined__';/** Used as the maximum memoize cache size. */var MAX_MEMOIZE_SIZE=500;/** Used as the internal argument placeholder. */var PLACEHOLDER='__lodash_placeholder__';/** Used to compose bitmasks for cloning. */var CLONE_DEEP_FLAG=1,CLONE_FLAT_FLAG=2,CLONE_SYMBOLS_FLAG=4;/** Used to compose bitmasks for value comparisons. */var COMPARE_PARTIAL_FLAG=1,COMPARE_UNORDERED_FLAG=2;/** Used to compose bitmasks for function metadata. */var WRAP_BIND_FLAG=1,WRAP_BIND_KEY_FLAG=2,WRAP_CURRY_BOUND_FLAG=4,WRAP_CURRY_FLAG=8,WRAP_CURRY_RIGHT_FLAG=16,WRAP_PARTIAL_FLAG=32,WRAP_PARTIAL_RIGHT_FLAG=64,WRAP_ARY_FLAG=128,WRAP_REARG_FLAG=256,WRAP_FLIP_FLAG=512;/** Used as default options for `_.truncate`. */var DEFAULT_TRUNC_LENGTH=30,DEFAULT_TRUNC_OMISSION='...';/** Used to detect hot functions by number of calls within a span of milliseconds. */var HOT_COUNT=800,HOT_SPAN=16;/** Used to indicate the type of lazy iteratees. */var LAZY_FILTER_FLAG=1,LAZY_MAP_FLAG=2,LAZY_WHILE_FLAG=3;/** Used as references for various `Number` constants. */var INFINITY=1/0,MAX_SAFE_INTEGER=9007199254740991,MAX_INTEGER=1.7976931348623157e+308,NAN=0/0;/** Used as references for the maximum length and index of an array. */var MAX_ARRAY_LENGTH=4294967295,MAX_ARRAY_INDEX=MAX_ARRAY_LENGTH-1,HALF_MAX_ARRAY_LENGTH=MAX_ARRAY_LENGTH>>>1;/** Used to associate wrap methods with their bit flags. */var wrapFlags=[['ary',WRAP_ARY_FLAG],['bind',WRAP_BIND_FLAG],['bindKey',WRAP_BIND_KEY_FLAG],['curry',WRAP_CURRY_FLAG],['curryRight',WRAP_CURRY_RIGHT_FLAG],['flip',WRAP_FLIP_FLAG],['partial',WRAP_PARTIAL_FLAG],['partialRight',WRAP_PARTIAL_RIGHT_FLAG],['rearg',WRAP_REARG_FLAG]];/** `Object#toString` result references. */var argsTag='[object Arguments]',arrayTag='[object Array]',asyncTag='[object AsyncFunction]',boolTag='[object Boolean]',dateTag='[object Date]',domExcTag='[object DOMException]',errorTag='[object Error]',funcTag='[object Function]',genTag='[object GeneratorFunction]',mapTag='[object Map]',numberTag='[object Number]',nullTag='[object Null]',objectTag='[object Object]',promiseTag='[object Promise]',proxyTag='[object Proxy]',regexpTag='[object RegExp]',setTag='[object Set]',stringTag='[object String]',symbolTag='[object Symbol]',undefinedTag='[object Undefined]',weakMapTag='[object WeakMap]',weakSetTag='[object WeakSet]';var arrayBufferTag='[object ArrayBuffer]',dataViewTag='[object DataView]',float32Tag='[object Float32Array]',float64Tag='[object Float64Array]',int8Tag='[object Int8Array]',int16Tag='[object Int16Array]',int32Tag='[object Int32Array]',uint8Tag='[object Uint8Array]',uint8ClampedTag='[object Uint8ClampedArray]',uint16Tag='[object Uint16Array]',uint32Tag='[object Uint32Array]';/** Used to match empty string literals in compiled template source. */var reEmptyStringLeading=/\b__p \+= '';/g,reEmptyStringMiddle=/\b(__p \+=) '' \+/g,reEmptyStringTrailing=/(__e\(.*?\)|\b__t\)) \+\n'';/g;/** Used to match HTML entities and HTML characters. */var reEscapedHtml=/&(?:amp|lt|gt|quot|#39);/g,reUnescapedHtml=/[&<>"']/g,reHasEscapedHtml=RegExp(reEscapedHtml.source),reHasUnescapedHtml=RegExp(reUnescapedHtml.source);/** Used to match template delimiters. */var reEscape=/<%-([\s\S]+?)%>/g,reEvaluate=/<%([\s\S]+?)%>/g,reInterpolate=/<%=([\s\S]+?)%>/g;/** Used to match property names within property paths. */var reIsDeepProp=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,reIsPlainProp=/^\w*$/,rePropName=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;/**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */var reRegExpChar=/[\\^$.*+?()[\]{}|]/g,reHasRegExpChar=RegExp(reRegExpChar.source);/** Used to match leading whitespace. */var reTrimStart=/^\s+/;/** Used to match a single whitespace character. */var reWhitespace=/\s/;/** Used to match wrap detail comments. */var reWrapComment=/\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,reWrapDetails=/\{\n\/\* \[wrapped with (.+)\] \*/,reSplitDetails=/,? & /;/** Used to match words composed of alphanumeric characters. */var reAsciiWord=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;/**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */var reForbiddenIdentifierChars=/[()=,{}\[\]\/\s]/;/** Used to match backslashes in property paths. */var reEscapeChar=/\\(\\)?/g;/**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */var reEsTemplate=/\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;/** Used to match `RegExp` flags from their coerced string values. */var reFlags=/\w*$/;/** Used to detect bad signed hexadecimal string values. */var reIsBadHex=/^[-+]0x[0-9a-f]+$/i;/** Used to detect binary string values. */var reIsBinary=/^0b[01]+$/i;/** Used to detect host constructors (Safari). */var reIsHostCtor=/^\[object .+?Constructor\]$/;/** Used to detect octal string values. */var reIsOctal=/^0o[0-7]+$/i;/** Used to detect unsigned integer values. */var reIsUint=/^(?:0|[1-9]\d*)$/;/** Used to match Latin Unicode letters (excluding mathematical operators). */var reLatin=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;/** Used to ensure capturing order of template delimiters. */var reNoMatch=/($^)/;/** Used to match unescaped characters in compiled string literals. */var reUnescapedString=/['\n\r\u2028\u2029\\]/g;/** Used to compose unicode character classes. */var rsAstralRange='\\ud800-\\udfff',rsComboMarksRange='\\u0300-\\u036f',reComboHalfMarksRange='\\ufe20-\\ufe2f',rsComboSymbolsRange='\\u20d0-\\u20ff',rsComboRange=rsComboMarksRange+reComboHalfMarksRange+rsComboSymbolsRange,rsDingbatRange='\\u2700-\\u27bf',rsLowerRange='a-z\\xdf-\\xf6\\xf8-\\xff',rsMathOpRange='\\xac\\xb1\\xd7\\xf7',rsNonCharRange='\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',rsPunctuationRange='\\u2000-\\u206f',rsSpaceRange=' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',rsUpperRange='A-Z\\xc0-\\xd6\\xd8-\\xde',rsVarRange='\\ufe0e\\ufe0f',rsBreakRange=rsMathOpRange+rsNonCharRange+rsPunctuationRange+rsSpaceRange;/** Used to compose unicode capture groups. */var rsApos="['\u2019]",rsAstral='['+rsAstralRange+']',rsBreak='['+rsBreakRange+']',rsCombo='['+rsComboRange+']',rsDigits='\\d+',rsDingbat='['+rsDingbatRange+']',rsLower='['+rsLowerRange+']',rsMisc='[^'+rsAstralRange+rsBreakRange+rsDigits+rsDingbatRange+rsLowerRange+rsUpperRange+']',rsFitz='\\ud83c[\\udffb-\\udfff]',rsModifier='(?:'+rsCombo+'|'+rsFitz+')',rsNonAstral='[^'+rsAstralRange+']',rsRegional='(?:\\ud83c[\\udde6-\\uddff]){2}',rsSurrPair='[\\ud800-\\udbff][\\udc00-\\udfff]',rsUpper='['+rsUpperRange+']',rsZWJ='\\u200d';/** Used to compose unicode regexes. */var rsMiscLower='(?:'+rsLower+'|'+rsMisc+')',rsMiscUpper='(?:'+rsUpper+'|'+rsMisc+')',rsOptContrLower='(?:'+rsApos+'(?:d|ll|m|re|s|t|ve))?',rsOptContrUpper='(?:'+rsApos+'(?:D|LL|M|RE|S|T|VE))?',reOptMod=rsModifier+'?',rsOptVar='['+rsVarRange+']?',rsOptJoin='(?:'+rsZWJ+'(?:'+[rsNonAstral,rsRegional,rsSurrPair].join('|')+')'+rsOptVar+reOptMod+')*',rsOrdLower='\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',rsOrdUpper='\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',rsSeq=rsOptVar+reOptMod+rsOptJoin,rsEmoji='(?:'+[rsDingbat,rsRegional,rsSurrPair].join('|')+')'+rsSeq,rsSymbol='(?:'+[rsNonAstral+rsCombo+'?',rsCombo,rsRegional,rsSurrPair,rsAstral].join('|')+')';/** Used to match apostrophes. */var reApos=RegExp(rsApos,'g');/**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */var reComboMark=RegExp(rsCombo,'g');/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */var reUnicode=RegExp(rsFitz+'(?='+rsFitz+')|'+rsSymbol+rsSeq,'g');/** Used to match complex or compound words. */var reUnicodeWord=RegExp([rsUpper+'?'+rsLower+'+'+rsOptContrLower+'(?='+[rsBreak,rsUpper,'$'].join('|')+')',rsMiscUpper+'+'+rsOptContrUpper+'(?='+[rsBreak,rsUpper+rsMiscLower,'$'].join('|')+')',rsUpper+'?'+rsMiscLower+'+'+rsOptContrLower,rsUpper+'+'+rsOptContrUpper,rsOrdUpper,rsOrdLower,rsDigits,rsEmoji].join('|'),'g');/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */var reHasUnicode=RegExp('['+rsZWJ+rsAstralRange+rsComboRange+rsVarRange+']');/** Used to detect strings that need a more robust regexp to match words. */var reHasUnicodeWord=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;/** Used to assign default `context` object properties. */var contextProps=['Array','Buffer','DataView','Date','Error','Float32Array','Float64Array','Function','Int8Array','Int16Array','Int32Array','Map','Math','Object','Promise','RegExp','Set','String','Symbol','TypeError','Uint8Array','Uint8ClampedArray','Uint16Array','Uint32Array','WeakMap','_','clearTimeout','isFinite','parseInt','setTimeout'];/** Used to make template sourceURLs easier to identify. */var templateCounter=-1;/** Used to identify `toStringTag` values of typed arrays. */var typedArrayTags={};typedArrayTags[float32Tag]=typedArrayTags[float64Tag]=typedArrayTags[int8Tag]=typedArrayTags[int16Tag]=typedArrayTags[int32Tag]=typedArrayTags[uint8Tag]=typedArrayTags[uint8ClampedTag]=typedArrayTags[uint16Tag]=typedArrayTags[uint32Tag]=true;typedArrayTags[argsTag]=typedArrayTags[arrayTag]=typedArrayTags[arrayBufferTag]=typedArrayTags[boolTag]=typedArrayTags[dataViewTag]=typedArrayTags[dateTag]=typedArrayTags[errorTag]=typedArrayTags[funcTag]=typedArrayTags[mapTag]=typedArrayTags[numberTag]=typedArrayTags[objectTag]=typedArrayTags[regexpTag]=typedArrayTags[setTag]=typedArrayTags[stringTag]=typedArrayTags[weakMapTag]=false;/** Used to identify `toStringTag` values supported by `_.clone`. */var cloneableTags={};cloneableTags[argsTag]=cloneableTags[arrayTag]=cloneableTags[arrayBufferTag]=cloneableTags[dataViewTag]=cloneableTags[boolTag]=cloneableTags[dateTag]=cloneableTags[float32Tag]=cloneableTags[float64Tag]=cloneableTags[int8Tag]=cloneableTags[int16Tag]=cloneableTags[int32Tag]=cloneableTags[mapTag]=cloneableTags[numberTag]=cloneableTags[objectTag]=cloneableTags[regexpTag]=cloneableTags[setTag]=cloneableTags[stringTag]=cloneableTags[symbolTag]=cloneableTags[uint8Tag]=cloneableTags[uint8ClampedTag]=cloneableTags[uint16Tag]=cloneableTags[uint32Tag]=true;cloneableTags[errorTag]=cloneableTags[funcTag]=cloneableTags[weakMapTag]=false;/** Used to map Latin Unicode letters to basic Latin letters. */var deburredLetters={// Latin-1 Supplement block.
'\xc0':'A','\xc1':'A','\xc2':'A','\xc3':'A','\xc4':'A','\xc5':'A','\xe0':'a','\xe1':'a','\xe2':'a','\xe3':'a','\xe4':'a','\xe5':'a','\xc7':'C','\xe7':'c','\xd0':'D','\xf0':'d','\xc8':'E','\xc9':'E','\xca':'E','\xcb':'E','\xe8':'e','\xe9':'e','\xea':'e','\xeb':'e','\xcc':'I','\xcd':'I','\xce':'I','\xcf':'I','\xec':'i','\xed':'i','\xee':'i','\xef':'i','\xd1':'N','\xf1':'n','\xd2':'O','\xd3':'O','\xd4':'O','\xd5':'O','\xd6':'O','\xd8':'O','\xf2':'o','\xf3':'o','\xf4':'o','\xf5':'o','\xf6':'o','\xf8':'o','\xd9':'U','\xda':'U','\xdb':'U','\xdc':'U','\xf9':'u','\xfa':'u','\xfb':'u','\xfc':'u','\xdd':'Y','\xfd':'y','\xff':'y','\xc6':'Ae','\xe6':'ae','\xde':'Th','\xfe':'th','\xdf':'ss',// Latin Extended-A block.
'\u0100':'A','\u0102':'A','\u0104':'A','\u0101':'a','\u0103':'a','\u0105':'a','\u0106':'C','\u0108':'C','\u010a':'C','\u010c':'C','\u0107':'c','\u0109':'c','\u010b':'c','\u010d':'c','\u010e':'D','\u0110':'D','\u010f':'d','\u0111':'d','\u0112':'E','\u0114':'E','\u0116':'E','\u0118':'E','\u011a':'E','\u0113':'e','\u0115':'e','\u0117':'e','\u0119':'e','\u011b':'e','\u011c':'G','\u011e':'G','\u0120':'G','\u0122':'G','\u011d':'g','\u011f':'g','\u0121':'g','\u0123':'g','\u0124':'H','\u0126':'H','\u0125':'h','\u0127':'h','\u0128':'I','\u012a':'I','\u012c':'I','\u012e':'I','\u0130':'I','\u0129':'i','\u012b':'i','\u012d':'i','\u012f':'i','\u0131':'i','\u0134':'J','\u0135':'j','\u0136':'K','\u0137':'k','\u0138':'k','\u0139':'L','\u013b':'L','\u013d':'L','\u013f':'L','\u0141':'L','\u013a':'l','\u013c':'l','\u013e':'l','\u0140':'l','\u0142':'l','\u0143':'N','\u0145':'N','\u0147':'N','\u014a':'N','\u0144':'n','\u0146':'n','\u0148':'n','\u014b':'n','\u014c':'O','\u014e':'O','\u0150':'O','\u014d':'o','\u014f':'o','\u0151':'o','\u0154':'R','\u0156':'R','\u0158':'R','\u0155':'r','\u0157':'r','\u0159':'r','\u015a':'S','\u015c':'S','\u015e':'S','\u0160':'S','\u015b':'s','\u015d':'s','\u015f':'s','\u0161':'s','\u0162':'T','\u0164':'T','\u0166':'T','\u0163':'t','\u0165':'t','\u0167':'t','\u0168':'U','\u016a':'U','\u016c':'U','\u016e':'U','\u0170':'U','\u0172':'U','\u0169':'u','\u016b':'u','\u016d':'u','\u016f':'u','\u0171':'u','\u0173':'u','\u0174':'W','\u0175':'w','\u0176':'Y','\u0177':'y','\u0178':'Y','\u0179':'Z','\u017b':'Z','\u017d':'Z','\u017a':'z','\u017c':'z','\u017e':'z','\u0132':'IJ','\u0133':'ij','\u0152':'Oe','\u0153':'oe','\u0149':"'n",'\u017f':'s'};/** Used to map characters to HTML entities. */var htmlEscapes={'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'};/** Used to map HTML entities to characters. */var htmlUnescapes={'&amp;':'&','&lt;':'<','&gt;':'>','&quot;':'"','&#39;':"'"};/** Used to escape characters for inclusion in compiled string literals. */var stringEscapes={'\\':'\\',"'":"'",'\n':'n','\r':'r','\u2028':'u2028','\u2029':'u2029'};/** Built-in method references without a dependency on `root`. */var freeParseFloat=parseFloat,freeParseInt=parseInt;/** Detect free variable `global` from Node.js. */var freeGlobal=typeof __webpack_require__.g=='object'&&__webpack_require__.g&&__webpack_require__.g.Object===Object&&__webpack_require__.g;/** Detect free variable `self`. */var freeSelf=typeof self=='object'&&self&&self.Object===Object&&self;/** Used as a reference to the global object. */var root=freeGlobal||freeSelf||Function('return this')();/** Detect free variable `exports`. */var freeExports= true&&exports&&!exports.nodeType&&exports;/** Detect free variable `module`. */var freeModule=freeExports&&"object"=='object'&&module&&!module.nodeType&&module;/** Detect the popular CommonJS extension `module.exports`. */var moduleExports=freeModule&&freeModule.exports===freeExports;/** Detect free variable `process` from Node.js. */var freeProcess=moduleExports&&freeGlobal.process;/** Used to access faster Node.js helpers. */var nodeUtil=function(){try{// Use `util.types` for Node.js 10+.
var types=freeModule&&freeModule.require&&freeModule.require('util').types;if(types){return types;}// Legacy `process.binding('util')` for Node.js < 10.
return freeProcess&&freeProcess.binding&&freeProcess.binding('util');}catch(e){}}();/* Node.js helper references. */var nodeIsArrayBuffer=nodeUtil&&nodeUtil.isArrayBuffer,nodeIsDate=nodeUtil&&nodeUtil.isDate,nodeIsMap=nodeUtil&&nodeUtil.isMap,nodeIsRegExp=nodeUtil&&nodeUtil.isRegExp,nodeIsSet=nodeUtil&&nodeUtil.isSet,nodeIsTypedArray=nodeUtil&&nodeUtil.isTypedArray;/*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */function apply(func,thisArg,args){switch(args.length){case 0:return func.call(thisArg);case 1:return func.call(thisArg,args[0]);case 2:return func.call(thisArg,args[0],args[1]);case 3:return func.call(thisArg,args[0],args[1],args[2]);}return func.apply(thisArg,args);}/**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */function arrayAggregator(array,setter,iteratee,accumulator){var index=-1,length=array==null?0:array.length;while(++index<length){var value=array[index];setter(accumulator,value,iteratee(value),array);}return accumulator;}/**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEach(array,iteratee){var index=-1,length=array==null?0:array.length;while(++index<length){if(iteratee(array[index],index,array)===false){break;}}return array;}/**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */function arrayEachRight(array,iteratee){var length=array==null?0:array.length;while(length--){if(iteratee(array[length],length,array)===false){break;}}return array;}/**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */function arrayEvery(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(!predicate(array[index],index,array)){return false;}}return true;}/**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */function arrayFilter(array,predicate){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(predicate(value,index,array)){result[resIndex++]=value;}}return result;}/**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludes(array,value){var length=array==null?0:array.length;return!!length&&baseIndexOf(array,value,0)>-1;}/**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */function arrayIncludesWith(array,value,comparator){var index=-1,length=array==null?0:array.length;while(++index<length){if(comparator(value,array[index])){return true;}}return false;}/**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */function arrayMap(array,iteratee){var index=-1,length=array==null?0:array.length,result=Array(length);while(++index<length){result[index]=iteratee(array[index],index,array);}return result;}/**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */function arrayPush(array,values){var index=-1,length=values.length,offset=array.length;while(++index<length){array[offset+index]=values[index];}return array;}/**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduce(array,iteratee,accumulator,initAccum){var index=-1,length=array==null?0:array.length;if(initAccum&&length){accumulator=array[++index];}while(++index<length){accumulator=iteratee(accumulator,array[index],index,array);}return accumulator;}/**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */function arrayReduceRight(array,iteratee,accumulator,initAccum){var length=array==null?0:array.length;if(initAccum&&length){accumulator=array[--length];}while(length--){accumulator=iteratee(accumulator,array[length],length,array);}return accumulator;}/**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */function arraySome(array,predicate){var index=-1,length=array==null?0:array.length;while(++index<length){if(predicate(array[index],index,array)){return true;}}return false;}/**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */var asciiSize=baseProperty('length');/**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function asciiToArray(string){return string.split('');}/**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function asciiWords(string){return string.match(reAsciiWord)||[];}/**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */function baseFindKey(collection,predicate,eachFunc){var result;eachFunc(collection,function(value,key,collection){if(predicate(value,key,collection)){result=key;return false;}});return result;}/**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseFindIndex(array,predicate,fromIndex,fromRight){var length=array.length,index=fromIndex+(fromRight?1:-1);while(fromRight?index--:++index<length){if(predicate(array[index],index,array)){return index;}}return-1;}/**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOf(array,value,fromIndex){return value===value?strictIndexOf(array,value,fromIndex):baseFindIndex(array,baseIsNaN,fromIndex);}/**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function baseIndexOfWith(array,value,fromIndex,comparator){var index=fromIndex-1,length=array.length;while(++index<length){if(comparator(array[index],value)){return index;}}return-1;}/**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */function baseIsNaN(value){return value!==value;}/**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */function baseMean(array,iteratee){var length=array==null?0:array.length;return length?baseSum(array,iteratee)/length:NAN;}/**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */function baseProperty(key){return function(object){return object==null?undefined:object[key];};}/**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */function basePropertyOf(object){return function(key){return object==null?undefined:object[key];};}/**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */function baseReduce(collection,iteratee,accumulator,initAccum,eachFunc){eachFunc(collection,function(value,index,collection){accumulator=initAccum?(initAccum=false,value):iteratee(accumulator,value,index,collection);});return accumulator;}/**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */function baseSortBy(array,comparer){var length=array.length;array.sort(comparer);while(length--){array[length]=array[length].value;}return array;}/**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */function baseSum(array,iteratee){var result,index=-1,length=array.length;while(++index<length){var current=iteratee(array[index]);if(current!==undefined){result=result===undefined?current:result+current;}}return result;}/**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */function baseTimes(n,iteratee){var index=-1,result=Array(n);while(++index<n){result[index]=iteratee(index);}return result;}/**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */function baseToPairs(object,props){return arrayMap(props,function(key){return[key,object[key]];});}/**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */function baseTrim(string){return string?string.slice(0,trimmedEndIndex(string)+1).replace(reTrimStart,''):string;}/**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */function baseUnary(func){return function(value){return func(value);};}/**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */function baseValues(object,props){return arrayMap(props,function(key){return object[key];});}/**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */function cacheHas(cache,key){return cache.has(key);}/**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */function charsStartIndex(strSymbols,chrSymbols){var index=-1,length=strSymbols.length;while(++index<length&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */function charsEndIndex(strSymbols,chrSymbols){var index=strSymbols.length;while(index--&&baseIndexOf(chrSymbols,strSymbols[index],0)>-1){}return index;}/**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */function countHolders(array,placeholder){var length=array.length,result=0;while(length--){if(array[length]===placeholder){++result;}}return result;}/**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */var deburrLetter=basePropertyOf(deburredLetters);/**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */var escapeHtmlChar=basePropertyOf(htmlEscapes);/**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */function escapeStringChar(chr){return'\\'+stringEscapes[chr];}/**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */function getValue(object,key){return object==null?undefined:object[key];}/**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */function hasUnicode(string){return reHasUnicode.test(string);}/**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */function hasUnicodeWord(string){return reHasUnicodeWord.test(string);}/**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */function iteratorToArray(iterator){var data,result=[];while(!(data=iterator.next()).done){result.push(data.value);}return result;}/**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */function mapToArray(map){var index=-1,result=Array(map.size);map.forEach(function(value,key){result[++index]=[key,value];});return result;}/**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */function overArg(func,transform){return function(arg){return func(transform(arg));};}/**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */function replaceHolders(array,placeholder){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value===placeholder||value===PLACEHOLDER){array[index]=PLACEHOLDER;result[resIndex++]=index;}}return result;}/**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */function setToArray(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=value;});return result;}/**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */function setToPairs(set){var index=-1,result=Array(set.size);set.forEach(function(value){result[++index]=[value,value];});return result;}/**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function strictIndexOf(array,value,fromIndex){var index=fromIndex-1,length=array.length;while(++index<length){if(array[index]===value){return index;}}return-1;}/**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */function strictLastIndexOf(array,value,fromIndex){var index=fromIndex+1;while(index--){if(array[index]===value){return index;}}return index;}/**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */function stringSize(string){return hasUnicode(string)?unicodeSize(string):asciiSize(string);}/**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function stringToArray(string){return hasUnicode(string)?unicodeToArray(string):asciiToArray(string);}/**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */function trimmedEndIndex(string){var index=string.length;while(index--&&reWhitespace.test(string.charAt(index))){}return index;}/**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */var unescapeHtmlChar=basePropertyOf(htmlUnescapes);/**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */function unicodeSize(string){var result=reUnicode.lastIndex=0;while(reUnicode.test(string)){++result;}return result;}/**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */function unicodeToArray(string){return string.match(reUnicode)||[];}/**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */function unicodeWords(string){return string.match(reUnicodeWord)||[];}/*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */var runInContext=function runInContext(context){context=context==null?root:_.defaults(root.Object(),context,_.pick(root,contextProps));/** Built-in constructor references. */var Array=context.Array,Date=context.Date,Error=context.Error,Function=context.Function,Math=context.Math,Object=context.Object,RegExp=context.RegExp,String=context.String,TypeError=context.TypeError;/** Used for built-in method references. */var arrayProto=Array.prototype,funcProto=Function.prototype,objectProto=Object.prototype;/** Used to detect overreaching core-js shims. */var coreJsData=context['__core-js_shared__'];/** Used to resolve the decompiled source of functions. */var funcToString=funcProto.toString;/** Used to check objects for own properties. */var hasOwnProperty=objectProto.hasOwnProperty;/** Used to generate unique IDs. */var idCounter=0;/** Used to detect methods masquerading as native. */var maskSrcKey=function(){var uid=/[^.]+$/.exec(coreJsData&&coreJsData.keys&&coreJsData.keys.IE_PROTO||'');return uid?'Symbol(src)_1.'+uid:'';}();/**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */var nativeObjectToString=objectProto.toString;/** Used to infer the `Object` constructor. */var objectCtorString=funcToString.call(Object);/** Used to restore the original `_` reference in `_.noConflict`. */var oldDash=root._;/** Used to detect if a method is native. */var reIsNative=RegExp('^'+funcToString.call(hasOwnProperty).replace(reRegExpChar,'\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,'$1.*?')+'$');/** Built-in value references. */var Buffer=moduleExports?context.Buffer:undefined,Symbol=context.Symbol,Uint8Array=context.Uint8Array,allocUnsafe=Buffer?Buffer.allocUnsafe:undefined,getPrototype=overArg(Object.getPrototypeOf,Object),objectCreate=Object.create,propertyIsEnumerable=objectProto.propertyIsEnumerable,splice=arrayProto.splice,spreadableSymbol=Symbol?Symbol.isConcatSpreadable:undefined,symIterator=Symbol?Symbol.iterator:undefined,symToStringTag=Symbol?Symbol.toStringTag:undefined;var defineProperty=function(){try{var func=getNative(Object,'defineProperty');func({},'',{});return func;}catch(e){}}();/** Mocked built-ins. */var ctxClearTimeout=context.clearTimeout!==root.clearTimeout&&context.clearTimeout,ctxNow=Date&&Date.now!==root.Date.now&&Date.now,ctxSetTimeout=context.setTimeout!==root.setTimeout&&context.setTimeout;/* Built-in method references for those with the same name as other `lodash` methods. */var nativeCeil=Math.ceil,nativeFloor=Math.floor,nativeGetSymbols=Object.getOwnPropertySymbols,nativeIsBuffer=Buffer?Buffer.isBuffer:undefined,nativeIsFinite=context.isFinite,nativeJoin=arrayProto.join,nativeKeys=overArg(Object.keys,Object),nativeMax=Math.max,nativeMin=Math.min,nativeNow=Date.now,nativeParseInt=context.parseInt,nativeRandom=Math.random,nativeReverse=arrayProto.reverse;/* Built-in method references that are verified to be native. */var DataView=getNative(context,'DataView'),Map=getNative(context,'Map'),Promise=getNative(context,'Promise'),Set=getNative(context,'Set'),WeakMap=getNative(context,'WeakMap'),nativeCreate=getNative(Object,'create');/** Used to store function metadata. */var metaMap=WeakMap&&new WeakMap();/** Used to lookup unminified function names. */var realNames={};/** Used to detect maps, sets, and weakmaps. */var dataViewCtorString=toSource(DataView),mapCtorString=toSource(Map),promiseCtorString=toSource(Promise),setCtorString=toSource(Set),weakMapCtorString=toSource(WeakMap);/** Used to convert symbols to primitives and strings. */var symbolProto=Symbol?Symbol.prototype:undefined,symbolValueOf=symbolProto?symbolProto.valueOf:undefined,symbolToString=symbolProto?symbolProto.toString:undefined;/*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */function lodash(value){if(isObjectLike(value)&&!isArray(value)&&!(value instanceof LazyWrapper)){if(value instanceof LodashWrapper){return value;}if(hasOwnProperty.call(value,'__wrapped__')){return wrapperClone(value);}}return new LodashWrapper(value);}/**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */var baseCreate=function(){function object(){}return function(proto){if(!isObject(proto)){return{};}if(objectCreate){return objectCreate(proto);}object.prototype=proto;var result=new object();object.prototype=undefined;return result;};}();/**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */function baseLodash(){// No operation performed.
}/**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */function LodashWrapper(value,chainAll){this.__wrapped__=value;this.__actions__=[];this.__chain__=!!chainAll;this.__index__=0;this.__values__=undefined;}/**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */lodash.templateSettings={/**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'escape':reEscape,/**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'evaluate':reEvaluate,/**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */'interpolate':reInterpolate,/**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */'variable':'',/**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */'imports':{/**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */'_':lodash}};// Ensure wrappers are instances of `baseLodash`.
lodash.prototype=baseLodash.prototype;lodash.prototype.constructor=lodash;LodashWrapper.prototype=baseCreate(baseLodash.prototype);LodashWrapper.prototype.constructor=LodashWrapper;/*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */function LazyWrapper(value){this.__wrapped__=value;this.__actions__=[];this.__dir__=1;this.__filtered__=false;this.__iteratees__=[];this.__takeCount__=MAX_ARRAY_LENGTH;this.__views__=[];}/**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */function lazyClone(){var result=new LazyWrapper(this.__wrapped__);result.__actions__=copyArray(this.__actions__);result.__dir__=this.__dir__;result.__filtered__=this.__filtered__;result.__iteratees__=copyArray(this.__iteratees__);result.__takeCount__=this.__takeCount__;result.__views__=copyArray(this.__views__);return result;}/**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */function lazyReverse(){if(this.__filtered__){var result=new LazyWrapper(this);result.__dir__=-1;result.__filtered__=true;}else{result=this.clone();result.__dir__*=-1;}return result;}/**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */function lazyValue(){var array=this.__wrapped__.value(),dir=this.__dir__,isArr=isArray(array),isRight=dir<0,arrLength=isArr?array.length:0,view=getView(0,arrLength,this.__views__),start=view.start,end=view.end,length=end-start,index=isRight?end:start-1,iteratees=this.__iteratees__,iterLength=iteratees.length,resIndex=0,takeCount=nativeMin(length,this.__takeCount__);if(!isArr||!isRight&&arrLength==length&&takeCount==length){return baseWrapperValue(array,this.__actions__);}var result=[];outer:while(length--&&resIndex<takeCount){index+=dir;var iterIndex=-1,value=array[index];while(++iterIndex<iterLength){var data=iteratees[iterIndex],iteratee=data.iteratee,type=data.type,computed=iteratee(value);if(type==LAZY_MAP_FLAG){value=computed;}else if(!computed){if(type==LAZY_FILTER_FLAG){continue outer;}else{break outer;}}}result[resIndex++]=value;}return result;}// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype=baseCreate(baseLodash.prototype);LazyWrapper.prototype.constructor=LazyWrapper;/*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Hash(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */function hashClear(){this.__data__=nativeCreate?nativeCreate(null):{};this.size=0;}/**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function hashDelete(key){var result=this.has(key)&&delete this.__data__[key];this.size-=result?1:0;return result;}/**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function hashGet(key){var data=this.__data__;if(nativeCreate){var result=data[key];return result===HASH_UNDEFINED?undefined:result;}return hasOwnProperty.call(data,key)?data[key]:undefined;}/**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function hashHas(key){var data=this.__data__;return nativeCreate?data[key]!==undefined:hasOwnProperty.call(data,key);}/**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */function hashSet(key,value){var data=this.__data__;this.size+=this.has(key)?0:1;data[key]=nativeCreate&&value===undefined?HASH_UNDEFINED:value;return this;}// Add methods to `Hash`.
Hash.prototype.clear=hashClear;Hash.prototype['delete']=hashDelete;Hash.prototype.get=hashGet;Hash.prototype.has=hashHas;Hash.prototype.set=hashSet;/*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function ListCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */function listCacheClear(){this.__data__=[];this.size=0;}/**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function listCacheDelete(key){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){return false;}var lastIndex=data.length-1;if(index==lastIndex){data.pop();}else{splice.call(data,index,1);}--this.size;return true;}/**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function listCacheGet(key){var data=this.__data__,index=assocIndexOf(data,key);return index<0?undefined:data[index][1];}/**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function listCacheHas(key){return assocIndexOf(this.__data__,key)>-1;}/**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */function listCacheSet(key,value){var data=this.__data__,index=assocIndexOf(data,key);if(index<0){++this.size;data.push([key,value]);}else{data[index][1]=value;}return this;}// Add methods to `ListCache`.
ListCache.prototype.clear=listCacheClear;ListCache.prototype['delete']=listCacheDelete;ListCache.prototype.get=listCacheGet;ListCache.prototype.has=listCacheHas;ListCache.prototype.set=listCacheSet;/*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function MapCache(entries){var index=-1,length=entries==null?0:entries.length;this.clear();while(++index<length){var entry=entries[index];this.set(entry[0],entry[1]);}}/**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */function mapCacheClear(){this.size=0;this.__data__={'hash':new Hash(),'map':new(Map||ListCache)(),'string':new Hash()};}/**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function mapCacheDelete(key){var result=getMapData(this,key)['delete'](key);this.size-=result?1:0;return result;}/**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function mapCacheGet(key){return getMapData(this,key).get(key);}/**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function mapCacheHas(key){return getMapData(this,key).has(key);}/**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */function mapCacheSet(key,value){var data=getMapData(this,key),size=data.size;data.set(key,value);this.size+=data.size==size?0:1;return this;}// Add methods to `MapCache`.
MapCache.prototype.clear=mapCacheClear;MapCache.prototype['delete']=mapCacheDelete;MapCache.prototype.get=mapCacheGet;MapCache.prototype.has=mapCacheHas;MapCache.prototype.set=mapCacheSet;/*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */function SetCache(values){var index=-1,length=values==null?0:values.length;this.__data__=new MapCache();while(++index<length){this.add(values[index]);}}/**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */function setCacheAdd(value){this.__data__.set(value,HASH_UNDEFINED);return this;}/**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */function setCacheHas(value){return this.__data__.has(value);}// Add methods to `SetCache`.
SetCache.prototype.add=SetCache.prototype.push=setCacheAdd;SetCache.prototype.has=setCacheHas;/*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */function Stack(entries){var data=this.__data__=new ListCache(entries);this.size=data.size;}/**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */function stackClear(){this.__data__=new ListCache();this.size=0;}/**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */function stackDelete(key){var data=this.__data__,result=data['delete'](key);this.size=data.size;return result;}/**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */function stackGet(key){return this.__data__.get(key);}/**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */function stackHas(key){return this.__data__.has(key);}/**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */function stackSet(key,value){var data=this.__data__;if(data instanceof ListCache){var pairs=data.__data__;if(!Map||pairs.length<LARGE_ARRAY_SIZE-1){pairs.push([key,value]);this.size=++data.size;return this;}data=this.__data__=new MapCache(pairs);}data.set(key,value);this.size=data.size;return this;}// Add methods to `Stack`.
Stack.prototype.clear=stackClear;Stack.prototype['delete']=stackDelete;Stack.prototype.get=stackGet;Stack.prototype.has=stackHas;Stack.prototype.set=stackSet;/*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */function arrayLikeKeys(value,inherited){var isArr=isArray(value),isArg=!isArr&&isArguments(value),isBuff=!isArr&&!isArg&&isBuffer(value),isType=!isArr&&!isArg&&!isBuff&&isTypedArray(value),skipIndexes=isArr||isArg||isBuff||isType,result=skipIndexes?baseTimes(value.length,String):[],length=result.length;for(var key in value){if((inherited||hasOwnProperty.call(value,key))&&!(skipIndexes&&(// Safari 9 has enumerable `arguments.length` in strict mode.
key=='length'||// Node.js 0.10 has enumerable non-index properties on buffers.
isBuff&&(key=='offset'||key=='parent')||// PhantomJS 2 has enumerable non-index properties on typed arrays.
isType&&(key=='buffer'||key=='byteLength'||key=='byteOffset')||// Skip index properties.
isIndex(key,length)))){result.push(key);}}return result;}/**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */function arraySample(array){var length=array.length;return length?array[baseRandom(0,length-1)]:undefined;}/**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */function arraySampleSize(array,n){return shuffleSelf(copyArray(array),baseClamp(n,0,array.length));}/**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */function arrayShuffle(array){return shuffleSelf(copyArray(array));}/**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignMergeValue(object,key,value){if(value!==undefined&&!eq(object[key],value)||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function assignValue(object,key,value){var objValue=object[key];if(!(hasOwnProperty.call(object,key)&&eq(objValue,value))||value===undefined&&!(key in object)){baseAssignValue(object,key,value);}}/**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */function assocIndexOf(array,key){var length=array.length;while(length--){if(eq(array[length][0],key)){return length;}}return-1;}/**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */function baseAggregator(collection,setter,iteratee,accumulator){baseEach(collection,function(value,key,collection){setter(accumulator,value,iteratee(value),collection);});return accumulator;}/**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssign(object,source){return object&&copyObject(source,keys(source),object);}/**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */function baseAssignIn(object,source){return object&&copyObject(source,keysIn(source),object);}/**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */function baseAssignValue(object,key,value){if(key=='__proto__'&&defineProperty){defineProperty(object,key,{'configurable':true,'enumerable':true,'value':value,'writable':true});}else{object[key]=value;}}/**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */function baseAt(object,paths){var index=-1,length=paths.length,result=Array(length),skip=object==null;while(++index<length){result[index]=skip?undefined:get(object,paths[index]);}return result;}/**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */function baseClamp(number,lower,upper){if(number===number){if(upper!==undefined){number=number<=upper?number:upper;}if(lower!==undefined){number=number>=lower?number:lower;}}return number;}/**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */function baseClone(value,bitmask,customizer,key,object,stack){var result,isDeep=bitmask&CLONE_DEEP_FLAG,isFlat=bitmask&CLONE_FLAT_FLAG,isFull=bitmask&CLONE_SYMBOLS_FLAG;if(customizer){result=object?customizer(value,key,object,stack):customizer(value);}if(result!==undefined){return result;}if(!isObject(value)){return value;}var isArr=isArray(value);if(isArr){result=initCloneArray(value);if(!isDeep){return copyArray(value,result);}}else{var tag=getTag(value),isFunc=tag==funcTag||tag==genTag;if(isBuffer(value)){return cloneBuffer(value,isDeep);}if(tag==objectTag||tag==argsTag||isFunc&&!object){result=isFlat||isFunc?{}:initCloneObject(value);if(!isDeep){return isFlat?copySymbolsIn(value,baseAssignIn(result,value)):copySymbols(value,baseAssign(result,value));}}else{if(!cloneableTags[tag]){return object?value:{};}result=initCloneByTag(value,tag,isDeep);}}// Check for circular references and return its corresponding clone.
stack||(stack=new Stack());var stacked=stack.get(value);if(stacked){return stacked;}stack.set(value,result);if(isSet(value)){value.forEach(function(subValue){result.add(baseClone(subValue,bitmask,customizer,subValue,value,stack));});}else if(isMap(value)){value.forEach(function(subValue,key){result.set(key,baseClone(subValue,bitmask,customizer,key,value,stack));});}var keysFunc=isFull?isFlat?getAllKeysIn:getAllKeys:isFlat?keysIn:keys;var props=isArr?undefined:keysFunc(value);arrayEach(props||value,function(subValue,key){if(props){key=subValue;subValue=value[key];}// Recursively populate clone (susceptible to call stack limits).
assignValue(result,key,baseClone(subValue,bitmask,customizer,key,value,stack));});return result;}/**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */function baseConforms(source){var props=keys(source);return function(object){return baseConformsTo(object,source,props);};}/**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */function baseConformsTo(object,source,props){var length=props.length;if(object==null){return!length;}object=Object(object);while(length--){var key=props[length],predicate=source[key],value=object[key];if(value===undefined&&!(key in object)||!predicate(value)){return false;}}return true;}/**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */function baseDelay(func,wait,args){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return setTimeout(function(){func.apply(undefined,args);},wait);}/**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */function baseDifference(array,values,iteratee,comparator){var index=-1,includes=arrayIncludes,isCommon=true,length=array.length,result=[],valuesLength=values.length;if(!length){return result;}if(iteratee){values=arrayMap(values,baseUnary(iteratee));}if(comparator){includes=arrayIncludesWith;isCommon=false;}else if(values.length>=LARGE_ARRAY_SIZE){includes=cacheHas;isCommon=false;values=new SetCache(values);}outer:while(++index<length){var value=array[index],computed=iteratee==null?value:iteratee(value);value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var valuesIndex=valuesLength;while(valuesIndex--){if(values[valuesIndex]===computed){continue outer;}}result.push(value);}else if(!includes(values,computed,comparator)){result.push(value);}}return result;}/**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEach=createBaseEach(baseForOwn);/**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */var baseEachRight=createBaseEach(baseForOwnRight,true);/**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */function baseEvery(collection,predicate){var result=true;baseEach(collection,function(value,index,collection){result=!!predicate(value,index,collection);return result;});return result;}/**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */function baseExtremum(array,iteratee,comparator){var index=-1,length=array.length;while(++index<length){var value=array[index],current=iteratee(value);if(current!=null&&(computed===undefined?current===current&&!isSymbol(current):comparator(current,computed))){var computed=current,result=value;}}return result;}/**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */function baseFill(array,value,start,end){var length=array.length;start=toInteger(start);if(start<0){start=-start>length?0:length+start;}end=end===undefined||end>length?length:toInteger(end);if(end<0){end+=length;}end=start>end?0:toLength(end);while(start<end){array[start++]=value;}return array;}/**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */function baseFilter(collection,predicate){var result=[];baseEach(collection,function(value,index,collection){if(predicate(value,index,collection)){result.push(value);}});return result;}/**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */function baseFlatten(array,depth,predicate,isStrict,result){var index=-1,length=array.length;predicate||(predicate=isFlattenable);result||(result=[]);while(++index<length){var value=array[index];if(depth>0&&predicate(value)){if(depth>1){// Recursively flatten arrays (susceptible to call stack limits).
baseFlatten(value,depth-1,predicate,isStrict,result);}else{arrayPush(result,value);}}else if(!isStrict){result[result.length]=value;}}return result;}/**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseFor=createBaseFor();/**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */var baseForRight=createBaseFor(true);/**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwn(object,iteratee){return object&&baseFor(object,iteratee,keys);}/**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */function baseForOwnRight(object,iteratee){return object&&baseForRight(object,iteratee,keys);}/**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */function baseFunctions(object,props){return arrayFilter(props,function(key){return isFunction(object[key]);});}/**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */function baseGet(object,path){path=castPath(path,object);var index=0,length=path.length;while(object!=null&&index<length){object=object[toKey(path[index++])];}return index&&index==length?object:undefined;}/**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */function baseGetAllKeys(object,keysFunc,symbolsFunc){var result=keysFunc(object);return isArray(object)?result:arrayPush(result,symbolsFunc(object));}/**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */function baseGetTag(value){if(value==null){return value===undefined?undefinedTag:nullTag;}return symToStringTag&&symToStringTag in Object(value)?getRawTag(value):objectToString(value);}/**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */function baseGt(value,other){return value>other;}/**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHas(object,key){return object!=null&&hasOwnProperty.call(object,key);}/**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */function baseHasIn(object,key){return object!=null&&key in Object(object);}/**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */function baseInRange(number,start,end){return number>=nativeMin(start,end)&&number<nativeMax(start,end);}/**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */function baseIntersection(arrays,iteratee,comparator){var includes=comparator?arrayIncludesWith:arrayIncludes,length=arrays[0].length,othLength=arrays.length,othIndex=othLength,caches=Array(othLength),maxLength=Infinity,result=[];while(othIndex--){var array=arrays[othIndex];if(othIndex&&iteratee){array=arrayMap(array,baseUnary(iteratee));}maxLength=nativeMin(array.length,maxLength);caches[othIndex]=!comparator&&(iteratee||length>=120&&array.length>=120)?new SetCache(othIndex&&array):undefined;}array=arrays[0];var index=-1,seen=caches[0];outer:while(++index<length&&result.length<maxLength){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(!(seen?cacheHas(seen,computed):includes(result,computed,comparator))){othIndex=othLength;while(--othIndex){var cache=caches[othIndex];if(!(cache?cacheHas(cache,computed):includes(arrays[othIndex],computed,comparator))){continue outer;}}if(seen){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */function baseInverter(object,setter,iteratee,accumulator){baseForOwn(object,function(value,key,object){setter(accumulator,iteratee(value),key,object);});return accumulator;}/**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */function baseInvoke(object,path,args){path=castPath(path,object);object=parent(object,path);var func=object==null?object:object[toKey(last(path))];return func==null?undefined:apply(func,object,args);}/**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */function baseIsArguments(value){return isObjectLike(value)&&baseGetTag(value)==argsTag;}/**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */function baseIsArrayBuffer(value){return isObjectLike(value)&&baseGetTag(value)==arrayBufferTag;}/**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */function baseIsDate(value){return isObjectLike(value)&&baseGetTag(value)==dateTag;}/**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */function baseIsEqual(value,other,bitmask,customizer,stack){if(value===other){return true;}if(value==null||other==null||!isObjectLike(value)&&!isObjectLike(other)){return value!==value&&other!==other;}return baseIsEqualDeep(value,other,bitmask,customizer,baseIsEqual,stack);}/**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function baseIsEqualDeep(object,other,bitmask,customizer,equalFunc,stack){var objIsArr=isArray(object),othIsArr=isArray(other),objTag=objIsArr?arrayTag:getTag(object),othTag=othIsArr?arrayTag:getTag(other);objTag=objTag==argsTag?objectTag:objTag;othTag=othTag==argsTag?objectTag:othTag;var objIsObj=objTag==objectTag,othIsObj=othTag==objectTag,isSameTag=objTag==othTag;if(isSameTag&&isBuffer(object)){if(!isBuffer(other)){return false;}objIsArr=true;objIsObj=false;}if(isSameTag&&!objIsObj){stack||(stack=new Stack());return objIsArr||isTypedArray(object)?equalArrays(object,other,bitmask,customizer,equalFunc,stack):equalByTag(object,other,objTag,bitmask,customizer,equalFunc,stack);}if(!(bitmask&COMPARE_PARTIAL_FLAG)){var objIsWrapped=objIsObj&&hasOwnProperty.call(object,'__wrapped__'),othIsWrapped=othIsObj&&hasOwnProperty.call(other,'__wrapped__');if(objIsWrapped||othIsWrapped){var objUnwrapped=objIsWrapped?object.value():object,othUnwrapped=othIsWrapped?other.value():other;stack||(stack=new Stack());return equalFunc(objUnwrapped,othUnwrapped,bitmask,customizer,stack);}}if(!isSameTag){return false;}stack||(stack=new Stack());return equalObjects(object,other,bitmask,customizer,equalFunc,stack);}/**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */function baseIsMap(value){return isObjectLike(value)&&getTag(value)==mapTag;}/**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */function baseIsMatch(object,source,matchData,customizer){var index=matchData.length,length=index,noCustomizer=!customizer;if(object==null){return!length;}object=Object(object);while(index--){var data=matchData[index];if(noCustomizer&&data[2]?data[1]!==object[data[0]]:!(data[0]in object)){return false;}}while(++index<length){data=matchData[index];var key=data[0],objValue=object[key],srcValue=data[1];if(noCustomizer&&data[2]){if(objValue===undefined&&!(key in object)){return false;}}else{var stack=new Stack();if(customizer){var result=customizer(objValue,srcValue,key,object,source,stack);}if(!(result===undefined?baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG,customizer,stack):result)){return false;}}}return true;}/**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */function baseIsNative(value){if(!isObject(value)||isMasked(value)){return false;}var pattern=isFunction(value)?reIsNative:reIsHostCtor;return pattern.test(toSource(value));}/**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */function baseIsRegExp(value){return isObjectLike(value)&&baseGetTag(value)==regexpTag;}/**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */function baseIsSet(value){return isObjectLike(value)&&getTag(value)==setTag;}/**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */function baseIsTypedArray(value){return isObjectLike(value)&&isLength(value.length)&&!!typedArrayTags[baseGetTag(value)];}/**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */function baseIteratee(value){// Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
// See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
if(typeof value=='function'){return value;}if(value==null){return identity;}if(typeof value=='object'){return isArray(value)?baseMatchesProperty(value[0],value[1]):baseMatches(value);}return property(value);}/**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeys(object){if(!isPrototype(object)){return nativeKeys(object);}var result=[];for(var key in Object(object)){if(hasOwnProperty.call(object,key)&&key!='constructor'){result.push(key);}}return result;}/**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function baseKeysIn(object){if(!isObject(object)){return nativeKeysIn(object);}var isProto=isPrototype(object),result=[];for(var key in object){if(!(key=='constructor'&&(isProto||!hasOwnProperty.call(object,key)))){result.push(key);}}return result;}/**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */function baseLt(value,other){return value<other;}/**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */function baseMap(collection,iteratee){var index=-1,result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value,key,collection){result[++index]=iteratee(value,key,collection);});return result;}/**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatches(source){var matchData=getMatchData(source);if(matchData.length==1&&matchData[0][2]){return matchesStrictComparable(matchData[0][0],matchData[0][1]);}return function(object){return object===source||baseIsMatch(object,source,matchData);};}/**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function baseMatchesProperty(path,srcValue){if(isKey(path)&&isStrictComparable(srcValue)){return matchesStrictComparable(toKey(path),srcValue);}return function(object){var objValue=get(object,path);return objValue===undefined&&objValue===srcValue?hasIn(object,path):baseIsEqual(srcValue,objValue,COMPARE_PARTIAL_FLAG|COMPARE_UNORDERED_FLAG);};}/**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMerge(object,source,srcIndex,customizer,stack){if(object===source){return;}baseFor(source,function(srcValue,key){stack||(stack=new Stack());if(isObject(srcValue)){baseMergeDeep(object,source,key,srcIndex,baseMerge,customizer,stack);}else{var newValue=customizer?customizer(safeGet(object,key),srcValue,key+'',object,source,stack):undefined;if(newValue===undefined){newValue=srcValue;}assignMergeValue(object,key,newValue);}},keysIn);}/**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */function baseMergeDeep(object,source,key,srcIndex,mergeFunc,customizer,stack){var objValue=safeGet(object,key),srcValue=safeGet(source,key),stacked=stack.get(srcValue);if(stacked){assignMergeValue(object,key,stacked);return;}var newValue=customizer?customizer(objValue,srcValue,key+'',object,source,stack):undefined;var isCommon=newValue===undefined;if(isCommon){var isArr=isArray(srcValue),isBuff=!isArr&&isBuffer(srcValue),isTyped=!isArr&&!isBuff&&isTypedArray(srcValue);newValue=srcValue;if(isArr||isBuff||isTyped){if(isArray(objValue)){newValue=objValue;}else if(isArrayLikeObject(objValue)){newValue=copyArray(objValue);}else if(isBuff){isCommon=false;newValue=cloneBuffer(srcValue,true);}else if(isTyped){isCommon=false;newValue=cloneTypedArray(srcValue,true);}else{newValue=[];}}else if(isPlainObject(srcValue)||isArguments(srcValue)){newValue=objValue;if(isArguments(objValue)){newValue=toPlainObject(objValue);}else if(!isObject(objValue)||isFunction(objValue)){newValue=initCloneObject(srcValue);}}else{isCommon=false;}}if(isCommon){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,newValue);mergeFunc(newValue,srcValue,srcIndex,customizer,stack);stack['delete'](srcValue);}assignMergeValue(object,key,newValue);}/**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */function baseNth(array,n){var length=array.length;if(!length){return;}n+=n<0?length:0;return isIndex(n,length)?array[n]:undefined;}/**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */function baseOrderBy(collection,iteratees,orders){if(iteratees.length){iteratees=arrayMap(iteratees,function(iteratee){if(isArray(iteratee)){return function(value){return baseGet(value,iteratee.length===1?iteratee[0]:iteratee);};}return iteratee;});}else{iteratees=[identity];}var index=-1;iteratees=arrayMap(iteratees,baseUnary(getIteratee()));var result=baseMap(collection,function(value,key,collection){var criteria=arrayMap(iteratees,function(iteratee){return iteratee(value);});return{'criteria':criteria,'index':++index,'value':value};});return baseSortBy(result,function(object,other){return compareMultiple(object,other,orders);});}/**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */function basePick(object,paths){return basePickBy(object,paths,function(value,path){return hasIn(object,path);});}/**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */function basePickBy(object,paths,predicate){var index=-1,length=paths.length,result={};while(++index<length){var path=paths[index],value=baseGet(object,path);if(predicate(value,path)){baseSet(result,castPath(path,object),value);}}return result;}/**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */function basePropertyDeep(path){return function(object){return baseGet(object,path);};}/**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */function basePullAll(array,values,iteratee,comparator){var indexOf=comparator?baseIndexOfWith:baseIndexOf,index=-1,length=values.length,seen=array;if(array===values){values=copyArray(values);}if(iteratee){seen=arrayMap(array,baseUnary(iteratee));}while(++index<length){var fromIndex=0,value=values[index],computed=iteratee?iteratee(value):value;while((fromIndex=indexOf(seen,computed,fromIndex,comparator))>-1){if(seen!==array){splice.call(seen,fromIndex,1);}splice.call(array,fromIndex,1);}}return array;}/**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */function basePullAt(array,indexes){var length=array?indexes.length:0,lastIndex=length-1;while(length--){var index=indexes[length];if(length==lastIndex||index!==previous){var previous=index;if(isIndex(index)){splice.call(array,index,1);}else{baseUnset(array,index);}}}return array;}/**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */function baseRandom(lower,upper){return lower+nativeFloor(nativeRandom()*(upper-lower+1));}/**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */function baseRange(start,end,step,fromRight){var index=-1,length=nativeMax(nativeCeil((end-start)/(step||1)),0),result=Array(length);while(length--){result[fromRight?length:++index]=start;start+=step;}return result;}/**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */function baseRepeat(string,n){var result='';if(!string||n<1||n>MAX_SAFE_INTEGER){return result;}// Leverage the exponentiation by squaring algorithm for a faster repeat.
// See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
do{if(n%2){result+=string;}n=nativeFloor(n/2);if(n){string+=string;}}while(n);return result;}/**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */function baseRest(func,start){return setToString(overRest(func,start,identity),func+'');}/**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */function baseSample(collection){return arraySample(values(collection));}/**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */function baseSampleSize(collection,n){var array=values(collection);return shuffleSelf(array,baseClamp(n,0,array.length));}/**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseSet(object,path,value,customizer){if(!isObject(object)){return object;}path=castPath(path,object);var index=-1,length=path.length,lastIndex=length-1,nested=object;while(nested!=null&&++index<length){var key=toKey(path[index]),newValue=value;if(key==='__proto__'||key==='constructor'||key==='prototype'){return object;}if(index!=lastIndex){var objValue=nested[key];newValue=customizer?customizer(objValue,key,nested):undefined;if(newValue===undefined){newValue=isObject(objValue)?objValue:isIndex(path[index+1])?[]:{};}}assignValue(nested,key,newValue);nested=nested[key];}return object;}/**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var baseSetData=!metaMap?identity:function(func,data){metaMap.set(func,data);return func;};/**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */var baseSetToString=!defineProperty?identity:function(func,string){return defineProperty(func,'toString',{'configurable':true,'enumerable':false,'value':constant(string),'writable':true});};/**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */function baseShuffle(collection){return shuffleSelf(values(collection));}/**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function baseSlice(array,start,end){var index=-1,length=array.length;if(start<0){start=-start>length?0:length+start;}end=end>length?length:end;if(end<0){end+=length;}length=start>end?0:end-start>>>0;start>>>=0;var result=Array(length);while(++index<length){result[index]=array[index+start];}return result;}/**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */function baseSome(collection,predicate){var result;baseEach(collection,function(value,index,collection){result=predicate(value,index,collection);return!result;});return!!result;}/**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndex(array,value,retHighest){var low=0,high=array==null?low:array.length;if(typeof value=='number'&&value===value&&high<=HALF_MAX_ARRAY_LENGTH){while(low<high){var mid=low+high>>>1,computed=array[mid];if(computed!==null&&!isSymbol(computed)&&(retHighest?computed<=value:computed<value)){low=mid+1;}else{high=mid;}}return high;}return baseSortedIndexBy(array,value,identity,retHighest);}/**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */function baseSortedIndexBy(array,value,iteratee,retHighest){var low=0,high=array==null?0:array.length;if(high===0){return 0;}value=iteratee(value);var valIsNaN=value!==value,valIsNull=value===null,valIsSymbol=isSymbol(value),valIsUndefined=value===undefined;while(low<high){var mid=nativeFloor((low+high)/2),computed=iteratee(array[mid]),othIsDefined=computed!==undefined,othIsNull=computed===null,othIsReflexive=computed===computed,othIsSymbol=isSymbol(computed);if(valIsNaN){var setLow=retHighest||othIsReflexive;}else if(valIsUndefined){setLow=othIsReflexive&&(retHighest||othIsDefined);}else if(valIsNull){setLow=othIsReflexive&&othIsDefined&&(retHighest||!othIsNull);}else if(valIsSymbol){setLow=othIsReflexive&&othIsDefined&&!othIsNull&&(retHighest||!othIsSymbol);}else if(othIsNull||othIsSymbol){setLow=false;}else{setLow=retHighest?computed<=value:computed<value;}if(setLow){low=mid+1;}else{high=mid;}}return nativeMin(high,MAX_ARRAY_INDEX);}/**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseSortedUniq(array,iteratee){var index=-1,length=array.length,resIndex=0,result=[];while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;if(!index||!eq(computed,seen)){var seen=computed;result[resIndex++]=value===0?0:value;}}return result;}/**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */function baseToNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}return+value;}/**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */function baseToString(value){// Exit early for strings to avoid a performance hit in some environments.
if(typeof value=='string'){return value;}if(isArray(value)){// Recursively convert values (susceptible to call stack limits).
return arrayMap(value,baseToString)+'';}if(isSymbol(value)){return symbolToString?symbolToString.call(value):'';}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */function baseUniq(array,iteratee,comparator){var index=-1,includes=arrayIncludes,length=array.length,isCommon=true,result=[],seen=result;if(comparator){isCommon=false;includes=arrayIncludesWith;}else if(length>=LARGE_ARRAY_SIZE){var set=iteratee?null:createSet(array);if(set){return setToArray(set);}isCommon=false;includes=cacheHas;seen=new SetCache();}else{seen=iteratee?[]:result;}outer:while(++index<length){var value=array[index],computed=iteratee?iteratee(value):value;value=comparator||value!==0?value:0;if(isCommon&&computed===computed){var seenIndex=seen.length;while(seenIndex--){if(seen[seenIndex]===computed){continue outer;}}if(iteratee){seen.push(computed);}result.push(value);}else if(!includes(seen,computed,comparator)){if(seen!==result){seen.push(computed);}result.push(value);}}return result;}/**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */function baseUnset(object,path){path=castPath(path,object);object=parent(object,path);return object==null||delete object[toKey(last(path))];}/**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */function baseUpdate(object,path,updater,customizer){return baseSet(object,path,updater(baseGet(object,path)),customizer);}/**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */function baseWhile(array,predicate,isDrop,fromRight){var length=array.length,index=fromRight?length:-1;while((fromRight?index--:++index<length)&&predicate(array[index],index,array)){}return isDrop?baseSlice(array,fromRight?0:index,fromRight?index+1:length):baseSlice(array,fromRight?index+1:0,fromRight?length:index);}/**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */function baseWrapperValue(value,actions){var result=value;if(result instanceof LazyWrapper){result=result.value();}return arrayReduce(actions,function(result,action){return action.func.apply(action.thisArg,arrayPush([result],action.args));},result);}/**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */function baseXor(arrays,iteratee,comparator){var length=arrays.length;if(length<2){return length?baseUniq(arrays[0]):[];}var index=-1,result=Array(length);while(++index<length){var array=arrays[index],othIndex=-1;while(++othIndex<length){if(othIndex!=index){result[index]=baseDifference(result[index]||array,arrays[othIndex],iteratee,comparator);}}}return baseUniq(baseFlatten(result,1),iteratee,comparator);}/**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */function baseZipObject(props,values,assignFunc){var index=-1,length=props.length,valsLength=values.length,result={};while(++index<length){var value=index<valsLength?values[index]:undefined;assignFunc(result,props[index],value);}return result;}/**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */function castArrayLikeObject(value){return isArrayLikeObject(value)?value:[];}/**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */function castFunction(value){return typeof value=='function'?value:identity;}/**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */function castPath(value,object){if(isArray(value)){return value;}return isKey(value,object)?[value]:stringToPath(toString(value));}/**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */var castRest=baseRest;/**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */function castSlice(array,start,end){var length=array.length;end=end===undefined?length:end;return!start&&end>=length?array:baseSlice(array,start,end);}/**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */var clearTimeout=ctxClearTimeout||function(id){return root.clearTimeout(id);};/**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */function cloneBuffer(buffer,isDeep){if(isDeep){return buffer.slice();}var length=buffer.length,result=allocUnsafe?allocUnsafe(length):new buffer.constructor(length);buffer.copy(result);return result;}/**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */function cloneArrayBuffer(arrayBuffer){var result=new arrayBuffer.constructor(arrayBuffer.byteLength);new Uint8Array(result).set(new Uint8Array(arrayBuffer));return result;}/**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */function cloneDataView(dataView,isDeep){var buffer=isDeep?cloneArrayBuffer(dataView.buffer):dataView.buffer;return new dataView.constructor(buffer,dataView.byteOffset,dataView.byteLength);}/**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */function cloneRegExp(regexp){var result=new regexp.constructor(regexp.source,reFlags.exec(regexp));result.lastIndex=regexp.lastIndex;return result;}/**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */function cloneSymbol(symbol){return symbolValueOf?Object(symbolValueOf.call(symbol)):{};}/**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */function cloneTypedArray(typedArray,isDeep){var buffer=isDeep?cloneArrayBuffer(typedArray.buffer):typedArray.buffer;return new typedArray.constructor(buffer,typedArray.byteOffset,typedArray.length);}/**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */function compareAscending(value,other){if(value!==other){var valIsDefined=value!==undefined,valIsNull=value===null,valIsReflexive=value===value,valIsSymbol=isSymbol(value);var othIsDefined=other!==undefined,othIsNull=other===null,othIsReflexive=other===other,othIsSymbol=isSymbol(other);if(!othIsNull&&!othIsSymbol&&!valIsSymbol&&value>other||valIsSymbol&&othIsDefined&&othIsReflexive&&!othIsNull&&!othIsSymbol||valIsNull&&othIsDefined&&othIsReflexive||!valIsDefined&&othIsReflexive||!valIsReflexive){return 1;}if(!valIsNull&&!valIsSymbol&&!othIsSymbol&&value<other||othIsSymbol&&valIsDefined&&valIsReflexive&&!valIsNull&&!valIsSymbol||othIsNull&&valIsDefined&&valIsReflexive||!othIsDefined&&valIsReflexive||!othIsReflexive){return-1;}}return 0;}/**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */function compareMultiple(object,other,orders){var index=-1,objCriteria=object.criteria,othCriteria=other.criteria,length=objCriteria.length,ordersLength=orders.length;while(++index<length){var result=compareAscending(objCriteria[index],othCriteria[index]);if(result){if(index>=ordersLength){return result;}var order=orders[index];return result*(order=='desc'?-1:1);}}// Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
// that causes it, under certain circumstances, to provide the same value for
// `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
// for more details.
//
// This also ensures a stable sort in V8 and other engines.
// See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
return object.index-other.index;}/**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgs(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersLength=holders.length,leftIndex=-1,leftLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(leftLength+rangeLength),isUncurried=!isCurried;while(++leftIndex<leftLength){result[leftIndex]=partials[leftIndex];}while(++argsIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[holders[argsIndex]]=args[argsIndex];}}while(rangeLength--){result[leftIndex++]=args[argsIndex++];}return result;}/**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */function composeArgsRight(args,partials,holders,isCurried){var argsIndex=-1,argsLength=args.length,holdersIndex=-1,holdersLength=holders.length,rightIndex=-1,rightLength=partials.length,rangeLength=nativeMax(argsLength-holdersLength,0),result=Array(rangeLength+rightLength),isUncurried=!isCurried;while(++argsIndex<rangeLength){result[argsIndex]=args[argsIndex];}var offset=argsIndex;while(++rightIndex<rightLength){result[offset+rightIndex]=partials[rightIndex];}while(++holdersIndex<holdersLength){if(isUncurried||argsIndex<argsLength){result[offset+holders[holdersIndex]]=args[argsIndex++];}}return result;}/**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */function copyArray(source,array){var index=-1,length=source.length;array||(array=Array(length));while(++index<length){array[index]=source[index];}return array;}/**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */function copyObject(source,props,object,customizer){var isNew=!object;object||(object={});var index=-1,length=props.length;while(++index<length){var key=props[index];var newValue=customizer?customizer(object[key],source[key],key,object,source):undefined;if(newValue===undefined){newValue=source[key];}if(isNew){baseAssignValue(object,key,newValue);}else{assignValue(object,key,newValue);}}return object;}/**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbols(source,object){return copyObject(source,getSymbols(source),object);}/**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */function copySymbolsIn(source,object){return copyObject(source,getSymbolsIn(source),object);}/**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */function createAggregator(setter,initializer){return function(collection,iteratee){var func=isArray(collection)?arrayAggregator:baseAggregator,accumulator=initializer?initializer():{};return func(collection,setter,getIteratee(iteratee,2),accumulator);};}/**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */function createAssigner(assigner){return baseRest(function(object,sources){var index=-1,length=sources.length,customizer=length>1?sources[length-1]:undefined,guard=length>2?sources[2]:undefined;customizer=assigner.length>3&&typeof customizer=='function'?(length--,customizer):undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){customizer=length<3?undefined:customizer;length=1;}object=Object(object);while(++index<length){var source=sources[index];if(source){assigner(object,source,index,customizer);}}return object;});}/**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseEach(eachFunc,fromRight){return function(collection,iteratee){if(collection==null){return collection;}if(!isArrayLike(collection)){return eachFunc(collection,iteratee);}var length=collection.length,index=fromRight?length:-1,iterable=Object(collection);while(fromRight?index--:++index<length){if(iteratee(iterable[index],index,iterable)===false){break;}}return collection;};}/**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */function createBaseFor(fromRight){return function(object,iteratee,keysFunc){var index=-1,iterable=Object(object),props=keysFunc(object),length=props.length;while(length--){var key=props[fromRight?length:++index];if(iteratee(iterable[key],key,iterable)===false){break;}}return object;};}/**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createBind(func,bitmask,thisArg){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return fn.apply(isBind?thisArg:this,arguments);}return wrapper;}/**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */function createCaseFirst(methodName){return function(string){string=toString(string);var strSymbols=hasUnicode(string)?stringToArray(string):undefined;var chr=strSymbols?strSymbols[0]:string.charAt(0);var trailing=strSymbols?castSlice(strSymbols,1).join(''):string.slice(1);return chr[methodName]()+trailing;};}/**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */function createCompounder(callback){return function(string){return arrayReduce(words(deburr(string).replace(reApos,'')),callback,'');};}/**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */function createCtor(Ctor){return function(){// Use a `switch` statement to work with class constructors. See
// http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
// for more details.
var args=arguments;switch(args.length){case 0:return new Ctor();case 1:return new Ctor(args[0]);case 2:return new Ctor(args[0],args[1]);case 3:return new Ctor(args[0],args[1],args[2]);case 4:return new Ctor(args[0],args[1],args[2],args[3]);case 5:return new Ctor(args[0],args[1],args[2],args[3],args[4]);case 6:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5]);case 7:return new Ctor(args[0],args[1],args[2],args[3],args[4],args[5],args[6]);}var thisBinding=baseCreate(Ctor.prototype),result=Ctor.apply(thisBinding,args);// Mimic the constructor's `return` behavior.
// See https://es5.github.io/#x13.2.2 for more details.
return isObject(result)?result:thisBinding;};}/**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createCurry(func,bitmask,arity){var Ctor=createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length,placeholder=getHolder(wrapper);while(index--){args[index]=arguments[index];}var holders=length<3&&args[0]!==placeholder&&args[length-1]!==placeholder?[]:replaceHolders(args,placeholder);length-=holders.length;if(length<arity){return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,undefined,args,holders,undefined,undefined,arity-length);}var fn=this&&this!==root&&this instanceof wrapper?Ctor:func;return apply(fn,this,args);}return wrapper;}/**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */function createFind(findIndexFunc){return function(collection,predicate,fromIndex){var iterable=Object(collection);if(!isArrayLike(collection)){var iteratee=getIteratee(predicate,3);collection=keys(collection);predicate=function(key){return iteratee(iterable[key],key,iterable);};}var index=findIndexFunc(collection,predicate,fromIndex);return index>-1?iterable[iteratee?collection[index]:index]:undefined;};}/**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */function createFlow(fromRight){return flatRest(function(funcs){var length=funcs.length,index=length,prereq=LodashWrapper.prototype.thru;if(fromRight){funcs.reverse();}while(index--){var func=funcs[index];if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(prereq&&!wrapper&&getFuncName(func)=='wrapper'){var wrapper=new LodashWrapper([],true);}}index=wrapper?index:length;while(++index<length){func=funcs[index];var funcName=getFuncName(func),data=funcName=='wrapper'?getData(func):undefined;if(data&&isLaziable(data[0])&&data[1]==(WRAP_ARY_FLAG|WRAP_CURRY_FLAG|WRAP_PARTIAL_FLAG|WRAP_REARG_FLAG)&&!data[4].length&&data[9]==1){wrapper=wrapper[getFuncName(data[0])].apply(wrapper,data[3]);}else{wrapper=func.length==1&&isLaziable(func)?wrapper[funcName]():wrapper.thru(func);}}return function(){var args=arguments,value=args[0];if(wrapper&&args.length==1&&isArray(value)){return wrapper.plant(value).value();}var index=0,result=length?funcs[index].apply(this,args):value;while(++index<length){result=funcs[index].call(this,result);}return result;};});}/**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createHybrid(func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity){var isAry=bitmask&WRAP_ARY_FLAG,isBind=bitmask&WRAP_BIND_FLAG,isBindKey=bitmask&WRAP_BIND_KEY_FLAG,isCurried=bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG),isFlip=bitmask&WRAP_FLIP_FLAG,Ctor=isBindKey?undefined:createCtor(func);function wrapper(){var length=arguments.length,args=Array(length),index=length;while(index--){args[index]=arguments[index];}if(isCurried){var placeholder=getHolder(wrapper),holdersCount=countHolders(args,placeholder);}if(partials){args=composeArgs(args,partials,holders,isCurried);}if(partialsRight){args=composeArgsRight(args,partialsRight,holdersRight,isCurried);}length-=holdersCount;if(isCurried&&length<arity){var newHolders=replaceHolders(args,placeholder);return createRecurry(func,bitmask,createHybrid,wrapper.placeholder,thisArg,args,newHolders,argPos,ary,arity-length);}var thisBinding=isBind?thisArg:this,fn=isBindKey?thisBinding[func]:func;length=args.length;if(argPos){args=reorder(args,argPos);}else if(isFlip&&length>1){args.reverse();}if(isAry&&ary<length){args.length=ary;}if(this&&this!==root&&this instanceof wrapper){fn=Ctor||createCtor(fn);}return fn.apply(thisBinding,args);}return wrapper;}/**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */function createInverter(setter,toIteratee){return function(object,iteratee){return baseInverter(object,setter,toIteratee(iteratee),{});};}/**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */function createMathOperation(operator,defaultValue){return function(value,other){var result;if(value===undefined&&other===undefined){return defaultValue;}if(value!==undefined){result=value;}if(other!==undefined){if(result===undefined){return other;}if(typeof value=='string'||typeof other=='string'){value=baseToString(value);other=baseToString(other);}else{value=baseToNumber(value);other=baseToNumber(other);}result=operator(value,other);}return result;};}/**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */function createOver(arrayFunc){return flatRest(function(iteratees){iteratees=arrayMap(iteratees,baseUnary(getIteratee()));return baseRest(function(args){var thisArg=this;return arrayFunc(iteratees,function(iteratee){return apply(iteratee,thisArg,args);});});});}/**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */function createPadding(length,chars){chars=chars===undefined?' ':baseToString(chars);var charsLength=chars.length;if(charsLength<2){return charsLength?baseRepeat(chars,length):chars;}var result=baseRepeat(chars,nativeCeil(length/stringSize(chars)));return hasUnicode(chars)?castSlice(stringToArray(result),0,length).join(''):result.slice(0,length);}/**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */function createPartial(func,bitmask,thisArg,partials){var isBind=bitmask&WRAP_BIND_FLAG,Ctor=createCtor(func);function wrapper(){var argsIndex=-1,argsLength=arguments.length,leftIndex=-1,leftLength=partials.length,args=Array(leftLength+argsLength),fn=this&&this!==root&&this instanceof wrapper?Ctor:func;while(++leftIndex<leftLength){args[leftIndex]=partials[leftIndex];}while(argsLength--){args[leftIndex++]=arguments[++argsIndex];}return apply(fn,isBind?thisArg:this,args);}return wrapper;}/**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */function createRange(fromRight){return function(start,end,step){if(step&&typeof step!='number'&&isIterateeCall(start,end,step)){end=step=undefined;}// Ensure the sign of `-0` is preserved.
start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}step=step===undefined?start<end?1:-1:toFinite(step);return baseRange(start,end,step,fromRight);};}/**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */function createRelationalOperation(operator){return function(value,other){if(!(typeof value=='string'&&typeof other=='string')){value=toNumber(value);other=toNumber(other);}return operator(value,other);};}/**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createRecurry(func,bitmask,wrapFunc,placeholder,thisArg,partials,holders,argPos,ary,arity){var isCurry=bitmask&WRAP_CURRY_FLAG,newHolders=isCurry?holders:undefined,newHoldersRight=isCurry?undefined:holders,newPartials=isCurry?partials:undefined,newPartialsRight=isCurry?undefined:partials;bitmask|=isCurry?WRAP_PARTIAL_FLAG:WRAP_PARTIAL_RIGHT_FLAG;bitmask&=~(isCurry?WRAP_PARTIAL_RIGHT_FLAG:WRAP_PARTIAL_FLAG);if(!(bitmask&WRAP_CURRY_BOUND_FLAG)){bitmask&=~(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG);}var newData=[func,bitmask,thisArg,newPartials,newHolders,newPartialsRight,newHoldersRight,argPos,ary,arity];var result=wrapFunc.apply(undefined,newData);if(isLaziable(func)){setData(result,newData);}result.placeholder=placeholder;return setWrapToString(result,func,bitmask);}/**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */function createRound(methodName){var func=Math[methodName];return function(number,precision){number=toNumber(number);precision=precision==null?0:nativeMin(toInteger(precision),292);if(precision&&nativeIsFinite(number)){// Shift with exponential notation to avoid floating-point issues.
// See [MDN](https://mdn.io/round#Examples) for more details.
var pair=(toString(number)+'e').split('e'),value=func(pair[0]+'e'+(+pair[1]+precision));pair=(toString(value)+'e').split('e');return+(pair[0]+'e'+(+pair[1]-precision));}return func(number);};}/**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */var createSet=!(Set&&1/setToArray(new Set([,-0]))[1]==INFINITY)?noop:function(values){return new Set(values);};/**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */function createToPairs(keysFunc){return function(object){var tag=getTag(object);if(tag==mapTag){return mapToArray(object);}if(tag==setTag){return setToPairs(object);}return baseToPairs(object,keysFunc(object));};}/**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */function createWrap(func,bitmask,thisArg,partials,holders,argPos,ary,arity){var isBindKey=bitmask&WRAP_BIND_KEY_FLAG;if(!isBindKey&&typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var length=partials?partials.length:0;if(!length){bitmask&=~(WRAP_PARTIAL_FLAG|WRAP_PARTIAL_RIGHT_FLAG);partials=holders=undefined;}ary=ary===undefined?ary:nativeMax(toInteger(ary),0);arity=arity===undefined?arity:toInteger(arity);length-=holders?holders.length:0;if(bitmask&WRAP_PARTIAL_RIGHT_FLAG){var partialsRight=partials,holdersRight=holders;partials=holders=undefined;}var data=isBindKey?undefined:getData(func);var newData=[func,bitmask,thisArg,partials,holders,partialsRight,holdersRight,argPos,ary,arity];if(data){mergeData(newData,data);}func=newData[0];bitmask=newData[1];thisArg=newData[2];partials=newData[3];holders=newData[4];arity=newData[9]=newData[9]===undefined?isBindKey?0:func.length:nativeMax(newData[9]-length,0);if(!arity&&bitmask&(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG)){bitmask&=~(WRAP_CURRY_FLAG|WRAP_CURRY_RIGHT_FLAG);}if(!bitmask||bitmask==WRAP_BIND_FLAG){var result=createBind(func,bitmask,thisArg);}else if(bitmask==WRAP_CURRY_FLAG||bitmask==WRAP_CURRY_RIGHT_FLAG){result=createCurry(func,bitmask,arity);}else if((bitmask==WRAP_PARTIAL_FLAG||bitmask==(WRAP_BIND_FLAG|WRAP_PARTIAL_FLAG))&&!holders.length){result=createPartial(func,bitmask,thisArg,partials);}else{result=createHybrid.apply(undefined,newData);}var setter=data?baseSetData:setData;return setWrapToString(setter(result,newData),func,bitmask);}/**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */function customDefaultsAssignIn(objValue,srcValue,key,object){if(objValue===undefined||eq(objValue,objectProto[key])&&!hasOwnProperty.call(object,key)){return srcValue;}return objValue;}/**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */function customDefaultsMerge(objValue,srcValue,key,object,source,stack){if(isObject(objValue)&&isObject(srcValue)){// Recursively merge objects and arrays (susceptible to call stack limits).
stack.set(srcValue,objValue);baseMerge(objValue,srcValue,undefined,customDefaultsMerge,stack);stack['delete'](srcValue);}return objValue;}/**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */function customOmitClone(value){return isPlainObject(value)?undefined:value;}/**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */function equalArrays(array,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,arrLength=array.length,othLength=other.length;if(arrLength!=othLength&&!(isPartial&&othLength>arrLength)){return false;}// Check that cyclic values are equal.
var arrStacked=stack.get(array);var othStacked=stack.get(other);if(arrStacked&&othStacked){return arrStacked==other&&othStacked==array;}var index=-1,result=true,seen=bitmask&COMPARE_UNORDERED_FLAG?new SetCache():undefined;stack.set(array,other);stack.set(other,array);// Ignore non-index properties.
while(++index<arrLength){var arrValue=array[index],othValue=other[index];if(customizer){var compared=isPartial?customizer(othValue,arrValue,index,other,array,stack):customizer(arrValue,othValue,index,array,other,stack);}if(compared!==undefined){if(compared){continue;}result=false;break;}// Recursively compare arrays (susceptible to call stack limits).
if(seen){if(!arraySome(other,function(othValue,othIndex){if(!cacheHas(seen,othIndex)&&(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){return seen.push(othIndex);}})){result=false;break;}}else if(!(arrValue===othValue||equalFunc(arrValue,othValue,bitmask,customizer,stack))){result=false;break;}}stack['delete'](array);stack['delete'](other);return result;}/**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalByTag(object,other,tag,bitmask,customizer,equalFunc,stack){switch(tag){case dataViewTag:if(object.byteLength!=other.byteLength||object.byteOffset!=other.byteOffset){return false;}object=object.buffer;other=other.buffer;case arrayBufferTag:if(object.byteLength!=other.byteLength||!equalFunc(new Uint8Array(object),new Uint8Array(other))){return false;}return true;case boolTag:case dateTag:case numberTag:// Coerce booleans to `1` or `0` and dates to milliseconds.
// Invalid dates are coerced to `NaN`.
return eq(+object,+other);case errorTag:return object.name==other.name&&object.message==other.message;case regexpTag:case stringTag:// Coerce regexes to strings and treat strings, primitives and objects,
// as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
// for more details.
return object==other+'';case mapTag:var convert=mapToArray;case setTag:var isPartial=bitmask&COMPARE_PARTIAL_FLAG;convert||(convert=setToArray);if(object.size!=other.size&&!isPartial){return false;}// Assume cyclic values are equal.
var stacked=stack.get(object);if(stacked){return stacked==other;}bitmask|=COMPARE_UNORDERED_FLAG;// Recursively compare objects (susceptible to call stack limits).
stack.set(object,other);var result=equalArrays(convert(object),convert(other),bitmask,customizer,equalFunc,stack);stack['delete'](object);return result;case symbolTag:if(symbolValueOf){return symbolValueOf.call(object)==symbolValueOf.call(other);}}return false;}/**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */function equalObjects(object,other,bitmask,customizer,equalFunc,stack){var isPartial=bitmask&COMPARE_PARTIAL_FLAG,objProps=getAllKeys(object),objLength=objProps.length,othProps=getAllKeys(other),othLength=othProps.length;if(objLength!=othLength&&!isPartial){return false;}var index=objLength;while(index--){var key=objProps[index];if(!(isPartial?key in other:hasOwnProperty.call(other,key))){return false;}}// Check that cyclic values are equal.
var objStacked=stack.get(object);var othStacked=stack.get(other);if(objStacked&&othStacked){return objStacked==other&&othStacked==object;}var result=true;stack.set(object,other);stack.set(other,object);var skipCtor=isPartial;while(++index<objLength){key=objProps[index];var objValue=object[key],othValue=other[key];if(customizer){var compared=isPartial?customizer(othValue,objValue,key,other,object,stack):customizer(objValue,othValue,key,object,other,stack);}// Recursively compare objects (susceptible to call stack limits).
if(!(compared===undefined?objValue===othValue||equalFunc(objValue,othValue,bitmask,customizer,stack):compared)){result=false;break;}skipCtor||(skipCtor=key=='constructor');}if(result&&!skipCtor){var objCtor=object.constructor,othCtor=other.constructor;// Non `Object` object instances with different constructors are not equal.
if(objCtor!=othCtor&&'constructor'in object&&'constructor'in other&&!(typeof objCtor=='function'&&objCtor instanceof objCtor&&typeof othCtor=='function'&&othCtor instanceof othCtor)){result=false;}}stack['delete'](object);stack['delete'](other);return result;}/**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */function flatRest(func){return setToString(overRest(func,undefined,flatten),func+'');}/**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeys(object){return baseGetAllKeys(object,keys,getSymbols);}/**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */function getAllKeysIn(object){return baseGetAllKeys(object,keysIn,getSymbolsIn);}/**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */var getData=!metaMap?noop:function(func){return metaMap.get(func);};/**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */function getFuncName(func){var result=func.name+'',array=realNames[result],length=hasOwnProperty.call(realNames,result)?array.length:0;while(length--){var data=array[length],otherFunc=data.func;if(otherFunc==null||otherFunc==func){return data.name;}}return result;}/**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */function getHolder(func){var object=hasOwnProperty.call(lodash,'placeholder')?lodash:func;return object.placeholder;}/**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */function getIteratee(){var result=lodash.iteratee||iteratee;result=result===iteratee?baseIteratee:result;return arguments.length?result(arguments[0],arguments[1]):result;}/**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */function getMapData(map,key){var data=map.__data__;return isKeyable(key)?data[typeof key=='string'?'string':'hash']:data.map;}/**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */function getMatchData(object){var result=keys(object),length=result.length;while(length--){var key=result[length],value=object[key];result[length]=[key,value,isStrictComparable(value)];}return result;}/**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */function getNative(object,key){var value=getValue(object,key);return baseIsNative(value)?value:undefined;}/**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */function getRawTag(value){var isOwn=hasOwnProperty.call(value,symToStringTag),tag=value[symToStringTag];try{value[symToStringTag]=undefined;var unmasked=true;}catch(e){}var result=nativeObjectToString.call(value);if(unmasked){if(isOwn){value[symToStringTag]=tag;}else{delete value[symToStringTag];}}return result;}/**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbols=!nativeGetSymbols?stubArray:function(object){if(object==null){return[];}object=Object(object);return arrayFilter(nativeGetSymbols(object),function(symbol){return propertyIsEnumerable.call(object,symbol);});};/**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */var getSymbolsIn=!nativeGetSymbols?stubArray:function(object){var result=[];while(object){arrayPush(result,getSymbols(object));object=getPrototype(object);}return result;};/**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */var getTag=baseGetTag;// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if(DataView&&getTag(new DataView(new ArrayBuffer(1)))!=dataViewTag||Map&&getTag(new Map())!=mapTag||Promise&&getTag(Promise.resolve())!=promiseTag||Set&&getTag(new Set())!=setTag||WeakMap&&getTag(new WeakMap())!=weakMapTag){getTag=function(value){var result=baseGetTag(value),Ctor=result==objectTag?value.constructor:undefined,ctorString=Ctor?toSource(Ctor):'';if(ctorString){switch(ctorString){case dataViewCtorString:return dataViewTag;case mapCtorString:return mapTag;case promiseCtorString:return promiseTag;case setCtorString:return setTag;case weakMapCtorString:return weakMapTag;}}return result;};}/**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */function getView(start,end,transforms){var index=-1,length=transforms.length;while(++index<length){var data=transforms[index],size=data.size;switch(data.type){case'drop':start+=size;break;case'dropRight':end-=size;break;case'take':end=nativeMin(end,start+size);break;case'takeRight':start=nativeMax(start,end-size);break;}}return{'start':start,'end':end};}/**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */function getWrapDetails(source){var match=source.match(reWrapDetails);return match?match[1].split(reSplitDetails):[];}/**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */function hasPath(object,path,hasFunc){path=castPath(path,object);var index=-1,length=path.length,result=false;while(++index<length){var key=toKey(path[index]);if(!(result=object!=null&&hasFunc(object,key))){break;}object=object[key];}if(result||++index!=length){return result;}length=object==null?0:object.length;return!!length&&isLength(length)&&isIndex(key,length)&&(isArray(object)||isArguments(object));}/**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */function initCloneArray(array){var length=array.length,result=new array.constructor(length);// Add properties assigned by `RegExp#exec`.
if(length&&typeof array[0]=='string'&&hasOwnProperty.call(array,'index')){result.index=array.index;result.input=array.input;}return result;}/**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneObject(object){return typeof object.constructor=='function'&&!isPrototype(object)?baseCreate(getPrototype(object)):{};}/**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */function initCloneByTag(object,tag,isDeep){var Ctor=object.constructor;switch(tag){case arrayBufferTag:return cloneArrayBuffer(object);case boolTag:case dateTag:return new Ctor(+object);case dataViewTag:return cloneDataView(object,isDeep);case float32Tag:case float64Tag:case int8Tag:case int16Tag:case int32Tag:case uint8Tag:case uint8ClampedTag:case uint16Tag:case uint32Tag:return cloneTypedArray(object,isDeep);case mapTag:return new Ctor();case numberTag:case stringTag:return new Ctor(object);case regexpTag:return cloneRegExp(object);case setTag:return new Ctor();case symbolTag:return cloneSymbol(object);}}/**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */function insertWrapDetails(source,details){var length=details.length;if(!length){return source;}var lastIndex=length-1;details[lastIndex]=(length>1?'& ':'')+details[lastIndex];details=details.join(length>2?', ':' ');return source.replace(reWrapComment,'{\n/* [wrapped with '+details+'] */\n');}/**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */function isFlattenable(value){return isArray(value)||isArguments(value)||!!(spreadableSymbol&&value&&value[spreadableSymbol]);}/**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */function isIndex(value,length){var type=typeof value;length=length==null?MAX_SAFE_INTEGER:length;return!!length&&(type=='number'||type!='symbol'&&reIsUint.test(value))&&value>-1&&value%1==0&&value<length;}/**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */function isIterateeCall(value,index,object){if(!isObject(object)){return false;}var type=typeof index;if(type=='number'?isArrayLike(object)&&isIndex(index,object.length):type=='string'&&index in object){return eq(object[index],value);}return false;}/**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */function isKey(value,object){if(isArray(value)){return false;}var type=typeof value;if(type=='number'||type=='symbol'||type=='boolean'||value==null||isSymbol(value)){return true;}return reIsPlainProp.test(value)||!reIsDeepProp.test(value)||object!=null&&value in Object(object);}/**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */function isKeyable(value){var type=typeof value;return type=='string'||type=='number'||type=='symbol'||type=='boolean'?value!=='__proto__':value===null;}/**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */function isLaziable(func){var funcName=getFuncName(func),other=lodash[funcName];if(typeof other!='function'||!(funcName in LazyWrapper.prototype)){return false;}if(func===other){return true;}var data=getData(other);return!!data&&func===data[0];}/**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */function isMasked(func){return!!maskSrcKey&&maskSrcKey in func;}/**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */var isMaskable=coreJsData?isFunction:stubFalse;/**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */function isPrototype(value){var Ctor=value&&value.constructor,proto=typeof Ctor=='function'&&Ctor.prototype||objectProto;return value===proto;}/**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */function isStrictComparable(value){return value===value&&!isObject(value);}/**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */function matchesStrictComparable(key,srcValue){return function(object){if(object==null){return false;}return object[key]===srcValue&&(srcValue!==undefined||key in Object(object));};}/**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */function memoizeCapped(func){var result=memoize(func,function(key){if(cache.size===MAX_MEMOIZE_SIZE){cache.clear();}return key;});var cache=result.cache;return result;}/**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */function mergeData(data,source){var bitmask=data[1],srcBitmask=source[1],newBitmask=bitmask|srcBitmask,isCommon=newBitmask<(WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG|WRAP_ARY_FLAG);var isCombo=srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_CURRY_FLAG||srcBitmask==WRAP_ARY_FLAG&&bitmask==WRAP_REARG_FLAG&&data[7].length<=source[8]||srcBitmask==(WRAP_ARY_FLAG|WRAP_REARG_FLAG)&&source[7].length<=source[8]&&bitmask==WRAP_CURRY_FLAG;// Exit early if metadata can't be merged.
if(!(isCommon||isCombo)){return data;}// Use source `thisArg` if available.
if(srcBitmask&WRAP_BIND_FLAG){data[2]=source[2];// Set when currying a bound function.
newBitmask|=bitmask&WRAP_BIND_FLAG?0:WRAP_CURRY_BOUND_FLAG;}// Compose partial arguments.
var value=source[3];if(value){var partials=data[3];data[3]=partials?composeArgs(partials,value,source[4]):value;data[4]=partials?replaceHolders(data[3],PLACEHOLDER):source[4];}// Compose partial right arguments.
value=source[5];if(value){partials=data[5];data[5]=partials?composeArgsRight(partials,value,source[6]):value;data[6]=partials?replaceHolders(data[5],PLACEHOLDER):source[6];}// Use source `argPos` if available.
value=source[7];if(value){data[7]=value;}// Use source `ary` if it's smaller.
if(srcBitmask&WRAP_ARY_FLAG){data[8]=data[8]==null?source[8]:nativeMin(data[8],source[8]);}// Use source `arity` if one is not provided.
if(data[9]==null){data[9]=source[9];}// Use source `func` and merge bitmasks.
data[0]=source[0];data[1]=newBitmask;return data;}/**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */function nativeKeysIn(object){var result=[];if(object!=null){for(var key in Object(object)){result.push(key);}}return result;}/**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */function objectToString(value){return nativeObjectToString.call(value);}/**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */function overRest(func,start,transform){start=nativeMax(start===undefined?func.length-1:start,0);return function(){var args=arguments,index=-1,length=nativeMax(args.length-start,0),array=Array(length);while(++index<length){array[index]=args[start+index];}index=-1;var otherArgs=Array(start+1);while(++index<start){otherArgs[index]=args[index];}otherArgs[start]=transform(array);return apply(func,this,otherArgs);};}/**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */function parent(object,path){return path.length<2?object:baseGet(object,baseSlice(path,0,-1));}/**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */function reorder(array,indexes){var arrLength=array.length,length=nativeMin(indexes.length,arrLength),oldArray=copyArray(array);while(length--){var index=indexes[length];array[length]=isIndex(index,arrLength)?oldArray[index]:undefined;}return array;}/**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */function safeGet(object,key){if(key==='constructor'&&typeof object[key]==='function'){return;}if(key=='__proto__'){return;}return object[key];}/**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */var setData=shortOut(baseSetData);/**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */var setTimeout=ctxSetTimeout||function(func,wait){return root.setTimeout(func,wait);};/**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */var setToString=shortOut(baseSetToString);/**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */function setWrapToString(wrapper,reference,bitmask){var source=reference+'';return setToString(wrapper,insertWrapDetails(source,updateWrapDetails(getWrapDetails(source),bitmask)));}/**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */function shortOut(func){var count=0,lastCalled=0;return function(){var stamp=nativeNow(),remaining=HOT_SPAN-(stamp-lastCalled);lastCalled=stamp;if(remaining>0){if(++count>=HOT_COUNT){return arguments[0];}}else{count=0;}return func.apply(undefined,arguments);};}/**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */function shuffleSelf(array,size){var index=-1,length=array.length,lastIndex=length-1;size=size===undefined?length:size;while(++index<size){var rand=baseRandom(index,lastIndex),value=array[rand];array[rand]=array[index];array[index]=value;}array.length=size;return array;}/**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */var stringToPath=memoizeCapped(function(string){var result=[];if(string.charCodeAt(0)===46/* . */){result.push('');}string.replace(rePropName,function(match,number,quote,subString){result.push(quote?subString.replace(reEscapeChar,'$1'):number||match);});return result;});/**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */function toKey(value){if(typeof value=='string'||isSymbol(value)){return value;}var result=value+'';return result=='0'&&1/value==-INFINITY?'-0':result;}/**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */function toSource(func){if(func!=null){try{return funcToString.call(func);}catch(e){}try{return func+'';}catch(e){}}return'';}/**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */function updateWrapDetails(details,bitmask){arrayEach(wrapFlags,function(pair){var value='_.'+pair[0];if(bitmask&pair[1]&&!arrayIncludes(details,value)){details.push(value);}});return details.sort();}/**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */function wrapperClone(wrapper){if(wrapper instanceof LazyWrapper){return wrapper.clone();}var result=new LodashWrapper(wrapper.__wrapped__,wrapper.__chain__);result.__actions__=copyArray(wrapper.__actions__);result.__index__=wrapper.__index__;result.__values__=wrapper.__values__;return result;}/*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */function chunk(array,size,guard){if(guard?isIterateeCall(array,size,guard):size===undefined){size=1;}else{size=nativeMax(toInteger(size),0);}var length=array==null?0:array.length;if(!length||size<1){return[];}var index=0,resIndex=0,result=Array(nativeCeil(length/size));while(index<length){result[resIndex++]=baseSlice(array,index,index+=size);}return result;}/**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */function compact(array){var index=-1,length=array==null?0:array.length,resIndex=0,result=[];while(++index<length){var value=array[index];if(value){result[resIndex++]=value;}}return result;}/**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */function concat(){var length=arguments.length;if(!length){return[];}var args=Array(length-1),array=arguments[0],index=length;while(index--){args[index-1]=arguments[index];}return arrayPush(isArray(array)?copyArray(array):[array],baseFlatten(args,1));}/**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */var difference=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true)):[];});/**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var differenceBy=baseRest(function(array,values){var iteratee=last(values);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),getIteratee(iteratee,2)):[];});/**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */var differenceWith=baseRest(function(array,values){var comparator=last(values);if(isArrayLikeObject(comparator)){comparator=undefined;}return isArrayLikeObject(array)?baseDifference(array,baseFlatten(values,1,isArrayLikeObject,true),undefined,comparator):[];});/**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function drop(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */function dropRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true,true):[];}/**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */function dropWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),true):[];}/**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */function fill(array,value,start,end){var length=array==null?0:array.length;if(!length){return[];}if(start&&typeof start!='number'&&isIterateeCall(array,value,start)){start=0;end=length;}return baseFill(array,value,start,end);}/**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */function findIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseFindIndex(array,getIteratee(predicate,3),index);}/**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */function findLastIndex(array,predicate,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length-1;if(fromIndex!==undefined){index=toInteger(fromIndex);index=fromIndex<0?nativeMax(length+index,0):nativeMin(index,length-1);}return baseFindIndex(array,getIteratee(predicate,3),index,true);}/**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */function flatten(array){var length=array==null?0:array.length;return length?baseFlatten(array,1):[];}/**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */function flattenDeep(array){var length=array==null?0:array.length;return length?baseFlatten(array,INFINITY):[];}/**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */function flattenDepth(array,depth){var length=array==null?0:array.length;if(!length){return[];}depth=depth===undefined?1:toInteger(depth);return baseFlatten(array,depth);}/**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */function fromPairs(pairs){var index=-1,length=pairs==null?0:pairs.length,result={};while(++index<length){var pair=pairs[index];result[pair[0]]=pair[1];}return result;}/**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */function head(array){return array&&array.length?array[0]:undefined;}/**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */function indexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=fromIndex==null?0:toInteger(fromIndex);if(index<0){index=nativeMax(length+index,0);}return baseIndexOf(array,value,index);}/**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */function initial(array){var length=array==null?0:array.length;return length?baseSlice(array,0,-1):[];}/**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */var intersection=baseRest(function(arrays){var mapped=arrayMap(arrays,castArrayLikeObject);return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped):[];});/**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */var intersectionBy=baseRest(function(arrays){var iteratee=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);if(iteratee===last(mapped)){iteratee=undefined;}else{mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,getIteratee(iteratee,2)):[];});/**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */var intersectionWith=baseRest(function(arrays){var comparator=last(arrays),mapped=arrayMap(arrays,castArrayLikeObject);comparator=typeof comparator=='function'?comparator:undefined;if(comparator){mapped.pop();}return mapped.length&&mapped[0]===arrays[0]?baseIntersection(mapped,undefined,comparator):[];});/**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */function join(array,separator){return array==null?'':nativeJoin.call(array,separator);}/**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */function last(array){var length=array==null?0:array.length;return length?array[length-1]:undefined;}/**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */function lastIndexOf(array,value,fromIndex){var length=array==null?0:array.length;if(!length){return-1;}var index=length;if(fromIndex!==undefined){index=toInteger(fromIndex);index=index<0?nativeMax(length+index,0):nativeMin(index,length-1);}return value===value?strictLastIndexOf(array,value,index):baseFindIndex(array,baseIsNaN,index,true);}/**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */function nth(array,n){return array&&array.length?baseNth(array,toInteger(n)):undefined;}/**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */var pull=baseRest(pullAll);/**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */function pullAll(array,values){return array&&array.length&&values&&values.length?basePullAll(array,values):array;}/**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */function pullAllBy(array,values,iteratee){return array&&array.length&&values&&values.length?basePullAll(array,values,getIteratee(iteratee,2)):array;}/**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */function pullAllWith(array,values,comparator){return array&&array.length&&values&&values.length?basePullAll(array,values,undefined,comparator):array;}/**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */var pullAt=flatRest(function(array,indexes){var length=array==null?0:array.length,result=baseAt(array,indexes);basePullAt(array,arrayMap(indexes,function(index){return isIndex(index,length)?+index:index;}).sort(compareAscending));return result;});/**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */function remove(array,predicate){var result=[];if(!(array&&array.length)){return result;}var index=-1,indexes=[],length=array.length;predicate=getIteratee(predicate,3);while(++index<length){var value=array[index];if(predicate(value,index,array)){result.push(value);indexes.push(index);}}basePullAt(array,indexes);return result;}/**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function reverse(array){return array==null?array:nativeReverse.call(array);}/**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */function slice(array,start,end){var length=array==null?0:array.length;if(!length){return[];}if(end&&typeof end!='number'&&isIterateeCall(array,start,end)){start=0;end=length;}else{start=start==null?0:toInteger(start);end=end===undefined?length:toInteger(end);}return baseSlice(array,start,end);}/**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */function sortedIndex(array,value){return baseSortedIndex(array,value);}/**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */function sortedIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2));}/**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */function sortedIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value);if(index<length&&eq(array[index],value)){return index;}}return-1;}/**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */function sortedLastIndex(array,value){return baseSortedIndex(array,value,true);}/**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */function sortedLastIndexBy(array,value,iteratee){return baseSortedIndexBy(array,value,getIteratee(iteratee,2),true);}/**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */function sortedLastIndexOf(array,value){var length=array==null?0:array.length;if(length){var index=baseSortedIndex(array,value,true)-1;if(eq(array[index],value)){return index;}}return-1;}/**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */function sortedUniq(array){return array&&array.length?baseSortedUniq(array):[];}/**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */function sortedUniqBy(array,iteratee){return array&&array.length?baseSortedUniq(array,getIteratee(iteratee,2)):[];}/**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */function tail(array){var length=array==null?0:array.length;return length?baseSlice(array,1,length):[];}/**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */function take(array,n,guard){if(!(array&&array.length)){return[];}n=guard||n===undefined?1:toInteger(n);return baseSlice(array,0,n<0?0:n);}/**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */function takeRight(array,n,guard){var length=array==null?0:array.length;if(!length){return[];}n=guard||n===undefined?1:toInteger(n);n=length-n;return baseSlice(array,n<0?0:n,length);}/**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */function takeRightWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3),false,true):[];}/**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */function takeWhile(array,predicate){return array&&array.length?baseWhile(array,getIteratee(predicate,3)):[];}/**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */var union=baseRest(function(arrays){return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true));});/**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */var unionBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),getIteratee(iteratee,2));});/**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var unionWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseUniq(baseFlatten(arrays,1,isArrayLikeObject,true),undefined,comparator);});/**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */function uniq(array){return array&&array.length?baseUniq(array):[];}/**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */function uniqBy(array,iteratee){return array&&array.length?baseUniq(array,getIteratee(iteratee,2)):[];}/**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */function uniqWith(array,comparator){comparator=typeof comparator=='function'?comparator:undefined;return array&&array.length?baseUniq(array,undefined,comparator):[];}/**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */function unzip(array){if(!(array&&array.length)){return[];}var length=0;array=arrayFilter(array,function(group){if(isArrayLikeObject(group)){length=nativeMax(group.length,length);return true;}});return baseTimes(length,function(index){return arrayMap(array,baseProperty(index));});}/**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */function unzipWith(array,iteratee){if(!(array&&array.length)){return[];}var result=unzip(array);if(iteratee==null){return result;}return arrayMap(result,function(group){return apply(iteratee,undefined,group);});}/**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */var without=baseRest(function(array,values){return isArrayLikeObject(array)?baseDifference(array,values):[];});/**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */var xor=baseRest(function(arrays){return baseXor(arrayFilter(arrays,isArrayLikeObject));});/**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */var xorBy=baseRest(function(arrays){var iteratee=last(arrays);if(isArrayLikeObject(iteratee)){iteratee=undefined;}return baseXor(arrayFilter(arrays,isArrayLikeObject),getIteratee(iteratee,2));});/**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */var xorWith=baseRest(function(arrays){var comparator=last(arrays);comparator=typeof comparator=='function'?comparator:undefined;return baseXor(arrayFilter(arrays,isArrayLikeObject),undefined,comparator);});/**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */var zip=baseRest(unzip);/**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */function zipObject(props,values){return baseZipObject(props||[],values||[],assignValue);}/**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */function zipObjectDeep(props,values){return baseZipObject(props||[],values||[],baseSet);}/**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */var zipWith=baseRest(function(arrays){var length=arrays.length,iteratee=length>1?arrays[length-1]:undefined;iteratee=typeof iteratee=='function'?(arrays.pop(),iteratee):undefined;return unzipWith(arrays,iteratee);});/*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */function chain(value){var result=lodash(value);result.__chain__=true;return result;}/**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */function tap(value,interceptor){interceptor(value);return value;}/**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */function thru(value,interceptor){return interceptor(value);}/**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */var wrapperAt=flatRest(function(paths){var length=paths.length,start=length?paths[0]:0,value=this.__wrapped__,interceptor=function(object){return baseAt(object,paths);};if(length>1||this.__actions__.length||!(value instanceof LazyWrapper)||!isIndex(start)){return this.thru(interceptor);}value=value.slice(start,+start+(length?1:0));value.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(value,this.__chain__).thru(function(array){if(length&&!array.length){array.push(undefined);}return array;});});/**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */function wrapperChain(){return chain(this);}/**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */function wrapperCommit(){return new LodashWrapper(this.value(),this.__chain__);}/**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */function wrapperNext(){if(this.__values__===undefined){this.__values__=toArray(this.value());}var done=this.__index__>=this.__values__.length,value=done?undefined:this.__values__[this.__index__++];return{'done':done,'value':value};}/**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */function wrapperToIterator(){return this;}/**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */function wrapperPlant(value){var result,parent=this;while(parent instanceof baseLodash){var clone=wrapperClone(parent);clone.__index__=0;clone.__values__=undefined;if(result){previous.__wrapped__=clone;}else{result=clone;}var previous=clone;parent=parent.__wrapped__;}previous.__wrapped__=value;return result;}/**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */function wrapperReverse(){var value=this.__wrapped__;if(value instanceof LazyWrapper){var wrapped=value;if(this.__actions__.length){wrapped=new LazyWrapper(this);}wrapped=wrapped.reverse();wrapped.__actions__.push({'func':thru,'args':[reverse],'thisArg':undefined});return new LodashWrapper(wrapped,this.__chain__);}return this.thru(reverse);}/**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */function wrapperValue(){return baseWrapperValue(this.__wrapped__,this.__actions__);}/*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */var countBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){++result[key];}else{baseAssignValue(result,key,1);}});/**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */function every(collection,predicate,guard){var func=isArray(collection)?arrayEvery:baseEvery;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */function filter(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,getIteratee(predicate,3));}/**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */var find=createFind(findIndex);/**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */var findLast=createFind(findLastIndex);/**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMap(collection,iteratee){return baseFlatten(map(collection,iteratee),1);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */function flatMapDeep(collection,iteratee){return baseFlatten(map(collection,iteratee),INFINITY);}/**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */function flatMapDepth(collection,iteratee,depth){depth=depth===undefined?1:toInteger(depth);return baseFlatten(map(collection,iteratee),depth);}/**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forEach(collection,iteratee){var func=isArray(collection)?arrayEach:baseEach;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */function forEachRight(collection,iteratee){var func=isArray(collection)?arrayEachRight:baseEachRight;return func(collection,getIteratee(iteratee,3));}/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */var groupBy=createAggregator(function(result,value,key){if(hasOwnProperty.call(result,key)){result[key].push(value);}else{baseAssignValue(result,key,[value]);}});/**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */function includes(collection,value,fromIndex,guard){collection=isArrayLike(collection)?collection:values(collection);fromIndex=fromIndex&&!guard?toInteger(fromIndex):0;var length=collection.length;if(fromIndex<0){fromIndex=nativeMax(length+fromIndex,0);}return isString(collection)?fromIndex<=length&&collection.indexOf(value,fromIndex)>-1:!!length&&baseIndexOf(collection,value,fromIndex)>-1;}/**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */var invokeMap=baseRest(function(collection,path,args){var index=-1,isFunc=typeof path=='function',result=isArrayLike(collection)?Array(collection.length):[];baseEach(collection,function(value){result[++index]=isFunc?apply(path,value,args):baseInvoke(value,path,args);});return result;});/**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */var keyBy=createAggregator(function(result,value,key){baseAssignValue(result,key,value);});/**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */function map(collection,iteratee){var func=isArray(collection)?arrayMap:baseMap;return func(collection,getIteratee(iteratee,3));}/**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */function orderBy(collection,iteratees,orders,guard){if(collection==null){return[];}if(!isArray(iteratees)){iteratees=iteratees==null?[]:[iteratees];}orders=guard?undefined:orders;if(!isArray(orders)){orders=orders==null?[]:[orders];}return baseOrderBy(collection,iteratees,orders);}/**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */var partition=createAggregator(function(result,value,key){result[key?0:1].push(value);},function(){return[[],[]];});/**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */function reduce(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduce:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEach);}/**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */function reduceRight(collection,iteratee,accumulator){var func=isArray(collection)?arrayReduceRight:baseReduce,initAccum=arguments.length<3;return func(collection,getIteratee(iteratee,4),accumulator,initAccum,baseEachRight);}/**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */function reject(collection,predicate){var func=isArray(collection)?arrayFilter:baseFilter;return func(collection,negate(getIteratee(predicate,3)));}/**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */function sample(collection){var func=isArray(collection)?arraySample:baseSample;return func(collection);}/**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */function sampleSize(collection,n,guard){if(guard?isIterateeCall(collection,n,guard):n===undefined){n=1;}else{n=toInteger(n);}var func=isArray(collection)?arraySampleSize:baseSampleSize;return func(collection,n);}/**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */function shuffle(collection){var func=isArray(collection)?arrayShuffle:baseShuffle;return func(collection);}/**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */function size(collection){if(collection==null){return 0;}if(isArrayLike(collection)){return isString(collection)?stringSize(collection):collection.length;}var tag=getTag(collection);if(tag==mapTag||tag==setTag){return collection.size;}return baseKeys(collection).length;}/**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */function some(collection,predicate,guard){var func=isArray(collection)?arraySome:baseSome;if(guard&&isIterateeCall(collection,predicate,guard)){predicate=undefined;}return func(collection,getIteratee(predicate,3));}/**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */var sortBy=baseRest(function(collection,iteratees){if(collection==null){return[];}var length=iteratees.length;if(length>1&&isIterateeCall(collection,iteratees[0],iteratees[1])){iteratees=[];}else if(length>2&&isIterateeCall(iteratees[0],iteratees[1],iteratees[2])){iteratees=[iteratees[0]];}return baseOrderBy(collection,baseFlatten(iteratees,1),[]);});/*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */var now=ctxNow||function(){return root.Date.now();};/*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */function after(n,func){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n<1){return func.apply(this,arguments);}};}/**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */function ary(func,n,guard){n=guard?undefined:n;n=func&&n==null?func.length:n;return createWrap(func,WRAP_ARY_FLAG,undefined,undefined,undefined,undefined,n);}/**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */function before(n,func){var result;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}n=toInteger(n);return function(){if(--n>0){result=func.apply(this,arguments);}if(n<=1){func=undefined;}return result;};}/**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */var bind=baseRest(function(func,thisArg,partials){var bitmask=WRAP_BIND_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bind));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(func,bitmask,thisArg,partials,holders);});/**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */var bindKey=baseRest(function(object,key,partials){var bitmask=WRAP_BIND_FLAG|WRAP_BIND_KEY_FLAG;if(partials.length){var holders=replaceHolders(partials,getHolder(bindKey));bitmask|=WRAP_PARTIAL_FLAG;}return createWrap(key,bitmask,object,partials,holders);});/**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */function curry(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curry.placeholder;return result;}/**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */function curryRight(func,arity,guard){arity=guard?undefined:arity;var result=createWrap(func,WRAP_CURRY_RIGHT_FLAG,undefined,undefined,undefined,undefined,undefined,arity);result.placeholder=curryRight.placeholder;return result;}/**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */function debounce(func,wait,options){var lastArgs,lastThis,maxWait,result,timerId,lastCallTime,lastInvokeTime=0,leading=false,maxing=false,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}wait=toNumber(wait)||0;if(isObject(options)){leading=!!options.leading;maxing='maxWait'in options;maxWait=maxing?nativeMax(toNumber(options.maxWait)||0,wait):maxWait;trailing='trailing'in options?!!options.trailing:trailing;}function invokeFunc(time){var args=lastArgs,thisArg=lastThis;lastArgs=lastThis=undefined;lastInvokeTime=time;result=func.apply(thisArg,args);return result;}function leadingEdge(time){// Reset any `maxWait` timer.
lastInvokeTime=time;// Start the timer for the trailing edge.
timerId=setTimeout(timerExpired,wait);// Invoke the leading edge.
return leading?invokeFunc(time):result;}function remainingWait(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime,timeWaiting=wait-timeSinceLastCall;return maxing?nativeMin(timeWaiting,maxWait-timeSinceLastInvoke):timeWaiting;}function shouldInvoke(time){var timeSinceLastCall=time-lastCallTime,timeSinceLastInvoke=time-lastInvokeTime;// Either this is the first call, activity has stopped and we're at the
// trailing edge, the system time has gone backwards and we're treating
// it as the trailing edge, or we've hit the `maxWait` limit.
return lastCallTime===undefined||timeSinceLastCall>=wait||timeSinceLastCall<0||maxing&&timeSinceLastInvoke>=maxWait;}function timerExpired(){var time=now();if(shouldInvoke(time)){return trailingEdge(time);}// Restart the timer.
timerId=setTimeout(timerExpired,remainingWait(time));}function trailingEdge(time){timerId=undefined;// Only invoke if we have `lastArgs` which means `func` has been
// debounced at least once.
if(trailing&&lastArgs){return invokeFunc(time);}lastArgs=lastThis=undefined;return result;}function cancel(){if(timerId!==undefined){clearTimeout(timerId);}lastInvokeTime=0;lastArgs=lastCallTime=lastThis=timerId=undefined;}function flush(){return timerId===undefined?result:trailingEdge(now());}function debounced(){var time=now(),isInvoking=shouldInvoke(time);lastArgs=arguments;lastThis=this;lastCallTime=time;if(isInvoking){if(timerId===undefined){return leadingEdge(lastCallTime);}if(maxing){// Handle invocations in a tight loop.
clearTimeout(timerId);timerId=setTimeout(timerExpired,wait);return invokeFunc(lastCallTime);}}if(timerId===undefined){timerId=setTimeout(timerExpired,wait);}return result;}debounced.cancel=cancel;debounced.flush=flush;return debounced;}/**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */var defer=baseRest(function(func,args){return baseDelay(func,1,args);});/**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */var delay=baseRest(function(func,wait,args){return baseDelay(func,toNumber(wait)||0,args);});/**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */function flip(func){return createWrap(func,WRAP_FLIP_FLAG);}/**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */function memoize(func,resolver){if(typeof func!='function'||resolver!=null&&typeof resolver!='function'){throw new TypeError(FUNC_ERROR_TEXT);}var memoized=function(){var args=arguments,key=resolver?resolver.apply(this,args):args[0],cache=memoized.cache;if(cache.has(key)){return cache.get(key);}var result=func.apply(this,args);memoized.cache=cache.set(key,result)||cache;return result;};memoized.cache=new(memoize.Cache||MapCache)();return memoized;}// Expose `MapCache`.
memoize.Cache=MapCache;/**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */function negate(predicate){if(typeof predicate!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return function(){var args=arguments;switch(args.length){case 0:return!predicate.call(this);case 1:return!predicate.call(this,args[0]);case 2:return!predicate.call(this,args[0],args[1]);case 3:return!predicate.call(this,args[0],args[1],args[2]);}return!predicate.apply(this,args);};}/**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */function once(func){return before(2,func);}/**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */var overArgs=castRest(function(func,transforms){transforms=transforms.length==1&&isArray(transforms[0])?arrayMap(transforms[0],baseUnary(getIteratee())):arrayMap(baseFlatten(transforms,1),baseUnary(getIteratee()));var funcsLength=transforms.length;return baseRest(function(args){var index=-1,length=nativeMin(args.length,funcsLength);while(++index<length){args[index]=transforms[index].call(this,args[index]);}return apply(func,this,args);});});/**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */var partial=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partial));return createWrap(func,WRAP_PARTIAL_FLAG,undefined,partials,holders);});/**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */var partialRight=baseRest(function(func,partials){var holders=replaceHolders(partials,getHolder(partialRight));return createWrap(func,WRAP_PARTIAL_RIGHT_FLAG,undefined,partials,holders);});/**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */var rearg=flatRest(function(func,indexes){return createWrap(func,WRAP_REARG_FLAG,undefined,undefined,undefined,indexes);});/**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */function rest(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start===undefined?start:toInteger(start);return baseRest(func,start);}/**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */function spread(func,start){if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}start=start==null?0:nativeMax(toInteger(start),0);return baseRest(function(args){var array=args[start],otherArgs=castSlice(args,0,start);if(array){arrayPush(otherArgs,array);}return apply(func,this,otherArgs);});}/**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */function throttle(func,wait,options){var leading=true,trailing=true;if(typeof func!='function'){throw new TypeError(FUNC_ERROR_TEXT);}if(isObject(options)){leading='leading'in options?!!options.leading:leading;trailing='trailing'in options?!!options.trailing:trailing;}return debounce(func,wait,{'leading':leading,'maxWait':wait,'trailing':trailing});}/**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */function unary(func){return ary(func,1);}/**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */function wrap(value,wrapper){return partial(castFunction(wrapper),value);}/*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */function castArray(){if(!arguments.length){return[];}var value=arguments[0];return isArray(value)?value:[value];}/**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */function clone(value){return baseClone(value,CLONE_SYMBOLS_FLAG);}/**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */function cloneWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_SYMBOLS_FLAG,customizer);}/**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */function cloneDeep(value){return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG);}/**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */function cloneDeepWith(value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseClone(value,CLONE_DEEP_FLAG|CLONE_SYMBOLS_FLAG,customizer);}/**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */function conformsTo(object,source){return source==null||baseConformsTo(object,source,keys(source));}/**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */function eq(value,other){return value===other||value!==value&&other!==other;}/**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */var gt=createRelationalOperation(baseGt);/**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */var gte=createRelationalOperation(function(value,other){return value>=other;});/**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */var isArguments=baseIsArguments(function(){return arguments;}())?baseIsArguments:function(value){return isObjectLike(value)&&hasOwnProperty.call(value,'callee')&&!propertyIsEnumerable.call(value,'callee');};/**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */var isArray=Array.isArray;/**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */var isArrayBuffer=nodeIsArrayBuffer?baseUnary(nodeIsArrayBuffer):baseIsArrayBuffer;/**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */function isArrayLike(value){return value!=null&&isLength(value.length)&&!isFunction(value);}/**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */function isArrayLikeObject(value){return isObjectLike(value)&&isArrayLike(value);}/**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */function isBoolean(value){return value===true||value===false||isObjectLike(value)&&baseGetTag(value)==boolTag;}/**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */var isBuffer=nativeIsBuffer||stubFalse;/**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */var isDate=nodeIsDate?baseUnary(nodeIsDate):baseIsDate;/**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */function isElement(value){return isObjectLike(value)&&value.nodeType===1&&!isPlainObject(value);}/**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */function isEmpty(value){if(value==null){return true;}if(isArrayLike(value)&&(isArray(value)||typeof value=='string'||typeof value.splice=='function'||isBuffer(value)||isTypedArray(value)||isArguments(value))){return!value.length;}var tag=getTag(value);if(tag==mapTag||tag==setTag){return!value.size;}if(isPrototype(value)){return!baseKeys(value).length;}for(var key in value){if(hasOwnProperty.call(value,key)){return false;}}return true;}/**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */function isEqual(value,other){return baseIsEqual(value,other);}/**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */function isEqualWith(value,other,customizer){customizer=typeof customizer=='function'?customizer:undefined;var result=customizer?customizer(value,other):undefined;return result===undefined?baseIsEqual(value,other,undefined,customizer):!!result;}/**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */function isError(value){if(!isObjectLike(value)){return false;}var tag=baseGetTag(value);return tag==errorTag||tag==domExcTag||typeof value.message=='string'&&typeof value.name=='string'&&!isPlainObject(value);}/**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */function isFinite(value){return typeof value=='number'&&nativeIsFinite(value);}/**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */function isFunction(value){if(!isObject(value)){return false;}// The use of `Object#toString` avoids issues with the `typeof` operator
// in Safari 9 which returns 'object' for typed arrays and other constructors.
var tag=baseGetTag(value);return tag==funcTag||tag==genTag||tag==asyncTag||tag==proxyTag;}/**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */function isInteger(value){return typeof value=='number'&&value==toInteger(value);}/**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */function isLength(value){return typeof value=='number'&&value>-1&&value%1==0&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */function isObject(value){var type=typeof value;return value!=null&&(type=='object'||type=='function');}/**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */function isObjectLike(value){return value!=null&&typeof value=='object';}/**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */var isMap=nodeIsMap?baseUnary(nodeIsMap):baseIsMap;/**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */function isMatch(object,source){return object===source||baseIsMatch(object,source,getMatchData(source));}/**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */function isMatchWith(object,source,customizer){customizer=typeof customizer=='function'?customizer:undefined;return baseIsMatch(object,source,getMatchData(source),customizer);}/**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */function isNaN(value){// An `NaN` primitive is the only value that is not equal to itself.
// Perform the `toStringTag` check first to avoid errors with some
// ActiveX objects in IE.
return isNumber(value)&&value!=+value;}/**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */function isNative(value){if(isMaskable(value)){throw new Error(CORE_ERROR_TEXT);}return baseIsNative(value);}/**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */function isNull(value){return value===null;}/**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */function isNil(value){return value==null;}/**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */function isNumber(value){return typeof value=='number'||isObjectLike(value)&&baseGetTag(value)==numberTag;}/**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */function isPlainObject(value){if(!isObjectLike(value)||baseGetTag(value)!=objectTag){return false;}var proto=getPrototype(value);if(proto===null){return true;}var Ctor=hasOwnProperty.call(proto,'constructor')&&proto.constructor;return typeof Ctor=='function'&&Ctor instanceof Ctor&&funcToString.call(Ctor)==objectCtorString;}/**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */var isRegExp=nodeIsRegExp?baseUnary(nodeIsRegExp):baseIsRegExp;/**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */function isSafeInteger(value){return isInteger(value)&&value>=-MAX_SAFE_INTEGER&&value<=MAX_SAFE_INTEGER;}/**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */var isSet=nodeIsSet?baseUnary(nodeIsSet):baseIsSet;/**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */function isString(value){return typeof value=='string'||!isArray(value)&&isObjectLike(value)&&baseGetTag(value)==stringTag;}/**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */function isSymbol(value){return typeof value=='symbol'||isObjectLike(value)&&baseGetTag(value)==symbolTag;}/**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */var isTypedArray=nodeIsTypedArray?baseUnary(nodeIsTypedArray):baseIsTypedArray;/**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */function isUndefined(value){return value===undefined;}/**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */function isWeakMap(value){return isObjectLike(value)&&getTag(value)==weakMapTag;}/**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */function isWeakSet(value){return isObjectLike(value)&&baseGetTag(value)==weakSetTag;}/**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */var lt=createRelationalOperation(baseLt);/**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */var lte=createRelationalOperation(function(value,other){return value<=other;});/**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */function toArray(value){if(!value){return[];}if(isArrayLike(value)){return isString(value)?stringToArray(value):copyArray(value);}if(symIterator&&value[symIterator]){return iteratorToArray(value[symIterator]());}var tag=getTag(value),func=tag==mapTag?mapToArray:tag==setTag?setToArray:values;return func(value);}/**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */function toFinite(value){if(!value){return value===0?value:0;}value=toNumber(value);if(value===INFINITY||value===-INFINITY){var sign=value<0?-1:1;return sign*MAX_INTEGER;}return value===value?value:0;}/**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */function toInteger(value){var result=toFinite(value),remainder=result%1;return result===result?remainder?result-remainder:result:0;}/**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */function toLength(value){return value?baseClamp(toInteger(value),0,MAX_ARRAY_LENGTH):0;}/**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */function toNumber(value){if(typeof value=='number'){return value;}if(isSymbol(value)){return NAN;}if(isObject(value)){var other=typeof value.valueOf=='function'?value.valueOf():value;value=isObject(other)?other+'':other;}if(typeof value!='string'){return value===0?value:+value;}value=baseTrim(value);var isBinary=reIsBinary.test(value);return isBinary||reIsOctal.test(value)?freeParseInt(value.slice(2),isBinary?2:8):reIsBadHex.test(value)?NAN:+value;}/**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */function toPlainObject(value){return copyObject(value,keysIn(value));}/**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */function toSafeInteger(value){return value?baseClamp(toInteger(value),-MAX_SAFE_INTEGER,MAX_SAFE_INTEGER):value===0?value:0;}/**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */function toString(value){return value==null?'':baseToString(value);}/*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */var assign=createAssigner(function(object,source){if(isPrototype(source)||isArrayLike(source)){copyObject(source,keys(source),object);return;}for(var key in source){if(hasOwnProperty.call(source,key)){assignValue(object,key,source[key]);}}});/**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */var assignIn=createAssigner(function(object,source){copyObject(source,keysIn(source),object);});/**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignInWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keysIn(source),object,customizer);});/**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var assignWith=createAssigner(function(object,source,srcIndex,customizer){copyObject(source,keys(source),object,customizer);});/**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */var at=flatRest(baseAt);/**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */function create(prototype,properties){var result=baseCreate(prototype);return properties==null?result:baseAssign(result,properties);}/**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */var defaults=baseRest(function(object,sources){object=Object(object);var index=-1;var length=sources.length;var guard=length>2?sources[2]:undefined;if(guard&&isIterateeCall(sources[0],sources[1],guard)){length=1;}while(++index<length){var source=sources[index];var props=keysIn(source);var propsIndex=-1;var propsLength=props.length;while(++propsIndex<propsLength){var key=props[propsIndex];var value=object[key];if(value===undefined||eq(value,objectProto[key])&&!hasOwnProperty.call(object,key)){object[key]=source[key];}}}return object;});/**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */var defaultsDeep=baseRest(function(args){args.push(undefined,customDefaultsMerge);return apply(mergeWith,undefined,args);});/**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */function findKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwn);}/**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */function findLastKey(object,predicate){return baseFindKey(object,getIteratee(predicate,3),baseForOwnRight);}/**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */function forIn(object,iteratee){return object==null?object:baseFor(object,getIteratee(iteratee,3),keysIn);}/**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */function forInRight(object,iteratee){return object==null?object:baseForRight(object,getIteratee(iteratee,3),keysIn);}/**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */function forOwn(object,iteratee){return object&&baseForOwn(object,getIteratee(iteratee,3));}/**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */function forOwnRight(object,iteratee){return object&&baseForOwnRight(object,getIteratee(iteratee,3));}/**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */function functions(object){return object==null?[]:baseFunctions(object,keys(object));}/**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */function functionsIn(object){return object==null?[]:baseFunctions(object,keysIn(object));}/**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */function get(object,path,defaultValue){var result=object==null?undefined:baseGet(object,path);return result===undefined?defaultValue:result;}/**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */function has(object,path){return object!=null&&hasPath(object,path,baseHas);}/**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */function hasIn(object,path){return object!=null&&hasPath(object,path,baseHasIn);}/**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */var invert=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}result[value]=key;},constant(identity));/**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */var invertBy=createInverter(function(result,value,key){if(value!=null&&typeof value.toString!='function'){value=nativeObjectToString.call(value);}if(hasOwnProperty.call(result,value)){result[value].push(key);}else{result[value]=[key];}},getIteratee);/**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */var invoke=baseRest(baseInvoke);/**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */function keys(object){return isArrayLike(object)?arrayLikeKeys(object):baseKeys(object);}/**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */function keysIn(object){return isArrayLike(object)?arrayLikeKeys(object,true):baseKeysIn(object);}/**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */function mapKeys(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,iteratee(value,key,object),value);});return result;}/**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */function mapValues(object,iteratee){var result={};iteratee=getIteratee(iteratee,3);baseForOwn(object,function(value,key,object){baseAssignValue(result,key,iteratee(value,key,object));});return result;}/**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */var merge=createAssigner(function(object,source,srcIndex){baseMerge(object,source,srcIndex);});/**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */var mergeWith=createAssigner(function(object,source,srcIndex,customizer){baseMerge(object,source,srcIndex,customizer);});/**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */var omit=flatRest(function(object,paths){var result={};if(object==null){return result;}var isDeep=false;paths=arrayMap(paths,function(path){path=castPath(path,object);isDeep||(isDeep=path.length>1);return path;});copyObject(object,getAllKeysIn(object),result);if(isDeep){result=baseClone(result,CLONE_DEEP_FLAG|CLONE_FLAT_FLAG|CLONE_SYMBOLS_FLAG,customOmitClone);}var length=paths.length;while(length--){baseUnset(result,paths[length]);}return result;});/**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */function omitBy(object,predicate){return pickBy(object,negate(getIteratee(predicate)));}/**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */var pick=flatRest(function(object,paths){return object==null?{}:basePick(object,paths);});/**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */function pickBy(object,predicate){if(object==null){return{};}var props=arrayMap(getAllKeysIn(object),function(prop){return[prop];});predicate=getIteratee(predicate);return basePickBy(object,props,function(value,path){return predicate(value,path[0]);});}/**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */function result(object,path,defaultValue){path=castPath(path,object);var index=-1,length=path.length;// Ensure the loop is entered when path is empty.
if(!length){length=1;object=undefined;}while(++index<length){var value=object==null?undefined:object[toKey(path[index])];if(value===undefined){index=length;value=defaultValue;}object=isFunction(value)?value.call(object):value;}return object;}/**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */function set(object,path,value){return object==null?object:baseSet(object,path,value);}/**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */function setWith(object,path,value,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseSet(object,path,value,customizer);}/**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */var toPairs=createToPairs(keys);/**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */var toPairsIn=createToPairs(keysIn);/**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */function transform(object,iteratee,accumulator){var isArr=isArray(object),isArrLike=isArr||isBuffer(object)||isTypedArray(object);iteratee=getIteratee(iteratee,4);if(accumulator==null){var Ctor=object&&object.constructor;if(isArrLike){accumulator=isArr?new Ctor():[];}else if(isObject(object)){accumulator=isFunction(Ctor)?baseCreate(getPrototype(object)):{};}else{accumulator={};}}(isArrLike?arrayEach:baseForOwn)(object,function(value,index,object){return iteratee(accumulator,value,index,object);});return accumulator;}/**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */function unset(object,path){return object==null?true:baseUnset(object,path);}/**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */function update(object,path,updater){return object==null?object:baseUpdate(object,path,castFunction(updater));}/**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */function updateWith(object,path,updater,customizer){customizer=typeof customizer=='function'?customizer:undefined;return object==null?object:baseUpdate(object,path,castFunction(updater),customizer);}/**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */function values(object){return object==null?[]:baseValues(object,keys(object));}/**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */function valuesIn(object){return object==null?[]:baseValues(object,keysIn(object));}/*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */function clamp(number,lower,upper){if(upper===undefined){upper=lower;lower=undefined;}if(upper!==undefined){upper=toNumber(upper);upper=upper===upper?upper:0;}if(lower!==undefined){lower=toNumber(lower);lower=lower===lower?lower:0;}return baseClamp(toNumber(number),lower,upper);}/**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */function inRange(number,start,end){start=toFinite(start);if(end===undefined){end=start;start=0;}else{end=toFinite(end);}number=toNumber(number);return baseInRange(number,start,end);}/**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */function random(lower,upper,floating){if(floating&&typeof floating!='boolean'&&isIterateeCall(lower,upper,floating)){upper=floating=undefined;}if(floating===undefined){if(typeof upper=='boolean'){floating=upper;upper=undefined;}else if(typeof lower=='boolean'){floating=lower;lower=undefined;}}if(lower===undefined&&upper===undefined){lower=0;upper=1;}else{lower=toFinite(lower);if(upper===undefined){upper=lower;lower=0;}else{upper=toFinite(upper);}}if(lower>upper){var temp=lower;lower=upper;upper=temp;}if(floating||lower%1||upper%1){var rand=nativeRandom();return nativeMin(lower+rand*(upper-lower+freeParseFloat('1e-'+((rand+'').length-1))),upper);}return baseRandom(lower,upper);}/*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */var camelCase=createCompounder(function(result,word,index){word=word.toLowerCase();return result+(index?capitalize(word):word);});/**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */function capitalize(string){return upperFirst(toString(string).toLowerCase());}/**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */function deburr(string){string=toString(string);return string&&string.replace(reLatin,deburrLetter).replace(reComboMark,'');}/**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */function endsWith(string,target,position){string=toString(string);target=baseToString(target);var length=string.length;position=position===undefined?length:baseClamp(toInteger(position),0,length);var end=position;position-=target.length;return position>=0&&string.slice(position,end)==target;}/**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */function escape(string){string=toString(string);return string&&reHasUnescapedHtml.test(string)?string.replace(reUnescapedHtml,escapeHtmlChar):string;}/**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */function escapeRegExp(string){string=toString(string);return string&&reHasRegExpChar.test(string)?string.replace(reRegExpChar,'\\$&'):string;}/**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */var kebabCase=createCompounder(function(result,word,index){return result+(index?'-':'')+word.toLowerCase();});/**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */var lowerCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toLowerCase();});/**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */var lowerFirst=createCaseFirst('toLowerCase');/**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */function pad(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;if(!length||strLength>=length){return string;}var mid=(length-strLength)/2;return createPadding(nativeFloor(mid),chars)+string+createPadding(nativeCeil(mid),chars);}/**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */function padEnd(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?string+createPadding(length-strLength,chars):string;}/**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */function padStart(string,length,chars){string=toString(string);length=toInteger(length);var strLength=length?stringSize(string):0;return length&&strLength<length?createPadding(length-strLength,chars)+string:string;}/**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */function parseInt(string,radix,guard){if(guard||radix==null){radix=0;}else if(radix){radix=+radix;}return nativeParseInt(toString(string).replace(reTrimStart,''),radix||0);}/**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */function repeat(string,n,guard){if(guard?isIterateeCall(string,n,guard):n===undefined){n=1;}else{n=toInteger(n);}return baseRepeat(toString(string),n);}/**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */function replace(){var args=arguments,string=toString(args[0]);return args.length<3?string:string.replace(args[1],args[2]);}/**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */var snakeCase=createCompounder(function(result,word,index){return result+(index?'_':'')+word.toLowerCase();});/**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */function split(string,separator,limit){if(limit&&typeof limit!='number'&&isIterateeCall(string,separator,limit)){separator=limit=undefined;}limit=limit===undefined?MAX_ARRAY_LENGTH:limit>>>0;if(!limit){return[];}string=toString(string);if(string&&(typeof separator=='string'||separator!=null&&!isRegExp(separator))){separator=baseToString(separator);if(!separator&&hasUnicode(string)){return castSlice(stringToArray(string),0,limit);}}return string.split(separator,limit);}/**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */var startCase=createCompounder(function(result,word,index){return result+(index?' ':'')+upperFirst(word);});/**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */function startsWith(string,target,position){string=toString(string);position=position==null?0:baseClamp(toInteger(position),0,string.length);target=baseToString(target);return string.slice(position,position+target.length)==target;}/**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */function template(string,options,guard){// Based on John Resig's `tmpl` implementation
// (http://ejohn.org/blog/javascript-micro-templating/)
// and Laura Doktorova's doT.js (https://github.com/olado/doT).
var settings=lodash.templateSettings;if(guard&&isIterateeCall(string,options,guard)){options=undefined;}string=toString(string);options=assignInWith({},options,settings,customDefaultsAssignIn);var imports=assignInWith({},options.imports,settings.imports,customDefaultsAssignIn),importsKeys=keys(imports),importsValues=baseValues(imports,importsKeys);var isEscaping,isEvaluating,index=0,interpolate=options.interpolate||reNoMatch,source="__p += '";// Compile the regexp to match each delimiter.
var reDelimiters=RegExp((options.escape||reNoMatch).source+'|'+interpolate.source+'|'+(interpolate===reInterpolate?reEsTemplate:reNoMatch).source+'|'+(options.evaluate||reNoMatch).source+'|$','g');// Use a sourceURL for easier debugging.
// The sourceURL gets injected into the source that's eval-ed, so be careful
// to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
// and escape the comment, thus injecting code that gets evaled.
var sourceURL='//# sourceURL='+(hasOwnProperty.call(options,'sourceURL')?(options.sourceURL+'').replace(/\s/g,' '):'lodash.templateSources['+ ++templateCounter+']')+'\n';string.replace(reDelimiters,function(match,escapeValue,interpolateValue,esTemplateValue,evaluateValue,offset){interpolateValue||(interpolateValue=esTemplateValue);// Escape characters that can't be included in string literals.
source+=string.slice(index,offset).replace(reUnescapedString,escapeStringChar);// Replace delimiters with snippets.
if(escapeValue){isEscaping=true;source+="' +\n__e("+escapeValue+") +\n'";}if(evaluateValue){isEvaluating=true;source+="';\n"+evaluateValue+";\n__p += '";}if(interpolateValue){source+="' +\n((__t = ("+interpolateValue+")) == null ? '' : __t) +\n'";}index=offset+match.length;// The JS engine embedded in Adobe products needs `match` returned in
// order to produce the correct `offset` value.
return match;});source+="';\n";// If `variable` is not specified wrap a with-statement around the generated
// code to add the data object to the top of the scope chain.
var variable=hasOwnProperty.call(options,'variable')&&options.variable;if(!variable){source='with (obj) {\n'+source+'\n}\n';}// Throw an error if a forbidden character was found in `variable`, to prevent
// potential command injection attacks.
else if(reForbiddenIdentifierChars.test(variable)){throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);}// Cleanup code by stripping empty strings.
source=(isEvaluating?source.replace(reEmptyStringLeading,''):source).replace(reEmptyStringMiddle,'$1').replace(reEmptyStringTrailing,'$1;');// Frame code as the function body.
source='function('+(variable||'obj')+') {\n'+(variable?'':'obj || (obj = {});\n')+"var __t, __p = ''"+(isEscaping?', __e = _.escape':'')+(isEvaluating?', __j = Array.prototype.join;\n'+"function print() { __p += __j.call(arguments, '') }\n":';\n')+source+'return __p\n}';var result=attempt(function(){return Function(importsKeys,sourceURL+'return '+source).apply(undefined,importsValues);});// Provide the compiled function's source by its `toString` method or
// the `source` property as a convenience for inlining compiled templates.
result.source=source;if(isError(result)){throw result;}return result;}/**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */function toLower(value){return toString(value).toLowerCase();}/**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */function toUpper(value){return toString(value).toUpperCase();}/**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */function trim(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return baseTrim(string);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),chrSymbols=stringToArray(chars),start=charsStartIndex(strSymbols,chrSymbols),end=charsEndIndex(strSymbols,chrSymbols)+1;return castSlice(strSymbols,start,end).join('');}/**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */function trimEnd(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.slice(0,trimmedEndIndex(string)+1);}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),end=charsEndIndex(strSymbols,stringToArray(chars))+1;return castSlice(strSymbols,0,end).join('');}/**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */function trimStart(string,chars,guard){string=toString(string);if(string&&(guard||chars===undefined)){return string.replace(reTrimStart,'');}if(!string||!(chars=baseToString(chars))){return string;}var strSymbols=stringToArray(string),start=charsStartIndex(strSymbols,stringToArray(chars));return castSlice(strSymbols,start).join('');}/**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */function truncate(string,options){var length=DEFAULT_TRUNC_LENGTH,omission=DEFAULT_TRUNC_OMISSION;if(isObject(options)){var separator='separator'in options?options.separator:separator;length='length'in options?toInteger(options.length):length;omission='omission'in options?baseToString(options.omission):omission;}string=toString(string);var strLength=string.length;if(hasUnicode(string)){var strSymbols=stringToArray(string);strLength=strSymbols.length;}if(length>=strLength){return string;}var end=length-stringSize(omission);if(end<1){return omission;}var result=strSymbols?castSlice(strSymbols,0,end).join(''):string.slice(0,end);if(separator===undefined){return result+omission;}if(strSymbols){end+=result.length-end;}if(isRegExp(separator)){if(string.slice(end).search(separator)){var match,substring=result;if(!separator.global){separator=RegExp(separator.source,toString(reFlags.exec(separator))+'g');}separator.lastIndex=0;while(match=separator.exec(substring)){var newEnd=match.index;}result=result.slice(0,newEnd===undefined?end:newEnd);}}else if(string.indexOf(baseToString(separator),end)!=end){var index=result.lastIndexOf(separator);if(index>-1){result=result.slice(0,index);}}return result+omission;}/**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */function unescape(string){string=toString(string);return string&&reHasEscapedHtml.test(string)?string.replace(reEscapedHtml,unescapeHtmlChar):string;}/**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */var upperCase=createCompounder(function(result,word,index){return result+(index?' ':'')+word.toUpperCase();});/**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */var upperFirst=createCaseFirst('toUpperCase');/**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */function words(string,pattern,guard){string=toString(string);pattern=guard?undefined:pattern;if(pattern===undefined){return hasUnicodeWord(string)?unicodeWords(string):asciiWords(string);}return string.match(pattern)||[];}/*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */var attempt=baseRest(function(func,args){try{return apply(func,undefined,args);}catch(e){return isError(e)?e:new Error(e);}});/**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */var bindAll=flatRest(function(object,methodNames){arrayEach(methodNames,function(key){key=toKey(key);baseAssignValue(object,key,bind(object[key],object));});return object;});/**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */function cond(pairs){var length=pairs==null?0:pairs.length,toIteratee=getIteratee();pairs=!length?[]:arrayMap(pairs,function(pair){if(typeof pair[1]!='function'){throw new TypeError(FUNC_ERROR_TEXT);}return[toIteratee(pair[0]),pair[1]];});return baseRest(function(args){var index=-1;while(++index<length){var pair=pairs[index];if(apply(pair[0],this,args)){return apply(pair[1],this,args);}}});}/**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */function conforms(source){return baseConforms(baseClone(source,CLONE_DEEP_FLAG));}/**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */function constant(value){return function(){return value;};}/**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */function defaultTo(value,defaultValue){return value==null||value!==value?defaultValue:value;}/**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */var flow=createFlow();/**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */var flowRight=createFlow(true);/**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */function identity(value){return value;}/**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */function iteratee(func){return baseIteratee(typeof func=='function'?func:baseClone(func,CLONE_DEEP_FLAG));}/**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */function matches(source){return baseMatches(baseClone(source,CLONE_DEEP_FLAG));}/**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */function matchesProperty(path,srcValue){return baseMatchesProperty(path,baseClone(srcValue,CLONE_DEEP_FLAG));}/**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */var method=baseRest(function(path,args){return function(object){return baseInvoke(object,path,args);};});/**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */var methodOf=baseRest(function(object,args){return function(path){return baseInvoke(object,path,args);};});/**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */function mixin(object,source,options){var props=keys(source),methodNames=baseFunctions(source,props);if(options==null&&!(isObject(source)&&(methodNames.length||!props.length))){options=source;source=object;object=this;methodNames=baseFunctions(source,keys(source));}var chain=!(isObject(options)&&'chain'in options)||!!options.chain,isFunc=isFunction(object);arrayEach(methodNames,function(methodName){var func=source[methodName];object[methodName]=func;if(isFunc){object.prototype[methodName]=function(){var chainAll=this.__chain__;if(chain||chainAll){var result=object(this.__wrapped__),actions=result.__actions__=copyArray(this.__actions__);actions.push({'func':func,'args':arguments,'thisArg':object});result.__chain__=chainAll;return result;}return func.apply(object,arrayPush([this.value()],arguments));};}});return object;}/**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */function noConflict(){if(root._===this){root._=oldDash;}return this;}/**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */function noop(){// No operation performed.
}/**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */function nthArg(n){n=toInteger(n);return baseRest(function(args){return baseNth(args,n);});}/**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */var over=createOver(arrayMap);/**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */var overEvery=createOver(arrayEvery);/**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */var overSome=createOver(arraySome);/**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */function property(path){return isKey(path)?baseProperty(toKey(path)):basePropertyDeep(path);}/**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */function propertyOf(object){return function(path){return object==null?undefined:baseGet(object,path);};}/**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */var range=createRange();/**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */var rangeRight=createRange(true);/**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */function stubArray(){return[];}/**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */function stubFalse(){return false;}/**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */function stubObject(){return{};}/**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */function stubString(){return'';}/**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */function stubTrue(){return true;}/**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */function times(n,iteratee){n=toInteger(n);if(n<1||n>MAX_SAFE_INTEGER){return[];}var index=MAX_ARRAY_LENGTH,length=nativeMin(n,MAX_ARRAY_LENGTH);iteratee=getIteratee(iteratee);n-=MAX_ARRAY_LENGTH;var result=baseTimes(length,iteratee);while(++index<n){iteratee(index);}return result;}/**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */function toPath(value){if(isArray(value)){return arrayMap(value,toKey);}return isSymbol(value)?[value]:copyArray(stringToPath(toString(value)));}/**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */function uniqueId(prefix){var id=++idCounter;return toString(prefix)+id;}/*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */var add=createMathOperation(function(augend,addend){return augend+addend;},0);/**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */var ceil=createRound('ceil');/**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */var divide=createMathOperation(function(dividend,divisor){return dividend/divisor;},1);/**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */var floor=createRound('floor');/**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */function max(array){return array&&array.length?baseExtremum(array,identity,baseGt):undefined;}/**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */function maxBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseGt):undefined;}/**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */function mean(array){return baseMean(array,identity);}/**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */function meanBy(array,iteratee){return baseMean(array,getIteratee(iteratee,2));}/**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */function min(array){return array&&array.length?baseExtremum(array,identity,baseLt):undefined;}/**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */function minBy(array,iteratee){return array&&array.length?baseExtremum(array,getIteratee(iteratee,2),baseLt):undefined;}/**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */var multiply=createMathOperation(function(multiplier,multiplicand){return multiplier*multiplicand;},1);/**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */var round=createRound('round');/**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */var subtract=createMathOperation(function(minuend,subtrahend){return minuend-subtrahend;},0);/**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */function sum(array){return array&&array.length?baseSum(array,identity):0;}/**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */function sumBy(array,iteratee){return array&&array.length?baseSum(array,getIteratee(iteratee,2)):0;}/*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
lodash.after=after;lodash.ary=ary;lodash.assign=assign;lodash.assignIn=assignIn;lodash.assignInWith=assignInWith;lodash.assignWith=assignWith;lodash.at=at;lodash.before=before;lodash.bind=bind;lodash.bindAll=bindAll;lodash.bindKey=bindKey;lodash.castArray=castArray;lodash.chain=chain;lodash.chunk=chunk;lodash.compact=compact;lodash.concat=concat;lodash.cond=cond;lodash.conforms=conforms;lodash.constant=constant;lodash.countBy=countBy;lodash.create=create;lodash.curry=curry;lodash.curryRight=curryRight;lodash.debounce=debounce;lodash.defaults=defaults;lodash.defaultsDeep=defaultsDeep;lodash.defer=defer;lodash.delay=delay;lodash.difference=difference;lodash.differenceBy=differenceBy;lodash.differenceWith=differenceWith;lodash.drop=drop;lodash.dropRight=dropRight;lodash.dropRightWhile=dropRightWhile;lodash.dropWhile=dropWhile;lodash.fill=fill;lodash.filter=filter;lodash.flatMap=flatMap;lodash.flatMapDeep=flatMapDeep;lodash.flatMapDepth=flatMapDepth;lodash.flatten=flatten;lodash.flattenDeep=flattenDeep;lodash.flattenDepth=flattenDepth;lodash.flip=flip;lodash.flow=flow;lodash.flowRight=flowRight;lodash.fromPairs=fromPairs;lodash.functions=functions;lodash.functionsIn=functionsIn;lodash.groupBy=groupBy;lodash.initial=initial;lodash.intersection=intersection;lodash.intersectionBy=intersectionBy;lodash.intersectionWith=intersectionWith;lodash.invert=invert;lodash.invertBy=invertBy;lodash.invokeMap=invokeMap;lodash.iteratee=iteratee;lodash.keyBy=keyBy;lodash.keys=keys;lodash.keysIn=keysIn;lodash.map=map;lodash.mapKeys=mapKeys;lodash.mapValues=mapValues;lodash.matches=matches;lodash.matchesProperty=matchesProperty;lodash.memoize=memoize;lodash.merge=merge;lodash.mergeWith=mergeWith;lodash.method=method;lodash.methodOf=methodOf;lodash.mixin=mixin;lodash.negate=negate;lodash.nthArg=nthArg;lodash.omit=omit;lodash.omitBy=omitBy;lodash.once=once;lodash.orderBy=orderBy;lodash.over=over;lodash.overArgs=overArgs;lodash.overEvery=overEvery;lodash.overSome=overSome;lodash.partial=partial;lodash.partialRight=partialRight;lodash.partition=partition;lodash.pick=pick;lodash.pickBy=pickBy;lodash.property=property;lodash.propertyOf=propertyOf;lodash.pull=pull;lodash.pullAll=pullAll;lodash.pullAllBy=pullAllBy;lodash.pullAllWith=pullAllWith;lodash.pullAt=pullAt;lodash.range=range;lodash.rangeRight=rangeRight;lodash.rearg=rearg;lodash.reject=reject;lodash.remove=remove;lodash.rest=rest;lodash.reverse=reverse;lodash.sampleSize=sampleSize;lodash.set=set;lodash.setWith=setWith;lodash.shuffle=shuffle;lodash.slice=slice;lodash.sortBy=sortBy;lodash.sortedUniq=sortedUniq;lodash.sortedUniqBy=sortedUniqBy;lodash.split=split;lodash.spread=spread;lodash.tail=tail;lodash.take=take;lodash.takeRight=takeRight;lodash.takeRightWhile=takeRightWhile;lodash.takeWhile=takeWhile;lodash.tap=tap;lodash.throttle=throttle;lodash.thru=thru;lodash.toArray=toArray;lodash.toPairs=toPairs;lodash.toPairsIn=toPairsIn;lodash.toPath=toPath;lodash.toPlainObject=toPlainObject;lodash.transform=transform;lodash.unary=unary;lodash.union=union;lodash.unionBy=unionBy;lodash.unionWith=unionWith;lodash.uniq=uniq;lodash.uniqBy=uniqBy;lodash.uniqWith=uniqWith;lodash.unset=unset;lodash.unzip=unzip;lodash.unzipWith=unzipWith;lodash.update=update;lodash.updateWith=updateWith;lodash.values=values;lodash.valuesIn=valuesIn;lodash.without=without;lodash.words=words;lodash.wrap=wrap;lodash.xor=xor;lodash.xorBy=xorBy;lodash.xorWith=xorWith;lodash.zip=zip;lodash.zipObject=zipObject;lodash.zipObjectDeep=zipObjectDeep;lodash.zipWith=zipWith;// Add aliases.
lodash.entries=toPairs;lodash.entriesIn=toPairsIn;lodash.extend=assignIn;lodash.extendWith=assignInWith;// Add methods to `lodash.prototype`.
mixin(lodash,lodash);/*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
lodash.add=add;lodash.attempt=attempt;lodash.camelCase=camelCase;lodash.capitalize=capitalize;lodash.ceil=ceil;lodash.clamp=clamp;lodash.clone=clone;lodash.cloneDeep=cloneDeep;lodash.cloneDeepWith=cloneDeepWith;lodash.cloneWith=cloneWith;lodash.conformsTo=conformsTo;lodash.deburr=deburr;lodash.defaultTo=defaultTo;lodash.divide=divide;lodash.endsWith=endsWith;lodash.eq=eq;lodash.escape=escape;lodash.escapeRegExp=escapeRegExp;lodash.every=every;lodash.find=find;lodash.findIndex=findIndex;lodash.findKey=findKey;lodash.findLast=findLast;lodash.findLastIndex=findLastIndex;lodash.findLastKey=findLastKey;lodash.floor=floor;lodash.forEach=forEach;lodash.forEachRight=forEachRight;lodash.forIn=forIn;lodash.forInRight=forInRight;lodash.forOwn=forOwn;lodash.forOwnRight=forOwnRight;lodash.get=get;lodash.gt=gt;lodash.gte=gte;lodash.has=has;lodash.hasIn=hasIn;lodash.head=head;lodash.identity=identity;lodash.includes=includes;lodash.indexOf=indexOf;lodash.inRange=inRange;lodash.invoke=invoke;lodash.isArguments=isArguments;lodash.isArray=isArray;lodash.isArrayBuffer=isArrayBuffer;lodash.isArrayLike=isArrayLike;lodash.isArrayLikeObject=isArrayLikeObject;lodash.isBoolean=isBoolean;lodash.isBuffer=isBuffer;lodash.isDate=isDate;lodash.isElement=isElement;lodash.isEmpty=isEmpty;lodash.isEqual=isEqual;lodash.isEqualWith=isEqualWith;lodash.isError=isError;lodash.isFinite=isFinite;lodash.isFunction=isFunction;lodash.isInteger=isInteger;lodash.isLength=isLength;lodash.isMap=isMap;lodash.isMatch=isMatch;lodash.isMatchWith=isMatchWith;lodash.isNaN=isNaN;lodash.isNative=isNative;lodash.isNil=isNil;lodash.isNull=isNull;lodash.isNumber=isNumber;lodash.isObject=isObject;lodash.isObjectLike=isObjectLike;lodash.isPlainObject=isPlainObject;lodash.isRegExp=isRegExp;lodash.isSafeInteger=isSafeInteger;lodash.isSet=isSet;lodash.isString=isString;lodash.isSymbol=isSymbol;lodash.isTypedArray=isTypedArray;lodash.isUndefined=isUndefined;lodash.isWeakMap=isWeakMap;lodash.isWeakSet=isWeakSet;lodash.join=join;lodash.kebabCase=kebabCase;lodash.last=last;lodash.lastIndexOf=lastIndexOf;lodash.lowerCase=lowerCase;lodash.lowerFirst=lowerFirst;lodash.lt=lt;lodash.lte=lte;lodash.max=max;lodash.maxBy=maxBy;lodash.mean=mean;lodash.meanBy=meanBy;lodash.min=min;lodash.minBy=minBy;lodash.stubArray=stubArray;lodash.stubFalse=stubFalse;lodash.stubObject=stubObject;lodash.stubString=stubString;lodash.stubTrue=stubTrue;lodash.multiply=multiply;lodash.nth=nth;lodash.noConflict=noConflict;lodash.noop=noop;lodash.now=now;lodash.pad=pad;lodash.padEnd=padEnd;lodash.padStart=padStart;lodash.parseInt=parseInt;lodash.random=random;lodash.reduce=reduce;lodash.reduceRight=reduceRight;lodash.repeat=repeat;lodash.replace=replace;lodash.result=result;lodash.round=round;lodash.runInContext=runInContext;lodash.sample=sample;lodash.size=size;lodash.snakeCase=snakeCase;lodash.some=some;lodash.sortedIndex=sortedIndex;lodash.sortedIndexBy=sortedIndexBy;lodash.sortedIndexOf=sortedIndexOf;lodash.sortedLastIndex=sortedLastIndex;lodash.sortedLastIndexBy=sortedLastIndexBy;lodash.sortedLastIndexOf=sortedLastIndexOf;lodash.startCase=startCase;lodash.startsWith=startsWith;lodash.subtract=subtract;lodash.sum=sum;lodash.sumBy=sumBy;lodash.template=template;lodash.times=times;lodash.toFinite=toFinite;lodash.toInteger=toInteger;lodash.toLength=toLength;lodash.toLower=toLower;lodash.toNumber=toNumber;lodash.toSafeInteger=toSafeInteger;lodash.toString=toString;lodash.toUpper=toUpper;lodash.trim=trim;lodash.trimEnd=trimEnd;lodash.trimStart=trimStart;lodash.truncate=truncate;lodash.unescape=unescape;lodash.uniqueId=uniqueId;lodash.upperCase=upperCase;lodash.upperFirst=upperFirst;// Add aliases.
lodash.each=forEach;lodash.eachRight=forEachRight;lodash.first=head;mixin(lodash,function(){var source={};baseForOwn(lodash,function(func,methodName){if(!hasOwnProperty.call(lodash.prototype,methodName)){source[methodName]=func;}});return source;}(),{'chain':false});/*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */lodash.VERSION=VERSION;// Assign default placeholders.
arrayEach(['bind','bindKey','curry','curryRight','partial','partialRight'],function(methodName){lodash[methodName].placeholder=lodash;});// Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
arrayEach(['drop','take'],function(methodName,index){LazyWrapper.prototype[methodName]=function(n){n=n===undefined?1:nativeMax(toInteger(n),0);var result=this.__filtered__&&!index?new LazyWrapper(this):this.clone();if(result.__filtered__){result.__takeCount__=nativeMin(n,result.__takeCount__);}else{result.__views__.push({'size':nativeMin(n,MAX_ARRAY_LENGTH),'type':methodName+(result.__dir__<0?'Right':'')});}return result;};LazyWrapper.prototype[methodName+'Right']=function(n){return this.reverse()[methodName](n).reverse();};});// Add `LazyWrapper` methods that accept an `iteratee` value.
arrayEach(['filter','map','takeWhile'],function(methodName,index){var type=index+1,isFilter=type==LAZY_FILTER_FLAG||type==LAZY_WHILE_FLAG;LazyWrapper.prototype[methodName]=function(iteratee){var result=this.clone();result.__iteratees__.push({'iteratee':getIteratee(iteratee,3),'type':type});result.__filtered__=result.__filtered__||isFilter;return result;};});// Add `LazyWrapper` methods for `_.head` and `_.last`.
arrayEach(['head','last'],function(methodName,index){var takeName='take'+(index?'Right':'');LazyWrapper.prototype[methodName]=function(){return this[takeName](1).value()[0];};});// Add `LazyWrapper` methods for `_.initial` and `_.tail`.
arrayEach(['initial','tail'],function(methodName,index){var dropName='drop'+(index?'':'Right');LazyWrapper.prototype[methodName]=function(){return this.__filtered__?new LazyWrapper(this):this[dropName](1);};});LazyWrapper.prototype.compact=function(){return this.filter(identity);};LazyWrapper.prototype.find=function(predicate){return this.filter(predicate).head();};LazyWrapper.prototype.findLast=function(predicate){return this.reverse().find(predicate);};LazyWrapper.prototype.invokeMap=baseRest(function(path,args){if(typeof path=='function'){return new LazyWrapper(this);}return this.map(function(value){return baseInvoke(value,path,args);});});LazyWrapper.prototype.reject=function(predicate){return this.filter(negate(getIteratee(predicate)));};LazyWrapper.prototype.slice=function(start,end){start=toInteger(start);var result=this;if(result.__filtered__&&(start>0||end<0)){return new LazyWrapper(result);}if(start<0){result=result.takeRight(-start);}else if(start){result=result.drop(start);}if(end!==undefined){end=toInteger(end);result=end<0?result.dropRight(-end):result.take(end-start);}return result;};LazyWrapper.prototype.takeRightWhile=function(predicate){return this.reverse().takeWhile(predicate).reverse();};LazyWrapper.prototype.toArray=function(){return this.take(MAX_ARRAY_LENGTH);};// Add `LazyWrapper` methods to `lodash.prototype`.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var checkIteratee=/^(?:filter|find|map|reject)|While$/.test(methodName),isTaker=/^(?:head|last)$/.test(methodName),lodashFunc=lodash[isTaker?'take'+(methodName=='last'?'Right':''):methodName],retUnwrapped=isTaker||/^find/.test(methodName);if(!lodashFunc){return;}lodash.prototype[methodName]=function(){var value=this.__wrapped__,args=isTaker?[1]:arguments,isLazy=value instanceof LazyWrapper,iteratee=args[0],useLazy=isLazy||isArray(value);var interceptor=function(value){var result=lodashFunc.apply(lodash,arrayPush([value],args));return isTaker&&chainAll?result[0]:result;};if(useLazy&&checkIteratee&&typeof iteratee=='function'&&iteratee.length!=1){// Avoid lazy use if the iteratee has a "length" value other than `1`.
isLazy=useLazy=false;}var chainAll=this.__chain__,isHybrid=!!this.__actions__.length,isUnwrapped=retUnwrapped&&!chainAll,onlyLazy=isLazy&&!isHybrid;if(!retUnwrapped&&useLazy){value=onlyLazy?value:new LazyWrapper(this);var result=func.apply(value,args);result.__actions__.push({'func':thru,'args':[interceptor],'thisArg':undefined});return new LodashWrapper(result,chainAll);}if(isUnwrapped&&onlyLazy){return func.apply(this,args);}result=this.thru(interceptor);return isUnwrapped?isTaker?result.value()[0]:result.value():result;};});// Add `Array` methods to `lodash.prototype`.
arrayEach(['pop','push','shift','sort','splice','unshift'],function(methodName){var func=arrayProto[methodName],chainName=/^(?:push|sort|unshift)$/.test(methodName)?'tap':'thru',retUnwrapped=/^(?:pop|shift)$/.test(methodName);lodash.prototype[methodName]=function(){var args=arguments;if(retUnwrapped&&!this.__chain__){var value=this.value();return func.apply(isArray(value)?value:[],args);}return this[chainName](function(value){return func.apply(isArray(value)?value:[],args);});};});// Map minified method names to their real names.
baseForOwn(LazyWrapper.prototype,function(func,methodName){var lodashFunc=lodash[methodName];if(lodashFunc){var key=lodashFunc.name+'';if(!hasOwnProperty.call(realNames,key)){realNames[key]=[];}realNames[key].push({'name':methodName,'func':lodashFunc});}});realNames[createHybrid(undefined,WRAP_BIND_KEY_FLAG).name]=[{'name':'wrapper','func':undefined}];// Add methods to `LazyWrapper`.
LazyWrapper.prototype.clone=lazyClone;LazyWrapper.prototype.reverse=lazyReverse;LazyWrapper.prototype.value=lazyValue;// Add chain sequence methods to the `lodash` wrapper.
lodash.prototype.at=wrapperAt;lodash.prototype.chain=wrapperChain;lodash.prototype.commit=wrapperCommit;lodash.prototype.next=wrapperNext;lodash.prototype.plant=wrapperPlant;lodash.prototype.reverse=wrapperReverse;lodash.prototype.toJSON=lodash.prototype.valueOf=lodash.prototype.value=wrapperValue;// Add lazy aliases.
lodash.prototype.first=lodash.prototype.head;if(symIterator){lodash.prototype[symIterator]=wrapperToIterator;}return lodash;};/*--------------------------------------------------------------------------*/ // Export lodash.
var _=runInContext();// Some AMD build optimizers, like r.js, check for condition patterns like:
if(true){// Expose Lodash on the global object to prevent errors when Lodash is
// loaded by a script tag in the presence of an AMD loader.
// See http://requirejs.org/docs/errors.html#mismatch for more details.
// Use `_.noConflict` to remove Lodash from the global object.
root._=_;// Define as an anonymous module so, through path mapping, it can be
// referenced as the "underscore" module.
!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return _;}).call(exports, __webpack_require__, exports, module),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));}// Check for `exports` after `define` in case a build optimizer adds it.
else {}}).call(this);

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "styled-components":
/*!************************************!*\
  !*** external "styled-components" ***!
  \************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_styled_components__;

/***/ }),

/***/ "?4f7e":
/*!********************************!*\
  !*** ./util.inspect (ignored) ***!
  \********************************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?ec06":
/*!********************!*\
  !*** fs (ignored) ***!
  \********************/
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ "?f46d":
/*!**********************!*\
  !*** path (ignored) ***!
  \**********************/
/***/ (() => {

/* (ignored) */

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	(() => {
/******/ 		__webpack_require__.nmd = (module) => {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.tsx");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});